webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	// we don't need to use a variable
	// or the from keyword when importing a css/styl file
	// thanks the the styles loader it gets added as a
	// <style> tag in the head by default but can be changed
	
	// import 'normalize.css';
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(31);
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import angularUIBootstrap from 'angular-ui-bootstrap';
	
	var _appComponentJs = __webpack_require__(153);
	
	var _componentsComponentsJs = __webpack_require__(155);
	
	var _modelsModelsJs = __webpack_require__(642);
	
	// import { messaging } from './messaging.js';
	
	var _configJs = __webpack_require__(683);
	
	if ('serviceWorker' in navigator) {
	    navigator.serviceWorker.getRegistrations().then(function (registrations) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = registrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var registration = _step.value;
	
	                if (registration.scope.includes('firebase-cloud-messaging-push-scope') === false) {
	                    registration.unregister();
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    });
	    navigator.serviceWorker.register('./firebase-messaging-sw.js', { scope: 'firebase-cloud-messaging-push-scope' }).then(function (reg) {
	        (0, _jquery2['default'])('body').bind('update-sw', function () {
	            reg.update();
	            console.log('Successfully updated service worker', reg);
	        });
	    })['catch'](function (err) {
	        console.warn('Error whilst registering service worker', err);
	    });
	}
	
	//Loads the correct sidebar on window load,
	//collapses the sidebar on window resize.
	// Sets the min-height of #page-wrapper to window size
	(0, _jquery2['default'])(document).ready(function () {
	    // Move right sidebar top after scroll
	    (0, _jquery2['default'])(window).scroll(function () {
	        if ((0, _jquery2['default'])(window).scrollTop() > 0 && !(0, _jquery2['default'])('body').hasClass('fixed-nav')) {
	            (0, _jquery2['default'])('#right-sidebar').addClass('sidebar-top');
	        } else {
	            (0, _jquery2['default'])('#right-sidebar').removeClass('sidebar-top');
	        }
	    });
	
	    // setTimeout(function(){
	    //     fix_height();
	    // });
	});
	
	// // Minimalize menu when screen is less than 768px
	// $(function() {
	//     $(window).bind('load resize', function() {
	//         if ($(document).width() < 769) {
	//             $('body').addClass('body-small');
	//         } else {
	//             $('body').removeClass('body-small');
	//         }
	//     });
	// });
	
	(0, _jquery2['default'])(document).ready(function () {
	    // Set minimal height of #wrapper to fit the window
	    setTimeout(function () {
	        fixWrapperHeight();
	    }, 300);
	
	    // Add special class to minimalize page elements when screen is less than 768px
	    setBodySmall();
	});
	
	(0, _jquery2['default'])(window).bind('resize click', function () {
	    // Add special class to minimalize page elements when screen is less than 768px
	    setBodySmall();
	
	    // Waint until metsiMenu, collapse and other effect finish and set wrapper height
	    setTimeout(function () {
	        fixWrapperHeight();
	    }, 300);
	});
	
	function fixWrapperHeight() {
	    // Get and set current height
	    var headerH = 62;
	    var navigationH = (0, _jquery2['default'])('#navigation').height();
	    var contentH = (0, _jquery2['default'])('.content').height();
	
	    // Set new height when contnet height is less then navigation
	    if (contentH < navigationH) {
	        (0, _jquery2['default'])('#wrapper').css('min-height', navigationH + 'px');
	    }
	
	    // Set new height when contnet height is less then navigation and navigation is less then window
	    if (contentH < navigationH && navigationH < (0, _jquery2['default'])(window).height()) {
	        (0, _jquery2['default'])('#wrapper').css('min-height', (0, _jquery2['default'])(window).height() - headerH + 'px');
	    }
	
	    // Set new height when contnet is higher then navigation but less then window
	    if (contentH > navigationH && contentH < (0, _jquery2['default'])(window).height()) {
	        (0, _jquery2['default'])('#wrapper').css('min-height', (0, _jquery2['default'])(window).height() - headerH + 'px');
	    }
	}
	
	function setBodySmall() {
	    if ((0, _jquery2['default'])(document).width() < 769) {
	        (0, _jquery2['default'])('body').addClass('page-small');
	    } else {
	        (0, _jquery2['default'])('body').removeClass('page-small');
	        (0, _jquery2['default'])('body').removeClass('show-sidebar');
	    }
	}
	
	// console.log(angularUIBootstrap);
	
	var app = _angular2['default'].module('app', [_angularUiRouter2['default'], _modelsModelsJs.models.name, _componentsComponentsJs.components.name, 'messaging']);
	
	app.config(_configJs.config);
	app.run(_configJs.run);
	app.component('app', _appComponentJs.AppComponent);

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(32);
	
	__webpack_require__(41);
	
	__webpack_require__(49);
	
	__webpack_require__(51);
	
	__webpack_require__(53);
	
	__webpack_require__(55);
	
	__webpack_require__(61);
	
	__webpack_require__(63);
	
	__webpack_require__(70);
	
	__webpack_require__(72);
	
	__webpack_require__(77);

/***/ },
/* 32 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
32,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
32,
/* 50 */,
/* 51 */
32,
/* 52 */,
/* 53 */
32,
/* 54 */,
/* 55 */
32,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
32,
/* 62 */,
/* 63 */
32,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
32,
/* 71 */,
/* 72 */
32,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
32,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appHtml = __webpack_require__(154);
	
	var _appHtml2 = _interopRequireDefault(_appHtml);
	
	function ComponentController() {
	    'ngInject';
	}
	
	var AppComponent = {
	    restrict: 'E',
	    templateUrl: _appHtml2['default'],
	    controller: ComponentController,
	    replace: true
	    // controllerAs: 'vm'
	};
	
	exports.AppComponent = AppComponent;

/***/ },
/* 154 */
/***/ function(module, exports) {

	var path = 'app/app.html';
	var html = "<ui-view></ui-view>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _authAuthJs = __webpack_require__(156);
	
	var _commonCommonJs = __webpack_require__(167);
	
	var _dashboardDashboardJs = __webpack_require__(512);
	
	var _ordinacijaOrdinacijaJs = __webpack_require__(565);
	
	var _cjenikCjenikJs = __webpack_require__(584);
	
	var _radniNalogRadniNalogJs = __webpack_require__(591);
	
	var _stavkaNalogaStavkaNalogaJs = __webpack_require__(594);
	
	var _fazaNalogaFazaNalogaJs = __webpack_require__(639);
	
	var components = _angular2['default'].module('components', [_authAuthJs.auth.name, _commonCommonJs.common.name, _dashboardDashboardJs.dashboard.name, _ordinacijaOrdinacijaJs.ordinacija.name, _cjenikCjenikJs.cjenik.name, _radniNalogRadniNalogJs.radniNalog.name, _stavkaNalogaStavkaNalogaJs.stavkaNaloga.name, _fazaNalogaFazaNalogaJs.fazaNaloga.name]);
	
	exports.components = components;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(157);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularLocalStorage = __webpack_require__(159);
	
	var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);
	
	var _authComponentJs = __webpack_require__(161);
	
	var _authServiceJs = __webpack_require__(164);
	
	var auth = _angular2['default'].module('auth', [_angularCookies2['default'], _angularLocalStorage2['default']]);
	
	auth.service('djangoAuth', _authServiceJs.djangoAuth);
	auth.component('auth', _authComponentJs.AuthComponent);
	
	exports.auth = auth;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(158);
	module.exports = 'ngCookies';


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.5
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The $cookieStore service is **deprecated**.
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 * </div>
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn("Cookie '" + name +
	        "' possibly not set or overflowed because it was too large (" +
	        cookieLength + " > 4096 bytes)!");
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(160);
	module.exports = 'LocalStorageModule';


/***/ },
/* 160 */
/***/ function(module, exports) {

	var isDefined = angular.isDefined,
	  isUndefined = angular.isUndefined,
	  isNumber = angular.isNumber,
	  isObject = angular.isObject,
	  isArray = angular.isArray,
	  extend = angular.extend,
	  toJson = angular.toJson;
	
	angular
	  .module('LocalStorageModule', [])
	  .provider('localStorageService', function() {
	    // You should set a prefix to avoid overwriting any local storage variables from the rest of your app
	    // e.g. localStorageServiceProvider.setPrefix('yourAppName');
	    // With provider you can use config as this:
	    // myApp.config(function (localStorageServiceProvider) {
	    //    localStorageServiceProvider.prefix = 'yourAppName';
	    // });
	    this.prefix = 'ls';
	
	    // You could change web storage type localstorage or sessionStorage
	    this.storageType = 'localStorage';
	
	    // Cookie options (usually in case of fallback)
	    // expiry = Number of days before cookies expire // 0 = Does not expire
	    // path = The web path the cookie represents
	    this.cookie = {
	      expiry: 30,
	      path: '/'
	    };
	
	    // Send signals for each of the following actions?
	    this.notify = {
	      setItem: true,
	      removeItem: false
	    };
	
	    // Setter for the prefix
	    this.setPrefix = function(prefix) {
	      this.prefix = prefix;
	      return this;
	    };
	
	    // Setter for the storageType
	    this.setStorageType = function(storageType) {
	      this.storageType = storageType;
	      return this;
	    };
	
	    // Setter for cookie config
	    this.setStorageCookie = function(exp, path) {
	      this.cookie.expiry = exp;
	      this.cookie.path = path;
	      return this;
	    };
	
	    // Setter for cookie domain
	    this.setStorageCookieDomain = function(domain) {
	      this.cookie.domain = domain;
	      return this;
	    };
	
	    // Setter for notification config
	    // itemSet & itemRemove should be booleans
	    this.setNotify = function(itemSet, itemRemove) {
	      this.notify = {
	        setItem: itemSet,
	        removeItem: itemRemove
	      };
	      return this;
	    };
	
	    this.$get = ['$rootScope', '$window', '$document', '$parse', function($rootScope, $window, $document, $parse) {
	      var self = this;
	      var prefix = self.prefix;
	      var cookie = self.cookie;
	      var notify = self.notify;
	      var storageType = self.storageType;
	      var webStorage;
	
	      // When Angular's $document is not available
	      if (!$document) {
	        $document = document;
	      } else if ($document[0]) {
	        $document = $document[0];
	      }
	
	      // If there is a prefix set in the config lets use that with an appended period for readability
	      if (prefix.substr(-1) !== '.') {
	        prefix = !!prefix ? prefix + '.' : '';
	      }
	      var deriveQualifiedKey = function(key) {
	        return prefix + key;
	      };
	      // Checks the browser to see if local storage is supported
	      var browserSupportsLocalStorage = (function () {
	        try {
	          var supported = (storageType in $window && $window[storageType] !== null);
	
	          // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
	          // is available, but trying to call .setItem throws an exception.
	          //
	          // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
	          // that exceeded the quota."
	          var key = deriveQualifiedKey('__' + Math.round(Math.random() * 1e7));
	          if (supported) {
	            webStorage = $window[storageType];
	            webStorage.setItem(key, '');
	            webStorage.removeItem(key);
	          }
	
	          return supported;
	        } catch (e) {
	          storageType = 'cookie';
	          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	          return false;
	        }
	      }());
	
	      // Directly adds a value to local storage
	      // If local storage is not available in the browser use cookies
	      // Example use: localStorageService.add('library','angular');
	      var addToLocalStorage = function (key, value) {
	        // Let's convert undefined values to null to get the value consistent
	        if (isUndefined(value)) {
	          value = null;
	        } else {
	          value = toJson(value);
	        }
	
	        // If this browser does not support local storage use cookies
	        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	
	          if (notify.setItem) {
	            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: 'cookie'});
	          }
	          return addToCookies(key, value);
	        }
	
	        try {
	          if (webStorage) {
	            webStorage.setItem(deriveQualifiedKey(key), value);
	          }
	          if (notify.setItem) {
	            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: self.storageType});
	          }
	        } catch (e) {
	          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	          return addToCookies(key, value);
	        }
	        return true;
	      };
	
	      // Directly get a value from local storage
	      // Example use: localStorageService.get('library'); // returns 'angular'
	      var getFromLocalStorage = function (key) {
	
	        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	
	          return getFromCookies(key);
	        }
	
	        var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
	        // angular.toJson will convert null to 'null', so a proper conversion is needed
	        // FIXME not a perfect solution, since a valid 'null' string can't be stored
	        if (!item || item === 'null') {
	          return null;
	        }
	
	        try {
	          return JSON.parse(item);
	        } catch (e) {
	          return item;
	        }
	      };
	
	      // Remove an item from local storage
	      // Example use: localStorageService.remove('library'); // removes the key/value pair of library='angular'
	      var removeFromLocalStorage = function () {
	        var i, key;
	        for (i=0; i<arguments.length; i++) {
	          key = arguments[i];
	          if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	            if (!browserSupportsLocalStorage) {
	              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	            }
	
	            if (notify.removeItem) {
	              $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {key: key, storageType: 'cookie'});
	            }
	            removeFromCookies(key);
	          }
	          else {
	            try {
	              webStorage.removeItem(deriveQualifiedKey(key));
	              if (notify.removeItem) {
	                $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
	                  key: key,
	                  storageType: self.storageType
	                });
	              }
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	              removeFromCookies(key);
	            }
	          }
	        }
	      };
	
	      // Return array of keys for local storage
	      // Example use: var keys = localStorageService.keys()
	      var getKeysForLocalStorage = function () {
	
	        if (!browserSupportsLocalStorage) {
	          $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          return [];
	        }
	
	        var prefixLength = prefix.length;
	        var keys = [];
	        for (var key in webStorage) {
	          // Only return keys that are for this app
	          if (key.substr(0, prefixLength) === prefix) {
	            try {
	              keys.push(key.substr(prefixLength));
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.Description);
	              return [];
	            }
	          }
	        }
	        return keys;
	      };
	
	      // Remove all data for this app from local storage
	      // Also optionally takes a regular expression string and removes the matching key-value pairs
	      // Example use: localStorageService.clearAll();
	      // Should be used mostly for development purposes
	      var clearAllFromLocalStorage = function (regularExpression) {
	
	        // Setting both regular expressions independently
	        // Empty strings result in catchall RegExp
	        var prefixRegex = !!prefix ? new RegExp('^' + prefix) : new RegExp();
	        var testRegex = !!regularExpression ? new RegExp(regularExpression) : new RegExp();
	
	        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	          return clearAllFromCookies();
	        }
	
	        var prefixLength = prefix.length;
	
	        for (var key in webStorage) {
	          // Only remove items that are for this app and match the regular expression
	          if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
	            try {
	              removeFromLocalStorage(key.substr(prefixLength));
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	              return clearAllFromCookies();
	            }
	          }
	        }
	        return true;
	      };
	
	      // Checks the browser to see if cookies are supported
	      var browserSupportsCookies = (function() {
	        try {
	          return $window.navigator.cookieEnabled ||
	          ("cookie" in $document && ($document.cookie.length > 0 ||
	            ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1));
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	        }());
	
	        // Directly adds a value to cookies
	        // Typically used as a fallback is local storage is not available in the browser
	        // Example use: localStorageService.cookie.add('library','angular');
	        var addToCookies = function (key, value, daysToExpiry) {
	
	          if (isUndefined(value)) {
	            return false;
	          } else if(isArray(value) || isObject(value)) {
	            value = toJson(value);
	          }
	
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          try {
	            var expiry = '',
	            expiryDate = new Date(),
	            cookieDomain = '';
	
	            if (value === null) {
	              // Mark that the cookie has expired one day ago
	              expiryDate.setTime(expiryDate.getTime() + (-1 * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	              value = '';
	            } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (daysToExpiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            } else if (cookie.expiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (cookie.expiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            }
	            if (!!key) {
	              var cookiePath = "; path=" + cookie.path;
	              if(cookie.domain){
	                cookieDomain = "; domain=" + cookie.domain;
	              }
	              $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
	            }
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	          return true;
	        };
	
	        // Directly get a value from a cookie
	        // Example use: localStorageService.cookie.get('library'); // returns 'angular'
	        var getFromCookies = function (key) {
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          var cookies = $document.cookie && $document.cookie.split(';') || [];
	          for(var i=0; i < cookies.length; i++) {
	            var thisCookie = cookies[i];
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1,thisCookie.length);
	            }
	            if (thisCookie.indexOf(deriveQualifiedKey(key) + '=') === 0) {
	              var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
	              try {
	                return JSON.parse(storedValues);
	              } catch(e) {
	                return storedValues;
	              }
	            }
	          }
	          return null;
	        };
	
	        var removeFromCookies = function (key) {
	          addToCookies(key,null);
	        };
	
	        var clearAllFromCookies = function () {
	          var thisCookie = null, thisKey = null;
	          var prefixLength = prefix.length;
	          var cookies = $document.cookie.split(';');
	          for(var i = 0; i < cookies.length; i++) {
	            thisCookie = cookies[i];
	
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1, thisCookie.length);
	            }
	
	            var key = thisCookie.substring(prefixLength, thisCookie.indexOf('='));
	            removeFromCookies(key);
	          }
	        };
	
	        var getStorageType = function() {
	          return storageType;
	        };
	
	        // Add a listener on scope variable to save its changes to local storage
	        // Return a function which when called cancels binding
	        var bindToScope = function(scope, key, def, lsKey) {
	          lsKey = lsKey || key;
	          var value = getFromLocalStorage(lsKey);
	
	          if (value === null && isDefined(def)) {
	            value = def;
	          } else if (isObject(value) && isObject(def)) {
	            value = extend(value, def);
	          }
	
	          $parse(key).assign(scope, value);
	
	          return scope.$watch(key, function(newVal) {
	            addToLocalStorage(lsKey, newVal);
	          }, isObject(scope[key]));
	        };
	
	        // Return localStorageService.length
	        // ignore keys that not owned
	        var lengthOfLocalStorage = function() {
	          var count = 0;
	          var storage = $window[storageType];
	          for(var i = 0; i < storage.length; i++) {
	            if(storage.key(i).indexOf(prefix) === 0 ) {
	              count++;
	            }
	          }
	          return count;
	        };
	
	        return {
	          isSupported: browserSupportsLocalStorage,
	          getStorageType: getStorageType,
	          set: addToLocalStorage,
	          add: addToLocalStorage, //DEPRECATED
	          get: getFromLocalStorage,
	          keys: getKeysForLocalStorage,
	          remove: removeFromLocalStorage,
	          clearAll: clearAllFromLocalStorage,
	          bind: bindToScope,
	          deriveKey: deriveQualifiedKey,
	          length: lengthOfLocalStorage,
	          cookie: {
	            isSupported: browserSupportsCookies,
	            set: addToCookies,
	            add: addToCookies, //DEPRECATED
	            get: getFromCookies,
	            remove: removeFromCookies,
	            clearAll: clearAllFromCookies
	          }
	        };
	      }];
	  });


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _authHtml = __webpack_require__(162);
	
	var _authHtml2 = _interopRequireDefault(_authHtml);
	
	var _authControllerJs = __webpack_require__(163);
	
	var AuthComponent = {
	    restrict: 'E',
	    templateUrl: _authHtml2['default'],
	    controller: _authControllerJs.AuthController,
	    controllerAs: 'vm'
	};
	
	exports.AuthComponent = AuthComponent;

/***/ },
/* 162 */
/***/ function(module, exports) {

	var path = 'app/components/auth/auth.html';
	var html = "<div class=\"color-line\"></div><div class=\"login-container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"text-center m-b-md\"><img src=\"images/logo.png\"><hr><h1><b>Dental<span class=\"text-warning\">LAB</span></b></h1><h2>Prijava za rad</h2></div><div class=\"hpanel\"><div class=\"panel-body\"><form id=\"loginForm\" ng-submit=\"vm.login()\"><div class=\"form-group\"><label class=\"control-label\" for=\"username\">Korisnik</label> <input type=\"text\" ng-model=\"vm.username\" class=\"form-control\" placeholder=\"korisnik\" required> <span class=\"help-block small\">Vaše korisničko ime</span></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\">Zaporka</label> <input type=\"password\" ng-model=\"vm.password\" class=\"form-control\" placeholder=\"*********\" required> <span class=\"help-block small\">Vaša sigurnosna zaporka</span></div><button type=\"submit\" class=\"btn btn-warning btn-block\">Prijavi me</button><div ng-if=\"!vm.logging\" class=\"margin-top10\"><div class=\"alert alert-danger\" ng-if=\"vm.errors.status === 400\"><strong>Neuspjela prijava!</strong> Nije moguće prijaviti se s navedenim vjerodajnicama.</div><div class=\"alert alert-danger\" ng-if=\"vm.errors.status === 502\">Povezivanje nije uspjelo. Molimo vas pokušajte ponovno.</div><div class=\"alert alert-danger\" ng-if=\"vm.errors.status === -1\">Server timeout. Molimo vas pokušajte ponovno.</div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-md-12 text-center\"><strong>DentalLAB</strong> - web application<br>&copy; 2017 InVita d.o.o.</div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AuthController = (function () {
	    function AuthController($state, djangoAuth, $scope) {
	        _classCallCheck(this, AuthController);
	
	        this.username = '';
	        this.password = '';
	        this.$state = $state;
	        this.$scope = $scope;
	        this.djangoAuth = djangoAuth;
	        this.djangoAuth.logout();
	    }
	
	    _createClass(AuthController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.$scope.$watchCollection('[vm.username, vm.password]', function (newVal, oldVal) {
	                _this.logging = false;
	                _this.errors = false;
	            });
	        }
	    }, {
	        key: 'login',
	        value: function login() {
	            var _this2 = this;
	
	            this.logging = true;
	            this.errors = false;
	            this.djangoAuth.login(this.username, this.password).then(function (data) {
	                _this2.logging = false;
	                _this2.$state.go('dashboard');
	            }, function (error) {
	                _this2.logging = false;
	                _this2.errors = error;
	            });
	        }
	    }]);
	
	    return AuthController;
	})();
	
	AuthController.$inject = ['$state', 'djangoAuth', '$scope'];
	
	exports.AuthController = AuthController;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var djangoAuth = function djangoAuth($q, $http, localStorageService, $rootScope, $timeout) {
	    // AngularJS will instantiate a singleton by calling "new" on this function
	    var service = {
	        /* START CUSTOMIZATION HERE */
	        // Change this to point to your Django REST Auth API
	        // e.g. /api/rest-auth  (DO NOT INCLUDE ENDING SLASH)
	        API_URL: '',
	        // Set use_session to true to use Django sessions to store security token.
	        // Set use_session to false to store the security token locally and transmit it as a custom header.
	        use_session: true,
	        /* END OF CUSTOMIZATION */
	        authenticated: null,
	        authPromise: null,
	        request: function request(args) {
	            // Let's retrieve the token from the cookie, if available
	            if (localStorageService.get('token')) {
	                $http.defaults.headers.common.Authorization = 'Token ' + localStorageService.get('token');
	            }
	            // Continue
	            params = args.params || {};
	            args = args || {};
	            var deferred = $q.defer(),
	                url = this.API_URL + args.url,
	                method = args.method || 'GET',
	                params = params,
	                data = args.data || {};
	            // Fire the request, as configured.
	
	            // let canceler = $q.defer();
	
	            $http({
	                url: url,
	                withCredentials: this.use_session,
	                method: method.toUpperCase(),
	                // headers: {'X-CSRFToken': $cookies['csrftoken']},
	                params: params,
	                data: data
	                // timeout: canceler.promise
	            }).then(function (response) {
	                deferred.resolve(response.data, response.status);
	            }, function (response) {
	                var status = response.status;
	                var headers = response.headers;
	                var config = response.config;
	
	                console.log('error syncing with: ' + url);
	
	                var data = {};
	                data.status = status;
	
	                if (status == 502) {
	                    data['details'] = ['Could not connect. Please try again.'];
	                } else if (status == -1) {
	                    data['details'] = ['Server timed out. Please try again.'];
	                } else {
	                    data['details'] = response.data['details'] || response.data['non_field_errors'];
	                }
	
	                deferred.reject(data);
	            });
	
	            // $timeout(() => {
	            //     canceler.resolve();
	            // }, 2000);
	
	            return deferred.promise;
	        },
	        register: function register(username, password1, password2, email, more) {
	            var data = {
	                username: username,
	                password1: password1,
	                password2: password2,
	                email: email
	            };
	            data = angular.extend(data, more);
	            return this.request({
	                method: 'POST',
	                url: '/registration/',
	                data: data
	            });
	        },
	        login: function login(username, password) {
	            var djangoAuth = this;
	            console.debug('Login executed!');
	            delete $http.defaults.headers.common.Authorization;
	            localStorageService.remove('token');
	            return this.request({
	                method: 'POST',
	                url: '/login/',
	                data: {
	                    username: username,
	                    password: password
	                }
	            }).then(function (data) {
	                if (!djangoAuth.use_session) {
	                    $http.defaults.headers.common.Authorization = 'Token ' + data.key;
	                    localStorageService.set('token', data.key);
	                }
	                djangoAuth.authenticated = true;
	                $rootScope.$broadcast('djangoAuth.logged_in', data);
	            });
	        },
	        logout: function logout() {
	            var djangoAuth = this;
	            return this.request({
	                method: 'POST',
	                url: '/logout/'
	            }).then(function (data) {
	                delete $http.defaults.headers.common.Authorization;
	                localStorageService.remove('token');
	                djangoAuth.authenticated = false;
	                $rootScope.$broadcast('djangoAuth.logged_out');
	            });
	        },
	        changePassword: function changePassword(password1, password2) {
	            return this.request({
	                method: 'POST',
	                url: '/password/change/',
	                data: {
	                    new_password1: password1,
	                    new_password2: password2
	                }
	            });
	        },
	        resetPassword: function resetPassword(email) {
	            return this.request({
	                method: 'POST',
	                url: '/password/reset/',
	                data: {
	                    email: email
	                }
	            });
	        },
	        profile: function profile() {
	            return this.request({
	                method: 'GET',
	                url: '/user/'
	            });
	        },
	        updateProfile: function updateProfile(data) {
	            return this.request({
	                method: 'PATCH',
	                url: '/user/',
	                data: data
	            });
	        },
	        verify: function verify(key) {
	            return this.request({
	                method: 'POST',
	                url: '/registration/verify-email/',
	                data: { key: key }
	            });
	        },
	        confirmReset: function confirmReset(uid, token, password1, password2) {
	            return this.request({
	                method: 'POST',
	                url: '/password/reset/confirm/',
	                data: {
	                    uid: uid,
	                    token: token,
	                    new_password1: password1,
	                    new_password2: password2
	                }
	            });
	        },
	        authenticationStatus: function authenticationStatus(restrict, force) {
	            // Set restrict to true to reject the promise if not logged in
	            // Set to false or omit to resolve when status is known
	            // Set force to true to ignore stored value and query API
	            restrict = restrict || false;
	            force = force || false;
	            if (this.authPromise == null || force) {
	                this.authPromise = this.request({
	                    method: 'GET',
	                    url: '/user/'
	                });
	            }
	            var da = this;
	            var getAuthStatus = $q.defer();
	            if (this.authenticated != null && !force) {
	                // We have a stored value which means we can pass it back right away.
	                if (this.authenticated == false && restrict) {
	                    getAuthStatus.reject('User is not logged in.');
	                } else {
	                    getAuthStatus.resolve();
	                }
	            } else {
	                // There isn't a stored value, or we're forcing a request back to
	                // the API to get the authentication status.
	                this.authPromise.then(function () {
	                    da.authenticated = true;
	                    getAuthStatus.resolve();
	                }, function () {
	                    da.authenticated = false;
	                    if (restrict) {
	                        getAuthStatus.reject('User is not logged in.');
	                    } else {
	                        getAuthStatus.resolve();
	                    }
	                });
	            }
	            return getAuthStatus.promise;
	        },
	        initialize: function initialize(url, sessions) {
	            this.API_URL = url;
	            this.use_session = sessions;
	            return this.authenticationStatus();
	        }
	    };
	    return service;
	};
	
	djangoAuth.$inject = ['$q', '$http', 'localStorageService', '$rootScope', '$timeout'];
	
	exports.djangoAuth = djangoAuth;

/***/ },
/* 165 */,
/* 166 */,
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarNavbarJs = __webpack_require__(168);
	
	var _navbarTopNavbarTopJs = __webpack_require__(190);
	
	var _footerFooterJs = __webpack_require__(194);
	
	var _headerHeaderJs = __webpack_require__(197);
	
	var _homerHomerJs = __webpack_require__(200);
	
	var _formsFormsJs = __webpack_require__(201);
	
	var _utilsUtilsJs = __webpack_require__(409);
	
	var _configurationConfigurationJs = __webpack_require__(411);
	
	var _breadcrumbBreadcrumbJs = __webpack_require__(450);
	
	var _pageHeaderPageHeaderJs = __webpack_require__(452);
	
	var _crudCrudJs = __webpack_require__(455);
	
	var _ngDraggableNgDraggableJs = __webpack_require__(500);
	
	var _loggerLoggerServiceJs = __webpack_require__(501);
	
	var _loggerLoggerServiceJs2 = _interopRequireDefault(_loggerLoggerServiceJs);
	
	var _loadingLoadingJs = __webpack_require__(504);
	
	var _qrCodeScannerQrCodeScannerJs = __webpack_require__(507);
	
	var common = _angular2['default'].module('common', [_homerHomerJs.homer.name, _navbarNavbarJs.navbar.name, _navbarTopNavbarTopJs.navbarTop.name, _footerFooterJs.footer.name, _headerHeaderJs.header.name, _formsFormsJs.forms.name, _configurationConfigurationJs.configurationModule.name, _utilsUtilsJs.utils.name, _breadcrumbBreadcrumbJs.breadcrumb.name, _pageHeaderPageHeaderJs.pageHeader.name, _crudCrudJs.crud.name, _ngDraggableNgDraggableJs.ngDraggable.name, _loggerLoggerServiceJs2['default'].name, _loadingLoadingJs.loading.name, _qrCodeScannerQrCodeScannerJs.qrScanner.name]);
	
	exports.common = common;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcTooltip = __webpack_require__(169);
	
	var _angularUiBootstrapSrcTooltip2 = _interopRequireDefault(_angularUiBootstrapSrcTooltip);
	
	var _navbarComponentJs = __webpack_require__(183);
	
	var _profilePictureComponentJs = __webpack_require__(186);
	
	var _navigationDirectiveJs = __webpack_require__(188);
	
	var navbar = _angular2['default'].module('navbar', [_angularUiBootstrapSrcTooltip2['default']]);
	
	navbar.component('navbar', _navbarComponentJs.NavbarComponent);
	navbar.component('profilePicture', _profilePictureComponentJs.ProfilePictureComponent);
	navbar.directive('sideNavigation', _navigationDirectiveJs.SideNavigation);
	
	exports.navbar = navbar;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(170);
	__webpack_require__(172);
	module.exports = __webpack_require__(174);


/***/ },
/* 170 */
32,
/* 171 */,
/* 172 */
32,
/* 173 */,
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(175);
	__webpack_require__(177);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	
	var MODULE_NAME = 'ui.bootstrap.module.tooltip';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tooltip', 'uib/template/tooltip/tooltip-popup.html', 'uib/template/tooltip/tooltip-html-popup.html', 'uib/template/tooltip/tooltip-template-popup.html']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(176);
	
	var MODULE_NAME = 'ui.bootstrap.module.position';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.position']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 176 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    /**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */
	    var SCROLLBAR_WIDTH;
	    /**
	     * scrollbar on body and html element in IE and Edge overlay
	     * content and should be considered 0 width.
	     */
	    var BODY_SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/
	    };
	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/
	    };
	    var BODY_REGEX = /(HTML|BODY)/;
	
	    return {
	
	      /**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */
	      getRawNode: function(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },
	
	      /**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */
	      parseStyle: function(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },
	
	      /**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */
	      offsetParent: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }
	
	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        return offsetParent || $document[0].documentElement;
	      },
	
	      /**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       * In IE and Edge, scollbar on body and html element overlay and should
	       * return a width of 0.
	       *
	       * @returns {number} The width of the browser scollbar.
	       */
	      scrollbarWidth: function(isBody) {
	        if (isBody) {
	          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	            var bodyElem = $document.find('body');
	            bodyElem.addClass('uib-position-body-scrollbar-measure');
	            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	            bodyElem.removeClass('uib-position-body-scrollbar-measure');
	          }
	          return BODY_SCROLLBAR_WIDTH;
	        }
	
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }
	
	        return SCROLLBAR_WIDTH;
	      },
	
	      /**
	       * Provides the padding required on an element to replace the scrollbar.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	       *     <li>**widthOverflow**: whether the the width is overflowing</li>
	       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	       *     <li>**heightOverflow**: whether the the height is overflowing</li>
	       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	       *   </ul>
	       */
	      scrollbarPadding: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemStyle = $window.getComputedStyle(elem);
	        var paddingRight = this.parseStyle(elemStyle.paddingRight);
	        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	        var scrollParent = this.scrollParent(elem, false, true);
	        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	        return {
	          scrollbarWidth: scrollbarWidth,
	          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	          right: paddingRight + scrollbarWidth,
	          originalRight: paddingRight,
	          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	          bottom: paddingBottom + scrollbarWidth,
	          originalBottom: paddingBottom
	         };
	      },
	
	      /**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */
	      isScrollable: function(elem, includeHidden) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },
	
	      /**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       * @param {boolean=} [includeSelf=false] - Should the element being passed be
	       * included in the scrollable llokup.
	       *
	       * @returns {element} A HTML element.
	       */
	      scrollParent: function(elem, includeHidden, includeSelf) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	          return elem;
	        }
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;
	
	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }
	
	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }
	
	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }
	
	        return scrollParent;
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */
	      position: function(elem, includeMagins) {
	        elem = this.getRawNode(elem);
	
	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = {top: 0, left: 0};
	
	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }
	
	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left)
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */
	      offset: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	        };
	      },
	
	      /**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */
	      viewportOffset: function(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;
	
	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};
	
	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }
	
	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right)
	        };
	      },
	
	      /**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */
	      parsePlacement: function(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }
	
	        placement = placement.split('-');
	
	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }
	
	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }
	
	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }
	
	        return placement;
	      },
	
	      /**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */
	      positionElements: function(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);
	
	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	        placement = this.parsePlacement(placement);
	
	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = {top: 0, left: 0, placement: ''};
	
	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	          };
	
	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	                         placement[0];
	
	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	                         placement[1];
	
	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }
	
	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;
	        }
	
	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;
	        }
	
	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	        return targetElemPos;
	      },
	
	      /**
	       * Provides a way to adjust the top positioning after first
	       * render to correctly align element to top after content
	       * rendering causes resized element height
	       *
	       * @param {array} placementClasses - The array of strings of classes
	       * element should have.
	       * @param {object} containerPosition - The object with container
	       * position information
	       * @param {number} initialHeight - The initial height for the elem.
	       * @param {number} currentHeight - The current height for the elem.
	       */
	      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
	        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	          return {
	            top: containerPosition.top - currentHeight + 'px'
	          };
	        }
	      },
	
	      /**
	       * Provides a way for positioning tooltip & dropdown
	       * arrows when using placement options beyond the standard
	       * left, right, top, or bottom.
	       *
	       * @param {element} elem - The tooltip/dropdown element.
	       * @param {string} placement - The placement for the elem.
	       */
	      positionArrow: function(elem, placement) {
	        elem = this.getRawNode(elem);
	
	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }
	
	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }
	
	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: ''
	        };
	
	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }
	
	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;
	        }
	
	        arrowCss[placement[1]] = borderRadius;
	
	        angular.element(arrowElem).css(arrowCss);
	      }
	    };
	  }]);


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(178);
	
	var MODULE_NAME = 'ui.bootstrap.module.stackedMap';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 178 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.pop();
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });

/***/ },
/* 179 */
/***/ function(module, exports) {

	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "");
	}]);


/***/ },
/* 180 */
/***/ function(module, exports) {

	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "");
	}]);


/***/ },
/* 181 */
/***/ function(module, exports) {

	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\"\n" +
	    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "");
	}]);


/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup ' +
	          'uib-title="' + startSym + 'title' + endSym + '" ' +
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'origin-scope="origScope" ' +
	          'class="uib-position-measure ' + prefix + '" ' +
	          'tooltip-animation-class="fade"' +
	          'uib-tooltip-classes ' +
	          'ng-class="{ in: isOpen }" ' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function() {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	                
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	              
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [], hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function(key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('uibTooltipPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarControllerJs = __webpack_require__(184);
	
	var _navbarHtml = __webpack_require__(185);
	
	var _navbarHtml2 = _interopRequireDefault(_navbarHtml);
	
	var NavbarComponent = {
	    restrict: 'E',
	    templateUrl: _navbarHtml2['default'],
	    controller: _navbarControllerJs.NavbarController,
	    controllerAs: 'vm',
	    replace: true
	};
	
	exports.NavbarComponent = NavbarComponent;

/***/ },
/* 184 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var NavbarController = function NavbarController($rootScope, $location, AppConfiguration) {
	    _classCallCheck(this, NavbarController);
	
	    var conf = AppConfiguration();
	    this.$rootScope = $rootScope;
	    this.menu = conf.menu().children();
	    this.appTitle = conf.title();
	    this.path = '#' + $location.path();
	};
	
	NavbarController.$inject = ['$rootScope', '$location', 'AppConfiguration'];
	
	exports.NavbarController = NavbarController;

/***/ },
/* 185 */
/***/ function(module, exports) {

	var path = 'app/components/common/navbar/navbar.html';
	var html = "<div id=\"navigation\"><profile-picture></profile-picture><div class=\"p-xs\"><a ui-sref=\"radniNalog.create\" uib-tooltip=\"Novi nalog\" class=\"btn btn-lg btn-info btn-circle\" style=\"padding: 15px\" type=\"button\" tooltip-placement=\"bottom\"><i class=\"fa fa-plus\"></i></a> <a href=\"api/radni_nalozi/radniNalozi/0/ispis\" target=\"_blank\" uib-tooltip=\"Ispis praznog naloga\" class=\"btn btn-lg btn-primary btn-circle\" style=\"padding: 15px\" type=\"button\" data-toggle=\"tooltip\" tooltip-placement=\"bottom\"><i class=\"fa fa-file\"></i></a></div><ul side-navigation class=\"nav metismenu\" id=\"side-menu\"><li ng-repeat=\"(key, menu) in ::vm.menu\" ng-class=\"{active: menu.isChildActive(vm.path)}\"><a ng-if=\"::menu.hasChild()\"><span compile=\"::menu.icon()\"></span> <span class=\"nav-label\">{{ menu.title()}}</span><span class=\"fa arrow\"></span></a> <a ng-if=\"::!menu.hasChild()\" href=\"{{menu.link()}}\"><span compile=\"::menu.icon()\"></span> <span class=\"nav-label\">{{ menu.title()}}</span></a><ul ng-if=\"::menu.hasChild()\" class=\"nav nav-second-level collapse\" ng-class=\"{in: menu.isChildActive(vm.path)}\"><li ng-repeat=\"menu in ::menu.children()\" ng-class=\"{active: menu.isActive(vm.path)}\"><a href=\"{{menu.link()}}\">{{menu.title()}}</a></li></ul></li></ul></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _profilePictureHtml = __webpack_require__(187);
	
	var _profilePictureHtml2 = _interopRequireDefault(_profilePictureHtml);
	
	var ProfilePictureController = (function () {
	    function ProfilePictureController($rootScope, messaging) {
	        _classCallCheck(this, ProfilePictureController);
	
	        this.messaging = function () {
	            return messaging;
	        };
	        this.user = $rootScope.user;
	    }
	
	    _createClass(ProfilePictureController, [{
	        key: 'activateNotification',
	        value: function activateNotification() {
	            var messaging = this.messaging();
	            messaging.requestPermission();
	        }
	    }, {
	        key: 'updateServiceWorker',
	        value: function updateServiceWorker() {
	            var e = _jquery2['default'].Event('update-sw');
	            (0, _jquery2['default'])('body').trigger(e);
	        }
	    }]);
	
	    return ProfilePictureController;
	})();
	
	ProfilePictureController.$inject = ['$rootScope', 'messaging'];
	
	var ProfilePictureComponent = {
	    restrict: 'E',
	    templateUrl: _profilePictureHtml2['default'],
	    controller: ProfilePictureController,
	    controllerAs: 'vm'
	};
	
	exports.ProfilePictureComponent = ProfilePictureComponent;

/***/ },
/* 187 */
/***/ function(module, exports) {

	var path = 'app/components/common/navbar/profilePicture.html';
	var html = "<div class=\"profile-picture\"><a href=\"index.html\"><i class=\"fa fa-user-md fa-4x\"></i></a><div class=\"stats-label text-color\"><span class=\"font-extra-bold font-uppercase\">DentalLAB</span><div class=\"dropdown\"><a class=\"dropdown-toggle\" href=\"#\" data-toggle=\"dropdown\"><small class=\"text-muted\">{{vm.user.username}} <b class=\"caret\"></b></small></a><ul class=\"dropdown-menu animated fadeInRight m-t-xs\"><li><a ui-sref=\"login\">Odjava</a></li><li><a ng-click=\"vm.activateNotification()\">Notificiraj me na ovoj lokaciji</a></li><li><a ng-click=\"vm.updateServiceWorker()\">Update SW</a></li></ul></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(189);
	
	function SideNavigation($timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            // Call the metsiMenu plugin and plug it to sidebar navigation
	            $timeout(function () {
	                (0, _jquery2['default'])(element).metisMenu();
	            });
	        }
	    };
	};
	
	SideNavigation.$inject = ['$timeout'];
	
	exports.SideNavigation = SideNavigation;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * metismenu - v2.4.3
	 * A jQuery menu plugin
	 * https://github.com/onokumus/metisMenu#readme
	 *
	 * Made by Osman Nuri Okumuş <onokumus@gmail.com> (https://github.com/onokumus)
	 * Under MIT License
	 */
	
	(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(80)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require('jquery'));
	  } else {
	    root.sortable = factory(root.jQuery);
	  }
	}(this, function($) {
	  'use strict';
	
	  function transitionEnd() {
	    var el = document.createElement('mm');
	
	    var transEndEventNames = {
	      WebkitTransition: 'webkitTransitionEnd',
	      MozTransition: 'transitionend',
	      OTransition: 'oTransitionEnd otransitionend',
	      transition: 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return {
	          end: transEndEventNames[name]
	        };
	      }
	    }
	    return false;
	  }
	
	  $.fn.emulateTransitionEnd = function(duration) {
	    var called = false;
	    var $el = this;
	    $(this).one('mmTransitionEnd', function() {
	      called = true;
	    });
	    var callback = function() {
	      if (!called) {
	        $($el).trigger($transition.end);
	      }
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  var $transition = transitionEnd();
	  if (!!$transition) {
	    $.event.special.mmTransitionEnd = {
	      bindType: $transition.end,
	      delegateType: $transition.end,
	      handle: function(e) {
	        if ($(e.target).is(this)) {
	          return e.
	          handleObj.
	          handler.
	          apply(this, arguments);
	        }
	      }
	    };
	  }
	
	  var MetisMenu = function(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, MetisMenu.DEFAULTS, options);
	    this.transitioning = null;
	
	    this.init();
	  };
	
	  MetisMenu.TRANSITION_DURATION = 350;
	
	  MetisMenu.DEFAULTS = {
	    toggle: true,
	    doubleTapToGo: false,
	    preventDefault: true,
	    activeClass: 'active',
	    collapseClass: 'collapse',
	    collapseInClass: 'in',
	    collapsingClass: 'collapsing',
	    onTransitionStart: false,
	    onTransitionEnd: false
	  };
	
	  MetisMenu.prototype.init = function() {
	    var $this = this;
	    var activeClass = this.options.activeClass;
	    var collapseClass = this.options.collapseClass;
	    var collapseInClass = this.options.collapseInClass;
	
	    this
	      .$element
	      .find('li.' + activeClass)
	      .has('ul')
	      .children('ul')
	      .attr('aria-expanded', true)
	      .addClass(collapseClass + ' ' + collapseInClass);
	
	    this
	      .$element
	      .find('li')
	      .not('.' + activeClass)
	      .has('ul')
	      .children('ul')
	      .attr('aria-expanded', false)
	      .addClass(collapseClass);
	
	    //add the 'doubleTapToGo' class to active items if needed
	    if (this.options.doubleTapToGo) {
	      this
	        .$element
	        .find('li.' + activeClass)
	        .has('ul')
	        .children('a')
	        .addClass('doubleTapToGo');
	    }
	
	    this
	      .$element
	      .find('li')
	      .has('ul')
	      .children('a')
	      .on('click.metisMenu', function(e) {
	        var self = $(this);
	        var $parent = self.parent('li');
	        var $list = $parent.children('ul');
	        if($this.options.preventDefault){
	          e.preventDefault();
	        }
	        if(self.attr('aria-disabled') === 'true'){
	            return;
	        }
	        if ($parent.hasClass(activeClass) && !$this.options.doubleTapToGo) {
	          $this.hide($list);
	          self.attr('aria-expanded',false);
	        } else {
	          $this.show($list);
	          self.attr('aria-expanded',true);
	        }
	
	        if($this.options.onTransitionStart) {
	          $this.options.onTransitionStart(e);
	        }
	
	        //Do we need to enable the double tap
	        if ($this.options.doubleTapToGo) {
	          //if we hit a second time on the link and the href is valid, navigate to that url
	          if ($this.doubleTapToGo(self) && self.attr('href') !== '#' && self.attr('href') !== '') {
	            e.stopPropagation();
	            document.location = self.attr('href');
	            return;
	          }
	        }
	      });
	  };
	
	  MetisMenu.prototype.doubleTapToGo = function(elem) {
	    var $this = this.$element;
	    //if the class 'doubleTapToGo' exists, remove it and return
	    if (elem.hasClass('doubleTapToGo')) {
	      elem.removeClass('doubleTapToGo');
	      return true;
	    }
	    //does not exists, add a new class and return false
	    if (elem.parent().children('ul').length) {
	      //first remove all other class
	      $this
	        .find('.doubleTapToGo')
	        .removeClass('doubleTapToGo');
	      //add the class on the current element
	      elem.addClass('doubleTapToGo');
	      return false;
	    }
	  };
	
	  MetisMenu.prototype.show = function(el) {
	    var activeClass = this.options.activeClass;
	    var collapseClass = this.options.collapseClass;
	    var collapseInClass = this.options.collapseInClass;
	    var collapsingClass = this.options.collapsingClass;
	    var $this = $(el);
	    var $parent = $this.parent('li');
	    if (this.transitioning || $this.hasClass(collapseInClass)) {
	      return;
	    }
	
	    $parent.addClass(activeClass);
	
	    if (this.options.toggle) {
	      this.hide($parent.siblings().children('ul.' + collapseInClass).attr('aria-expanded', false));
	    }
	
	    $this
	      .removeClass(collapseClass)
	      .addClass(collapsingClass)
	      .height(0);
	
	    this.transitioning = 1;
	    var complete = function() {
	      if(this.transitioning && this.options.onTransitionEnd) {
	        this.options.onTransitionEnd();
	      }
	      $this
	        .removeClass(collapsingClass)
	        .addClass(collapseClass + ' ' + collapseInClass)
	        .height('')
	        .attr('aria-expanded', true);
	      this.transitioning = 0;
	    };
	    if (!$transition) {
	      return complete.call(this);
	    }
	    $this
	      .one('mmTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(MetisMenu.TRANSITION_DURATION)
	      .height($this[0].scrollHeight);
	  };
	
	  MetisMenu.prototype.hide = function(el) {
	    var activeClass = this.options.activeClass;
	    var collapseClass = this.options.collapseClass;
	    var collapseInClass = this.options.collapseInClass;
	    var collapsingClass = this.options.collapsingClass;
	    var $this = $(el);
	
	    if (this.transitioning || !$this.hasClass(collapseInClass)) {
	      return;
	    }
	
	    $this.parent('li').removeClass(activeClass);
	    $this.height($this.height())[0].offsetHeight;
	
	    $this
	      .addClass(collapsingClass)
	      .removeClass(collapseClass)
	      .removeClass(collapseInClass);
	
	    this.transitioning = 1;
	
	    var complete = function() {
	      if(this.transitioning && this.options.onTransitionEnd) {
	        this.options.onTransitionEnd();
	      }
	      this.transitioning = 0;
	      $this
	        .removeClass(collapsingClass)
	        .addClass(collapseClass)
	        .attr('aria-expanded', false);
	    };
	
	    if (!$transition) {
	      return complete.call(this);
	    }
	    $this
	      .height(0)
	      .one('mmTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(MetisMenu.TRANSITION_DURATION);
	  };
	
	  function Plugin(option) {
	    return this.each(function() {
	      var $this = $(this);
	      var data = $this.data('mm');
	      var options = $.extend({},
	        MetisMenu.DEFAULTS,
	        $this.data(),
	        typeof option === 'object' && option
	      );
	
	      if (!data) {
	        $this.data('mm', (data = new MetisMenu(this, options)));
	      }
	      if (typeof option === 'string') {
	        data[option]();
	      }
	    });
	  }
	
	  var old = $.fn.metisMenu;
	
	  $.fn.metisMenu = Plugin;
	  $.fn.metisMenu.Constructor = MetisMenu;
	
	  $.fn.metisMenu.noConflict = function() {
	    $.fn.metisMenu = old;
	    return this;
	  };
	}));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarTopComponentJs = __webpack_require__(191);
	
	var navbarTop = _angular2['default'].module('navbartop', []);
	
	navbarTop.component('navbarTop', _navbarTopComponentJs.NavbarTopComponent);
	
	exports.navbarTop = navbarTop;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarTopHtml = __webpack_require__(192);
	
	var _navbarTopHtml2 = _interopRequireDefault(_navbarTopHtml);
	
	var _navbarTopControllerJs = __webpack_require__(193);
	
	var NavbarTopComponent = {
	    restrict: 'E',
	    templateUrl: _navbarTopHtml2['default'],
	    controller: _navbarTopControllerJs.NavbarTopController,
	    controllerAs: 'vm',
	    bindings: {
	        searchCaption: '<',
	        onFilter: '&'
	    }
	};
	
	exports.NavbarTopComponent = NavbarTopComponent;

/***/ },
/* 192 */
/***/ function(module, exports) {

	var path = 'app/components/common/navbarTop/navbarTop.html';
	var html = "<nav class=\"navbar navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><a class=\"navbar-minimalize minimalize-styl-2 btn btn-primary\" href=\"#\"><i class=\"fa fa-bars\"></i></a><form role=\"search\" class=\"navbar-form-custom\" ng-submit=\"vm.submit()\"><div class=\"form-group\"><input ng-model=\"vm.searchValue\" type=\"text\" placeholder=\"{{vm.searchCaption}}\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login\"><i class=\"fa fa-sign-out\"></i> Odjava</a></li></ul></nav>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var NavbarTopController = (function () {
	    function NavbarTopController() {
	        _classCallCheck(this, NavbarTopController);
	
	        this.searchCaption = this.searchCaption || 'Pretraži';
	        this.onFilter = this.onFilter || angular.noop;
	        this.hideFilter = this.onFilter === angular.noop;
	        this.searchValue = '';
	    }
	
	    _createClass(NavbarTopController, [{
	        key: 'submit',
	        value: function submit() {
	            this.onFilter({ value: this.searchValue });
	        }
	    }]);
	
	    return NavbarTopController;
	})();
	
	exports.NavbarTopController = NavbarTopController;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _footerComponentJs = __webpack_require__(195);
	
	var footer = _angular2['default'].module('footer', []);
	
	footer.component('footer', _footerComponentJs.FooterComponent);
	
	exports.footer = footer;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _footerHtml = __webpack_require__(196);
	
	var _footerHtml2 = _interopRequireDefault(_footerHtml);
	
	var FooterComponent = {
	    restrict: 'E',
	    templateUrl: _footerHtml2['default']
	};
	
	exports.FooterComponent = FooterComponent;

/***/ },
/* 196 */
/***/ function(module, exports) {

	var path = 'app/components/common/footer/footer.html';
	var html = "<div class=\"footer\"><div><strong>Copyright</strong> <a href=\"http://www.invita.hr\" target=\"_blank\">InVita d.o.o.</a> &copy; 2017.</div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _headerComponentJs = __webpack_require__(198);
	
	var header = _angular2['default'].module('header', []);
	
	header.component('header', _headerComponentJs.HeaderComponent);
	
	exports.header = header;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _headerHtml = __webpack_require__(199);
	
	var _headerHtml2 = _interopRequireDefault(_headerHtml);
	
	var HeaderController = (function () {
	    function HeaderController(messaging, $state) {
	        _classCallCheck(this, HeaderController);
	
	        this.messaging = function () {
	            return messaging;
	        };
	        this.$state = function () {
	            return $state;
	        };
	    }
	
	    _createClass(HeaderController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.comments = [];
	            this.disableSearch = !_lodash2['default'].isString(this.searchPlaceholder);
	            this.refreshState();
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this = this;
	
	            var messaging = this.messaging();
	            messaging.getComments().then(function (response) {
	                _this.comments = [].concat(_toConsumableArray(response));
	            });
	        }
	    }, {
	        key: 'showComment',
	        value: function showComment(comment) {
	            var messaging = this.messaging();
	            var $state = this.$state();
	            messaging.updateComment(comment).then(function () {
	                $state.go('radniNalog.details.komentari', { id: comment.radni_nalog });
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            this.onSearch({ value: this.searchValue });
	        }
	    }]);
	
	    return HeaderController;
	})();
	
	HeaderController.$inject = ['messaging', '$state'];
	
	var HeaderComponent = {
	    restrict: 'E',
	    templateUrl: _headerHtml2['default'],
	    controller: HeaderController,
	    controllerAs: 'vm',
	    bindings: {
	        onSearch: '&',
	        searchPlaceholder: '@'
	    }
	};
	
	exports.HeaderComponent = HeaderComponent;

/***/ },
/* 199 */
/***/ function(module, exports) {

	var path = 'app/components/common/header/header.html';
	var html = "<div class=\"color-line\"></div><div id=\"logo\" class=\"light-version\"><span><i class=\"fa fa-user\"></i> Aktivni korisnik</span></div><nav role=\"navigation\"><minimaliza-menu></minimaliza-menu><div class=\"small-logo\"><span class=\"text-primary\">DENTAL LAB</span></div><form role=\"search\" class=\"navbar-form-custom\" ng-submit=\"vm.submit()\"><div class=\"form-group\"><input type=\"text\" ng-model=\"vm.searchValue\" placeholder=\"{{vm.searchPlaceholder}}\" class=\"form-control\" name=\"search\" ng-disabled=\"vm.disableSearch\"></div></form><div class=\"mobile-menu\"><button type=\"button\" class=\"navbar-toggle mobile-menu-toggle\" data-toggle=\"collapse\" data-target=\"#mobile-collapse\"><i class=\"fa fa-chevron-down\"></i></button><div class=\"collapse mobile-navbar\" id=\"mobile-collapse\"><ul class=\"nav navbar-nav\"><li><a href=\"#\">Login</a></li></ul></div></div><div class=\"navbar-right\"><ul class=\"nav navbar-nav no-borders\"><li class=\"dropdown\"><a class=\"dropdown-toggle label-menu-corner\" data-toggle=\"dropdown\"><i class=\"pe-7s-note2\"></i> <span class=\"label label-success\">{{vm.comments.length}}</span></a><ul class=\"dropdown-menu hdropdown notification animated flipInX\"><li ng-repeat=\"item in vm.comments\"><a ng-click=\"vm.showComment(item)\">Nalog: &nbsp; <span class=\"label label-success\">{{item.sifra_naloga}}</span> - {{item.sender}} - {{item.poruka}}</a></li><li class=\"summary\"><h5 ng-if=\"vm.comments.length > 0\">{{vm.comments.length}} nove poruke</h5><h5 ng-if=\"vm.comments.length === 0\">Nemate novih poruka</h5></li></ul></li><li class=\"dropdown\"><a ui-sref=\"login\"><i class=\"pe-7s-upload pe-rotate-90\"></i></a></li></ul></div></nav>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	// import jQuery from 'jQuery';
	
	/**
	 * HOMER - Responsive Admin Theme
	 * Copyright 2015 Webapplayers.com
	 *
	 */
	
	/**
	 * pageTitle - Directive for set Page title - mata title
	 */
	function pageTitle($rootScope, $timeout) {
	    return {
	        link: function link(scope, element) {
	            var listener = function listener(event, toState, toParams, fromState, fromParams) {
	                // Default title
	                var title = 'HOMER | AngularJS Responsive WebApp';
	                // Create your own title pattern
	                if (toState.data && toState.data.pageTitle) title = 'HOMER | ' + toState.data.pageTitle;
	                $timeout(function () {
	                    element.text(title);
	                });
	            };
	            $rootScope.$on('$stateChangeStart', listener);
	        }
	    };
	}
	pageTitle.$inject = ['$rootScope', '$timeout'];
	
	// /**
	//  * sideNavigation - Directive for run metsiMenu on sidebar navigation
	//  */
	// function sideNavigation($timeout) {
	//     return {
	//         restrict: 'A',
	//         link: function(scope, element) {
	//             // Call the metsiMenu plugin and plug it to sidebar navigation
	//             element.metisMenu();
	
	//             // Colapse menu in mobile mode after click on element
	//             var menuElement = $('#side-menu a:not([href$="\\#"])');
	//             menuElement.click(function(){
	
	//                 if ($(window).width() < 769) {
	//                     $("body").toggleClass("show-sidebar");
	//                 }
	//             });
	
	//         }
	//     };
	// };
	
	/**
	 * minimalizaSidebar - Directive for minimalize sidebar
	 */
	function minimalizaMenu($rootScope) {
	    return {
	        restrict: 'EA',
	        template: '<div class="header-link hide-menu" ng-click="minimalize()"><i class="fa fa-bars"></i></div>',
	        controller: ['$scope', function ($scope) {
	            $scope.minimalize = function () {
	                if ($(window).width() < 769) {
	                    $('body').toggleClass('show-sidebar');
	                } else {
	                    $('body').toggleClass('hide-sidebar');
	                }
	            };
	        }]
	    };
	}
	minimalizaMenu.$inject = ['$rootScope'];
	
	/**
	 * sparkline - Directive for Sparkline chart
	 */
	function sparkline() {
	    return {
	        restrict: 'A',
	        scope: {
	            sparkData: '=',
	            sparkOptions: '='
	        },
	        link: function link(scope, element, attrs) {
	            scope.$watch(scope.sparkData, function () {
	                render();
	            });
	            scope.$watch(scope.sparkOptions, function () {
	                render();
	            });
	            var render = function render() {
	                $(element).sparkline(scope.sparkData, scope.sparkOptions);
	            };
	        }
	    };
	}
	
	/**
	 * icheck - Directive for custom checkbox icheck
	 */
	function icheck($timeout) {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function link($scope, element, $attrs, ngModel) {
	            return $timeout(function () {
	                var value;
	                value = $attrs['value'];
	
	                $scope.$watch($attrs['ngModel'], function (newValue) {
	                    $(element).iCheck('update');
	                });
	
	                return $(element).iCheck({
	                    checkboxClass: 'icheckbox_square-green',
	                    radioClass: 'iradio_square-green'
	                }).on('ifChanged', function (event) {
	                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
	                        $scope.$apply(function () {
	                            return ngModel.$setViewValue(event.target.checked);
	                        });
	                    }
	                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
	                        return $scope.$apply(function () {
	                            return ngModel.$setViewValue(value);
	                        });
	                    }
	                });
	            });
	        }
	    };
	}
	icheck.$inject = ['$timeout'];
	
	/**
	 * panelTools - Directive for panel tools elements in right corner of panel
	 */
	function panelTools($timeout) {
	    return {
	        restrict: 'A',
	        scope: true,
	        templateUrl: 'views/common/panel_tools.html',
	        controller: ['$scope', '$element', function ($scope, $element) {
	            // Function for collapse ibox
	            $scope.showhide = function () {
	                var hpanel = $element.closest('div.hpanel');
	                var icon = $element.find('i:first');
	                var body = hpanel.find('div.panel-body');
	                var footer = hpanel.find('div.panel-footer');
	                body.slideToggle(300);
	                footer.slideToggle(200);
	                // Toggle icon from up to down
	                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
	                hpanel.toggleClass('').toggleClass('panel-collapse');
	                $timeout(function () {
	                    hpanel.resize();
	                    hpanel.find('[id^=map-]').resize();
	                }, 50);
	            },
	            // Function for close ibox
	            $scope.closebox = function () {
	                var hpanel = $element.closest('div.hpanel');
	                hpanel.remove();
	            };
	        }]
	    };
	}
	panelTools.$inject = ['$timeout'];
	
	/**
	 * panelToolsFullscreen - Directive for panel tools elements in right corner of panel with fullscreen option
	 */
	function panelToolsFullscreen($timeout) {
	    return {
	        restrict: 'A',
	        scope: true,
	        templateUrl: 'views/common/panel_tools_fullscreen.html',
	        controller: ['$scope', '$element', function ($scope, $element) {
	            // Function for collapse ibox
	            $scope.showhide = function () {
	                var hpanel = $element.closest('div.hpanel');
	                var icon = $element.find('i:first');
	                var body = hpanel.find('div.panel-body');
	                var footer = hpanel.find('div.panel-footer');
	                body.slideToggle(300);
	                footer.slideToggle(200);
	                // Toggle icon from up to down
	                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
	                hpanel.toggleClass('').toggleClass('panel-collapse');
	                $timeout(function () {
	                    hpanel.resize();
	                    hpanel.find('[id^=map-]').resize();
	                }, 50);
	            };
	
	            // Function for close ibox
	            $scope.closebox = function () {
	                var hpanel = $element.closest('div.hpanel');
	                hpanel.remove();
	                if ($('body').hasClass('fullscreen-panel-mode')) {
	                    $('body').removeClass('fullscreen-panel-mode');
	                }
	            };
	
	            // Function for fullscreen
	            $scope.fullscreen = function () {
	                var hpanel = $element.closest('div.hpanel');
	                var icon = $element.find('i:first');
	                $('body').toggleClass('fullscreen-panel-mode');
	                icon.toggleClass('fa-expand').toggleClass('fa-compress');
	                hpanel.toggleClass('fullscreen');
	                setTimeout(function () {
	                    $(window).trigger('resize');
	                }, 100);
	            };
	        }]
	    };
	}
	panelToolsFullscreen.$inject = ['$timeout'];
	
	/**
	 * smallHeader - Directive for page title panel
	 */
	function smallHeader() {
	    return {
	        restrict: 'A',
	        scope: true,
	        controller: ['$scope', '$element', function ($scope, $element) {
	            $scope.small = function () {
	                var icon = $element.find('i:first');
	                var breadcrumb = $element.find('#hbreadcrumb');
	                $element.toggleClass('small-header');
	                breadcrumb.toggleClass('m-t-lg');
	                icon.toggleClass('fa-arrow-up').toggleClass('fa-arrow-down');
	            };
	        }]
	    };
	}
	
	function animatePanel($timeout, $state) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            //Set defaul values for start animation and delay
	            var panel;
	            var startAnimation = 0;
	            var delay = 0.06; // secunds
	            var start = Math.abs(delay) + startAnimation;
	
	            // Store current state where directive was start
	            var currentState = $state.current.name;
	
	            // Set default values for attrs
	            if (!attrs.effect) {
	                attrs.effect = 'zoomIn';
	            }
	            if (attrs.delay) {
	                delay = attrs.delay / 10;
	            } else {
	                delay = 0.06;
	            }
	            if (!attrs.child) {
	                attrs.child = '.row > div';
	            } else {
	                attrs.child = '.' + attrs.child;
	            }
	            // Get all element and set opactiy to 0
	            element.addClass('opacity-0');
	
	            // Wrap to $timeout to execute after ng-repeat
	            $timeout(function () {
	                // Get all elements and add effect class
	                panel = element.find(attrs.child);
	                panel.addClass('opacity-0').addClass('stagger').addClass('animated-panel').addClass(attrs.effect);
	
	                // show main element
	                element.removeClass('opacity-0');
	
	                var panelsCount = panel.length + 10;
	                var animateTime = panelsCount * delay * 10000 / 10;
	
	                // Add delay for each child elements
	                panel.each(function (i, elm) {
	                    start += delay;
	                    var rounded = Math.round(start * 10) / 10;
	                    $(elm).css('animation-delay', rounded + 's');
	                    // Remove opacity 0 after finish
	                    $(elm).removeClass('opacity-0');
	                });
	
	                // Clear animation after finish
	                $timeout(function () {
	                    // $('.stagger').css('animation', '');
	                    // $('.stagger').removeClass(attrs.effect).removeClass('animated-panel').removeClass('stagger');
	                    panel.css('animation', '');
	                    panel.removeClass(attrs.effect).removeClass('animated-panel').removeClass('stagger');
	                    panel.resize();
	                }, animateTime);
	            });
	        }
	    };
	}
	animatePanel.$inject = ['$timeout', '$state'];
	
	function landingScrollspy() {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.scrollspy({
	                target: '.navbar-fixed-top',
	                offset: 80
	            });
	        }
	    };
	}
	
	/**
	 * clockPicker - Directive for clock picker plugin
	 */
	function clockPicker() {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            element.clockpicker();
	        }
	    };
	}
	
	function dateTimePicker() {
	    return {
	        require: '?ngModel',
	        restrict: 'AE',
	        scope: {
	            pick12HourFormat: '@',
	            language: '@',
	            useCurrent: '@',
	            location: '@'
	        },
	        link: function link(scope, elem, attrs) {
	            elem.datetimepicker({
	                pick12HourFormat: scope.pick12HourFormat,
	                language: scope.language,
	                useCurrent: scope.useCurrent
	            });
	
	            //Local event change
	            elem.on('blur', function () {
	                // For test
	                //console.info('this', this);
	                //console.info('scope', scope);
	                //console.info('attrs', attrs);
	                /*// returns moments.js format object
	                 scope.dateTime = new Date(elem.data("DateTimePicker").getDate().format());
	                 // Global change propagation
	                 $rootScope.$broadcast("emit:dateTimePicker", {
	                 location: scope.location,
	                 action: 'changed',
	                 dateTime: scope.dateTime,
	                 example: scope.useCurrent
	                 });
	                 scope.$apply();*/
	            });
	        }
	    };
	}
	
	var homer = angular.module('homer', []);
	
	homer.directive('pageTitle', pageTitle)
	// .directive('sideNavigation', sideNavigation)
	.directive('minimalizaMenu', minimalizaMenu).directive('sparkline', sparkline).directive('icheck', icheck).directive('panelTools', panelTools).directive('panelToolsFullscreen', panelToolsFullscreen).directive('smallHeader', smallHeader).directive('animatePanel', animatePanel).directive('landingScrollspy', landingScrollspy).directive('clockPicker', clockPicker).directive('dateTimePicker', dateTimePicker);
	
	exports.homer = homer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(202);
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularFormly = __webpack_require__(204);
	
	var _angularFormly2 = _interopRequireDefault(_angularFormly);
	
	// import formlyBootstrap from './formly-bootstrap';
	
	var _angularFormlyTemplatesBootstrap = __webpack_require__(206);
	
	var _angularFormlyTemplatesBootstrap2 = _interopRequireDefault(_angularFormlyTemplatesBootstrap);
	
	var _angularSanitize = __webpack_require__(207);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularMessages = __webpack_require__(209);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _uiSelect = __webpack_require__(211);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _angularUiMask = __webpack_require__(213);
	
	var _angularUiMask2 = _interopRequireDefault(_angularUiMask);
	
	var _datemaskJs = __webpack_require__(215);
	
	var _datetimepickerJs = __webpack_require__(315);
	
	// templates
	
	var _templatesFieldsetHtml = __webpack_require__(399);
	
	var _templatesFieldsetHtml2 = _interopRequireDefault(_templatesFieldsetHtml);
	
	var _templatesRowHtml = __webpack_require__(400);
	
	var _templatesRowHtml2 = _interopRequireDefault(_templatesRowHtml);
	
	var _templatesDivHtml = __webpack_require__(401);
	
	var _templatesDivHtml2 = _interopRequireDefault(_templatesDivHtml);
	
	var _templatesHorizontalLabelHtml = __webpack_require__(402);
	
	var _templatesHorizontalLabelHtml2 = _interopRequireDefault(_templatesHorizontalLabelHtml);
	
	var _templatesHorizontalCheckboxHtml = __webpack_require__(403);
	
	var _templatesHorizontalCheckboxHtml2 = _interopRequireDefault(_templatesHorizontalCheckboxHtml);
	
	var _templatesValidationHtml = __webpack_require__(404);
	
	var _templatesValidationHtml2 = _interopRequireDefault(_templatesValidationHtml);
	
	var _templatesErrorMessagesHtml = __webpack_require__(405);
	
	var _templatesErrorMessagesHtml2 = _interopRequireDefault(_templatesErrorMessagesHtml);
	
	var _templatesUiSelectHtml = __webpack_require__(406);
	
	var _templatesUiSelectHtml2 = _interopRequireDefault(_templatesUiSelectHtml);
	
	var _templatesUiSelectAsyncHtml = __webpack_require__(407);
	
	var _templatesUiSelectAsyncHtml2 = _interopRequireDefault(_templatesUiSelectAsyncHtml);
	
	var _templatesFeedHtml = __webpack_require__(408);
	
	var _templatesFeedHtml2 = _interopRequireDefault(_templatesFeedHtml);
	
	var forms = _angular2['default'].module('forms', [_angularSanitize2['default'], _angularMessages2['default'], _angularFormly2['default'], _angularFormlyTemplatesBootstrap2['default'], _angularUiMask2['default'], _uiSelect2['default'], _datetimepickerJs.datetimepicker.name]);
	
	function setWrappers(formlyConfig) {
	    // formlyConfig.setWrapper({
	    //     name: 'validation',
	    //     templateUrl: 'app/blocks/formly/templates/validation.html'
	    // });
	
	    formlyConfig.setWrapper({
	        name: 'row',
	        templateUrl: _templatesRowHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'div',
	        templateUrl: _templatesDivHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'fieldset',
	        templateUrl: _templatesFieldsetHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'horizontalBootstrapLabel',
	        templateUrl: _templatesHorizontalLabelHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'horizontalBootstrapCheckbox',
	        templateUrl: _templatesHorizontalCheckboxHtml2['default']
	    });
	}
	
	configFunc.$inject = ['formlyConfigProvider'];
	function configFunc(formlyConfigProvider) {
	    formlyConfigProvider.setWrapper({
	        name: 'validation',
	        types: ['input', 'hInput', 'maskedInput', 'textarea', 'select', 'typeahead', 'datepicker', 'hDatepicker', 'hSelect', 'hTextarea', 'huiSelect', 'uiSelect', 'uiSelectAsync', 'huiSelectAsync'],
	        templateUrl: _templatesValidationHtml2['default']
	    });
	}
	
	runFunc.$inject = ['formlyConfig'];
	function runFunc(formlyConfig) {
	    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = '!fc.$pristine || form.$submitted';
	
	    setWrappers(formlyConfig);
	
	    formlyConfig.setType({
	        name: 'hInput',
	        'extends': 'input',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hCheckbox',
	        'extends': 'checkbox',
	        wrapper: ['horizontalBootstrapCheckbox', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hRadio',
	        'extends': 'radio',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hSelect',
	        'extends': 'select',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hTextarea',
	        'extends': 'textarea',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'typeahead',
	        'extends': 'input',
	        defaultOptions: {
	            ngModelAttrs: {
	                uibTypeahead: {
	                    attribute: 'typeahead'
	                },
	                typeaheadOnSelect: {
	                    attribute: 'typeahead-on-select'
	                },
	                typeaheadWaitMs: {
	                    attribute: 'typeahead-wait-ms'
	                },
	                typeaheadEditable: {
	                    attribute: 'typeahead-editable'
	                }
	            },
	
	            ngModelElAttrs: {
	                autocomplete: 'off'
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'hTypeahead',
	        'extends': 'typeahead',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'maskedInput',
	        'extends': 'input',
	        defaultOptions: {
	            ngModelAttrs: {
	                mask: {
	                    attribute: 'ui-mask'
	                },
	                maskPlaceholder: {
	                    attribute: 'ui-mask-placeholder'
	                }
	            },
	            templateOptions: {
	                maskPlaceholder: ''
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'datepicker',
	        'extends': 'maskedInput',
	        defaultOptions: {
	            templateOptions: {
	                maskPlaceholder: 'DD.MM.GGGG',
	                mask: '99.99.9999'
	            },
	            ngModelElAttrs: {
	                datemask: '',
	                datetimepicker: ''
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'timepicker',
	        'extends': 'maskedInput',
	        defaultOptions: {
	            templateOptions: {
	                maskPlaceholder: 'HH:MM',
	                mask: '99:99'
	            },
	            ngModelElAttrs: {
	                'model-view-value': 'true'
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'datetimepicker',
	        'extends': 'maskedInput',
	        defaultOptions: {
	            templateOptions: {
	                maskPlaceholder: 'DD.MM.GGGG hh:mm',
	                mask: '99.99.9999 99:99'
	            },
	            ngModelElAttrs: {
	                datemask: '',
	                format: 'datetime'
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'hTimepicker',
	        'extends': 'timepicker',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hDatepicker',
	        'extends': 'datepicker',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hDatetimepicker',
	        'extends': 'datetimepicker',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'uiSelect',
	        'extends': 'select',
	        templateUrl: _templatesUiSelectHtml2['default']
	    });
	
	    formlyConfig.setType({
	        name: 'huiSelect',
	        'extends': 'uiSelect',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'uiSelectAsync',
	        'extends': 'select',
	        templateUrl: _templatesUiSelectAsyncHtml2['default'],
	        defaultOptions: {
	            templateOptions: {
	                optionsAttr: 'bs-options',
	                ngOptions: 'option[to.valueProp] as option in to.options',
	                options: [],
	                refreshDelay: 700
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'huiSelectAsync',
	        'extends': 'uiSelectAsync',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	}
	
	forms.config(configFunc);
	forms.run(runFunc);
	
	forms.directive('datemask', _datemaskJs.datemask);
	
	exports.forms = forms;

/***/ },
/* 202 */
32,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! angular-formly-templates-bootstrap version 6.3.0 built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us> (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(81), __webpack_require__(204), __webpack_require__(205));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "angular-formly", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormlyTemplatesBootstrap"] = factory(require("angular"), require("angular-formly"), require("api-check"));
		else
			root["ngFormlyTemplatesBootstrap"] = factory(root["angular"], root["ngFormly"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var ngModuleName = 'formlyBootstrap';
		var angular = __webpack_require__(2);
		var ngModule = angular.module(ngModuleName, [__webpack_require__(4)]);
		ngModule.constant('formlyBootstrapApiCheck', __webpack_require__(5)({
		  output: {
		    prefix: 'angular-formly-bootstrap'
		  }
		}));
		ngModule.constant('formlyBootstrapVersion', ("6.3.0"));
	
		__webpack_require__(6)(ngModule);
		__webpack_require__(9)(ngModule);
		__webpack_require__(19)(ngModule);
	
		exports['default'] = ngModuleName;
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		var angular = __webpack_require__(3);
		if (!angular.version) {
		  angular = window.angular;
		}
		module.exports = angular;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addWrappers);
	
		  function addWrappers(formlyConfigProvider) {
		    formlyConfigProvider.setWrapper([{
		      name: 'bootstrapLabel',
		      template: __webpack_require__(7),
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string.optional,
		            required: check.bool.optional,
		            labelSrOnly: check.bool.optional
		          }
		        };
		      }
		    }, { name: 'bootstrapHasError', template: __webpack_require__(8) }]);
		  }
		  addWrappers.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = "<div>\n  <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\">\n    {{to.label}}\n    {{to.required ? '*' : ''}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"form-group\" ng-class=\"{'has-error': showError}\">\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  __webpack_require__(10)(ngModule);
		  __webpack_require__(12)(ngModule);
		  __webpack_require__(14)(ngModule);
		  __webpack_require__(15)(ngModule);
		  __webpack_require__(17)(ngModule);
		  __webpack_require__(18)(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'checkbox',
		      template: __webpack_require__(11),
		      wrapper: ['bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string
		          }
		        };
		      }
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"checkbox\">\n\t<label>\n\t\t<input type=\"checkbox\"\n           class=\"formly-field-checkbox\"\n\t\t       ng-model=\"model[options.key]\">\n\t\t{{to.label}}\n\t\t{{to.required ? '*' : ''}}\n\t</label>\n</div>\n"
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'multiCheckbox',
		      template: __webpack_require__(13),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional
		          }
		        };
		      },
		      defaultOptions: {
		        noFormControl: false,
		        ngModelAttrs: {
		          required: {
		            attribute: '',
		            bound: ''
		          }
		        }
		      },
		      controller: /* @ngInject */["$scope", function controller($scope) {
		        var to = $scope.to;
		        var opts = $scope.options;
		        $scope.multiCheckbox = {
		          checked: [],
		          change: setModel
		        };
	
		        // initialize the checkboxes check property
		        $scope.$watch('model', function modelWatcher(newModelValue) {
		          var modelValue, valueProp;
	
		          if (Object.keys(newModelValue).length) {
		            modelValue = newModelValue[opts.key];
	
		            $scope.$watch('to.options', function optionsWatcher(newOptionsValues) {
		              if (newOptionsValues && Array.isArray(newOptionsValues) && Array.isArray(modelValue)) {
		                valueProp = to.valueProp || 'value';
		                for (var index = 0; index < newOptionsValues.length; index++) {
		                  $scope.multiCheckbox.checked[index] = modelValue.indexOf(newOptionsValues[index][valueProp]) !== -1;
		                }
		              }
		            });
		          }
		        }, true);
	
		        function checkValidity(expressionValue) {
		          var valid;
	
		          if ($scope.to.required) {
		            valid = angular.isArray($scope.model[opts.key]) && $scope.model[opts.key].length > 0 && expressionValue;
	
		            $scope.fc.$setValidity('required', valid);
		          }
		        }
	
		        function setModel() {
		          $scope.model[opts.key] = [];
		          angular.forEach($scope.multiCheckbox.checked, function (checkbox, index) {
		            if (checkbox) {
		              $scope.model[opts.key].push(to.options[index][to.valueProp || 'value']);
		            }
		          });
	
		          // Must make sure we mark as touched because only the last checkbox due to a bug in angular.
		          $scope.fc.$setTouched();
		          checkValidity(true);
		        }
	
		        if (opts.expressionProperties && opts.expressionProperties['templateOptions.required']) {
		          $scope.$watch(function () {
		            return $scope.to.required;
		          }, function (newValue) {
		            checkValidity(newValue);
		          });
		        }
	
		        if ($scope.to.required) {
		          var unwatchFormControl = $scope.$watch('fc', function (newValue) {
		            if (!newValue) {
		              return;
		            }
		            checkValidity(true);
		            unwatchFormControl();
		          });
		        }
		      }]
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\"\n             id=\"{{id + '_'+ $index}}\"\n             ng-model=\"multiCheckbox.checked[$index]\"\n             ng-change=\"multiCheckbox.change()\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addInputType);
	
		  function addInputType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'input',
		      template: '<input class="form-control" ng-model="model[options.key]">',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError']
		    });
		  }
		  addInputType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addRadioType);
	
		  function addRadioType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'radio',
		      template: __webpack_require__(16),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        noFormControl: false
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional
		          }
		        };
		      }
		    });
		  }
		  addRadioType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"radio\">\n    <label>\n      <input type=\"radio\"\n             id=\"{{id + '_'+ $index}}\"\n             tabindex=\"0\"\n             ng-value=\"option[to.valueProp || 'value']\"\n             ng-model=\"model[options.key]\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addSelectType);
	
		  var template = '<select class="form-control" ng-model="model[options.key]"></select>';
	
		  function addSelectType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'select',
		      template: template,
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: function defaultOptions(options) {
		        /* jshint maxlen:195 */
		        var ngOptions = options.templateOptions.ngOptions || 'option[to.valueProp || \'value\'] as option[to.labelProp || \'name\'] group by option[to.groupProp || \'group\'] for option in to.options';
		        return {
		          ngModelAttrs: _defineProperty({}, ngOptions, {
		            value: options.templateOptions.optionsAttr || 'ng-options'
		          })
		        };
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            optionsAttr: check.string.optional,
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            groupProp: check.string.optional
		          }
		        };
		      }
		    });
		  }
		  addSelectType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addTextareaType);
	
		  function addTextareaType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'textarea',
		      template: '<textarea class="form-control" ng-model="model[options.key]"></textarea>',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        ngModelAttrs: {
		          rows: { attribute: 'rows' },
		          cols: { attribute: 'cols' }
		        }
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            rows: check.number.optional,
		            cols: check.number.optional
		          }
		        };
		      }
		    });
		  }
		  addTextareaType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _addons = __webpack_require__(20);
	
		var _addons2 = _interopRequireDefault(_addons);
	
		var _description = __webpack_require__(22);
	
		var _description2 = _interopRequireDefault(_description);
	
		exports['default'] = function (ngModule) {
		  (0, _addons2['default'])(ngModule);
		  (0, _description2['default'])(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addAddonsManipulator);
	
		  function addAddonsManipulator(formlyConfig, formlyBootstrapApiCheck) {
		    var addonTemplate = __webpack_require__(21);
		    var addonChecker = formlyBootstrapApiCheck.shape({
		      'class': formlyBootstrapApiCheck.string.optional,
		      text: formlyBootstrapApiCheck.string.optional,
		      onClick: formlyBootstrapApiCheck.func.optional
		    }).strict.optional;
		    var api = formlyBootstrapApiCheck.shape({
		      templateOptions: formlyBootstrapApiCheck.shape({
		        addonLeft: addonChecker,
		        addonRight: addonChecker
		      })
		    });
		    formlyConfig.templateManipulators.preWrapper.push(function (template, options) {
		      if (!options.templateOptions.addonLeft && !options.templateOptions.addonRight) {
		        return template;
		      }
		      formlyBootstrapApiCheck.warn([api], [options]);
		      return addonTemplate.replace('<formly-transclude></formly-transclude>', template);
		    });
		  }
		  addAddonsManipulator.$inject = ["formlyConfig", "formlyBootstrapApiCheck"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		module.exports = "<div ng-class=\"{'input-group': to.addonLeft || to.addonRight}\">\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonLeft\"\n         ng-style=\"{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonLeft.onClick(options, this, $event)\">\n        <i class=\"{{to.addonLeft.class}}\" ng-if=\"to.addonLeft.class\"></i>\n        <span ng-if=\"to.addonLeft.text\">{{to.addonLeft.text}}</span>\n    </div>\n    <formly-transclude></formly-transclude>\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonRight\"\n         ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonRight.onClick(options, this, $event)\">\n        <i class=\"{{to.addonRight.class}}\" ng-if=\"to.addonRight.class\"></i>\n        <span ng-if=\"to.addonRight.text\">{{to.addonRight.text}}</span>\n    </div>\n</div>\n"
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addDescriptionManipulator);
	
		  function addDescriptionManipulator(formlyConfig) {
		    formlyConfig.templateManipulators.preWrapper.push(function ariaDescribedBy(template, options, scope) {
		      if (angular.isDefined(options.templateOptions.description)) {
		        var el = document.createElement('div');
		        el.appendChild(angular.element(template)[0]);
		        el.appendChild(angular.element('<p id="' + scope.id + '_description"' + 'class="help-block"' + 'ng-if="to.description">' + '{{to.description}}' + '</p>')[0]);
		        var modelEls = angular.element(el.querySelectorAll('[ng-model]'));
		        if (modelEls) {
		          modelEls.attr('aria-describedby', scope.id + '_description');
		        }
		        return el.innerHTML;
		      } else {
		        return template;
		      }
		    });
		  }
		  addDescriptionManipulator.$inject = ["formlyConfig"];
		};
	
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//https://github.com/angular/angular.js/pull/10732
	
	var angular = __webpack_require__(81);
	var mask = __webpack_require__(214);
	
	module.exports = 'ui.mask';


/***/ },
/* 214 */
/***/ function(module, exports) {

	/*!
	 * angular-ui-mask
	 * https://github.com/angular-ui/ui-mask
	 * Version: 1.8.5 - 2016-06-10T18:02:57.970Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	        .value('uiMaskConfig', {
	            maskDefinitions: {
	                '9': /\d/,
	                'A': /[a-zA-Z]/,
	                '*': /[a-zA-Z0-9]/
	            },
	            clearOnBlur: true,
	            clearOnBlurPlaceholder: false,
	            escChar: '\\',
	            eventsToHandle: ['input', 'keyup', 'click', 'focus'],
	            addDefaultPlaceholder: true,
	            allowInvalidValue: false
	        })
	        .provider('uiMask.Config', function() {
	            var options = {};
	
	            this.maskDefinitions = function(maskDefinitions) {
	                return options.maskDefinitions = maskDefinitions;
	            };
	            this.clearOnBlur = function(clearOnBlur) {
	                return options.clearOnBlur = clearOnBlur;
	            };
	            this.clearOnBlurPlaceholder = function(clearOnBlurPlaceholder) {
	                return options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
	            };
	            this.eventsToHandle = function(eventsToHandle) {
	                return options.eventsToHandle = eventsToHandle;
	            };
	            this.addDefaultPlaceholder = function(addDefaultPlaceholder) {
	                return options.addDefaultPlaceholder = addDefaultPlaceholder;
	            };
	            this.allowInvalidValue = function(allowInvalidValue) {
	                return options.allowInvalidValue = allowInvalidValue;
	            };
	            this.$get = ['uiMaskConfig', function(uiMaskConfig) {
	                var tempOptions = uiMaskConfig;
	                for(var prop in options) {
	                    if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) {
	                        angular.extend(tempOptions[prop], options[prop]);
	                    } else {
	                        tempOptions[prop] = options[prop];
	                    }
	                }
	
	                return tempOptions;
	            }];
	        })
	        .directive('uiMask', ['uiMask.Config', function(maskConfig) {
	                function isFocused (elem) {
	                  return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                }
	
	                return {
	                    priority: 100,
	                    require: 'ngModel',
	                    restrict: 'A',
	                    compile: function uiMaskCompilingFunction() {
	                        var options = angular.copy(maskConfig);
	
	                        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
	                            var maskProcessed = false, eventsBound = false,
	                                    maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	                                    // Minimum required length of the value to be considered valid
	                                    minRequiredLength,
	                                    value, valueMasked, isValid,
	                                    // Vars for initializing/uninitializing
	                                    originalPlaceholder = iAttrs.placeholder,
	                                    originalMaxlength = iAttrs.maxlength,
	                                    // Vars used exclusively in eventHandler()
	                                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength,
	                                    // Used for communicating if a backspace operation should be allowed between
	                                    // keydownHandler and eventHandler
	                                    preventBackspace;
	
	                            var originalIsEmpty = controller.$isEmpty;
	                            controller.$isEmpty = function(value) {
	                                if (maskProcessed) {
	                                    return originalIsEmpty(unmaskValue(value || ''));
	                                } else {
	                                    return originalIsEmpty(value);
	                                }
	                            };
	
	                            function initialize(maskAttr) {
	                                if (!angular.isDefined(maskAttr)) {
	                                    return uninitialize();
	                                }
	                                processRawMask(maskAttr);
	                                if (!maskProcessed) {
	                                    return uninitialize();
	                                }
	                                initializeElement();
	                                bindEventListeners();
	                                return true;
	                            }
	
	                            function initPlaceholder(placeholderAttr) {
	                                if ( ! placeholderAttr) {
	                                    return;
	                                }
	
	                                maskPlaceholder = placeholderAttr;
	
	                                // If the mask is processed, then we need to update the value
	                                // but don't set the value if there is nothing entered into the element
	                                // and there is a placeholder attribute on the element because that
	                                // will only set the value as the blank maskPlaceholder
	                                // and override the placeholder on the element
	                                if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
	                                    iElement.val(maskValue(unmaskValue(iElement.val())));
	                                }
	                            }
	
	                            function initPlaceholderChar() {
	                                return initialize(iAttrs.uiMask);
	                            }
	
	                            var modelViewValue = false;
	                            iAttrs.$observe('modelViewValue', function(val) {
	                                if (val === 'true') {
	                                    modelViewValue = true;
	                                }
	                            });
	
	                            iAttrs.$observe('allowInvalidValue', function(val) {
	                                linkOptions.allowInvalidValue = val === ''
	                                    ? true
	                                    : !!val;
	                                formatter(controller.$modelValue);
	                            });
	
	                            function formatter(fromModelValue) {
	                                if (!maskProcessed) {
	                                    return fromModelValue;
	                                }
	                                value = unmaskValue(fromModelValue || '');
	                                isValid = validateValue(value);
	                                controller.$setValidity('mask', isValid);
	
	                                if (!value.length) return undefined;
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return maskValue(value);
	                                } else {
	                                    return undefined;
	                                }
	                            }
	
	                            function parser(fromViewValue) {
	                                if (!maskProcessed) {
	                                    return fromViewValue;
	                                }
	                                value = unmaskValue(fromViewValue || '');
	                                isValid = validateValue(value);
	                                // We have to set viewValue manually as the reformatting of the input
	                                // value performed by eventHandler() doesn't happen until after
	                                // this parser is called, which causes what the user sees in the input
	                                // to be out-of-sync with what the controller's $viewValue is set to.
	                                controller.$viewValue = value.length ? maskValue(value) : '';
	                                controller.$setValidity('mask', isValid);
	
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return modelViewValue ? controller.$viewValue : value;
	                                }
	                            }
	
	                            var linkOptions = {};
	
	                            if (iAttrs.uiOptions) {
	                                linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	                                if (angular.isObject(linkOptions[0])) {
	                                    // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	                                    linkOptions = (function(original, current) {
	                                        for (var i in original) {
	                                            if (Object.prototype.hasOwnProperty.call(original, i)) {
	                                                if (current[i] === undefined) {
	                                                    current[i] = angular.copy(original[i]);
	                                                } else {
	                                                    if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
	                                                        current[i] = angular.extend({}, original[i], current[i]);
	                                                    }
	                                                }
	                                            }
	                                        }
	                                        return current;
	                                    })(options, linkOptions[0]);
	                                } else {
	                                    linkOptions = options;  //gotta be a better way to do this..
	                                }
	                            } else {
	                                linkOptions = options;
	                            }
	
	                            iAttrs.$observe('uiMask', initialize);
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
	                                iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
	                            }
	                            else {
	                                iAttrs.$observe('placeholder', initPlaceholder);
	                            }
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
	                                iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
	                            }
	
	                            controller.$formatters.unshift(formatter);
	                            controller.$parsers.unshift(parser);
	
	                            function uninitialize() {
	                                maskProcessed = false;
	                                unbindEventListeners();
	
	                                if (angular.isDefined(originalPlaceholder)) {
	                                    iElement.attr('placeholder', originalPlaceholder);
	                                } else {
	                                    iElement.removeAttr('placeholder');
	                                }
	
	                                if (angular.isDefined(originalMaxlength)) {
	                                    iElement.attr('maxlength', originalMaxlength);
	                                } else {
	                                    iElement.removeAttr('maxlength');
	                                }
	
	                                iElement.val(controller.$modelValue);
	                                controller.$viewValue = controller.$modelValue;
	                                return false;
	                            }
	
	                            function initializeElement() {
	                                value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
	                                valueMasked = oldValue = maskValue(value);
	                                isValid = validateValue(value);
	                                if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	                                    iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	                                }
	                                if ( ! originalPlaceholder && linkOptions.addDefaultPlaceholder) {
	                                    iElement.attr('placeholder', maskPlaceholder);
	                                }
	                                var viewValue = controller.$modelValue;
	                                var idx = controller.$formatters.length;
	                                while(idx--) {
	                                    viewValue = controller.$formatters[idx](viewValue);
	                                }
	                                controller.$viewValue = viewValue || '';
	                                controller.$render();
	                                // Not using $setViewValue so we don't clobber the model value and dirty the form
	                                // without any kind of user interaction.
	                            }
	
	                            function bindEventListeners() {
	                                if (eventsBound) {
	                                    return;
	                                }
	                                iElement.bind('blur', blurHandler);
	                                iElement.bind('mousedown mouseup', mouseDownUpHandler);
	                                iElement.bind('keydown', keydownHandler);
	                                iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
	                                eventsBound = true;
	                            }
	
	                            function unbindEventListeners() {
	                                if (!eventsBound) {
	                                    return;
	                                }
	                                iElement.unbind('blur', blurHandler);
	                                iElement.unbind('mousedown', mouseDownUpHandler);
	                                iElement.unbind('mouseup', mouseDownUpHandler);
	                                iElement.unbind('keydown', keydownHandler);
	                                iElement.unbind('input', eventHandler);
	                                iElement.unbind('keyup', eventHandler);
	                                iElement.unbind('click', eventHandler);
	                                iElement.unbind('focus', eventHandler);
	                                eventsBound = false;
	                            }
	
	                            function validateValue(value) {
	                                // Zero-length value validity is ngRequired's determination
	                                return value.length ? value.length >= minRequiredLength : true;
	                            }
	
	                            function unmaskValue(value) {
	                                var valueUnmasked = '',
	                                    input = iElement[0],
	                                    maskPatternsCopy = maskPatterns.slice(),
	                                    selectionStart = oldCaretPosition,
	                                    selectionEnd = selectionStart + getSelectionLength(input),
	                                    valueOffset, valueDelta, tempValue = '';
	                                // Preprocess by stripping mask components from value
	                                value = value.toString();
	                                valueOffset = 0;
	                                valueDelta = value.length - maskPlaceholder.length;
	                                angular.forEach(maskComponents, function(component) {
	                                    var position = component.position;
	                                    //Only try and replace the component if the component position is not within the selected range
	                                    //If component was in selected range then it was removed with the user input so no need to try and remove that component
	                                    if (!(position >= selectionStart && position < selectionEnd)) {
	                                        if (position >= selectionStart) {
	                                            position += valueDelta;
	                                        }
	                                        if (value.substring(position, position + component.value.length) === component.value) {
	                                            tempValue += value.slice(valueOffset, position);// + value.slice(position + component.value.length);
	                                            valueOffset = position + component.value.length;
	                                        }
	                                    }
	                                });
	                                value = tempValue + value.slice(valueOffset);
	                                angular.forEach(value.split(''), function(chr) {
	                                    if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                                        valueUnmasked += chr;
	                                        maskPatternsCopy.shift();
	                                    }
	                                });
	
	                                return valueUnmasked;
	                            }
	
	                            function maskValue(unmaskedValue) {
	                                var valueMasked = '',
	                                        maskCaretMapCopy = maskCaretMap.slice();
	
	                                angular.forEach(maskPlaceholder.split(''), function(chr, i) {
	                                    if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                                        valueMasked += unmaskedValue.charAt(0) || '_';
	                                        unmaskedValue = unmaskedValue.substr(1);
	                                        maskCaretMapCopy.shift();
	                                    }
	                                    else {
	                                        valueMasked += chr;
	                                    }
	                                });
	                                return valueMasked;
	                            }
	
	                            function getPlaceholderChar(i) {
	                                var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder,
	                                    defaultPlaceholderChar;
	
	                                if (angular.isDefined(placeholder) && placeholder[i]) {
	                                    return placeholder[i];
	                                } else {
	                                    defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
	                                    return (defaultPlaceholderChar.toLowerCase() === 'space') ? ' ' : defaultPlaceholderChar[0];
	                                }
	                            }
	
	                            // Generate array of mask components that will be stripped from a masked value
	                            // before processing to prevent mask components from being added to the unmasked value.
	                            // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	                            function getMaskComponents() {
	                                var maskPlaceholderChars = maskPlaceholder.split(''),
	                                        maskPlaceholderCopy, components;
	
	                                //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
	                                if (maskCaretMap && !isNaN(maskCaretMap[0])) {
	                                    //Instead of trying to manipulate the RegEx based on the placeholder characters
	                                    //we can simply replace the placeholder characters based on the already built
	                                    //maskCaretMap to underscores and leave the original working RegEx to get the proper
	                                    //mask components
	                                    angular.forEach(maskCaretMap, function(value) {
	                                        maskPlaceholderChars[value] = '_';
	                                    });
	                                }
	                                maskPlaceholderCopy = maskPlaceholderChars.join('');
	                                components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
	                                components = components.filter(function(s) {
	                                    return s !== '';
	                                });
	
	                                // need a string search offset in cases where the mask contains multiple identical components
	                                // E.g., a mask of 99.99.99-999.99
	                                var offset = 0;
	                                return components.map(function(c) {
	                                    var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
	                                    offset = componentPosition + 1;
	                                    return {
	                                        value: c,
	                                        position: componentPosition
	                                    };
	                                });
	                            }
	
	                            function processRawMask(mask) {
	                                var characterCount = 0;
	
	                                maskCaretMap = [];
	                                maskPatterns = [];
	                                maskPlaceholder = '';
	
	                                if (angular.isString(mask)) {
	                                    minRequiredLength = 0;
	
	                                    var isOptional = false,
	                                            numberOfOptionalCharacters = 0,
	                                            splitMask = mask.split('');
	
	                                    var inEscape = false;
	                                    angular.forEach(splitMask, function(chr, i) {
	                                        if (inEscape) {
	                                            inEscape = false;
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                        else if (linkOptions.escChar === chr) {
	                                            inEscape = true;
	                                        }
	                                        else if (linkOptions.maskDefinitions[chr]) {
	                                            maskCaretMap.push(characterCount);
	
	                                            maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                                            maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                                            characterCount++;
	                                            if (!isOptional) {
	                                                minRequiredLength++;
	                                            }
	
	                                            isOptional = false;
	                                        }
	                                        else if (chr === '?') {
	                                            isOptional = true;
	                                            numberOfOptionalCharacters++;
	                                        }
	                                        else {
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                    });
	                                }
	                                // Caret position immediately following last position is valid.
	                                maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	                                maskComponents = getMaskComponents();
	                                maskProcessed = maskCaretMap.length > 1 ? true : false;
	                            }
	
	                            var prevValue = iElement.val();
	                            function blurHandler() {
	                                if (linkOptions.clearOnBlur || ((linkOptions.clearOnBlurPlaceholder) && (value.length === 0) && iAttrs.placeholder)) {
	                                    oldCaretPosition = 0;
	                                    oldSelectionLength = 0;
	                                    if (!isValid || value.length === 0) {
	                                        valueMasked = '';
	                                        iElement.val('');
	                                        scope.$apply(function() {
	                                            //only $setViewValue when not $pristine to avoid changing $pristine state.
	                                            if (!controller.$pristine) {
	                                                controller.$setViewValue('');
	                                            }
	                                        });
	                                    }
	                                }
	                                //Check for different value and trigger change.
	                                //Check for different value and trigger change.
	                                if (value !== prevValue) {
	                                    // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
	                                    // and then blurring out.
	                                    // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
	                                    // when it should be empty
	                                    var currentVal = iElement.val();
	                                    var isTemporarilyEmpty = value === '' && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === 'space'; 
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val('');
	                                    }
	                                    triggerChangeEvent(iElement[0]);
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val(currentVal);
	                                    }
	                                }
	                                prevValue = value;
	                            }
	
	                            function triggerChangeEvent(element) {
	                                var change;
	                                if (angular.isFunction(window.Event) && !element.fireEvent) {
	                                    // modern browsers and Edge
	                                    change = new Event('change', {
	                                        view: window,
	                                        bubbles: true,
	                                        cancelable: false
	                                    });
	                                    element.dispatchEvent(change);
	                                } else if ('createEvent' in document) {
	                                    // older browsers
	                                    change = document.createEvent('HTMLEvents');
	                                    change.initEvent('change', false, true);
	                                    element.dispatchEvent(change);
	                                }
	                                else if (element.fireEvent) {
	                                    // IE <= 11
	                                    element.fireEvent('onchange');
	                                }
	                            }
	
	                            function mouseDownUpHandler(e) {
	                                if (e.type === 'mousedown') {
	                                    iElement.bind('mouseout', mouseoutHandler);
	                                } else {
	                                    iElement.unbind('mouseout', mouseoutHandler);
	                                }
	                            }
	
	                            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	                            function mouseoutHandler() {
	                                /*jshint validthis: true */
	                                oldSelectionLength = getSelectionLength(this);
	                                iElement.unbind('mouseout', mouseoutHandler);
	                            }
	
	                            function keydownHandler(e) {
	                                /*jshint validthis: true */
	                                var isKeyBackspace = e.which === 8,
	                                    caretPos = getCaretPosition(this) - 1 || 0; //value in keydown is pre change so bump caret position back to simulate post change
	
	                                if (isKeyBackspace) {
	                                    while(caretPos >= 0) {
	                                        if (isValidCaretPosition(caretPos)) {
	                                            //re-adjust the caret position.
	                                            //Increment to account for the initial decrement to simulate post change caret position
	                                            setCaretPosition(this, caretPos + 1);
	                                            break;
	                                        }
	                                        caretPos--;
	                                    }
	                                    preventBackspace = caretPos === -1;
	                                }
	                            }
	
	                            function eventHandler(e) {
	                                /*jshint validthis: true */
	                                e = e || {};
	                                // Allows more efficient minification
	                                var eventWhich = e.which,
	                                        eventType = e.type;
	
	                                // Prevent shift and ctrl from mucking with old values
	                                if (eventWhich === 16 || eventWhich === 91) {
	                                    return;
	                                }
	
	                                var val = iElement.val(),
	                                        valOld = oldValue,
	                                        valMasked,
	                                        valAltered = false,
	                                        valUnmasked = unmaskValue(val),
	                                        valUnmaskedOld = oldValueUnmasked,
	                                        caretPos = getCaretPosition(this) || 0,
	                                        caretPosOld = oldCaretPosition || 0,
	                                        caretPosDelta = caretPos - caretPosOld,
	                                        caretPosMin = maskCaretMap[0],
	                                        caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	                                        selectionLenOld = oldSelectionLength || 0,
	                                        isSelected = getSelectionLength(this) > 0,
	                                        wasSelected = selectionLenOld > 0,
	                                        // Case: Typing a character to overwrite a selection
	                                        isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	                                        // Case: Delete and backspace behave identically on a selection
	                                        isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	                                        isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	                                        isKeyLeftArrow = eventWhich === 37,
	                                        // Necessary due to "input" event not providing a key code
	                                        isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	                                        isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),
	                                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	                                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	                                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	                                        // a character when clicking within a filled input.
	                                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	                                oldSelectionLength = getSelectionLength(this);
	
	                                // These events don't require any action
	                                if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus'))) {
	                                    return;
	                                }
	
	                                if (isKeyBackspace && preventBackspace) {
	                                    iElement.val(maskPlaceholder);
	                                    // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
	                                    // This keeps the $viewValue updated and correct.
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                    setCaretPosition(this, caretPosOld);
	                                    return;
	                                }
	
	                                // Value Handling
	                                // ==============
	
	                                // User attempted to delete but raw value was unaffected--correct this grievous offense
	                                if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	                                    while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                                        caretPos--;
	                                    }
	                                    while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                                        caretPos++;
	                                    }
	                                    var charIndex = maskCaretMap.indexOf(caretPos);
	                                    // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	                                    valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	
	                                    // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
	                                    if (valUnmasked !== valUnmaskedOld)
	                                        valAltered = true;
	                                }
	
	                                // Update values
	                                valMasked = maskValue(valUnmasked);
	
	                                oldValue = valMasked;
	                                oldValueUnmasked = valUnmasked;
	
	                                //additional check to fix the problem where the viewValue is out of sync with the value of the element.
	                                //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
	                                if (!valAltered && val.length > valMasked.length)
	                                    valAltered = true;
	
	                                iElement.val(valMasked);
	
	                                //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
	                                //actually doing anything.  Meaning, things like pristine and touched will be set.
	                                if (valAltered) {
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                }
	
	                                // Caret Repositioning
	                                // ===================
	
	                                // Ensure that typing always places caret ahead of typed character in cases where the first char of
	                                // the input is a mask char and the caret is placed at the 0 position.
	                                if (isAddition && (caretPos <= caretPosMin)) {
	                                    caretPos = caretPosMin + 1;
	                                }
	
	                                if (caretBumpBack) {
	                                    caretPos--;
	                                }
	
	                                // Make sure caret is within min and max position limits
	                                caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	                                // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	                                while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	                                    caretPos += caretBumpBack ? -1 : 1;
	                                }
	
	                                if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	                                    caretPos++;
	                                }
	                                oldCaretPosition = caretPos;
	                                setCaretPosition(this, caretPos);
	                            }
	
	                            function isValidCaretPosition(pos) {
	                                return maskCaretMap.indexOf(pos) > -1;
	                            }
	
	                            function getCaretPosition(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return input.selectionStart;
	                                } else if (document.selection) {
	                                    if (isFocused(iElement[0])) {
	                                        // Curse you IE
	                                        input.focus();
	                                        var selection = document.selection.createRange();
	                                        selection.moveStart('character', input.value ? -input.value.length : 0);
	                                        return selection.text.length;
	                                    }
	                                }
	                                return 0;
	                            }
	
	                            function setCaretPosition(input, pos) {
	                                if (!input)
	                                    return 0;
	                                if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	                                    return; // Input's hidden
	                                }
	                                if (input.setSelectionRange) {
	                                    if (isFocused(iElement[0])) {
	                                        input.focus();
	                                        input.setSelectionRange(pos, pos);
	                                    }
	                                }
	                                else if (input.createTextRange) {
	                                    // Curse you IE
	                                    var range = input.createTextRange();
	                                    range.collapse(true);
	                                    range.moveEnd('character', pos);
	                                    range.moveStart('character', pos);
	                                    range.select();
	                                }
	                            }
	
	                            function getSelectionLength(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return (input.selectionEnd - input.selectionStart);
	                                }
	                                if (document.selection) {
	                                    return (document.selection.createRange().text.length);
	                                }
	                                return 0;
	                            }
	
	                            // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	                            if (!Array.prototype.indexOf) {
	                                Array.prototype.indexOf = function(searchElement /*, fromIndex */) {
	                                    if (this === null) {
	                                        throw new TypeError();
	                                    }
	                                    var t = Object(this);
	                                    var len = t.length >>> 0;
	                                    if (len === 0) {
	                                        return -1;
	                                    }
	                                    var n = 0;
	                                    if (arguments.length > 1) {
	                                        n = Number(arguments[1]);
	                                        if (n !== n) { // shortcut for verifying if it's NaN
	                                            n = 0;
	                                        } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                                            n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                                        }
	                                    }
	                                    if (n >= len) {
	                                        return -1;
	                                    }
	                                    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	                                    for (; k < len; k++) {
	                                        if (k in t && t[k] === searchElement) {
	                                            return k;
	                                        }
	                                    }
	                                    return -1;
	                                };
	                            }
	
	                        };
	                    }
	                };
	            }
	        ]);
	
	}());

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var datemask = function datemask() {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        priority: 1000,
	        link: function link(scope, iElement, iAttrs, ngModelCtrl) {
	            var format, momentFormat, isoFormat;
	            var type = iAttrs.format || 'date';
	            if (type === 'datetime') {
	                momentFormat = 'DDMMYYYYHHmm';
	                format = 'DD.MM.YYYY HH:mm';
	                isoFormat = 'YYYY-MM-DDTHH:mm:ss';
	            } else {
	                momentFormat = 'DDMMYYYY';
	                format = 'DD.MM.YYYY';
	                isoFormat = 'YYYY-MM-DD';
	            }
	
	            iElement.on('keyup', function (event) {
	                if (event.keyCode === 32 && ngModelCtrl.$viewValue === iAttrs.uiMaskPlaceholder) {
	                    var value = (0, _moment2['default'])().format(momentFormat);
	                    ngModelCtrl.$setViewValue(value);
	                    ngModelCtrl.$render();
	                }
	            });
	
	            function parseViewValue(value) {
	                var d = (0, _moment2['default'])(value, momentFormat, true);
	                if (d.isValid()) {
	                    return d.format(isoFormat);
	                }
	
	                return value;
	            }
	
	            function formatViewValue(value) {
	                var d = (0, _moment2['default'])(value, isoFormat, true);
	                if (d.isValid()) {
	                    return d.format(format);
	                }
	            }
	
	            function validateValue(modelValue, viewValue) {
	                var value = modelValue;
	                if (value === null || angular.isUndefined(value) || value === '') {
	                    return true;
	                }
	
	                var d = (0, _moment2['default'])(value, isoFormat, true);
	                return d.isValid();
	            }
	
	            ngModelCtrl.$parsers.push(parseViewValue);
	            ngModelCtrl.$formatters.push(formatViewValue);
	            ngModelCtrl.$validators.datemask = validateValue;
	        }
	    };
	};
	
	exports.datemask = datemask;

/***/ },
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(316);
	
	__webpack_require__(397);
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var datetimepicker = _angular2['default'].module('datetimepicker', []);
	
	datetimepicker.provider('datetimepicker', function () {
	    var default_options = {};
	
	    this.setOptions = function (options) {
	        default_options = options;
	    };
	
	    this.$get = function () {
	        return {
	            getOptions: function getOptions() {
	                return default_options;
	            }
	        };
	    };
	}).directive('datetimepicker', ['$timeout', 'datetimepicker', function ($timeout, datetimepicker) {
	    var default_options = datetimepicker.getOptions();
	
	    return {
	        require: '?ngModel',
	        restrict: 'AE',
	        scope: {
	            datetimepickerOptions: '@'
	        },
	        link: function link($scope, $element, $attrs, ngModelCtrl) {
	            var passed_in_options = $scope.$eval($attrs.datetimepickerOptions);
	            var options = jQuery.extend({}, default_options, passed_in_options);
	
	            $element.on('dp.change', function (e) {
	                if (ngModelCtrl) {
	                    $timeout(function () {
	                        ngModelCtrl.$setViewValue(e.target.value);
	                    });
	                }
	            }).datetimepicker(options);
	
	            function setPickerValue() {
	                var date = options.defaultDate || null;
	
	                if (ngModelCtrl && ngModelCtrl.$viewValue) {
	                    date = ngModelCtrl.$viewValue;
	                }
	
	                $element.data('DateTimePicker').date(date);
	            }
	
	            if (ngModelCtrl) {
	                ngModelCtrl.$render = function () {
	                    setPickerValue();
	                };
	            }
	
	            setPickerValue();
	        }
	    };
	}]);
	
	exports.datetimepicker = datetimepicker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! version : 4.17.37
	 =========================================================
	 bootstrap-datetimejs
	 https://github.com/Eonasdan/bootstrap-datetimepicker
	 Copyright (c) 2015 Jonathan Peterson
	 =========================================================
	 */
	!function(a){"use strict";if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(80),__webpack_require__(317)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("object"==typeof exports)a(require("jquery"),require("moment"));else{if("undefined"==typeof jQuery)throw"bootstrap-datetimepicker requires jQuery to be loaded first";if("undefined"==typeof moment)throw"bootstrap-datetimepicker requires Moment.js to be loaded first";a(jQuery,moment)}}(function(a,b){"use strict";if(!b)throw new Error("bootstrap-datetimepicker requires Moment.js to be loaded first");var c=function(c,d){var e,f,g,h,i,j,k,l={},m=!0,n=!1,o=!1,p=0,q=[{clsName:"days",navFnc:"M",navStep:1},{clsName:"months",navFnc:"y",navStep:1},{clsName:"years",navFnc:"y",navStep:10},{clsName:"decades",navFnc:"y",navStep:100}],r=["days","months","years","decades"],s=["top","bottom","auto"],t=["left","right","auto"],u=["default","top","bottom"],v={up:38,38:"up",down:40,40:"down",left:37,37:"left",right:39,39:"right",tab:9,9:"tab",escape:27,27:"escape",enter:13,13:"enter",pageUp:33,33:"pageUp",pageDown:34,34:"pageDown",shift:16,16:"shift",control:17,17:"control",space:32,32:"space",t:84,84:"t","delete":46,46:"delete"},w={},x=function(a){var c,e,f,g,h,i=!1;return void 0!==b.tz&&void 0!==d.timeZone&&null!==d.timeZone&&""!==d.timeZone&&(i=!0),void 0===a||null===a?c=i?b().tz(d.timeZone).startOf("d"):b().startOf("d"):i?(e=b().tz(d.timeZone).utcOffset(),f=b(a,j,d.useStrict).utcOffset(),f!==e?(g=b().tz(d.timeZone).format("Z"),h=b(a,j,d.useStrict).format("YYYY-MM-DD[T]HH:mm:ss")+g,c=b(h,j,d.useStrict).tz(d.timeZone)):c=b(a,j,d.useStrict).tz(d.timeZone)):c=b(a,j,d.useStrict),c},y=function(a){if("string"!=typeof a||a.length>1)throw new TypeError("isEnabled expects a single character string parameter");switch(a){case"y":return-1!==i.indexOf("Y");case"M":return-1!==i.indexOf("M");case"d":return-1!==i.toLowerCase().indexOf("d");case"h":case"H":return-1!==i.toLowerCase().indexOf("h");case"m":return-1!==i.indexOf("m");case"s":return-1!==i.indexOf("s");default:return!1}},z=function(){return y("h")||y("m")||y("s")},A=function(){return y("y")||y("M")||y("d")},B=function(){var b=a("<thead>").append(a("<tr>").append(a("<th>").addClass("prev").attr("data-action","previous").append(a("<span>").addClass(d.icons.previous))).append(a("<th>").addClass("picker-switch").attr("data-action","pickerSwitch").attr("colspan",d.calendarWeeks?"6":"5")).append(a("<th>").addClass("next").attr("data-action","next").append(a("<span>").addClass(d.icons.next)))),c=a("<tbody>").append(a("<tr>").append(a("<td>").attr("colspan",d.calendarWeeks?"8":"7")));return[a("<div>").addClass("datepicker-days").append(a("<table>").addClass("table-condensed").append(b).append(a("<tbody>"))),a("<div>").addClass("datepicker-months").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())),a("<div>").addClass("datepicker-years").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())),a("<div>").addClass("datepicker-decades").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone()))]},C=function(){var b=a("<tr>"),c=a("<tr>"),e=a("<tr>");return y("h")&&(b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementHour}).addClass("btn").attr("data-action","incrementHours").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-hour").attr({"data-time-component":"hours",title:d.tooltips.pickHour}).attr("data-action","showHours"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementHour}).addClass("btn").attr("data-action","decrementHours").append(a("<span>").addClass(d.icons.down))))),y("m")&&(y("h")&&(b.append(a("<td>").addClass("separator")),c.append(a("<td>").addClass("separator").html(":")),e.append(a("<td>").addClass("separator"))),b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementMinute}).addClass("btn").attr("data-action","incrementMinutes").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-minute").attr({"data-time-component":"minutes",title:d.tooltips.pickMinute}).attr("data-action","showMinutes"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementMinute}).addClass("btn").attr("data-action","decrementMinutes").append(a("<span>").addClass(d.icons.down))))),y("s")&&(y("m")&&(b.append(a("<td>").addClass("separator")),c.append(a("<td>").addClass("separator").html(":")),e.append(a("<td>").addClass("separator"))),b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementSecond}).addClass("btn").attr("data-action","incrementSeconds").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-second").attr({"data-time-component":"seconds",title:d.tooltips.pickSecond}).attr("data-action","showSeconds"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementSecond}).addClass("btn").attr("data-action","decrementSeconds").append(a("<span>").addClass(d.icons.down))))),h||(b.append(a("<td>").addClass("separator")),c.append(a("<td>").append(a("<button>").addClass("btn btn-primary").attr({"data-action":"togglePeriod",tabindex:"-1",title:d.tooltips.togglePeriod}))),e.append(a("<td>").addClass("separator"))),a("<div>").addClass("timepicker-picker").append(a("<table>").addClass("table-condensed").append([b,c,e]))},D=function(){var b=a("<div>").addClass("timepicker-hours").append(a("<table>").addClass("table-condensed")),c=a("<div>").addClass("timepicker-minutes").append(a("<table>").addClass("table-condensed")),d=a("<div>").addClass("timepicker-seconds").append(a("<table>").addClass("table-condensed")),e=[C()];return y("h")&&e.push(b),y("m")&&e.push(c),y("s")&&e.push(d),e},E=function(){var b=[];return d.showTodayButton&&b.push(a("<td>").append(a("<a>").attr({"data-action":"today",title:d.tooltips.today}).append(a("<span>").addClass(d.icons.today)))),!d.sideBySide&&A()&&z()&&b.push(a("<td>").append(a("<a>").attr({"data-action":"togglePicker",title:d.tooltips.selectTime}).append(a("<span>").addClass(d.icons.time)))),d.showClear&&b.push(a("<td>").append(a("<a>").attr({"data-action":"clear",title:d.tooltips.clear}).append(a("<span>").addClass(d.icons.clear)))),d.showClose&&b.push(a("<td>").append(a("<a>").attr({"data-action":"close",title:d.tooltips.close}).append(a("<span>").addClass(d.icons.close)))),a("<table>").addClass("table-condensed").append(a("<tbody>").append(a("<tr>").append(b)))},F=function(){var b=a("<div>").addClass("bootstrap-datetimepicker-widget dropdown-menu"),c=a("<div>").addClass("datepicker").append(B()),e=a("<div>").addClass("timepicker").append(D()),f=a("<ul>").addClass("list-unstyled"),g=a("<li>").addClass("picker-switch"+(d.collapse?" accordion-toggle":"")).append(E());return d.inline&&b.removeClass("dropdown-menu"),h&&b.addClass("usetwentyfour"),y("s")&&!h&&b.addClass("wider"),d.sideBySide&&A()&&z()?(b.addClass("timepicker-sbs"),"top"===d.toolbarPlacement&&b.append(g),b.append(a("<div>").addClass("row").append(c.addClass("col-md-6")).append(e.addClass("col-md-6"))),"bottom"===d.toolbarPlacement&&b.append(g),b):("top"===d.toolbarPlacement&&f.append(g),A()&&f.append(a("<li>").addClass(d.collapse&&z()?"collapse in":"").append(c)),"default"===d.toolbarPlacement&&f.append(g),z()&&f.append(a("<li>").addClass(d.collapse&&A()?"collapse":"").append(e)),"bottom"===d.toolbarPlacement&&f.append(g),b.append(f))},G=function(){var b,e={};return b=c.is("input")||d.inline?c.data():c.find("input").data(),b.dateOptions&&b.dateOptions instanceof Object&&(e=a.extend(!0,e,b.dateOptions)),a.each(d,function(a){var c="date"+a.charAt(0).toUpperCase()+a.slice(1);void 0!==b[c]&&(e[a]=b[c])}),e},H=function(){var b,e=(n||c).position(),f=(n||c).offset(),g=d.widgetPositioning.vertical,h=d.widgetPositioning.horizontal;if(d.widgetParent)b=d.widgetParent.append(o);else if(c.is("input"))b=c.after(o).parent();else{if(d.inline)return void(b=c.append(o));b=c,c.children().first().after(o)}if("auto"===g&&(g=f.top+1.5*o.height()>=a(window).height()+a(window).scrollTop()&&o.height()+c.outerHeight()<f.top?"top":"bottom"),"auto"===h&&(h=b.width()<f.left+o.outerWidth()/2&&f.left+o.outerWidth()>a(window).width()?"right":"left"),"top"===g?o.addClass("top").removeClass("bottom"):o.addClass("bottom").removeClass("top"),"right"===h?o.addClass("pull-right"):o.removeClass("pull-right"),"relative"!==b.css("position")&&(b=b.parents().filter(function(){return"relative"===a(this).css("position")}).first()),0===b.length)throw new Error("datetimepicker component should be placed within a relative positioned container");o.css({top:"top"===g?"auto":e.top+c.outerHeight(),bottom:"top"===g?e.top+c.outerHeight():"auto",left:"left"===h?b===c?0:e.left:"auto",right:"left"===h?"auto":b.outerWidth()-c.outerWidth()-(b===c?0:e.left)})},I=function(a){"dp.change"===a.type&&(a.date&&a.date.isSame(a.oldDate)||!a.date&&!a.oldDate)||c.trigger(a)},J=function(a){"y"===a&&(a="YYYY"),I({type:"dp.update",change:a,viewDate:f.clone()})},K=function(a){o&&(a&&(k=Math.max(p,Math.min(3,k+a))),o.find(".datepicker > div").hide().filter(".datepicker-"+q[k].clsName).show())},L=function(){var b=a("<tr>"),c=f.clone().startOf("w").startOf("d");for(d.calendarWeeks===!0&&b.append(a("<th>").addClass("cw").text("#"));c.isBefore(f.clone().endOf("w"));)b.append(a("<th>").addClass("dow").text(c.format("dd"))),c.add(1,"d");o.find(".datepicker-days thead").append(b)},M=function(a){return d.disabledDates[a.format("YYYY-MM-DD")]===!0},N=function(a){return d.enabledDates[a.format("YYYY-MM-DD")]===!0},O=function(a){return d.disabledHours[a.format("H")]===!0},P=function(a){return d.enabledHours[a.format("H")]===!0},Q=function(b,c){if(!b.isValid())return!1;if(d.disabledDates&&"d"===c&&M(b))return!1;if(d.enabledDates&&"d"===c&&!N(b))return!1;if(d.minDate&&b.isBefore(d.minDate,c))return!1;if(d.maxDate&&b.isAfter(d.maxDate,c))return!1;if(d.daysOfWeekDisabled&&"d"===c&&-1!==d.daysOfWeekDisabled.indexOf(b.day()))return!1;if(d.disabledHours&&("h"===c||"m"===c||"s"===c)&&O(b))return!1;if(d.enabledHours&&("h"===c||"m"===c||"s"===c)&&!P(b))return!1;if(d.disabledTimeIntervals&&("h"===c||"m"===c||"s"===c)){var e=!1;if(a.each(d.disabledTimeIntervals,function(){return b.isBetween(this[0],this[1])?(e=!0,!1):void 0}),e)return!1}return!0},R=function(){for(var b=[],c=f.clone().startOf("y").startOf("d");c.isSame(f,"y");)b.push(a("<span>").attr("data-action","selectMonth").addClass("month").text(c.format("MMM"))),c.add(1,"M");o.find(".datepicker-months td").empty().append(b)},S=function(){var b=o.find(".datepicker-months"),c=b.find("th"),g=b.find("tbody").find("span");c.eq(0).find("span").attr("title",d.tooltips.prevYear),c.eq(1).attr("title",d.tooltips.selectYear),c.eq(2).find("span").attr("title",d.tooltips.nextYear),b.find(".disabled").removeClass("disabled"),Q(f.clone().subtract(1,"y"),"y")||c.eq(0).addClass("disabled"),c.eq(1).text(f.year()),Q(f.clone().add(1,"y"),"y")||c.eq(2).addClass("disabled"),g.removeClass("active"),e.isSame(f,"y")&&!m&&g.eq(e.month()).addClass("active"),g.each(function(b){Q(f.clone().month(b),"M")||a(this).addClass("disabled")})},T=function(){var a=o.find(".datepicker-years"),b=a.find("th"),c=f.clone().subtract(5,"y"),g=f.clone().add(6,"y"),h="";for(b.eq(0).find("span").attr("title",d.tooltips.prevDecade),b.eq(1).attr("title",d.tooltips.selectDecade),b.eq(2).find("span").attr("title",d.tooltips.nextDecade),a.find(".disabled").removeClass("disabled"),d.minDate&&d.minDate.isAfter(c,"y")&&b.eq(0).addClass("disabled"),b.eq(1).text(c.year()+"-"+g.year()),d.maxDate&&d.maxDate.isBefore(g,"y")&&b.eq(2).addClass("disabled");!c.isAfter(g,"y");)h+='<span data-action="selectYear" class="year'+(c.isSame(e,"y")&&!m?" active":"")+(Q(c,"y")?"":" disabled")+'">'+c.year()+"</span>",c.add(1,"y");a.find("td").html(h)},U=function(){var a=o.find(".datepicker-decades"),c=a.find("th"),g=b({y:f.year()-f.year()%100-1}),h=g.clone().add(100,"y"),i=g.clone(),j="";for(c.eq(0).find("span").attr("title",d.tooltips.prevCentury),c.eq(2).find("span").attr("title",d.tooltips.nextCentury),a.find(".disabled").removeClass("disabled"),(g.isSame(b({y:1900}))||d.minDate&&d.minDate.isAfter(g,"y"))&&c.eq(0).addClass("disabled"),c.eq(1).text(g.year()+"-"+h.year()),(g.isSame(b({y:2e3}))||d.maxDate&&d.maxDate.isBefore(h,"y"))&&c.eq(2).addClass("disabled");!g.isAfter(h,"y");)j+='<span data-action="selectDecade" class="decade'+(g.isSame(e,"y")?" active":"")+(Q(g,"y")?"":" disabled")+'" data-selection="'+(g.year()+6)+'">'+(g.year()+1)+" - "+(g.year()+12)+"</span>",g.add(12,"y");j+="<span></span><span></span><span></span>",a.find("td").html(j),c.eq(1).text(i.year()+1+"-"+g.year())},V=function(){var b,c,g,h,i=o.find(".datepicker-days"),j=i.find("th"),k=[];if(A()){for(j.eq(0).find("span").attr("title",d.tooltips.prevMonth),j.eq(1).attr("title",d.tooltips.selectMonth),j.eq(2).find("span").attr("title",d.tooltips.nextMonth),i.find(".disabled").removeClass("disabled"),j.eq(1).text(f.format(d.dayViewHeaderFormat)),Q(f.clone().subtract(1,"M"),"M")||j.eq(0).addClass("disabled"),Q(f.clone().add(1,"M"),"M")||j.eq(2).addClass("disabled"),b=f.clone().startOf("M").startOf("w").startOf("d"),h=0;42>h;h++)0===b.weekday()&&(c=a("<tr>"),d.calendarWeeks&&c.append('<td class="cw">'+b.week()+"</td>"),k.push(c)),g="",b.isBefore(f,"M")&&(g+=" old"),b.isAfter(f,"M")&&(g+=" new"),b.isSame(e,"d")&&!m&&(g+=" active"),Q(b,"d")||(g+=" disabled"),b.isSame(x(),"d")&&(g+=" today"),(0===b.day()||6===b.day())&&(g+=" weekend"),c.append('<td data-action="selectDay" data-day="'+b.format("L")+'" class="day'+g+'">'+b.date()+"</td>"),b.add(1,"d");i.find("tbody").empty().append(k),S(),T(),U()}},W=function(){var b=o.find(".timepicker-hours table"),c=f.clone().startOf("d"),d=[],e=a("<tr>");for(f.hour()>11&&!h&&c.hour(12);c.isSame(f,"d")&&(h||f.hour()<12&&c.hour()<12||f.hour()>11);)c.hour()%4===0&&(e=a("<tr>"),d.push(e)),e.append('<td data-action="selectHour" class="hour'+(Q(c,"h")?"":" disabled")+'">'+c.format(h?"HH":"hh")+"</td>"),c.add(1,"h");b.empty().append(d)},X=function(){for(var b=o.find(".timepicker-minutes table"),c=f.clone().startOf("h"),e=[],g=a("<tr>"),h=1===d.stepping?5:d.stepping;f.isSame(c,"h");)c.minute()%(4*h)===0&&(g=a("<tr>"),e.push(g)),g.append('<td data-action="selectMinute" class="minute'+(Q(c,"m")?"":" disabled")+'">'+c.format("mm")+"</td>"),c.add(h,"m");b.empty().append(e)},Y=function(){for(var b=o.find(".timepicker-seconds table"),c=f.clone().startOf("m"),d=[],e=a("<tr>");f.isSame(c,"m");)c.second()%20===0&&(e=a("<tr>"),d.push(e)),e.append('<td data-action="selectSecond" class="second'+(Q(c,"s")?"":" disabled")+'">'+c.format("ss")+"</td>"),c.add(5,"s");b.empty().append(d)},Z=function(){var a,b,c=o.find(".timepicker span[data-time-component]");h||(a=o.find(".timepicker [data-action=togglePeriod]"),b=e.clone().add(e.hours()>=12?-12:12,"h"),a.text(e.format("A")),Q(b,"h")?a.removeClass("disabled"):a.addClass("disabled")),c.filter("[data-time-component=hours]").text(e.format(h?"HH":"hh")),c.filter("[data-time-component=minutes]").text(e.format("mm")),c.filter("[data-time-component=seconds]").text(e.format("ss")),W(),X(),Y()},$=function(){o&&(V(),Z())},_=function(a){var b=m?null:e;return a?(a=a.clone().locale(d.locale),1!==d.stepping&&a.minutes(Math.round(a.minutes()/d.stepping)*d.stepping%60).seconds(0),void(Q(a)?(e=a,f=e.clone(),g.val(e.format(i)),c.data("date",e.format(i)),m=!1,$(),I({type:"dp.change",date:e.clone(),oldDate:b})):(d.keepInvalid||g.val(m?"":e.format(i)),I({type:"dp.error",date:a})))):(m=!0,g.val(""),c.data("date",""),I({type:"dp.change",date:!1,oldDate:b}),void $())},aa=function(){var b=!1;return o?(o.find(".collapse").each(function(){var c=a(this).data("collapse");return c&&c.transitioning?(b=!0,!1):!0}),b?l:(n&&n.hasClass("btn")&&n.toggleClass("active"),o.hide(),a(window).off("resize",H),o.off("click","[data-action]"),o.off("mousedown",!1),o.remove(),o=!1,I({type:"dp.hide",date:e.clone()}),g.blur(),l)):l},ba=function(){_(null)},ca={next:function(){var a=q[k].navFnc;f.add(q[k].navStep,a),V(),J(a)},previous:function(){var a=q[k].navFnc;f.subtract(q[k].navStep,a),V(),J(a)},pickerSwitch:function(){K(1)},selectMonth:function(b){var c=a(b.target).closest("tbody").find("span").index(a(b.target));f.month(c),k===p?(_(e.clone().year(f.year()).month(f.month())),d.inline||aa()):(K(-1),V()),J("M")},selectYear:function(b){var c=parseInt(a(b.target).text(),10)||0;f.year(c),k===p?(_(e.clone().year(f.year())),d.inline||aa()):(K(-1),V()),J("YYYY")},selectDecade:function(b){var c=parseInt(a(b.target).data("selection"),10)||0;f.year(c),k===p?(_(e.clone().year(f.year())),d.inline||aa()):(K(-1),V()),J("YYYY")},selectDay:function(b){var c=f.clone();a(b.target).is(".old")&&c.subtract(1,"M"),a(b.target).is(".new")&&c.add(1,"M"),_(c.date(parseInt(a(b.target).text(),10))),z()||d.keepOpen||d.inline||aa()},incrementHours:function(){var a=e.clone().add(1,"h");Q(a,"h")&&_(a)},incrementMinutes:function(){var a=e.clone().add(d.stepping,"m");Q(a,"m")&&_(a)},incrementSeconds:function(){var a=e.clone().add(1,"s");Q(a,"s")&&_(a)},decrementHours:function(){var a=e.clone().subtract(1,"h");Q(a,"h")&&_(a)},decrementMinutes:function(){var a=e.clone().subtract(d.stepping,"m");Q(a,"m")&&_(a)},decrementSeconds:function(){var a=e.clone().subtract(1,"s");Q(a,"s")&&_(a)},togglePeriod:function(){_(e.clone().add(e.hours()>=12?-12:12,"h"))},togglePicker:function(b){var c,e=a(b.target),f=e.closest("ul"),g=f.find(".in"),h=f.find(".collapse:not(.in)");if(g&&g.length){if(c=g.data("collapse"),c&&c.transitioning)return;g.collapse?(g.collapse("hide"),h.collapse("show")):(g.removeClass("in"),h.addClass("in")),e.is("span")?e.toggleClass(d.icons.time+" "+d.icons.date):e.find("span").toggleClass(d.icons.time+" "+d.icons.date)}},showPicker:function(){o.find(".timepicker > div:not(.timepicker-picker)").hide(),o.find(".timepicker .timepicker-picker").show()},showHours:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-hours").show()},showMinutes:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-minutes").show()},showSeconds:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-seconds").show()},selectHour:function(b){var c=parseInt(a(b.target).text(),10);h||(e.hours()>=12?12!==c&&(c+=12):12===c&&(c=0)),_(e.clone().hours(c)),ca.showPicker.call(l)},selectMinute:function(b){_(e.clone().minutes(parseInt(a(b.target).text(),10))),ca.showPicker.call(l)},selectSecond:function(b){_(e.clone().seconds(parseInt(a(b.target).text(),10))),ca.showPicker.call(l)},clear:ba,today:function(){var a=x();Q(a,"d")&&_(a)},close:aa},da=function(b){return a(b.currentTarget).is(".disabled")?!1:(ca[a(b.currentTarget).data("action")].apply(l,arguments),!1)},ea=function(){var b,c={year:function(a){return a.month(0).date(1).hours(0).seconds(0).minutes(0)},month:function(a){return a.date(1).hours(0).seconds(0).minutes(0)},day:function(a){return a.hours(0).seconds(0).minutes(0)},hour:function(a){return a.seconds(0).minutes(0)},minute:function(a){return a.seconds(0)}};return g.prop("disabled")||!d.ignoreReadonly&&g.prop("readonly")||o?l:(void 0!==g.val()&&0!==g.val().trim().length?_(ga(g.val().trim())):d.useCurrent&&m&&(g.is("input")&&0===g.val().trim().length||d.inline)&&(b=x(),"string"==typeof d.useCurrent&&(b=c[d.useCurrent](b)),_(b)),o=F(),L(),R(),o.find(".timepicker-hours").hide(),o.find(".timepicker-minutes").hide(),o.find(".timepicker-seconds").hide(),$(),K(),a(window).on("resize",H),o.on("click","[data-action]",da),o.on("mousedown",!1),n&&n.hasClass("btn")&&n.toggleClass("active"),o.show(),H(),d.focusOnShow&&!g.is(":focus")&&g.focus(),I({type:"dp.show"}),l)},fa=function(){return o?aa():ea()},ga=function(a){return a=void 0===d.parseInputDate?b.isMoment(a)||a instanceof Date?b(a):x(a):d.parseInputDate(a),a.locale(d.locale),a},ha=function(a){var b,c,e,f,g=null,h=[],i={},j=a.which,k="p";w[j]=k;for(b in w)w.hasOwnProperty(b)&&w[b]===k&&(h.push(b),parseInt(b,10)!==j&&(i[b]=!0));for(b in d.keyBinds)if(d.keyBinds.hasOwnProperty(b)&&"function"==typeof d.keyBinds[b]&&(e=b.split(" "),e.length===h.length&&v[j]===e[e.length-1])){for(f=!0,c=e.length-2;c>=0;c--)if(!(v[e[c]]in i)){f=!1;break}if(f){g=d.keyBinds[b];break}}g&&(g.call(l,o),a.stopPropagation(),a.preventDefault())},ia=function(a){w[a.which]="r",a.stopPropagation(),a.preventDefault()},ja=function(b){var c=a(b.target).val().trim(),d=c?ga(c):null;return _(d),b.stopImmediatePropagation(),!1},ka=function(){g.on({change:ja,blur:d.debug?"":aa,keydown:ha,keyup:ia,focus:d.allowInputToggle?ea:""}),c.is("input")?g.on({focus:ea}):n&&(n.on("click",fa),n.on("mousedown",!1))},la=function(){g.off({change:ja,blur:blur,keydown:ha,keyup:ia,focus:d.allowInputToggle?aa:""}),c.is("input")?g.off({focus:ea}):n&&(n.off("click",fa),n.off("mousedown",!1))},ma=function(b){var c={};return a.each(b,function(){var a=ga(this);a.isValid()&&(c[a.format("YYYY-MM-DD")]=!0)}),Object.keys(c).length?c:!1},na=function(b){var c={};return a.each(b,function(){c[this]=!0}),Object.keys(c).length?c:!1},oa=function(){var a=d.format||"L LT";i=a.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(a){var b=e.localeData().longDateFormat(a)||a;return b.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(a){return e.localeData().longDateFormat(a)||a})}),j=d.extraFormats?d.extraFormats.slice():[],j.indexOf(a)<0&&j.indexOf(i)<0&&j.push(i),h=i.toLowerCase().indexOf("a")<1&&i.replace(/\[.*?\]/g,"").indexOf("h")<1,y("y")&&(p=2),y("M")&&(p=1),y("d")&&(p=0),k=Math.max(p,k),m||_(e)};if(l.destroy=function(){aa(),la(),c.removeData("DateTimePicker"),c.removeData("date")},l.toggle=fa,l.show=ea,l.hide=aa,l.disable=function(){return aa(),n&&n.hasClass("btn")&&n.addClass("disabled"),g.prop("disabled",!0),l},l.enable=function(){return n&&n.hasClass("btn")&&n.removeClass("disabled"),g.prop("disabled",!1),l},l.ignoreReadonly=function(a){if(0===arguments.length)return d.ignoreReadonly;if("boolean"!=typeof a)throw new TypeError("ignoreReadonly () expects a boolean parameter");return d.ignoreReadonly=a,l},l.options=function(b){if(0===arguments.length)return a.extend(!0,{},d);if(!(b instanceof Object))throw new TypeError("options() options parameter should be an object");return a.extend(!0,d,b),a.each(d,function(a,b){if(void 0===l[a])throw new TypeError("option "+a+" is not recognized!");l[a](b)}),l},l.date=function(a){if(0===arguments.length)return m?null:e.clone();if(!(null===a||"string"==typeof a||b.isMoment(a)||a instanceof Date))throw new TypeError("date() parameter must be one of [null, string, moment or Date]");return _(null===a?null:ga(a)),l},l.format=function(a){if(0===arguments.length)return d.format;if("string"!=typeof a&&("boolean"!=typeof a||a!==!1))throw new TypeError("format() expects a sting or boolean:false parameter "+a);return d.format=a,i&&oa(),l},l.timeZone=function(a){return 0===arguments.length?d.timeZone:(d.timeZone=a,l)},l.dayViewHeaderFormat=function(a){if(0===arguments.length)return d.dayViewHeaderFormat;if("string"!=typeof a)throw new TypeError("dayViewHeaderFormat() expects a string parameter");return d.dayViewHeaderFormat=a,l},l.extraFormats=function(a){if(0===arguments.length)return d.extraFormats;if(a!==!1&&!(a instanceof Array))throw new TypeError("extraFormats() expects an array or false parameter");return d.extraFormats=a,j&&oa(),l},l.disabledDates=function(b){if(0===arguments.length)return d.disabledDates?a.extend({},d.disabledDates):d.disabledDates;if(!b)return d.disabledDates=!1,$(),l;if(!(b instanceof Array))throw new TypeError("disabledDates() expects an array parameter");return d.disabledDates=ma(b),d.enabledDates=!1,$(),l},l.enabledDates=function(b){if(0===arguments.length)return d.enabledDates?a.extend({},d.enabledDates):d.enabledDates;if(!b)return d.enabledDates=!1,$(),l;if(!(b instanceof Array))throw new TypeError("enabledDates() expects an array parameter");return d.enabledDates=ma(b),d.disabledDates=!1,$(),l},l.daysOfWeekDisabled=function(a){if(0===arguments.length)return d.daysOfWeekDisabled.splice(0);if("boolean"==typeof a&&!a)return d.daysOfWeekDisabled=!1,$(),l;if(!(a instanceof Array))throw new TypeError("daysOfWeekDisabled() expects an array parameter");if(d.daysOfWeekDisabled=a.reduce(function(a,b){return b=parseInt(b,10),b>6||0>b||isNaN(b)?a:(-1===a.indexOf(b)&&a.push(b),a)},[]).sort(),d.useCurrent&&!d.keepInvalid){for(var b=0;!Q(e,"d");){if(e.add(1,"d"),7===b)throw"Tried 7 times to find a valid date";b++}_(e)}return $(),l},l.maxDate=function(a){if(0===arguments.length)return d.maxDate?d.maxDate.clone():d.maxDate;if("boolean"==typeof a&&a===!1)return d.maxDate=!1,$(),l;"string"==typeof a&&("now"===a||"moment"===a)&&(a=x());var b=ga(a);if(!b.isValid())throw new TypeError("maxDate() Could not parse date parameter: "+a);if(d.minDate&&b.isBefore(d.minDate))throw new TypeError("maxDate() date parameter is before options.minDate: "+b.format(i));return d.maxDate=b,d.useCurrent&&!d.keepInvalid&&e.isAfter(a)&&_(d.maxDate),f.isAfter(b)&&(f=b.clone().subtract(d.stepping,"m")),$(),l},l.minDate=function(a){if(0===arguments.length)return d.minDate?d.minDate.clone():d.minDate;if("boolean"==typeof a&&a===!1)return d.minDate=!1,$(),l;"string"==typeof a&&("now"===a||"moment"===a)&&(a=x());var b=ga(a);if(!b.isValid())throw new TypeError("minDate() Could not parse date parameter: "+a);if(d.maxDate&&b.isAfter(d.maxDate))throw new TypeError("minDate() date parameter is after options.maxDate: "+b.format(i));return d.minDate=b,d.useCurrent&&!d.keepInvalid&&e.isBefore(a)&&_(d.minDate),f.isBefore(b)&&(f=b.clone().add(d.stepping,"m")),$(),l},l.defaultDate=function(a){if(0===arguments.length)return d.defaultDate?d.defaultDate.clone():d.defaultDate;if(!a)return d.defaultDate=!1,l;"string"==typeof a&&("now"===a||"moment"===a)&&(a=x());var b=ga(a);if(!b.isValid())throw new TypeError("defaultDate() Could not parse date parameter: "+a);if(!Q(b))throw new TypeError("defaultDate() date passed is invalid according to component setup validations");return d.defaultDate=b,(d.defaultDate&&d.inline||""===g.val().trim())&&_(d.defaultDate),l},l.locale=function(a){if(0===arguments.length)return d.locale;if(!b.localeData(a))throw new TypeError("locale() locale "+a+" is not loaded from moment locales!");return d.locale=a,e.locale(d.locale),f.locale(d.locale),i&&oa(),o&&(aa(),ea()),l},l.stepping=function(a){return 0===arguments.length?d.stepping:(a=parseInt(a,10),(isNaN(a)||1>a)&&(a=1),d.stepping=a,l)},l.useCurrent=function(a){var b=["year","month","day","hour","minute"];if(0===arguments.length)return d.useCurrent;if("boolean"!=typeof a&&"string"!=typeof a)throw new TypeError("useCurrent() expects a boolean or string parameter");if("string"==typeof a&&-1===b.indexOf(a.toLowerCase()))throw new TypeError("useCurrent() expects a string parameter of "+b.join(", "));return d.useCurrent=a,l},l.collapse=function(a){if(0===arguments.length)return d.collapse;if("boolean"!=typeof a)throw new TypeError("collapse() expects a boolean parameter");return d.collapse===a?l:(d.collapse=a,o&&(aa(),ea()),l)},l.icons=function(b){if(0===arguments.length)return a.extend({},d.icons);if(!(b instanceof Object))throw new TypeError("icons() expects parameter to be an Object");return a.extend(d.icons,b),o&&(aa(),ea()),l},l.tooltips=function(b){if(0===arguments.length)return a.extend({},d.tooltips);if(!(b instanceof Object))throw new TypeError("tooltips() expects parameter to be an Object");return a.extend(d.tooltips,b),o&&(aa(),ea()),l},l.useStrict=function(a){if(0===arguments.length)return d.useStrict;if("boolean"!=typeof a)throw new TypeError("useStrict() expects a boolean parameter");return d.useStrict=a,l},l.sideBySide=function(a){if(0===arguments.length)return d.sideBySide;if("boolean"!=typeof a)throw new TypeError("sideBySide() expects a boolean parameter");return d.sideBySide=a,o&&(aa(),ea()),l},l.viewMode=function(a){if(0===arguments.length)return d.viewMode;if("string"!=typeof a)throw new TypeError("viewMode() expects a string parameter");if(-1===r.indexOf(a))throw new TypeError("viewMode() parameter must be one of ("+r.join(", ")+") value");return d.viewMode=a,k=Math.max(r.indexOf(a),p),K(),l},l.toolbarPlacement=function(a){if(0===arguments.length)return d.toolbarPlacement;if("string"!=typeof a)throw new TypeError("toolbarPlacement() expects a string parameter");if(-1===u.indexOf(a))throw new TypeError("toolbarPlacement() parameter must be one of ("+u.join(", ")+") value");return d.toolbarPlacement=a,o&&(aa(),ea()),l},l.widgetPositioning=function(b){if(0===arguments.length)return a.extend({},d.widgetPositioning);if("[object Object]"!=={}.toString.call(b))throw new TypeError("widgetPositioning() expects an object variable");if(b.horizontal){if("string"!=typeof b.horizontal)throw new TypeError("widgetPositioning() horizontal variable must be a string");if(b.horizontal=b.horizontal.toLowerCase(),-1===t.indexOf(b.horizontal))throw new TypeError("widgetPositioning() expects horizontal parameter to be one of ("+t.join(", ")+")");d.widgetPositioning.horizontal=b.horizontal}if(b.vertical){if("string"!=typeof b.vertical)throw new TypeError("widgetPositioning() vertical variable must be a string");if(b.vertical=b.vertical.toLowerCase(),-1===s.indexOf(b.vertical))throw new TypeError("widgetPositioning() expects vertical parameter to be one of ("+s.join(", ")+")");d.widgetPositioning.vertical=b.vertical}return $(),l},l.calendarWeeks=function(a){if(0===arguments.length)return d.calendarWeeks;if("boolean"!=typeof a)throw new TypeError("calendarWeeks() expects parameter to be a boolean value");return d.calendarWeeks=a,$(),l},l.showTodayButton=function(a){if(0===arguments.length)return d.showTodayButton;if("boolean"!=typeof a)throw new TypeError("showTodayButton() expects a boolean parameter");return d.showTodayButton=a,o&&(aa(),ea()),l},l.showClear=function(a){if(0===arguments.length)return d.showClear;if("boolean"!=typeof a)throw new TypeError("showClear() expects a boolean parameter");return d.showClear=a,o&&(aa(),ea()),l},l.widgetParent=function(b){if(0===arguments.length)return d.widgetParent;if("string"==typeof b&&(b=a(b)),null!==b&&"string"!=typeof b&&!(b instanceof a))throw new TypeError("widgetParent() expects a string or a jQuery object parameter");return d.widgetParent=b,o&&(aa(),ea()),l},l.keepOpen=function(a){if(0===arguments.length)return d.keepOpen;if("boolean"!=typeof a)throw new TypeError("keepOpen() expects a boolean parameter");return d.keepOpen=a,l},l.focusOnShow=function(a){if(0===arguments.length)return d.focusOnShow;if("boolean"!=typeof a)throw new TypeError("focusOnShow() expects a boolean parameter");return d.focusOnShow=a,l},l.inline=function(a){if(0===arguments.length)return d.inline;if("boolean"!=typeof a)throw new TypeError("inline() expects a boolean parameter");return d.inline=a,l},l.clear=function(){return ba(),l},l.keyBinds=function(a){return d.keyBinds=a,l},l.getMoment=function(a){return x(a)},l.debug=function(a){if("boolean"!=typeof a)throw new TypeError("debug() expects a boolean parameter");return d.debug=a,l},l.allowInputToggle=function(a){if(0===arguments.length)return d.allowInputToggle;if("boolean"!=typeof a)throw new TypeError("allowInputToggle() expects a boolean parameter");return d.allowInputToggle=a,l},l.showClose=function(a){if(0===arguments.length)return d.showClose;if("boolean"!=typeof a)throw new TypeError("showClose() expects a boolean parameter");return d.showClose=a,l},l.keepInvalid=function(a){if(0===arguments.length)return d.keepInvalid;if("boolean"!=typeof a)throw new TypeError("keepInvalid() expects a boolean parameter");return d.keepInvalid=a,l},l.datepickerInput=function(a){if(0===arguments.length)return d.datepickerInput;if("string"!=typeof a)throw new TypeError("datepickerInput() expects a string parameter");return d.datepickerInput=a,l},l.parseInputDate=function(a){if(0===arguments.length)return d.parseInputDate;
	if("function"!=typeof a)throw new TypeError("parseInputDate() sholud be as function");return d.parseInputDate=a,l},l.disabledTimeIntervals=function(b){if(0===arguments.length)return d.disabledTimeIntervals?a.extend({},d.disabledTimeIntervals):d.disabledTimeIntervals;if(!b)return d.disabledTimeIntervals=!1,$(),l;if(!(b instanceof Array))throw new TypeError("disabledTimeIntervals() expects an array parameter");return d.disabledTimeIntervals=b,$(),l},l.disabledHours=function(b){if(0===arguments.length)return d.disabledHours?a.extend({},d.disabledHours):d.disabledHours;if(!b)return d.disabledHours=!1,$(),l;if(!(b instanceof Array))throw new TypeError("disabledHours() expects an array parameter");if(d.disabledHours=na(b),d.enabledHours=!1,d.useCurrent&&!d.keepInvalid){for(var c=0;!Q(e,"h");){if(e.add(1,"h"),24===c)throw"Tried 24 times to find a valid date";c++}_(e)}return $(),l},l.enabledHours=function(b){if(0===arguments.length)return d.enabledHours?a.extend({},d.enabledHours):d.enabledHours;if(!b)return d.enabledHours=!1,$(),l;if(!(b instanceof Array))throw new TypeError("enabledHours() expects an array parameter");if(d.enabledHours=na(b),d.disabledHours=!1,d.useCurrent&&!d.keepInvalid){for(var c=0;!Q(e,"h");){if(e.add(1,"h"),24===c)throw"Tried 24 times to find a valid date";c++}_(e)}return $(),l},l.viewDate=function(a){if(0===arguments.length)return f.clone();if(!a)return f=e.clone(),l;if(!("string"==typeof a||b.isMoment(a)||a instanceof Date))throw new TypeError("viewDate() parameter must be one of [string, moment or Date]");return f=ga(a),J(),l},c.is("input"))g=c;else if(g=c.find(d.datepickerInput),0===g.size())g=c.find("input");else if(!g.is("input"))throw new Error('CSS class "'+d.datepickerInput+'" cannot be applied to non input element');if(c.hasClass("input-group")&&(n=0===c.find(".datepickerbutton").size()?c.find(".input-group-addon"):c.find(".datepickerbutton")),!d.inline&&!g.is("input"))throw new Error("Could not initialize DateTimePicker without an input element");return e=x(),f=e.clone(),a.extend(!0,d,G()),l.options(d),oa(),ka(),g.prop("disabled")&&l.disable(),g.is("input")&&0!==g.val().trim().length?_(ga(g.val().trim())):d.defaultDate&&void 0===g.attr("placeholder")&&_(d.defaultDate),d.inline&&ea(),l};a.fn.datetimepicker=function(b){return this.each(function(){var d=a(this);d.data("DateTimePicker")||(b=a.extend(!0,{},a.fn.datetimepicker.defaults,b),d.data("DateTimePicker",c(d,b)))})},a.fn.datetimepicker.defaults={timeZone:"Etc/UTC",format:!1,dayViewHeaderFormat:"MMMM YYYY",extraFormats:!1,stepping:1,minDate:!1,maxDate:!1,useCurrent:!0,collapse:!0,locale:b.locale(),defaultDate:!1,disabledDates:!1,enabledDates:!1,icons:{time:"glyphicon glyphicon-time",date:"glyphicon glyphicon-calendar",up:"glyphicon glyphicon-chevron-up",down:"glyphicon glyphicon-chevron-down",previous:"glyphicon glyphicon-chevron-left",next:"glyphicon glyphicon-chevron-right",today:"glyphicon glyphicon-screenshot",clear:"glyphicon glyphicon-trash",close:"glyphicon glyphicon-remove"},tooltips:{today:"Go to today",clear:"Clear selection",close:"Close the picker",selectMonth:"Select Month",prevMonth:"Previous Month",nextMonth:"Next Month",selectYear:"Select Year",prevYear:"Previous Year",nextYear:"Next Year",selectDecade:"Select Decade",prevDecade:"Previous Decade",nextDecade:"Next Decade",prevCentury:"Previous Century",nextCentury:"Next Century",pickHour:"Pick Hour",incrementHour:"Increment Hour",decrementHour:"Decrement Hour",pickMinute:"Pick Minute",incrementMinute:"Increment Minute",decrementMinute:"Decrement Minute",pickSecond:"Pick Second",incrementSecond:"Increment Second",decrementSecond:"Decrement Second",togglePeriod:"Toggle Period",selectTime:"Select Time"},useStrict:!1,sideBySide:!1,daysOfWeekDisabled:!1,calendarWeeks:!1,viewMode:"days",toolbarPlacement:"default",showTodayButton:!1,showClear:!1,showClose:!1,widgetPositioning:{horizontal:"auto",vertical:"auto"},widgetParent:null,ignoreReadonly:!1,keepOpen:!1,focusOnShow:!0,inline:!1,keepInvalid:!1,datepickerInput:".datepickerinput",keyBinds:{up:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().subtract(7,"d")):this.date(b.clone().add(this.stepping(),"m"))}},down:function(a){if(!a)return void this.show();var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().add(7,"d")):this.date(b.clone().subtract(this.stepping(),"m"))},"control up":function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().subtract(1,"y")):this.date(b.clone().add(1,"h"))}},"control down":function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().add(1,"y")):this.date(b.clone().subtract(1,"h"))}},left:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().subtract(1,"d"))}},right:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().add(1,"d"))}},pageUp:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().subtract(1,"M"))}},pageDown:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().add(1,"M"))}},enter:function(){this.hide()},escape:function(){this.hide()},"control space":function(a){a.find(".timepicker").is(":visible")&&a.find('.btn[data-action="togglePeriod"]').click()},t:function(){this.date(this.getMoment())},"delete":function(){this.clear()}},debug:!1,allowInputToggle:!1,disabledTimeIntervals:!1,disabledHours:!1,enabledHours:!1,viewDate:!1}});

/***/ },
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
32,
/* 398 */,
/* 399 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/fieldset.html';
	var html = "<fieldset class=\"{{to.className}}\"><legend><span>{{to.label}}</span></legend><formly-transclude></formly-transclude></fieldset>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 400 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/row.html';
	var html = "<div class=\"{{to.cssClass || 'row'}}\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 401 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/div.html';
	var html = "<div class=\"{{to.className}}\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 402 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/horizontalLabel.html';
	var html = "<label ng-if=\"to.label\" for=\"{{::id}}\" class=\"{{::to.labelcss || 'col-md-3'}} control-label\">{{to.label}} {{to.required ? \"*\" : \"\"}}</label><div class=\"{{::to.controllCss || 'col-md-9'}}\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 403 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/horizontalCheckbox.html';
	var html = "<div class=\"col-sm-offset-3 col-sm-8\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 404 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/validation.html';
	var html = "<formly-transclude></formly-transclude><div ng-messages=\"fc.$error\" ng-if=\"options.validation.errorExistsAndShouldBeVisible\" class=\"field-error-messages\"><div ng-message=\"{{ ::name }}\" ng-repeat=\"(name, message) in ::options.validation.messages\" class=\"message\">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div><div ng-messages-include=\"app/components/common/forms/templates/errorMessages.html\"></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 405 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/errorMessages.html';
	var html = "<div ng-message=\"required\" class=\"field-error-messages\">Obavezno polje</div><div ng-message=\"minlength\" class=\"field-error-messages\">Unos je predug</div><div ng-message=\"maxlength\" class=\"field-error-messages\">Unos je prekratak</div><div ng-message=\"email\" class=\"field-error-messages\">Neispravna e-mail adresa</div><div ng-message=\"datemask\" class=\"field-error-messages\">Neispravan datum</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 406 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/ui-select.html';
	var html = "<div class=\"input-group\"><ui-select ng-model=\"model[options.key]\" theme=\"bootstrap\" ng-required=\"{{to.required}}\" ng-disabled=\"{{to.disabled}}\" reset-search-input=\"false\" on-select=\"ctrl.onRemove($item, $model)\"><ui-select-match placeholder=\"{{to.placeholder}}\">{{$select.selected[to.labelProp || 'name']}}</ui-select-match><ui-select-choices group-by=\"to.groupBy\" repeat=\"option[to.valueProp || 'value'] as option in to.options | filter: $select.search track by option.id\"><div ng-bind-html=\"option[to.labelProp || 'name'] | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"input-group-addon\" ng-style=\"{cursor: 'pointer'}\" ng-click=\"model[options.key]=null\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 407 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/ui-select-async.html';
	var html = "<div class=\"input-group\"><ui-select on-select=\"onSelect($item, $model)\" ng-model=\"model[options.key]\" theme=\"bootstrap\" ng-required=\"{{to.required}}\" ng-disabled=\"{{to.disabled}}\" on-remove=\"onRemove($item, $model)\"><ui-select-match placeholder=\"{{to.placeholder}}\">{{$select.selected[to.labelProp || 'name']}}</ui-select-match><ui-select-choices repeat=\"option[to.valueProp || 'value'] as option in to.options\" refresh=\"to.refresh($select.search, options)\" refresh-delay=\"{{to.refreshDelay}}\"><div ng-bind-html=\"option[to.labelProp || 'name'] | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-if=\"true\" class=\"input-group-addon\" ng-style=\"{cursor: 'pointer'}\" ng-click=\"model[options.key]=null\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></div><div class=\"input-group-addon\" ng-if=\"to.addon\" ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\" ng-click=\"to.addon.onClick(options, this, $event)\"><i class=\"{{to.addon.class}}\" ng-if=\"to.addon.class\"></i> <span ng-if=\"to.addon.text\">{{to.addon.text}}</span></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 408 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/feed.html';
	var html = "<div style=\"overflow-y: scroll; height: 500px\" ng-hide=\"!model[options.key]\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Postojeći unosi</h5><div class=\"ibox-tools\"><span class=\"label label-warning-light pull-right\">{{model[options.key].length}} pregleda</span></div></div><div class=\"ibox-content\"><div><div class=\"feed-activity-list\"><div class=\"feed-element\" ng-repeat=\"item in model[options.key]\"><div class=\"media-body\"><strong>Datum posjete</strong><small class=\"text-muted\">&nbsp{{item.datum | date:'dd.MM.yyyy'}}</small><br><small class=\"text-muted\">{{item.dijagnoza_text}}</small><div class=\"well\">{{item.napomena}}</div></div></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _compileJs = __webpack_require__(410);
	
	var _compileJs2 = _interopRequireDefault(_compileJs);
	
	var utils = _angular2['default'].module('utils', []);
	
	utils.directive('compile', _compileJs2['default']);
	
	exports.utils = utils;

/***/ },
/* 410 */
/***/ function(module, exports) {

	// @see https://docs.angularjs.org/api/ng/service/$compile
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = Compile;
	
	function Compile($injector) {
	    var $compile = $injector.get('$compile');
	
	    return {
	        transclude: true,
	        link: function link(scope, element, attrs, controller, transcludeFn) {
	            var unbindWatcher = scope.$watch(function (scope) {
	                // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	            }, function (value) {
	                if (false === value || undefined === value) {
	                    // use the default tag content
	                    transcludeFn(scope, function (clone) {
	                        element.append(clone);
	                    });
	                    return;
	                }
	                // when the 'compile' expression changes assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current scope.
	                $compile(element.contents())(scope);
	
	                if (attrs.compileOnce == 'true') {
	                    unbindWatcher();
	                }
	            });
	        }
	    };
	}
	
	Compile.$inject = ['$injector'];
	module.exports = exports['default'];

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _FactoryJs = __webpack_require__(412);
	
	var _FactoryJs2 = _interopRequireDefault(_FactoryJs);
	
	var AppConfiguration = (function () {
	    function AppConfiguration() {
	        _classCallCheck(this, AppConfiguration);
	
	        this._config = null;
	        this.factory = new _FactoryJs2['default']();
	    }
	
	    // class AppConfigurationUIRouter extends AppConfiguration {
	
	    //     $get($state) {
	
	    //     }
	    // }
	
	    _createClass(AppConfiguration, [{
	        key: 'configure',
	        value: function configure(config) {
	            this._config = config;
	        }
	    }, {
	        key: '$get',
	        value: function $get() {
	            var _this = this;
	
	            var appConf = function appConf() {
	                return _this._config;
	            };
	
	            appConf.application = this.application.bind(this);
	            appConf.menu = this.menu.bind(this);
	            appConf.entity = this.entity.bind(this);
	            appConf.configure = this.configure.bind(this);
	            appConf.field = this.field.bind(this);
	            // appConf.setFactory = this.setFactory.bind(this);
	
	            return appConf;
	        }
	    }, {
	        key: 'application',
	        value: function application(name) {
	            return this.factory.application(name);
	        }
	    }, {
	        key: 'menu',
	        value: function menu(entity) {
	            return this.factory.menu(entity);
	        }
	    }, {
	        key: 'entity',
	        value: function entity(name) {
	            return this.factory.entity(name);
	        }
	    }, {
	        key: 'field',
	        value: function field(name, type) {
	            return this.factory.field(name, type);
	        }
	    }, {
	        key: 'setfactroy',
	        value: function setfactroy(factory) {
	            this.factory = factory;
	        }
	    }]);
	
	    return AppConfiguration;
	})();
	
	var configurationModule = _angular2['default'].module('ConfigurationModule', []);
	
	configurationModule.provider('AppConfiguration', AppConfiguration);
	
	exports.configurationModule = configurationModule;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ApplicationJs = __webpack_require__(413);
	
	var _ApplicationJs2 = _interopRequireDefault(_ApplicationJs);
	
	var _EntityEntity = __webpack_require__(415);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	// import DataStore from "./DataStore/DataStore";
	// import PromisesResolver from "./Utils/PromisesResolver";
	
	// import ReadQueries from "./Queries/ReadQueries";
	// import WriteQueries from "./Queries/WriteQueries";
	
	var _FieldField = __webpack_require__(417);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _FieldBooleanField = __webpack_require__(432);
	
	var _FieldBooleanField2 = _interopRequireDefault(_FieldBooleanField);
	
	var _FieldChoiceField = __webpack_require__(433);
	
	var _FieldChoiceField2 = _interopRequireDefault(_FieldChoiceField);
	
	var _FieldChoicesField = __webpack_require__(434);
	
	var _FieldChoicesField2 = _interopRequireDefault(_FieldChoicesField);
	
	var _FieldDateField = __webpack_require__(435);
	
	var _FieldDateField2 = _interopRequireDefault(_FieldDateField);
	
	var _FieldDateTimeField = __webpack_require__(436);
	
	var _FieldDateTimeField2 = _interopRequireDefault(_FieldDateTimeField);
	
	var _FieldEmailField = __webpack_require__(437);
	
	var _FieldEmailField2 = _interopRequireDefault(_FieldEmailField);
	
	var _FieldEmbeddedListField = __webpack_require__(438);
	
	var _FieldEmbeddedListField2 = _interopRequireDefault(_FieldEmbeddedListField);
	
	var _FieldFloatFieldJs = __webpack_require__(439);
	
	var _FieldFloatFieldJs2 = _interopRequireDefault(_FieldFloatFieldJs);
	
	var _FieldFileField = __webpack_require__(441);
	
	var _FieldFileField2 = _interopRequireDefault(_FieldFileField);
	
	var _FieldJsonField = __webpack_require__(442);
	
	var _FieldJsonField2 = _interopRequireDefault(_FieldJsonField);
	
	var _FieldNumberField = __webpack_require__(440);
	
	var _FieldNumberField2 = _interopRequireDefault(_FieldNumberField);
	
	var _FieldPasswordField = __webpack_require__(443);
	
	var _FieldPasswordField2 = _interopRequireDefault(_FieldPasswordField);
	
	var _FieldReferenceField = __webpack_require__(444);
	
	var _FieldReferenceField2 = _interopRequireDefault(_FieldReferenceField);
	
	var _FieldReferencedListField = __webpack_require__(445);
	
	var _FieldReferencedListField2 = _interopRequireDefault(_FieldReferencedListField);
	
	var _FieldReferenceManyField = __webpack_require__(446);
	
	var _FieldReferenceManyField2 = _interopRequireDefault(_FieldReferenceManyField);
	
	var _FieldTemplateField = __webpack_require__(447);
	
	var _FieldTemplateField2 = _interopRequireDefault(_FieldTemplateField);
	
	var _FieldTextField = __webpack_require__(448);
	
	var _FieldTextField2 = _interopRequireDefault(_FieldTextField);
	
	var _FieldWysiwygField = __webpack_require__(449);
	
	var _FieldWysiwygField2 = _interopRequireDefault(_FieldWysiwygField);
	
	var _MenuMenuJs = __webpack_require__(414);
	
	var _MenuMenuJs2 = _interopRequireDefault(_MenuMenuJs);
	
	// import Collection from './Collection';
	// import Dashboard from './Dashboard';
	// import Entry from './Entry';
	
	var Factory = (function () {
	    function Factory() {
	        _classCallCheck(this, Factory);
	
	        this._fieldTypes = [];
	        this._init();
	    }
	
	    _createClass(Factory, [{
	        key: "application",
	        value: function application(name, debug) {
	            return new _ApplicationJs2["default"](name, debug);
	        }
	    }, {
	        key: "entity",
	        value: function entity(name) {
	            return new _EntityEntity2["default"](name);
	        }
	    }, {
	        key: "field",
	        value: function field(name, type) {
	            type = type || 'string';
	
	            if (!(type in this._fieldTypes)) {
	                throw new Error("Unknown field type \"" + type + "\".");
	            }
	
	            return new this._fieldTypes[type](name);
	        }
	    }, {
	        key: "registerFieldType",
	        value: function registerFieldType(name, constructor) {
	            this._fieldTypes[name] = constructor;
	        }
	    }, {
	        key: "getFieldConstructor",
	        value: function getFieldConstructor(name) {
	            return this._fieldTypes[name];
	        }
	    }, {
	        key: "menu",
	        value: function menu(entity) {
	            var menu = new _MenuMenuJs2["default"]();
	            if (entity) {
	                menu.populateFromEntity(entity);
	            }
	            return menu;
	        }
	    }, {
	        key: "dashboard",
	        value: function dashboard() {
	            return new Dashboard();
	        }
	    }, {
	        key: "collection",
	        value: function collection(entity) {
	            var collection = new Collection();
	            if (entity) {
	                collection.setEntity(entity);
	            }
	            return collection;
	        }
	    }, {
	        key: "getEntryConstructor",
	        value: function getEntryConstructor() {
	            return Entry;
	        }
	    }, {
	        key: "getDataStore",
	        value: function getDataStore() {
	            return new DataStore();
	        }
	    }, {
	        key: "getReadQueries",
	        value: function getReadQueries(RestWrapper, PromisesResolver, Application) {
	            return new ReadQueries(RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getWriteQueries",
	        value: function getWriteQueries(RestWrapper, PromisesResolver, Application) {
	            return new WriteQueries(RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getPromisesResolver",
	        value: function getPromisesResolver() {
	            return PromisesResolver;
	        }
	    }, {
	        key: "_init",
	        value: function _init() {
	            this.registerFieldType('boolean', _FieldBooleanField2["default"]);
	            this.registerFieldType('choice', _FieldChoiceField2["default"]);
	            this.registerFieldType('choices', _FieldChoicesField2["default"]);
	            this.registerFieldType('date', _FieldDateField2["default"]);
	            this.registerFieldType('datetime', _FieldDateTimeField2["default"]);
	            this.registerFieldType('email', _FieldEmailField2["default"]);
	            this.registerFieldType('embedded_list', _FieldEmbeddedListField2["default"]);
	            this.registerFieldType('float', _FieldFloatFieldJs2["default"]);
	            this.registerFieldType('string', _FieldField2["default"]);
	            this.registerFieldType('file', _FieldFileField2["default"]);
	            this.registerFieldType('json', _FieldJsonField2["default"]);
	            this.registerFieldType('number', _FieldNumberField2["default"]);
	            this.registerFieldType('password', _FieldPasswordField2["default"]);
	            this.registerFieldType('reference', _FieldReferenceField2["default"]);
	            this.registerFieldType('reference_many', _FieldReferenceManyField2["default"]);
	            this.registerFieldType('referenced_list', _FieldReferencedListField2["default"]);
	            this.registerFieldType('template', _FieldTemplateField2["default"]);
	            this.registerFieldType('text', _FieldTextField2["default"]);
	            this.registerFieldType('wysiwyg', _FieldWysiwygField2["default"]);
	        }
	    }]);
	
	    return Factory;
	})();
	
	exports["default"] = Factory;
	module.exports = exports["default"];

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _MenuMenuJs = __webpack_require__(414);
	
	var _MenuMenuJs2 = _interopRequireDefault(_MenuMenuJs);
	
	var Application = (function () {
	    function Application() {
	        var title = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	        var debug = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	        _classCallCheck(this, Application);
	
	        this._baseApiUrl = '';
	        this._customTemplate = function (viewName) {};
	        this._title = title;
	        this._menu = null;
	        this._dashboard = null;
	        this._layout = false;
	        this._header = false;
	        this._entities = [];
	        this._errorMessage = this.defaultErrorMessage;
	        this._debug = debug;
	    }
	
	    // defaultErrorMessage(response) {
	    //     let body = response.data;
	
	    //     if (typeof body === 'object') {
	    //         body = JSON.stringify(body);
	    //     }
	
	    //     return 'Oops, an error occured : (code: ' + response.status + ') ' + body;
	    // }
	
	    _createClass(Application, [{
	        key: 'title',
	
	        // getViewsOfType(type) {
	        //     return orderElement.order(
	        //         this.entities.map(entity => entity.views[type])
	        //                      .filter(view => view.enabled)
	        //     );
	        // }
	
	        // getRouteFor(entity, viewUrl, viewType, identifierValue, identifierName) {
	        //     let baseApiUrl = entity.baseApiUrl() || this.baseApiUrl(),
	        //         url = viewUrl || entity.getUrl(viewType, identifierValue, identifierName);
	
	        //     // If the view or the entity don't define the url, retrieve it from the baseURL of the entity or the app
	        //     if (!url) {
	        //         url = baseApiUrl + encodeURIComponent(entity.name());
	        //         if (identifierValue != null) {
	        //             url += '/' + encodeURIComponent(identifierValue);
	        //         }
	        //     } else if (!/^(?:[a-z]+:)?\/\//.test(url)) {
	        //         // Add baseUrl for relative URL
	        //         url = baseApiUrl + url;
	        //     }
	
	        //     return url;
	        // }
	
	        // debug(debug) {
	        //     if (!arguments.length) return this._debug;
	        //     this._debug = debug;
	        //     return this;
	        // }
	
	        // layout(layout) {
	        //     if (!arguments.length) return this._layout;
	        //     this._layout = layout;
	        //     return this;
	        // }
	
	        // header(header) {
	        //     if (!arguments.length) return this._header;
	        //     this._header = header;
	        //     return this;
	        // }
	
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	
	        /**
	         * Getter/Setter for the main application menu
	         *
	         * If the getter is called first, it will return a menu based on entities.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(); // Menu { children: [ Menu { title: "Posts" }, Menu { title: "Comments" } ]}
	         *
	         * If the setter is called first, all subsequent calls to the getter will return the set menu.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(new Menu().addChild(new Menu().title('Foo')));
	         *     application.menu(); // Menu { children: [ Menu { title: "Foo" } ]}
	         *
	         * @see Menu
	         */
	    }, {
	        key: 'menu',
	        value: function menu(_menu) {
	            if (!arguments.length) {
	                if (!this._menu) {
	                    this._menu = this.buildMenuFromEntities();
	                }
	                return this._menu;
	            }
	
	            this._menu = _menu;
	            return this;
	        }
	    }, {
	        key: 'buildMenuFromEntities',
	        value: function buildMenuFromEntities() {
	            return new _MenuMenuJs2['default']().children(this.entities.filter(function (entity) {
	                return entity.menuView().enabled;
	            }).sort(function (e1, e2) {
	                return e1.menuView().order() - e2.menuView().order();
	            }).map(function (entity) {
	                return new _MenuMenuJs2['default']().populateFromEntity(entity);
	            }));
	        }
	
	        // dashboard(dashboard) {
	        //     if (!arguments.length) {
	        //             if (!this._dashboard) {
	        //                 this._dashboard = this.buildDashboardFromEntities();
	        //             }
	        //             return this._dashboard
	        //     }
	        //     this._dashboard = dashboard;
	        //     return this;
	        // }
	
	        // buildDashboardFromEntities() {
	        //     let dashboard = new Dashboard()
	        //     this.entities
	        //         .filter(entity => entity.dashboardView().enabled)
	        //         .map(entity => {
	        //             dashboard.addCollection(entity.dashboardView()); // yep, a collection is a ListView, and so is a DashboardView - forgive this duck typing for BC sake
	        //         });
	        //     if (!dashboard.hasCollections()) {
	        //         // still no collection from dashboardViews, let's use listViews instead
	        //         this.entities
	        //             .filter(entity => entity.listView().enabled)
	        //             .map((entity, index) => {
	        //                 let collection = new Collection();
	        //                 let listView = entity.listView();
	        //                 collection.setEntity(entity);
	        //                 collection.perPage(listView.perPage())
	        //                 collection.sortField(listView.sortField())
	        //                 collection.sortDir(listView.sortDir())
	        //                 collection.order(index);
	        //                 // use only the first 3 cols
	        //                 collection.fields(listView.fields().filter((el, index) => index < 3));
	        //                 dashboard.addCollection(collection);
	        //             });
	        //     }
	        //     return dashboard;
	        // }
	
	        // customTemplate(customTemplate) {
	        //     if (!arguments.length) return this._customTemplate;
	        //     this._customTemplate = customTemplate;
	        //     return this;
	        // }
	
	    }, {
	        key: 'baseApiUrl',
	        value: function baseApiUrl(url) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = url;
	            return this;
	        }
	    }, {
	        key: 'addEntity',
	        value: function addEntity(entity) {
	            if (!entity) {
	                throw new Error("No entity given");
	            }
	
	            this._entities.push(entity);
	
	            return this;
	        }
	    }, {
	        key: 'getEntity',
	        value: function getEntity(entityName) {
	            var foundEntity = this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0];
	            if (!foundEntity) {
	                throw new Error('Unable to find entity "' + entityName + '"');
	            }
	
	            return foundEntity;
	        }
	    }, {
	        key: 'hasEntity',
	        value: function hasEntity(fieldName) {
	            return !!this._entities.filter(function (f) {
	                return f.name() === fieldName;
	            }).length;
	        }
	    }, {
	        key: 'getViewByEntityAndType',
	        value: function getViewByEntityAndType(entityName, type) {
	            return this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0].views[type];
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessageFor',
	        value: function getErrorMessageFor(view, response) {
	            return view.getErrorMessage(response) || view.getEntity().getErrorMessage(response) || this.getErrorMessage(response);
	        }
	    }, {
	        key: 'getEntityNames',
	        value: function getEntityNames() {
	            return this.entities.map(function (f) {
	                return f.name();
	            });
	        }
	    }, {
	        key: 'entities',
	        get: function get() {
	            return this._entities;
	        }
	    }]);
	
	    return Application;
	})();
	
	exports['default'] = Application;
	module.exports = exports['default'];

/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function alwaysFalse() {
	    return false;
	}
	
	var uuid = 0;
	var _autoClose = true;
	
	var Menu = (function () {
	    function Menu() {
	        _classCallCheck(this, Menu);
	
	        this._link = null;
	        this._activeFunc = alwaysFalse;
	        this._title = null;
	        this._icon = false;
	        this._children = [];
	        this._template = false;
	        this._autoClose = true;
	        this.uuid = uuid++;
	    }
	
	    _createClass(Menu, [{
	        key: 'title',
	        value: function title() {
	            if (arguments.length) {
	                this._title = arguments[0];
	                return this;
	            }
	            return this._title;
	        }
	    }, {
	        key: 'isLink',
	        value: function isLink() {
	            return !!this._link;
	        }
	    }, {
	        key: 'link',
	        value: function link() {
	            var _this = this;
	
	            if (arguments.length) {
	                this._link = arguments[0];
	                if (this._activeFunc == alwaysFalse) {
	                    this._activeFunc = function (url) {
	                        return url.indexOf(_this._link) === 0;
	                    };
	                }
	                return this;
	            }
	            return this._link;
	        }
	    }, {
	        key: 'autoClose',
	        value: function autoClose() {
	            if (arguments.length) {
	                _autoClose = arguments[0];
	                return this;
	            }
	            return _autoClose;
	        }
	    }, {
	        key: 'active',
	        value: function active(activeFunc) {
	            if (arguments.length) {
	                this._activeFunc = arguments[0];
	                return this;
	            }
	            return this._activeFunc;
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(url) {
	            return this._activeFunc(url);
	            // return true;
	        }
	    }, {
	        key: 'isChildActive',
	        value: function isChildActive(url) {
	            return this.isActive(url) || this.children().filter(function (menu) {
	                return menu.isChildActive(url);
	            }).length > 0;
	        }
	    }, {
	        key: 'addChild',
	        value: function addChild(child) {
	            if (!(child instanceof Menu)) {
	                throw new Error('Only Menu instances are accepted as children of a Menu');
	            }
	            this._children.push(child);
	            return this;
	        }
	    }, {
	        key: 'hasChild',
	        value: function hasChild() {
	            return this._children.length > 0;
	        }
	    }, {
	        key: 'getChildByTitle',
	        value: function getChildByTitle(title) {
	            return this.children().filter(function (child) {
	                return child.title() == title;
	            }).pop();
	        }
	    }, {
	        key: 'children',
	        value: function children() {
	            if (arguments.length) {
	                this._children = arguments[0];
	                return this;
	            }
	            return this._children;
	        }
	    }, {
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                this._icon = arguments[0];
	                return this;
	            }
	            return this._icon;
	        }
	    }, {
	        key: 'template',
	        value: function template() {
	            if (arguments.length) {
	                this._template = arguments[0];
	                return this;
	            }
	            return this._template;
	        }
	
	        // populateFromEntity(entity) {
	        //     if (!(entity instanceof Entity)) {
	        //         throw new Error('populateFromEntity() only accepts an Entity parameter');
	        //     }
	        //     this.title(entity.label());
	        //     this.active(path => path.indexOf(`/${entity.name()}/`) === 0 );
	        //     this.link(`/${entity.name()}/list`);
	        //     // deprecated
	        //     this.icon(entity.menuView().icon());
	        //     return this;
	        // }
	    }]);
	
	    return Menu;
	})();
	
	exports['default'] = Menu;
	module.exports = exports['default'];

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _UtilsStringUtils = __webpack_require__(416);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var _FieldField = __webpack_require__(417);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _ViewDashboardView = __webpack_require__(418);
	
	var _ViewDashboardView2 = _interopRequireDefault(_ViewDashboardView);
	
	var _ViewMenuView = __webpack_require__(425);
	
	var _ViewMenuView2 = _interopRequireDefault(_ViewMenuView);
	
	var _ViewListView = __webpack_require__(419);
	
	var _ViewListView2 = _interopRequireDefault(_ViewListView);
	
	var _ViewCreateView = __webpack_require__(426);
	
	var _ViewCreateView2 = _interopRequireDefault(_ViewCreateView);
	
	var _ViewEditView = __webpack_require__(427);
	
	var _ViewEditView2 = _interopRequireDefault(_ViewEditView);
	
	var _ViewDeleteView = __webpack_require__(428);
	
	var _ViewDeleteView2 = _interopRequireDefault(_ViewDeleteView);
	
	var _ViewShowView = __webpack_require__(429);
	
	var _ViewShowView2 = _interopRequireDefault(_ViewShowView);
	
	var _ViewBatchDeleteView = __webpack_require__(430);
	
	var _ViewBatchDeleteView2 = _interopRequireDefault(_ViewBatchDeleteView);
	
	var _ViewExportView = __webpack_require__(431);
	
	var _ViewExportView2 = _interopRequireDefault(_ViewExportView);
	
	var index = 0;
	
	var Entity = (function () {
	    function Entity(name) {
	        _classCallCheck(this, Entity);
	
	        this._name = name;
	        this._uniqueId = this._name + '_' + index++;
	        this._baseApiUrl = null;
	        this._label = null;
	        this._identifierField = new _FieldField2["default"]("id");
	        this._isReadOnly = false;
	        this._errorMessage = null;
	        this._order = 0;
	        this._url = null;
	        this._createMethod = null; // manually set the HTTP-method for create operation, defaults to post
	        this._updateMethod = null; // manually set the HTTP-method for update operation, defaults to put
	        this._retrieveMethod = null; // manually set the HTTP-method for the get operation, defaults to get
	        this._deleteMethod = null; // manually set the HTTP-method for the delete operation, defaults to delete
	
	        this._initViews();
	    }
	
	    _createClass(Entity, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "menuView",
	        value: function menuView() {
	            return this._views["MenuView"];
	        }
	    }, {
	        key: "dashboardView",
	        value: function dashboardView() {
	            return this._views["DashboardView"];
	        }
	    }, {
	        key: "listView",
	        value: function listView() {
	            return this._views["ListView"];
	        }
	    }, {
	        key: "creationView",
	        value: function creationView() {
	            return this._views["CreateView"];
	        }
	    }, {
	        key: "editionView",
	        value: function editionView() {
	            return this._views["EditView"];
	        }
	    }, {
	        key: "deletionView",
	        value: function deletionView() {
	            return this._views["DeleteView"];
	        }
	    }, {
	        key: "batchDeleteView",
	        value: function batchDeleteView() {
	            return this._views["BatchDeleteView"];
	        }
	    }, {
	        key: "exportView",
	        value: function exportView() {
	            return this._views["ExportView"];
	        }
	    }, {
	        key: "showView",
	        value: function showView() {
	            return this._views["ShowView"];
	        }
	    }, {
	        key: "baseApiUrl",
	        value: function baseApiUrl(_baseApiUrl) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = _baseApiUrl;
	            return this;
	        }
	    }, {
	        key: "_initViews",
	        value: function _initViews() {
	            this._views = {
	                "DashboardView": new _ViewDashboardView2["default"]().setEntity(this),
	                "MenuView": new _ViewMenuView2["default"]().setEntity(this),
	                "ListView": new _ViewListView2["default"]().setEntity(this),
	                "CreateView": new _ViewCreateView2["default"]().setEntity(this),
	                "EditView": new _ViewEditView2["default"]().setEntity(this),
	                "DeleteView": new _ViewDeleteView2["default"]().setEntity(this),
	                "BatchDeleteView": new _ViewBatchDeleteView2["default"]().setEntity(this),
	                "ExportView": new _ViewExportView2["default"]().setEntity(this),
	                "ShowView": new _ViewShowView2["default"]().setEntity(this)
	            };
	        }
	    }, {
	        key: "identifier",
	        value: function identifier(value) {
	            if (!arguments.length) return this._identifierField;
	            if (!(value instanceof _FieldField2["default"])) {
	                throw new Error('Entity ' + this.name() + ': identifier must be an instance of Field.');
	            }
	            this._identifierField = value;
	            return this;
	        }
	    }, {
	        key: "readOnly",
	        value: function readOnly() {
	            this._isReadOnly = true;
	
	            this._views["CreateView"].disable();
	            this._views["EditView"].disable();
	            this._views["DeleteView"].disable();
	            this._views["BatchDeleteView"].disable();
	
	            return this;
	        }
	    }, {
	        key: "getErrorMessage",
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: "errorMessage",
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: "order",
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: "url",
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: "getUrl",
	        value: function getUrl(viewType, identifierValue, identifierName) {
	            if (typeof this._url === 'function') {
	                return this._url(this.name(), viewType, identifierValue, identifierName);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: "createMethod",
	        value: function createMethod(_createMethod) {
	            if (!arguments.length) return this._createMethod;
	            this._createMethod = _createMethod;
	            return this;
	        }
	    }, {
	        key: "updateMethod",
	        value: function updateMethod(_updateMethod) {
	            if (!arguments.length) return this._updateMethod;
	            this._updateMethod = _updateMethod;
	            return this;
	        }
	    }, {
	        key: "retrieveMethod",
	        value: function retrieveMethod(_retrieveMethod) {
	            if (!arguments.length) return this._retrieveMethod;
	            this._retrieveMethod = _retrieveMethod;
	            return this;
	        }
	    }, {
	        key: "deleteMethod",
	        value: function deleteMethod(_deleteMethod) {
	            if (!arguments.length) return this._deleteMethod;
	            this._deleteMethod = _deleteMethod;
	            return this;
	        }
	    }, {
	        key: "uniqueId",
	        get: function get() {
	            return this._uniqueId;
	        }
	    }, {
	        key: "views",
	        get: function get() {
	            return this._views;
	        }
	    }, {
	        key: "isReadOnly",
	        get: function get() {
	            return this._isReadOnly;
	        }
	    }]);
	
	    return Entity;
	})();
	
	exports["default"] = Entity;
	module.exports = exports["default"];

/***/ },
/* 416 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    /**
	     * @see http://stackoverflow.com/questions/10425287/convert-string-to-camelcase-with-regular-expression
	     * @see http://phpjs.org/functions/ucfirst/
	     */
	    camelCase: function camelCase(text) {
	        if (!text) {
	            return text;
	        }
	
	        var f = text.charAt(0).toUpperCase();
	        text = f + text.substr(1);
	
	        return text.replace(/[-_.\s](.)/g, function (match, group1) {
	            return ' ' + group1.toUpperCase();
	        });
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _UtilsStringUtils = __webpack_require__(416);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var Field = (function () {
	    function Field(name) {
	        _classCallCheck(this, Field);
	
	        this._name = name || Math.random().toString(36).substring(7);
	        this._detailLink = name === 'id';
	        this._type = "string";
	        this._order = null;
	        this._label = null;
	        this._maps = [];
	        this._transforms = [];
	        this._attributes = {};
	        this._cssClasses = null;
	        this._validation = { required: false, minlength: 0, maxlength: 99999 };
	        this._defaultValue = null;
	        this._editable = true;
	        this._sortable = true;
	        this._detailLinkRoute = 'edit';
	        this._pinned = false;
	        this._flattenable = true;
	        this.dashboard = true;
	        this.list = true;
	        this._template = function () {
	            return '';
	        };
	        this._templateIncludesLabel = false;
	        this._hidden = false;
	    }
	
	    _createClass(Field, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "type",
	        value: function type() {
	            return this._type;
	        }
	    }, {
	        key: "hidden",
	        value: function hidden(value) {
	            this._hidden = value;
	            return this;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "order",
	        value: function order() {
	            if (arguments.length) {
	                if (arguments[1] !== true) {
	                    console.warn('Setting order with Field.order is deprecated, order directly in fields array');
	                }
	                this._order = arguments[0];
	                return this;
	            }
	
	            return this._order;
	        }
	    }, {
	        key: "isDetailLink",
	        value: function isDetailLink(detailLink) {
	            if (arguments.length) {
	                this._detailLink = arguments[0];
	                return this;
	            }
	
	            if (this._detailLink === null) {
	                return this._name === 'id';
	            }
	
	            return this._detailLink;
	        }
	    }, {
	        key: "map",
	
	        /**
	         * Add a function to be applied to the response object to turn it into an entry
	         */
	        value: function map(fn) {
	            if (!fn) return this._maps;
	            if (typeof fn !== "function") {
	                var type = typeof fn;
	                throw new Error("Map argument should be a function, " + type + " given.");
	            }
	
	            this._maps.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasMaps",
	        value: function hasMaps() {
	            return !!this._maps.length;
	        }
	    }, {
	        key: "getMappedValue",
	        value: function getMappedValue(value, entry) {
	            for (var i in this._maps) {
	                value = this._maps[i](value, entry);
	            }
	
	            return value;
	        }
	
	        /**
	         * Add a function to be applied to the entry to turn it into a response object
	         */
	    }, {
	        key: "transform",
	        value: function transform(fn) {
	            if (!fn) return this._transforms;
	            if (typeof fn !== "function") {
	                var type = typeof fn;
	                throw new Error("transform argument should be a function, " + type + " given.");
	            }
	
	            this._transforms.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasTranforms",
	        value: function hasTranforms() {
	            return !!this._transforms.length;
	        }
	    }, {
	        key: "getTransformedValue",
	        value: function getTransformedValue(value, entry) {
	            for (var i in this._transforms) {
	                value = this._transforms[i](value, entry);
	            }
	
	            return value;
	        }
	    }, {
	        key: "attributes",
	        value: function attributes(_attributes) {
	            if (!arguments.length) {
	                return this._attributes;
	            }
	
	            this._attributes = _attributes;
	
	            return this;
	        }
	    }, {
	        key: "cssClasses",
	        value: function cssClasses(classes) {
	            if (!arguments.length) return this._cssClasses;
	            this._cssClasses = classes;
	            return this;
	        }
	    }, {
	        key: "getCssClasses",
	        value: function getCssClasses(entry) {
	            if (!this._cssClasses) {
	                return '';
	            }
	
	            if (this._cssClasses.constructor === Array) {
	                return this._cssClasses.join(' ');
	            }
	
	            if (typeof this._cssClasses === 'function') {
	                return this._cssClasses(entry);
	            }
	
	            return this._cssClasses;
	        }
	    }, {
	        key: "validation",
	        value: function validation(_validation) {
	            if (!arguments.length) {
	                return this._validation;
	            }
	
	            for (var property in _validation) {
	                if (!_validation.hasOwnProperty(property)) continue;
	                if (_validation[property] === null) {
	                    delete this._validation[property];
	                } else {
	                    this._validation[property] = _validation[property];
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: "defaultValue",
	        value: function defaultValue(_defaultValue) {
	            if (!arguments.length) return this._defaultValue;
	            this._defaultValue = _defaultValue;
	            return this;
	        }
	    }, {
	        key: "editable",
	        value: function editable(_editable) {
	            if (!arguments.length) return this._editable;
	            this._editable = _editable;
	            return this;
	        }
	    }, {
	        key: "sortable",
	        value: function sortable(_sortable) {
	            if (!arguments.length) return this._sortable;
	            this._sortable = _sortable;
	            return this;
	        }
	    }, {
	        key: "detailLinkRoute",
	        value: function detailLinkRoute(route) {
	            if (!arguments.length) return this._detailLinkRoute;
	            this._detailLinkRoute = route;
	            return this;
	        }
	    }, {
	        key: "pinned",
	        value: function pinned(_pinned) {
	            if (!arguments.length) return this._pinned;
	            this._pinned = _pinned;
	            return this;
	        }
	    }, {
	        key: "flattenable",
	        value: function flattenable() {
	            return this._flattenable;
	        }
	    }, {
	        key: "getTemplateValue",
	        value: function getTemplateValue(data) {
	            if (typeof this._template === 'function') {
	                return this._template(data);
	            }
	
	            return this._template;
	        }
	    }, {
	        key: "getTemplateValueWithLabel",
	        value: function getTemplateValueWithLabel(data) {
	            return this._templateIncludesLabel ? this.getTemplateValue(data) : false;
	        }
	    }, {
	        key: "templateIncludesLabel",
	        value: function templateIncludesLabel(_templateIncludesLabel) {
	            if (!arguments.length) return this._templateIncludesLabel;
	            this._templateIncludesLabel = _templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            var templateIncludesLabel = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            if (!arguments.length) return this._template;
	            this._template = _template;
	            this._templateIncludesLabel = templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "detailLink",
	        set: function set(isDetailLink) {
	            return this._detailLink = isDetailLink;
	        }
	    }]);
	
	    return Field;
	})();
	
	exports["default"] = Field;
	module.exports = exports["default"];

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ListView2 = __webpack_require__(419);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var DashboardView = (function (_ListView) {
	    _inherits(DashboardView, _ListView);
	
	    function DashboardView() {
	        _classCallCheck(this, DashboardView);
	
	        _get(Object.getPrototypeOf(DashboardView.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(DashboardView, [{
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name();
	            }
	            return this;
	        }
	    }]);
	
	    return DashboardView;
	})(_ListView3['default']);
	
	exports['default'] = DashboardView;
	module.exports = exports['default'];

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(420);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var _UtilsOrderElement = __webpack_require__(424);
	
	var _UtilsOrderElement2 = _interopRequireDefault(_UtilsOrderElement);
	
	var ListView = (function (_View) {
	    _inherits(ListView, _View);
	
	    function ListView(name) {
	        _classCallCheck(this, ListView);
	
	        _get(Object.getPrototypeOf(ListView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'ListView';
	        this._perPage = 30;
	        this._infinitePagination = false;
	        this._listActions = [];
	        this._batchActions = ['delete'];
	        this._filters = [];
	        this._permanentFilters = {};
	        this._exportFields = null;
	        this._exportOptions = {};
	        this._entryCssClasses = null;
	
	        this._sortField = 'id';
	        this._sortDir = 'DESC';
	    }
	
	    _createClass(ListView, [{
	        key: 'perPage',
	        value: function perPage() {
	            if (!arguments.length) {
	                return this._perPage;
	            }
	            this._perPage = arguments[0];
	            return this;
	        }
	
	        /** @deprecated Use perPage instead */
	    }, {
	        key: 'limit',
	        value: function limit() {
	            if (!arguments.length) {
	                return this.perPage();
	            }
	            return this.perPage(arguments[0]);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            return this.name() + '.' + this._sortField;
	        }
	    }, {
	        key: 'infinitePagination',
	        value: function infinitePagination() {
	            if (arguments.length) {
	                this._infinitePagination = arguments[0];
	                return this;
	            }
	
	            return this._infinitePagination;
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) {
	                return this._actions;
	            }
	
	            this._actions = _actions;
	
	            return this;
	        }
	    }, {
	        key: 'exportFields',
	        value: function exportFields(_exportFields) {
	            if (!arguments.length) {
	                return this._exportFields;
	            }
	
	            this._exportFields = _exportFields;
	
	            return this;
	        }
	    }, {
	        key: 'exportOptions',
	        value: function exportOptions(_exportOptions) {
	            if (!arguments.length) {
	                return this._exportOptions;
	            }
	
	            this._exportOptions = _exportOptions;
	
	            return this;
	        }
	    }, {
	        key: 'batchActions',
	        value: function batchActions(actions) {
	            if (!arguments.length) {
	                return this._batchActions;
	            }
	
	            this._batchActions = actions;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     posts.listView().permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: 'permanentFilters',
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	
	        /**
	         * Define filters the user can add to the datagrid
	         *
	         *     posts.listView().filters([
	         *       nga.field('title'),
	         *       nga.field('age', 'number')
	         *     ]);
	         *
	         * @param {Field[]} filters list of filters to add to the GUI
	         */
	    }, {
	        key: 'filters',
	        value: function filters(_filters) {
	            if (!arguments.length) {
	                return this._filters;
	            }
	
	            this._filters = _UtilsOrderElement2['default'].order(_filters);
	
	            return this;
	        }
	    }, {
	        key: 'getFilterReferences',
	        value: function getFilterReferences(withRemoteComplete) {
	            var result = {};
	            var lists = this._filters.filter(function (f) {
	                return f.type() === 'reference';
	            });
	
	            var filterFunction = null;
	            if (withRemoteComplete === true) {
	                filterFunction = function (f) {
	                    return f.remoteComplete();
	                };
	            } else if (withRemoteComplete === false) {
	                filterFunction = function (f) {
	                    return !f.remoteComplete();
	                };
	            }
	
	            if (filterFunction !== null) {
	                lists = lists.filter(filterFunction);
	            }
	
	            for (var i = 0, c = lists.length; i < c; i++) {
	                var list = lists[i];
	                result[list.name()] = list;
	            }
	
	            return result;
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getEntryCssClasses',
	        value: function getEntryCssClasses(entry) {
	            if (!this._entryCssClasses) {
	                return '';
	            }
	
	            if (this._entryCssClasses.constructor === Array) {
	                return this._entryCssClasses.join(' ');
	            }
	
	            if (typeof this._entryCssClasses === 'function') {
	                return this._entryCssClasses(entry);
	            }
	
	            return this._entryCssClasses;
	        }
	    }]);
	
	    return ListView;
	})(_View3['default']);
	
	exports['default'] = ListView;
	module.exports = exports['default'];

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _Entry = __webpack_require__(421);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var _UtilsReferenceExtractor = __webpack_require__(423);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var _UtilsObjectProperties = __webpack_require__(422);
	
	var View = (function () {
	    function View(name) {
	        _classCallCheck(this, View);
	
	        this.entity = null;
	        this._actions = null;
	        this._title = false;
	        this._description = '';
	        this._template = null;
	
	        this._enabled = false;
	        this._fields = [];
	        this._type = null;
	        this._name = name;
	        this._order = 0;
	        this._errorMessage = null;
	        this._url = null;
	        this._prepare = null;
	        this._icon = false;
	    }
	
	    _createClass(View, [{
	        key: 'icon',
	        value: function icon(_icon) {
	            if (!arguments.length) return this._icon;
	            this._icon = _icon;
	            return this;
	        }
	    }, {
	        key: 'title',
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	    }, {
	        key: 'getTitle',
	        value: function getTitle(params) {
	            if (typeof this._title === 'function') {
	                return this._title(params);
	            }
	
	            return this._title;
	        }
	    }, {
	        key: 'description',
	        value: function description() {
	            if (arguments.length) {
	                this._description = arguments[0];
	                return this;
	            }
	
	            return this._description;
	        }
	    }, {
	        key: 'name',
	        value: function name(_name) {
	            if (!arguments.length) {
	                return this._name || this.entity.name() + '_' + this._type;
	            }
	
	            this._name = _name;
	            return this;
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            this._enabled = false;
	
	            return this;
	        }
	    }, {
	        key: 'enable',
	        value: function enable() {
	            this._enabled = true;
	
	            return this;
	        }
	
	        /**
	         * @deprecated Use getter "enabled" instead
	         */
	    }, {
	        key: 'isEnabled',
	        value: function isEnabled() {
	            return this.enabled;
	        }
	
	        /**
	         * @deprecated Use getter "entity" instead
	         */
	    }, {
	        key: 'getEntity',
	        value: function getEntity() {
	            return this.entity;
	        }
	
	        /**
	         * @deprecated Specify entity at view creation or use "entity" setter instead
	         */
	    }, {
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name() + '_' + this._type;
	            }
	
	            return this;
	        }
	
	        /*
	         * Supports various syntax
	         * fields([ Field1, Field2 ])
	         * fields(Field1, Field2)
	         * fields([Field1, {Field2, Field3}])
	         * fields(Field1, {Field2, Field3})
	         * fields({Field2, Field3})
	         */
	    }, {
	        key: 'fields',
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                View.flatten(argument).map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }, {
	        key: 'hasFields',
	        value: function hasFields() {
	            return this.fields.length > 0;
	        }
	    }, {
	        key: 'removeFields',
	        value: function removeFields() {
	            this._fields = [];
	            return this;
	        }
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            return this._fields;
	        }
	    }, {
	        key: 'getField',
	        value: function getField(fieldName) {
	            return this._fields.filter(function (f) {
	                return f.name() === fieldName;
	            })[0];
	        }
	    }, {
	        key: 'getFieldsOfType',
	        value: function getFieldsOfType(type) {
	            return this._fields.filter(function (f) {
	                return f.type() === type;
	            });
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            if (field.order() === null) {
	                field.order(this._fields.length, true);
	            }
	            this._fields.push(field);
	            this._fields = this._fields.sort(function (a, b) {
	                return a.order() - b.order();
	            });
	
	            return this;
	        }
	    }, {
	        key: 'order',
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getReferencedLists',
	        value: function getReferencedLists() {
	            return _UtilsReferenceExtractor2['default'].getReferencedLists(this._fields);
	        }
	    }, {
	        key: 'template',
	        value: function template(_template) {
	            if (!arguments.length) {
	                return this._template;
	            }
	
	            this._template = _template;
	
	            return this;
	        }
	    }, {
	        key: 'identifier',
	        value: function identifier() {
	            return this.entity.identifier();
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) return this._actions;
	            this._actions = _actions;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'url',
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: 'getUrl',
	        value: function getUrl(identifierValue) {
	            if (typeof this._url === 'function') {
	                return this._url(identifierValue);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: 'validate',
	        value: function validate(entry) {
	            this._fields.map(function (field) {
	                var validation = field.validation();
	
	                if (typeof validation.validator === 'function') {
	                    validation.validator(entry.values[field.name()], entry.values);
	                }
	            });
	        }
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         */
	    }, {
	        key: 'mapEntry',
	        value: function mapEntry(restEntry) {
	            return _Entry2['default'].createFromRest(restEntry, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	    }, {
	        key: 'mapEntries',
	        value: function mapEntries(restEntries) {
	            return _Entry2['default'].createArrayFromRest(restEntries, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         */
	    }, {
	        key: 'transformEntry',
	        value: function transformEntry(entry) {
	            return entry.transformToRest(this._fields);
	        }
	
	        /**
	         * Add a function to be executed before the view renders
	         *
	         * This is the ideal place to prefetch related entities and manipulate
	         * the dataStore.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - query: the query object (an object representation of the main request
	         *    query string)
	         *  - datastore: where the Entries are stored. The dataStore is accessible
	         *    during rendering
	         *  - view: the current View object
	         *  - entry: the current Entry instance (except in listView)
	         *  - Entry: the Entry constructor (required to transform an object from
	         *    the REST response to an Entry)
	         *  - window: the window object. If you need to fetch anything other than an
	         *    entry and pass it to the view layer, it's the only way.
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.listView().prepare(['datastore', 'view', 'Entry', function(datastore, view, Entry) {
	         *       const posts = datastore.getEntries(view.getEntity().uniqueId);
	         *       const authorIds = posts.map(post => post.values.authorId).join(',');
	         *       return fetch('http://myapi.com/authors?id[]=' + authorIds)
	         *          .then(response => response.json())
	         *          .then(authors => Entry.createArrayFromRest(
	         *              authors,
	         *              [new Field('first_name'), new Field('last_name')],
	         *              'author'
	         *          ))
	         *          .then(authorEntries => datastore.setEntries('authors', authorEntries));
	         *     }]);
	         */
	    }, {
	        key: 'prepare',
	        value: function prepare(_prepare) {
	            if (!arguments.length) return this._prepare;
	            this._prepare = _prepare;
	            return this;
	        }
	    }, {
	        key: 'doPrepare',
	        value: function doPrepare() {
	            return this._prepare.apply(this, arguments);
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled || !!this._fields.length;
	        }
	    }, {
	        key: 'type',
	        get: function get() {
	            return this._type;
	        }
	    }], [{
	        key: 'flatten',
	        value: function flatten(arg) {
	            if (arg.constructor.name === 'Object') {
	                console.warn('Passing literal of Field to fields method is deprecated use array instead');
	                var result = [];
	                for (var fieldName in arg) {
	                    result = result.concat(View.flatten(arg[fieldName]));
	                }
	                return result;
	            }
	            if (Array.isArray(arg)) {
	                return arg.reduce(function (previous, current) {
	                    return previous.concat(View.flatten(current));
	                }, []);
	            }
	            // arg is a scalar
	            return [arg];
	        }
	    }]);
	
	    return View;
	})();
	
	exports['default'] = View;
	module.exports = exports['default'];

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _UtilsObjectProperties = __webpack_require__(422);
	
	var Entry = (function () {
	    function Entry(entityName, values, identifierValue) {
	        _classCallCheck(this, Entry);
	
	        this._entityName = entityName;
	        this.values = values || {};
	        this._identifierValue = identifierValue;
	        this.listValues = {};
	    }
	
	    _createClass(Entry, [{
	        key: 'transformToRest',
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         *
	         * @return {Object}
	         */
	        value: function transformToRest(fields) {
	
	            var restEntry = (0, _UtilsObjectProperties.clone)(this.values);
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                if (fieldName in restEntry) {
	                    restEntry[fieldName] = field.getTransformedValue(restEntry[fieldName], restEntry);
	                }
	            });
	
	            return (0, _UtilsObjectProperties.cloneAndNest)(restEntry);
	        }
	    }, {
	        key: 'entityName',
	        get: function get() {
	            return this._entityName;
	        }
	    }, {
	        key: 'identifierValue',
	        get: function get() {
	            return this._identifierValue;
	        }
	    }], [{
	        key: 'createForFields',
	        value: function createForFields(fields, entityName) {
	            var entry = new Entry(entityName);
	            fields.forEach(function (field) {
	                entry.values[field.name()] = field.defaultValue();
	            });
	            return entry;
	        }
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         *
	         * @return {Entry}
	         */
	    }, {
	        key: 'createFromRest',
	        value: function createFromRest(restEntry) {
	            var fields = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	            var entityName = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	            var identifierName = arguments.length <= 3 || arguments[3] === undefined ? 'id' : arguments[3];
	
	            if (!restEntry || Object.keys(restEntry).length == 0) {
	                return Entry.createForFields(fields, entityName);
	            }
	            var excludedFields = fields.filter(function (f) {
	                return !f.flattenable();
	            }).map(function (f) {
	                return f.name();
	            });
	
	            var values = (0, _UtilsObjectProperties.cloneAndFlatten)(restEntry, excludedFields);
	
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                values[fieldName] = field.getMappedValue(values[fieldName], values);
	            });
	
	            return new Entry(entityName, values, values[identifierName]);
	        }
	
	        /**
	         * Map an array of JS objects from the REST API Response to an array of Entries
	         *
	         * @return {Array[Entry]}
	         */
	    }, {
	        key: 'createArrayFromRest',
	        value: function createArrayFromRest(restEntries, fields, entityName, identifierName) {
	            return restEntries.map(function (e) {
	                return Entry.createFromRest(e, fields, entityName, identifierName);
	            });
	        }
	    }]);
	
	    return Entry;
	})();
	
	exports['default'] = Entry;
	module.exports = exports['default'];

/***/ },
/* 422 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.clone = clone;
	exports.cloneAndFlatten = cloneAndFlatten;
	exports.cloneAndNest = cloneAndNest;
	function isObject(value) {
	    if (value === null) return false;
	    if (typeof value !== 'object') return false;
	    if (Array.isArray(value)) return false;
	    if (Object.prototype.toString.call(value) === '[object Date]') return false;
	    return true;
	}
	
	function clone(object) {
	    return Object.keys(object).reduce(function (values, name) {
	        if (object.hasOwnProperty(name)) {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	/*
	 * Flatten nested object into a single level object with 'foo.bar' property names
	 *
	 * The parameter object is left unchanged. All values in the returned object are scalar.
	 *
	 *     cloneAndFlatten({ a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } }, i: { j: 6 } }, ['i'])
	 *     // { a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5, i: { j: 6 } } }
	 *
	 * @param {Object} object
	 * @param {String[]} excludedProperties
	 * @return {Object}
	 */
	
	function cloneAndFlatten(object) {
	    var excludedProperties = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	    if (typeof object !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        if (isObject(object[name])) {
	            if (excludedProperties.indexOf(name) === -1) {
	                (function () {
	                    var flatObject = cloneAndFlatten(object[name]);
	                    Object.keys(flatObject).forEach(function (flatObjectKey) {
	                        if (!flatObject.hasOwnProperty(flatObjectKey)) return;
	                        values[name + '.' + flatObjectKey] = flatObject[flatObjectKey];
	                    });
	                })();
	            } else {
	                values[name] = clone(object[name]);
	            }
	        } else {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	;
	
	/*
	 * Clone flattened object into a nested object
	 *
	 * The parameter object is left unchanged.
	 *
	 *     cloneAndNest({ a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5 } )
	 *     // { a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } } }
	 *
	 * @param {Object} object
	 * @return {Object}
	 */
	
	function cloneAndNest(object) {
	    if (typeof object !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        name.split('.').reduce(function (previous, current, index, list) {
	            if (previous != null) {
	                if (typeof previous[current] === 'undefined') previous[current] = {};
	                if (index < list.length - 1) {
	                    return previous[current];
	                };
	                previous[current] = object[name];
	            }
	        }, values);
	        return values;
	    }, {});
	}

/***/ },
/* 423 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	
	    getReferencedLists: function getReferencedLists(fields) {
	        return this.indexByName(fields.filter(function (f) {
	            return f.type() === 'referenced_list';
	        }));
	    },
	    getReferences: function getReferences(fields, withRemoteComplete) {
	        var optimized = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	        var references = fields.filter(function (f) {
	            return f.type() === 'reference' || f.type() === 'reference_many';
	        });
	        if (withRemoteComplete === true) {
	            references = references.filter(function (r) {
	                return r.remoteComplete();
	            });
	        } else if (withRemoteComplete === false) {
	            references = references.filter(function (r) {
	                return !r.remoteComplete();
	            });
	        }
	        if (optimized !== null) {
	            references = references.filter(function (r) {
	                return r.hasSingleApiCall() === optimized;
	            });
	        }
	        return this.indexByName(references);
	    },
	    getNonOptimizedReferences: function getNonOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, false);
	    },
	    getOptimizedReferences: function getOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, true);
	    },
	    indexByName: function indexByName(references) {
	        return references.reduce(function (referencesByName, reference) {
	            referencesByName[reference.name()] = reference;
	            return referencesByName;
	        }, {});
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 424 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = {
	    order: function order(input) {
	        var results = [],
	            objectKey;
	
	        for (objectKey in input) {
	            results.push(input[objectKey]);
	        }
	
	        return results.sort(function (e1, e2) {
	            return e1.order() - e2.order();
	        });
	    }
	};
	module.exports = exports["default"];

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(420);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var MenuView = (function (_View) {
	    _inherits(MenuView, _View);
	
	    function MenuView(name) {
	        _classCallCheck(this, MenuView);
	
	        _get(Object.getPrototypeOf(MenuView.prototype), 'constructor', this).call(this, name);
	        this._type = 'MenuView';
	        this._icon = null;
	    }
	
	    _createClass(MenuView, [{
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                console.warn('entity.menuView() is deprecated. Please use the Menu class instead');
	                this._icon = arguments[0];
	                return this;
	            }
	
	            if (this._icon === null) {
	                return '<span class="glyphicon glyphicon-list"></span>';
	            }
	
	            return this._icon;
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled || this.entity.views['ListView'].enabled;
	        }
	    }]);
	
	    return MenuView;
	})(_View3['default']);
	
	exports['default'] = MenuView;
	module.exports = exports['default'];

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(420);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var CreateView = (function (_View) {
	    _inherits(CreateView, _View);
	
	    function CreateView(name) {
	        _classCallCheck(this, CreateView);
	
	        _get(Object.getPrototypeOf(CreateView.prototype), 'constructor', this).call(this, name);
	        this._type = 'CreateView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    /**
	     * Add a function to be executed after the creation succeeds.
	     *
	     * This is the ideal place to use the response to update the entry, or
	     * redirect to another view.
	     *
	     * If the function returns false, the default execution workflow is stopped.
	     * This means that the function must provide a custom workflow.
	     *
	     * If the function throws an exception, the onSubmitError callback will
	     * execute.
	     *
	     * The syntax depends on the framework calling the function.
	     *
	     * With ng-admin, the function can be an angular injectable, listing
	     * required dependencies in an array. Among other, the function can receive
	     * the following services:
	     *  - $event: the form submission event
	     *  - entry: the current Entry instance
	     *  - entity: the current entity
	     *  - form: the form object (for form validation and errors)
	     *  - progression: the controller for the loading indicator
	     *  - notification: the controller for top notifications
	     *
	     * The function can be asynchronous, in which case it should return
	     * a Promise.
	     *
	     * @example
	     *
	     *     post.creationView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	     *         // stop the progress bar
	     *         progression.done();
	     *         // add a notification
	     *         notification.log(`Element #${entry._identifierValue} successfully created.`, { addnCls: 'humane-flatty-success' });
	     *         // redirect to the list view
	     *         $state.go($state.get('list'), { entity: entity.name() });
	     *         // cancel the default action (redirect to the edition view)
	     *         return false;
	     *      }])
	     *
	     */
	
	    _createClass(CreateView, [{
	        key: 'onSubmitSuccess',
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	
	        /**
	         * Add a function to be executed after the creation request receives a
	         * failed http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.creationView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	    }, {
	        key: 'onSubmitError',
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            this._fields.push(field);
	            return this;
	        }
	    }, {
	        key: 'fields',
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                argument.map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }]);
	
	    return CreateView;
	})(_View3['default']);
	
	exports['default'] = CreateView;
	module.exports = exports['default'];

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(420);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var EditView = (function (_View) {
	    _inherits(EditView, _View);
	
	    function EditView(name) {
	        _classCallCheck(this, EditView);
	
	        _get(Object.getPrototypeOf(EditView.prototype), 'constructor', this).call(this, name);
	        this._type = 'EditView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    /**
	     * Add a function to be executed after the update succeeds.
	     *
	     * This is the ideal place to use the response to update the entry, or
	     * redirect to another view.
	     *
	     * If the function returns false, the default execution workflow is stopped.
	     * This means that the function must provide a custom workflow.
	     *
	     * If the function throws an exception, the onSubmitError callback will
	     * execute.
	     *
	     * The syntax depends on the framework calling the function.
	     *
	     * With ng-admin, the function can be an angular injectable, listing
	     * required dependencies in an array. Among other, the function can receive
	     * the following services:
	     *  - $event: the form submission event
	     *  - entry: the current Entry instance
	     *  - entity: the current entity
	     *  - form: the form object (for form validation and errors)
	     *  - progression: the controller for the loading indicator
	     *  - notification: the controller for top notifications
	     *
	     * The function can be asynchronous, in which case it should return
	     * a Promise.
	     *
	     * @example
	     *
	     *     post.editionView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	     *         // stop the progress bar
	     *         progression.done();
	     *         // add a notification
	     *         notification.log(`Element #${entry._identifierValue} successfully edited.`, { addnCls: 'humane-flatty-success' });
	     *         // redirect to the list view
	     *         $state.go($state.get('list'), { entity: entity.name() });
	     *         // cancel the default action (redirect to the edition view)
	     *         return false;
	     *      }])
	     */
	
	    _createClass(EditView, [{
	        key: 'onSubmitSuccess',
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	
	        /**
	         * Add a function to be executed after the update request receives a failed
	         * http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.editionView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	    }, {
	        key: 'onSubmitError',
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            this._fields.push(field);
	            return this;
	        }
	    }, {
	        key: 'fields',
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                argument.map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }]);
	
	    return EditView;
	})(_View3['default']);
	
	exports['default'] = EditView;
	module.exports = exports['default'];

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(420);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var DeleteView = (function (_View) {
	    _inherits(DeleteView, _View);
	
	    function DeleteView(name) {
	        _classCallCheck(this, DeleteView);
	
	        _get(Object.getPrototypeOf(DeleteView.prototype), 'constructor', this).call(this, name);
	        this._type = 'DeleteView';
	        this._enabled = true;
	    }
	
	    return DeleteView;
	})(_View3['default']);
	
	exports['default'] = DeleteView;
	module.exports = exports['default'];

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(420);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var ShowView = (function (_View) {
	    _inherits(ShowView, _View);
	
	    function ShowView(name) {
	        _classCallCheck(this, ShowView);
	
	        _get(Object.getPrototypeOf(ShowView.prototype), 'constructor', this).call(this, name);
	        this._type = 'ShowView';
	    }
	
	    return ShowView;
	})(_View3['default']);
	
	exports['default'] = ShowView;
	module.exports = exports['default'];

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(420);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var BatchDeleteView = (function (_View) {
	    _inherits(BatchDeleteView, _View);
	
	    function BatchDeleteView(name) {
	        _classCallCheck(this, BatchDeleteView);
	
	        _get(Object.getPrototypeOf(BatchDeleteView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'BatchDeleteView';
	        this._enabled = true;
	    }
	
	    return BatchDeleteView;
	})(_View3['default']);
	
	exports['default'] = BatchDeleteView;
	module.exports = exports['default'];

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ListView2 = __webpack_require__(419);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var ExportView = (function (_ListView) {
	    _inherits(ExportView, _ListView);
	
	    function ExportView(name) {
	        _classCallCheck(this, ExportView);
	
	        _get(Object.getPrototypeOf(ExportView.prototype), 'constructor', this).call(this, name);
	        this._fields = [];
	        this._type = 'ExportView';
	    }
	
	    return ExportView;
	})(_ListView3['default']);
	
	exports['default'] = ExportView;
	module.exports = exports['default'];

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ChoiceField2 = __webpack_require__(433);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var BooleanField = (function (_ChoiceField) {
	    _inherits(BooleanField, _ChoiceField);
	
	    function BooleanField(name) {
	        _classCallCheck(this, BooleanField);
	
	        _get(Object.getPrototypeOf(BooleanField.prototype), "constructor", this).call(this, name);
	        this._type = "boolean";
	        this._choices = [{ value: null, label: 'undefined' }, { value: true, label: 'true' }, { value: false, label: 'false' }];
	        this._filterChoices = [{ value: true, label: 'true' }, { value: false, label: 'false' }];
	    }
	
	    _createClass(BooleanField, [{
	        key: "filterChoices",
	        value: function filterChoices(_filterChoices) {
	            if (!arguments.length) return this._filterChoices;
	            this._filterChoices = _filterChoices;
	
	            return this;
	        }
	    }]);
	
	    return BooleanField;
	})(_ChoiceField3["default"]);
	
	exports["default"] = BooleanField;
	module.exports = exports["default"];

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ChoiceField = (function (_Field) {
	    _inherits(ChoiceField, _Field);
	
	    function ChoiceField(name) {
	        _classCallCheck(this, ChoiceField);
	
	        _get(Object.getPrototypeOf(ChoiceField.prototype), "constructor", this).call(this, name);
	        this._type = "choice";
	        this._choices = [];
	    }
	
	    _createClass(ChoiceField, [{
	        key: "choices",
	        value: function choices(_choices) {
	            if (!arguments.length) return this._choices;
	            this._choices = _choices;
	
	            return this;
	        }
	    }, {
	        key: "getLabelForChoice",
	        value: function getLabelForChoice(value, entry) {
	            var choices = typeof this._choices === 'function' ? this._choices(entry) : this._choices;
	            var choice = choices.filter(function (c) {
	                return c.value == value;
	            }).pop();
	            return choice ? choice.label : null;
	        }
	    }]);
	
	    return ChoiceField;
	})(_Field3["default"]);
	
	exports["default"] = ChoiceField;
	module.exports = exports["default"];

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ChoiceField2 = __webpack_require__(433);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var ChoicesField = (function (_ChoiceField) {
	    _inherits(ChoicesField, _ChoiceField);
	
	    function ChoicesField(name) {
	        _classCallCheck(this, ChoicesField);
	
	        _get(Object.getPrototypeOf(ChoicesField.prototype), "constructor", this).call(this, name);
	        this._type = "choices";
	    }
	
	    return ChoicesField;
	})(_ChoiceField3["default"]);
	
	exports["default"] = ChoicesField;
	module.exports = exports["default"];

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var DateField = (function (_Field) {
	    _inherits(DateField, _Field);
	
	    function DateField(name) {
	        _classCallCheck(this, DateField);
	
	        _get(Object.getPrototypeOf(DateField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            if (date instanceof Date) {
	                // the datepicker returns a JS Date object, with hours, minutes and timezone
	                // in order to convert it back to date, we must remove the timezone, then
	                // remove hours and minutes
	                date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
	
	                var dateString = date.toJSON();
	                return dateString ? dateString.substr(0, 10) : null;
	            }
	            return date;
	        };
	        this._type = "date";
	    }
	
	    _createClass(DateField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "parse",
	        value: function parse(value) {
	            if (!arguments.length) return this._parse;
	            this._parse = value;
	            return this;
	        }
	    }]);
	
	    return DateField;
	})(_Field3["default"]);
	
	exports["default"] = DateField;
	module.exports = exports["default"];

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _DateField2 = __webpack_require__(435);
	
	var _DateField3 = _interopRequireDefault(_DateField2);
	
	var DateTimeField = (function (_DateField) {
	    _inherits(DateTimeField, _DateField);
	
	    function DateTimeField(name) {
	        _classCallCheck(this, DateTimeField);
	
	        _get(Object.getPrototypeOf(DateTimeField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            return date;
	        };
	
	        this._type = 'datetime';
	    }
	
	    return DateTimeField;
	})(_DateField3["default"]);
	
	exports["default"] = DateTimeField;
	module.exports = exports["default"];

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var EmailField = (function (_Field) {
	    _inherits(EmailField, _Field);
	
	    function EmailField(name) {
	        _classCallCheck(this, EmailField);
	
	        _get(Object.getPrototypeOf(EmailField.prototype), "constructor", this).call(this, name);
	        this._type = "email";
	    }
	
	    return EmailField;
	})(_Field3["default"]);
	
	exports["default"] = EmailField;
	module.exports = exports["default"];

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var _EntityEntity = __webpack_require__(415);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	/**
	 * Map an embedded list in the entry
	 *
	 * @example
	 *
	 *     {
	 *        id: 123,
	 *        title: "hello, world",
	 *        comments: [
	 *          { date: "2015-09-30", author: "John Doe", body: "Lorem Ipsum" },
	 *          { date: "2015-10-02", author: "Jane Doe", body: "Sic dolor amet" }
	 *        ]
	 *     }
	 *
	 *     let commentsField = new EmbeddedListField('comments')
	 *        .targetFields([
	 *          new DateField('date'),
	 *          new StringField('author'),
	 *          new StringField('body')
	 *        ])
	 */
	
	var EmbeddedListField = (function (_Field) {
	    _inherits(EmbeddedListField, _Field);
	
	    function EmbeddedListField(name) {
	        _classCallCheck(this, EmbeddedListField);
	
	        _get(Object.getPrototypeOf(EmbeddedListField.prototype), "constructor", this).call(this, name);
	        this._type = 'embedded_list';
	        this._flattenable = false;
	        this._targetEntity = new _EntityEntity2["default"](); // link to an empty entity by default
	        this._targetFields = [];
	        this._sortField = null;
	        this._sortDir = null;
	        this._permanentFilters = null;
	        this._listActions = [];
	    }
	
	    /**
	     * Optionally set the target Entity
	     *
	     * Useful if the embedded entries can be edited in standalone
	     */
	
	    _createClass(EmbeddedListField, [{
	        key: "targetEntity",
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	
	        /**
	         * List the fields to map in the embedded entries
	         *
	         * @example
	         *
	         *     embeddedListField.targetFields([
	         *       new DateField('date'),
	         *       new StringField('author'),
	         *       new StringField('body')
	         *     ])
	         */
	    }, {
	        key: "targetFields",
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	
	        /**
	         * Name of the field used for sorting.
	         *
	         * @param string
	         */
	    }, {
	        key: "sortField",
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField ? this._sortField : this.targetEntity().identifier().name();
	        }
	
	        /**
	         * Direction used for sorting.
	         *
	         * @param String either 'ASC' or 'DESC'
	         */
	    }, {
	        key: "sortDir",
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: "listActions",
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: "permanentFilters",
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	    }]);
	
	    return EmbeddedListField;
	})(_Field3["default"]);
	
	exports["default"] = EmbeddedListField;
	module.exports = exports["default"];

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _NumberField2 = __webpack_require__(440);
	
	var _NumberField3 = _interopRequireDefault(_NumberField2);
	
	var FloatField = (function (_NumberField) {
	    _inherits(FloatField, _NumberField);
	
	    function FloatField(name) {
	        _classCallCheck(this, FloatField);
	
	        _get(Object.getPrototypeOf(FloatField.prototype), 'constructor', this).call(this, name);
	        this._type = 'float';
	        this._format = '0.000';
	    }
	
	    return FloatField;
	})(_NumberField3['default']);
	
	exports['default'] = FloatField;
	module.exports = exports['default'];

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var NumberField = (function (_Field) {
	    _inherits(NumberField, _Field);
	
	    function NumberField(name) {
	        _classCallCheck(this, NumberField);
	
	        _get(Object.getPrototypeOf(NumberField.prototype), "constructor", this).call(this, name);
	        this._type = "number";
	        this._format = undefined;
	    }
	
	    /**
	     * Specify format pattern for number to string conversion. 
	     *
	     * Based on NumeralJs, which uses a syntax similar to Excel.
	     *
	     * {@link} http://numeraljs.com/
	     * {@link} https://github.com/baumandm/angular-numeraljs
	     * {@example}
	     *
	     *     nga.field('height', 'number').format('$0,0.00');
	     */
	
	    _createClass(NumberField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "fractionSize",
	        value: function fractionSize(decimals) {
	            console.warn('NumberField.fractionSize() is deprecated, use NumberField.format() instead');
	            this.format('0.' + '0'.repeat(decimals));
	            return this;
	        }
	    }]);
	
	    return NumberField;
	})(_Field3["default"]);
	
	exports["default"] = NumberField;
	module.exports = exports["default"];

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var FileField = (function (_Field) {
	    _inherits(FileField, _Field);
	
	    function FileField(name) {
	        _classCallCheck(this, FileField);
	
	        _get(Object.getPrototypeOf(FileField.prototype), "constructor", this).call(this, name);
	        this._type = "file";
	        this._uploadInformation = {
	            url: '/upload',
	            accept: '*'
	        };
	    }
	
	    _createClass(FileField, [{
	        key: "uploadInformation",
	        value: function uploadInformation(information) {
	            if (!arguments.length) return this._uploadInformation;
	            this._uploadInformation = information;
	            return this;
	        }
	    }]);
	
	    return FileField;
	})(_Field3["default"]);
	
	exports["default"] = FileField;
	module.exports = exports["default"];

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var JsonField = (function (_Field) {
	    _inherits(JsonField, _Field);
	
	    function JsonField(name) {
	        _classCallCheck(this, JsonField);
	
	        _get(Object.getPrototypeOf(JsonField.prototype), "constructor", this).call(this, name);
	        this._type = "json";
	        this._flattenable = false;
	    }
	
	    return JsonField;
	})(_Field3["default"]);
	
	exports["default"] = JsonField;
	module.exports = exports["default"];

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var PasswordField = (function (_Field) {
	    _inherits(PasswordField, _Field);
	
	    function PasswordField(name) {
	        _classCallCheck(this, PasswordField);
	
	        _get(Object.getPrototypeOf(PasswordField.prototype), "constructor", this).call(this, name);
	        this._type = "password";
	    }
	
	    return PasswordField;
	})(_Field3["default"]);
	
	exports["default"] = PasswordField;
	module.exports = exports["default"];

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ReferenceField = (function (_Field) {
	    _inherits(ReferenceField, _Field);
	
	    function ReferenceField(name) {
	        _classCallCheck(this, ReferenceField);
	
	        _get(Object.getPrototypeOf(ReferenceField.prototype), 'constructor', this).call(this, name);
	        this._type = 'reference';
	        this._targetEntity = null;
	        this._targetField = null;
	        this._perPage = 30;
	        this._permanentFilters = null;
	        this._sortField = null;
	        this._sortDir = null;
	        this._singleApiCall = false;
	        this._detailLink = true;
	        this._remoteComplete = false;
	        this._remoteCompleteOptions = {
	            refreshDelay: 500
	        };
	    }
	
	    _createClass(ReferenceField, [{
	        key: 'perPage',
	        value: function perPage(_perPage) {
	            if (!arguments.length) return this._perPage;
	            this._perPage = _perPage;
	            return this;
	        }
	    }, {
	        key: 'datagridName',
	        value: function datagridName() {
	            return this._targetEntity.name() + '_ListView';
	        }
	    }, {
	        key: 'targetEntity',
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	    }, {
	        key: 'targetField',
	        value: function targetField(field) {
	            if (!arguments.length) return this._targetField;
	            this._targetField = field;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: 'permanentFilters',
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	
	        /**
	         * @deprecated use permanentFilters() instead
	         */
	    }, {
	        key: 'filters',
	        value: function filters(_filters) {
	            console.warn('ReferenceField.filters() is deprecated, please use ReferenceField.permanentFilters() instead');
	            return this.permanentFilters(_filters);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'singleApiCall',
	        value: function singleApiCall(_singleApiCall) {
	            if (!arguments.length) return this._singleApiCall;
	            this._singleApiCall = _singleApiCall;
	            return this;
	        }
	    }, {
	        key: 'hasSingleApiCall',
	        value: function hasSingleApiCall() {
	            return typeof this._singleApiCall === 'function';
	        }
	    }, {
	        key: 'getSingleApiCall',
	        value: function getSingleApiCall(identifiers) {
	            return this.hasSingleApiCall() ? this._singleApiCall(identifiers) : this._singleApiCall;
	        }
	    }, {
	        key: 'getIdentifierValues',
	        value: function getIdentifierValues(rawValues) {
	            var results = {};
	            var identifierName = this._name;
	            for (var i = 0, l = rawValues.length; i < l; i++) {
	                var identifier = rawValues[i][identifierName];
	                if (identifier == null) {
	                    continue;
	                }
	
	                if (identifier instanceof Array) {
	                    for (var j in identifier) {
	                        results[identifier[j]] = true;
	                    }
	                    continue;
	                }
	
	                results[identifier] = true;
	            }
	
	            return Object.keys(results);
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	
	        /**
	         * Enable autocompletion using REST API for choices.
	         *
	         * Available options are:
	         *
	         * * `refreshDelay`: minimal delay between two API calls in milliseconds. By default: 500.
	         * * `searchQuery`: a function returning the parameters to add to the query string basd on the input string.
	         *
	         *       new ReferenceField('authors')
	         *           .targetEntity(author)
	         *           .targetField(new Field('name'))
	         *           .remoteComplete(true, {
	         *               refreshDelay: 300,
	         *               // populate choices from the response of GET /tags?q=XXX
	         *               searchQuery: function(search) { return { q: search }; }
	         *           })
	         *           .perPage(10) // limit the number of results to 10
	         *
	         * @param {Boolean} remoteComplete true to enable remote complete. False by default
	         * @param {Object} options Remote completion options (optional)
	         */
	    }, {
	        key: 'remoteComplete',
	        value: function remoteComplete(_remoteComplete, options) {
	            if (!arguments.length) return this._remoteComplete;
	            this._remoteComplete = _remoteComplete;
	            if (options) {
	                this.remoteCompleteOptions(options);
	            }
	            return this;
	        }
	    }, {
	        key: 'remoteCompleteOptions',
	        value: function remoteCompleteOptions(options) {
	            if (!arguments.length) return this._remoteCompleteOptions;
	            this._remoteCompleteOptions = options;
	            return this;
	        }
	    }]);
	
	    return ReferenceField;
	})(_Field3['default']);
	
	exports['default'] = ReferenceField;
	module.exports = exports['default'];

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ReferenceField2 = __webpack_require__(444);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var _UtilsReferenceExtractor = __webpack_require__(423);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var ReferencedListField = (function (_ReferenceField) {
	    _inherits(ReferencedListField, _ReferenceField);
	
	    function ReferencedListField(name) {
	        _classCallCheck(this, ReferencedListField);
	
	        _get(Object.getPrototypeOf(ReferencedListField.prototype), 'constructor', this).call(this, name);
	        this._type = 'referenced_list';
	        this._targetReferenceField = null;
	        this._targetFields = [];
	        this._detailLink = false;
	        this._listActions = [];
	        this._entryCssClasses = null;
	    }
	
	    _createClass(ReferencedListField, [{
	        key: 'targetReferenceField',
	        value: function targetReferenceField(value) {
	            if (!arguments.length) return this._targetReferenceField;
	            this._targetReferenceField = value;
	            return this;
	        }
	    }, {
	        key: 'targetFields',
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	    }, {
	        key: 'getGridColumns',
	        value: function getGridColumns() {
	            var columns = [];
	            for (var i = 0, l = this._targetFields.length; i < l; i++) {
	                var field = this._targetFields[i];
	                columns.push({
	                    field: field,
	                    label: field.label()
	                });
	            }
	
	            return columns;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }]);
	
	    return ReferencedListField;
	})(_ReferenceField3['default']);
	
	exports['default'] = ReferencedListField;
	module.exports = exports['default'];

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ReferenceField2 = __webpack_require__(444);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var ReferenceManyField = (function (_ReferenceField) {
	    _inherits(ReferenceManyField, _ReferenceField);
	
	    function ReferenceManyField(name) {
	        _classCallCheck(this, ReferenceManyField);
	
	        _get(Object.getPrototypeOf(ReferenceManyField.prototype), "constructor", this).call(this, name);
	        this._type = 'reference_many';
	    }
	
	    return ReferenceManyField;
	})(_ReferenceField3["default"]);
	
	exports["default"] = ReferenceManyField;
	module.exports = exports["default"];

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TemplateField = (function (_Field) {
	    _inherits(TemplateField, _Field);
	
	    function TemplateField(name) {
	        _classCallCheck(this, TemplateField);
	
	        _get(Object.getPrototypeOf(TemplateField.prototype), "constructor", this).call(this, name);
	        this._type = "template";
	        this._flattenable = false;
	    }
	
	    return TemplateField;
	})(_Field3["default"]);
	
	exports["default"] = TemplateField;
	module.exports = exports["default"];

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TextField = (function (_Field) {
	    _inherits(TextField, _Field);
	
	    function TextField(name) {
	        _classCallCheck(this, TextField);
	
	        _get(Object.getPrototypeOf(TextField.prototype), "constructor", this).call(this, name);
	        this._type = "text";
	    }
	
	    return TextField;
	})(_Field3["default"]);
	
	exports["default"] = TextField;
	module.exports = exports["default"];

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(417);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var WysiwygField = (function (_Field) {
	    _inherits(WysiwygField, _Field);
	
	    function WysiwygField(name) {
	        _classCallCheck(this, WysiwygField);
	
	        _get(Object.getPrototypeOf(WysiwygField.prototype), "constructor", this).call(this, name);
	        this._type = "wysiwyg";
	        this._stripTags = false;
	        this._sanitize = true;
	    }
	
	    _createClass(WysiwygField, [{
	        key: "stripTags",
	        value: function stripTags(value) {
	            if (!arguments.length) return this._stripTags;
	            this._stripTags = value;
	            return this;
	        }
	    }, {
	        key: "sanitize",
	        value: function sanitize(value) {
	            if (!arguments.length) return this._sanitize;
	            this._sanitize = value;
	            return this;
	        }
	    }]);
	
	    return WysiwygField;
	})(_Field3["default"]);
	
	exports["default"] = WysiwygField;
	module.exports = exports["default"];

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _breadcrumbHtml = __webpack_require__(451);
	
	var _breadcrumbHtml2 = _interopRequireDefault(_breadcrumbHtml);
	
	var BreadcrumbController = (function () {
	    function BreadcrumbController($state, $stateParams) {
	        _classCallCheck(this, BreadcrumbController);
	
	        this.$state = function () {
	            return $state;
	        };
	        this.$stateParams = function () {
	            return $stateParams;
	        };
	    }
	
	    _createClass(BreadcrumbController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$state = this.$state();
	            this.stateParams = this.$stateParams();
	            this.states = this.$state.$current.path.filter(function (s) {
	                return !s.abstract;
	            });
	        }
	    }]);
	
	    return BreadcrumbController;
	})();
	
	BreadcrumbController.$inject = ['$state', '$stateParams'];
	
	var BreadcrumbComponent = {
	    restrict: 'E',
	    templateUrl: _breadcrumbHtml2['default'],
	    controller: BreadcrumbController,
	    controllerAs: 'vm'
	};
	
	var breadcrumb = _angular2['default'].module('breadcrumb', [_angularUiRouter2['default']]);
	breadcrumb.component('breadcrumb', BreadcrumbComponent);
	
	exports.breadcrumb = breadcrumb;

/***/ },
/* 451 */
/***/ function(module, exports) {

	var path = 'app/components/common/breadcrumb/breadcrumb.html';
	var html = "<div id=\"hbreadcrumb\" class=\"m-t-lg\"><ol class=\"hbreadcrumb breadcrumb\"><li ng-repeat=\"state in vm.states\" ng-switch=\"$last\" ng-class=\"{active: $last}\"><a ng-switch-when=\"false\" href=\"#{{state.url.format(vm.stateParams)}}\">{{state.data.pageTitle}}</a> <span ng-switch-when=\"true\">{{state.data.pageTitle}}</span></li></ol></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pageHeaderComponentJs = __webpack_require__(453);
	
	var pageHeader = _angular2['default'].module('pageHeader', []);
	pageHeader.component('pageHeader', _pageHeaderComponentJs.PageHeaderComponent);
	
	exports.pageHeader = pageHeader;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pageHeaderHtml = __webpack_require__(454);
	
	var _pageHeaderHtml2 = _interopRequireDefault(_pageHeaderHtml);
	
	var PageHeaderController = function PageHeaderController($state) {
	    _classCallCheck(this, PageHeaderController);
	
	    this.$state = $state;
	    this.icon = this.icon || false;
	};
	
	PageHeaderController.$inject = ['$state'];
	
	var PageHeaderComponent = {
	    restrict: 'E',
	    templateUrl: _pageHeaderHtml2['default'],
	    controller: PageHeaderController,
	    controllerAs: 'vm',
	    bindings: {
	        icon: '<',
	        pageTitle: '<',
	        pageDesc: '<'
	    }
	};
	
	exports.PageHeaderComponent = PageHeaderComponent;

/***/ },
/* 454 */
/***/ function(module, exports) {

	var path = 'app/components/common/pageHeader/pageHeader.html';
	var html = "<div small-header class=\"normalheader transition\"><div class=\"hpanel\"><div class=\"panel-body\"><a ng-click=\"small()\"><div class=\"clip-header\"><i class=\"fa fa-arrow-up\"></i></div></a><div class=\"pull-right\" compile=\"vm.icon\" compileOnce=\"true\"><breadcrumb></breadcrumb></div><h2 class=\"font-light m-b-xs\" compile=\"vm.pageTitle\" compileOnce=\"true\"></h2><small ng-bind-html=\"vm.pageDesc\"></small></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _configurationConfigurationJs = __webpack_require__(411);
	
	var _listDataGridComponentJs = __webpack_require__(456);
	
	var _listListViewComponentJs = __webpack_require__(458);
	
	var _formModalFormComponentJs = __webpack_require__(471);
	
	var _fieldViewFieldViewConfigurationJs = __webpack_require__(473);
	
	var _fieldViewFieldViewConfigurationJs2 = _interopRequireDefault(_fieldViewFieldViewConfigurationJs);
	
	var crud = _angular2['default'].module('crud', [_angularUiRouter2['default'], _configurationConfigurationJs.configurationModule.name]);
	
	crud.component('inDataGrid', _listDataGridComponentJs.DataGridComponent);
	crud.component('listView', _listListViewComponentJs.ListViewComponent);
	crud.component('modalForm', _formModalFormComponentJs.ModalFormComponent);
	
	crud.provider('FieldViewConfiguration', _fieldViewFieldViewConfigurationJs2['default']);
	
	crud.directive('inListActions', __webpack_require__(493));
	
	crud.directive('column', __webpack_require__(495));
	crud.directive('inStringColumn', __webpack_require__(496));
	crud.directive('inDateColumn', __webpack_require__(497));
	crud.directive('inTemplateColumn', __webpack_require__(498));
	crud.directive('inReferenceColumn', __webpack_require__(499));
	
	exports.crud = crud;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _dataGridHtml = __webpack_require__(457);
	
	var _dataGridHtml2 = _interopRequireDefault(_dataGridHtml);
	
	var DataGridController = (function () {
	    function DataGridController() {
	        _classCallCheck(this, DataGridController);
	
	        this.shouldDisplayActions = this.actions && this.actions.length > 0;
	        // this.datastore = this.datastore();
	    }
	
	    _createClass(DataGridController, [{
	        key: 'btnClicked',
	        value: function btnClicked(btnId, params) {
	            this.onBtnClick({ btnId: btnId, params: params });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.onEdit({ item: item });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(item) {
	            this.onDelete({ item: item });
	        }
	    }]);
	
	    return DataGridController;
	})();
	
	DataGridController.$inject = ['$q'];
	
	var DataGridComponent = {
	    restrict: 'E',
	    templateUrl: _dataGridHtml2['default'],
	    bindings: {
	        fields: '<',
	        entries: '<',
	        entity: '<',
	        datastore: '&',
	        actions: '<',
	        onBtnClick: '&',
	        onEdit: '&',
	        onDelete: '&',
	        tblClass: '@'
	    },
	    controller: DataGridController,
	    controllerAs: 'vm'
	};
	
	exports.DataGridComponent = DataGridComponent;

/***/ },
/* 457 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/list/dataGrid.html';
	var html = "<table class=\"table table-striped table-hover\" ng-class=\"vm.tblClass\"><thead><tr><th ng-repeat=\"field in vm.fields | filter: {_hidden:false} track by $index\" ng-class=\"field.getCssClasses()\" class=\"ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}\"><span ng-bind-html=\"field.label()\"></span></th><th ng-if=\"vm.shouldDisplayActions\" class=\"ng-admin-column-actions col-lg-2 text-center\">Akcije</th></tr></thead><tbody><tr ng-repeat=\"entry in vm.entries\"><td ng-repeat=\"field in vm.fields | filter: {_hidden:false}\" ng-class=\"field.getCssClasses(entry)\" class=\"ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}\"><column field=\"::field\" entry=\"::entry\" entity=\"::vm.entity\" datastore=\"::vm.datastore()\"></column></td><td ng-if=\"vm.shouldDisplayActions\" class=\"ng-admin-column-actions text-center\"><in-list-actions entry=\"::entry\" entity=\"::vm.entity\" buttons=\"vm.actions\" on-btn-click=\"vm.btnClicked(btnId, params)\" on-edit=\"vm.edit(item)\" on-delete=\"vm.delete(item)\"></in-list-actions></td></tr></tbody></table>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _sweetalert = __webpack_require__(459);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _listViewHtml = __webpack_require__(468);
	
	var _listViewHtml2 = _interopRequireDefault(_listViewHtml);
	
	var _listControllerJs = __webpack_require__(469);
	
	var _listControllerJs2 = _interopRequireDefault(_listControllerJs);
	
	var ListViewController = (function (_ListController) {
	    _inherits(ListViewController, _ListController);
	
	    function ListViewController($uibModal, DS, $q, logger) {
	        _classCallCheck(this, ListViewController);
	
	        _get(Object.getPrototypeOf(ListViewController.prototype), 'constructor', this).call(this);
	        this.$uibModal = $uibModal;
	        this.$q = $q;
	        this.logger = logger;
	        this.view = this.view || false;
	        this.Model = this.store || false;
	        this.datastore = function () {
	            return DS;
	        };
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.title();
	        this.pageDesc = this.view.description();
	
	        this.getState();
	    }
	
	    _createClass(ListViewController, [{
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            this.resolveReferences().then(function () {
	                _this.getItems();
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.view.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params, { bypassCache: true });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this2 = this;
	
	            var model = item;
	            var entity = this.view.entity;
	            var _view = entity.editionView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this2.Model.update(model.id, model).then(function () {
	                    return _this2.getState();
	                })['catch'](function (error) {
	                    _this2.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'canInsert',
	        value: function canInsert() {
	            var fields = this.view.entity.editionView().fields();
	            return fields.length > 0;
	        }
	    }, {
	        key: 'insert',
	        value: function insert() {
	            var _this3 = this;
	
	            var model = {};
	            var entity = this.view.entity;
	            var _view2 = entity.editionView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view2;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this3.Model.create(model).then(function () {
	                    _this3.Model.ejectAll();
	                    _this3.getState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(item) {
	            var _this4 = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje retka entiteta ' + this.view.title(),
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    _this4.Model.destroy(item.id).then(function (data) {
	                        _this4.getState();
	                        (0, _sweetalert2['default'])('Redak obrisan', '', 'success');
	                    }, function (error) {
	                        (0, _sweetalert2['default'])('Greška', 'Došlo je do greške prilikom brisanja', 'error');
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'btnClicked',
	        value: function btnClicked(btnId, params) {}
	    }]);
	
	    return ListViewController;
	})(_listControllerJs2['default']);
	
	ListViewController.$inject = ['$uibModal', 'DS', '$q', 'logger'];
	
	var ListViewComponent = {
	    restrict: 'E',
	    templateUrl: _listViewHtml2['default'],
	    controller: ListViewController,
	    controllerAs: 'vm',
	    bindings: {
	        view: '<',
	        store: '<'
	    }
	};
	
	exports.ListViewComponent = ListViewComponent;

/***/ },
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/list/listView.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Pretraži...\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\" id=\"example2_paginate\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ng-click=\"vm.insert()\" type=\"button\" class=\"btn btn-success\" ng-if=\"vm.canInsert()\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><div animate-panel child=\"hpanel\"><div class=\"hpanel\"><div class=\"panel-heading\"><div class=\"panel-tools\"><a class=\"showhide\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"closebox\" hidden><i class=\"fa fa-times\"></i></a></div><br></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.view.fields()\" entries=\"vm.items\" entity=\"vm.view.entity\" actions=\"vm.view.listActions()\" datastore=\"vm.datastore()\" on-btn-click=\"vm.btnClicked(btnId, params)\" on-edit=\"vm.edit(item)\" on-delete=\"vm.delete(item)\"></in-data-grid></div></div><div class=\"panel-footer\"><br></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _modelsMetaJs = __webpack_require__(470);
	
	var ListController = (function () {
	    function ListController(Model) {
	        _classCallCheck(this, ListController);
	
	        this.Model = Model;
	        this.items = [];
	        this.pager = {
	            currentPage: 1,
	            limit: 15,
	            totalItems: 0,
	            search: "",
	            start: 0,
	            end: 0
	        };
	    }
	
	    _createClass(ListController, [{
	        key: 'getState',
	        value: function getState() {}
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params);
	        }
	    }, {
	        key: 'getItems',
	        value: function getItems() {
	            var _this = this;
	
	            var params = {
	                limit: this.pager.limit,
	                offset: 0,
	                search: this.pager.search
	            };
	
	            if (params.search === '') {
	                delete params.search;
	            }
	
	            params.offset = (this.pager.currentPage - 1) * params.limit;
	
	            return this.getQueryset(params).then(function (response) {
	                _this.items = response;
	
	                _this.pager.start = parseInt(params.offset * (_this.pager.currentPage - 1)) + 1;
	                _this.pager.end = parseInt(params.offset * (_this.pager.currentPage - 1)) + response.length;
	
	                if (_modelsMetaJs.meta[_this.Model.name] !== undefined) {
	                    _this.pager.totalItems = _modelsMetaJs.meta[_this.Model.name].count;
	                    // this.pager.start = response.meta.start;
	                    // this.pager.end = response.meta.end;
	                }
	
	                return _this.items;
	            });
	        }
	    }, {
	        key: 'onFilter',
	        value: function onFilter(value) {
	            this.pager.search = value;
	            this.getState();
	        }
	    }, {
	        key: 'pageChanged',
	        value: function pageChanged() {
	            this.getState();
	        }
	    }]);
	
	    return ListController;
	})();
	
	exports['default'] = ListController;
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var meta = {};
	
	exports.meta = meta;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalFormHtml = __webpack_require__(472);
	
	var _modalFormHtml2 = _interopRequireDefault(_modalFormHtml);
	
	var ModalFormController = (function () {
	    function ModalFormController() {
	        _classCallCheck(this, ModalFormController);
	    }
	
	    _createClass(ModalFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.item = this.resolve.item;
	            this.view = this.resolve.view;
	            this.formClass = this.resolve.formClass || 'horizontal';
	            this.clone = _angular2['default'].copy(this.item);
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            this.close({ $value: item });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }]);
	
	    return ModalFormController;
	})();
	
	var ModalFormComponent = {
	    restrict: 'E',
	    templateUrl: _modalFormHtml2['default'],
	    controller: ModalFormController,
	    controllerAs: 'vm',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    }
	};
	
	exports.ModalFormComponent = ModalFormComponent;

/***/ },
/* 472 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/form/modalForm.html';
	var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header\"><h5 class=\"modal-title\">{{vm.view.title()}}</h5></div><div class=\"modal-body\"><div class=\"hpanel stats\"><div class=\"panel-body list\"><form name=\"vm.form\" ng-submit=\"vm.submit(vm.clone)\" ng-class=\"{'form-horizontal': vm.formClass === 'horizontal'}\"><formly-form model=\"vm.clone\" fields=\"vm.view.fields()\" form=\"vm.form\" options=\"vm.options\"></formly-form></form></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.submit(vm.clone)\">Potvrdi</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var FieldViewConfiguration = (function () {
	    function FieldViewConfiguration() {
	        _classCallCheck(this, FieldViewConfiguration);
	
	        this.fieldViews = {};
	        this._init();
	    }
	
	    _createClass(FieldViewConfiguration, [{
	        key: 'registerFieldView',
	        value: function registerFieldView(type, FieldView) {
	            this.fieldViews[type] = FieldView;
	        }
	    }, {
	        key: '$get',
	        value: function $get() {
	            return this.fieldViews;
	        }
	    }, {
	        key: '_init',
	        value: function _init() {
	            this.registerFieldView('boolean', __webpack_require__(474));
	            this.registerFieldView('choice', __webpack_require__(475));
	            this.registerFieldView('choices', __webpack_require__(476));
	            this.registerFieldView('date', __webpack_require__(477));
	            this.registerFieldView('datetime', __webpack_require__(478));
	            this.registerFieldView('email', __webpack_require__(479));
	            this.registerFieldView('embedded_list', __webpack_require__(480));
	            this.registerFieldView('file', __webpack_require__(481));
	            this.registerFieldView('float', __webpack_require__(482));
	            this.registerFieldView('json', __webpack_require__(483));
	            this.registerFieldView('number', __webpack_require__(484));
	            this.registerFieldView('password', __webpack_require__(485));
	            this.registerFieldView('referenced_list', __webpack_require__(486));
	            this.registerFieldView('reference', __webpack_require__(487));
	            this.registerFieldView('reference_many', __webpack_require__(488));
	            this.registerFieldView('string', __webpack_require__(489));
	            this.registerFieldView('template', __webpack_require__(490));
	            this.registerFieldView('text', __webpack_require__(491));
	            this.registerFieldView('wysiwyg', __webpack_require__(492));
	        }
	    }]);
	
	    return FieldViewConfiguration;
	})();
	
	exports['default'] = FieldViewConfiguration;
	
	FieldViewConfiguration.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-boolean-column value="::value"></ma-boolean-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value" choices="::field.filterChoices()"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="row">\n        <ma-choice-field class="col-sm-4 col-md-3" ng-if="!field.validation().required" field="::field" value="$parent.value"></ma-choice-field>\n        <ma-checkbox-field class="col-sm-4 col-md-3" ng-if="!!field.validation().required" field="::field" value="$parent.value"></ma-checkbox-field>\n    </div>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 475 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::field.getLabelForChoice(value, entry)"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choice-field field="::field" entry="entry" value="value"></ma-choice-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::value"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choices-field field="::field" value="value"></ma-choices-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choices-field field="::field" entry="::entry" value="value"></ma-choices-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-date-column field="::field" value="::value()"></in-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="date_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 478 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-date-column field="::field" value="::value()"></in-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="email" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-embedded-list-column field="::field" value="::value" datastore="::datastore"></ma-embedded-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-embedded-list-field field="::field" value="value" datastore="::datastore"></ma-embedded-list-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 481 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display file field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display file field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display file field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-file-field field="::field" value="value"></ma-file-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 482 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 483 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-json-column value="::value"></ma-json-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display a json field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-json-field field="::field" value="value"></ma-json-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 484 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 485 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display password field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display password field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display password field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="password" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 487 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-reference-column field="::field" value="value()" datastore="::datastore"></in-reference-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-link-column entry="::entry" field="::field" value="::value" datastore="::datastore"></ma-reference-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::entry.listValues[field.name()]"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-many-link-column ids="::value" values="::entry.listValues[field.name()]" field="::field"></ma-reference-many-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-string-column value="::value()"></in-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 490 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-template-column entry="::entry" field="::field" entity="::entity"></in-template-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-template-field field="::field" value="value" values="values" filters="filters"></ma-template-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-template-field field="::field" value="value" entry="entry" entity="::entity"></ma-template-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 491 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-text-field field="::field" value="value"></ma-text-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 492 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-wysiwyg-column field="::field" value="::value"></ma-wysiwyg-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-wysiwyg-field field="::field" value="value"></ma-wysiwyg-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inListActions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _listActionsHtml = __webpack_require__(494);
	
	var _listActionsHtml2 = _interopRequireDefault(_listActionsHtml);
	
	function inListActions() {
	    return {
	        restrict: 'E',
	        transclude: true,
	        scope: {
	            'buttons': '<',
	            'entry': '<',
	            'entity': '<',
	            'onBtnClick': '&',
	            'onEdit': '&',
	            'onDelete': '&'
	        },
	        controller: ['$scope', function ($scope) {
	
	            $scope.actionClick = function (btnId) {
	                var params = {
	                    entity: $scope.entity,
	                    entry: $scope.entry
	                };
	                $scope.onBtnClick({ btnId: btnId, params: params });
	            };
	
	            $scope.edit = function () {
	                $scope.onEdit({ item: $scope.entry });
	            };
	
	            $scope['delete'] = function () {
	                $scope.onDelete({ item: $scope.entry });
	            };
	        }],
	        link: function link($scope) {
	            $scope.customTemplate = false;
	            if (typeof $scope.buttons === 'string') {
	                $scope.customTemplate = $scope.buttons;
	                $scope.buttons = null;
	            }
	        },
	        templateUrl: _listActionsHtml2['default']
	    };
	}
	
	inListActions.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 494 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/list/listActions.html';
	var html = "<span compile=\"customTemplate\"><span ng-repeat=\"button in ::buttons\" ng-switch=\"button\"><ma-show-button ng-switch-when=\"show\" entry=\"::entry\" entity=\"::entity\" size=\"xs\"></ma-show-button><a ng-click=\"edit()\" ng-switch-when=\"edit\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i></a> <a ng-click=\"delete()\" ng-switch-when=\"delete\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-close\"></i></a><span ng-switch-default><span compile=\"button\"></span></span></span></span>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 495 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = column;
	
	function column($compile, FieldViewConfiguration) {
	
	    function linkFn(scope, element) {
	        // debugger;
	
	        if (typeof scope.field === 'undefined') return;
	
	        scope.value = function () {
	            if (typeof scope.entry === 'undefined') {
	                return '';
	            }
	            return scope.entry[scope.field.name()];
	        };
	
	        var type = scope.field.type();
	        element.append(FieldViewConfiguration[type].getReadWidget());
	        $compile(element.contents())(scope);
	    }
	
	    return {
	        restrict: 'E',
	        scope: {
	            field: '<',
	            entry: '<',
	            entity: '<',
	            datastore: '&'
	        },
	        link: linkFn
	    };
	}
	
	column.$inject = ['$compile', 'FieldViewConfiguration'];
	module.exports = exports['default'];

/***/ },
/* 496 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inStringColumn;
	
	function inStringColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        template: '<span>{{ value() }}</span>'
	    };
	}
	
	inStringColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 497 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inDateColumn;
	
	function inDateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '<'
	        },
	        link: function link(scope) {
	            var field = scope.field;
	            scope.format = field.format();
	            if (!scope.format) {
	                scope.format = field.type() === 'date' ? 'dd.MM.yyyy' : 'dd.MM.yyyy HH:mm:ss';
	            }
	        },
	        template: '<span>{{ value() | date:format }}</span>'
	    };
	}
	
	inDateColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 498 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inTemplateColumn;
	
	function inTemplateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '<',
	            entry: '<',
	            entity: '<'
	        },
	        link: function link(scope) {
	            // scope.field = scope.field();
	            // scope.entry = scope.entry();
	            // scope.entity = scope.entity();
	        },
	        template: '<span compile="field.getTemplateValue(entry)"></span>'
	    };
	}
	
	inTemplateColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inReferenceColumn;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function inReferenceColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            value: '&',
	            datastore: '<'
	        },
	        link: {
	            pre: function pre(scope) {
	                // const value = scope.value();
	                scope.field = scope.field();
	                scope.targetEntity = scope.field.targetEntity();
	                scope.targetField = scope.field.targetField();
	                var referencedEntries = scope.datastore().definitions[scope.targetEntity.name()].getAll();
	                // scope.referencedEntry = _.find(referencedEntries, (e) => e.id === value);
	
	                scope.$watch(scope.value, function (newVal, oldVal) {
	                    scope.referencedEntry = _lodash2['default'].find(referencedEntries, function (e) {
	                        return e.id === newVal;
	                    });
	                });
	            }
	        },
	        template: '<column field="::targetField" entry="referencedEntry" entity="::targetEntity" datastore="::datastore()"></column>'
	    };
	}
	
	inReferenceColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*
	 *
	 * https://github.com/fatlinesofcode/ngDraggable
	 */
	var ngDraggable = _angular2['default'].module("ngDraggable", []).service('ngDraggable', [function () {
	
	    var scope = this;
	    scope.inputEvent = function (event) {
	        if (_angular2['default'].isDefined(event.touches)) {
	            return event.touches[0];
	        } else if (_angular2['default'].isDefined(event.originalEvent.touches)) {
	            return event.originalEvent.touches[0];
	        }
	        return event;
	    };
	}]).directive('ngDrag', ['$rootScope', '$parse', '$document', '$window', 'ngDraggable', function ($rootScope, $parse, $document, $window, ngDraggable) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            scope.value = attrs.ngDrag;
	            var offset,
	                _centerAnchor = false,
	                _mx,
	                _my,
	                _tx,
	                _ty,
	                _mrx,
	                _mry;
	            var _hasTouch = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
	            var _pressEvents = 'touchstart mousedown';
	            var _moveEvents = 'touchmove mousemove';
	            var _releaseEvents = 'touchend mouseup';
	            var _dragHandle;
	
	            // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
	            var _myid = scope.$id;
	            var _data = null;
	
	            var _dragOffset = null;
	
	            var _dragEnabled = false;
	
	            var _pressTimer = null;
	
	            var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;
	            var allowTransform = _angular2['default'].isDefined(attrs.allowTransform) ? scope.$eval(attrs.allowTransform) : true;
	            // var allowTransform = true;
	
	            // debugger;
	
	            // Adjust scroll offset if drag element is in a position fixed div and we scroll while dragging
	            var scrollOffset = _angular2['default'].isDefined(attrs.scrollOffset) ? scope.$eval(attrs.scrollOffset) : false;
	            // scrollOffset = scrollOffset && !allowTransform;
	            scrollOffset = true;
	
	            var getDragData = $parse(attrs.ngDragData);
	
	            // deregistration function for mouse move events in $rootScope triggered by jqLite trigger handler
	            var _deregisterRootMoveListener = _angular2['default'].noop;
	
	            var initialize = function initialize() {
	                element.attr('draggable', 'false'); // prevent native drag
	                // check to see if drag handle(s) was specified
	                // if querySelectorAll is available, we use this instead of find
	                // as JQLite find is limited to tagnames
	                if (element[0].querySelectorAll) {
	                    var dragHandles = _angular2['default'].element(element[0].querySelectorAll('[ng-drag-handle]'));
	                } else {
	                    var dragHandles = element.find('[ng-drag-handle]');
	                }
	                if (dragHandles.length) {
	                    _dragHandle = dragHandles;
	                }
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                if (!enable) return;
	                // add listeners.
	
	                scope.$on('$destroy', onDestroy);
	                scope.$watch(attrs.ngDrag, onEnableChange);
	                scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
	                // wire up touch events
	                if (_dragHandle) {
	                    // handle(s) specified, use those to initiate drag
	                    _dragHandle.on(_pressEvents, onpress);
	                } else {
	                    // no handle(s) specified, use the element as the handle
	                    element.on(_pressEvents, onpress);
	                }
	                if (!_hasTouch && element[0].nodeName.toLowerCase() == "img") {
	                    element.on('mousedown', function () {
	                        return false;
	                    }); // prevent native drag for images
	                }
	            };
	            var onDestroy = function onDestroy(enable) {
	                toggleListeners(false);
	            };
	            var onEnableChange = function onEnableChange(newVal, oldVal) {
	                _dragEnabled = newVal;
	            };
	            var onCenterAnchor = function onCenterAnchor(newVal, oldVal) {
	                if (_angular2['default'].isDefined(newVal)) _centerAnchor = newVal || 'true';
	            };
	
	            var isClickableElement = function isClickableElement(evt) {
	                return _angular2['default'].isDefined(_angular2['default'].element(evt.target).attr("ng-cancel-drag"));
	            };
	            /*
	             * When the element is clicked start the drag behaviour
	             * On touch devices as a small delay so as not to prevent native window scrolling
	             */
	            var onpress = function onpress(evt) {
	                if (!_dragEnabled) return;
	
	                if (isClickableElement(evt)) {
	                    return;
	                }
	
	                if (evt.type == "mousedown" && evt.button != 0) {
	                    // Do not start dragging on right-click
	                    return;
	                }
	
	                if (_hasTouch) {
	                    cancelPress();
	                    _pressTimer = setTimeout(function () {
	                        cancelPress();
	                        onlongpress(evt);
	                    }, 100);
	                    $document.on(_moveEvents, cancelPress);
	                    $document.on(_releaseEvents, cancelPress);
	                } else {
	                    onlongpress(evt);
	                }
	            };
	
	            var cancelPress = function cancelPress() {
	                clearTimeout(_pressTimer);
	                $document.off(_moveEvents, cancelPress);
	                $document.off(_releaseEvents, cancelPress);
	            };
	
	            var onlongpress = function onlongpress(evt) {
	                if (!_dragEnabled) return;
	                evt.preventDefault();
	
	                offset = element[0].getBoundingClientRect();
	                if (allowTransform) _dragOffset = offset;else {
	                    _dragOffset = { left: document.body.scrollLeft, top: document.body.scrollTop };
	                }
	
	                element.centerX = element[0].offsetWidth / 2;
	                element.centerY = element[0].offsetHeight / 2;
	
	                _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
	                _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');
	                _mrx = _mx - offset.left;
	                _mry = _my - offset.top;
	                if (_centerAnchor) {
	                    _tx = _mx - element.centerX - $window.pageXOffset;
	                    _ty = _my - element.centerY - $window.pageYOffset;
	                } else {
	                    _tx = _mx - _mrx - $window.pageXOffset;
	                    _ty = _my - _mry - $window.pageYOffset;
	                }
	
	                $document.on(_moveEvents, onmove);
	                $document.on(_releaseEvents, onrelease);
	                // This event is used to receive manually triggered mouse move events
	                // jqLite unfortunately only supports triggerHandler(...)
	                // See http://api.jquery.com/triggerHandler/
	                // _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', onmove);
	                _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', function (event, origEvent) {
	                    onmove(origEvent);
	                });
	            };
	
	            var onmove = function onmove(evt) {
	                if (!_dragEnabled) return;
	                evt.preventDefault();
	
	                if (!element.hasClass('dragging')) {
	                    _data = getDragData(scope);
	                    element.addClass('dragging');
	                    $rootScope.$broadcast('draggable:start', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data });
	                }
	
	                _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
	                _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');
	
	                if (_centerAnchor) {
	                    _tx = _mx - element.centerX - _dragOffset.left;
	                    _ty = _my - element.centerY - _dragOffset.top;
	                } else {
	                    _tx = _mx - _mrx - _dragOffset.left;
	                    _ty = _my - _mry - _dragOffset.top;
	                }
	
	                // Adjust offset based on scroll
	                if (scrollOffset) {
	                    if (_dragOffset.top === 0) {
	                        _ty = _ty - document.body.scrollTop;
	                    } else if (_dragOffset.top > 0) {
	                        _ty = _ty - document.body.scrollTop + 2 * _dragOffset.top;
	                    }
	                }
	
	                moveElement(_tx, _ty);
	
	                $rootScope.$broadcast('draggable:move', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data, uid: _myid });
	            };
	
	            var onrelease = function onrelease(evt) {
	                if (!_dragEnabled) return;
	                evt.preventDefault();
	                $rootScope.$broadcast('draggable:end', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data, callback: onDragComplete, uid: _myid });
	                element.removeClass('dragging');
	                element.parent().find('.drag-enter').removeClass('drag-enter');
	                reset();
	                $document.off(_moveEvents, onmove);
	                $document.off(_releaseEvents, onrelease);
	                _deregisterRootMoveListener();
	            };
	
	            var onDragComplete = function onDragComplete(evt) {
	                if (!onDragSuccessCallback) return;
	
	                scope.$apply(function () {
	                    onDragSuccessCallback(scope, { $data: _data, $event: evt });
	                });
	            };
	
	            var reset = function reset() {
	                if (allowTransform) element.css({ transform: '', 'z-index': '', '-webkit-transform': '', '-ms-transform': '' });else element.css({ 'position': '', top: '', left: '' });
	            };
	
	            var moveElement = function moveElement(x, y) {
	                if (allowTransform) {
	                    element.css({
	                        transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
	                        'z-index': 99999,
	                        '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
	                        '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
	                    });
	                } else {
	                    element.css({ 'left': x + 'px', 'top': y + 'px', 'position': 'fixed' });
	                }
	            };
	            initialize();
	        }
	    };
	}]).directive('ngDrop', ['$parse', '$timeout', '$window', '$document', 'ngDraggable', function ($parse, $timeout, $window, $document, ngDraggable) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            scope.value = attrs.ngDrop;
	            scope.isTouching = false;
	
	            var _lastDropTouch = null;
	
	            var _myid = scope.$id;
	
	            var _dropEnabled = false;
	
	            var onDropCallback = $parse(attrs.ngDropSuccess); // || function(){};
	
	            var onDragStartCallback = $parse(attrs.ngDragStart);
	            var onDragStopCallback = $parse(attrs.ngDragStop);
	            var onDragMoveCallback = $parse(attrs.ngDragMove);
	
	            var initialize = function initialize() {
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                // remove listeners
	
	                if (!enable) return;
	                // add listeners.
	                scope.$watch(attrs.ngDrop, onEnableChange);
	                scope.$on('$destroy', onDestroy);
	                scope.$on('draggable:start', onDragStart);
	                scope.$on('draggable:move', onDragMove);
	                scope.$on('draggable:end', onDragEnd);
	            };
	
	            var onDestroy = function onDestroy(enable) {
	                toggleListeners(false);
	            };
	            var onEnableChange = function onEnableChange(newVal, oldVal) {
	                _dropEnabled = newVal;
	            };
	            var onDragStart = function onDragStart(evt, obj) {
	                if (!_dropEnabled) return;
	                isTouching(obj.x, obj.y, obj.element);
	
	                if (attrs.ngDragStart) {
	                    $timeout(function () {
	                        onDragStartCallback(scope, { $data: obj.data, $event: obj });
	                    });
	                }
	            };
	            var onDragMove = function onDragMove(evt, obj) {
	                if (!_dropEnabled) return;
	                isTouching(obj.x, obj.y, obj.element);
	
	                if (attrs.ngDragMove) {
	                    $timeout(function () {
	                        onDragMoveCallback(scope, { $data: obj.data, $event: obj });
	                    });
	                }
	            };
	
	            var onDragEnd = function onDragEnd(evt, obj) {
	
	                // don't listen to drop events if this is the element being dragged
	                // only update the styles and return
	                if (!_dropEnabled || _myid === obj.uid) {
	                    updateDragStyles(false, obj.element);
	                    return;
	                }
	                if (isTouching(obj.x, obj.y, obj.element)) {
	                    // call the ngDraggable ngDragSuccess element callback
	                    if (obj.callback) {
	                        obj.callback(obj);
	                    }
	
	                    if (attrs.ngDropSuccess) {
	                        $timeout(function () {
	                            onDropCallback(scope, { $data: obj.data, $event: obj, $target: scope.$eval(scope.value) });
	                        });
	                    }
	                }
	
	                if (attrs.ngDragStop) {
	                    $timeout(function () {
	                        onDragStopCallback(scope, { $data: obj.data, $event: obj });
	                    });
	                }
	
	                updateDragStyles(false, obj.element);
	            };
	
	            var isTouching = function isTouching(mouseX, mouseY, dragElement) {
	                var touching = hitTest(mouseX, mouseY);
	                scope.isTouching = touching;
	                if (touching) {
	                    _lastDropTouch = element;
	                }
	                updateDragStyles(touching, dragElement);
	                return touching;
	            };
	
	            var updateDragStyles = function updateDragStyles(touching, dragElement) {
	                if (touching) {
	                    element.addClass('drag-enter');
	                    dragElement.addClass('drag-over');
	                } else if (_lastDropTouch == element) {
	                    _lastDropTouch = null;
	                    element.removeClass('drag-enter');
	                    dragElement.removeClass('drag-over');
	                }
	            };
	
	            var hitTest = function hitTest(x, y) {
	                var bounds = element[0].getBoundingClientRect(); // ngDraggable.getPrivOffset(element);
	                x -= $document[0].body.scrollLeft + $document[0].documentElement.scrollLeft;
	                y -= $document[0].body.scrollTop + $document[0].documentElement.scrollTop;
	                return x >= bounds.left && x <= bounds.right && y <= bounds.bottom && y >= bounds.top;
	            };
	
	            initialize();
	        }
	    };
	}]).directive('ngDragClone', ['$parse', '$timeout', 'ngDraggable', function ($parse, $timeout, ngDraggable) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var img,
	                _allowClone = true;
	            var _dragOffset = null;
	            scope.clonedData = {};
	            var initialize = function initialize() {
	
	                img = element.find('img');
	                element.attr('draggable', 'false');
	                img.attr('draggable', 'false');
	                reset();
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                // remove listeners
	
	                if (!enable) return;
	                // add listeners.
	                scope.$on('draggable:start', onDragStart);
	                scope.$on('draggable:move', onDragMove);
	                scope.$on('draggable:end', onDragEnd);
	                preventContextMenu();
	            };
	            var preventContextMenu = function preventContextMenu() {
	                //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	                img.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	                //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	                img.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	            };
	            var onDragStart = function onDragStart(evt, obj, elm) {
	                _allowClone = true;
	                if (_angular2['default'].isDefined(obj.data.allowClone)) {
	                    _allowClone = obj.data.allowClone;
	                }
	                if (_allowClone) {
	                    scope.$apply(function () {
	                        scope.clonedData = obj.data;
	                    });
	                    element.css('width', obj.element[0].offsetWidth);
	                    element.css('height', obj.element[0].offsetHeight);
	
	                    moveElement(obj.tx, obj.ty);
	                }
	
	                _dragOffset = element[0].getBoundingClientRect(); //ngDraggable.getPrivOffset(element);
	            };
	            var onDragMove = function onDragMove(evt, obj) {
	                if (_allowClone) {
	
	                    _tx = obj.tx + _dragOffset.left;
	                    _ty = obj.ty + _dragOffset.top;
	
	                    moveElement(_tx, _ty);
	                }
	            };
	            var onDragEnd = function onDragEnd(evt, obj) {
	                //moveElement(obj.tx,obj.ty);
	                if (_allowClone) {
	                    reset();
	                }
	            };
	
	            var reset = function reset() {
	                element.css({ left: 0, top: 0, position: 'fixed', 'z-index': -1, visibility: 'hidden' });
	            };
	            var moveElement = function moveElement(x, y) {
	                element.css({
	                    transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)', 'z-index': 99999, 'visibility': 'visible',
	                    '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
	                    '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
	                    //,margin: '0'  don't monkey with the margin,
	                });
	            };
	
	            var absorbEvent_ = function absorbEvent_(event) {
	                var e = event; //.originalEvent;
	                e.preventDefault && e.preventDefault();
	                e.stopPropagation && e.stopPropagation();
	                e.cancelBubble = true;
	                e.returnValue = false;
	                return false;
	            };
	
	            initialize();
	        }
	    };
	}]).directive('ngPreventDrag', ['$parse', '$timeout', function ($parse, $timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var initialize = function initialize() {
	
	                element.attr('draggable', 'false');
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                // remove listeners
	
	                if (!enable) return;
	                // add listeners.
	                element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	            };
	
	            var absorbEvent_ = function absorbEvent_(event) {
	                var e = event.originalEvent;
	                e.preventDefault && e.preventDefault();
	                e.stopPropagation && e.stopPropagation();
	                e.cancelBubble = true;
	                e.returnValue = false;
	                return false;
	            };
	
	            initialize();
	        }
	    };
	}]).directive('ngCancelDrag', [function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.find('*').attr('ng-cancel-drag', 'ng-cancel-drag');
	        }
	    };
	}]).directive('ngDragScroll', ['$window', '$interval', '$timeout', '$document', '$rootScope', function ($window, $interval, $timeout, $document, $rootScope) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var intervalPromise = null;
	            var lastMouseEvent = null;
	
	            var config = {
	                verticalScroll: attrs.verticalScroll || true,
	                horizontalScroll: attrs.horizontalScroll || true,
	                activationDistance: attrs.activationDistance || 75,
	                scrollDistance: attrs.scrollDistance || 15
	            };
	
	            var reqAnimFrame = (function () {
	                return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function ( /* function FrameRequestCallback */callback, /* DOMElement Element */element) {
	                    window.setTimeout(callback, 1000 / 60);
	                };
	            })();
	
	            var animationIsOn = false;
	            var createInterval = function createInterval() {
	                animationIsOn = true;
	
	                function nextFrame(callback) {
	                    var args = Array.prototype.slice.call(arguments);
	                    if (animationIsOn) {
	                        reqAnimFrame(function () {
	                            $rootScope.$apply(function () {
	                                callback.apply(null, args);
	                                nextFrame(callback);
	                            });
	                        });
	                    }
	                }
	
	                nextFrame(function () {
	                    if (!lastMouseEvent) return;
	
	                    var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	                    var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	
	                    var scrollX = 0;
	                    var scrollY = 0;
	
	                    if (config.horizontalScroll) {
	                        // If horizontal scrolling is active.
	                        if (lastMouseEvent.clientX < config.activationDistance) {
	                            // If the mouse is on the left of the viewport within the activation distance.
	                            scrollX = -config.scrollDistance;
	                        } else if (lastMouseEvent.clientX > viewportWidth - config.activationDistance) {
	                            // If the mouse is on the right of the viewport within the activation distance.
	                            scrollX = config.scrollDistance;
	                        }
	                    }
	
	                    if (config.verticalScroll) {
	                        // If vertical scrolling is active.
	                        if (lastMouseEvent.clientY < config.activationDistance) {
	                            // If the mouse is on the top of the viewport within the activation distance.
	                            scrollY = -config.scrollDistance;
	                        } else if (lastMouseEvent.clientY > viewportHeight - config.activationDistance) {
	                            // If the mouse is on the bottom of the viewport within the activation distance.
	                            scrollY = config.scrollDistance;
	                        }
	                    }
	
	                    if (scrollX !== 0 || scrollY !== 0) {
	                        // Record the current scroll position.
	                        var currentScrollLeft = $window.pageXOffset || $document[0].documentElement.scrollLeft;
	                        var currentScrollTop = $window.pageYOffset || $document[0].documentElement.scrollTop;
	
	                        // Remove the transformation from the element, scroll the window by the scroll distance
	                        // record how far we scrolled, then reapply the element transformation.
	                        var elementTransform = element.css('transform');
	                        element.css('transform', 'initial');
	
	                        $window.scrollBy(scrollX, scrollY);
	
	                        var horizontalScrollAmount = ($window.pageXOffset || $document[0].documentElement.scrollLeft) - currentScrollLeft;
	                        var verticalScrollAmount = ($window.pageYOffset || $document[0].documentElement.scrollTop) - currentScrollTop;
	
	                        element.css('transform', elementTransform);
	
	                        lastMouseEvent.pageX += horizontalScrollAmount;
	                        lastMouseEvent.pageY += verticalScrollAmount;
	
	                        $rootScope.$emit('draggable:_triggerHandlerMove', lastMouseEvent);
	                    }
	                });
	            };
	
	            var clearInterval = function clearInterval() {
	                animationIsOn = false;
	            };
	
	            scope.$on('draggable:start', function (event, obj) {
	                // Ignore this event if it's not for this element.
	                if (obj.element[0] !== element[0]) return;
	
	                if (!animationIsOn) createInterval();
	            });
	
	            scope.$on('draggable:end', function (event, obj) {
	                // Ignore this event if it's not for this element.
	                if (obj.element[0] !== element[0]) return;
	
	                if (animationIsOn) clearInterval();
	            });
	
	            scope.$on('draggable:move', function (event, obj) {
	                // Ignore this event if it's not for this element.
	                if (obj.element[0] !== element[0]) return;
	
	                lastMouseEvent = obj.event;
	            });
	        }
	    };
	}]);
	
	exports.ngDraggable = ngDraggable;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loggerJs = __webpack_require__(502);
	
	var _module = _angular2['default'].module('logger', []);
	
	_module.service('logger', ['$filter', function ($filter) {
	    return {
	        error: function error(title, data) {
	            _loggerJs.logger.error(title, $filter('json')(data));
	        }
	    };
	}]);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _swalSwalJs = __webpack_require__(503);
	
	var _swalSwalJs2 = _interopRequireDefault(_swalSwalJs);
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function error(title, data) {
	    var html = '<pre style="text-align: left">' + data + '</pre>';
	    (0, _swalSwalJs2['default'])({
	        title: title,
	        text: html,
	        html: true,
	        type: 'error'
	    });
	}
	
	function info(message, data, title) {
	    toastr.info(message, title);
	    // $log.info('Info: ' + title, data);
	}
	
	function success(message, data, title) {
	    toastr.success(message, title);
	    // $log.info('Success: ' + title, data);
	}
	
	function warning(message, data, title) {
	    toastr.warning(message, title);
	    // $log.warn('Warning: ' + title, data);
	}
	
	var logger = {
	
	    error: error,
	    info: info,
	    success: success,
	    warning: warning
	};
	
	exports.logger = logger;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _sweetalert = __webpack_require__(459);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	exports['default'] = function () {
	    var previousWindowKeyDown = window.onkeydown;
	    _sweetalert2['default'].apply(this, Array.prototype.slice.call(arguments, 0));
	    window.onkeydown = previousWindowKeyDown;
	};
	
	module.exports = exports['default'];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loadingComponentJs = __webpack_require__(505);
	
	var loading = _angular2['default'].module('loading', []);
	
	loading.component('loading', _loadingComponentJs.LoadingComponent);
	
	exports.loading = loading;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _loadingHtml = __webpack_require__(506);
	
	var _loadingHtml2 = _interopRequireDefault(_loadingHtml);
	
	var LoadingController = function LoadingController() {
	    _classCallCheck(this, LoadingController);
	};
	
	LoadingController.$inject = [];
	
	var LoadingComponent = {
	    restrict: 'E',
	    templateUrl: _loadingHtml2['default'],
	    controller: LoadingController,
	    controllerAs: 'vm',
	    bindings: {
	        isLoading: '<',
	        message: '@'
	    }
	};
	
	exports.LoadingComponent = LoadingComponent;
	exports.LoadingController = LoadingController;

/***/ },
/* 506 */
/***/ function(module, exports) {

	var path = 'app/components/common/loading/loading.html';
	var html = "<div class=\"row\" ng-if=\"vm.isLoading\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"col-lg-12 text-center\"><span>{{vm.message}}</span></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _qrModalComponentJs = __webpack_require__(508);
	
	var _qrCodeScanComponentJs = __webpack_require__(510);
	
	var qrScanner = _angular2['default'].module('qrScanner', []);
	qrScanner.component('modalQr', _qrModalComponentJs.ModalQrFormComponent);
	qrScanner.component('qrScan', _qrCodeScanComponentJs.QrCodeScanComponent);
	
	exports.qrScanner = qrScanner;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _qrModalHtml = __webpack_require__(509);
	
	var _qrModalHtml2 = _interopRequireDefault(_qrModalHtml);
	
	var ModalFormController = (function () {
	    function ModalFormController() {
	        _classCallCheck(this, ModalFormController);
	    }
	
	    _createClass(ModalFormController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }, {
	        key: 'onQrCode',
	        value: function onQrCode(content) {
	            this.close({ $value: content });
	        }
	    }]);
	
	    return ModalFormController;
	})();
	
	var ModalQrFormComponent = {
	    restrict: 'E',
	    templateUrl: _qrModalHtml2['default'],
	    controller: ModalFormController,
	    controllerAs: 'vm',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    }
	};
	
	exports.ModalQrFormComponent = ModalQrFormComponent;

/***/ },
/* 509 */
/***/ function(module, exports) {

	var path = 'app/components/common/qrCodeScanner/qrModal.html';
	var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header\"><h5 class=\"modal-title\">Title</h5></div><div class=\"modal-body\"><div class=\"hpanel stats\"><div class=\"panel-body list\"><qr-scan on-data=\"vm.onQrCode(content)\"></qr-scan></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _qrCodeScanHtml = __webpack_require__(511);
	
	var _qrCodeScanHtml2 = _interopRequireDefault(_qrCodeScanHtml);
	
	var QrCodeScanController = (function () {
	    function QrCodeScanController($q) {
	        _classCallCheck(this, QrCodeScanController);
	
	        this.$q = function () {
	            return $q;
	        };
	    }
	
	    _createClass(QrCodeScanController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.scanner = new Instascan.Scanner({ video: document.getElementById('preview') });
	            this.scanner.addListener('scan', function (content) {
	                _this.onData({ content: content });
	            });
	            Instascan.Camera.getCameras().then(function (cameras) {
	                _this.cameras = cameras;
	                if (cameras.length > 0) {
	                    _this.activeCameraId = cameras[0].id;
	                    _this.scanner.start(cameras[0]);
	                } else {
	                    console.error('No cameras found.');
	                }
	            })['catch'](function (e) {
	                console.error(e);
	            });
	        }
	    }, {
	        key: 'selectCamera',
	        value: function selectCamera(camera) {
	            var _this2 = this;
	
	            var $q = this.$q();
	            this.scanner.stop().then(function () {
	                $q.when(_this2.scanner.start(camera)).then(function () {
	                    _this2.activeCameraId = camera.id;
	                });
	            });
	        }
	    }, {
	        key: 'formatName',
	        value: function formatName(camera) {
	            return camera.name || '(unknown)';
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.scanner.stop().then(function () {
	                console.log('Scan stoped');
	            });
	        }
	    }]);
	
	    return QrCodeScanController;
	})();
	
	QrCodeScanController.$inject = ['$q'];
	
	var QrCodeScanComponent = {
	    restrict: 'E',
	    templateUrl: _qrCodeScanHtml2['default'],
	    controller: QrCodeScanController,
	    controllerAs: 'vm',
	    bindings: {
	        onData: '&'
	    }
	};
	
	exports.QrCodeScanComponent = QrCodeScanComponent;
	exports.QrCodeScanController = QrCodeScanController;

/***/ },
/* 511 */
/***/ function(module, exports) {

	var path = 'app/components/common/qrCodeScanner/qrCodeScan.html';
	var html = "<video id=\"preview\" autoplay class=\"active\" style=\"transform: scaleX(-1);\"></video><section class=\"cameras\"><h2>Pronađene kamere</h2><ul><li ng-if=\"vm.cameras.length === 0\" class=\"empty\">No cameras found</li><li ng-repeat=\"camera in vm.cameras\"><span ng-if=\"camera.id == vm.activeCameraId\" title=\"vm.formatName(camera)\" class=\"active\">{{ vm.formatName(camera) }}</span> <span ng-if=\"camera.id != vm.activeCameraId\" title=\"vm.formatName(camera)\"><a ng-click=\"vm.selectCamera(camera)\">{{ vm.formatName(camera) }}</a></span></li></ul></section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(513);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _dashboardComponentJs = __webpack_require__(519);
	
	var _komentarWidgetComponentJs = __webpack_require__(525);
	
	var _animateFazeDirectiveJs = __webpack_require__(527);
	
	var _animateFazeDirectiveJs2 = _interopRequireDefault(_animateFazeDirectiveJs);
	
	var _heatCalendarDirectiveJs = __webpack_require__(528);
	
	var dashboard = _angular2['default'].module('dashboard', [_angularUiBootstrapSrcModal2['default']]);
	
	dashboard.component('dashboard', _dashboardComponentJs.DashboardComponent);
	dashboard.component('komentarWidget', _komentarWidgetComponentJs.KomentarWidgetComponent);
	dashboard.directive('animateFaze', _animateFazeDirectiveJs2['default']);
	dashboard.directive('heatCalendar', _heatCalendarDirectiveJs.heatCalendar);
	
	exports.dashboard = dashboard;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(170);
	module.exports = __webpack_require__(514);


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(515);
	__webpack_require__(175);
	__webpack_require__(177);
	__webpack_require__(517);
	__webpack_require__(518);
	
	var MODULE_NAME = 'ui.bootstrap.module.modal';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(516);


/***/ },
/* 516 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  });


/***/ },
/* 517 */
/***/ function(module, exports) {

	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/modal/window.html",
	    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "");
	}]);


/***/ },
/* 518 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	  .provider('$uibResolve', function() {
	    var resolve = this;
	    this.resolver = null;
	
	    this.setResolver = function(resolver) {
	      this.resolver = resolver;
	    };
	
	    this.$get = ['$injector', '$q', function($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }
	
	          var promises = [];
	
	          angular.forEach(invocables, function(value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });
	
	          return $q.all(promises).then(function(resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function(value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });
	
	            return resolveObj;
	          });
	        }
	      };
	    }];
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
	  function($animate, $injector, $modalStack) {
	    return {
	      restrict: 'A',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animate.addClass(element, attrs.modalInClass);
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
	  function($modalStack, $q, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@'
	      },
	      restrict: 'A',
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	            modal.value.backdrop !== 'static' &&
	            evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is rendered.
	        var modalRenderDeferObj = $q.defer();
	        // Resolve render promise post-digest
	        scope.$$postDigest(function() {
	          modalRenderDeferObj.resolve();
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	
	            /**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus) then there's no need to try to focus anything.
	             */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function(clone) {
	          element.empty();
	          $animate.enter(clone, element);
	        });
	      }
	    };
	  }])
	
	  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
	    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	      var topModalIndex = 0;
	      var previousTopOpenedModal = null;
	      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	      //Modal focus behavior
	      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
	        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
	        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	      var scrollbarPadding;
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	      // TODO: extract into common dependency with tooltip
	      function snake_case(name) {
	        var separator = '-';
	        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	          return (pos ? separator : '') + letter.toLowerCase();
	        });
	      }
	
	      function isVisible(element) {
	        return !!(element.offsetWidth ||
	          element.offsetHeight ||
	          element.getClientRects().length);
	      }
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	
	        // If any backdrop exist, ensure that it's index is always
	        // right below the top modal
	        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	          topBackdropIndex = topModalIndex;
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        var appendToElement = modalWindow.appendTo;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	        previousTopOpenedModal = openedWindows.top();
	        if (previousTopOpenedModal) {
	          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	        }
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	            if (scrollbarPadding.originalRight) {
	              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
	            } else {
	              appendToElement.css({paddingRight: ''});
	            }
	            scrollbarPadding = null;
	          }
	          toggleTopWindowClass(true);
	        }, modalWindow.closedDeferred);
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else if (appendToElement.focus) {
	          appendToElement.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          $animate.leave(domEl).then(function() {
	            if (done) {
	              done();
	            }
	
	            domEl.remove();
	            if (closedDeferred) {
	              closedDeferred.resolve();
	            }
	          });
	
	          scope.$destroy();
	        }
	      }
	
	      $document.on('keydown', keydownListener);
	
	      $rootScope.$on('$destroy', function() {
	        $document.off('keydown', keydownListener);
	      });
	
	      function keydownListener(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal) {
	          switch (evt.which) {
	            case 27: {
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function() {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	            case 9: {
	              var list = $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement(list);
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt, list)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement(list);
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        // Store the current top first, to determine what index we ought to use
	        // for the current top modal
	        previousTopOpenedModal = openedWindows.top();
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          closedDeferred: modal.closedDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass,
	          animation: modal.animation,
	          appendTo: modal.appendTo
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var appendToElement = modal.appendTo,
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.modalOptions = modal;
	          backdropScope.index = currBackdropIndex;
	          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          backdropDomEl.attr({
	            'class': 'modal-backdrop',
	            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	            'uib-modal-animation-class': 'fade',
	            'modal-in-class': 'in'
	          });
	          if (modal.backdropClass) {
	            backdropDomEl.addClass(modal.backdropClass);
	          }
	
	          if (modal.animation) {
	            backdropDomEl.attr('modal-animation', 'true');
	          }
	          $compile(backdropDomEl)(backdropScope);
	          $animate.enter(backdropDomEl, appendToElement);
	          if ($uibPosition.isScrollable(appendToElement)) {
	            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
	            }
	          }
	        }
	
	        var content;
	        if (modal.component) {
	          content = document.createElement(snake_case(modal.component.name));
	          content = angular.element(content);
	          content.attr({
	            resolve: '$resolve',
	            'modal-instance': '$uibModalInstance',
	            close: '$close($value)',
	            dismiss: '$dismiss($value)'
	          });
	        } else {
	          content = modal.content;
	        }
	
	        // Set the top modal index based on the index of the previous top modal
	        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'class': 'modal',
	          'template-url': modal.windowTemplateUrl,
	          'window-top-class': modal.windowTopClass,
	          'role': 'dialog',
	          'aria-labelledby': modal.ariaLabelledBy,
	          'aria-describedby': modal.ariaDescribedBy,
	          'size': modal.size,
	          'index': topModalIndex,
	          'animate': 'animate',
	          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	          'tabindex': -1,
	          'uib-modal-animation-class': 'fade',
	          'modal-in-class': 'in'
	        }).append(content);
	        if (modal.windowClass) {
	          angularDomEl.addClass(modal.windowClass);
	        }
	
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        appendToElement.addClass(modalBodyClass);
	        if (modal.scope) {
	          // we need to explicitly add the modal index to the modal scope
	          // because it is needed by ngStyle to compute the zIndex property.
	          modal.scope.$$topModalIndex = topModalIndex;
	        }
	        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	        openedWindows.top().value.modalDomEl = angularDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	
	        applyAriaHidden(angularDomEl);
	
	        function applyAriaHidden(el) {
	          if (!el || el[0].tagName === 'BODY') {
	            return;
	          }
	
	          getSiblings(el).forEach(function(sibling) {
	            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	            if (!ariaHiddenCount) {
	              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	            }
	
	            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	            sibling.setAttribute('aria-hidden', 'true');
	          });
	
	          return applyAriaHidden(el.parent());
	
	          function getSiblings(el) {
	            var children = el.parent() ? el.parent().children() : [];
	
	            return Array.prototype.filter.call(children, function(child) {
	              return child !== el[0];
	            });
	          }
	        }
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      function unhideBackgroundElements() {
	        Array.prototype.forEach.call(
	          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
	          function(hiddenEl) {
	            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	              newHiddenCount = ariaHiddenCount - 1;
	            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	            if (!newHiddenCount) {
	              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	              hiddenEl.removeAttribute('aria-hidden');
	            }
	          }
	        );
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[0].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.focusLastFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[list.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isModalFocused = function(evt, modalWindow) {
	        if (evt && modalWindow) {
	          var modalDomEl = modalWindow.value.modalDomEl;
	          if (modalDomEl && modalDomEl.length) {
	            return (evt.target || evt.srcElement) === modalDomEl[0];
	          }
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[list.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	            return elements ?
	              Array.prototype.filter.call(elements, function(element) {
	                return isVisible(element);
	              }) : elements;
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ?
	                options.templateUrl() : options.templateUrl);
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalClosedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              closed: modalClosedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	            if (!modalOptions.appendTo.length) {
	              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	            }
	
	            //verify options
	            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of component or template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise;
	            if (modalOptions.component) {
	              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	            } else {
	              templateAndResolvePromise =
	                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	            }
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	                var providedScope = modalOptions.scope || $rootScope;
	
	                var modalScope = providedScope.$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var modal = {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  closedDeferred: modalClosedDeferred,
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  ariaLabelledBy: modalOptions.ariaLabelledBy,
	                  ariaDescribedBy: modalOptions.ariaDescribedBy,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass,
	                  appendTo: modalOptions.appendTo
	                };
	
	                var component = {};
	                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};
	
	                if (modalOptions.component) {
	                  constructLocals(component, false, true, false);
	                  component.name = modalOptions.component;
	                  modal.component = component;
	                } else if (modalOptions.controller) {
	                  constructLocals(ctrlLocals, true, false, true);
	
	                  // the third param will make the controller instantiate later,private api
	                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	                  if (modalOptions.controllerAs && modalOptions.bindToController) {
	                    ctrlInstance = ctrlInstantiate.instance;
	                    ctrlInstance.$close = modalScope.$close;
	                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                    angular.extend(ctrlInstance, {
	                      $resolve: ctrlLocals.$scope.$resolve
	                    }, providedScope);
	                  }
	
	                  ctrlInstance = ctrlInstantiate();
	
	                  if (angular.isFunction(ctrlInstance.$onInit)) {
	                    ctrlInstance.$onInit();
	                  }
	                }
	
	                if (!modalOptions.component) {
	                  modal.content = tplAndVars[0];
	                }
	
	                $modalStack.open(modalInstance, modal);
	                modalOpenedDeferred.resolve(true);
	
	                function constructLocals(obj, template, instanceOnScope, injectable) {
	                  obj.$scope = modalScope;
	                  obj.$scope.$resolve = {};
	                  if (instanceOnScope) {
	                    obj.$scope.$uibModalInstance = modalInstance;
	                  } else {
	                    obj.$uibModalInstance = modalInstance;
	                  }
	
	                  var resolves = template ? tplAndVars[1] : tplAndVars;
	                  angular.forEach(resolves, function(value, key) {
	                    if (injectable) {
	                      obj[key] = value;
	                    }
	
	                    obj.$scope.$resolve[key] = value;
	                  });
	                }
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })['finally'](function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboardHtml = __webpack_require__(520);
	
	var _dashboardHtml2 = _interopRequireDefault(_dashboardHtml);
	
	var _dashboardControllerJs = __webpack_require__(521);
	
	exports.DashboardController = _dashboardControllerJs.DashboardController;
	
	var DashboardComponent = {
	    restrict: 'E',
	    templateUrl: _dashboardHtml2['default'],
	    controller: _dashboardControllerJs.DashboardController,
	    controllerAs: 'vm'
	};
	
	exports.DashboardComponent = DashboardComponent;

/***/ },
/* 520 */
/***/ function(module, exports) {

	var path = 'app/components/dashboard/dashboard.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><div class=\"content\" animate-panel effect=\"zoomIn\"><div class=\"row\"><div class=\"col-lg-5\"><div class=\"hpanel\"><div class=\"panel-body\"><heat-calendar date=\"vm.calendarStartDate\" on-change=\"vm.calendarViewChange(year, month)\" on-date-selected=\"vm.dateChange(value)\" heat-data=\"vm.heatData\"></heat-calendar></div></div></div><div class=\"col-lg-7\"><komentar-widget day=\"vm.calendarDate\"></komentar-widget></div></div><div class=\"row\" animate-faze=\"vm.mode\"><div class=\"col-lg-6\"><div class=\"hpanel\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-12\"><h4 class=\"text-success\"><i class=\"fa fa-star\"></i> Novi radni nalozi</h4></div></div><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th>Datum naloga <i class=\"fa fa-sort-down\"></i></th><th class=\"text-center\">Broj naloga</th><th>Pacijent</th><th>Ordinacija</th></tr></thead><tbody><tr ng-repeat=\"item in vm.otvoreniNalozi\"><td data-title=\"Datum naloga\">{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item\"></rn-link></td><td data-title=\"Pacijent\"><strong>{{item.pacijent}}</strong></td><td data-title=\"Ordinacija\"><strong>{{item.ordinacija_naziv}}</strong></td></tr></tbody></table></div></div></div><div class=\"col-lg-6\" id=\"faze-for-day\"><div class=\"hpanel\"><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-8\"><h4><i class=\"fa fa-clock-o\"></i> Probe za dan: <strong class=\"text-success\">{{vm.day|date:\"dd.MM.yyyy\" }}</strong> <a ng-if=\"vm.days.length === 1\" ng-href=\"api/radni_nalozi/fazeNaloga/ispis?datum={{vm.day|date:'yyyy-MM-dd'}}\" target=\"_blank\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-print\"></i> Ispis</a> <a ng-if=\"vm.days.length > 1\" ng-href=\"api/radni_nalozi/fazeNaloga/ispis_tjedan?datum_od={{vm.datum_od}}&datum_do={{vm.datum_do}}\" target=\"_blank\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-print\"></i> Ispis</a></h4></div><div class=\"col-lg-4 text-right\"><a ng-click=\"vm.getForToday()\" class=\"btn btn-xs btn-default\" ng-class=\"{'btn-danger': vm.mode === 'danas'}\">Danas</a> <a ng-click=\"vm.getForNextDay()\" class=\"btn btn-xs btn-default\" ng-class=\"{'btn-danger': vm.mode === 'sutra'}\">Sutra</a> <a ng-click=\"vm.getForWeek()\" class=\"btn btn-xs btn-default\" ng-class=\"{'btn-danger': vm.mode === 'tjedan'}\">Sljedećih 7 dana</a></div></div><faze-for-day days=\"vm.days\" on-click=\"vm.getForDay(day)\"></faze-for-day></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-12\"><h4><i class=\"fa fa-file\"></i> Radni nalozi - u obradi | <a ng-click=\"vm.findByQrCode()\"><i class=\"fa fa-qrcode\" aria-hidden=\"true\"></i></a></h4><hr></div></div><div class=\"table-responsive project-list\"><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum naloga</th><th class=\"col-lg-2 text-center\">Broj naloga</th><th>Pacijent</th><th>Ordinacija</th><th>Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.entries\"><td data-title=\"Datum naloga\">{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item\"></rn-link></td><td data-title=\"Pacijent\">{{item.pacijent}},<br><small><i class=\"fa fa-clock-o\"></i> Status: <strong>{{item.status}}</strong></small></td><td data-title=\"Ordinacija\"><strong>{{item.ordinacija_naziv}}</strong></td><td data-title=\"Akcije\"><a ng-click=\"vm.edit(item)\" title=\"Detalji\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i></a></td></tr></tbody></table></div></div><div class=\"panel-footer\"><a ui-sref=\"radniNalog\" class=\"btn btn-xs btn-success\">Pregled svih radnih naloga</a></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _commonModalControllerJs = __webpack_require__(522);
	
	var _commonFormsLayoutJs = __webpack_require__(523);
	
	var _radniNalogStatusiJs = __webpack_require__(524);
	
	var DashboardController = (function () {
	    function DashboardController($state, AppConfiguration, DS, $uibModal) {
	        _classCallCheck(this, DashboardController);
	
	        var app = AppConfiguration();
	        this.$uibModal = function () {
	            return $uibModal;
	        };
	        this.entityRN = app.getEntity('dashboard');
	        this.fields = this.entityRN.listView().fields();
	        this.datastore = function () {
	            return DS;
	        };
	
	        this.listActions = this.entityRN.listView().listActions();
	        this.$state = $state;
	        this.params = {
	            limit: 10,
	            offset: 0,
	            status: _radniNalogStatusiJs.UOBRADI
	        };
	    }
	
	    _createClass(DashboardController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.calendarDate = (0, _moment2['default'])();
	            this.otvoreniNalozi = [];
	            this.refreshState(this.params);
	            this.getForToday();
	            this.mode = 'danas';
	            this.heatData = {};
	
	            var start = (0, _moment2['default'])([this.calendarDate.year(), this.calendarDate.month(), 1]);
	            var end = (0, _moment2['default'])(start).add(1, 'months').add(-1, 'days');
	            this.getFaze(start, end);
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState(params) {
	            var _this = this;
	
	            var DS = this.datastore();
	            DS.findAll('RadniNalog', { limit: 20, offset: 0, status: _radniNalogStatusiJs.OTVOREN }, { bypassCache: true }).then(function (response) {
	                _this.otvoreniNalozi = response;
	            });
	
	            DS.findAll('Ordinacija').then(function (response) {
	                return DS.findAll('RadniNalog', params, { bypassCache: true });
	            }).then(function (response) {
	                _this.entries = response;
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.$state.go('radniNalog.details', { id: item.id });
	        }
	    }, {
	        key: 'onFilter',
	        value: function onFilter(item) {
	            this.params.search = item;
	            this.refreshState(this.params);
	        }
	    }, {
	        key: 'getFaze',
	        value: function getFaze(start, end) {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            DS.findAll('FazaNaloga', {
	                aktivne: 1,
	                datum_probe_range_0: start.format('YYYY-MM-DD'),
	                datum_probe_range_1: end.format('YYYY-MM-DD')
	            }, { bypassCache: true }).then(function (response) {
	                var faze = {};
	                response.map(function (r) {
	                    if (faze[r.datum_probe] === undefined) {
	                        faze[r.datum_probe] = 1;
	                    } else {
	                        faze[r.datum_probe] = faze[r.datum_probe] + 1;
	                    }
	                });
	                _this2.heatData = faze;
	            });
	        }
	    }, {
	        key: 'calendarViewChange',
	        value: function calendarViewChange(year, month) {
	            var start = (0, _moment2['default'])([year, month, 1]);
	            var end = (0, _moment2['default'])(start).add(1, 'months').add(-1, 'days');
	            this.getFaze(start, end);
	        }
	    }, {
	        key: 'dateChange',
	        value: function dateChange(value) {
	            this.getForDay((0, _moment2['default'])(value).format('YYYY-MM-DD'));
	            this.calendarDate = (0, _moment2['default'])(value);
	        }
	    }, {
	        key: 'getForToday',
	        value: function getForToday() {
	            this.mode = 'danas';
	            this.days = [(0, _moment2['default'])().format('YYYY-MM-DD')];
	            this.day = this.days[0];
	        }
	    }, {
	        key: 'getForNextDay',
	        value: function getForNextDay() {
	            this.mode = 'sutra';
	            this.days = [(0, _moment2['default'])().add(1, 'days').format('YYYY-MM-DD')];
	            this.day = this.days[0];
	        }
	    }, {
	        key: 'getForDay',
	        value: function getForDay(day) {
	            this.mode = 'custom';
	            this.days = [day];
	            this.day = this.days[0];
	        }
	    }, {
	        key: 'getForWeek',
	        value: function getForWeek() {
	            this.mode = 'tjedan';
	            this.days = [(0, _moment2['default'])().format('YYYY-MM-DD'), (0, _moment2['default'])().add(1, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(2, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(3, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(4, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(5, 'days').format('YYYY-MM-DD')];
	            this.day = null;
	            this.datum_od = this.days[0];
	            this.datum_do = this.days[5];
	        }
	    }, {
	        key: 'findByQrCode',
	        value: function findByQrCode() {
	            var _this3 = this;
	
	            var $uibModal = this.$uibModal();
	            var modalInstance = $uibModal.open({
	                size: 'lg',
	                component: 'modalQr'
	            });
	
	            modalInstance.result.then(function (content) {
	                if (_lodash2['default'].isFinite(parseInt(content))) {
	                    _this3.edit({ id: content });
	                }
	            });
	        }
	    }]);
	
	    return DashboardController;
	})();
	
	DashboardController.$inject = ['$state', 'AppConfiguration', 'DS', '$uibModal'];
	
	exports.DashboardController = DashboardController;

/***/ },
/* 522 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ModalController = (function () {
	    function ModalController($uibModalInstance, model) {
	        _classCallCheck(this, ModalController);
	
	        this.uibModalInstance = $uibModalInstance;
	        this.model = model;
	    }
	
	    _createClass(ModalController, [{
	        key: 'submit',
	        value: function submit(model) {
	            this.uibModalInstance.close(model);
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.uibModalInstance.dismiss();
	        }
	    }]);
	
	    return ModalController;
	})();
	
	ModalController.$inject = ['$uibModalInstance', 'model'];
	
	exports.ModalController = ModalController;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function Div(cssClass, fields) {
	    var fieldsArray = _lodash2['default'].castArray(fields);
	    return {
	        wrapper: 'div',
	        templateOptions: {
	            className: cssClass
	        },
	        fieldGroup: fieldsArray || []
	    };
	}
	
	function Fieldset(legend, fields) {
	    var fieldsArray = _lodash2['default'].castArray(fields);
	    return {
	        wrapper: 'fieldset',
	        templateOptions: {
	            label: legend
	        },
	        fieldGroup: fieldsArray || []
	    };
	}
	
	function Row(columns) {
	    return Div('row', columns);
	}
	
	var Column2 = _lodash2['default'].partial(Div, 'col-lg-2');
	var Column3 = _lodash2['default'].partial(Div, 'col-lg-3');
	var Column4 = _lodash2['default'].partial(Div, 'col-lg-4');
	var Column5 = _lodash2['default'].partial(Div, 'col-lg-5');
	var Column6 = _lodash2['default'].partial(Div, 'col-lg-6');
	var Column7 = _lodash2['default'].partial(Div, 'col-lg-7');
	var Column8 = _lodash2['default'].partial(Div, 'col-lg-8');
	var Column9 = _lodash2['default'].partial(Div, 'col-lg-9');
	var Column10 = _lodash2['default'].partial(Div, 'col-lg-10');
	var Column11 = _lodash2['default'].partial(Div, 'col-lg-11');
	var Column12 = _lodash2['default'].partial(Div, 'col-lg-12');
	
	exports.Div = Div;
	exports.Row = Row;
	exports.Fieldset = Fieldset;
	exports.Column2 = Column2;
	exports.Column3 = Column3;
	exports.Column4 = Column4;
	exports.Column5 = Column5;
	exports.Column6 = Column6;
	exports.Column7 = Column7;
	exports.Column8 = Column8;
	exports.Column9 = Column9;
	exports.Column10 = Column10;
	exports.Column11 = Column11;
	exports.Column12 = Column12;

/***/ },
/* 524 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var OTVOREN = 'Otvoren';
	exports.OTVOREN = OTVOREN;
	var UOBRADI = 'U obradi';
	exports.UOBRADI = UOBRADI;
	var ZAKLJUCAN = 'Zaključan';
	exports.ZAKLJUCAN = ZAKLJUCAN;
	var STORNIRAN = 'Storniran';
	exports.STORNIRAN = STORNIRAN;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _komentarWidgetHtml = __webpack_require__(526);
	
	var _komentarWidgetHtml2 = _interopRequireDefault(_komentarWidgetHtml);
	
	var KomentarWidgetController = (function () {
	    function KomentarWidgetController(DS) {
	        _classCallCheck(this, KomentarWidgetController);
	
	        this.datastore = function () {
	            return DS;
	        };
	    }
	
	    _createClass(KomentarWidgetController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.komentari = [];
	            this.day = (0, _moment2['default'])();
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges() {
	            this.fetch();
	        }
	    }, {
	        key: 'getDayOfWeek',
	        value: function getDayOfWeek(day) {
	            return (0, _moment2['default'])(day).format('ddd');
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var _this = this;
	
	            var DS = this.datastore();
	            var Komentar = DS.definitions['Komentar'];
	
	            Komentar.findAll({ created_at: this.day.format('YYYY-MM-DD') }, { bypassCache: true }).then(function (response) {
	                _this.komentari = [].concat(_toConsumableArray(response));
	            });
	        }
	    }]);
	
	    return KomentarWidgetController;
	})();
	
	KomentarWidgetController.$inject = ['DS'];
	
	var KomentarWidgetComponent = {
	    restrict: 'E',
	    templateUrl: _komentarWidgetHtml2['default'],
	    controller: KomentarWidgetController,
	    controllerAs: 'vm',
	    bindings: {
	        day: '<'
	    }
	};
	
	exports.KomentarWidgetComponent = KomentarWidgetComponent;
	exports.KomentarWidgetController = KomentarWidgetController;

/***/ },
/* 526 */
/***/ function(module, exports) {

	var path = 'app/components/dashboard/komentarWidget.html';
	var html = "<div class=\"hpanel forum-box\"><div class=\"panel-heading\"><span class=\"f\">Komentari na dan <span class=\"text-success\">{{vm.day.format('ddd DD.MM.YYYY')}}</span></span></div><div class=\"komentari\"><div class=\"panel-body\" ng-repeat=\"komentar in vm.komentari\"><div class=\"media\"><div class=\"media-image pull-left\"><div class=\"author-info\"><strong>{{komentar.sender}}</strong><br><small style=\"text-transform: capitalize;\">{{vm.getDayOfWeek(komentar.created_at)}} {{komentar.created_at | date: 'dd.MM.yyyy'}}</small><br><small>{{komentar.created_at | date: 'HH:mm'}}</small></div></div><div class=\"media-body\"><i>{{komentar.poruka}}</i></div></div></div><div class=\"panel-body\" ng-if=\"vm.komentari.length === 0\"><span>Nema komentara</span></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = animateFaze;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function animateFaze($timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, iElement, iAttrs) {
	            var element = (0, _jquery2['default'])('#faze-for-day');
	            var row = (0, _jquery2['default'])('.content');
	            var cssClasses = [];
	
	            row.children().each(function (i, c) {
	                cssClasses.push((0, _jquery2['default'])(c).attr('class'));
	            });
	
	            function restoreCssClasses() {
	                row.children().each(function (i, c) {
	                    (0, _jquery2['default'])(c).attr('class', cssClasses[i]);
	                });
	            }
	
	            function zoomOut() {
	                row.children().addClass('animated-panel').removeClass('zoomIn').addClass('zoomOut');
	            }
	
	            function zoomIn() {
	                row.children().addClass('animated-panel').removeClass('zoomOut').addClass('zoomIn');
	            }
	
	            scope.$watch('vm.days.length', function (newVal, oldVal) {
	                if (oldVal !== newVal) {
	                    if (newVal > 1) {
	                        zoomOut();
	                        $timeout(function () {
	                            element.siblings().addClass('hide');
	                            element.attr('class', 'col-lg-12');
	                            zoomIn();
	                        }, 400);
	                    } else {
	                        restoreCssClasses();
	                        zoomOut();
	                        $timeout(function () {
	                            restoreCssClasses();
	                            element.siblings().removeClass('hide');
	                            element.attr('class', 'col-lg-6');
	                            zoomIn();
	                        }, 400);
	                    }
	                    $timeout(function () {
	                        restoreCssClasses();
	                    }, 1000);
	                }
	            });
	        }
	    };
	}
	
	animateFaze.$inject = ['$timeout'];
	module.exports = exports['default'];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentRange = __webpack_require__(529);
	
	var _d3 = __webpack_require__(530);
	
	var d3 = _interopRequireWildcard(_d3);
	
	var _heatCalendarHtml = __webpack_require__(562);
	
	var _heatCalendarHtml2 = _interopRequireDefault(_heatCalendarHtml);
	
	__webpack_require__(563);
	
	var moment = (0, _momentRange.extendMoment)(_moment2['default']);
	
	function drawCalendar(year, month, selectedDate) {}
	
	function heatCalendar($document, $element) {
	    var controller = ['$scope', '$timeout', '$q', 'DS', function ($scope, $timeout, $q, DS) {
	        $scope.selectedDate = moment($scope.date);
	        $scope.currentDate = moment($scope.date);
	        $scope.komentari = [];
	        // debugger;
	
	        var months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	
	        $scope.months = months.map(function (m) {
	            return moment([$scope.currentDate.year(), m]);
	        });
	
	        $scope.drawCalendar = function () {
	            var date = moment([$scope.currentDate.year(), $scope.currentDate.month(), 1]);
	
	            var start = date.format('YYYY-MM-DD');
	            var end = date.add(1, 'months').add(-1, 'days').format('YYYY-MM-DD');
	
	            var range = moment.range(start, end);
	            var data = Array.from(range.by('day')).map(function (r) {
	                return { date: r };
	            });
	
	            if (_.isObject($scope.heatData)) {
	                data.map(function (d) {
	                    d.heatIndex = $scope.heatData[d.date.format('YYYY-MM-DD')];
	                });
	            }
	
	            $scope.draw(data);
	        };
	
	        $scope.changeMonth = function (m) {
	            $scope.currentDate.month(m.month());
	            $scope.onChange({ year: $scope.currentDate.year(), month: $scope.currentDate.month() });
	            $scope.drawCalendar();
	        };
	
	        $scope.changeYear = function (y) {
	            var year = $scope.currentDate.year() + y;
	            $scope.currentDate.year(year);
	            $scope.onChange({ year: $scope.currentDate.year(), month: $scope.currentDate.month() });
	            $scope.drawCalendar();
	        };
	
	        $scope.onSelectDate = function (d) {
	            $timeout(function () {
	                $scope.selectedDate = moment(d.date);
	                $scope.drawCalendar();
	                $scope.onDateSelected({ value: moment(d.date) });
	            });
	        };
	    }];
	
	    return {
	        restrict: 'E',
	        scope: {
	            date: '<',
	            heatData: '<',
	            onDateSelected: '&',
	            onChange: '&'
	        },
	        templateUrl: _heatCalendarHtml2['default'],
	        controller: controller,
	        link: function link(scope, iElement, attrs) {
	            var d = d3;
	            var m = moment;
	            var rootElement = iElement[0];
	
	            var svg = d3.select('#calendar').append('svg');
	
	            svg.attr('width', '100%');
	            svg.attr('height', '100%');
	            svg.attr('viewBox', '0 0 350 150');
	
	            var isSelectedDate = function isSelectedDate(d) {
	                if (d.year() === scope.selectedDate.year() && d.month() === scope.selectedDate.month() && d.date() === scope.selectedDate.date()) {
	                    return true;
	                }
	                return false;
	            };
	
	            scope.draw = function (data) {
	                var startColor = d3.rgb('#ffffff');
	                var endColor = d3.rgb('#a30010');
	                var length = 10;
	                var color = d3.scaleLinear().domain([0, length]).range([startColor, endColor]);
	
	                svg.selectAll('g').remove();
	
	                var margin = { top: 49, right: 20, bottom: 20, left: 19 },
	                    cellWidth = 50,
	                    cellHeight = 25;
	
	                var day = d3.timeFormat('%w'),
	                    week = d3.timeFormat('%U'),
	                    percent = d3.format('.1%'),
	                    format = d3.timeFormat('%d'),
	                    monthName = d3.timeFormat('%B');
	
	                var days = svg.selectAll('g').data(data);
	
	                var dayGroups = days.enter().append('g').attr('transform', function (d, i) {
	                    var startOfMonth = moment([d.date.year(), d.date.month(), 1]);
	                    var x = day(d.date) * cellWidth;
	                    var y = (week(d.date) - week(startOfMonth)) * cellHeight + cellHeight;
	                    return 'translate(' + x + ', ' + y + ')';
	                }).attr('class', function (d) {
	                    if (isSelectedDate(d.date)) {
	                        return 'selected';
	                    }
	                });
	
	                dayGroups.append('rect').attr('width', cellWidth).attr('height', cellHeight).attr('fill', function (d) {
	                    return color(d.heatIndex || 0);
	                });
	
	                var circle = svg.select('.selected').append('circle').attr('r', cellHeight / 2 - 1).attr('cx', cellWidth / 2).attr('cy', cellHeight / 2);
	
	                dayGroups.append('text').text(function (d, i) {
	                    return d.date.format('DD');
	                }).attr('text-anchor', 'middle').attr('class', 'num-dates').attr('x', cellWidth / 2).attr('y', (cellHeight + 10) / 2).on('click', function (d) {
	                    scope.onSelectDate(d);
	                });
	
	                var labels = svg.append('g').selectAll('text').data(['NED', 'PON', 'UTO', 'SRI', 'ČET', 'PET', 'SUB']).enter().append('text').text(function (d, i) {
	                    return d;
	                }).attr('x', function (d, i) {
	                    return (i + 0.5) * cellWidth;
	                }).attr('y', cellHeight / 2).attr('text-anchor', 'middle').attr('class', 'days');
	            };
	
	            scope.$watch('heatData', function (newVal, oldVal) {
	                scope.drawCalendar();
	            });
	        }
	    };
	}
	
	heatCalendar.$inject = ['$document', '$timeout'];
	
	exports.heatCalendar = heatCalendar;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(216)):"function"==typeof define&&define.amd?define("moment-range",["moment"],e):"object"==typeof exports?exports["moment-range"]=e(require("moment")):t["moment-range"]=e(t.moment)}(this,function(t){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=3)}([function(t,e,n){"use strict";var r=n(5)();t.exports=function(t){return t!==r&&null!==t}},function(t,e,n){"use strict";t.exports=n(18)()?Symbol:n(20)},function(e,n){e.exports=t},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t){return t.range=function(e,n){var r=this;return"string"==typeof e&&y.hasOwnProperty(e)?new h(t(r).startOf(e),t(r).endOf(e)):new h(e,n)},t.rangeFromInterval=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t();if(t.isMoment(r)||(r=t(r)),!r.isValid())throw new Error("Invalid date.");var o=r.clone().add(n,e),i=[];return i.push(t.min(r,o)),i.push(t.max(r,o)),new h(i)},t.rangeFromISOString=function(e){var n=a(e),r=t.parseZone(n[0]),o=t.parseZone(n[1]);return new h(r,o)},t.parseZoneRange=t.rangeFromISOString,t.fn.range=t.range,t.range.constructor=h,t.isRange=function(t){return t instanceof h},t.fn.within=function(t){return t.contains(this.toDate())},t}function a(t){return t.split("/")}Object.defineProperty(e,"__esModule",{value:!0}),e.DateRange=void 0;var s=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},f=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();e.extendMoment=u;var l=n(2),v=r(l),d=n(1),p=r(d),y={year:!0,quarter:!0,month:!0,week:!0,day:!0,hour:!0,minute:!0,second:!0},h=e.DateRange=function(){function t(e,n){i(this,t);var r=e,o=n;if(1===arguments.length||void 0===n)if("object"===(void 0===e?"undefined":c(e))&&2===e.length){var u=s(e,2);r=u[0],o=u[1]}else if("string"==typeof e){var f=a(e),l=s(f,2);r=l[0],o=l[1]}this.start=r||0===r?(0,v.default)(r):(0,v.default)(-864e13),this.end=o||0===o?(0,v.default)(o):(0,v.default)(864e13)}return f(t,[{key:"adjacent",value:function(t){var e=this.start.isSame(t.end),n=this.end.isSame(t.start);return e&&t.start.valueOf()<=this.start.valueOf()||n&&t.end.valueOf()>=this.end.valueOf()}},{key:"add",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1};return this.overlaps(t,e)?new this.constructor(v.default.min(this.start,t.start),v.default.max(this.end,t.end)):null}},{key:"by",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeEnd||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.start.clone().add(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"byRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeEnd||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0,v.default)(n.start.valueOf()+t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"center",value:function(){var t=this.start.valueOf()+this.diff()/2;return(0,v.default)(t)}},{key:"clone",value:function(){return new this.constructor(this.start.clone(),this.end.clone())}},{key:"contains",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,excludeEnd:!1},r=this.start.valueOf(),o=this.end.valueOf(),i=e.valueOf(),u=e.valueOf(),a=n.excludeStart||!1,s=n.excludeEnd||!1;n.hasOwnProperty("exclusive")&&(a=s=n.exclusive),e instanceof t&&(i=e.start.valueOf(),u=e.end.valueOf());var c=r<i||r<=i&&!a,f=o>u||o>=u&&!s;return c&&f}},{key:"diff",value:function(t,e){return this.end.diff(this.start,t,e)}},{key:"duration",value:function(t,e){return this.diff(t,e)}},{key:"intersect",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf(),i=e==n,u=r==o;if(i){var a=e;if(a==r||a==o)return null;if(a>r&&a<o)return this.clone()}else if(u){var s=r;if(s==e||s==n)return null;if(s>e&&s<n)return new this.constructor(s,s)}return e<=r&&r<n&&n<o?new this.constructor(r,n):r<e&&e<o&&o<=n?new this.constructor(e,o):r<e&&e<=n&&n<o?this.clone():e<=r&&r<=o&&o<=n?new this.constructor(r,o):null}},{key:"isEqual",value:function(t){return this.start.isSame(t.start)&&this.end.isSame(t.end)}},{key:"isSame",value:function(t){return this.isEqual(t)}},{key:"overlaps",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1},n=null!==this.intersect(t);return e.adjacent&&!n?this.adjacent(t):n}},{key:"reverseBy",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeStart||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.end.clone().subtract(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"reverseByRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeStart||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0,v.default)(n.end.valueOf()-t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"snapTo",value:function(t){var e=this.clone();return e.start.isSame((0,v.default)(-864e13))||(e.start=e.start.startOf(t)),e.end.isSame((0,v.default)(864e13))||(e.end=e.end.endOf(t)),e}},{key:"subtract",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf();return null===this.intersect(t)?[this]:r<=e&&e<n&&n<=o?[]:r<=e&&e<o&&o<n?[new this.constructor(o,n)]:e<r&&r<n&&n<=o?[new this.constructor(e,r)]:e<r&&r<o&&o<n?[new this.constructor(e,r),new this.constructor(o,n)]:e<r&&r<n&&o<n?[new this.constructor(e,r),new this.constructor(r,n)]:[]}},{key:"toDate",value:function(){return[this.start.toDate(),this.end.toDate()]}},{key:"toString",value:function(){return this.start.format()+"/"+this.end.format()}},{key:"valueOf",value:function(){return this.end.valueOf()-this.start.valueOf()}}]),t}()},function(t,e,n){"use strict";var r,o=n(6),i=n(13),u=n(9),a=n(15);r=t.exports=function(t,e){var n,r,u,s,c;return arguments.length<2||"string"!=typeof t?(s=e,e=t,t=null):s=arguments[2],null==t?(n=u=!0,r=!1):(n=a.call(t,"c"),r=a.call(t,"e"),u=a.call(t,"w")),c={value:e,configurable:n,enumerable:r,writable:u},s?o(i(s),c):c},r.gs=function(t,e,n){var r,s,c,f;return"string"!=typeof t?(c=n,n=e,e=t,t=null):c=arguments[3],null==e?e=void 0:u(e)?null==n?n=void 0:u(n)||(c=n,n=void 0):(c=e,e=n=void 0),null==t?(r=!0,s=!1):(r=a.call(t,"c"),s=a.call(t,"e")),f={get:e,set:n,configurable:r,enumerable:s},c?o(i(c),f):f}},function(t,e,n){"use strict";t.exports=function(){}},function(t,e,n){"use strict";t.exports=n(7)()?Object.assign:n(8)},function(t,e,n){"use strict";t.exports=function(){var t,e=Object.assign;return"function"==typeof e&&(t={foo:"raz"},e(t,{bar:"dwa"},{trzy:"trzy"}),t.foo+t.bar+t.trzy==="razdwatrzy")}},function(t,e,n){"use strict";var r=n(10),o=n(14),i=Math.max;t.exports=function(t,e){var n,u,a,s=i(arguments.length,2);for(t=Object(o(t)),a=function(r){try{t[r]=e[r]}catch(t){n||(n=t)}},u=1;u<s;++u)e=arguments[u],r(e).forEach(a);if(void 0!==n)throw n;return t}},function(t,e,n){"use strict";t.exports=function(t){return"function"==typeof t}},function(t,e,n){"use strict";t.exports=n(11)()?Object.keys:n(12)},function(t,e,n){"use strict";t.exports=function(){try{return Object.keys("primitive"),!0}catch(t){return!1}}},function(t,e,n){"use strict";var r=n(0),o=Object.keys;t.exports=function(t){return o(r(t)?Object(t):t)}},function(t,e,n){"use strict";var r=n(0),o=Array.prototype.forEach,i=Object.create,u=function(t,e){var n;for(n in t)e[n]=t[n]};t.exports=function(t){var e=i(null);return o.call(arguments,function(t){r(t)&&u(Object(t),e)}),e}},function(t,e,n){"use strict";var r=n(0);t.exports=function(t){if(!r(t))throw new TypeError("Cannot use null or undefined");return t}},function(t,e,n){"use strict";t.exports=n(16)()?String.prototype.contains:n(17)},function(t,e,n){"use strict";var r="razdwatrzy";t.exports=function(){return"function"==typeof r.contains&&(!0===r.contains("dwa")&&!1===r.contains("foo"))}},function(t,e,n){"use strict";var r=String.prototype.indexOf;t.exports=function(t){return r.call(this,t,arguments[1])>-1}},function(t,e,n){"use strict";var r={object:!0,symbol:!0};t.exports=function(){var t;if("function"!=typeof Symbol)return!1;t=Symbol("test symbol");try{String(t)}catch(t){return!1}return!!r[typeof Symbol.iterator]&&(!!r[typeof Symbol.toPrimitive]&&!!r[typeof Symbol.toStringTag])}},function(t,e,n){"use strict";t.exports=function(t){return!!t&&("symbol"==typeof t||!!t.constructor&&("Symbol"===t.constructor.name&&"Symbol"===t[t.constructor.toStringTag]))}},function(t,e,n){"use strict";var r,o,i,u,a=n(4),s=n(21),c=Object.create,f=Object.defineProperties,l=Object.defineProperty,v=Object.prototype,d=c(null);if("function"==typeof Symbol){r=Symbol;try{String(r()),u=!0}catch(t){}}var p=function(){var t=c(null);return function(e){for(var n,r,o=0;t[e+(o||"")];)++o;return e+=o||"",t[e]=!0,n="@@"+e,l(v,n,a.gs(null,function(t){r||(r=!0,l(this,n,a(t)),r=!1)})),n}}();i=function(t){if(this instanceof i)throw new TypeError("Symbol is not a constructor");return o(t)},t.exports=o=function t(e){var n;if(this instanceof t)throw new TypeError("Symbol is not a constructor");return u?r(e):(n=c(i.prototype),e=void 0===e?"":String(e),f(n,{__description__:a("",e),__name__:a("",p(e))}))},f(o,{for:a(function(t){return d[t]?d[t]:d[t]=o(String(t))}),keyFor:a(function(t){var e;s(t);for(e in d)if(d[e]===t)return e}),hasInstance:a("",r&&r.hasInstance||o("hasInstance")),isConcatSpreadable:a("",r&&r.isConcatSpreadable||o("isConcatSpreadable")),iterator:a("",r&&r.iterator||o("iterator")),match:a("",r&&r.match||o("match")),replace:a("",r&&r.replace||o("replace")),search:a("",r&&r.search||o("search")),species:a("",r&&r.species||o("species")),split:a("",r&&r.split||o("split")),toPrimitive:a("",r&&r.toPrimitive||o("toPrimitive")),toStringTag:a("",r&&r.toStringTag||o("toStringTag")),unscopables:a("",r&&r.unscopables||o("unscopables"))}),f(i.prototype,{constructor:a(o),toString:a("",function(){return this.__name__})}),f(o.prototype,{toString:a(function(){return"Symbol ("+s(this).__description__+")"}),valueOf:a(function(){return s(this)})}),l(o.prototype,o.toPrimitive,a("",function(){var t=s(this);return"symbol"==typeof t?t:t.toString()})),l(o.prototype,o.toStringTag,a("c","Symbol")),l(i.prototype,o.toStringTag,a("c",o.prototype[o.toStringTag])),l(i.prototype,o.toPrimitive,a("c",o.prototype[o.toPrimitive]))},function(t,e,n){"use strict";var r=n(19);t.exports=function(t){if(!r(t))throw new TypeError(t+" is not a symbol");return t}}])});
	//# sourceMappingURL=moment-range.js.map

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var d3Array = __webpack_require__(531);
	var d3Axis = __webpack_require__(532);
	var d3Brush = __webpack_require__(533);
	var d3Chord = __webpack_require__(542);
	var d3Collection = __webpack_require__(544);
	var d3Color = __webpack_require__(538);
	var d3Contour = __webpack_require__(545);
	var d3Dispatch = __webpack_require__(534);
	var d3Drag = __webpack_require__(535);
	var d3Dsv = __webpack_require__(546);
	var d3Ease = __webpack_require__(541);
	var d3Fetch = __webpack_require__(547);
	var d3Force = __webpack_require__(548);
	var d3Format = __webpack_require__(550);
	var d3Geo = __webpack_require__(551);
	var d3Hierarchy = __webpack_require__(552);
	var d3Interpolate = __webpack_require__(537);
	var d3Path = __webpack_require__(543);
	var d3Polygon = __webpack_require__(553);
	var d3Quadtree = __webpack_require__(549);
	var d3Random = __webpack_require__(554);
	var d3Scale = __webpack_require__(555);
	var d3ScaleChromatic = __webpack_require__(558);
	var d3Selection = __webpack_require__(536);
	var d3Shape = __webpack_require__(559);
	var d3Time = __webpack_require__(556);
	var d3TimeFormat = __webpack_require__(557);
	var d3Timer = __webpack_require__(540);
	var d3Transition = __webpack_require__(539);
	var d3Voronoi = __webpack_require__(560);
	var d3Zoom = __webpack_require__(561);
	
	var version = "5.4.0";
	
	Object.keys(d3Array).forEach(function (key) { exports[key] = d3Array[key]; });
	Object.keys(d3Axis).forEach(function (key) { exports[key] = d3Axis[key]; });
	Object.keys(d3Brush).forEach(function (key) { exports[key] = d3Brush[key]; });
	Object.keys(d3Chord).forEach(function (key) { exports[key] = d3Chord[key]; });
	Object.keys(d3Collection).forEach(function (key) { exports[key] = d3Collection[key]; });
	Object.keys(d3Color).forEach(function (key) { exports[key] = d3Color[key]; });
	Object.keys(d3Contour).forEach(function (key) { exports[key] = d3Contour[key]; });
	Object.keys(d3Dispatch).forEach(function (key) { exports[key] = d3Dispatch[key]; });
	Object.keys(d3Drag).forEach(function (key) { exports[key] = d3Drag[key]; });
	Object.keys(d3Dsv).forEach(function (key) { exports[key] = d3Dsv[key]; });
	Object.keys(d3Ease).forEach(function (key) { exports[key] = d3Ease[key]; });
	Object.keys(d3Fetch).forEach(function (key) { exports[key] = d3Fetch[key]; });
	Object.keys(d3Force).forEach(function (key) { exports[key] = d3Force[key]; });
	Object.keys(d3Format).forEach(function (key) { exports[key] = d3Format[key]; });
	Object.keys(d3Geo).forEach(function (key) { exports[key] = d3Geo[key]; });
	Object.keys(d3Hierarchy).forEach(function (key) { exports[key] = d3Hierarchy[key]; });
	Object.keys(d3Interpolate).forEach(function (key) { exports[key] = d3Interpolate[key]; });
	Object.keys(d3Path).forEach(function (key) { exports[key] = d3Path[key]; });
	Object.keys(d3Polygon).forEach(function (key) { exports[key] = d3Polygon[key]; });
	Object.keys(d3Quadtree).forEach(function (key) { exports[key] = d3Quadtree[key]; });
	Object.keys(d3Random).forEach(function (key) { exports[key] = d3Random[key]; });
	Object.keys(d3Scale).forEach(function (key) { exports[key] = d3Scale[key]; });
	Object.keys(d3ScaleChromatic).forEach(function (key) { exports[key] = d3ScaleChromatic[key]; });
	Object.keys(d3Selection).forEach(function (key) { exports[key] = d3Selection[key]; });
	Object.keys(d3Shape).forEach(function (key) { exports[key] = d3Shape[key]; });
	Object.keys(d3Time).forEach(function (key) { exports[key] = d3Time[key]; });
	Object.keys(d3TimeFormat).forEach(function (key) { exports[key] = d3TimeFormat[key]; });
	Object.keys(d3Timer).forEach(function (key) { exports[key] = d3Timer[key]; });
	Object.keys(d3Transition).forEach(function (key) { exports[key] = d3Transition[key]; });
	Object.keys(d3Voronoi).forEach(function (key) { exports[key] = d3Voronoi[key]; });
	Object.keys(d3Zoom).forEach(function (key) { exports[key] = d3Zoom[key]; });
	exports.version = version;
	Object.defineProperty(exports, "event", {get: function() { return d3Selection.event; }});


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-axis/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var slice = Array.prototype.slice;
	
	var identity = function(x) {
	  return x;
	};
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon = 1e-6;
	
	function translateX(x) {
	  return "translate(" + (x + 0.5) + ",0)";
	}
	
	function translateY(y) {
	  return "translate(0," + (y + 0.5) + ")";
	}
	
	function number(scale) {
	  return function(d) {
	    return +scale(d);
	  };
	}
	
	function center(scale) {
	  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return +scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3,
	      k = orient === top || orient === left ? -1 : 1,
	      x = orient === left || orient === right ? "x" : "y",
	      transform = orient === top || orient === bottom ? translateX : translateY;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        range = scale.range(),
	        range0 = +range[0] + 0.5,
	        range1 = +range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : number)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });
	
	      tickEnter
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position(d)); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-brush/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(534), __webpack_require__(535), __webpack_require__(537), __webpack_require__(536), __webpack_require__(539)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-dispatch', 'd3-drag', 'd3-interpolate', 'd3-selection', 'd3-transition'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Dispatch,d3Drag,d3Interpolate,d3Selection,d3Transition) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var BrushEvent = function(target, type, selection) {
	  this.target = target;
	  this.type = type;
	  this.selection = selection;
	};
	
	function nopropagation() {
	  d3Selection.event.stopImmediatePropagation();
	}
	
	var noevent = function() {
	  d3Selection.event.preventDefault();
	  d3Selection.event.stopImmediatePropagation();
	};
	
	var MODE_DRAG = {name: "drag"};
	var MODE_SPACE = {name: "space"};
	var MODE_HANDLE = {name: "handle"};
	var MODE_CENTER = {name: "center"};
	
	var X = {
	  name: "x",
	  handles: ["e", "w"].map(type),
	  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
	  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
	};
	
	var Y = {
	  name: "y",
	  handles: ["n", "s"].map(type),
	  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
	  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
	};
	
	var XY = {
	  name: "xy",
	  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
	  input: function(xy) { return xy; },
	  output: function(xy) { return xy; }
	};
	
	var cursors = {
	  overlay: "crosshair",
	  selection: "move",
	  n: "ns-resize",
	  e: "ew-resize",
	  s: "ns-resize",
	  w: "ew-resize",
	  nw: "nwse-resize",
	  ne: "nesw-resize",
	  se: "nwse-resize",
	  sw: "nesw-resize"
	};
	
	var flipX = {
	  e: "w",
	  w: "e",
	  nw: "ne",
	  ne: "nw",
	  se: "sw",
	  sw: "se"
	};
	
	var flipY = {
	  n: "s",
	  s: "n",
	  nw: "sw",
	  ne: "se",
	  se: "ne",
	  sw: "nw"
	};
	
	var signsX = {
	  overlay: +1,
	  selection: +1,
	  n: null,
	  e: +1,
	  s: null,
	  w: -1,
	  nw: -1,
	  ne: +1,
	  se: +1,
	  sw: -1
	};
	
	var signsY = {
	  overlay: +1,
	  selection: +1,
	  n: -1,
	  e: null,
	  s: +1,
	  w: null,
	  nw: -1,
	  ne: -1,
	  se: +1,
	  sw: +1
	};
	
	function type(t) {
	  return {type: t};
	}
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !d3Selection.event.button;
	}
	
	function defaultExtent() {
	  var svg = this.ownerSVGElement || this;
	  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
	}
	
	// Like d3.local, but with the name “__brush” rather than auto-generated.
	function local(node) {
	  while (!node.__brush) if (!(node = node.parentNode)) return;
	  return node.__brush;
	}
	
	function empty(extent) {
	  return extent[0][0] === extent[1][0]
	      || extent[0][1] === extent[1][1];
	}
	
	function brushSelection(node) {
	  var state = node.__brush;
	  return state ? state.dim.output(state.selection) : null;
	}
	
	function brushX() {
	  return brush$1(X);
	}
	
	function brushY() {
	  return brush$1(Y);
	}
	
	var brush = function() {
	  return brush$1(XY);
	};
	
	function brush$1(dim) {
	  var extent = defaultExtent,
	      filter = defaultFilter,
	      listeners = d3Dispatch.dispatch(brush, "start", "brush", "end"),
	      handleSize = 6,
	      touchending;
	
	  function brush(group) {
	    var overlay = group
	        .property("__brush", initialize)
	      .selectAll(".overlay")
	      .data([type("overlay")]);
	
	    overlay.enter().append("rect")
	        .attr("class", "overlay")
	        .attr("pointer-events", "all")
	        .attr("cursor", cursors.overlay)
	      .merge(overlay)
	        .each(function() {
	          var extent = local(this).extent;
	          d3Selection.select(this)
	              .attr("x", extent[0][0])
	              .attr("y", extent[0][1])
	              .attr("width", extent[1][0] - extent[0][0])
	              .attr("height", extent[1][1] - extent[0][1]);
	        });
	
	    group.selectAll(".selection")
	      .data([type("selection")])
	      .enter().append("rect")
	        .attr("class", "selection")
	        .attr("cursor", cursors.selection)
	        .attr("fill", "#777")
	        .attr("fill-opacity", 0.3)
	        .attr("stroke", "#fff")
	        .attr("shape-rendering", "crispEdges");
	
	    var handle = group.selectAll(".handle")
	      .data(dim.handles, function(d) { return d.type; });
	
	    handle.exit().remove();
	
	    handle.enter().append("rect")
	        .attr("class", function(d) { return "handle handle--" + d.type; })
	        .attr("cursor", function(d) { return cursors[d.type]; });
	
	    group
	        .each(redraw)
	        .attr("fill", "none")
	        .attr("pointer-events", "all")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .on("mousedown.brush touchstart.brush", started);
	  }
	
	  brush.move = function(group, selection) {
	    if (group.selection) {
	      group
	          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
	          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
	          .tween("brush", function() {
	            var that = this,
	                state = that.__brush,
	                emit = emitter(that, arguments),
	                selection0 = state.selection,
	                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
	                i = d3Interpolate.interpolate(selection0, selection1);
	
	            function tween(t) {
	              state.selection = t === 1 && empty(selection1) ? null : i(t);
	              redraw.call(that);
	              emit.brush();
	            }
	
	            return selection0 && selection1 ? tween : tween(1);
	          });
	    } else {
	      group
	          .each(function() {
	            var that = this,
	                args = arguments,
	                state = that.__brush,
	                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
	                emit = emitter(that, args).beforestart();
	
	            d3Transition.interrupt(that);
	            state.selection = selection1 == null || empty(selection1) ? null : selection1;
	            redraw.call(that);
	            emit.start().brush().end();
	          });
	    }
	  };
	
	  function redraw() {
	    var group = d3Selection.select(this),
	        selection = local(this).selection;
	
	    if (selection) {
	      group.selectAll(".selection")
	          .style("display", null)
	          .attr("x", selection[0][0])
	          .attr("y", selection[0][1])
	          .attr("width", selection[1][0] - selection[0][0])
	          .attr("height", selection[1][1] - selection[0][1]);
	
	      group.selectAll(".handle")
	          .style("display", null)
	          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
	          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
	          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
	          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
	    }
	
	    else {
	      group.selectAll(".selection,.handle")
	          .style("display", "none")
	          .attr("x", null)
	          .attr("y", null)
	          .attr("width", null)
	          .attr("height", null);
	    }
	  }
	
	  function emitter(that, args) {
	    return that.__brush.emitter || new Emitter(that, args);
	  }
	
	  function Emitter(that, args) {
	    this.that = that;
	    this.args = args;
	    this.state = that.__brush;
	    this.active = 0;
	  }
	
	  Emitter.prototype = {
	    beforestart: function() {
	      if (++this.active === 1) this.state.emitter = this, this.starting = true;
	      return this;
	    },
	    start: function() {
	      if (this.starting) this.starting = false, this.emit("start");
	      return this;
	    },
	    brush: function() {
	      this.emit("brush");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) delete this.state.emitter, this.emit("end");
	      return this;
	    },
	    emit: function(type) {
	      d3Selection.customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function started() {
	    if (d3Selection.event.touches) { if (d3Selection.event.changedTouches.length < d3Selection.event.touches.length) return noevent(); }
	    else if (touchending) return;
	    if (!filter.apply(this, arguments)) return;
	
	    var that = this,
	        type = d3Selection.event.target.__data__.type,
	        mode = (d3Selection.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (d3Selection.event.altKey ? MODE_CENTER : MODE_HANDLE),
	        signX = dim === Y ? null : signsX[type],
	        signY = dim === X ? null : signsY[type],
	        state = local(that),
	        extent = state.extent,
	        selection = state.selection,
	        W = extent[0][0], w0, w1,
	        N = extent[0][1], n0, n1,
	        E = extent[1][0], e0, e1,
	        S = extent[1][1], s0, s1,
	        dx,
	        dy,
	        moving,
	        shifting = signX && signY && d3Selection.event.shiftKey,
	        lockX,
	        lockY,
	        point0 = d3Selection.mouse(that),
	        point = point0,
	        emit = emitter(that, arguments).beforestart();
	
	    if (type === "overlay") {
	      state.selection = selection = [
	        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
	        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
	      ];
	    } else {
	      w0 = selection[0][0];
	      n0 = selection[0][1];
	      e0 = selection[1][0];
	      s0 = selection[1][1];
	    }
	
	    w1 = w0;
	    n1 = n0;
	    e1 = e0;
	    s1 = s0;
	
	    var group = d3Selection.select(that)
	        .attr("pointer-events", "none");
	
	    var overlay = group.selectAll(".overlay")
	        .attr("cursor", cursors[type]);
	
	    if (d3Selection.event.touches) {
	      group
	          .on("touchmove.brush", moved, true)
	          .on("touchend.brush touchcancel.brush", ended, true);
	    } else {
	      var view = d3Selection.select(d3Selection.event.view)
	          .on("keydown.brush", keydowned, true)
	          .on("keyup.brush", keyupped, true)
	          .on("mousemove.brush", moved, true)
	          .on("mouseup.brush", ended, true);
	
	      d3Drag.dragDisable(d3Selection.event.view);
	    }
	
	    nopropagation();
	    d3Transition.interrupt(that);
	    redraw.call(that);
	    emit.start();
	
	    function moved() {
	      var point1 = d3Selection.mouse(that);
	      if (shifting && !lockX && !lockY) {
	        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
	        else lockX = true;
	      }
	      point = point1;
	      moving = true;
	      noevent();
	      move();
	    }
	
	    function move() {
	      var t;
	
	      dx = point[0] - point0[0];
	      dy = point[1] - point0[1];
	
	      switch (mode) {
	        case MODE_SPACE:
	        case MODE_DRAG: {
	          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
	          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
	          break;
	        }
	        case MODE_HANDLE: {
	          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
	          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
	          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
	          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
	          break;
	        }
	        case MODE_CENTER: {
	          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
	          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
	          break;
	        }
	      }
	
	      if (e1 < w1) {
	        signX *= -1;
	        t = w0, w0 = e0, e0 = t;
	        t = w1, w1 = e1, e1 = t;
	        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
	      }
	
	      if (s1 < n1) {
	        signY *= -1;
	        t = n0, n0 = s0, s0 = t;
	        t = n1, n1 = s1, s1 = t;
	        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
	      }
	
	      if (state.selection) selection = state.selection; // May be set by brush.move!
	      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
	      if (lockY) n1 = selection[0][1], s1 = selection[1][1];
	
	      if (selection[0][0] !== w1
	          || selection[0][1] !== n1
	          || selection[1][0] !== e1
	          || selection[1][1] !== s1) {
	        state.selection = [[w1, n1], [e1, s1]];
	        redraw.call(that);
	        emit.brush();
	      }
	    }
	
	    function ended() {
	      nopropagation();
	      if (d3Selection.event.touches) {
	        if (d3Selection.event.touches.length) return;
	        if (touchending) clearTimeout(touchending);
	        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
	      } else {
	        d3Drag.dragEnable(d3Selection.event.view, moving);
	        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
	      }
	      group.attr("pointer-events", "all");
	      overlay.attr("cursor", cursors.overlay);
	      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
	      if (empty(selection)) state.selection = null, redraw.call(that);
	      emit.end();
	    }
	
	    function keydowned() {
	      switch (d3Selection.event.keyCode) {
	        case 16: { // SHIFT
	          shifting = signX && signY;
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_HANDLE) {
	            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	            mode = MODE_CENTER;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE; takes priority over ALT
	          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
	            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
	            mode = MODE_SPACE;
	            overlay.attr("cursor", cursors.selection);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent();
	    }
	
	    function keyupped() {
	      switch (d3Selection.event.keyCode) {
	        case 16: { // SHIFT
	          if (shifting) {
	            lockX = lockY = shifting = false;
	            move();
	          }
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	            mode = MODE_HANDLE;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE
	          if (mode === MODE_SPACE) {
	            if (d3Selection.event.altKey) {
	              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	              mode = MODE_CENTER;
	            } else {
	              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	              mode = MODE_HANDLE;
	            }
	            overlay.attr("cursor", cursors[type]);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent();
	    }
	  }
	
	  function initialize() {
	    var state = this.__brush || {selection: null};
	    state.extent = extent.apply(this, arguments);
	    state.dim = dim;
	    return state;
	  }
	
	  brush.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
	  };
	
	  brush.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), brush) : filter;
	  };
	
	  brush.handleSize = function(_) {
	    return arguments.length ? (handleSize = +_, brush) : handleSize;
	  };
	
	  brush.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? brush : value;
	  };
	
	  return brush;
	}
	
	exports.brush = brush;
	exports.brushX = brushX;
	exports.brushY = brushY;
	exports.brushSelection = brushSelection;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dispatch/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var noop = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	exports.dispatch = dispatch;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-drag/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(534), __webpack_require__(536)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-dispatch', 'd3-selection'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3));
	}(this, (function (exports,d3Dispatch,d3Selection) { 'use strict';
	
	function nopropagation() {
	  d3Selection.event.stopImmediatePropagation();
	}
	
	var noevent = function() {
	  d3Selection.event.preventDefault();
	  d3Selection.event.stopImmediatePropagation();
	};
	
	var nodrag = function(view) {
	  var root = view.document.documentElement,
	      selection = d3Selection.select(view).on("dragstart.drag", noevent, true);
	  if ("onselectstart" in root) {
	    selection.on("selectstart.drag", noevent, true);
	  } else {
	    root.__noselect = root.style.MozUserSelect;
	    root.style.MozUserSelect = "none";
	  }
	};
	
	function yesdrag(view, noclick) {
	  var root = view.document.documentElement,
	      selection = d3Selection.select(view).on("dragstart.drag", null);
	  if (noclick) {
	    selection.on("click.drag", noevent, true);
	    setTimeout(function() { selection.on("click.drag", null); }, 0);
	  }
	  if ("onselectstart" in root) {
	    selection.on("selectstart.drag", null);
	  } else {
	    root.style.MozUserSelect = root.__noselect;
	    delete root.__noselect;
	  }
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch$$1) {
	  this.target = target;
	  this.type = type;
	  this.subject = subject;
	  this.identifier = id;
	  this.active = active;
	  this.x = x;
	  this.y = y;
	  this.dx = dx;
	  this.dy = dy;
	  this._ = dispatch$$1;
	}
	
	DragEvent.prototype.on = function() {
	  var value = this._.on.apply(this._, arguments);
	  return value === this._ ? this : value;
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !d3Selection.event.button;
	}
	
	function defaultContainer() {
	  return this.parentNode;
	}
	
	function defaultSubject(d) {
	  return d == null ? {x: d3Selection.event.x, y: d3Selection.event.y} : d;
	}
	
	function defaultTouchable() {
	  return "ontouchstart" in this;
	}
	
	var drag = function() {
	  var filter = defaultFilter,
	      container = defaultContainer,
	      subject = defaultSubject,
	      touchable = defaultTouchable,
	      gestures = {},
	      listeners = d3Dispatch.dispatch("start", "drag", "end"),
	      active = 0,
	      mousedownx,
	      mousedowny,
	      mousemoving,
	      touchending,
	      clickDistance2 = 0;
	
	  function drag(selection) {
	    selection
	        .on("mousedown.drag", mousedowned)
	      .filter(touchable)
	        .on("touchstart.drag", touchstarted)
	        .on("touchmove.drag", touchmoved)
	        .on("touchend.drag touchcancel.drag", touchended)
	        .style("touch-action", "none")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var gesture = beforestart("mouse", container.apply(this, arguments), d3Selection.mouse, this, arguments);
	    if (!gesture) return;
	    d3Selection.select(d3Selection.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
	    nodrag(d3Selection.event.view);
	    nopropagation();
	    mousemoving = false;
	    mousedownx = d3Selection.event.clientX;
	    mousedowny = d3Selection.event.clientY;
	    gesture("start");
	  }
	
	  function mousemoved() {
	    noevent();
	    if (!mousemoving) {
	      var dx = d3Selection.event.clientX - mousedownx, dy = d3Selection.event.clientY - mousedowny;
	      mousemoving = dx * dx + dy * dy > clickDistance2;
	    }
	    gestures.mouse("drag");
	  }
	
	  function mouseupped() {
	    d3Selection.select(d3Selection.event.view).on("mousemove.drag mouseup.drag", null);
	    yesdrag(d3Selection.event.view, mousemoving);
	    noevent();
	    gestures.mouse("end");
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var touches = d3Selection.event.changedTouches,
	        c = container.apply(this, arguments),
	        n = touches.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = beforestart(touches[i].identifier, c, d3Selection.touch, this, arguments)) {
	        nopropagation();
	        gesture("start");
	      }
	    }
	  }
	
	  function touchmoved() {
	    var touches = d3Selection.event.changedTouches,
	        n = touches.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches[i].identifier]) {
	        noevent();
	        gesture("drag");
	      }
	    }
	  }
	
	  function touchended() {
	    var touches = d3Selection.event.changedTouches,
	        n = touches.length, i, gesture;
	
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches[i].identifier]) {
	        nopropagation();
	        gesture("end");
	      }
	    }
	  }
	
	  function beforestart(id, container, point, that, args) {
	    var p = point(container, id), s, dx, dy,
	        sublisteners = listeners.copy();
	
	    if (!d3Selection.customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
	      if ((d3Selection.event.subject = s = subject.apply(that, args)) == null) return false;
	      dx = s.x - p[0] || 0;
	      dy = s.y - p[1] || 0;
	      return true;
	    })) return;
	
	    return function gesture(type) {
	      var p0 = p, n;
	      switch (type) {
	        case "start": gestures[id] = gesture, n = active++; break;
	        case "end": delete gestures[id], --active; // nobreak
	        case "drag": p = point(container, id), n = active; break;
	      }
	      d3Selection.customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
	    };
	  }
	
	  drag.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), drag) : filter;
	  };
	
	  drag.container = function(_) {
	    return arguments.length ? (container = typeof _ === "function" ? _ : constant(_), drag) : container;
	  };
	
	  drag.subject = function(_) {
	    return arguments.length ? (subject = typeof _ === "function" ? _ : constant(_), drag) : subject;
	  };
	
	  drag.touchable = function(_) {
	    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), drag) : touchable;
	  };
	
	  drag.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? drag : value;
	  };
	
	  drag.clickDistance = function(_) {
	    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
	  };
	
	  return drag;
	};
	
	exports.drag = drag;
	exports.dragDisable = nodrag;
	exports.dragEnable = yesdrag;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.3.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	function namespace(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	}
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	function creator(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	}
	
	function none() {}
	
	function selector(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	}
	
	function selection_select(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function empty() {
	  return [];
	}
	
	function selectorAll(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	}
	
	function selection_selectAll(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	}
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	function selection_filter(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function sparse(update) {
	  return new Array(update.length);
	}
	
	function selection_enter() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	}
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	function selection_data(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	}
	
	function selection_exit() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	}
	
	function selection_merge(selection$$1) {
	
	  for (var groups0 = this._groups, groups1 = selection$$1._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	}
	
	function selection_order() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	}
	
	function selection_sort(compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	}
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function selection_call() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	}
	
	function selection_nodes() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	}
	
	function selection_node() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	}
	
	function selection_size() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	}
	
	function selection_empty() {
	  return !this.node();
	}
	
	function selection_each(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	}
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	function selection_attr(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	}
	
	function defaultView(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	}
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	function selection_style(name, value, priority) {
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : styleValue(this.node(), name);
	}
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name)
	      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	function selection_property(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	}
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	function selection_classed(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	}
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	function selection_text(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	}
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	function selection_html(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	}
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	function selection_raise() {
	  return this.each(raise);
	}
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	function selection_lower() {
	  return this.each(lower);
	}
	
	function selection_append(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	}
	
	function constantNull() {
	  return null;
	}
	
	function selection_insert(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	}
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	function selection_remove() {
	  return this.each(remove);
	}
	
	function selection_cloneShallow() {
	  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
	}
	
	function selection_cloneDeep() {
	  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
	}
	
	function selection_clone(deep) {
	  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
	}
	
	function selection_datum(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	}
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	function selection_on(typename, value, capture) {
	  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	}
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	function selection_dispatch(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	}
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  clone: selection_clone,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	function select(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	}
	
	function create(name) {
	  return select(creator(name).call(document.documentElement));
	}
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	function sourceEvent() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	}
	
	function point(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	}
	
	function mouse(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	}
	
	function selectAll(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	}
	
	function touch(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	}
	
	function touches(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	}
	
	exports.create = create;
	exports.creator = creator;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.clientPoint = point;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.style = styleValue;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	exports.customEvent = customEvent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(538)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18;
	var Xn = 0.96422;
	var Yn = 1;
	var Zn = 0.82521;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-transition/ Version 1.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(536), __webpack_require__(534), __webpack_require__(540), __webpack_require__(537), __webpack_require__(538), __webpack_require__(541)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-selection', 'd3-dispatch', 'd3-timer', 'd3-interpolate', 'd3-color', 'd3-ease'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Selection,d3Dispatch,d3Timer,d3Interpolate,d3Color,d3Ease) { 'use strict';
	
	var emptyOn = d3Dispatch.dispatch("start", "end", "interrupt");
	var emptyTween = [];
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	var schedule = function(node, name, id, index, group, timing) {
	  var schedules = node.__transition;
	  if (!schedules) node.__transition = {};
	  else if (id in schedules) return;
	  create(node, id, {
	    name: name,
	    index: index, // For context during callback.
	    group: group, // For context during callback.
	    on: emptyOn,
	    tween: emptyTween,
	    time: timing.time,
	    delay: timing.delay,
	    duration: timing.duration,
	    ease: timing.ease,
	    timer: null,
	    state: CREATED
	  });
	};
	
	function init(node, id) {
	  var schedule = get(node, id);
	  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
	  return schedule;
	}
	
	function set(node, id) {
	  var schedule = get(node, id);
	  if (schedule.state > STARTING) throw new Error("too late; already started");
	  return schedule;
	}
	
	function get(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
	  return schedule;
	}
	
	function create(node, id, self) {
	  var schedules = node.__transition,
	      tween;
	
	  // Initialize the self timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  schedules[id] = self;
	  self.timer = d3Timer.timer(schedule, 0, self.time);
	
	  function schedule(elapsed) {
	    self.state = SCHEDULED;
	    self.timer.restart(start, self.delay, self.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (self.delay <= elapsed) start(elapsed - self.delay);
	  }
	
	  function start(elapsed) {
	    var i, j, n, o;
	
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (self.state !== SCHEDULED) return stop();
	
	    for (i in schedules) {
	      o = schedules[i];
	      if (o.name !== self.name) continue;
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (o.state === STARTED) return d3Timer.timeout(start);
	
	      // Interrupt the active transition, if any.
	      // Dispatch the interrupt event.
	      if (o.state === RUNNING) {
	        o.state = ENDED;
	        o.timer.stop();
	        o.on.call("interrupt", node, node.__data__, o.index, o.group);
	        delete schedules[i];
	      }
	
	      // Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	      else if (+i < id) {
	        o.state = ENDED;
	        o.timer.stop();
	        delete schedules[i];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    d3Timer.timeout(function() {
	      if (self.state === STARTED) {
	        self.state = RUNNING;
	        self.timer.restart(tick, self.delay, self.time);
	        tick(elapsed);
	      }
	    });
	
	    // Dispatch the start event.
	    // Note this must be done before the tween are initialized.
	    self.state = STARTING;
	    self.on.call("start", node, node.__data__, self.index, self.group);
	    if (self.state !== STARTING) return; // interrupted
	    self.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    tween = new Array(n = self.tween.length);
	    for (i = 0, j = -1; i < n; ++i) {
	      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
	        tween[++j] = o;
	      }
	    }
	    tween.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
	        i = -1,
	        n = tween.length;
	
	    while (++i < n) {
	      tween[i].call(null, t);
	    }
	
	    // Dispatch the end event.
	    if (self.state === ENDING) {
	      self.on.call("end", node, node.__data__, self.index, self.group);
	      stop();
	    }
	  }
	
	  function stop() {
	    self.state = ENDED;
	    self.timer.stop();
	    delete schedules[id];
	    for (var i in schedules) return; // eslint-disable-line no-unused-vars
	    delete node.__transition;
	  }
	}
	
	var interrupt = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      active,
	      empty = true,
	      i;
	
	  if (!schedules) return;
	
	  name = name == null ? null : name + "";
	
	  for (i in schedules) {
	    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
	    active = schedule.state > STARTING && schedule.state < ENDING;
	    schedule.state = ENDED;
	    schedule.timer.stop();
	    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
	    delete schedules[i];
	  }
	
	  if (empty) delete node.__transition;
	};
	
	var selection_interrupt = function(name) {
	  return this.each(function() {
	    interrupt(this, name);
	  });
	};
	
	function tweenRemove(id, name) {
	  var tween0, tween1;
	  return function() {
	    var schedule = set(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = tween0 = tween;
	      for (var i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1 = tween1.slice();
	          tween1.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	function tweenFunction(id, name, value) {
	  var tween0, tween1;
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    var schedule = set(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = (tween0 = tween).slice();
	      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1[i] = t;
	          break;
	        }
	      }
	      if (i === n) tween1.push(t);
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	var transition_tween = function(name, value) {
	  var id = this._id;
	
	  name += "";
	
	  if (arguments.length < 2) {
	    var tween = get(this.node(), id).tween;
	    for (var i = 0, n = tween.length, t; i < n; ++i) {
	      if ((t = tween[i]).name === name) {
	        return t.value;
	      }
	    }
	    return null;
	  }
	
	  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
	};
	
	function tweenValue(transition, name, value) {
	  var id = transition._id;
	
	  transition.each(function() {
	    var schedule = set(this, id);
	    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
	  });
	
	  return function(node) {
	    return get(node, id).value[name];
	  };
	}
	
	var interpolate = function(a, b) {
	  var c;
	  return (typeof b === "number" ? d3Interpolate.interpolateNumber
	      : b instanceof d3Color.color ? d3Interpolate.interpolateRgb
	      : (c = d3Color.color(b)) ? (b = c, d3Interpolate.interpolateRgb)
	      : d3Interpolate.interpolateString)(a, b);
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrConstantNS(fullname, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrFunction(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttribute(name);
	    value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function attrFunctionNS(fullname, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
	    value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_attr = function(name, value) {
	  var fullname = d3Selection.namespace(name), i = fullname === "transform" ? d3Interpolate.interpolateTransformSvg : interpolate;
	  return this.attrTween(name, typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
	      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
	      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
	};
	
	function attrTweenNS(fullname, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttributeNS(fullname.space, fullname.local, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	function attrTween(name, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttribute(name, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_attrTween = function(name, value) {
	  var key = "attr." + name;
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  var fullname = d3Selection.namespace(name);
	  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
	};
	
	function delayFunction(id, value) {
	  return function() {
	    init(this, id).delay = +value.apply(this, arguments);
	  };
	}
	
	function delayConstant(id, value) {
	  return value = +value, function() {
	    init(this, id).delay = value;
	  };
	}
	
	var transition_delay = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? delayFunction
	          : delayConstant)(id, value))
	      : get(this.node(), id).delay;
	};
	
	function durationFunction(id, value) {
	  return function() {
	    set(this, id).duration = +value.apply(this, arguments);
	  };
	}
	
	function durationConstant(id, value) {
	  return value = +value, function() {
	    set(this, id).duration = value;
	  };
	}
	
	var transition_duration = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? durationFunction
	          : durationConstant)(id, value))
	      : get(this.node(), id).duration;
	};
	
	function easeConstant(id, value) {
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    set(this, id).ease = value;
	  };
	}
	
	var transition_ease = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each(easeConstant(id, value))
	      : get(this.node(), id).ease;
	};
	
	var transition_filter = function(match) {
	  if (typeof match !== "function") match = d3Selection.matcher(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, this._name, this._id);
	};
	
	var transition_merge = function(transition) {
	  if (transition._id !== this._id) throw new Error;
	
	  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Transition(merges, this._parents, this._name, this._id);
	};
	
	function start(name) {
	  return (name + "").trim().split(/^|\s+/).every(function(t) {
	    var i = t.indexOf(".");
	    if (i >= 0) t = t.slice(0, i);
	    return !t || t === "start";
	  });
	}
	
	function onFunction(id, name, listener) {
	  var on0, on1, sit = start(name) ? init : set;
	  return function() {
	    var schedule = sit(this, id),
	        on = schedule.on;
	
	    // If this node shared a dispatch with the previous node,
	    // just assign the updated shared dispatch and we’re done!
	    // Otherwise, copy-on-write.
	    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
	
	    schedule.on = on1;
	  };
	}
	
	var transition_on = function(name, listener) {
	  var id = this._id;
	
	  return arguments.length < 2
	      ? get(this.node(), id).on.on(name)
	      : this.each(onFunction(id, name, listener));
	};
	
	function removeFunction(id) {
	  return function() {
	    var parent = this.parentNode;
	    for (var i in this.__transition) if (+i !== id) return;
	    if (parent) parent.removeChild(this);
	  };
	}
	
	var transition_remove = function() {
	  return this.on("end.remove", removeFunction(this._id));
	};
	
	var transition_select = function(select) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select !== "function") select = d3Selection.selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	        schedule(subgroup[i], name, id, i, subgroup, get(node, id));
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, name, id);
	};
	
	var transition_selectAll = function(select) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select !== "function") select = d3Selection.selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        for (var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k) {
	          if (child = children[k]) {
	            schedule(child, name, id, k, children, inherit);
	          }
	        }
	        subgroups.push(children);
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, parents, name, id);
	};
	
	var Selection = d3Selection.selection.prototype.constructor;
	
	var transition_selection = function() {
	  return new Selection(this._groups, this._parents);
	};
	
	function styleRemove(name, interpolate$$1) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0 = d3Selection.style(this, name),
	        value1 = (this.style.removeProperty(name), d3Selection.style(this, name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function styleRemoveEnd(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = d3Selection.style(this, name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function styleFunction(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0 = d3Selection.style(this, name),
	        value1 = value(this);
	    if (value1 == null) value1 = (this.style.removeProperty(name), d3Selection.style(this, name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_style = function(name, value, priority) {
	  var i = (name += "") === "transform" ? d3Interpolate.interpolateTransformCss : interpolate;
	  return value == null ? this
	          .styleTween(name, styleRemove(name, i))
	          .on("end.style." + name, styleRemoveEnd(name))
	      : this.styleTween(name, typeof value === "function"
	          ? styleFunction(name, i, tweenValue(this, "style." + name, value))
	          : styleConstant(name, i, value + ""), priority);
	};
	
	function styleTween(name, value, priority) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.style.setProperty(name, i(t), priority);
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_styleTween = function(name, value, priority) {
	  var key = "style." + (name += "");
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
	};
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var value1 = value(this);
	    this.textContent = value1 == null ? "" : value1;
	  };
	}
	
	var transition_text = function(value) {
	  return this.tween("text", typeof value === "function"
	      ? textFunction(tweenValue(this, "text", value))
	      : textConstant(value == null ? "" : value + ""));
	};
	
	var transition_transition = function() {
	  var name = this._name,
	      id0 = this._id,
	      id1 = newId();
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        var inherit = get(node, id0);
	        schedule(node, name, id1, i, group, {
	          time: inherit.time + inherit.delay + inherit.duration,
	          delay: 0,
	          duration: inherit.duration,
	          ease: inherit.ease
	        });
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id1);
	};
	
	var id = 0;
	
	function Transition(groups, parents, name, id) {
	  this._groups = groups;
	  this._parents = parents;
	  this._name = name;
	  this._id = id;
	}
	
	function transition(name) {
	  return d3Selection.selection().transition(name);
	}
	
	function newId() {
	  return ++id;
	}
	
	var selection_prototype = d3Selection.selection.prototype;
	
	Transition.prototype = transition.prototype = {
	  constructor: Transition,
	  select: transition_select,
	  selectAll: transition_selectAll,
	  filter: transition_filter,
	  merge: transition_merge,
	  selection: transition_selection,
	  transition: transition_transition,
	  call: selection_prototype.call,
	  nodes: selection_prototype.nodes,
	  node: selection_prototype.node,
	  size: selection_prototype.size,
	  empty: selection_prototype.empty,
	  each: selection_prototype.each,
	  on: transition_on,
	  attr: transition_attr,
	  attrTween: transition_attrTween,
	  style: transition_style,
	  styleTween: transition_styleTween,
	  text: transition_text,
	  remove: transition_remove,
	  tween: transition_tween,
	  delay: transition_delay,
	  duration: transition_duration,
	  ease: transition_ease
	};
	
	var defaultTiming = {
	  time: null, // Set on use.
	  delay: 0,
	  duration: 250,
	  ease: d3Ease.easeCubicInOut
	};
	
	function inherit(node, id) {
	  var timing;
	  while (!(timing = node.__transition) || !(timing = timing[id])) {
	    if (!(node = node.parentNode)) {
	      return defaultTiming.time = d3Timer.now(), defaultTiming;
	    }
	  }
	  return timing;
	}
	
	var selection_transition = function(name) {
	  var id,
	      timing;
	
	  if (name instanceof Transition) {
	    id = name._id, name = name._name;
	  } else {
	    id = newId(), (timing = defaultTiming).time = d3Timer.now(), name = name == null ? null : name + "";
	  }
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        schedule(node, name, id, i, group, timing || inherit(node, id));
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id);
	};
	
	d3Selection.selection.prototype.interrupt = selection_interrupt;
	d3Selection.selection.prototype.transition = selection_transition;
	
	var root = [null];
	
	var active = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      i;
	
	  if (schedules) {
	    name = name == null ? null : name + "";
	    for (i in schedules) {
	      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
	        return new Transition([[node]], root, name, +i);
	      }
	    }
	  }
	
	  return null;
	};
	
	exports.transition = transition;
	exports.active = active;
	exports.interrupt = interrupt;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-chord/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(531), __webpack_require__(543)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Path) { 'use strict';
	
	var cos = Math.cos;
	var sin = Math.sin;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = pi * 2;
	var max = Math.max;
	
	function compareValue(compare) {
	  return function(a, b) {
	    return compare(
	      a.source.value + a.target.value,
	      b.source.value + b.target.value
	    );
	  };
	}
	
	var chord = function() {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = d3Array.range(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1; while (++i < n) {
	      x = 0, j = -1; while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push(d3Array.range(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function(a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
	      d.sort(function(a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = max(0, tau - padAngle * n) / k;
	    dx = k ? padAngle : tau / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1; while (++i < n) {
	      x0 = x, j = -1; while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1; while (++i < n) {
	      j = i - 1; while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value
	              ? {source: target, target: source}
	              : {source: source, target: target});
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function(_) {
	    return arguments.length ? (padAngle = max(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function(_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function(_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function(_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	};
	
	var slice = Array.prototype.slice;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}
	
	var ribbon = function() {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = slice.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - halfPi,
	        sa1 = endAngle.apply(this, argv) - halfPi,
	        sx0 = sr * cos(sa0),
	        sy0 = sr * sin(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - halfPi,
	        ta1 = endAngle.apply(this, argv) - halfPi;
	
	    if (!context) context = buffer = d3Path.path();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function(_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function(_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
	  };
	
	  return ribbon;
	};
	
	exports.chord = chord;
	exports.ribbon = ribbon;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-contour/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(531)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	var array = Array.prototype;
	
	var slice = array.slice;
	
	var ascending = function(a, b) {
	  return a - b;
	};
	
	var area = function(ring) {
	  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
	  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
	  return area;
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var contains = function(ring, hole) {
	  var i = -1, n = hole.length, c;
	  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
	  return 0;
	};
	
	function ringContains(ring, point) {
	  var x = point[0], y = point[1], contains = -1;
	  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
	    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
	    if (segmentContains(pi, pj, point)) return 0;
	    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
	  }
	  return contains;
	}
	
	function segmentContains(a, b, c) {
	  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
	}
	
	function collinear(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
	}
	
	function within(p, q, r) {
	  return p <= q && q <= r || r <= q && q <= p;
	}
	
	var noop = function() {};
	
	var cases = [
	  [],
	  [[[1.0, 1.5], [0.5, 1.0]]],
	  [[[1.5, 1.0], [1.0, 1.5]]],
	  [[[1.5, 1.0], [0.5, 1.0]]],
	  [[[1.0, 0.5], [1.5, 1.0]]],
	  [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]],
	  [[[1.0, 0.5], [1.0, 1.5]]],
	  [[[1.0, 0.5], [0.5, 1.0]]],
	  [[[0.5, 1.0], [1.0, 0.5]]],
	  [[[1.0, 1.5], [1.0, 0.5]]],
	  [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]],
	  [[[1.5, 1.0], [1.0, 0.5]]],
	  [[[0.5, 1.0], [1.5, 1.0]]],
	  [[[1.0, 1.5], [1.5, 1.0]]],
	  [[[0.5, 1.0], [1.0, 1.5]]],
	  []
	];
	
	var contours = function() {
	  var dx = 1,
	      dy = 1,
	      threshold = d3Array.thresholdSturges,
	      smooth = smoothLinear;
	
	  function contours(values) {
	    var tz = threshold(values);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      var domain = d3Array.extent(values), start = domain[0], stop = domain[1];
	      tz = d3Array.tickStep(start, stop, tz);
	      tz = d3Array.range(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
	    } else {
	      tz = tz.slice().sort(ascending);
	    }
	
	    return tz.map(function(value) {
	      return contour(values, value);
	    });
	  }
	
	  // Accumulate, smooth contour rings, assign holes to exterior rings.
	  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
	  function contour(values, value) {
	    var polygons = [],
	        holes = [];
	
	    isorings(values, value, function(ring) {
	      smooth(ring, values, value);
	      if (area(ring) > 0) polygons.push([ring]);
	      else holes.push(ring);
	    });
	
	    holes.forEach(function(hole) {
	      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
	        if (contains((polygon = polygons[i])[0], hole) !== -1) {
	          polygon.push(hole);
	          return;
	        }
	      }
	    });
	
	    return {
	      type: "MultiPolygon",
	      value: value,
	      coordinates: polygons
	    };
	  }
	
	  // Marching squares with isolines stitched into rings.
	  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
	  function isorings(values, value, callback) {
	    var fragmentByStart = new Array,
	        fragmentByEnd = new Array,
	        x, y, t0, t1, t2, t3;
	
	    // Special case for the first row (y = -1, t2 = t3 = 0).
	    x = y = -1;
	    t1 = values[0] >= value;
	    cases[t1 << 1].forEach(stitch);
	    while (++x < dx - 1) {
	      t0 = t1, t1 = values[x + 1] >= value;
	      cases[t0 | t1 << 1].forEach(stitch);
	    }
	    cases[t1 << 0].forEach(stitch);
	
	    // General case for the intermediate rows.
	    while (++y < dy - 1) {
	      x = -1;
	      t1 = values[y * dx + dx] >= value;
	      t2 = values[y * dx] >= value;
	      cases[t1 << 1 | t2 << 2].forEach(stitch);
	      while (++x < dx - 1) {
	        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
	        t3 = t2, t2 = values[y * dx + x + 1] >= value;
	        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
	      }
	      cases[t1 | t2 << 3].forEach(stitch);
	    }
	
	    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
	    x = -1;
	    t2 = values[y * dx] >= value;
	    cases[t2 << 2].forEach(stitch);
	    while (++x < dx - 1) {
	      t3 = t2, t2 = values[y * dx + x + 1] >= value;
	      cases[t2 << 2 | t3 << 3].forEach(stitch);
	    }
	    cases[t2 << 3].forEach(stitch);
	
	    function stitch(line) {
	      var start = [line[0][0] + x, line[0][1] + y],
	          end = [line[1][0] + x, line[1][1] + y],
	          startIndex = index(start),
	          endIndex = index(end),
	          f, g;
	      if (f = fragmentByEnd[startIndex]) {
	        if (g = fragmentByStart[endIndex]) {
	          delete fragmentByEnd[f.end];
	          delete fragmentByStart[g.start];
	          if (f === g) {
	            f.ring.push(end);
	            callback(f.ring);
	          } else {
	            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
	          }
	        } else {
	          delete fragmentByEnd[f.end];
	          f.ring.push(end);
	          fragmentByEnd[f.end = endIndex] = f;
	        }
	      } else if (f = fragmentByStart[endIndex]) {
	        if (g = fragmentByEnd[startIndex]) {
	          delete fragmentByStart[f.start];
	          delete fragmentByEnd[g.end];
	          if (f === g) {
	            f.ring.push(end);
	            callback(f.ring);
	          } else {
	            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
	          }
	        } else {
	          delete fragmentByStart[f.start];
	          f.ring.unshift(start);
	          fragmentByStart[f.start = startIndex] = f;
	        }
	      } else {
	        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
	      }
	    }
	  }
	
	  function index(point) {
	    return point[0] * 2 + point[1] * (dx + 1) * 4;
	  }
	
	  function smoothLinear(ring, values, value) {
	    ring.forEach(function(point) {
	      var x = point[0],
	          y = point[1],
	          xt = x | 0,
	          yt = y | 0,
	          v0,
	          v1 = values[yt * dx + xt];
	      if (x > 0 && x < dx && xt === x) {
	        v0 = values[yt * dx + xt - 1];
	        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
	      }
	      if (y > 0 && y < dy && yt === y) {
	        v0 = values[(yt - 1) * dx + xt];
	        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
	      }
	    });
	  }
	
	  contours.contour = contour;
	
	  contours.size = function(_) {
	    if (!arguments.length) return [dx, dy];
	    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
	    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
	    return dx = _0, dy = _1, contours;
	  };
	
	  contours.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), contours) : threshold;
	  };
	
	  contours.smooth = function(_) {
	    return arguments.length ? (smooth = _ ? smoothLinear : noop, contours) : smooth === smoothLinear;
	  };
	
	  return contours;
	};
	
	// TODO Optimize edge cases.
	// TODO Optimize index calculation.
	// TODO Optimize arguments.
	function blurX(source, target, r) {
	  var n = source.width,
	      m = source.height,
	      w = (r << 1) + 1;
	  for (var j = 0; j < m; ++j) {
	    for (var i = 0, sr = 0; i < n + r; ++i) {
	      if (i < n) {
	        sr += source.data[i + j * n];
	      }
	      if (i >= r) {
	        if (i >= w) {
	          sr -= source.data[i - w + j * n];
	        }
	        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
	      }
	    }
	  }
	}
	
	// TODO Optimize edge cases.
	// TODO Optimize index calculation.
	// TODO Optimize arguments.
	function blurY(source, target, r) {
	  var n = source.width,
	      m = source.height,
	      w = (r << 1) + 1;
	  for (var i = 0; i < n; ++i) {
	    for (var j = 0, sr = 0; j < m + r; ++j) {
	      if (j < m) {
	        sr += source.data[i + j * n];
	      }
	      if (j >= r) {
	        if (j >= w) {
	          sr -= source.data[i + (j - w) * n];
	        }
	        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
	      }
	    }
	  }
	}
	
	function defaultX(d) {
	  return d[0];
	}
	
	function defaultY(d) {
	  return d[1];
	}
	
	var density = function() {
	  var x = defaultX,
	      y = defaultY,
	      dx = 960,
	      dy = 500,
	      r = 20, // blur radius
	      k = 2, // log2(grid cell size)
	      o = r * 3, // grid offset, to pad for blur
	      n = (dx + o * 2) >> k, // grid width
	      m = (dy + o * 2) >> k, // grid height
	      threshold = constant(20);
	
	  function density(data) {
	    var values0 = new Float32Array(n * m),
	        values1 = new Float32Array(n * m);
	
	    data.forEach(function(d, i, data) {
	      var xi = (x(d, i, data) + o) >> k,
	          yi = (y(d, i, data) + o) >> k;
	      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
	        ++values0[xi + yi * n];
	      }
	    });
	
	    // TODO Optimize.
	    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
	    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
	    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
	    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
	    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
	    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
	
	    var tz = threshold(values0);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      var stop = d3Array.max(values0);
	      tz = d3Array.tickStep(0, stop, tz);
	      tz = d3Array.range(0, Math.floor(stop / tz) * tz, tz);
	      tz.shift();
	    }
	
	    return contours()
	        .thresholds(tz)
	        .size([n, m])
	      (values0)
	        .map(transform);
	  }
	
	  function transform(geometry) {
	    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
	    geometry.coordinates.forEach(transformPolygon);
	    return geometry;
	  }
	
	  function transformPolygon(coordinates) {
	    coordinates.forEach(transformRing);
	  }
	
	  function transformRing(coordinates) {
	    coordinates.forEach(transformPoint);
	  }
	
	  // TODO Optimize.
	  function transformPoint(coordinates) {
	    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
	    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
	  }
	
	  function resize() {
	    o = r * 3;
	    n = (dx + o * 2) >> k;
	    m = (dy + o * 2) >> k;
	    return density;
	  }
	
	  density.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), density) : x;
	  };
	
	  density.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), density) : y;
	  };
	
	  density.size = function(_) {
	    if (!arguments.length) return [dx, dy];
	    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
	    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
	    return dx = _0, dy = _1, resize();
	  };
	
	  density.cellSize = function(_) {
	    if (!arguments.length) return 1 << k;
	    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
	    return k = Math.floor(Math.log(_) / Math.LN2), resize();
	  };
	
	  density.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), density) : threshold;
	  };
	
	  density.bandwidth = function(_) {
	    if (!arguments.length) return Math.sqrt(r * (r + 1));
	    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
	    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
	  };
	
	  return density;
	};
	
	exports.contours = contours;
	exports.contourDensity = density;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dsv/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var EOL = {};
	var EOF = {};
	var QUOTE = 34;
	var NEWLINE = 10;
	var RETURN = 13;
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
	      DELIMITER = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns || [];
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // current line number
	        t, // current token
	        eof = N <= 0, // current token followed by EOF?
	        eol = false; // current token followed by EOL?
	
	    // Strip the trailing newline.
	    if (text.charCodeAt(N - 1) === NEWLINE) --N;
	    if (text.charCodeAt(N - 1) === RETURN) --N;
	
	    function token() {
	      if (eof) return EOF;
	      if (eol) return eol = false, EOL;
	
	      // Unescape quotes.
	      var i, j = I, c;
	      if (text.charCodeAt(j) === QUOTE) {
	        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
	        if ((i = I) >= N) eof = true;
	        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
	        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
	        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
	      }
	
	      // Find next delimiter or newline.
	      while (I < N) {
	        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
	        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
	        else if (c !== DELIMITER) continue;
	        return text.slice(j, i);
	      }
	
	      // Return last token before EOF.
	      return eof = true, text.slice(j, N);
	    }
	
	    while ((t = token()) !== EOF) {
	      var row = [];
	      while (t !== EOL && t !== EOF) row.push(t), t = token();
	      if (f && (row = f(row, n++)) == null) continue;
	      rows.push(row);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-fetch/ Version 1.1.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(546)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-dsv'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Dsv) { 'use strict';
	
	function responseBlob(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.blob();
	}
	
	function blob(input, init) {
	  return fetch(input, init).then(responseBlob);
	}
	
	function responseArrayBuffer(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.arrayBuffer();
	}
	
	function buffer(input, init) {
	  return fetch(input, init).then(responseArrayBuffer);
	}
	
	function responseText(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.text();
	}
	
	function text(input, init) {
	  return fetch(input, init).then(responseText);
	}
	
	function dsvParse(parse) {
	  return function(input, init, row) {
	    if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
	    return text(input, init).then(function(response) {
	      return parse(response, row);
	    });
	  };
	}
	
	function dsv(delimiter, input, init, row) {
	  if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
	  var format = d3Dsv.dsvFormat(delimiter);
	  return text(input, init).then(function(response) {
	    return format.parse(response, row);
	  });
	}
	
	var csv = dsvParse(d3Dsv.csvParse);
	var tsv = dsvParse(d3Dsv.tsvParse);
	
	function image(input, init) {
	  return new Promise(function(resolve, reject) {
	    var image = new Image;
	    for (var key in init) image[key] = init[key];
	    image.onerror = reject;
	    image.onload = function() { resolve(image); };
	    image.src = input;
	  });
	}
	
	function responseJson(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.json();
	}
	
	function json(input, init) {
	  return fetch(input, init).then(responseJson);
	}
	
	function parser(type) {
	  return function(input, init)  {
	    return text(input, init).then(function(text$$1) {
	      return (new DOMParser).parseFromString(text$$1, type);
	    });
	  };
	}
	
	var xml = parser("application/xml");
	
	var html = parser("text/html");
	
	var svg = parser("image/svg+xml");
	
	exports.blob = blob;
	exports.buffer = buffer;
	exports.dsv = dsv;
	exports.csv = csv;
	exports.tsv = tsv;
	exports.image = image;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.html = html;
	exports.svg = svg;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-force/ Version 1.1.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(549), __webpack_require__(544), __webpack_require__(534), __webpack_require__(540)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-quadtree', 'd3-collection', 'd3-dispatch', 'd3-timer'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Quadtree,d3Collection,d3Dispatch,d3Timer) { 'use strict';
	
	var center = function(x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var jiggle = function() {
	  return (Math.random() - 0.5) * 1e-6;
	};
	
	function x(d) {
	  return d.x + d.vx;
	}
	
	function y(d) {
	  return d.y + d.vy;
	}
	
	var collide = function(radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);
	
	  function force() {
	    var i, n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = d3Quadtree.quadtree(nodes, x, y).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[node.index], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data, rj = quad.r, r = ri + rj;
	      if (data) {
	        if (data.index > node.index) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = jiggle(), l += x * x;
	            if (y === 0) y = jiggle(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    radii = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
	  };
	
	  return force;
	};
	
	function index(d) {
	  return d.index;
	}
	
	function find(nodeById, nodeId) {
	  var node = nodeById.get(nodeId);
	  if (!node) throw new Error("missing: " + nodeId);
	  return node;
	}
	
	var link = function(links) {
	  var id = index,
	      strength = defaultStrength,
	      strengths,
	      distance = constant(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || jiggle();
	        y = target.y + target.vy - source.y - source.vy || jiggle();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = d3Collection.map(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < m; ++i) {
	      link = links[i], link.index = i;
	      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
	      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
	      count[link.source.index] = (count[link.source.index] || 0) + 1;
	      count[link.target.index] = (count[link.target.index] || 0) + 1;
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function(_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function(_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function(_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : constant(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	};
	
	function x$1(d) {
	  return d.x;
	}
	
	function y$1(d) {
	  return d.y;
	}
	
	var initialRadius = 10;
	var initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	var simulation = function(nodes) {
	  var simulation,
	      alpha = 1,
	      alphaMin = 0.001,
	      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	      alphaTarget = 0,
	      velocityDecay = 0.6,
	      forces = d3Collection.map(),
	      stepper = d3Timer.timer(step),
	      event = d3Dispatch.dispatch("tick", "end");
	
	  if (nodes == null) nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (alpha < alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i, n = nodes.length, node;
	
	    alpha += (alphaTarget - alpha) * alphaDecay;
	
	    forces.each(function(force) {
	      force(alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i];
	      if (node.fx == null) node.x += node.vx *= velocityDecay;
	      else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= velocityDecay;
	      else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function(_) {
	      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	    },
	
	    alpha: function(_) {
	      return arguments.length ? (alpha = +_, simulation) : alpha;
	    },
	
	    alphaMin: function(_) {
	      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	    },
	
	    alphaDecay: function(_) {
	      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	    },
	
	    alphaTarget: function(_) {
	      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	    },
	
	    velocityDecay: function(_) {
	      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	    },
	
	    force: function(name, _) {
	      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	    },
	
	    find: function(x, y, radius) {
	      var i = 0,
	          n = nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;
	      else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	};
	
	var manyBody = function() {
	  var nodes,
	      node,
	      alpha,
	      strength = constant(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i, n = nodes.length, tree = d3Quadtree.quadtree(nodes, x$1, y$1).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
	  }
	
	  function accumulate(quad) {
	    var strength = 0, q, c, weight = 0, x, y, i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x = y = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = Math.abs(q.value))) {
	          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
	        }
	      }
	      quad.x = x / weight;
	      quad.y = y / weight;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	      q = quad;
	      q.x = q.data.x;
	      q.y = q.data.y;
	      do strength += strengths[q.data.index];
	      while (q = q.next);
	    }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x = quad.x - node.x,
	        y = quad.y - node.y,
	        w = x2 - x1,
	        l = x * x + y * y;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x === 0) x = jiggle(), l += x * x;
	        if (y === 0) y = jiggle(), l += y * y;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x * quad.value * alpha / l;
	        node.vy += y * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x === 0) x = jiggle(), l += x * x;
	      if (y === 0) y = jiggle(), l += y * y;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do if (quad.data !== node) {
	      w = strengths[quad.data.index] * alpha / l;
	      node.vx += x * w;
	      node.vy += y * w;
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function(_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function(_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function(_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	};
	
	var radial = function(radius, x, y) {
	  var nodes,
	      strength = constant(0.1),
	      strengths,
	      radiuses;
	
	  if (typeof radius !== "function") radius = constant(+radius);
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length; i < n; ++i) {
	      var node = nodes[i],
	          dx = node.x - x || 1e-6,
	          dy = node.y - y || 1e-6,
	          r = Math.sqrt(dx * dx + dy * dy),
	          k = (radiuses[i] - r) * strengths[i] * alpha / r;
	      node.vx += dx * k;
	      node.vy += dy * k;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    radiuses = new Array(n);
	    for (i = 0; i < n; ++i) {
	      radiuses[i] = +radius(nodes[i], i, nodes);
	      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _, initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var x$2 = function(x) {
	  var strength = constant(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = constant(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), initialize(), force) : x;
	  };
	
	  return force;
	};
	
	var y$2 = function(y) {
	  var strength = constant(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = constant(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), initialize(), force) : y;
	  };
	
	  return force;
	};
	
	exports.forceCenter = center;
	exports.forceCollide = collide;
	exports.forceLink = link;
	exports.forceManyBody = manyBody;
	exports.forceRadial = radial;
	exports.forceSimulation = simulation;
	exports.forceX = x$2;
	exports.forceY = y$2;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-quadtree/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var tree_add = function(d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	};
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = {data: d},
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d, i, n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}
	
	var tree_cover = function(x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	    var z = x1 - x0,
	        node = this._root,
	        parent,
	        i;
	
	    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	      case 0: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	        break;
	      }
	      case 1: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	        break;
	      }
	      case 2: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	        break;
	      }
	      case 3: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	        break;
	      }
	    }
	
	    if (this._root && this._root.length) this._root = node;
	  }
	
	  // If the quadtree covers the point already, just return.
	  else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	};
	
	var tree_data = function() {
	  var data = [];
	  this.visit(function(node) {
	    if (!node.length) do data.push(node.data); while (node = node.next)
	  });
	  return data;
	};
	
	var tree_extent = function(_) {
	  return arguments.length
	      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	};
	
	var Quad = function(node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	};
	
	var tree_find = function(x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;
	  else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node)
	        || (x1 = q.x0) > x3
	        || (y1 = q.y0) > y3
	        || (x2 = q.x1) < x0
	        || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(
	        new Quad(node[3], xm, ym, x2, y2),
	        new Quad(node[2], x1, ym, xm, y2),
	        new Quad(node[1], xm, y1, x2, ym),
	        new Quad(node[0], x1, y1, xm, ym)
	      );
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | (x >= xm)) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	      var dx = x - +this._x.call(null, node.data),
	          dy = y - +this._y.call(null, node.data),
	          d2 = dx * dx + dy * dy;
	      if (d2 < radius) {
	        var d = Math.sqrt(radius = d2);
	        x0 = x - d, y0 = y - d;
	        x3 = x + d, y3 = y + d;
	        data = node.data;
	      }
	    }
	  }
	
	  return data;
	};
	
	var tree_remove = function(d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	  if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	      && node === (parent[3] || parent[2] || parent[1] || parent[0])
	      && !node.length) {
	    if (retainer) retainer[j] = node;
	    else this._root = node;
	  }
	
	  return this;
	};
	
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	  return this;
	}
	
	var tree_root = function() {
	  return this._root;
	};
	
	var tree_size = function() {
	  var size = 0;
	  this.visit(function(node) {
	    if (!node.length) do ++size; while (node = node.next)
	  });
	  return size;
	};
	
	var tree_visit = function(callback) {
	  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	};
	
	var tree_visitAfter = function(callback) {
	  var quads = [], next = [], q;
	  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	};
	
	function defaultX(d) {
	  return d[0];
	}
	
	var tree_x = function(_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	};
	
	function defaultY(d) {
	  return d[1];
	}
	
	var tree_y = function(_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	};
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = {data: leaf.data}, next = copy;
	  while (leaf = leaf.next) next = next.next = {data: leaf.data};
	  return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function() {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{source: node, target: copy._root = new Array(4)}];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	        else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = tree_add;
	treeProto.addAll = addAll;
	treeProto.cover = tree_cover;
	treeProto.data = tree_data;
	treeProto.extent = tree_extent;
	treeProto.find = tree_find;
	treeProto.remove = tree_remove;
	treeProto.removeAll = removeAll;
	treeProto.root = tree_root;
	treeProto.size = tree_size;
	treeProto.visit = tree_visit;
	treeProto.visitAfter = tree_visitAfter;
	treeProto.x = tree_x;
	treeProto.y = tree_y;
	
	exports.quadtree = quadtree;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.3.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  this.fill = match[1] || " ";
	  this.align = match[2] || ">";
	  this.sign = match[3] || "-";
	  this.symbol = match[4] || "";
	  this.zero = !!match[5];
	  this.width = match[6] && +match[6];
	  this.comma = !!match[7];
	  this.precision = match[8] && +match[8].slice(1);
	  this.trim = !!match[9];
	  this.type = match[10] || "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	var formatTrim = function(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo/ Version 1.10.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(531)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	function adder() {
	  return new Adder;
	}
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add(temp, y, this.t);
	    add(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var tau = pi * 2;
	
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log = Math.log;
	var pow = Math.pow;
	var sin = Math.sin;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin(x / 2)) * x;
	}
	
	function noop() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(object, stream) {
	    streamGeometry(object.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	function geoStream(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	}
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop;
	  },
	  sphere: function() {
	    areaSum.add(tau);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos(phi = phi / 2 + quarterPi), sinPhi0 = sin(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos(phi),
	      sinPhi = sin(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos(adLambda),
	      v = k * sdLambda * sin(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	function area(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	}
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
	  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon) phi1 = 90;
	    else if (deltaSum < -epsilon) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  }
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range$$1, x) {
	  return range$$1[0] <= range$$1[1] ? range$$1[0] <= x && x <= range$$1[1] : x < range$$1[0] || range$$1[1] < x;
	}
	
	function bounds(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	}
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt(cx * cx + cy * cy + cz * cz),
	      w = asin(m), // line weight = angle
	      v = m && -w / m; // area weight multiplier
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroid(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees, asin(z / sqrt(m)) * degrees];
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function compose(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	}
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos(deltaPhi),
	      sinDeltaPhi = sin(deltaPhi),
	      cosDeltaGamma = cos(deltaGamma),
	      sinDeltaGamma = sin(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	function rotation(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  };
	
	  return forward;
	}
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos(radius),
	      sinRadius = sin(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
	}
	
	function circle() {
	  var center = constant([0, 0]),
	      radius = constant(90),
	      precision = constant(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees, x[1] *= degrees;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
	  };
	
	  return circle;
	}
	
	function clipBuffer() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	}
	
	function pointEqual(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	}
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	function clipRejoin(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link(subject);
	  link(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	}
	
	function link(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var sum = adder();
	
	function polygonContains(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      sinPhi = sin(phi),
	      normal = [sin(lambda), -cos(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum.reset();
	
	  if (sinPhi === 1) phi = halfPi + epsilon;
	  else if (sinPhi === -1) phi = -halfPi - epsilon;
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin(phi0),
	        cosPhi0 = cos(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin(phi1),
	          cosPhi1 = cos(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi,
	          k = sinPhi0 * sinPhi1;
	
	      sum.add(atan2(k * sign$$1 * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon || angle < epsilon && sum < -epsilon) ^ (winding & 1);
	}
	
	function clip(pointVisible, clipLine, interpolate, start) {
	  return function(sink) {
	    var line = clipLine(sink),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = d3Array.merge(segments);
	        var startInside = polygonContains(polygon, start);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      line.point(lambda, phi);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      ringSink.point(lambda, phi);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	}
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi, -halfPi]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi : -pi,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi) < epsilon) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon
	      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
	          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi;
	    stream.point(-pi, phi);
	    stream.point(0, phi);
	    stream.point(pi, phi);
	    stream.point(pi, 0);
	    stream.point(pi, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi, -phi);
	    stream.point(-pi, 0);
	    stream.point(-pi, phi);
	  } else if (abs(from[0] - to[0]) > epsilon) {
	    var lambda = from[0] < to[0] ? pi : -pi;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	function clipCircle(radius) {
	  var cr = cos(radius),
	      delta = 6 * radians,
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos(lambda) * cos(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon;
	            point1[1] += epsilon;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi) < epsilon,
	        meridian = polar || delta < epsilon;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
	}
	
	function clipLine(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipRectangle(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = d3Array.merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	function extent() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	}
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop,
	  point: noop,
	  lineStart: lengthLineStart,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin(phi), cosPhi0$1 = cos(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin(phi),
	      cosPhi = cos(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos(delta),
	      sinDelta = sin(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	function length(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	}
	
	var coordinates = [null, null];
	var object = {type: "LineString", coordinates: coordinates};
	
	function distance(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length(object);
	}
	
	var containsObjectType = {
	  Feature: function(object, point) {
	    return containsGeometry(object.geometry, point);
	  },
	  FeatureCollection: function(object, point) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
	    return false;
	  }
	};
	
	var containsGeometryType = {
	  Sphere: function() {
	    return true;
	  },
	  Point: function(object, point) {
	    return containsPoint(object.coordinates, point);
	  },
	  MultiPoint: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
	    return false;
	  },
	  LineString: function(object, point) {
	    return containsLine(object.coordinates, point);
	  },
	  MultiLineString: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsLine(coordinates[i], point)) return true;
	    return false;
	  },
	  Polygon: function(object, point) {
	    return containsPolygon(object.coordinates, point);
	  },
	  MultiPolygon: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
	    return false;
	  },
	  GeometryCollection: function(object, point) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
	    return false;
	  }
	};
	
	function containsGeometry(geometry, point) {
	  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
	      ? containsGeometryType[geometry.type](geometry, point)
	      : false;
	}
	
	function containsPoint(coordinates, point) {
	  return distance(coordinates, point) === 0;
	}
	
	function containsLine(coordinates, point) {
	  var ab = distance(coordinates[0], coordinates[1]),
	      ao = distance(coordinates[0], point),
	      ob = distance(point, coordinates[1]);
	  return ao + ob <= ab + epsilon;
	}
	
	function containsPolygon(coordinates, point) {
	  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
	}
	
	function ringRadians(ring) {
	  return ring = ring.map(pointRadians), ring.pop(), ring;
	}
	
	function pointRadians(point) {
	  return [point[0] * radians, point[1] * radians];
	}
	
	function contains(object, point) {
	  return (object && containsObjectType.hasOwnProperty(object.type)
	      ? containsObjectType[object.type]
	      : containsGeometry)(object, point);
	}
	
	function graticuleX(y0, y1, dy) {
	  var y = d3Array.range(y0, y1 - epsilon, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = d3Array.range(x0, x1 - epsilon, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return d3Array.range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(d3Array.range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(d3Array.range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon; }).map(x))
	        .concat(d3Array.range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]])
	      .extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	function interpolate(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos(y0),
	      sy0 = sin(y0),
	      cy1 = cos(y1),
	      sy1 = sin(y1),
	      kx0 = cy0 * cos(x0),
	      ky0 = cy0 * sin(x0),
	      kx1 = cy1 * cos(x1),
	      ky1 = cy1 * sin(x1),
	      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin(t *= d) / k,
	        A = sin(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees,
	      atan2(z, sqrt(x * x + y * y)) * degrees
	    ];
	  } : function() {
	    return [x0 * degrees, y0 * degrees];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	}
	
	function identity(x) {
	  return x;
	}
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau);
	        break;
	      }
	    }
	  },
	  result: noop
	};
	
	var lengthSum$1 = adder();
	var lengthRing;
	var x00$2;
	var y00$2;
	var x0$4;
	var y0$4;
	
	var lengthStream$1 = {
	  point: noop,
	  lineStart: function() {
	    lengthStream$1.point = lengthPointFirst$1;
	  },
	  lineEnd: function() {
	    if (lengthRing) lengthPoint$1(x00$2, y00$2);
	    lengthStream$1.point = noop;
	  },
	  polygonStart: function() {
	    lengthRing = true;
	  },
	  polygonEnd: function() {
	    lengthRing = null;
	  },
	  result: function() {
	    var length = +lengthSum$1;
	    lengthSum$1.reset();
	    return length;
	  }
	};
	
	function lengthPointFirst$1(x, y) {
	  lengthStream$1.point = lengthPoint$1;
	  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
	}
	
	function lengthPoint$1(x, y) {
	  x0$4 -= x, y0$4 -= y;
	  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
	  x0$4 = x, y0$4 = y;
	}
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _radius: 4.5,
	  _circle: circle$1(4.5),
	  pointRadius: function(_) {
	    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
	    return this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        if (this._circle == null) this._circle = circle$1(this._radius);
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    } else {
	      return null;
	    }
	  }
	};
	
	function circle$1(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	function index(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.measure = function(object) {
	    geoStream(object, projectionStream(lengthStream$1));
	    return lengthStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	}
	
	function transform(methods) {
	  return {
	    stream: transformer(methods)
	  };
	}
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fit(projection, fitBounds, object) {
	  var clip = projection.clipExtent && projection.clipExtent();
	  projection.scale(150).translate([0, 0]);
	  if (clip != null) projection.clipExtent(null);
	  geoStream(object, projection.stream(boundsStream$1));
	  fitBounds(boundsStream$1.result());
	  if (clip != null) projection.clipExtent(clip);
	  return projection;
	}
	
	function fitExtent(projection, extent, object) {
	  return fit(projection, function(b) {
	    var w = extent[1][0] - extent[0][0],
	        h = extent[1][1] - extent[0][1],
	        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	function fitWidth(projection, width, object) {
	  return fit(projection, function(b) {
	    var w = +width,
	        k = w / (b[1][0] - b[0][0]),
	        x = (w - k * (b[1][0] + b[0][0])) / 2,
	        y = -k * b[0][1];
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	function fitHeight(projection, height, object) {
	  return fit(projection, function(b) {
	    var h = +height,
	        k = h / (b[1][1] - b[0][1]),
	        x = -k * b[0][0],
	        y = (h - k * (b[1][1] + b[0][1])) / 2;
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos(30 * radians); // cos(minimum angular distance)
	
	function resample(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	}
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt(a * a + b * b + c * c),
	          phi2 = asin(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function transformRotate(rotate) {
	  return transformer({
	    point: function(x, y) {
	      var r = rotate(x, y);
	      return this.stream.point(r[0], r[1]);
	    }
	  });
	}
	
	function scaleTranslate(k, dx, dy) {
	  function transform$$1(x, y) {
	    return [dx + k * x, dy - k * y];
	  }
	  transform$$1.invert = function(x, y) {
	    return [(x - dx) / k, (dy - y) / k];
	  };
	  return transform$$1;
	}
	
	function scaleTranslateRotate(k, dx, dy, alpha) {
	  var cosAlpha = cos(alpha),
	      sinAlpha = sin(alpha),
	      a = cosAlpha * k,
	      b = sinAlpha * k,
	      ai = cosAlpha / k,
	      bi = sinAlpha / k,
	      ci = (sinAlpha * dy - cosAlpha * dx) / k,
	      fi = (sinAlpha * dx + cosAlpha * dy) / k;
	  function transform$$1(x, y) {
	    return [a * x - b * y + dx, dy - b * x - a * y];
	  }
	  transform$$1.invert = function(x, y) {
	    return [ai * x - bi * y + ci, fi - bi * x - ai * y];
	  };
	  return transform$$1;
	}
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, // pre-rotate
	      alpha = 0, // post-rotate
	      theta = null, preclip = clipAntimeridian, // pre-clip angle
	      x0 = null, y0, x1, y1, postclip = identity, // post-clip extent
	      delta2 = 0.5, // precision
	      projectResample,
	      projectTransform,
	      projectRotateTransform,
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    return projectRotateTransform(point[0] * radians, point[1] * radians);
	  }
	
	  function invert(point) {
	    point = projectRotateTransform.invert(point[0], point[1]);
	    return point && [point[0] * degrees, point[1] * degrees];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
	  };
	
	  projection.preclip = function(_) {
	    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
	  };
	
	  projection.postclip = function(_) {
	    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
	  };
	
	  projection.angle = function(_) {
	    return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  projection.fitWidth = function(width, object) {
	    return fitWidth(projection, width, object);
	  };
	
	  projection.fitHeight = function(height, object) {
	    return fitHeight(projection, height, object);
	  };
	
	  function recenter() {
	    var center = scaleTranslateRotate(k, 0, 0, alpha).apply(null, project(lambda, phi)),
	        transform$$1 = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], alpha);
	    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
	    projectTransform = compose(project, transform$$1);
	    projectRotateTransform = compose(rotate, projectTransform);
	    projectResample = resample(projectTransform, delta2);
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin(y0), n = (sy0 + sin(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
	
	  function project(x, y) {
	    var r = sqrt(c - 2 * n * sin(y)) / n;
	    return [r * sin(x *= n), r0 - r * cos(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	function conicEqualArea() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	}
	
	function albers() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	}
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	function albersUsa() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null, (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  albersUsa.fitWidth = function(width, object) {
	    return fitWidth(albersUsa, width, object);
	  };
	
	  albersUsa.fitHeight = function(height, object) {
	    return fitHeight(albersUsa, height, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	}
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos(x),
	        cy = cos(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin(x),
	      k * sin(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt(x * x + y * y),
	        c = angle(z),
	        sc = sin(c),
	        cc = cos(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin(z / 2);
	});
	
	function azimuthalEqualArea() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	}
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	function azimuthalEquidistant() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	}
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log(tan((halfPi + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi];
	};
	
	function mercator() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau);
	}
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      center = m.center,
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      x0 = null, y0, x1, y1; // clip extent
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), reclip()) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), reclip()) : translate();
	  };
	
	  m.center = function(_) {
	    return arguments.length ? (center(_), reclip()) : center();
	  };
	
	  m.clipExtent = function(_) {
	    return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  function reclip() {
	    var k = pi * scale(),
	        t = m(rotation(m.rotate()).invert([0, 0]));
	    return clipExtent(x0 == null
	        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
	        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
	        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
	  }
	
	  return reclip();
	}
	
	function tany(y) {
	  return tan((halfPi + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : log(cy0 / cos(y1)) / log(tany(y1) / tany(y0)),
	      f = cy0 * pow(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi + epsilon) y = -halfPi + epsilon; }
	    else { if (y > halfPi - epsilon) y = halfPi - epsilon; }
	    var r = f / pow(tany(y), n);
	    return [r * sin(n * x), f - r * cos(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi];
	  };
	
	  return project;
	}
	
	function conicConformal() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	}
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	function equirectangular() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	}
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : (cy0 - cos(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin(nx), g - gy * cos(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	function conicEquidistant() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	}
	
	function gnomonicRaw(x, y) {
	  var cy = cos(y), k = cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	function gnomonic() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	}
	
	function scaleTranslate$1(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	function identity$1() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform$$1 = identity, // scale, translate and reflect
	      x0 = null, y0, x1, y1, // clip extent
	      postclip = identity,
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform$$1(postclip(cacheStream = stream));
	    },
	    postclip: function(_) {
	      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate$1((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate$1(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate$1(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate$1(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    },
	    fitWidth: function(width, object) {
	      return fitWidth(projection, width, object);
	    },
	    fitHeight: function(height, object) {
	      return fitHeight(projection, height, object);
	    }
	  };
	}
	
	function naturalEarth1Raw(lambda, phi) {
	  var phi2 = phi * phi, phi4 = phi2 * phi2;
	  return [
	    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
	    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
	  ];
	}
	
	naturalEarth1Raw.invert = function(x, y) {
	  var phi = y, i = 25, delta;
	  do {
	    var phi2 = phi * phi, phi4 = phi2 * phi2;
	    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
	        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
	  } while (abs(delta) > epsilon && --i > 0);
	  return [
	    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
	    phi
	  ];
	};
	
	function naturalEarth1() {
	  return projection(naturalEarth1Raw)
	      .scale(175.295);
	}
	
	function orthographicRaw(x, y) {
	  return [cos(y) * sin(x), sin(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin);
	
	function orthographic() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon);
	}
	
	function stereographicRaw(x, y) {
	  var cy = cos(y), k = 1 + cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	function stereographic() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	}
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log(tan((halfPi + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi];
	};
	
	function transverseMercator() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	}
	
	exports.geoArea = area;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid;
	exports.geoCircle = circle;
	exports.geoClipAntimeridian = clipAntimeridian;
	exports.geoClipCircle = clipCircle;
	exports.geoClipExtent = extent;
	exports.geoClipRectangle = clipRectangle;
	exports.geoContains = contains;
	exports.geoDistance = distance;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoInterpolate = interpolate;
	exports.geoLength = length;
	exports.geoPath = index;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoIdentity = identity$1;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoNaturalEarth1 = naturalEarth1;
	exports.geoNaturalEarth1Raw = naturalEarth1Raw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	exports.geoRotation = rotation;
	exports.geoStream = geoStream;
	exports.geoTransform = transform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-hierarchy/ Version 1.1.6. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	var node_count = function() {
	  return this.eachAfter(count);
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	var slice = Array.prototype.slice;
	
	function shuffle(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}
	
	var enclose = function(circles) {
	  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;
	    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	};
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i])
	        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
	          && enclosesNot(encloseBasis2(B[i], p), B[j])
	          && enclosesNot(encloseBasis2(B[j], p), B[i])
	          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error;
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1: return encloseBasis1(B[0]);
	    case 2: return encloseBasis2(B[0], B[1]);
	    case 3: return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}
	
	function place(b, a, c) {
	  var dx = b.x - a.x, x, a2,
	      dy = b.y - a.y, y, b2,
	      d2 = dx * dx + dy * dy;
	  if (d2) {
	    a2 = a.r + c.r, a2 *= a2;
	    b2 = b.r + c.r, b2 *= b2;
	    if (a2 > b2) {
	      x = (d2 + b2 - a2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
	      c.x = b.x - x * dx - y * dy;
	      c.y = b.y - x * dy + y * dx;
	    } else {
	      x = (d2 + a2 - b2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
	      c.x = a.x + x * dx - y * dy;
	      c.y = a.y + x * dy + y * dx;
	    }
	  } else {
	    c.x = a.x + c.r;
	    c.y = a.y;
	  }
	}
	
	function intersects(a, b) {
	  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = ((function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	}))(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = ((function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	}))(phi);
	
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-polygon/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var area = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      a,
	      b = polygon[n - 1],
	      area = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    area += a[1] * b[0] - a[0] * b[1];
	  }
	
	  return area / 2;
	};
	
	var centroid = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      x = 0,
	      y = 0,
	      a,
	      b = polygon[n - 1],
	      c,
	      k = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    k += c = a[0] * b[1] - b[0] * a[1];
	    x += (a[0] + b[0]) * c;
	    y += (a[1] + b[1]) * c;
	  }
	
	  return k *= 3, [x / k, y / k];
	};
	
	// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
	// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
	// right, +y is up). Returns a positive value if ABC is counter-clockwise,
	// negative if clockwise, and zero if the points are collinear.
	var cross = function(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	};
	
	function lexicographicOrder(a, b) {
	  return a[0] - b[0] || a[1] - b[1];
	}
	
	// Computes the upper convex hull per the monotone chain algorithm.
	// Assumes points.length >= 3, is sorted by x, unique in y.
	// Returns an array of indices into points in left-to-right order.
	function computeUpperHullIndexes(points) {
	  var n = points.length,
	      indexes = [0, 1],
	      size = 2;
	
	  for (var i = 2; i < n; ++i) {
	    while (size > 1 && cross(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
	    indexes[size++] = i;
	  }
	
	  return indexes.slice(0, size); // remove popped points
	}
	
	var hull = function(points) {
	  if ((n = points.length) < 3) return null;
	
	  var i,
	      n,
	      sortedPoints = new Array(n),
	      flippedPoints = new Array(n);
	
	  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
	  sortedPoints.sort(lexicographicOrder);
	  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
	
	  var upperIndexes = computeUpperHullIndexes(sortedPoints),
	      lowerIndexes = computeUpperHullIndexes(flippedPoints);
	
	  // Construct the hull polygon, removing possible duplicate endpoints.
	  var skipLeft = lowerIndexes[0] === upperIndexes[0],
	      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
	      hull = [];
	
	  // Add upper hull in right-to-l order.
	  // Then add lower hull in left-to-right order.
	  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
	  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
	
	  return hull;
	};
	
	var contains = function(polygon, point) {
	  var n = polygon.length,
	      p = polygon[n - 1],
	      x = point[0], y = point[1],
	      x0 = p[0], y0 = p[1],
	      x1, y1,
	      inside = false;
	
	  for (var i = 0; i < n; ++i) {
	    p = polygon[i], x1 = p[0], y1 = p[1];
	    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
	    x0 = x1, y0 = y1;
	  }
	
	  return inside;
	};
	
	var length = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      b = polygon[n - 1],
	      xa,
	      ya,
	      xb = b[0],
	      yb = b[1],
	      perimeter = 0;
	
	  while (++i < n) {
	    xa = xb;
	    ya = yb;
	    b = polygon[i];
	    xb = b[0];
	    yb = b[1];
	    xa -= xb;
	    ya -= yb;
	    perimeter += Math.sqrt(xa * xa + ya * ya);
	  }
	
	  return perimeter;
	};
	
	exports.polygonArea = area;
	exports.polygonCentroid = centroid;
	exports.polygonHull = hull;
	exports.polygonContains = contains;
	exports.polygonLength = length;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-random/ Version 1.1.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var defaultSource = function() {
	  return Math.random();
	};
	
	var uniform = ((function sourceRandomUniform(source) {
	  function randomUniform(min, max) {
	    min = min == null ? 0 : +min;
	    max = max == null ? 1 : +max;
	    if (arguments.length === 1) max = min, min = 0;
	    else max -= min;
	    return function() {
	      return source() * max + min;
	    };
	  }
	
	  randomUniform.source = sourceRandomUniform;
	
	  return randomUniform;
	}))(defaultSource);
	
	var normal = ((function sourceRandomNormal(source) {
	  function randomNormal(mu, sigma) {
	    var x, r;
	    mu = mu == null ? 0 : +mu;
	    sigma = sigma == null ? 1 : +sigma;
	    return function() {
	      var y;
	
	      // If available, use the second previously-generated uniform random.
	      if (x != null) y = x, x = null;
	
	      // Otherwise, generate a new x and y.
	      else do {
	        x = source() * 2 - 1;
	        y = source() * 2 - 1;
	        r = x * x + y * y;
	      } while (!r || r > 1);
	
	      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
	    };
	  }
	
	  randomNormal.source = sourceRandomNormal;
	
	  return randomNormal;
	}))(defaultSource);
	
	var logNormal = ((function sourceRandomLogNormal(source) {
	  function randomLogNormal() {
	    var randomNormal = normal.source(source).apply(this, arguments);
	    return function() {
	      return Math.exp(randomNormal());
	    };
	  }
	
	  randomLogNormal.source = sourceRandomLogNormal;
	
	  return randomLogNormal;
	}))(defaultSource);
	
	var irwinHall = ((function sourceRandomIrwinHall(source) {
	  function randomIrwinHall(n) {
	    return function() {
	      for (var sum = 0, i = 0; i < n; ++i) sum += source();
	      return sum;
	    };
	  }
	
	  randomIrwinHall.source = sourceRandomIrwinHall;
	
	  return randomIrwinHall;
	}))(defaultSource);
	
	var bates = ((function sourceRandomBates(source) {
	  function randomBates(n) {
	    var randomIrwinHall = irwinHall.source(source)(n);
	    return function() {
	      return randomIrwinHall() / n;
	    };
	  }
	
	  randomBates.source = sourceRandomBates;
	
	  return randomBates;
	}))(defaultSource);
	
	var exponential = ((function sourceRandomExponential(source) {
	  function randomExponential(lambda) {
	    return function() {
	      return -Math.log(1 - source()) / lambda;
	    };
	  }
	
	  randomExponential.source = sourceRandomExponential;
	
	  return randomExponential;
	}))(defaultSource);
	
	exports.randomUniform = uniform;
	exports.randomNormal = normal;
	exports.randomLogNormal = logNormal;
	exports.randomBates = bates;
	exports.randomIrwinHall = irwinHall;
	exports.randomExponential = exponential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 2.0.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(531), __webpack_require__(544), __webpack_require__(537), __webpack_require__(550), __webpack_require__(556), __webpack_require__(557)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	function tickFormat(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	function time() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	}
	
	function utcTime() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	}
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(556)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale-chromatic/ Version 1.3.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(537), __webpack_require__(538)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-interpolate', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3));
	}(this, (function (exports,d3Interpolate,d3Color) { 'use strict';
	
	function colors(specifier) {
	  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
	  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
	  return colors;
	}
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
	
	var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
	
	var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
	
	var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
	
	var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
	
	var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
	
	var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
	
	var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
	
	function ramp(scheme) {
	  return d3Interpolate.interpolateRgbBasis(scheme[scheme.length - 1]);
	}
	
	var scheme = new Array(3).concat(
	  "d8b365f5f5f55ab4ac",
	  "a6611adfc27d80cdc1018571",
	  "a6611adfc27df5f5f580cdc1018571",
	  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
	  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
	  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
	  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
	  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
	  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
	).map(colors);
	
	var BrBG = ramp(scheme);
	
	var scheme$1 = new Array(3).concat(
	  "af8dc3f7f7f77fbf7b",
	  "7b3294c2a5cfa6dba0008837",
	  "7b3294c2a5cff7f7f7a6dba0008837",
	  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
	  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
	  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
	  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
	  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
	  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
	).map(colors);
	
	var PRGn = ramp(scheme$1);
	
	var scheme$2 = new Array(3).concat(
	  "e9a3c9f7f7f7a1d76a",
	  "d01c8bf1b6dab8e1864dac26",
	  "d01c8bf1b6daf7f7f7b8e1864dac26",
	  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
	  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
	  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
	  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
	  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
	  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
	).map(colors);
	
	var PiYG = ramp(scheme$2);
	
	var scheme$3 = new Array(3).concat(
	  "998ec3f7f7f7f1a340",
	  "5e3c99b2abd2fdb863e66101",
	  "5e3c99b2abd2f7f7f7fdb863e66101",
	  "542788998ec3d8daebfee0b6f1a340b35806",
	  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
	  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
	  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
	  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
	  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
	).map(colors);
	
	var PuOr = ramp(scheme$3);
	
	var scheme$4 = new Array(3).concat(
	  "ef8a62f7f7f767a9cf",
	  "ca0020f4a58292c5de0571b0",
	  "ca0020f4a582f7f7f792c5de0571b0",
	  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
	  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
	  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
	  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
	  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
	  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
	).map(colors);
	
	var RdBu = ramp(scheme$4);
	
	var scheme$5 = new Array(3).concat(
	  "ef8a62ffffff999999",
	  "ca0020f4a582bababa404040",
	  "ca0020f4a582ffffffbababa404040",
	  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
	  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
	  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
	  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
	  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
	  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
	).map(colors);
	
	var RdGy = ramp(scheme$5);
	
	var scheme$6 = new Array(3).concat(
	  "fc8d59ffffbf91bfdb",
	  "d7191cfdae61abd9e92c7bb6",
	  "d7191cfdae61ffffbfabd9e92c7bb6",
	  "d73027fc8d59fee090e0f3f891bfdb4575b4",
	  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
	  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
	  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
	  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
	  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
	).map(colors);
	
	var RdYlBu = ramp(scheme$6);
	
	var scheme$7 = new Array(3).concat(
	  "fc8d59ffffbf91cf60",
	  "d7191cfdae61a6d96a1a9641",
	  "d7191cfdae61ffffbfa6d96a1a9641",
	  "d73027fc8d59fee08bd9ef8b91cf601a9850",
	  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
	  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
	  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
	  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
	  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
	).map(colors);
	
	var RdYlGn = ramp(scheme$7);
	
	var scheme$8 = new Array(3).concat(
	  "fc8d59ffffbf99d594",
	  "d7191cfdae61abdda42b83ba",
	  "d7191cfdae61ffffbfabdda42b83ba",
	  "d53e4ffc8d59fee08be6f59899d5943288bd",
	  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
	  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
	  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
	  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
	  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
	).map(colors);
	
	var Spectral = ramp(scheme$8);
	
	var scheme$9 = new Array(3).concat(
	  "e5f5f999d8c92ca25f",
	  "edf8fbb2e2e266c2a4238b45",
	  "edf8fbb2e2e266c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
	).map(colors);
	
	var BuGn = ramp(scheme$9);
	
	var scheme$10 = new Array(3).concat(
	  "e0ecf49ebcda8856a7",
	  "edf8fbb3cde38c96c688419d",
	  "edf8fbb3cde38c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
	).map(colors);
	
	var BuPu = ramp(scheme$10);
	
	var scheme$11 = new Array(3).concat(
	  "e0f3dba8ddb543a2ca",
	  "f0f9e8bae4bc7bccc42b8cbe",
	  "f0f9e8bae4bc7bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
	).map(colors);
	
	var GnBu = ramp(scheme$11);
	
	var scheme$12 = new Array(3).concat(
	  "fee8c8fdbb84e34a33",
	  "fef0d9fdcc8afc8d59d7301f",
	  "fef0d9fdcc8afc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
	).map(colors);
	
	var OrRd = ramp(scheme$12);
	
	var scheme$13 = new Array(3).concat(
	  "ece2f0a6bddb1c9099",
	  "f6eff7bdc9e167a9cf02818a",
	  "f6eff7bdc9e167a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
	).map(colors);
	
	var PuBuGn = ramp(scheme$13);
	
	var scheme$14 = new Array(3).concat(
	  "ece7f2a6bddb2b8cbe",
	  "f1eef6bdc9e174a9cf0570b0",
	  "f1eef6bdc9e174a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
	).map(colors);
	
	var PuBu = ramp(scheme$14);
	
	var scheme$15 = new Array(3).concat(
	  "e7e1efc994c7dd1c77",
	  "f1eef6d7b5d8df65b0ce1256",
	  "f1eef6d7b5d8df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
	).map(colors);
	
	var PuRd = ramp(scheme$15);
	
	var scheme$16 = new Array(3).concat(
	  "fde0ddfa9fb5c51b8a",
	  "feebe2fbb4b9f768a1ae017e",
	  "feebe2fbb4b9f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
	).map(colors);
	
	var RdPu = ramp(scheme$16);
	
	var scheme$17 = new Array(3).concat(
	  "edf8b17fcdbb2c7fb8",
	  "ffffcca1dab441b6c4225ea8",
	  "ffffcca1dab441b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
	).map(colors);
	
	var YlGnBu = ramp(scheme$17);
	
	var scheme$18 = new Array(3).concat(
	  "f7fcb9addd8e31a354",
	  "ffffccc2e69978c679238443",
	  "ffffccc2e69978c67931a354006837",
	  "ffffccd9f0a3addd8e78c67931a354006837",
	  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
	).map(colors);
	
	var YlGn = ramp(scheme$18);
	
	var scheme$19 = new Array(3).concat(
	  "fff7bcfec44fd95f0e",
	  "ffffd4fed98efe9929cc4c02",
	  "ffffd4fed98efe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
	).map(colors);
	
	var YlOrBr = ramp(scheme$19);
	
	var scheme$20 = new Array(3).concat(
	  "ffeda0feb24cf03b20",
	  "ffffb2fecc5cfd8d3ce31a1c",
	  "ffffb2fecc5cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
	).map(colors);
	
	var YlOrRd = ramp(scheme$20);
	
	var scheme$21 = new Array(3).concat(
	  "deebf79ecae13182bd",
	  "eff3ffbdd7e76baed62171b5",
	  "eff3ffbdd7e76baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
	).map(colors);
	
	var Blues = ramp(scheme$21);
	
	var scheme$22 = new Array(3).concat(
	  "e5f5e0a1d99b31a354",
	  "edf8e9bae4b374c476238b45",
	  "edf8e9bae4b374c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
	).map(colors);
	
	var Greens = ramp(scheme$22);
	
	var scheme$23 = new Array(3).concat(
	  "f0f0f0bdbdbd636363",
	  "f7f7f7cccccc969696525252",
	  "f7f7f7cccccc969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
	).map(colors);
	
	var Greys = ramp(scheme$23);
	
	var scheme$24 = new Array(3).concat(
	  "efedf5bcbddc756bb1",
	  "f2f0f7cbc9e29e9ac86a51a3",
	  "f2f0f7cbc9e29e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
	).map(colors);
	
	var Purples = ramp(scheme$24);
	
	var scheme$25 = new Array(3).concat(
	  "fee0d2fc9272de2d26",
	  "fee5d9fcae91fb6a4acb181d",
	  "fee5d9fcae91fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
	).map(colors);
	
	var Reds = ramp(scheme$25);
	
	var scheme$26 = new Array(3).concat(
	  "fee6cefdae6be6550d",
	  "feeddefdbe85fd8d3cd94701",
	  "feeddefdbe85fd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
	).map(colors);
	
	var Oranges = ramp(scheme$26);
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var c = d3Color.cubehelix();
	
	function rainbow(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  c.h = 360 * t - 100;
	  c.s = 1.5 - 1.5 * ts;
	  c.l = 0.8 - 0.9 * ts;
	  return c + "";
	}
	
	var c$1 = d3Color.rgb();
	var pi_1_3 = Math.PI / 3;
	var pi_2_3 = Math.PI * 2 / 3;
	
	function sinebow(t) {
	  var x;
	  t = (0.5 - t) * Math.PI;
	  c$1.r = 255 * (x = Math.sin(t)) * x;
	  c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
	  c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
	  return c$1 + "";
	}
	
	function ramp$1(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp$1(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp$1(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp$1(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp$1(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	exports.schemeCategory10 = category10;
	exports.schemeAccent = Accent;
	exports.schemeDark2 = Dark2;
	exports.schemePaired = Paired;
	exports.schemePastel1 = Pastel1;
	exports.schemePastel2 = Pastel2;
	exports.schemeSet1 = Set1;
	exports.schemeSet2 = Set2;
	exports.schemeSet3 = Set3;
	exports.interpolateBrBG = BrBG;
	exports.schemeBrBG = scheme;
	exports.interpolatePRGn = PRGn;
	exports.schemePRGn = scheme$1;
	exports.interpolatePiYG = PiYG;
	exports.schemePiYG = scheme$2;
	exports.interpolatePuOr = PuOr;
	exports.schemePuOr = scheme$3;
	exports.interpolateRdBu = RdBu;
	exports.schemeRdBu = scheme$4;
	exports.interpolateRdGy = RdGy;
	exports.schemeRdGy = scheme$5;
	exports.interpolateRdYlBu = RdYlBu;
	exports.schemeRdYlBu = scheme$6;
	exports.interpolateRdYlGn = RdYlGn;
	exports.schemeRdYlGn = scheme$7;
	exports.interpolateSpectral = Spectral;
	exports.schemeSpectral = scheme$8;
	exports.interpolateBuGn = BuGn;
	exports.schemeBuGn = scheme$9;
	exports.interpolateBuPu = BuPu;
	exports.schemeBuPu = scheme$10;
	exports.interpolateGnBu = GnBu;
	exports.schemeGnBu = scheme$11;
	exports.interpolateOrRd = OrRd;
	exports.schemeOrRd = scheme$12;
	exports.interpolatePuBuGn = PuBuGn;
	exports.schemePuBuGn = scheme$13;
	exports.interpolatePuBu = PuBu;
	exports.schemePuBu = scheme$14;
	exports.interpolatePuRd = PuRd;
	exports.schemePuRd = scheme$15;
	exports.interpolateRdPu = RdPu;
	exports.schemeRdPu = scheme$16;
	exports.interpolateYlGnBu = YlGnBu;
	exports.schemeYlGnBu = scheme$17;
	exports.interpolateYlGn = YlGn;
	exports.schemeYlGn = scheme$18;
	exports.interpolateYlOrBr = YlOrBr;
	exports.schemeYlOrBr = scheme$19;
	exports.interpolateYlOrRd = YlOrRd;
	exports.schemeYlOrRd = scheme$20;
	exports.interpolateBlues = Blues;
	exports.schemeBlues = scheme$21;
	exports.interpolateGreens = Greens;
	exports.schemeGreens = scheme$22;
	exports.interpolateGreys = Greys;
	exports.schemeGreys = scheme$23;
	exports.interpolatePurples = Purples;
	exports.schemePurples = scheme$24;
	exports.interpolateReds = Reds;
	exports.schemeReds = scheme$25;
	exports.interpolateOranges = Oranges;
	exports.schemeOranges = scheme$26;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateSinebow = sinebow;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(543)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-voronoi/ Version 1.1.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
	              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
	              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon
	      && Math.abs(y - lArc.circle.cy) < epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon
	      && Math.abs(y - rArc.circle.cy) < epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon) * epsilon, Math.round(y$$1(d, i, data) / epsilon) * epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	exports.voronoi = voronoi;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-zoom/ Version 1.7.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(534), __webpack_require__(535), __webpack_require__(537), __webpack_require__(536), __webpack_require__(539)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-dispatch', 'd3-drag', 'd3-interpolate', 'd3-selection', 'd3-transition'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Dispatch,d3Drag,d3Interpolate,d3Selection,d3Transition) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function ZoomEvent(target, type, transform) {
	  this.target = target;
	  this.type = type;
	  this.transform = transform;
	}
	
	function Transform(k, x, y) {
	  this.k = k;
	  this.x = x;
	  this.y = y;
	}
	
	Transform.prototype = {
	  constructor: Transform,
	  scale: function(k) {
	    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
	  },
	  translate: function(x, y) {
	    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
	  },
	  apply: function(point) {
	    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
	  },
	  applyX: function(x) {
	    return x * this.k + this.x;
	  },
	  applyY: function(y) {
	    return y * this.k + this.y;
	  },
	  invert: function(location) {
	    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
	  },
	  invertX: function(x) {
	    return (x - this.x) / this.k;
	  },
	  invertY: function(y) {
	    return (y - this.y) / this.k;
	  },
	  rescaleX: function(x) {
	    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
	  },
	  rescaleY: function(y) {
	    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
	  },
	  toString: function() {
	    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	  }
	};
	
	var identity = new Transform(1, 0, 0);
	
	transform.prototype = Transform.prototype;
	
	function transform(node) {
	  return node.__zoom || identity;
	}
	
	function nopropagation() {
	  d3Selection.event.stopImmediatePropagation();
	}
	
	var noevent = function() {
	  d3Selection.event.preventDefault();
	  d3Selection.event.stopImmediatePropagation();
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !d3Selection.event.button;
	}
	
	function defaultExtent() {
	  var e = this, w, h;
	  if (e instanceof SVGElement) {
	    e = e.ownerSVGElement || e;
	    w = e.width.baseVal.value;
	    h = e.height.baseVal.value;
	  } else {
	    w = e.clientWidth;
	    h = e.clientHeight;
	  }
	  return [[0, 0], [w, h]];
	}
	
	function defaultTransform() {
	  return this.__zoom || identity;
	}
	
	function defaultWheelDelta() {
	  return -d3Selection.event.deltaY * (d3Selection.event.deltaMode ? 120 : 1) / 500;
	}
	
	function defaultTouchable() {
	  return "ontouchstart" in this;
	}
	
	function defaultConstrain(transform$$1, extent, translateExtent) {
	  var dx0 = transform$$1.invertX(extent[0][0]) - translateExtent[0][0],
	      dx1 = transform$$1.invertX(extent[1][0]) - translateExtent[1][0],
	      dy0 = transform$$1.invertY(extent[0][1]) - translateExtent[0][1],
	      dy1 = transform$$1.invertY(extent[1][1]) - translateExtent[1][1];
	  return transform$$1.translate(
	    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
	    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
	  );
	}
	
	var zoom = function() {
	  var filter = defaultFilter,
	      extent = defaultExtent,
	      constrain = defaultConstrain,
	      wheelDelta = defaultWheelDelta,
	      touchable = defaultTouchable,
	      scaleExtent = [0, Infinity],
	      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
	      duration = 250,
	      interpolate = d3Interpolate.interpolateZoom,
	      gestures = [],
	      listeners = d3Dispatch.dispatch("start", "zoom", "end"),
	      touchstarting,
	      touchending,
	      touchDelay = 500,
	      wheelDelay = 150,
	      clickDistance2 = 0;
	
	  function zoom(selection) {
	    selection
	        .property("__zoom", defaultTransform)
	        .on("wheel.zoom", wheeled)
	        .on("mousedown.zoom", mousedowned)
	        .on("dblclick.zoom", dblclicked)
	      .filter(touchable)
	        .on("touchstart.zoom", touchstarted)
	        .on("touchmove.zoom", touchmoved)
	        .on("touchend.zoom touchcancel.zoom", touchended)
	        .style("touch-action", "none")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  zoom.transform = function(collection, transform$$1) {
	    var selection = collection.selection ? collection.selection() : collection;
	    selection.property("__zoom", defaultTransform);
	    if (collection !== selection) {
	      schedule(collection, transform$$1);
	    } else {
	      selection.interrupt().each(function() {
	        gesture(this, arguments)
	            .start()
	            .zoom(null, typeof transform$$1 === "function" ? transform$$1.apply(this, arguments) : transform$$1)
	            .end();
	      });
	    }
	  };
	
	  zoom.scaleBy = function(selection, k) {
	    zoom.scaleTo(selection, function() {
	      var k0 = this.__zoom.k,
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return k0 * k1;
	    });
	  };
	
	  zoom.scaleTo = function(selection, k) {
	    zoom.transform(selection, function() {
	      var e = extent.apply(this, arguments),
	          t0 = this.__zoom,
	          p0 = centroid(e),
	          p1 = t0.invert(p0),
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
	    });
	  };
	
	  zoom.translateBy = function(selection, x, y) {
	    zoom.transform(selection, function() {
	      return constrain(this.__zoom.translate(
	        typeof x === "function" ? x.apply(this, arguments) : x,
	        typeof y === "function" ? y.apply(this, arguments) : y
	      ), extent.apply(this, arguments), translateExtent);
	    });
	  };
	
	  zoom.translateTo = function(selection, x, y) {
	    zoom.transform(selection, function() {
	      var e = extent.apply(this, arguments),
	          t = this.__zoom,
	          p = centroid(e);
	      return constrain(identity.translate(p[0], p[1]).scale(t.k).translate(
	        typeof x === "function" ? -x.apply(this, arguments) : -x,
	        typeof y === "function" ? -y.apply(this, arguments) : -y
	      ), e, translateExtent);
	    });
	  };
	
	  function scale(transform$$1, k) {
	    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
	    return k === transform$$1.k ? transform$$1 : new Transform(k, transform$$1.x, transform$$1.y);
	  }
	
	  function translate(transform$$1, p0, p1) {
	    var x = p0[0] - p1[0] * transform$$1.k, y = p0[1] - p1[1] * transform$$1.k;
	    return x === transform$$1.x && y === transform$$1.y ? transform$$1 : new Transform(transform$$1.k, x, y);
	  }
	
	  function centroid(extent) {
	    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
	  }
	
	  function schedule(transition, transform$$1, center) {
	    transition
	        .on("start.zoom", function() { gesture(this, arguments).start(); })
	        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
	        .tween("zoom", function() {
	          var that = this,
	              args = arguments,
	              g = gesture(that, args),
	              e = extent.apply(that, args),
	              p = center || centroid(e),
	              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
	              a = that.__zoom,
	              b = typeof transform$$1 === "function" ? transform$$1.apply(that, args) : transform$$1,
	              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
	          return function(t) {
	            if (t === 1) t = b; // Avoid rounding error on end.
	            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
	            g.zoom(null, t);
	          };
	        });
	  }
	
	  function gesture(that, args) {
	    for (var i = 0, n = gestures.length, g; i < n; ++i) {
	      if ((g = gestures[i]).that === that) {
	        return g;
	      }
	    }
	    return new Gesture(that, args);
	  }
	
	  function Gesture(that, args) {
	    this.that = that;
	    this.args = args;
	    this.index = -1;
	    this.active = 0;
	    this.extent = extent.apply(that, args);
	  }
	
	  Gesture.prototype = {
	    start: function() {
	      if (++this.active === 1) {
	        this.index = gestures.push(this) - 1;
	        this.emit("start");
	      }
	      return this;
	    },
	    zoom: function(key, transform$$1) {
	      if (this.mouse && key !== "mouse") this.mouse[1] = transform$$1.invert(this.mouse[0]);
	      if (this.touch0 && key !== "touch") this.touch0[1] = transform$$1.invert(this.touch0[0]);
	      if (this.touch1 && key !== "touch") this.touch1[1] = transform$$1.invert(this.touch1[0]);
	      this.that.__zoom = transform$$1;
	      this.emit("zoom");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) {
	        gestures.splice(this.index, 1);
	        this.index = -1;
	        this.emit("end");
	      }
	      return this;
	    },
	    emit: function(type) {
	      d3Selection.customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function wheeled() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        t = this.__zoom,
	        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
	        p = d3Selection.mouse(this);
	
	    // If the mouse is in the same location as before, reuse it.
	    // If there were recent wheel events, reset the wheel idle timeout.
	    if (g.wheel) {
	      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
	        g.mouse[1] = t.invert(g.mouse[0] = p);
	      }
	      clearTimeout(g.wheel);
	    }
	
	    // If this wheel event won’t trigger a transform change, ignore it.
	    else if (t.k === k) return;
	
	    // Otherwise, capture the mouse point and location at the start.
	    else {
	      g.mouse = [p, t.invert(p)];
	      d3Transition.interrupt(this);
	      g.start();
	    }
	
	    noevent();
	    g.wheel = setTimeout(wheelidled, wheelDelay);
	    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
	
	    function wheelidled() {
	      g.wheel = null;
	      g.end();
	    }
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        v = d3Selection.select(d3Selection.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
	        p = d3Selection.mouse(this),
	        x0 = d3Selection.event.clientX,
	        y0 = d3Selection.event.clientY;
	
	    d3Drag.dragDisable(d3Selection.event.view);
	    nopropagation();
	    g.mouse = [p, this.__zoom.invert(p)];
	    d3Transition.interrupt(this);
	    g.start();
	
	    function mousemoved() {
	      noevent();
	      if (!g.moved) {
	        var dx = d3Selection.event.clientX - x0, dy = d3Selection.event.clientY - y0;
	        g.moved = dx * dx + dy * dy > clickDistance2;
	      }
	      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = d3Selection.mouse(g.that), g.mouse[1]), g.extent, translateExtent));
	    }
	
	    function mouseupped() {
	      v.on("mousemove.zoom mouseup.zoom", null);
	      d3Drag.dragEnable(d3Selection.event.view, g.moved);
	      noevent();
	      g.end();
	    }
	  }
	
	  function dblclicked() {
	    if (!filter.apply(this, arguments)) return;
	    var t0 = this.__zoom,
	        p0 = d3Selection.mouse(this),
	        p1 = t0.invert(p0),
	        k1 = t0.k * (d3Selection.event.shiftKey ? 0.5 : 2),
	        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
	
	    noevent();
	    if (duration > 0) d3Selection.select(this).transition().duration(duration).call(schedule, t1, p0);
	    else d3Selection.select(this).call(zoom.transform, t1);
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        touches = d3Selection.event.changedTouches,
	        started,
	        n = touches.length, i, t, p;
	
	    nopropagation();
	    for (i = 0; i < n; ++i) {
	      t = touches[i], p = d3Selection.touch(this, touches, t.identifier);
	      p = [p, this.__zoom.invert(p), t.identifier];
	      if (!g.touch0) g.touch0 = p, started = true;
	      else if (!g.touch1) g.touch1 = p;
	    }
	
	    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
	    if (touchstarting) {
	      touchstarting = clearTimeout(touchstarting);
	      if (!g.touch1) {
	        g.end();
	        p = d3Selection.select(this).on("dblclick.zoom");
	        if (p) p.apply(this, arguments);
	        return;
	      }
	    }
	
	    if (started) {
	      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
	      d3Transition.interrupt(this);
	      g.start();
	    }
	  }
	
	  function touchmoved() {
	    var g = gesture(this, arguments),
	        touches = d3Selection.event.changedTouches,
	        n = touches.length, i, t, p, l;
	
	    noevent();
	    if (touchstarting) touchstarting = clearTimeout(touchstarting);
	    for (i = 0; i < n; ++i) {
	      t = touches[i], p = d3Selection.touch(this, touches, t.identifier);
	      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
	      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
	    }
	    t = g.that.__zoom;
	    if (g.touch1) {
	      var p0 = g.touch0[0], l0 = g.touch0[1],
	          p1 = g.touch1[0], l1 = g.touch1[1],
	          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
	          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
	      t = scale(t, Math.sqrt(dp / dl));
	      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
	      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
	    }
	    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
	    else return;
	    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
	  }
	
	  function touchended() {
	    var g = gesture(this, arguments),
	        touches = d3Selection.event.changedTouches,
	        n = touches.length, i, t;
	
	    nopropagation();
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, touchDelay);
	    for (i = 0; i < n; ++i) {
	      t = touches[i];
	      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
	      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
	    }
	    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
	    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
	    else g.end();
	  }
	
	  zoom.wheelDelta = function(_) {
	    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
	  };
	
	  zoom.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
	  };
	
	  zoom.touchable = function(_) {
	    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
	  };
	
	  zoom.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
	  };
	
	  zoom.scaleExtent = function(_) {
	    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
	  };
	
	  zoom.translateExtent = function(_) {
	    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
	  };
	
	  zoom.constrain = function(_) {
	    return arguments.length ? (constrain = _, zoom) : constrain;
	  };
	
	  zoom.duration = function(_) {
	    return arguments.length ? (duration = +_, zoom) : duration;
	  };
	
	  zoom.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, zoom) : interpolate;
	  };
	
	  zoom.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? zoom : value;
	  };
	
	  zoom.clickDistance = function(_) {
	    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
	  };
	
	  return zoom;
	};
	
	exports.zoom = zoom;
	exports.zoomTransform = transform;
	exports.zoomIdentity = identity;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 562 */
/***/ function(module, exports) {

	var path = 'app/components/dashboard/heatCalendar.html';
	var html = "<div class=\"row calendar\"><div class=\"col-lg-12 calendar-left\"><div class=\"num-date\">{{selectedDate.date()}}</div><div class=\"day\">{{selectedDate.format('dddd')}}</div><div class=\"current-events\">Komentari<br><ul><li ng-repeat=\"k in komentari\">{{k.poruka}}</li></ul></div></div><div class=\"col-lg-12 calendar-base\"><div class=\"year\">{{currentDate.year()}}</div><div class=\"triangle-left\" ng-click=\"changeYear(-1)\"></div><div class=\"triangle-right\" ng-click=\"changeYear(1)\"></div><div class=\"months\"><span ng-click=\"changeMonth(m)\" ng-repeat=\"m in months\" class=\"month-hover\" ng-class=\"{'month-color': m.month() === currentDate.month()}\">{{m.format('MMM')}}</span></div><hr class=\"month-line\"><div id=\"calendar\"></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 563 */
32,
/* 564 */,
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcPagination = __webpack_require__(566);
	
	var _angularUiBootstrapSrcPagination2 = _interopRequireDefault(_angularUiBootstrapSrcPagination);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(513);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _commonCrudCrudJs = __webpack_require__(455);
	
	var _ordinacijaListComponentJs = __webpack_require__(573);
	
	var _cardOrdinacijaComponentJs = __webpack_require__(575);
	
	var _ordinacijaDetailsComponentJs = __webpack_require__(577);
	
	var _ordinacijaCreateComponentJs = __webpack_require__(579);
	
	var _ordinacijaEditComponentJs = __webpack_require__(581);
	
	var _ordinacijaFormComponentJs = __webpack_require__(582);
	
	var ordinacija = _angular2['default'].module('ordinacija', [_angularUiBootstrapSrcPagination2['default'], _angularUiBootstrapSrcModal2['default'], _commonCrudCrudJs.crud.name]);
	
	ordinacija.component('ordinacijaList', _ordinacijaListComponentJs.OrdinacijaListComponent);
	ordinacija.component('cardOrdinacija', _cardOrdinacijaComponentJs.CardOrdinacijaComponent);
	ordinacija.component('ordinacijaDetails', _ordinacijaDetailsComponentJs.OrdinacijaDetailsComponent);
	ordinacija.component('ordinacijaCreate', _ordinacijaCreateComponentJs.OrdinacijaCreateComponent);
	ordinacija.component('ordinacijaEdit', _ordinacijaEditComponentJs.OrdinacijaEditComponent);
	ordinacija.component('ordinacijaForm', _ordinacijaFormComponentJs.OrdinacijaFormComponent);
	
	exports.ordinacija = ordinacija;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(567);
	__webpack_require__(569);
	__webpack_require__(571);
	__webpack_require__(572);
	
	var MODULE_NAME = 'ui.bootstrap.module.pagination';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.pagination', 'uib/template/pagination/pagination.html']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(568);
	
	var MODULE_NAME = 'ui.bootstrap.module.paging';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.paging']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 568 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.paging', [])
	/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */
	.factory('uibPaging', ['$parse', function($parse) {
	  return {
	    create: function(ctrl, $scope, $attrs) {
	      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	      ctrl._watchers = [];
	
	      ctrl.init = function(ngModelCtrl, config) {
	        ctrl.ngModelCtrl = ngModelCtrl;
	        ctrl.config = config;
	
	        ngModelCtrl.$render = function() {
	          ctrl.render();
	        };
	
	        if ($attrs.itemsPerPage) {
	          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
	            ctrl.itemsPerPage = parseInt(value, 10);
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }));
	        } else {
	          ctrl.itemsPerPage = config.itemsPerPage;
	        }
	
	        $scope.$watch('totalItems', function(newTotal, oldTotal) {
	          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }
	        });
	      };
	
	      ctrl.calculateTotalPages = function() {
	        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	      };
	
	      ctrl.render = function() {
	        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	      };
	
	      $scope.selectPage = function(page, evt) {
	        if (evt) {
	          evt.preventDefault();
	        }
	
	        var clickAllowed = !$scope.ngDisabled || !evt;
	        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	          if (evt && evt.target) {
	            evt.target.blur();
	          }
	          ctrl.ngModelCtrl.$setViewValue(page);
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.getText = function(key) {
	        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	      };
	
	      $scope.noPrevious = function() {
	        return $scope.page === 1;
	      };
	
	      $scope.noNext = function() {
	        return $scope.page === $scope.totalPages;
	      };
	
	      ctrl.updatePage = function() {
	        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable
	
	        if ($scope.page > $scope.totalPages) {
	          $scope.selectPage($scope.totalPages);
	        } else {
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.$on('$destroy', function() {
	        while (ctrl._watchers.length) {
	          ctrl._watchers.shift()();
	        }
	      });
	    }
	  };
	}]);


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(570);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabindex';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabindex']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 570 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.tabindex', [])
	
	.directive('uibTabindexToggle', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      attrs.$observe('disabled', function(disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});


/***/ },
/* 571 */
/***/ function(module, exports) {

	angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/pagination/pagination.html",
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
	    "");
	}]);


/***/ },
/* 572 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	  var ctrl = this;
	  // Setup configuration parameters
	  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
	  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
	  $attrs.$set('role', 'menu');
	
	  uibPaging.create(this, $scope, $attrs);
	
	  if ($attrs.maxSize) {
	    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
	      maxSize = parseInt(value, 10);
	      ctrl.render();
	    }));
	  }
	
	  // Create page object used in template
	  function makePage(number, text, isActive) {
	    return {
	      number: number,
	      text: text,
	      active: isActive
	    };
	  }
	
	  function getPages(currentPage, totalPages) {
	    var pages = [];
	
	    // Default page limits
	    var startPage = 1, endPage = totalPages;
	    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	    // recompute if maxSize
	    if (isMaxSized) {
	      if (rotate) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	        endPage = startPage + maxSize - 1;
	
	        // Adjust if limit is exceeded
	        if (endPage > totalPages) {
	          endPage = totalPages;
	          startPage = endPage - maxSize + 1;
	        }
	      } else {
	        // Visible pages are paginated with maxSize
	        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
	
	        // Adjust last page if limit is exceeded
	        endPage = Math.min(startPage + maxSize - 1, totalPages);
	      }
	    }
	
	    // Add page number links
	    for (var number = startPage; number <= endPage; number++) {
	      var page = makePage(number, pageLabel(number), number === currentPage);
	      pages.push(page);
	    }
	
	    // Add links to move between page sets
	    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	      if (startPage > 1) {
	        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
	        var previousPageSet = makePage(startPage - 1, '...', false);
	        pages.unshift(previousPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
	            var secondPageLink = makePage(2, '2', false);
	            pages.unshift(secondPageLink);
	          }
	          //add the first page
	          var firstPageLink = makePage(1, '1', false);
	          pages.unshift(firstPageLink);
	        }
	      }
	
	      if (endPage < totalPages) {
	        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
	        var nextPageSet = makePage(endPage + 1, '...', false);
	        pages.push(nextPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
	            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	            pages.push(secondToLastPageLink);
	          }
	          //add the last page
	          var lastPageLink = makePage(totalPages, totalPages, false);
	          pages.push(lastPageLink);
	        }
	      }
	    }
	    return pages;
	  }
	
	  var originalRender = this.render;
	  this.render = function() {
	    originalRender();
	    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	      $scope.pages = getPages($scope.page, $scope.totalPages);
	    }
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  boundaryLinkNumbers: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true,
	  forceEllipses: false
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pagination');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	    }
	  };
	}]);


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ordinacijaListHtml = __webpack_require__(574);
	
	var _ordinacijaListHtml2 = _interopRequireDefault(_ordinacijaListHtml);
	
	var _commonListControllerJs = __webpack_require__(469);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var OrdinacijaListController = (function (_ListController) {
	    _inherits(OrdinacijaListController, _ListController);
	
	    function OrdinacijaListController(ModelFactory, $state) {
	        _classCallCheck(this, OrdinacijaListController);
	
	        _get(Object.getPrototypeOf(OrdinacijaListController.prototype), 'constructor', this).call(this, ModelFactory);
	        this.getState();
	        this.icon = $state.current.data.icon || false;
	        this.pageTitle = $state.current.data.pageTitle || false;
	        this.pageDesc = $state.current.data.pageDesc || false;
	
	        this.getState();
	    }
	
	    _createClass(OrdinacijaListController, [{
	        key: 'getState',
	        value: function getState() {
	            this.getItems();
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params, { bypassCache: true });
	        }
	    }]);
	
	    return OrdinacijaListController;
	})(_commonListControllerJs2['default']);
	
	OrdinacijaListController.$inject = ['Ordinacija', '$state'];
	
	var OrdinacijaListComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaListHtml2['default'],
	    controller: OrdinacijaListController,
	    controllerAs: 'vm'
	};
	
	exports.OrdinacijaListComponent = OrdinacijaListComponent;
	exports.OrdinacijaListController = OrdinacijaListController;

/***/ },
/* 574 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaList.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Naziv ili oib\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul><uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></uib-pagination></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ui-sref=\"ordinacija.create\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><hr><div ng-if=\"vm.items.length > 0\" animate-panel><card-ordinacija class=\"card\" items=\"vm.items\"></card-ordinacija></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cardOrdinacijaHtml = __webpack_require__(576);
	
	var _cardOrdinacijaHtml2 = _interopRequireDefault(_cardOrdinacijaHtml);
	
	var CardOrdinacijaController = (function () {
	    function CardOrdinacijaController($scope) {
	        _classCallCheck(this, CardOrdinacijaController);
	
	        this.items = this.items || [];
	        this.rows = [];
	        $scope.$watch('vm.items', this.itemsChanged());
	    }
	
	    _createClass(CardOrdinacijaController, [{
	        key: 'itemsChanged',
	        value: function itemsChanged() {
	            var _this = this;
	
	            return function (newValue, oldValue) {
	                var items = _lodash2['default'].map(newValue, _lodash2['default'].clone);
	                _this.rows = [];
	                for (var i = 0, j = items.length; i < j; i = i + 4) {
	                    _this.rows.push(items.splice(0, 4));
	                }
	            };
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.onEdit({ item: item });
	        }
	    }]);
	
	    return CardOrdinacijaController;
	})();
	
	CardOrdinacijaController.$inject = ['$scope'];
	
	var CardOrdinacijaComponent = {
	    restrict: 'E',
	    templateUrl: _cardOrdinacijaHtml2['default'],
	    controller: CardOrdinacijaController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onEdit: '&'
	    }
	};
	
	exports.CardOrdinacijaComponent = CardOrdinacijaComponent;

/***/ },
/* 576 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/cardOrdinacija.html';
	var html = "<div class=\"row\" ng-repeat=\"row in vm.rows\"><div class=\"col-lg-3\" ng-repeat=\"item in row\"><div class=\"hpanel hviolet contact-panel\"><div class=\"panel-body\"><div class=\"btn-group pull-right\"><button data-toggle=\"dropdown\" class=\"btn btn-success btn-xs dropdown-toggle\" aria-expanded=\"false\">Akcije <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ui-sref=\"ordinacija.details({id: item.id})\">Detalji</a></li></ul></div><i class=\"fa fa-user fa-3x\"></i><h3><a ui-sref=\"ordinacija.details({id: item.id})\">{{item.naziv}}</a></h3><div class=\"text-muted font-bold m-b-xs\">{{item.adresa}}, {{item.postanski_broj}} {{item.mjesto}}</div><p>Korisničko ime: <strong>{{item.korisnicko_ime}}</strong></p><p>E-mail: <strong><a>{{item.email}}</a></strong></p></div><div class=\"panel-footer contact-footer\"><div class=\"row\"><div class=\"col-md-6 border-right\"><div class=\"contact-stat\"><span>OIB:</span> <strong>{{item.oib}}</strong></div></div><div class=\"col-md-6 border-right\"><div class=\"contact-stat\"><span>Telefon:</span> <strong>{{item.telefon}}</strong></div></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaDetailsHtml = __webpack_require__(578);
	
	var _ordinacijaDetailsHtml2 = _interopRequireDefault(_ordinacijaDetailsHtml);
	
	var OrdinacijaDetailsController = (function () {
	    function OrdinacijaDetailsController(DS, AppConfiguration, $q, $uibModal, logger) {
	        _classCallCheck(this, OrdinacijaDetailsController);
	
	        this.$q = $q;
	        this.$uibModal = $uibModal;
	        this.logger = logger;
	        this.icon = false;
	        this.pageTitle = 'Ordinacija dentalne medicine:' || false;
	        this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
	        this.datastore = function () {
	            return DS;
	        };
	        this.naloziListView = AppConfiguration().getViewByEntityAndType('RadniNalog', 'OrdinacijaViews');
	        this.korisniciListView = AppConfiguration().getViewByEntityAndType('KorisnikOrdinacija', 'ListView');
	        this.korisniciCreateView = AppConfiguration().getViewByEntityAndType('KorisnikOrdinacija', 'CreateView');
	    }
	
	    _createClass(OrdinacijaDetailsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.shouldDisplayActions = true;
	            this.pageTitle = 'Ordinacija dentalne medicine: ' + this.item.naziv;
	            this.refreshState();
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            this.getNaloge();
	            this.getKorisnike();
	        }
	    }, {
	        key: 'getNaloge',
	        value: function getNaloge() {
	            var _this = this;
	
	            var DS = this.datastore();
	            this.resolveReferences().then(function () {
	                return DS.findAll('RadniNalog', { ordinacija: _this.item.id, aktivne: 1 }, { bypassCache: true });
	            }).then(function (response) {
	                _this.nalozi = response;
	            });
	        }
	    }, {
	        key: 'getKorisnike',
	        value: function getKorisnike() {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            DS.findAll('KorisnikOrdinacija', { ordinacija: this.item.id }, { bypassCache: true }).then(function (response) {
	                _this2.korisnici = response.map(function (item) {
	                    return {
	                        id: item.id,
	                        user_id: item.user.id,
	                        first_name: item.user.first_name,
	                        last_name: item.user.last_name,
	                        email: item.user.email,
	                        username: item.user.username
	                    };
	                });
	            });
	        }
	    }, {
	        key: 'insertKorisnika',
	        value: function insertKorisnika() {
	            var _this3 = this;
	
	            var DS = this.datastore();
	            var _view = this.korisniciCreateView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return {};
	                    },
	                    view: function view() {
	                        return _view;
	                    },
	                    formClass: function formClass() {
	                        return 'horizontal';
	                    }
	                }
	            });
	
	            modal.result.then(function (user) {
	                DS.create('KorisnikOrdinacija', { ordinacija: _this3.item.id, user: user }, { cacheResponse: true }).then(function (response) {
	                    _this3.refreshState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Oops...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'deleteKorisnika',
	        value: function deleteKorisnika(item) {
	            var _this4 = this;
	
	            var DS = this.datastore();
	            var previousWindowKeyDown = window.onkeydown;
	            swal({
	                title: 'Brisanje korisnika',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    DS.destroy('KorisnikOrdinacija', item.id).then(function (data) {
	                        _this4.refreshState();
	                        swal('Redak obrisan', '', 'success');
	                    }, function (error) {
	                        swal('Greška', 'Došlo je do greške prilikom brisanja', 'error');
	                    });
	                    return true;
	                }
	                swal.showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.naloziListView.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }]);
	
	    return OrdinacijaDetailsController;
	})();
	
	OrdinacijaDetailsController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', 'logger'];
	
	var OrdinacijaDetailsComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaDetailsHtml2['default'],
	    controller: OrdinacijaDetailsController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.OrdinacijaDetailsComponent = OrdinacijaDetailsComponent;

/***/ },
/* 578 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaDetails.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\"><div animate-panel><div class=\"row\"><div class=\"col-lg-12\"><a ui-sref=\"radniNalog.create\" class=\"btn btn-info\" type=\"button\"><i class=\"fa fa-plus-square\"></i> Novi nalog</a> <a ui-sref=\"ordinacija.details.edit({id: vm.item.id})\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-edit\"></i> Izmjeni</a></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"hpanel stats\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"pull-right\"><i class=\"fa fa-building-o fa-3x\"></i></div><div class=\"panel-title\">ORDINACIJA DENTALNE MEDICINE</div><small class=\"fo\">Osnovni podaci</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Naziv</td><td width=\"65%\"><b>{{vm.item.naziv}}</b></td></tr><tr><td width=\"35%\">OIB</td><td width=\"65%\"><b>{{vm.item.oib}}</b></td></tr><tr><td width=\"35%\">Radno vrijeme</td><td width=\"65%\"><b>{{vm.item.radno_vrijeme}}</b></td></tr><tr><td width=\"35%\">Napomena</td><td width=\"65%\"><b>{{vm.item.napomena}}</b></td></tr></tbody></table><small class=\"fo\">Adresa, kontakt</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Adresa</td><td width=\"65%\"><b>{{vm.item.adresa}}</b></td></tr><tr><td width=\"35%\">Naziv mjesta</td><td width=\"65%\"><b>{{vm.item.postanski_broj}} {{vm.item.mjesto}}</b></td></tr><tr><td width=\"35%\">E-mail</td><td width=\"65%\"><b>{{vm.item.email}}</b></td></tr><tr><td width=\"35%\">Telefon</td><td width=\"65%\"><b>{{vm.item.telefon}}</b></td></tr></tbody></table><small class=\"fo\">Korisnički računi</small><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertKorisnika()\"><i class=\"fa fa-plus-square\"></i> Novi korisnik</button></div><hr><table class=\"table table-striped table-hover\"><thead><tr><th class=\"col-md-2\">Ime</th><th class=\"col-md-2\">Prezime</th><th>Email</th><th>Username</th><th ng-if=\"vm.shouldDisplayActions\">Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.korisnici\"><td>{{item.first_name}}</td><td>{{item.last_name}}</td><td>{{item.email}}</td><td>{{item.username}}</td><td ng-if=\"vm.shouldDisplayActions\"><a ng-click=\"vm.deleteKorisnika(item)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-close\"></i></a></td></tr></tbody></table></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-12\"><h4><i class=\"fa fa-file\"></i> Radni nalozi - aktivni</h4><hr></div></div><div class=\"table-responsive project-list\"><table class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum naloga</th><th>Pacijent</th><th class=\"col-lg-2 text-center\">Broj naloga</th></tr></thead><tbody><tr ng-repeat=\"item in vm.nalozi\"><td>{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td>{{item.pacijent}},<br><small><i class=\"fa fa-clock-o\"></i> Status: <strong>{{item.status}}</strong></small></td><td class=\"text-center\"><rn-link rn=\"item\"></rn-link></td></tr></tbody></table></div></div><div class=\"panel-footer\"><a ui-sref=\"radniNalog\" class=\"btn btn-xs btn-success\">Pregled svih radnih naloga</a></div></div></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaCreateEditHtml = __webpack_require__(580);
	
	var _ordinacijaCreateEditHtml2 = _interopRequireDefault(_ordinacijaCreateEditHtml);
	
	var _sweetalert = __webpack_require__(459);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var OrdinacijaCreateController = (function () {
	    function OrdinacijaCreateController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, OrdinacijaCreateController);
	
	        this.$state = $state;
	        this.logger = logger;
	        this.Model = DS.definitions['Ordinacija'];
	        this.view = AppConfiguration().getViewByEntityAndType('Ordinacija', 'CreateView');
	    }
	
	    _createClass(OrdinacijaCreateController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pageTitle = 'Unos nove ordinacije dentalne medicine';
	            this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
	            this.fields = this.view.fields();
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            this.Model.create(item).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspiješno pohranjeni',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this.Model.ejectAll();
	                    _this.$state.go('ordinacija.details', { id: response.id });
	                });
	            })['catch'](function (error) {
	                _this.logger.error('Upsss', error.data);
	            });
	        }
	    }]);
	
	    return OrdinacijaCreateController;
	})();
	
	OrdinacijaCreateController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var OrdinacijaCreateComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaCreateEditHtml2['default'],
	    controller: OrdinacijaCreateController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.OrdinacijaCreateComponent = OrdinacijaCreateComponent;
	exports.OrdinacijaCreateController = OrdinacijaCreateController;

/***/ },
/* 580 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaCreateEdit.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><ordinacija-form fields=\"vm.fields\" on-submit=\"vm.submit(item)\" item=\"vm.item\"></ordinacija-form></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaCreateEditHtml = __webpack_require__(580);
	
	var _ordinacijaCreateEditHtml2 = _interopRequireDefault(_ordinacijaCreateEditHtml);
	
	var _sweetalert = __webpack_require__(459);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var OrdinacijaEditController = (function () {
	    function OrdinacijaEditController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, OrdinacijaEditController);
	
	        this.$state = $state;
	        this.logger = logger;
	        this.Model = DS.definitions['Ordinacija'];
	        this.view = AppConfiguration().getViewByEntityAndType('Ordinacija', 'CreateView');
	    }
	
	    _createClass(OrdinacijaEditController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pageTitle = 'Izmjena ordinacije dentalne medicine ' + this.item.naziv;
	            this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
	            this.fields = this.view.fields();
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            this.Model.update(item.id, item).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspješno ažurirani',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this.$state.go('ordinacija.details', { id: response.id });
	                });
	            })['catch'](function (error) {
	                _this.logger.error('Upsss', error.data);
	            });
	        }
	    }]);
	
	    return OrdinacijaEditController;
	})();
	
	OrdinacijaEditController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var OrdinacijaEditComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaCreateEditHtml2['default'],
	    controller: OrdinacijaEditController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.OrdinacijaEditComponent = OrdinacijaEditComponent;
	exports.OrdinacijaEditController = OrdinacijaEditController;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaFormHtml = __webpack_require__(583);
	
	var _ordinacijaFormHtml2 = _interopRequireDefault(_ordinacijaFormHtml);
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var OrdinacijaFormController = (function () {
	    function OrdinacijaFormController() {
	        _classCallCheck(this, OrdinacijaFormController);
	
	        this.step = 1;
	    }
	
	    _createClass(OrdinacijaFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.step1Fields = this.fields[0];
	            this.step2Fields = this.fields[1];
	            this.model = _angular2['default'].copy(this.item);
	        }
	    }, {
	        key: 'show',
	        value: function show(step) {
	            this.step = step;
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            if (this.step < 2) {
	                this.step++;
	            }
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            if (this.step > 1) {
	                this.step--;
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            this.onSubmit({ item: item });
	        }
	    }]);
	
	    return OrdinacijaFormController;
	})();
	
	OrdinacijaFormController.$inject = [];
	
	var OrdinacijaFormComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaFormHtml2['default'],
	    controller: OrdinacijaFormController,
	    controllerAs: 'vm',
	    bindings: {
	        fields: '<',
	        item: '<',
	        onSubmit: '&'
	    }
	};
	
	exports.OrdinacijaFormComponent = OrdinacijaFormComponent;
	exports.OrdinacijaFormController = OrdinacijaFormController;

/***/ },
/* 583 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaForm.html';
	var html = "<form name=\"vm.form\" novalidate ng-submit=\"vm.submit(vm.model)\"><div class=\"text-center m-b-md\" id=\"wizardControl\"><a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 1, 'btn-default': vm.step != 1}\" ng-click=\"vm.show(1)\">1 - Osnovni podaci</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 2, 'btn-default': vm.step != 2}\" ng-click=\"vm.show(2)\">2 - Kontakt, korisnički račun</a></div><div class=\"tab-content\"><div id=\"step1\" class=\"p-m\" ng-show=\"vm.step == 1\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"fa fa-building-o fa-3x text-muted\"></i><p class=\"small m-t-md\">Osnovni podaci o <strong>ordinaciji dentalne medicine</strong></p></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.step1Fields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a></div></div><div id=\"step2\" class=\"p-m\" ng-show=\"vm.step == 2\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"pe-7s-map-marker fa-5x text-muted\"></i><p class=\"small m-t-md\"><strong>Kontakt podaci</strong> ordinacije.<br>Podaci o <strong>korisničkom računu</strong> za rad u aplikaciji</p></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.step2Fields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-success\" ng-click=\"vm.submit(vm.model)\">Potvrdi</a></div></div></div></form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcPagination = __webpack_require__(566);
	
	var _angularUiBootstrapSrcPagination2 = _interopRequireDefault(_angularUiBootstrapSrcPagination);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(513);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _commonCrudCrudJs = __webpack_require__(455);
	
	var _cjenikComponentJs = __webpack_require__(585);
	
	var _cardCjenikComponentJs = __webpack_require__(587);
	
	var _stavkaCjenikaComponentJs = __webpack_require__(589);
	
	var cjenik = _angular2['default'].module('cjenik', [_angularUiBootstrapSrcPagination2['default'], _angularUiBootstrapSrcModal2['default'], _commonCrudCrudJs.crud.name]);
	
	cjenik.component('cjenik', _cjenikComponentJs.CjenikComponent);
	cjenik.component('cardCjenik', _cardCjenikComponentJs.CardCjenikComponent);
	cjenik.component('stavkaCjenika', _stavkaCjenikaComponentJs.StavkaCjenikaComponent);
	
	exports.cjenik = cjenik;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _cjenikHtml = __webpack_require__(586);
	
	var _cjenikHtml2 = _interopRequireDefault(_cjenikHtml);
	
	var _commonListControllerJs = __webpack_require__(469);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var CjenikController = (function (_ListController) {
	    _inherits(CjenikController, _ListController);
	
	    function CjenikController(DS, $q, $uibModal, AppConfiguration, logger) {
	        _classCallCheck(this, CjenikController);
	
	        _get(Object.getPrototypeOf(CjenikController.prototype), 'constructor', this).call(this, DS.definitions.Cjenik);
	        this.DS = DS;
	        this.$q = $q;
	        this.logger = logger;
	        this.view = AppConfiguration().getViewByEntityAndType('Cjenik', 'ListView');
	        this.formView = AppConfiguration().getViewByEntityAndType('Cjenik', 'EditView');
	        this.$uibModal = $uibModal;
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.title();
	        this.pageDesc = this.view.description();
	
	        this.getState();
	    }
	
	    _createClass(CjenikController, [{
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            this.DS.findAll('Valuta').then(function (response) {
	                _this.valute = response;
	            })['finally'](function () {
	                _this.getItems();
	            });
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params, { bypassCache: true });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this2 = this;
	
	            var modal = this.showForm(item);
	            modal.result.then(function (model) {
	                _this2.Model.update(model.id, model).then(function () {
	                    return _this2.getState();
	                })['catch'](function (error) {
	                    _this2.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'insert',
	        value: function insert() {
	            var _this3 = this;
	
	            var modal = this.showForm({});
	            modal.result.then(function (model) {
	                _this3.Model.create(model).then(function () {
	                    return _this3.getState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'showForm',
	        value: function showForm(_item) {
	            var _view = this.formView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return _item;
	                    },
	                    view: function view() {
	                        return _view;
	                    }
	                }
	            });
	            return modal;
	        }
	    }]);
	
	    return CjenikController;
	})(_commonListControllerJs2['default']);
	
	CjenikController.$inject = ['DS', '$q', '$uibModal', 'AppConfiguration', 'logger'];
	
	var CjenikComponent = {
	    restrict: 'E',
	    templateUrl: _cjenikHtml2['default'],
	    controller: CjenikController,
	    controllerAs: 'vm'
	};
	
	exports.CjenikComponent = CjenikComponent;

/***/ },
/* 586 */
/***/ function(module, exports) {

	var path = 'app/components/cjenik/cjenik.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul><uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></uib-pagination></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ng-click=\"vm.insert()\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><hr><div ng-if=\"vm.items.length > 0\" animate-panel><card-cjenik class=\"card\" items=\"vm.items\" valute=\"vm.valute\" on-edit=\"vm.edit(item)\"></card-cjenik></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cardCjenikHtml = __webpack_require__(588);
	
	var _cardCjenikHtml2 = _interopRequireDefault(_cardCjenikHtml);
	
	var CardCjenikController = (function () {
	    function CardCjenikController(DS, $scope) {
	        _classCallCheck(this, CardCjenikController);
	
	        this.store = DS;
	        this.valute = _lodash2['default'].castArray(this.valute);
	        this.items = this.items || [];
	        this.rows = [];
	        $scope.$watch('vm.items', this.itemsChanged());
	    }
	
	    _createClass(CardCjenikController, [{
	        key: 'itemsChanged',
	        value: function itemsChanged() {
	            var _this = this;
	
	            return function (newValue, oldValue) {
	                var items = _lodash2['default'].map(newValue, _lodash2['default'].clone);
	                _this.rows = [];
	                for (var i = 0, j = items.length; i < j; i = i + 4) {
	                    _this.rows.push(items.splice(0, 4));
	                }
	            };
	        }
	    }, {
	        key: 'getValutu',
	        value: function getValutu(item) {
	            return _lodash2['default'].find(this.valute, function (i) {
	                return i.id === item.valuta;
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.onEdit({ item: item });
	        }
	    }]);
	
	    return CardCjenikController;
	})();
	
	var CardCjenikComponent = {
	    restrict: 'E',
	    templateUrl: _cardCjenikHtml2['default'],
	    controller: CardCjenikController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        valute: '<',
	        onEdit: '&'
	    }
	};
	
	CardCjenikController.$inject = ['DS', '$scope'];
	exports.CardCjenikComponent = CardCjenikComponent;

/***/ },
/* 588 */
/***/ function(module, exports) {

	var path = 'app/components/cjenik/cardCjenik.html';
	var html = "<div class=\"row\" ng-repeat=\"row in vm.rows\"><div class=\"col-lg-3\" ng-repeat=\"item in row\"><div class=\"hpanel hgreen contact-panel\"><div class=\"panel-body\"><div class=\"btn-group pull-right\"><button data-toggle=\"dropdown\" class=\"btn btn-success btn-xs dropdown-toggle\" aria-expanded=\"false\">Akcije <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"vm.edit(item)\"><i class=\"fa fa-edit\"></i> Ažuriranje zaglavlja</a></li><li class=\"divider\"></li><li><a ui-sref=\"cjenik.details({id: item.id})\"><i class=\"fa fa-list-alt\"></i> Ažuriranje cijena</a></li><li><a><i class=\"fa fa-print\"></i> Ispis cjenika</a></li></ul></div><a ui-sref=\"cjenik.details({id: item.id})\"><i class=\"fa fa-list-alt fa-3x\"></i></a><h3><a ui-sref=\"cjenik.details({id: item.id})\">{{item.naziv}}</a></h3></div><div class=\"panel-footer contact-footer\"><div class=\"row\"><div class=\"col-md-12 border-right\"><div class=\"contact-stat\"><span>Valuta:</span> <strong>{{vm.getValutu(item).valuta | uppercase}}</strong></div></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _sweetalert = __webpack_require__(459);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _stavkaCjenikaHtml = __webpack_require__(590);
	
	var _stavkaCjenikaHtml2 = _interopRequireDefault(_stavkaCjenikaHtml);
	
	var _commonListControllerJs = __webpack_require__(469);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var StavkaCjenikaController = (function (_ListController) {
	    _inherits(StavkaCjenikaController, _ListController);
	
	    function StavkaCjenikaController(DS, AppConfiguration, $q, $uibModal, logger) {
	        _classCallCheck(this, StavkaCjenikaController);
	
	        _get(Object.getPrototypeOf(StavkaCjenikaController.prototype), 'constructor', this).call(this);
	        this.DS = DS;
	        this.$q = $q;
	        this.logger = logger;
	        this.$uibModal = $uibModal;
	        this.Model = DS.definitions['StavkaCjenika'] || false;
	        this.view = AppConfiguration().getViewByEntityAndType('StavkaCjenika', 'ListView');
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.getTitle({ naziv: this.cjenik.naziv });
	        this.pageDesc = this.view.description();
	
	        this.getState();
	    }
	
	    _createClass(StavkaCjenikaController, [{
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            this.resolveReferences().then(function () {
	                _this.getItems();
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.view.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            var cloneParams = _extends({}, params);
	            cloneParams.cjenik = this.cjenik.id;
	            return this.Model.findAll(cloneParams, { bypassCache: true });
	        }
	    }, {
	        key: 'datastore',
	        value: function datastore() {
	            return this.DS;
	        }
	    }, {
	        key: 'insert',
	        value: function insert() {
	            var _this2 = this;
	
	            var model = {
	                cjenik: this.cjenik.id
	            };
	            var entity = this.view.entity;
	            var _view = entity.creationView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this2.Model.create(model).then(function () {
	                    _this2.Model.ejectAll();
	                    _this2.getState();
	                })['catch'](function (error) {
	                    _this2.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this3 = this;
	
	            var model = item;
	            var entity = this.view.entity;
	            var _view2 = entity.creationView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view2;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this3.Model.update(model.id, model).then(function () {
	                    return _this3.getState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(item) {
	            var _this4 = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje retka stavke cjenika ',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    _this4.Model.destroy(item.id).then(function (data) {
	                        _this4.getState();
	                        (0, _sweetalert2['default'])('Redak obrisan', '', 'success');
	                    }, function (error) {
	                        (0, _sweetalert2['default'])('Greška', 'Došlo je do greške prilikom brisanja', 'error');
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }]);
	
	    return StavkaCjenikaController;
	})(_commonListControllerJs2['default']);
	
	StavkaCjenikaController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', 'logger'];
	
	var StavkaCjenikaComponent = {
	    restrict: 'E',
	    templateUrl: _stavkaCjenikaHtml2['default'],
	    controller: StavkaCjenikaController,
	    controllerAs: 'vm',
	    bindings: {
	        cjenik: '<'
	    }
	};
	
	exports.StavkaCjenikaComponent = StavkaCjenikaComponent;

/***/ },
/* 590 */
/***/ function(module, exports) {

	var path = 'app/components/cjenik/stavkaCjenika.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Naziv protetskog rada / usluge\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\" id=\"example2_paginate\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ng-click=\"vm.insert()\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><div animate-panel child=\"hpanel\"><div class=\"hpanel\"><div class=\"panel-heading\"><div class=\"panel-tools\"><a class=\"showhide\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"closebox\" hidden><i class=\"fa fa-times\"></i></a></div><br></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.view.fields()\" entries=\"vm.items\" entity=\"vm.view.entity\" datastore=\"vm.datastore()\" actions=\"vm.view.listActions()\" on-btn-click=\"vm.btnClicked(btnId, params)\" on-edit=\"vm.edit(item)\" on-delete=\"vm.delete(item)\"></in-data-grid></div></div><div class=\"panel-footer\"><br></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(592);
	
	var _angularUiBootstrapSrcPagination = __webpack_require__(566);
	
	var _angularUiBootstrapSrcPagination2 = _interopRequireDefault(_angularUiBootstrapSrcPagination);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(513);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _angularUiBootstrapSrcTooltip = __webpack_require__(169);
	
	var _angularUiBootstrapSrcTooltip2 = _interopRequireDefault(_angularUiBootstrapSrcTooltip);
	
	var _commonCrudCrudJs = __webpack_require__(455);
	
	var _stavkaNalogaStavkaNalogaJs = __webpack_require__(594);
	
	var _radniNalogListComponentJs = __webpack_require__(609);
	
	var _radniNalogDetailsComponentJs = __webpack_require__(611);
	
	var _planRadaComponentJs = __webpack_require__(614);
	
	var _shemaComponentJs = __webpack_require__(617);
	
	var _radniNalogCreateComponentJs = __webpack_require__(619);
	
	var _radniNalogEditComponentJs = __webpack_require__(621);
	
	var _radniNalogWizardFormComponentJs = __webpack_require__(623);
	
	var _evidencijaNalogaComponentJs = __webpack_require__(625);
	
	var _komentariComponentJs = __webpack_require__(627);
	
	var _rnLinkComponentJs = __webpack_require__(630);
	
	var _humanDentalArchesComponentJs = __webpack_require__(632);
	
	var _zubDirectiveJs = __webpack_require__(634);
	
	var _dentalEditorDirectiveJs = __webpack_require__(637);
	
	var radniNalog = _angular2['default'].module('radniNalog', [_angularUiBootstrapSrcPagination2['default'], _angularUiBootstrapSrcModal2['default'], _angularUiBootstrapSrcTooltip2['default'], 'ngFileUpload', _commonCrudCrudJs.crud.name, _stavkaNalogaStavkaNalogaJs.stavkaNaloga.name]);
	
	radniNalog.component('radniNalogList', _radniNalogListComponentJs.RadniNalogListComponent);
	radniNalog.component('radniNalogDetails', _radniNalogDetailsComponentJs.RadniNalogDetailsComponent);
	radniNalog.component('planRada', _planRadaComponentJs.PlanRadaComponent);
	radniNalog.component('shema', _shemaComponentJs.ShemaComponent);
	radniNalog.component('radniNalogCreate', _radniNalogCreateComponentJs.RadniNalogCreateComponent);
	radniNalog.component('radniNalogEdit', _radniNalogEditComponentJs.RadniNalogEditComponent);
	radniNalog.component('radniNalogWizardForm', _radniNalogWizardFormComponentJs.RadniNalogWizardFormComponent);
	radniNalog.component('evidencijaNaloga', _evidencijaNalogaComponentJs.EvidencijaNalogaComponent);
	radniNalog.component('komentari', _komentariComponentJs.KomentariComponent);
	radniNalog.component('rnLink', _rnLinkComponentJs.RnLinkComponent);
	radniNalog.component('humanDentalArches', _humanDentalArchesComponentJs.HumanDentalArchesComponent);
	
	radniNalog.directive('zub', _zubDirectiveJs.zub);
	radniNalog.directive('dentalEditor', _dentalEditorDirectiveJs.editor);
	
	exports.radniNalog = radniNalog;

/***/ },
/* 592 */,
/* 593 */,
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stavkaNalogaFormComponentJs = __webpack_require__(595);
	
	var _odabirPozicijaFormComponentJs = __webpack_require__(598);
	
	var _pozicijeComponentJs = __webpack_require__(600);
	
	var _kvadrantComponentJs = __webpack_require__(602);
	
	var _protetskiPozicijeDirectiveJs = __webpack_require__(604);
	
	var _vrstaRadaComponentJs = __webpack_require__(605);
	
	var _materijalComponentJs = __webpack_require__(607);
	
	var stavkaNaloga = _angular2['default'].module('stavkaNaloga', []);
	
	stavkaNaloga.component('stavkaNalogaForm', _stavkaNalogaFormComponentJs.StavkaNalogaFormComponent);
	stavkaNaloga.component('odabirPozicijaForm', _odabirPozicijaFormComponentJs.OdabirPozicijaFormComponent);
	stavkaNaloga.component('pozicije', _pozicijeComponentJs.PozicijeComponent);
	stavkaNaloga.component('kvadrant', _kvadrantComponentJs.KvadrantComponent);
	stavkaNaloga.component('vrstaRada', _vrstaRadaComponentJs.VrstaRadaComponent);
	stavkaNaloga.component('materijal', _materijalComponentJs.MaterijalComponent);
	
	stavkaNaloga.directive('protetskiPozicije', _protetskiPozicijeDirectiveJs.protetskiPozicije);
	
	exports.stavkaNaloga = stavkaNaloga;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _stavkaNalogaFormHtml = __webpack_require__(596);
	
	var _stavkaNalogaFormHtml2 = _interopRequireDefault(_stavkaNalogaFormHtml);
	
	var _kvadrantJs = __webpack_require__(597);
	
	var StavkaNalogaFormController = (function () {
	    function StavkaNalogaFormController(AppConfiguration, DS, $timeout, logger, $q) {
	        _classCallCheck(this, StavkaNalogaFormController);
	
	        this.item = this.resolve.item;
	        this.logger = logger;
	        this.view = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'CreateView');
	        this.datastore = function () {
	            return DS;
	        };
	        this.$timeout = function () {
	            return $timeout;
	        };
	        this.$q = function () {
	            return $q;
	        };
	    }
	
	    _createClass(StavkaNalogaFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            var $q = this.$q();
	            this.vrste_radova = [];
	            this._materijali = []; // cache materijala za kasnije filtriranje
	            this.stavke_cjenika = [];
	            this.clone = angular.copy(this.item);
	            DS.findAll('StavkaCjenika').then(function (stavke) {
	                _this.stavke_cjenika = stavke;
	
	                DS.findAll('ProtetskiRad').then(function (response) {
	                    _this.protetski_rad = response.filter(function (i) {
	                        return _lodash2['default'].find(_this.stavke_cjenika, { protetski_rad: i.id });
	                    });
	                }).then(function () {
	                    $q.when(DS.findAll('VrstaRada')).then(function (vrsta) {
	                        _this.vrste_radova = vrsta.filter(function (i) {
	                            return _lodash2['default'].find(_this.protetski_rad, { vrsta_rada: i.id });
	                        });
	                    });
	                });
	                DS.findAll('Materijal').then(function (response) {
	                    _this._materijali = response;
	                });
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit(model) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            this.close({ $value: model });
	        }
	    }, {
	        key: 'setVrstuRada',
	        value: function setVrstuRada(item) {
	            var _this2 = this;
	
	            if (item === undefined) {
	                this.clone.vrsta_rada = undefined;
	                this.materijali = [];
	                return;
	            }
	
	            var $timeout = this.$timeout();
	            var radovi = _lodash2['default'].filter(this.protetski_rad, { vrsta_rada: item.id });
	
	            this.clone.vrsta_rada = null;
	            this.clone.protetski_rad = null;
	            this.clone.cjenik = null;
	            var materijali = [];
	
	            _lodash2['default'].forEach(radovi, function (rad) {
	                if (rad.materijal) {
	                    materijali.push(rad.materijal);
	                }
	            });
	
	            if (materijali.length === 0) {
	                this.setProtetskiRadByVrstaRada(item.id);
	            }
	
	            $timeout(function () {
	                _this2.clone.vrsta_rada = item.id;
	                _this2.materijali = _lodash2['default'].uniq(materijali).map(function (m) {
	                    return _lodash2['default'].cloneDeep(_lodash2['default'].find(_this2._materijali, { id: m }));
	                });
	            });
	        }
	    }, {
	        key: 'setMaterijal',
	        value: function setMaterijal(item) {
	            // const $timeout = this.$timeout();
	            // this.setProtetskiRadByVrstaRadaAndMaterijal(this.clone.vrsta_rada, item.id);
	            if (item && _lodash2['default'].isFinite(parseInt(item.id))) {
	                this.clone.materijal = item.id;
	            } else {
	                this.clone.materijal = undefined;
	            }
	            // $timeout(() => {
	            // });
	        }
	    }, {
	        key: 'setProtetskiRadByVrstaRada',
	        value: function setProtetskiRadByVrstaRada(vrsta_rada) {
	            // const protetski_rad = _.find(this.protetski_rad, {vrsta_rada: vrsta_rada});
	            // if (_.isUndefined(protetski_rad)) {
	            //     this.logger.error('Oupss...', 'Traženi protetski rad nije pronađen');
	            //     return;
	            // }
	            // this.clone.protetski_rad = protetski_rad.id;
	            // this.setCjenik(this.clone.protetski_rad);
	        }
	    }, {
	        key: 'setProtetskiRadByVrstaRadaAndMaterijal',
	        value: function setProtetskiRadByVrstaRadaAndMaterijal(vrsta_rada, materijal) {
	            // const protetski_rad = _.find(this.protetski_rad, {vrsta_rada: vrsta_rada, materijal: materijal});
	            // if (_.isUndefined(protetski_rad)) {
	            //     this.logger.error('Oupss...', 'Traženi protetski rad nije pronađen');
	            //     return;
	            // }
	            // this.clone.protetski_rad = protetski_rad.id;
	            // this.setCjenik(this.clone.protetski_rad);
	        }
	    }, {
	        key: 'setCjenik',
	        value: function setCjenik(protetski_rad) {
	            var stavke = _lodash2['default'].filter(this.stavke_cjenika, { protetski_rad: protetski_rad });
	            debugger;
	            if (stavke.length === 1) {
	                this.clone.cjenik = stavke[0].cjenik;
	            }
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }]);
	
	    return StavkaNalogaFormController;
	})();
	
	StavkaNalogaFormController.$inject = ['AppConfiguration', 'DS', '$timeout', 'logger', '$q'];
	
	var StavkaNalogaFormComponent = {
	    restrict: 'E',
	    templateUrl: _stavkaNalogaFormHtml2['default'],
	    controller: StavkaNalogaFormController,
	    controllerAs: 'vm',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    }
	};
	
	exports.StavkaNalogaFormComponent = StavkaNalogaFormComponent;
	exports.StavkaNalogaFormController = StavkaNalogaFormController;

/***/ },
/* 596 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/stavkaNalogaForm.html';
	var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header padding15\"><h1 ng-if=\"vm.clone.pozicije.length > 0\" class=\"modal-title\">Odabrana pozicija za rad: <a ng-repeat=\"p in vm.clone.pozicije\" class=\"btn btn-lg btn-warning pozicije\">{{p}}</a></h1></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"vm.vrste_radova.length > 0\" animate-panel><vrsta-rada items=\"vm.vrste_radova\" on-click=\"vm.setVrstuRada(item)\"></vrsta-rada></div><div class=\"col-lg-3 col-sm-12\" ng-if=\"vm.materijali.length > 0\" animate-panel><materijal items=\"vm.materijali\" on-click=\"vm.setMaterijal(item)\"></materijal></div><div class=\"col-lg-9 col-sm-12\" animate-panel><div class=\"row\"><div class=\"col-lg-12\"><form name=\"vm.form\" ng-submit=\"vm.submit(vm.clone)\" class=\"form-horizontal\"><formly-form model=\"vm.clone\" fields=\"vm.view.fields()\" form=\"vm.form\" options=\"vm.options\"></formly-form></form></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.submit(vm.clone)\">Potvrdi</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 597 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var kvadrant_I = [{ broj: 18, selected: false, veza: false }, { broj: 1817, selected: false, veza: true }, { broj: 17, selected: false, veza: false }, { broj: 1716, selected: false, veza: true }, { broj: 16, selected: false, veza: false }, { broj: 1615, selected: false, veza: true }, { broj: 15, selected: false, veza: false }, { broj: 1514, selected: false, veza: true }, { broj: 14, selected: false, veza: false }, { broj: 1413, selected: false, veza: true }, { broj: 13, selected: false, veza: false }, { broj: 1312, selected: false, veza: true }, { broj: 12, selected: false, veza: false }, { broj: 1211, selected: false, veza: true }, { broj: 11, selected: false, veza: false }, { broj: 1121, selected: false, veza: true }];
	
	var kvadrant_II = [{ broj: 21, selected: false, veza: false }, { broj: 2122, selected: false, veza: true }, { broj: 22, selected: false, veza: false }, { broj: 2223, selected: false, veza: true }, { broj: 23, selected: false, veza: false }, { broj: 2324, selected: false, veza: true }, { broj: 24, selected: false, veza: false }, { broj: 2425, selected: false, veza: true }, { broj: 25, selected: false, veza: false }, { broj: 2526, selected: false, veza: true }, { broj: 26, selected: false, veza: false }, { broj: 2627, selected: false, veza: true }, { broj: 27, selected: false, veza: false }, { broj: 2728, selected: false, veza: true }, { broj: 28, selected: false, veza: false }];
	
	var kvadrant_III = [{ broj: 31, selected: false, veza: false }, { broj: 3132, selected: false, veza: true }, { broj: 32, selected: false, veza: false }, { broj: 3233, selected: false, veza: true }, { broj: 33, selected: false, veza: false }, { broj: 3334, selected: false, veza: true }, { broj: 34, selected: false, veza: false }, { broj: 3435, selected: false, veza: true }, { broj: 35, selected: false, veza: false }, { broj: 3536, selected: false, veza: true }, { broj: 36, selected: false, veza: false }, { broj: 3637, selected: false, veza: true }, { broj: 37, selected: false, veza: false }, { broj: 3738, selected: false, veza: true }, { broj: 38, selected: false, veza: false }];
	
	var kvadrant_IV = [{ broj: 48, selected: false, veza: false }, { broj: 4847, selected: false, veza: true }, { broj: 47, selected: false, veza: false }, { broj: 4746, selected: false, veza: true }, { broj: 46, selected: false, veza: false }, { broj: 4645, selected: false, veza: true }, { broj: 45, selected: false, veza: false }, { broj: 4544, selected: false, veza: true }, { broj: 44, selected: false, veza: false }, { broj: 4443, selected: false, veza: true }, { broj: 43, selected: false, veza: false }, { broj: 4342, selected: false, veza: true }, { broj: 42, selected: false, veza: false }, { broj: 4241, selected: false, veza: true }, { broj: 41, selected: false, veza: false }, { broj: 4131, selected: false, veza: true }];
	
	exports.kvadrant_I = kvadrant_I;
	exports.kvadrant_II = kvadrant_II;
	exports.kvadrant_III = kvadrant_III;
	exports.kvadrant_IV = kvadrant_IV;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _odabirPozicijaFormHtml = __webpack_require__(599);
	
	var _odabirPozicijaFormHtml2 = _interopRequireDefault(_odabirPozicijaFormHtml);
	
	var _kvadrantJs = __webpack_require__(597);
	
	var OdabirPozicijaFormController = (function () {
	    function OdabirPozicijaFormController() {
	        _classCallCheck(this, OdabirPozicijaFormController);
	
	        this.item = this.resolve.item;
	        this.kvadranti = [];
	    }
	
	    _createClass(OdabirPozicijaFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.clone = angular.copy(this.item);
	
	            this.kvadranti = [_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_I), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_II), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_III), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_IV)];
	
	            this.kvadranti.map(function (kvadrant) {
	                kvadrant.map(function (pozicija) {
	                    var item = _lodash2['default'].find(_this.clone.pozicije, { broj: pozicija.broj });
	                    pozicija.selected = _lodash2['default'].isUndefined(item) ? false : true;
	                });
	            });
	
	            if (_lodash2['default'].isArray(this.clone.pozicije) === false) {
	                this.clone.pozicije = [];
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var pozicije = [];
	            this.kvadranti.map(function (kvadrant) {
	                kvadrant.map(function (pozicija) {
	                    if (pozicija.selected) {
	                        pozicije.push({ broj: pozicija.broj, selected: pozicija.selected });
	                    }
	                });
	            });
	            this.close({ $value: pozicije });
	        }
	    }, {
	        key: 'pozicijaClicked',
	        value: function pozicijaClicked(pozicija) {
	
	            this.kvadranti.map(function (kvadrant) {
	                kvadrant.map(function (item) {
	                    if (item.broj === pozicija.broj) {
	                        pozicija.selected = !pozicija.selected;
	                    }
	                });
	            });
	            this.submit();
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }]);
	
	    return OdabirPozicijaFormController;
	})();
	
	OdabirPozicijaFormController.$inject = [];
	
	var OdabirPozicijaFormComponent = {
	    restrict: 'E',
	    templateUrl: _odabirPozicijaFormHtml2['default'],
	    controller: OdabirPozicijaFormController,
	    controllerAs: 'vm',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    }
	};
	
	exports.OdabirPozicijaFormComponent = OdabirPozicijaFormComponent;
	exports.OdabirPozicijaFormController = OdabirPozicijaFormController;

/***/ },
/* 599 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/odabirPozicijaForm.html';
	var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header\"><h5 class=\"modal-title\">Odaberite pozicije</h5></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">1. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[0]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">2. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[1]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">4. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[3]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">3. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[2]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.submit()\">Potvrdi</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _pozicijeHtml = __webpack_require__(601);
	
	var _pozicijeHtml2 = _interopRequireDefault(_pozicijeHtml);
	
	var PozicijeController = (function () {
	    function PozicijeController() {
	        _classCallCheck(this, PozicijeController);
	    }
	
	    _createClass(PozicijeController, [{
	        key: '$onInit',
	
	        // this.items = [];
	        value: function $onInit() {}
	    }, {
	        key: 'pozicijaClicked',
	        value: function pozicijaClicked(pozicija) {
	            this.onClick({ pozicija: pozicija });
	        }
	    }]);
	
	    return PozicijeController;
	})();
	
	PozicijeController.$inject = [];
	
	var PozicijeComponent = {
	    restrict: 'E',
	    templateUrl: _pozicijeHtml2['default'],
	    controller: PozicijeController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onClick: '&'
	    }
	};
	
	exports.PozicijeComponent = PozicijeComponent;
	exports.PozicijeController = PozicijeController;

/***/ },
/* 601 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/pozicije.html';
	var html = "<table cellpadding=\"1\" cellspacing=\"1\" class=\"table table-condensed no_border\"><tbody><tr><th class=\"text-center\" ng-repeat=\"pozicija in vm.items\"><a ng-click=\"vm.pozicijaClicked(pozicija)\" ng-class=\"{'btn-warning': pozicija.selected}\" class=\"btn btn-xs btn-default pozicije\">{{pozicija.broj}}</a></th></tr></tbody></table>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _kvadrantHtml = __webpack_require__(603);
	
	var _kvadrantHtml2 = _interopRequireDefault(_kvadrantHtml);
	
	var _kvadrantJs = __webpack_require__(597);
	
	var KvadrantController = (function () {
	    function KvadrantController($scope) {
	        _classCallCheck(this, KvadrantController);
	
	        this.kvadranti = [_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_I).concat(_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_II)), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_IV).concat(_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_III))];
	
	        this.$scope = $scope;
	        this.kvadrant = this.kvadrant || 1;
	        // debugger;
	        this.stavke = this.stavke || [];
	        this.pozicije = [];
	        this.dragStarted = false;
	    }
	
	    _createClass(KvadrantController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pozicije = this.kvadranti[this.kvadrant - 1];
	            this.$scope.$watch('vm.stavke', this.refreshPozicije(), true);
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(pozicija) {
	            if (!this.dragStarted) {
	                this.pozicijaClicked({ pozicija: pozicija });
	            }
	        }
	    }, {
	        key: 'refreshStavke',
	        value: function refreshStavke() {
	            var that = this;
	            return function (newValue, oldValue) {
	                that.pozicije.map(function (i) {
	                    return i.selected = false;
	                });
	                that.stavke.map(function (stavka) {
	                    that.pozicije.map(function (item) {
	                        var pozicija = _lodash2['default'].find(stavka.pozicije, { broj: item.broj });
	                        if (_lodash2['default'].isUndefined(pozicija) === false) {
	                            item.selected = pozicija.selected;
	                        }
	                    });
	                });
	            };
	        }
	    }, {
	        key: 'onDropComplete',
	        value: function onDropComplete(toPozicija, fromPozicija, $event) {
	            this.dragStarted = false;
	            $event.event.stopPropagation();
	            this.onDrop({ from: fromPozicija, to: toPozicija });
	        }
	    }, {
	        key: 'onDragStarted',
	        value: function onDragStarted($event) {
	            this.dragStarted = true;
	        }
	    }, {
	        key: 'refreshPozicije',
	        value: function refreshPozicije() {
	            var _this = this;
	
	            var that = this;
	            return function (newValue, oldValue) {
	                that.pozicije.map(function (pozicija) {
	                    var stavka = _lodash2['default'].find(_this.stavke, { broj: pozicija.broj });
	                    pozicija.selected = _lodash2['default'].isObject(stavka);
	                });
	            };
	        }
	    }]);
	
	    return KvadrantController;
	})();
	
	KvadrantController.$inject = ['$scope'];
	
	var KvadrantComponent = {
	    restrict: 'E',
	    templateUrl: _kvadrantHtml2['default'],
	    controller: KvadrantController,
	    controllerAs: 'vm',
	    bindings: {
	        stavke: '<',
	        kvadrant: '<',
	        pozicijaClicked: '&',
	        onDrop: '&'
	    }
	};
	
	exports.KvadrantComponent = KvadrantComponent;
	exports.KvadrantController = KvadrantController;

/***/ },
/* 603 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/kvadrant.html';
	var html = "<div class=\"table-responsive\"><table cellpadding=\"1\" cellspacing=\"1\" border=\"0\" class=\"table table-condensed table-kvadrant\" ng-if=\"vm.kvadrant===1\"><thead><tr><th class=\"text-center\" ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"!pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"btn btn-xs btn-default pozicije\" ng-class=\"{'btn-warning': pozicija.selected}\">{{pozicija.broj}}</a></th></tr></thead><tbody><tr><td ng-repeat=\"pozicija in vm.pozicije\" ng-drop=\"true\" ng-drop-success=\"vm.onDropComplete(pozicija, $data,$event)\" ng-drag-start=\"vm.onDragStarted($event)\"><div ng-if=\"!pozicija.veza\" style=\"z-index: 2\" ng-drag=\"true\" ng-drag-data=\"pozicija\" data-allow-transform=\"false\"><a ng-click=\"vm.onClick(pozicija)\"><img ng-src=\"images/zubi/{{pozicija.broj}}.jpg\" ng-class=\"{'pozicija_selected_kvadrant_1': pozicija.selected}\" class=\"img-responsive center-block zubi_gornji\"></a></div></td></tr><tr><td ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"veza\" ng-class=\"{'active': pozicija.selected}\"></a></td></tr></tbody></table><table cellpadding=\"1\" cellspacing=\"1\" border=\"0\" class=\"table table-condensed table-kvadrant\" ng-if=\"vm.kvadrant===2\"><thead><tr><th ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"veza\" ng-class=\"{'active': pozicija.selected}\"></a></th></tr></thead><tbody><tr><td ng-repeat=\"pozicija in vm.pozicije\" ng-drop=\"true\" ng-drop-success=\"vm.onDropComplete(pozicija, $data,$event)\" ng-drag-start=\"vm.onDragStarted($event)\"><div ng-if=\"!pozicija.veza\" ng-drag=\"true\" ng-drag-data=\"pozicija\" data-allow-transform=\"false\"><a ng-click=\"vm.onClick(pozicija)\"><img ng-src=\"images/zubi/{{pozicija.broj}}.jpg\" ng-class=\"{'pozicija_selected_kvadrant_2': pozicija.selected}\" class=\"img-responsive center-block zubi_donji\"></a></div></td></tr><tr><td class=\"text-center\" ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"!pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"btn btn-xs btn-default pozicije\" ng-class=\"{'btn-warning': pozicija.selected}\">{{pozicija.broj}}</a></td></tr></tbody></table></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function protetskiPozicije() {
	    return {
	        restrict: 'E',
	        controller: ['DS', '$scope', function (DS, $scope) {
	            $scope.protetski_rad_naziv = function () {
	                var protetski_rad = DS.get('ProtetskiRad', $scope.entry.protetski_rad);
	                if (_lodash2['default'].isObject(protetski_rad)) {
	                    return protetski_rad.naziv;
	                }
	                return protetski_rad;
	            };
	        }],
	        template: '\n            <div><strong>{{protetski_rad_naziv()}}</strong></div>\n            <small>\n                <span ng-repeat="pozicija in entry.pozicije track by $index" ng-show="pozicija">[{{pozicija}}] </span>\n            </small>\n        '
	    };
	}
	
	exports.protetskiPozicije = protetskiPozicije;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vrstaRadaHtml = __webpack_require__(606);
	
	var _vrstaRadaHtml2 = _interopRequireDefault(_vrstaRadaHtml);
	
	var VrstaRadaController = (function () {
	    function VrstaRadaController(DS) {
	        _classCallCheck(this, VrstaRadaController);
	
	        this.datastore = function () {
	            return DS;
	        };
	    }
	
	    _createClass(VrstaRadaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.selectedItem = undefined;
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            if (changes.items.currentValue.length > 0) {
	                this.grupe = [];
	                this.refreshState();
	            }
	        }
	    }, {
	        key: 'click',
	        value: function click(item) {
	            if (this.selectedItem === item) {
	                this.selectedItem = undefined;
	                this.onClick({ item: undefined });
	            } else {
	                this.selectedItem = item;
	                this.onClick({ item: item });
	            }
	        }
	    }, {
	        key: 'itemSelected',
	        value: function itemSelected(item) {
	            // return (!_.isUndefined(this.selectedItem) && this.selectedItem.id === item.id);
	            return this.selectedItem === item;
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this = this;
	
	            var DS = this.datastore();
	            DS.findAll('GrupaRada').then(function (response) {
	                var grupe = response.map(function (grupa) {
	                    var clone = _lodash2['default'].cloneDeep(grupa);
	                    var items = _lodash2['default'].filter(_this.items, { grupa: grupa.id });
	                    clone.items = [];
	                    for (var i = 0, j = items.length; i < j; i = i + 3) {
	                        clone.items.push(items.splice(0, 3));
	                    }
	                    return clone;
	                });
	
	                _this.grupe = _lodash2['default'].filter(grupe, function (i) {
	                    return i.items.length > 0;
	                });
	            });
	        }
	    }]);
	
	    return VrstaRadaController;
	})();
	
	VrstaRadaController.$inject = ['DS'];
	
	var VrstaRadaComponent = {
	    restrict: 'E',
	    templateUrl: _vrstaRadaHtml2['default'],
	    controller: VrstaRadaController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onClick: '&'
	    }
	};
	
	exports.VrstaRadaComponent = VrstaRadaComponent;
	exports.VrstaRadaController = VrstaRadaController;

/***/ },
/* 606 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/vrstaRada.html';
	var html = "<h2>Vrsta rada</h2><hr><div id=\"vrste-rada\" class=\"panel-body float-e-margins\"><div class=\"row\"><div class=\"col-lg-2\" ng-repeat=\"grupa in vm.grupe\"><h4 class=\"m-t-sm m-b-sm\">{{grupa.naziv}}</h4><div ng-repeat=\"row in grupa.items\"><span class=\"vrsta\" ng-repeat=\"item in row\"><a ng-click=\"vm.click(item)\" class=\"btn btn-primary\" ng-class=\"{'btn-warning': vm.itemSelected(item)}\" type=\"button\">{{item.naziv}}</a></span></div></div></div></div><hr>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materijalHtml = __webpack_require__(608);
	
	var _materijalHtml2 = _interopRequireDefault(_materijalHtml);
	
	var MaterijalController = (function () {
	    function MaterijalController() {
	        _classCallCheck(this, MaterijalController);
	    }
	
	    _createClass(MaterijalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.selectedItem = undefined;
	        }
	    }, {
	        key: 'click',
	        value: function click(item) {
	            if (this.selectedItem === item) {
	                this.selectedItem = undefined;
	                this.onClick({ item: undefined });
	            } else {
	                this.selectedItem = item;
	                this.onClick({ item: item });
	            }
	        }
	    }, {
	        key: 'itemSelected',
	        value: function itemSelected(item) {
	            return this.selectedItem === item;
	        }
	    }]);
	
	    return MaterijalController;
	})();
	
	MaterijalController.$inject = [];
	
	var MaterijalComponent = {
	    restrict: 'E',
	    templateUrl: _materijalHtml2['default'],
	    controller: MaterijalController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onClick: '&'
	    }
	};
	
	exports.MaterijalComponent = MaterijalComponent;
	exports.MaterijalController = MaterijalController;

/***/ },
/* 608 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/materijal.html';
	var html = "<h2>Materijal</h2><hr><div class=\"row\"><div class=\"col-lg-12\"><button ng-repeat=\"item in vm.items track by $index\" ng-click=\"vm.click(item)\" class=\"btn btn-primary margin-right10 margin-bottom20\" ng-class=\"{'btn-warning': vm.itemSelected(item)}\" type=\"button\"><i class=\"fa fa-recycle\"></i><br>{{item.naziv}}</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _radniNalogListHtml = __webpack_require__(610);
	
	var _radniNalogListHtml2 = _interopRequireDefault(_radniNalogListHtml);
	
	var _commonListControllerJs = __webpack_require__(469);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var RadniNalogListController = (function (_ListController) {
	    _inherits(RadniNalogListController, _ListController);
	
	    function RadniNalogListController(DS, AppConfiguration, $q, $state) {
	        _classCallCheck(this, RadniNalogListController);
	
	        _get(Object.getPrototypeOf(RadniNalogListController.prototype), 'constructor', this).call(this, DS.definitions.RadniNalog);
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = $q;
	        this.$state = $state;
	        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'ListView');
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.title();
	        this.pageDesc = this.view.description();
	    }
	
	    _createClass(RadniNalogListController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.items = [];
	            this.getState();
	        }
	    }, {
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            this.resolveReferences().then(function () {
	                _this.getItems();
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.view.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params, { bypassCache: true });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.$state.go('radniNalog.details', { id: item.id });
	        }
	    }]);
	
	    return RadniNalogListController;
	})(_commonListControllerJs2['default']);
	
	RadniNalogListController.$inject = ['DS', 'AppConfiguration', '$q', '$state'];
	
	var RadniNalogListComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogListHtml2['default'],
	    controller: RadniNalogListController,
	    controllerAs: 'vm'
	};
	
	exports.RadniNalogListComponent = RadniNalogListComponent;
	exports.RadniNalogListController = RadniNalogListController;

/***/ },
/* 610 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogList.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Broj RN, pacijent ili ordinacija\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul><uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></uib-pagination></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-6\"><a ui-sref=\"radniNalog.create\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div><div class=\"col-lg-6\"><div class=\"pull-right\"><a ui-sref=\"crud.list({entity: 'Komentar'})\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-comments\"></i> Pregled svih komentara</a></div></div></div><hr><div animate-panel><div class=\"hpanel\"><div class=\"panel-heading\"><div class=\"panel-tools\"><a class=\"showhide\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"closebox\" hidden><i class=\"fa fa-times\"></i></a></div><br></div><div class=\"panel-body\"><div class=\"table-responsive project-list\"><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum naloga</th><th class=\"col-lg-2 text-center\">Broj naloga</th><th>Pacijent</th><th>Ordinacija</th><th>Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td data-title=\"Datum naloga\">{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item\"></rn-link></td><td data-title=\"Pacijent\">{{item.pacijent}},<br><small><i class=\"fa fa-clock-o\"></i> Status: <strong>{{item.status}}</strong></small></td><td data-title=\"Ordinacija\"><strong>{{item.ordinacija_naziv}}</strong></td><td data-title=\"Akcije\"><a ng-click=\"vm.edit(item)\" title=\"Detalji\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i></a></td></tr></tbody></table></div></div><div class=\"panel-footer\"><br></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _radniNalogDetailsHtml = __webpack_require__(612);
	
	var _radniNalogDetailsHtml2 = _interopRequireDefault(_radniNalogDetailsHtml);
	
	var _sweetalert = __webpack_require__(459);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _lightbox2 = __webpack_require__(613);
	
	var _lightbox22 = _interopRequireDefault(_lightbox2);
	
	var _statusiJs = __webpack_require__(524);
	
	var RadniNalogDetailsController = (function () {
	    function RadniNalogDetailsController(DS, AppConfiguration, $uibModal, $q, $timeout, Upload, $cookies, logger, $http) {
	        _classCallCheck(this, RadniNalogDetailsController);
	
	        this.icon = false;
	        this.$uibModal = $uibModal;
	        this.$q = $q;
	        this.$timeout = $timeout;
	        this.logger = logger;
	        this.pageTitle = 'Radni nalog:' || false;
	        this.pageDesc = 'Podaci o radnom nalogu';
	        this.datastore = function () {
	            return DS;
	        };
	        this.fazeListView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'ListView');
	        this.fazeEditView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'EditView');
	        this.stavkeListView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
	        this.upload = function () {
	            return Upload;
	        };
	        this.$cookies = function () {
	            return $cookies;
	        };
	        this.$http = function () {
	            return $http;
	        };
	    }
	
	    _createClass(RadniNalogDetailsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.uploading = false;
	            this.otvoren = _statusiJs.OTVOREN;
	            this.uobradi = _statusiJs.UOBRADI;
	            this.zakljucan = _statusiJs.ZAKLJUCAN;
	            this.storniran = _statusiJs.STORNIRAN;
	            this.progress = 0;
	            this.refreshState();
	            // this.uploader.onBeforeUploadItem = (item) => {
	            //      item.formData.push({radni_nalog: this.item.id});
	            // };
	            // this.uploader.bind('beforeupload', (event, item) => {
	            //     item.formData.push({radni_nalog: this.item.id});
	            // });
	        }
	    }, {
	        key: 'uploadDocument',
	        value: function uploadDocument(file) {
	            var _this = this;
	
	            var $cookies = this.$cookies();
	            var uploader = this.upload();
	            if (file) {
	                this.uploading = true;
	                uploader.upload({
	                    url: '/api/radni_nalozi/dokumentNaloga',
	                    headers: {
	                        'X-CSRFToken': $cookies.get('csrftoken')
	                    },
	                    data: {
	                        dokument: file,
	                        radni_nalog: this.item.id
	                    }
	                }).then(function (response) {
	                    _this.uploading = false;
	                    _this.refreshState();
	                }, function (error) {
	                    _this.uploading = false;
	                    _this.logger.error('Oupss...', error.data);
	                }, function (evt) {
	                    _this.progress = parseInt(100.0 * evt.loaded / evt.total);
	                });
	            }
	        }
	    }, {
	        key: 'deleteImage',
	        value: function deleteImage(item) {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje slike',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    DS.destroy('DokumentNaloga', item.id).then(function (data) {
	                        _this2.refreshState();
	                        (0, _sweetalert2['default'])('Slika obrisana', '', 'success');
	                        _this2.refreshState();
	                    }, function (error) {
	                        _this2.logger.error('Oops...', error.data);
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this3 = this;
	
	            var DS = this.datastore();
	            DS.find('RadniNalog', this.id, { bypassCache: true }).then(function (radniNalog) {
	                _this3.item = radniNalog;
	                _this3.pageTitle = 'Radni nalog: ' + _this3.item.sifra_naloga;
	                _this3.pageDesc = '<i class="fa fa-check-square-o"></i> Status: ' + _this3.item.status;
	            }).then(function () {
	                _this3.resolveReferences().then(function () {
	                    return _this3.getFaze();
	                }).then(function (response) {
	                    _this3.faze = response;
	                    return _this3.getStavke();
	                }).then(function (response) {
	                    _this3.stavke = response;
	                    _this3.groupStavke();
	                    return _this3.getDokumente();
	                }).then(function (dokumenti) {
	                    _this3.dokumenti = [];
	                    for (var i = 0, j = dokumenti.length; i < j; i = i + 3) {
	                        _this3.dokumenti.push(dokumenti.splice(0, 3));
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'getFaze',
	        value: function getFaze() {
	            var DS = this.datastore();
	            return DS.findAll('FazaNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
	        }
	    }, {
	        key: 'getStavke',
	        value: function getStavke() {
	            var DS = this.datastore();
	            return DS.findAll('StavkaNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
	        }
	    }, {
	        key: 'getDokumente',
	        value: function getDokumente() {
	            var DS = this.datastore();
	            return DS.findAll('DokumentNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
	        }
	    }, {
	        key: 'groupStavke',
	        value: function groupStavke() {
	            // grupiraj stavke naloga po protetskom radu
	            // {
	            //     "protetski_rad": 21,
	            //     "pozicije": [
	            //            12,
	            //            22,
	            //            18
	            //     ],
	            //     cjenik: 1
	            // },
	
	            var DS = this.datastore();
	            var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	            this.groupedStavke = StavkaNaloga.group(this.stavke);
	        }
	    }, {
	        key: 'doPozicije',
	        value: function doPozicije() {
	            var _this4 = this;
	
	            var modal = this.$uibModal.open({
	                component: 'odabirPozicijaForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return {};
	                    }
	                }
	            });
	
	            modal.result.then(function (pozicije) {
	                _this4.$timeout(function () {
	                    _this4.insertStavku(pozicije);
	                }, 500);
	            });
	        }
	    }, {
	        key: 'insertStavku',
	        value: function insertStavku(pozicije) {
	            var _this5 = this;
	
	            var DS = this.datastore();
	            var model = {
	                radni_nalog: this.item.id
	            };
	
	            if (pozicije.length === 1) {
	                model.pozicija = pozicije[0].broj;
	            }
	            var stavkaForm = this.$uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg-extra',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            stavkaForm.result.then(function (model) {
	                var promises = [];
	
	                if (pozicije.length > 0) {
	                    _.forEach(pozicije, function (pozicija) {
	                        var clone = _.cloneDeep(model);
	                        clone.pozicija = pozicija.broj;
	                        promises.push(DS.create('StavkaNaloga', clone));
	                    });
	                } else {
	                    promises.push(DS.create('StavkaNaloga', model));
	                }
	
	                _this5.$q.all(promises).then(function () {
	                    _this5.refreshState();
	                })['catch'](function (error) {
	                    _this5.logger.error('Oops...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'editStavku',
	        value: function editStavku(item) {
	            var _this6 = this;
	
	            var DS = this.datastore();
	            var model = item;
	            var modal = this.$uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                DS.update('StavkaNaloga', model.id, model).then(function () {
	                    _this6.refreshState();
	                });
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.fazeListView.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            _.forOwn(this.stavkeListView.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }, {
	        key: 'editFazu',
	        value: function editFazu(item) {
	            var _this7 = this;
	
	            var DS = this.datastore();
	            var model = item;
	            var _view = this.fazeEditView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    },
	                    formClass: function formClass() {
	                        return 'standard';
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                DS.update('FazaNaloga', model.id, model).then(function () {
	                    _this7.refreshState();
	                })['catch'](function (error) {
	                    _this7.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'deleteFazu',
	        value: function deleteFazu(item) {
	            var _this8 = this;
	
	            var DS = this.datastore();
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje probe',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    DS.destroy('FazaNaloga', item.id).then(function (data) {
	                        _this8.refreshState();
	                        (0, _sweetalert2['default'])('Proba obrisana', '', 'success');
	                    }, function (error) {
	                        _this8.logger.error('Oops...', error.data);
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'insertFazu',
	        value: function insertFazu() {
	            var _this9 = this;
	
	            var DS = this.datastore();
	            var model = {
	                radni_nalog: this.item.id
	            };
	            var _view2 = this.fazeEditView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view2;
	                    },
	                    formClass: function formClass() {
	                        return 'standard';
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                DS.create('FazaNaloga', model).then(function () {
	                    _this9.refreshState();
	                })['catch'](function (error) {
	                    _this9.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'setStatus',
	        value: function setStatus(status) {
	            var _this10 = this;
	
	            var $http = this.$http();
	            var previousWindowKeyDown = window.onkeydown;
	            $http.put('/api/radni_nalozi/radniNalozi/' + this.item.id + '/postavi_status', { status: status }).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspješno ažurirani',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this10.refreshState();
	                });
	            }, function (error) {
	                _this10.logger.error('Oupss...', error.data);
	            });
	        }
	    }]);
	
	    return RadniNalogDetailsController;
	})();
	
	RadniNalogDetailsController.$inject = ['DS', 'AppConfiguration', '$uibModal', '$q', '$timeout', 'Upload', '$cookies', 'logger', '$http'];
	
	var RadniNalogDetailsComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogDetailsHtml2['default'],
	    controller: RadniNalogDetailsController,
	    controllerAs: 'vm',
	    bindings: {
	        id: '<'
	    }
	};
	
	exports.RadniNalogDetailsComponent = RadniNalogDetailsComponent;
	exports.RadniNalogDetailsController = RadniNalogDetailsController;

/***/ },
/* 612 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogDetails.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel effect=\"zoomIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">Akcije&nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\"><li><a ui-sref=\"radniNalog.details.edit({id: vm.item.id})\"><i class=\"fa fa-edit\"></i> Izmjeni</a></li><li class=\"divider\"></li><li><a ng-click=\"vm.setStatus(vm.otvoren)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.otvoren, 'fa-check-square-o': vm.item.status === vm.otvoren}\" aria-hidden=\"true\"></i> Otvoren</a> <a ng-click=\"vm.setStatus(vm.uobradi)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.uobradi, 'fa-check-square-o': vm.item.status === vm.uobradi}\" aria-hidden=\"true\"></i> U obradi</a> <a ng-click=\"vm.setStatus(vm.zakljucan)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.zakljucan, 'fa-check-square-o': vm.item.status === vm.zakljucan}\" aria-hidden=\"true\"></i> Zaključan</a> <a ng-click=\"vm.setStatus(vm.storniran)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.storniran, 'fa-check-square-o': vm.item.status === vm.storniran}\" aria-hidden=\"true\"></i> Storniran</a></li></ul></div><a ng-href=\"api/radni_nalozi/radniNalozi/{{vm.item.id}}/ispis\" target=\"_blank\" class=\"btn btn-primary btn-sm pull-right\"><i class=\"fa fa-print\"></i> Ispis naloga</a></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"hpanel stats\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"pull-right\"><i class=\"fa fa-file-text-o fa-3x\"></i></div><div class=\"panel-title\">RADNI NALOG</div><small class=\"fo\">Osnovni podaci</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Ordinacija dentalne medicine</td><td width=\"65%\"><a ui-sref=\"ordinacija.details({id: vm.item.ordinacija})\"><b>{{vm.item.ordinacija_naziv}}</b></a></td></tr><tr><td width=\"35%\">Datum naloga</td><td width=\"65%\"><b>{{vm.item.datum_naloga | date:'dd.MM.yyyy'}}</b></td></tr><tr><td width=\"35%\">Boja</td><td width=\"65%\"><b>{{vm.item.boja}} ({{vm.item.oznaka_boje}})</b></td></tr><tr><td width=\"35%\">Oblik</td><td width=\"65%\"><b>{{vm.item.oblik}}</b></td></tr><tr><td width=\"35%\">Napomena</td><td width=\"65%\"><small>{{vm.item.napomena}}</small></td></tr></tbody></table><small class=\"fo\">Podaci o pacijentu</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Ime i prezime</td><td width=\"65%\"><b>{{vm.item.pacijent}}</b></td></tr><tr><td width=\"35%\">Spol</td><td width=\"65%\"><b>{{vm.item.spol}}</b></td></tr><tr><td width=\"35%\">Godina rođenja</td><td width=\"65%\"><b>{{vm.item.godina_rodjenja}}</b></td></tr></tbody></table><small class=\"fo\">Podaci - pozicije radnog naloga</small><div class=\"pull-right\"><a type=\"button\" class=\"btn btn-xs btn-success\" ui-sref=\"radniNalog.details.planRada({id: vm.item.id})\"><i class=\"fa fa-plus-square\"></i> Plan rada</a></div><hr><div class=\"table-responsive m-t\"><in-data-grid fields=\"vm.stavkeListView.fields()\" entries=\"vm.groupedStavke\" entity=\"vm.stavkeListView.entity\" datastore=\"vm.datastore()\"></in-data-grid></div></div></div><div>&nbsp;<i class=\"fa fa-clock-o\"></i>&nbsp;<small>Kreirano: {{vm.item.created_at | date: 'dd.MM.yyyy HH:mm'}}</small></div><div>&nbsp;<i class=\"fa fa-clock-o\"></i>&nbsp;<small>Datum zadnje promjene: {{vm.item.last_modified | date: 'dd.MM.yyyy HH:mm'}}</small></div></div><div class=\"col-lg-6\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"panel-title\">FAZE RADNOG NALOGA</div><small class=\"fo\">Probe rada</small><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertFazu()\"><i class=\"fa fa-plus-square\"></i> Nova faza</button></div><hr><div class=\"table-responsive project-list\"><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum probe</th><th class=\"col-lg-2\">Termin</th><th>Tehničar</th><th>Napomena</th><th class=\"col-lg-2 text-center\">Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.faze\"><td data-title=\"Datum probe\">{{item.datum_probe | date: 'dd.MM.yyyy'}}</td><td data-title=\"Termin\"><i class=\"fa fa-clock-o\"></i> {{item.termin_probe}}</td><td data-title=\"Tehničar\"><small>{{item.tehnicar_naziv}}&nbsp;</small></td><td data-title=\"Napomena\"><small>{{item.napomena}}&nbsp;</small></td><td data-title=\"Akcije\" class=\"text-center\"><section ng-if=\"item.broj_probe !== -1\"><a ng-click=\"vm.editFazu(item)\" class=\"btn btn-xs btn-success\" type=\"button\"><i class=\"fa fa-edit\"></i></a> <a ng-click=\"vm.deleteFazu(item)\" class=\"btn btn-xs btn-danger\" type=\"button\"><i class=\"fa fa-remove\"></i></a></section></td></tr></tbody></table></div></div></div><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-6 animated-panel zoomIn\" style=\"animation-delay: 0.3s;\"><div class=\"panel-title\">DOKUMENTI</div><small class=\"fo\">Priloženi dokumenti</small></div><div class=\"col-lg-6 text-right animated-panel zoomIn\" style=\"animation-delay: 0.4s;\"><div class=\"input-group\"><label class=\"input-group-btn\"><button class=\"btn btn-primary btn-xs ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" ngf-select=\"vm.uploadDocument(vm.docFile)\" ng-model=\"vm.docFile\" name=\"file\" required ngf-model-invalid=\"errorFile\"><i class=\"fa fa-file\"></i> Upload dokumenta</button></label></div></div></div><hr><div class=\"row lightBoxGallery\"><div class=\"row\" ng-repeat=\"row in vm.dokumenti\"><div class=\"col-sm-4\" ng-repeat=\"item in row\"><a ng-href=\"/api/radni_nalozi/dokumentNaloga/{{item.id}}/download\" data-lightbox=\"roadtrip\"><img class=\"img-responsive\" ng-src=\"/api/radni_nalozi/dokumentNaloga/{{item.id}}/thumbnail\"></a> <button type=\"button\" ng-click=\"vm.deleteImage(item)\" class=\"close\" aria-label=\"Close\" uib-tooltip=\"Ukloni sliku\" tooltip-placement=\"right\"><span aria-hidden=\"true\">×</span></button></div></div><div class=\"col-sm-4\" ng-if=\"vm.uploading\"><loading is-loading=\"vm.uploading\" message=\"Pričekajte dok se dokument upload-a\"></loading><span>{{vm.progress}}%</span></div></div></div></div><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"panel-title\">Komentari</div></div></div><hr><div class=\"row\"><div class=\"col-lg-12\"><komentari id=\"vm.id\"></komentari></div></div></div></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 613 */,
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _planRadaHtml = __webpack_require__(615);
	
	var _planRadaHtml2 = _interopRequireDefault(_planRadaHtml);
	
	var _zubiSvgJs = __webpack_require__(616);
	
	var PlanRadaController = (function () {
	    function PlanRadaController(DS, AppConfiguration, $q, $uibModal, $state, logger) {
	        _classCallCheck(this, PlanRadaController);
	
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	        this.$uibModal = function () {
	            return $uibModal;
	        };
	        this.$state = function () {
	            return $state;
	        };
	        this.logger = function () {
	            return logger;
	        };
	        this.view = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
	        this.pageTitle = 'Plan rada';
	    }
	
	    _createClass(PlanRadaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            DS.find('RadniNalog', this.id, { bypassCache: true }).then(function (radniNalog) {
	                _this.item = radniNalog;
	                _this.pageTitle = 'Plan rada: ' + radniNalog.pacijent;
	                _this.refreshState();
	            });
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            var $q = this.$q();
	            this.nalog = this.item;
	            this.stavke = _lodash2['default'].cloneDeep(this.nalog.stavke);
	            this.veze = _lodash2['default'].cloneDeep(this.nalog.veze);
	            this.plan = { pozicije: [], veze: [] };
	
	            this.nalog.stavke.map(function (stavka) {
	                _this2.plan.pozicije.push({ id: stavka.pozicija, protetski_rad: stavka.protetski_rad });
	            });
	
	            this.nalog.veze.map(function (veza) {
	                var item = (0, _zubiSvgJs.findVezaByPozicija)(veza.pozicija);
	                if (item !== null && item !== undefined) {
	                    _this2.plan.veze.push(Object.assign({}, item));
	                }
	            });
	
	            $q.all([DS.findAll('ProtetskiRad'), DS.findAll('Cjenik')]).then(function (response) {
	                _this2.groupStavke(_this2.stavke);
	            });
	        }
	    }, {
	        key: 'groupStavke',
	        value: function groupStavke(stavke) {
	            // grupiraj stavke naloga po protetskom radu
	            // {
	            //     "protetski_rad": 21,
	            //     "pozicije": [
	            //            12,
	            //            22,
	            //            18
	            //     ],
	            //     cjenik: 1
	            // },
	            var DS = this.datastore();
	            var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	            this.groupedStavke = StavkaNaloga.group(stavke);
	        }
	    }, {
	        key: 'insertStavkuNaloga',
	        value: function insertStavkuNaloga(pozicije) {
	            var _this3 = this;
	
	            var $uibModal = this.$uibModal();
	            var model = { pozicije: pozicije };
	
	            var modal = $uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg-extra',
	                // windowClass: 'modal-lg-extra',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            return modal.result.then(function (model) {
	                var stavke = [];
	                var plan = [];
	                if (pozicije.length > 0) {
	                    pozicije.forEach(function (pozicija) {
	                        stavke.push(Object.assign({}, model, { pozicija: pozicija }));
	                    });
	                } else {
	                    stavke.push(Object.assign({}, model, { pozicija: null }));
	                }
	                _this3.stavke = [].concat(_toConsumableArray(_this3.stavke), stavke);
	                _this3.groupStavke(_this3.stavke);
	
	                _this3.stavke.map(function (s) {
	                    plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
	                });
	
	                _this3.plan = { pozicije: [].concat(plan), veze: [].concat(_toConsumableArray(_this3.plan.veze)) };
	            });
	        }
	    }, {
	        key: 'removeStavkuNaloga',
	        value: function removeStavkuNaloga(item) {
	            var plan = [];
	            this.stavke = this.stavke.filter(function (stavka) {
	                return !(stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik);
	            });
	
	            this.stavke.map(function (s) {
	                plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
	            });
	
	            this.plan = { pozicije: [].concat(plan), veze: [].concat(_toConsumableArray(this.plan.veze)) };
	            this.groupStavke(this.stavke);
	        }
	    }, {
	        key: 'vezeClicked',
	        value: function vezeClicked(veza) {
	            var item = _lodash2['default'].find(this.plan.veze, { id: veza.id, celjust: veza.celjust });
	            if (_lodash2['default'].isObject(item)) {
	                var veze = this.plan.veze.filter(function (f) {
	                    return f.id !== item.id || f.celjust !== item.celjust;
	                });
	                this.plan = Object.assign({}, this.plan, {
	                    veze: [].concat(_toConsumableArray(veze))
	                });
	            } else {
	                this.plan = Object.assign({}, this.plan, { veze: [].concat(_toConsumableArray(this.plan.veze), [veza]) });
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var _this4 = this;
	
	            var DS = this.datastore();
	            var $state = this.$state();
	            var logger = this.logger();
	            DS.update('PlanRada', this.item.id, { stavke: this.stavke, veze: this.plan.veze }).then(function (response) {
	                $state.go('radniNalog.details', { id: _this4.item.id });
	            })['catch'](function (error) {
	                logger.error('Oupss....', error.data);
	            });
	        }
	    }]);
	
	    return PlanRadaController;
	})();
	
	PlanRadaController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', '$state', 'logger'];
	
	var PlanRadaComponent = {
	    restrict: 'E',
	    templateUrl: _planRadaHtml2['default'],
	    controller: PlanRadaController,
	    controllerAs: 'vm',
	    bindings: {
	        id: '<'
	    }
	};
	
	exports.PlanRadaComponent = PlanRadaComponent;
	exports.PlanRadaController = PlanRadaController;

/***/ },
/* 615 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/planRada.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\"><div class=\"hpanel\"><div class=\"panel-body\"><div ui-view animate-panel><human-dental-arches data=\"vm.plan\" on-nove-stavke=\"vm.insertStavkuNaloga(pozicije)\" on-veza-btn-clicked=\"vm.vezeClicked(veza)\"></human-dental-arches><div class=\"row\"><div class=\"col-lg-8\"><div class=\"hpanel\"><div class=\"panel-heading hbuilt\"><h4>Naručene pozicije</h4></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.view.fields()\" entries=\"vm.groupedStavke\" entity=\"vm.view.entity\" datastore=\"vm.datastore()\" actions=\"vm.view.listActions()\" on-delete=\"vm.removeStavkuNaloga(item)\"></in-data-grid></div></div></div></div><div class=\"col-lg-4\" ng-if=\"vm.item.napomena\"><div class=\"well well-lg\"><h5 class=\"font-bold\">Napomena</h5><hr><span>{{vm.item.napomena}}</span></div></div></div><div class=\"row\"></div></div><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ui-sref=\"radniNalog.details({id: vm.nalog.id})\">Povratak</a> <a class=\"btn btn-success\" ng-click=\"vm.submit()\">Potvrdi</a></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.findZub = findZub;
	exports.findVeza = findVeza;
	exports.findVezaByPozicija = findVezaByPozicija;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var zubi = [{ id: 18, rbr: 1, celjust: 'G' }, { id: 17, rbr: 2, celjust: 'G' }, { id: 16, rbr: 3, celjust: 'G' }, { id: 15, rbr: 4, celjust: 'G' }, { id: 14, rbr: 5, celjust: 'G' }, { id: 13, rbr: 6, celjust: 'G' }, { id: 12, rbr: 7, celjust: 'G' }, { id: 11, rbr: 8, celjust: 'G' }, { id: 21, rbr: 9, celjust: 'G' }, { id: 22, rbr: 10, celjust: 'G' }, { id: 23, rbr: 11, celjust: 'G' }, { id: 24, rbr: 12, celjust: 'G' }, { id: 25, rbr: 13, celjust: 'G' }, { id: 26, rbr: 14, celjust: 'G' }, { id: 27, rbr: 15, celjust: 'G' }, { id: 28, rbr: 16, celjust: 'G' }, { id: 48, rbr: 1, celjust: 'D' }, { id: 47, rbr: 2, celjust: 'D' }, { id: 46, rbr: 3, celjust: 'D' }, { id: 45, rbr: 4, celjust: 'D' }, { id: 44, rbr: 5, celjust: 'D' }, { id: 43, rbr: 6, celjust: 'D' }, { id: 42, rbr: 7, celjust: 'D' }, { id: 41, rbr: 8, celjust: 'D' }, { id: 31, rbr: 9, celjust: 'D' }, { id: 32, rbr: 10, celjust: 'D' }, { id: 33, rbr: 11, celjust: 'D' }, { id: 34, rbr: 12, celjust: 'D' }, { id: 35, rbr: 13, celjust: 'D' }, { id: 36, rbr: 14, celjust: 'D' }, { id: 37, rbr: 15, celjust: 'D' }, { id: 38, rbr: 16, celjust: 'D' }];
	
	exports.zubi = zubi;
	var veze = [{ id: 1, celjust: 'G', pozicija: 1817 }, { id: 2, celjust: 'G', pozicija: 1716 }, { id: 3, celjust: 'G', pozicija: 1615 }, { id: 4, celjust: 'G', pozicija: 1514 }, { id: 5, celjust: 'G', pozicija: 1413 }, { id: 6, celjust: 'G', pozicija: 1312 }, { id: 7, celjust: 'G', pozicija: 1211 }, { id: 8, celjust: 'G', pozicija: 1121 }, { id: 9, celjust: 'G', pozicija: 2122 }, { id: 10, celjust: 'G', pozicija: 2223 }, { id: 11, celjust: 'G', pozicija: 2324 }, { id: 12, celjust: 'G', pozicija: 2425 }, { id: 13, celjust: 'G', pozicija: 2526 }, { id: 14, celjust: 'G', pozicija: 2627 }, { id: 15, celjust: 'G', pozicija: 2728 }, { id: 1, celjust: 'D', pozicija: 4847 }, { id: 2, celjust: 'D', pozicija: 4746 }, { id: 3, celjust: 'D', pozicija: 4645 }, { id: 4, celjust: 'D', pozicija: 4544 }, { id: 5, celjust: 'D', pozicija: 4443 }, { id: 6, celjust: 'D', pozicija: 4342 }, { id: 7, celjust: 'D', pozicija: 4241 }, { id: 8, celjust: 'D', pozicija: 4131 }, { id: 9, celjust: 'D', pozicija: 3132 }, { id: 10, celjust: 'D', pozicija: 3233 }, { id: 11, celjust: 'D', pozicija: 3334 }, { id: 12, celjust: 'D', pozicija: 3435 }, { id: 13, celjust: 'D', pozicija: 3536 }, { id: 14, celjust: 'D', pozicija: 3637 }, { id: 15, celjust: 'D', pozicija: 3738 }];
	
	exports.veze = veze;
	
	function findZub(id) {
	    var item = _lodash2['default'].find(zubi, { id: id });
	    return item;
	}
	
	function findVeza(id, celjust) {
	    var item = _lodash2['default'].find(veze, { id: id, celjust: celjust });
	    return item;
	}
	
	function findVezaByPozicija(pozicija) {
	    var item = _lodash2['default'].find(veze, { pozicija: pozicija });
	    return item;
	}

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shemaHtml = __webpack_require__(618);
	
	var _shemaHtml2 = _interopRequireDefault(_shemaHtml);
	
	var ShemaController = (function () {
	    function ShemaController() {
	        _classCallCheck(this, ShemaController);
	    }
	
	    _createClass(ShemaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.pozicije = [];
	            this.veze = [];
	            this.nalog.stavke.forEach(function (stavka) {
	                _this.pozicije.push({ broj: stavka.pozicija, selected: true, veza: false });
	            });
	            this.nalog.veze.forEach(function (veza) {
	                var pozicija = veza.pozicija.toString();
	                _this.veze.push({ broj: parseInt(pozicija.slice(0, 2)), selected: true, veza: true });
	                _this.veze.push({ broj: parseInt(pozicija.slice(2, 4)), selected: true, veza: true });
	            });
	        }
	    }, {
	        key: 'pozSelected',
	        value: function pozSelected(poz) {
	            return _lodash2['default'].filter(this.pozicije, function (item) {
	                return item.broj === poz;
	            }).length > 0;
	        }
	    }, {
	        key: 'vezaSelected',
	        value: function vezaSelected(poz) {
	            return _lodash2['default'].filter(this.veze, function (item) {
	                return item.broj === poz;
	            }).length > 0;
	        }
	    }]);
	
	    return ShemaController;
	})();
	
	ShemaController.$inject = [];
	
	var ShemaComponent = {
	    restrict: 'E',
	    templateUrl: _shemaHtml2['default'],
	    controller: ShemaController,
	    controllerAs: 'vm',
	    bindings: {
	        nalog: '<'
	    }
	};
	
	exports.ShemaComponent = ShemaComponent;
	exports.ShemaController = ShemaController;

/***/ },
/* 618 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/shema.html';
	var html = "<table><tr><td ng-class=\"{'circle': vm.pozSelected(18), 'selected': vm.vezaSelected(18)}\">8</td><td ng-class=\"{'circle': vm.pozSelected(17), 'selected': vm.vezaSelected(17)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(16), 'selected': vm.vezaSelected(16)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(15), 'selected': vm.vezaSelected(15)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(14), 'selected': vm.vezaSelected(14)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(13), 'selected': vm.vezaSelected(13)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(12), 'selected': vm.vezaSelected(12)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(11), 'selected': vm.vezaSelected(11)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(21), 'selected': vm.vezaSelected(21)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(22), 'selected': vm.vezaSelected(22)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(23), 'selected': vm.vezaSelected(23)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(24), 'selected': vm.vezaSelected(24)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(25), 'selected': vm.vezaSelected(25)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(26), 'selected': vm.vezaSelected(26)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(27), 'selected': vm.vezaSelected(27)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(28), 'selected': vm.vezaSelected(28)}\">8</td></tr><tr><td ng-class=\"{'circle': vm.pozSelected(48), 'selected': vm.vezaSelected(48)}\">8</td><td ng-class=\"{'circle': vm.pozSelected(47), 'selected': vm.vezaSelected(47)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(46), 'selected': vm.vezaSelected(46)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(45), 'selected': vm.vezaSelected(45)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(44), 'selected': vm.vezaSelected(44)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(43), 'selected': vm.vezaSelected(43)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(42), 'selected': vm.vezaSelected(42)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(41), 'selected': vm.vezaSelected(41)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(31), 'selected': vm.vezaSelected(31)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(32), 'selected': vm.vezaSelected(32)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(33), 'selected': vm.vezaSelected(33)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(34), 'selected': vm.vezaSelected(34)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(35), 'selected': vm.vezaSelected(35)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(36), 'selected': vm.vezaSelected(36)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(37), 'selected': vm.vezaSelected(37)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(38), 'selected': vm.vezaSelected(38)}\">8</td></tr></table>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _radniNalogCreateHtml = __webpack_require__(620);
	
	var _radniNalogCreateHtml2 = _interopRequireDefault(_radniNalogCreateHtml);
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var RadniNalogCreateController = (function () {
	    function RadniNalogCreateController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, RadniNalogCreateController);
	
	        this.Model = DS.definitions['RadniNalog'];
	        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'CreateView');
	        this.$state = $state;
	        this.logger = logger;
	    }
	
	    _createClass(RadniNalogCreateController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.item = {
	                datum_naloga: (0, _moment2['default'])().format('YYYY-MM-DD')
	            };
	            this.fields = this.view.fields();
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            this.Model.create(item).then(function (response) {
	                // uploader.url = '/api/radni_nalozi/dokument'
	                _this.$state.go('radniNalog.details', { id: response.id });
	            })['catch'](function (error) {
	                _this.logger.error('Oupss...', error.data);
	            });
	        }
	    }]);
	
	    return RadniNalogCreateController;
	})();
	
	RadniNalogCreateController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var RadniNalogCreateComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogCreateHtml2['default'],
	    controller: RadniNalogCreateController,
	    controllerAs: 'vm'
	};
	
	exports.RadniNalogCreateComponent = RadniNalogCreateComponent;
	exports.RadniNalogCreateController = RadniNalogCreateController;

/***/ },
/* 620 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogCreate.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><radni-nalog-wizard-form fields=\"vm.fields\" on-submit=\"vm.submit(item)\" item=\"vm.item\"></radni-nalog-wizard-form></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _radniNalogEditHtml = __webpack_require__(622);
	
	var _radniNalogEditHtml2 = _interopRequireDefault(_radniNalogEditHtml);
	
	var _sweetalert = __webpack_require__(459);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var RadniNalogEditController = (function () {
	    function RadniNalogEditController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, RadniNalogEditController);
	
	        this.$state = $state;
	        this.logger = logger;
	        this.Model = DS.definitions['RadniNalog'];
	        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'EditView');
	    }
	
	    _createClass(RadniNalogEditController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pageTitle = 'Izmjena radnog naloga ' + this.item.broj_naloga;
	            this.pageDesc = 'Izmjena općih podataka radnog naloga';
	            this.fields = this.view.fields();
	            this.model = Object.assign({}, this.item, { stavke: [], veze: [], faze: [] });
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            this.Model.update(item.id, item).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspješno ažurirani',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this.$state.go('radniNalog.details', { id: response.id });
	                });
	            })['catch'](function (error) {
	                _this.logger.error('Upsss', error.data);
	            });
	        }
	    }]);
	
	    return RadniNalogEditController;
	})();
	
	RadniNalogEditController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var RadniNalogEditComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogEditHtml2['default'],
	    controller: RadniNalogEditController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.RadniNalogEditComponent = RadniNalogEditComponent;
	exports.RadniNalogEditController = RadniNalogEditController;

/***/ },
/* 622 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogEdit.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><form name=\"vm.form\" novalidate ng-submit=\"vm.submit(vm.model)\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"pe-7s-credit fa-5x text-muted\"></i><h4>Radni nalog - izmjena</h4></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.fields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a ui-sref=\"radniNalog.details({id: vm.item.id})\" class=\"btn btn-default\">Odustani</a> <a class=\"btn btn-success\" ng-click=\"vm.submit(vm.model)\">Potvrdi</a></div></form></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _radniNalogWizardFormHtml = __webpack_require__(624);
	
	var _radniNalogWizardFormHtml2 = _interopRequireDefault(_radniNalogWizardFormHtml);
	
	var RadniNalogWizardFormController = (function () {
	    function RadniNalogWizardFormController($uibModal, DS, AppConfiguration, logger, $state) {
	        var _this = this;
	
	        _classCallCheck(this, RadniNalogWizardFormController);
	
	        this.step = 1;
	        this.$uibModal = $uibModal;
	        this.logger = logger;
	        this.$state = $state;
	        DS.findAll('ProtetskiRad').then(function (response) {
	            _this.protetski_rad = response;
	        });
	        this.datastore = function () {
	            return DS;
	        };
	        this.fazeListView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'ListView');
	        this.stavkeNalogaListView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
	        this.fazeEditView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'EditView');
	        this.stavkeCreateView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'CreateView');
	    }
	
	    _createClass(RadniNalogWizardFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.osnovniPodaciFields = this.fields[0];
	            this.stavkeNalogaFields = this.fields[1];
	            this.napomenaField = this.fields[2];
	            this.model = angular.copy(this.item);
	            this.model.stavke = [];
	            this.model.faze = [];
	            this.model.plan = { pozicije: [], veze: [] };
	            this.groupedStavke = [];
	        }
	    }, {
	        key: 'show',
	        value: function show(step) {
	            this.step = step;
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            if (this.step < 4) {
	                this.step++;
	            }
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            if (this.step > 1) {
	                this.step--;
	            }
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            var _this2 = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            swal({
	                title: 'Prekid unosa novog radnog naloga',
	                text: 'Želite odustati od unosa novog radnog naloga?',
	                type: 'warning',
	                showCancelButton: true,
	                closeOnConfirme: true
	            }, function () {
	                window.onkeydown = previousWindowKeyDown;
	                _this2.$state.go('dashboard');
	            });
	        }
	    }, {
	        key: 'resolveNazivProtetskogRada',
	        value: function resolveNazivProtetskogRada(stavka) {
	            var item = _lodash2['default'].find(this.protetski_rad, { id: stavka.protetski_rad });
	            if (_lodash2['default'].isUndefined(item)) {
	                return '';
	            }
	            return item.naziv;
	        }
	    }, {
	        key: 'insertStavkuNaloga',
	        value: function insertStavkuNaloga(pozicije) {
	            var _this3 = this;
	
	            var model = { pozicije: pozicije };
	
	            var modal = this.$uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg-extra',
	                // windowClass: 'modal-lg-extra',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            return modal.result.then(function (model) {
	                var stavke = [];
	                var plan = [];
	                if (pozicije.length > 0) {
	                    pozicije.forEach(function (pozicija) {
	                        stavke.push(Object.assign({}, model, { pozicija: pozicija }));
	                    });
	                } else {
	                    stavke.push(Object.assign({}, model, { pozicija: null }));
	                }
	                _this3.model.stavke = [].concat(_toConsumableArray(_this3.model.stavke), stavke);
	                _this3.groupStavke();
	
	                _this3.model.stavke.map(function (s) {
	                    plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
	                });
	
	                _this3.model.plan = { pozicije: [].concat(plan), veze: [].concat(_toConsumableArray(_this3.model.plan.veze)) };
	            });
	        }
	    }, {
	        key: 'vezeClicked',
	        value: function vezeClicked(veza) {
	            var item = _lodash2['default'].find(this.model.plan.veze, { id: veza.id, celjust: veza.celjust });
	            if (_lodash2['default'].isObject(item)) {
	                var veze = this.model.plan.veze.filter(function (f) {
	                    return f.id !== item.id || f.celjust !== item.celjust;
	                });
	                this.model.plan = Object.assign({}, this.model.plan, {
	                    veze: [].concat(_toConsumableArray(veze))
	                });
	            } else {
	                this.model.plan = Object.assign({}, this.model.plan, { veze: [].concat(_toConsumableArray(this.model.plan.veze), [veza]) });
	            }
	        }
	    }, {
	        key: 'groupStavke',
	        value: function groupStavke() {
	            // grupiraj stavke naloga po protetskom radu
	            // {
	            //     "protetski_rad": 21,
	            //     "pozicije": [
	            //            12,
	            //            22,
	            //            18
	            //     ],
	            //     cjenik: 1
	            // },
	            var DS = this.datastore();
	            var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	            this.groupedStavke = StavkaNaloga.group(this.model.stavke);
	        }
	    }, {
	        key: 'insertFazu',
	        value: function insertFazu() {
	            var _this4 = this;
	
	            var DS = this.datastore();
	            var model = {
	                radni_nalog: this.item.id
	            };
	            var _view = this.fazeEditView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    },
	                    formClass: function formClass() {
	                        return 'standard';
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this4.model.faze.push(model);
	            });
	        }
	    }, {
	        key: 'deleteFazu',
	        value: function deleteFazu(item) {
	            this.model.faze = this.model.faze.filter(function (f) {
	                return f !== item;
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            // TODO: refaktorizirati kod tako da se više ne koriste veze
	            item.veze = [].concat(_toConsumableArray(item.plan.veze));
	            this.onSubmit({ item: item });
	        }
	    }, {
	        key: 'removeStavkuNaloga',
	        value: function removeStavkuNaloga(item) {
	            var plan = [];
	            this.model.stavke = this.model.stavke.filter(function (stavka) {
	                return !(stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik);
	            });
	            // osvježi plan
	            this.model.stavke.map(function (s) {
	                plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
	            });
	
	            this.model.plan = { pozicije: [].concat(plan), veze: [].concat(_toConsumableArray(this.model.plan.veze)) };
	            this.groupStavke();
	        }
	    }]);
	
	    return RadniNalogWizardFormController;
	})();
	
	RadniNalogWizardFormController.$inject = ['$uibModal', 'DS', 'AppConfiguration', 'logger', '$state'];
	
	var RadniNalogWizardFormComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogWizardFormHtml2['default'],
	    controller: RadniNalogWizardFormController,
	    controllerAs: 'vm',
	    bindings: {
	        fields: '<',
	        item: '<',
	        onSubmit: '&'
	    }
	};
	
	exports.RadniNalogWizardFormComponent = RadniNalogWizardFormComponent;
	exports.RadniNalogWizardFormController = RadniNalogWizardFormController;

/***/ },
/* 624 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogWizardForm.html';
	var html = "<form name=\"vm.form\" novalidate ng-submit=\"vm.submit(vm.model)\"><div class=\"text-center m-b-md\" id=\"wizardControl\"><a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 1, 'btn-default': vm.step != 1}\" ng-click=\"vm.show(1)\">1 - Osnovni podaci</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 2, 'btn-default': vm.step != 2}\" ng-click=\"vm.show(2)\">2 - Plan rada</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 3, 'btn-default': vm.step != 3}\" ng-click=\"vm.show(3)\">3 - Naručene probe</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 4, 'btn-default': vm.step != 4}\" ng-click=\"vm.show(4)\">4 - Pregled naloga</a></div><div class=\"tab-content\"><div id=\"step1\" class=\"p-m\" ng-show=\"vm.step == 1\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"pe-7s-credit fa-5x text-muted\"></i><h4>Radni nalog - unos</h4></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.osnovniPodaciFields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a></div></div><div id=\"step2\" class=\"p-m\" ng-show=\"vm.step == 2\"><div class=\"row\"><div class=\"col-lg-6\"><human-dental-arches data=\"vm.model.plan\" on-nove-stavke=\"vm.insertStavkuNaloga(pozicije)\" on-veza-btn-clicked=\"vm.vezeClicked(veza)\"></human-dental-arches></div><div class=\"col-lg-6\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading hbuilt\"><h4>Naručene pozicije</h4></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.stavkeNalogaListView.fields()\" entries=\"vm.groupedStavke\" entity=\"vm.stavkeNalogaListView.entity\" datastore=\"vm.datastore()\" actions=\"vm.stavkeNalogaListView.listActions()\" on-delete=\"vm.removeStavkuNaloga(item)\"></in-data-grid></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><formly-form model=\"vm.model\" fields=\"vm.napomenaField\" form=\"vm.form\" options=\"vm.options\"></formly-form></div><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-3 col-sm-12\"><formly-form model=\"vm.model\" fields=\"vm.stavkeNalogaFields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div></div></div><div class=\"row\"><div class=\"col-lg-8\"></div><div class=\"col-lg-4\"><div class=\"row\"><div class=\"col-lg-12\"></div></div></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a></div></div><div id=\"step3\" class=\"p-m\" ng-if=\"vm.step == 3\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading hbuilt\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertFazu()\"><i class=\"fa fa-plus-square\"></i> Nova proba</button></div><h4>Naručene probe</h4></div><div class=\"panel-body\"><div class=\"table-responsive project-list\"><in-data-grid fields=\"vm.fazeListView.fields()\" entries=\"vm.model.faze\" entity=\"vm.fazeListView.entity\" datastore=\"vm.datastore()\" actions=\"vm.fazeListView.listActions()\" on-delete=\"vm.deleteFazu(item)\"></in-data-grid></div></div></div></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a></div></div><div id=\"step4\" class=\"p-m\" ng-if=\"vm.step == 4\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"vm.form.$valid\"><evidencija-naloga item=\"vm.model\"></evidencija-naloga></div><div class=\"col-lg-12\" ng-if=\"vm.form.$invalid\"><span>Forma sadrži neispravne unose</span></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a> <a class=\"btn btn-success\" ng-click=\"vm.submit(vm.model)\">Potvrdi</a></div></div></div></form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _evidencijaNalogaHtml = __webpack_require__(626);
	
	var _evidencijaNalogaHtml2 = _interopRequireDefault(_evidencijaNalogaHtml);
	
	var EvidencijaNalogaController = (function () {
	    function EvidencijaNalogaController(DS, $q) {
	        _classCallCheck(this, EvidencijaNalogaController);
	
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	        this.protetski_rad = [];
	    }
	
	    _createClass(EvidencijaNalogaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            var $q = this.$q();
	            this.item = this.item || undefined;
	            if (this.item === undefined) {
	                return;
	            }
	
	            this.ukupniIznos = 0;
	
	            DS.find('Ordinacija', this.item.ordinacija).then(function (response) {
	                _this.ordinacija = response;
	            });
	
	            $q.all([DS.findAll('ProtetskiRad'), DS.findAll('StavkaCjenika')]).then(function (response) {
	                var _response = _slicedToArray(response, 2);
	
	                var protetskiRadovi = _response[0];
	                var stavkeCjenika = _response[1];
	
	                var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	                _this.stavke = StavkaNaloga.group(_this.item.stavke);
	
	                _this.stavke.map(function (stavka) {
	                    var protetskiRad = _lodash2['default'].find(protetskiRadovi, { id: stavka.protetski_rad });
	                    var stavkaCjenika = _lodash2['default'].find(stavkeCjenika, {
	                        cjenik: stavka.cjenik,
	                        protetski_rad: stavka.protetski_rad
	                    });
	                    stavka.nazivProtetskogRada = protetskiRad.naziv;
	                    stavka.jedinicnaCijena = stavkaCjenika.iznos;
	                    stavka.kolicina = stavka.pozicije.length;
	                    stavka.iznos = stavka.jedinicnaCijena * stavka.kolicina;
	                    _this.ukupniIznos = _this.ukupniIznos + stavka.iznos;
	                });
	                // this.protetski_rad = response;
	                // this.stavke = this.item.stavke;
	            });
	        }
	    }, {
	        key: 'resolveNazivProtetskogRada',
	        value: function resolveNazivProtetskogRada(stavka) {
	            var item = _lodash2['default'].find(this.protetski_rad, { id: stavka.protetski_rad });
	            if (_lodash2['default'].isUndefined(item)) {
	                return '';
	            }
	            return item.naziv;
	        }
	    }]);
	
	    return EvidencijaNalogaController;
	})();
	
	EvidencijaNalogaController.$inject = ['DS', '$q'];
	
	var EvidencijaNalogaComponent = {
	    restrict: 'E',
	    templateUrl: _evidencijaNalogaHtml2['default'],
	    controller: EvidencijaNalogaController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.EvidencijaNalogaComponent = EvidencijaNalogaComponent;
	exports.EvidencijaNalogaController = EvidencijaNalogaController;

/***/ },
/* 626 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/evidencijaNaloga.html';
	var html = "<div class=\"hpanel\"><div class=\"panel-body p-xl\"><div class=\"row m-b-xl\"><div class=\"col-sm-6\"><h3 class=\"text-info\">RN-{br. radnog naloga}</h3><address><strong>Panjol Dental d.o.o.</strong><br>Ul. Svete Marije 68<br>23000 Zadar<br><abbr title=\"Phone\">Tel:</abbr> (385)23 236 099</address></div><div class=\"col-sm-6 text-right\"><span>Ordinacija dentalne medicine</span><address><strong>{{vm.ordinacija.naziv}}</strong><br>{{vm.ordinacija.adresa}}<br>{{vm.ordinacija.postanski_broj}} {{vm.ordinacija.mjesto}}<br><abbr title=\"Phone\">Tel:</abbr> {{vm.ordinacija.telefon}}</address><p><span><strong>Datum naloga:</strong> {{vm.item.datum_naloga | date: 'dd.MM.yyyy.'}}</span><br></p></div></div><h3>&nbsp;Pacijent:&nbsp;<span class=\"text-info\">{{vm.item.pacijent}}, ({{vm.item.godina_rodjenja}})</span></h3><div class=\"table-responsive m-t\"><table class=\"table table-striped\"><thead><tr><th class=\"col-lg-8\">Protetski rad<br><small>Pozicija</small></th><th class=\"col-lg-2\">Količina</th><th class=\"col-lg-2 text-right\">Iznos (HRK)</th></tr></thead><tbody><tr ng-repeat=\"stavka in vm.stavke\"><td><div><strong>{{stavka.nazivProtetskogRada}}</strong></div><small><span ng-repeat=\"pozicija in stavka.pozicije\" ng-if=\"pozicija\">[{{pozicija}}]</span></small></td><td>{{stavka.kolicina}}</td><td class=\"text-right\">{{stavka.iznos | currency: '' : 2}}</td></tr></tbody></table></div><div class=\"row m-t\"><div class=\"col-md-8\"><table class=\"table text-left\"><tbody><tr><td>Boja: <strong>{{vm.item.boja}} ({{vm.item.oznaka_boje}})</strong>, oblik: <strong>{{vm.item.oblik}}</strong></td></tr></tbody></table></div><div class=\"col-md-4 text-right\"><table class=\"table table-striped text-right\"><tbody><tr><td><h3>Ukupan iznos (HRK):</h3></td><td><h3>{{vm.ukupniIznos | currency: '' : 2 }}</h3></td></tr></tbody></table><small class=\"text-info\">*Izračun je informativnog karaktera.</small></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"m-t\"><strong>Napomena:</strong><br><small class=\"text-danger\">{{vm.item.napomena}}</small></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _komentariHtml = __webpack_require__(628);
	
	var _komentariHtml2 = _interopRequireDefault(_komentariHtml);
	
	var _modelsKomentarJs = __webpack_require__(629);
	
	var KomentariController = (function () {
	    function KomentariController(DS, $q, $state, logger) {
	        _classCallCheck(this, KomentariController);
	
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	        this.$state = function () {
	            return $state;
	        };
	        this.logger = function () {
	            return logger;
	        };
	    }
	
	    _createClass(KomentariController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            this.newComment = '';
	            DS.find('RadniNalog', this.id, { bypassCache: true }).then(function (radniNalog) {
	                _this.item = radniNalog;
	                _this.refreshState();
	            });
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            var Komentar = DS.definitions['Komentar'];
	            var $q = this.$q();
	            this.pageTitle = 'Poruke radnog naloga: ' + this.item.sifra_naloga;
	            this.pageDesc = 'Evidencija zaprimljenih poruka operatera';
	            $q.when(Komentar.findAll({ radni_nalog: this.item.id }, { bypassCache: true })).then(function (response) {
	                _this2.komentari = [].concat(_toConsumableArray(response));
	                response.filter(function (item) {
	                    return item.status === _modelsKomentarJs.NOVI;
	                }).map(function (item) {
	                    Komentar.update(item.id, { status: _modelsKomentarJs.PROCITAN, radni_nalog: item.radni_nalog, poruka: item.poruka });
	                });
	            });
	        }
	    }, {
	        key: 'createComment',
	        value: function createComment(text) {
	            var _this3 = this;
	
	            var DS = this.datastore();
	            var Komentar = DS.definitions['Komentar'];
	            if (text.length > 0) Komentar.create({ radni_nalog: this.item.id, poruka: text }).then(function (komentar) {
	                _this3.komentari = [komentar].concat(_toConsumableArray(_this3.komentari));
	                _this3.newComment = '';
	            });
	        }
	    }, {
	        key: 'getDayOfWeek',
	        value: function getDayOfWeek(day) {
	            return (0, _moment2['default'])(day).format('dddd');
	        }
	    }]);
	
	    return KomentariController;
	})();
	
	KomentariController.$inject = ['DS', '$q', '$state', 'logger'];
	
	var KomentariComponent = {
	    restrict: 'E',
	    templateUrl: _komentariHtml2['default'],
	    controller: KomentariController,
	    controllerAs: 'vm',
	    bindings: {
	        id: '<'
	    }
	};
	
	exports.KomentariComponent = KomentariComponent;
	exports.KomentariController = KomentariController;

/***/ },
/* 628 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/komentari.html';
	var html = "<div class=\"hpanel\"><div class=\"panel-heading hbuilt\">Slanje nove poruke</div><div class=\"panel-footer borders\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.newComment\" placeholder=\"Upišite sadržaj poruke ovdje...\"> <span class=\"input-group-btn\"><button ng-click=\"vm.createComment(vm.newComment)\" class=\"btn btn-success\" ng-disabled=\"vm.newComment === ''\">Pošalji</button></span></div></div><div class=\"v-timeline vertical-container\"><div class=\"vertical-timeline-block\" ng-repeat=\"item in vm.komentari\" animate-panel effect=\"zoomIn\"><div class=\"row\"><div class=\"vertical-timeline-icon navy-bg\"><i class=\"fa fa-comment\"></i></div><div class=\"vertical-timeline-content\"><div class=\"p-sm\"><span class=\"vertical-date pull-right\"><small style=\"text-transform: capitalize;\">{{vm.getDayOfWeek(item.created_at)}}, {{item.created_at | date: 'dd.MM.yyyy'}}</small><br><small>{{item.created_at | date: 'HH:mm'}}</small></span><h5 class=\"text-primary\">{{item.sender}}</h5><p>{{item.poruka}}</p></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 629 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Komentar = function Komentar(DS) {
	    return DS.defineResource({
	        name: 'Komentar',
	        endpoint: '/komentar'
	    });
	};
	
	var NeprocitanKomentar = function NeprocitanKomentar(DS) {
	    return DS.defineResource({
	        name: 'NeprocitanKomentar',
	        endpoint: '/komentar/neprocitani'
	    });
	};
	
	Komentar.$inject = ['DS'];
	NeprocitanKomentar.$inject = ['DS'];
	
	var NOVI = 'Novi';
	var PROCITAN = 'Procitan';
	
	exports.NOVI = NOVI;
	exports.PROCITAN = PROCITAN;
	exports.Komentar = Komentar;
	exports.NeprocitanKomentar = NeprocitanKomentar;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _rnLinkHtml = __webpack_require__(631);
	
	var _rnLinkHtml2 = _interopRequireDefault(_rnLinkHtml);
	
	var _statusiJs = __webpack_require__(524);
	
	var status = {};
	status[_statusiJs.OTVOREN] = 'btn-success';
	status[_statusiJs.UOBRADI] = 'btn-info';
	status[_statusiJs.ZAKLJUCAN] = 'btn-danger';
	status[_statusiJs.STORNIRAN] = 'btn-default';
	
	var RnLinkController = (function () {
	    function RnLinkController() {
	        _classCallCheck(this, RnLinkController);
	    }
	
	    _createClass(RnLinkController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.style = status[this.rn.status];
	        }
	    }]);
	
	    return RnLinkController;
	})();
	
	RnLinkController.$inject = [];
	
	var RnLinkComponent = {
	    restrict: 'E',
	    templateUrl: _rnLinkHtml2['default'],
	    controller: RnLinkController,
	    controllerAs: 'vm',
	    bindings: {
	        rn: '<',
	        badge: '<'
	    }
	};
	
	exports.RnLinkComponent = RnLinkComponent;
	exports.RnLinkController = RnLinkController;

/***/ },
/* 631 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/rnLink.html';
	var html = "<a ui-sref=\"radniNalog.details({id:vm.rn.id})\" class=\"btn btn-xs\" ng-class=\"vm.style\"><span class=\"label\">{{vm.rn.sifra_naloga}}</span></a>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _humanDentalArchesHtml = __webpack_require__(633);
	
	var _humanDentalArchesHtml2 = _interopRequireDefault(_humanDentalArchesHtml);
	
	var _zubiSvgJs = __webpack_require__(616);
	
	var HumanDentalArchesController = (function () {
	    function HumanDentalArchesController() {
	        _classCallCheck(this, HumanDentalArchesController);
	
	        this.plan = { pozicije: [], veze: [] };
	        this.selected = [];
	    }
	
	    _createClass(HumanDentalArchesController, [{
	        key: 'getSelected',
	        value: function getSelected() {
	            return this.plan.pozicije.filter(function (zub) {
	                return zub.selected === true;
	            }).map(function (zub) {
	                return zub.id;
	            });
	        }
	    }, {
	        key: 'refreshPlan',
	        value: function refreshPlan() {
	            var _this = this;
	
	            return {
	                pozicije: _zubiSvgJs.zubi.map(function (item) {
	                    var zub = Object.assign({}, item, { filled: false, selected: false });
	                    if (_this.data && _this.data.pozicije) {
	                        zub.filled = _lodash2['default'].findIndex(_this.data.pozicije, function (i) {
	                            return i.id === zub.id;
	                        }) > -1;
	                    }
	                    zub.selected = _lodash2['default'].findIndex(_this.selected, function (i) {
	                        return i === zub.id;
	                    }) > -1;
	                    return zub;
	                }),
	                veze: _zubiSvgJs.veze.map(function (item) {
	                    var veza = Object.assign({}, item, { active: false });
	                    if (_this.data && _this.data.veze) {
	                        veza.active = _lodash2['default'].findIndex(_this.data.veze, function (i) {
	                            return i.id === veza.id && i.celjust === veza.celjust;
	                        }) > -1;
	                    }
	                    return veza;
	                })
	            };
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges() {
	            this.plan = this.refreshPlan();
	        }
	    }, {
	        key: 'pozicijaClicked',
	        value: function pozicijaClicked(pozicija) {
	            var poz = _lodash2['default'].findIndex(this.selected, function (i) {
	                return i === pozicija;
	            });
	            if (poz !== -1) {
	                this.selected.splice(poz, 1);
	            } else {
	                this.selected.push(pozicija);
	            }
	            this.plan = this.refreshPlan();
	        }
	    }, {
	        key: 'getVezeZaCeljust',
	        value: function getVezeZaCeljust(celjust) {
	            var elementi = [];
	
	            if (celjust.length === 0) {
	                return [];
	            }
	
	            var min_G = _lodash2['default'].minBy(celjust, 'rbr');
	            var max_G = _lodash2['default'].maxBy(celjust, 'rbr');
	
	            _lodash2['default'].range(min_G.rbr, max_G.rbr).map(function (i) {
	                var veza = (0, _zubiSvgJs.findVeza)(i, min_G.celjust);
	                if (veza !== null && veza !== undefined) {
	                    elementi.push(veza);
	                }
	            });
	
	            return elementi;
	        }
	    }, {
	        key: 'vezaBtnClicked',
	        value: function vezaBtnClicked() {
	            var _this2 = this;
	
	            var celjustG = [];
	            var celjustD = [];
	            var selected = this.getSelected();
	            selected.map(function (s) {
	                var zub = (0, _zubiSvgJs.findZub)(s);
	                if (zub.celjust === 'G') {
	                    celjustG.push(zub);
	                }
	
	                if (zub.celjust === 'D') {
	                    celjustD.push(zub);
	                }
	            });
	
	            this.getVezeZaCeljust(celjustG).map(function (v) {
	                _this2.onVezaBtnClicked({ veza: v });
	            });
	
	            this.getVezeZaCeljust(celjustD).map(function (v) {
	                _this2.onVezaBtnClicked({ veza: v });
	            });
	
	            this.selected = [];
	        }
	    }, {
	        key: 'onBtnNovaStavkaClicked',
	        value: function onBtnNovaStavkaClicked() {
	            var selected = this.getSelected();
	            this.onNoveStavke({ pozicije: [].concat(_toConsumableArray(selected)) });
	            this.selected = [];
	        }
	    }]);
	
	    return HumanDentalArchesController;
	})();
	
	HumanDentalArchesController.$inject = [];
	
	var HumanDentalArchesComponent = {
	    restrict: 'E',
	    templateUrl: _humanDentalArchesHtml2['default'],
	    controller: HumanDentalArchesController,
	    controllerAs: 'vm',
	    bindings: {
	        data: '<',
	        onNoveStavke: '&',
	        onVezaBtnClicked: '&'
	    }
	};
	
	exports.HumanDentalArchesComponent = HumanDentalArchesComponent;
	exports.HumanDentalArchesController = HumanDentalArchesController;

/***/ },
/* 633 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/humanDentalArches.html';
	var html = "<div class=\"row\"><div class=\"col-lg-9 col-sm-8\"><dental-editor plan=\"vm.plan\" on-click=\"vm.pozicijaClicked(id)\" , on-veza=\"vm.vezaBtnClicked()\"></dental-editor></div><div class=\"col-lg-1 col-sm-2\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.onBtnNovaStavkaClicked()\"><i class=\"fa fa-plus-square\"></i> Nova stavka</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _zubHtml = __webpack_require__(635);
	
	var _zubHtml2 = _interopRequireDefault(_zubHtml);
	
	var _svgJs = __webpack_require__(636);
	
	var _svgJs2 = _interopRequireDefault(_svgJs);
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function zub($document, $timeout) {
	    return {
	        restrict: 'E',
	        scope: {
	            onClick: '&',
	            ondblClick: '&',
	            item: '='
	        },
	        link: function link(scope, iElement, attrs) {
	            var q = _jquery2['default'];
	            var SVG = (0, _svgJs2['default'])('svg2');
	            var bbox = null;
	            // debugger;
	
	            var group = SVG.group();
	            group.attr('id', scope.item.id);
	            scope.item.paths.map(function (p) {
	                group.path(p).style({
	                    stroke: '#000000',
	                    cursor: 'pointer',
	                    'stroke-width': 10.66666698,
	                    'stroke-linecap': 'round',
	                    'stroke-linejoin': 'miter',
	                    'stroke-miterlimit': 4,
	                    'stroke-dasharray': 'none',
	                    'stroke-opacity': 1
	                });
	            });
	
	            group.style({ fill: 'white' });
	
	            if (scope.item) {
	                if (scope.item.selected === true) {
	                    var b = group.bbox();
	                    bbox = SVG.rect(b.width, b.height).addClass('box').move(b.x, b.y).style({ fill: 'none', 'stroke-width': 10, stroke: 'black' });
	                }
	
	                if (scope.item.filled === true) {
	                    group.style({ fill: '#dde3e1' });
	                }
	            }
	
	            var dblclick_occured = false;
	            var t = null;
	
	            group.click(function () {
	                $timeout(function () {
	                    scope.onClick({ id: scope.item.id });
	                });
	            });
	
	            scope.$on('$destroy', function () {
	                group.off();
	                if (bbox) {
	                    bbox.remove();
	                }
	                group.remove();
	            });
	
	            // debugger;
	        }
	        // templateUrl: template
	    };
	}
	
	zub.$inject = ['$document', '$timeout'];
	
	exports.zub = zub;

/***/ },
/* 635 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/zub.html';
	var html = "<g id=\"17\" ng-click=\"vm.onclick(vm.id)\" style=\"fill:white\"><path ng-repeat=\"p in paths\" d=\"{{p}}\" style=\"stroke:#000000;stroke-width:10.66666698;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path></g>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* svg.js - A lightweight library for manipulating and animating SVG.
	* @version 2.6.4
	* https://svgdotjs.github.io/
	*
	* @copyright Wout Fierens <wout@mick-wout.com>
	* @license MIT
	*
	* BUILT: Wed Feb 07 2018 22:59:25 GMT+0100 (Mitteleuropäische Zeit)
	*/;
	(function(root, factory) {
	  /* istanbul ignore next */
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	      return factory(root, root.document)
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else if (typeof exports === 'object') {
	    module.exports = root.document ? factory(root, root.document) : function(w){ return factory(w, w.document) }
	  } else {
	    root.SVG = factory(root, root.document)
	  }
	}(typeof window !== "undefined" ? window : this, function(window, document) {
	
	// The main wrapping element
	var SVG = this.SVG = function(element) {
	  if (SVG.supported) {
	    element = new SVG.Doc(element)
	
	    if(!SVG.parser.draw)
	      SVG.prepare()
	
	    return element
	  }
	}
	
	// Default namespaces
	SVG.ns    = 'http://www.w3.org/2000/svg'
	SVG.xmlns = 'http://www.w3.org/2000/xmlns/'
	SVG.xlink = 'http://www.w3.org/1999/xlink'
	SVG.svgjs = 'http://svgjs.com/svgjs'
	
	// Svg support test
	SVG.supported = (function() {
	  return !! document.createElementNS &&
	         !! document.createElementNS(SVG.ns,'svg').createSVGRect
	})()
	
	// Don't bother to continue if SVG is not supported
	if (!SVG.supported) return false
	
	// Element id sequence
	SVG.did  = 1000
	
	// Get next named element id
	SVG.eid = function(name) {
	  return 'Svgjs' + capitalize(name) + (SVG.did++)
	}
	
	// Method for element creation
	SVG.create = function(name) {
	  // create element
	  var element = document.createElementNS(this.ns, name)
	
	  // apply unique id
	  element.setAttribute('id', this.eid(name))
	
	  return element
	}
	
	// Method for extending objects
	SVG.extend = function() {
	  var modules, methods, key, i
	
	  // Get list of modules
	  modules = [].slice.call(arguments)
	
	  // Get object with extensions
	  methods = modules.pop()
	
	  for (i = modules.length - 1; i >= 0; i--)
	    if (modules[i])
	      for (key in methods)
	        modules[i].prototype[key] = methods[key]
	
	  // Make sure SVG.Set inherits any newly added methods
	  if (SVG.Set && SVG.Set.inherit)
	    SVG.Set.inherit()
	}
	
	// Invent new element
	SVG.invent = function(config) {
	  // Create element initializer
	  var initializer = typeof config.create == 'function' ?
	    config.create :
	    function() {
	      this.constructor.call(this, SVG.create(config.create))
	    }
	
	  // Inherit prototype
	  if (config.inherit)
	    initializer.prototype = new config.inherit
	
	  // Extend with methods
	  if (config.extend)
	    SVG.extend(initializer, config.extend)
	
	  // Attach construct method to parent
	  if (config.construct)
	    SVG.extend(config.parent || SVG.Container, config.construct)
	
	  return initializer
	}
	
	// Adopt existing svg elements
	SVG.adopt = function(node) {
	  // check for presence of node
	  if (!node) return null
	
	  // make sure a node isn't already adopted
	  if (node.instance) return node.instance
	
	  // initialize variables
	  var element
	
	  // adopt with element-specific settings
	  if (node.nodeName == 'svg')
	    element = node.parentNode instanceof window.SVGElement ? new SVG.Nested : new SVG.Doc
	  else if (node.nodeName == 'linearGradient')
	    element = new SVG.Gradient('linear')
	  else if (node.nodeName == 'radialGradient')
	    element = new SVG.Gradient('radial')
	  else if (SVG[capitalize(node.nodeName)])
	    element = new SVG[capitalize(node.nodeName)]
	  else
	    element = new SVG.Element(node)
	
	  // ensure references
	  element.type  = node.nodeName
	  element.node  = node
	  node.instance = element
	
	  // SVG.Class specific preparations
	  if (element instanceof SVG.Doc)
	    element.namespace().defs()
	
	  // pull svgjs data from the dom (getAttributeNS doesn't work in html5)
	  element.setData(JSON.parse(node.getAttribute('svgjs:data')) || {})
	
	  return element
	}
	
	// Initialize parsing element
	SVG.prepare = function() {
	  // Select document body and create invisible svg element
	  var body = document.getElementsByTagName('body')[0]
	    , draw = (body ? new SVG.Doc(body) : SVG.adopt(document.documentElement).nested()).size(2, 0)
	
	  // Create parser object
	  SVG.parser = {
	    body: body || document.documentElement
	  , draw: draw.style('opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden').node
	  , poly: draw.polyline().node
	  , path: draw.path().node
	  , native: SVG.create('svg')
	  }
	}
	
	SVG.parser = {
	  native: SVG.create('svg')
	}
	
	document.addEventListener('DOMContentLoaded', function() {
	  if(!SVG.parser.draw)
	    SVG.prepare()
	}, false)
	
	// Storage for regular expressions
	SVG.regex = {
	  // Parse unit value
	  numberAndUnit:    /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i
	
	  // Parse hex value
	, hex:              /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i
	
	  // Parse rgb value
	, rgb:              /rgb\((\d+),(\d+),(\d+)\)/
	
	  // Parse reference id
	, reference:        /#([a-z0-9\-_]+)/i
	
	  // splits a transformation chain
	, transforms:       /\)\s*,?\s*/
	
	  // Whitespace
	, whitespace:       /\s/g
	
	  // Test hex value
	, isHex:            /^#[a-f0-9]{3,6}$/i
	
	  // Test rgb value
	, isRgb:            /^rgb\(/
	
	  // Test css declaration
	, isCss:            /[^:]+:[^;]+;?/
	
	  // Test for blank string
	, isBlank:          /^(\s+)?$/
	
	  // Test for numeric string
	, isNumber:         /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i
	
	  // Test for percent value
	, isPercent:        /^-?[\d\.]+%$/
	
	  // Test for image url
	, isImage:          /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i
	
	  // split at whitespace and comma
	, delimiter:        /[\s,]+/
	
	  // The following regex are used to parse the d attribute of a path
	
	  // Matches all hyphens which are not after an exponent
	, hyphen:           /([^e])\-/gi
	
	  // Replaces and tests for all path letters
	, pathLetters:      /[MLHVCSQTAZ]/gi
	
	  // yes we need this one, too
	, isPathLetter:     /[MLHVCSQTAZ]/i
	
	  // matches 0.154.23.45
	, numbersWithDots:  /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi
	
	  // matches .
	, dots:             /\./g
	}
	
	SVG.utils = {
	  // Map function
	  map: function(array, block) {
	    var i
	      , il = array.length
	      , result = []
	
	    for (i = 0; i < il; i++)
	      result.push(block(array[i]))
	
	    return result
	  }
	
	  // Filter function
	, filter: function(array, block) {
	    var i
	      , il = array.length
	      , result = []
	
	    for (i = 0; i < il; i++)
	      if (block(array[i]))
	        result.push(array[i])
	
	    return result
	  }
	
	  // Degrees to radians
	, radians: function(d) {
	    return d % 360 * Math.PI / 180
	  }
	
	  // Radians to degrees
	, degrees: function(r) {
	    return r * 180 / Math.PI % 360
	  }
	
	, filterSVGElements: function(nodes) {
	    return this.filter( nodes, function(el) { return el instanceof window.SVGElement })
	  }
	
	}
	
	SVG.defaults = {
	  // Default attribute values
	  attrs: {
	    // fill and stroke
	    'fill-opacity':     1
	  , 'stroke-opacity':   1
	  , 'stroke-width':     0
	  , 'stroke-linejoin':  'miter'
	  , 'stroke-linecap':   'butt'
	  , fill:               '#000000'
	  , stroke:             '#000000'
	  , opacity:            1
	    // position
	  , x:                  0
	  , y:                  0
	  , cx:                 0
	  , cy:                 0
	    // size
	  , width:              0
	  , height:             0
	    // radius
	  , r:                  0
	  , rx:                 0
	  , ry:                 0
	    // gradient
	  , offset:             0
	  , 'stop-opacity':     1
	  , 'stop-color':       '#000000'
	    // text
	  , 'font-size':        16
	  , 'font-family':      'Helvetica, Arial, sans-serif'
	  , 'text-anchor':      'start'
	  }
	
	}
	// Module for color convertions
	SVG.Color = function(color) {
	  var match
	
	  // initialize defaults
	  this.r = 0
	  this.g = 0
	  this.b = 0
	
	  if(!color) return
	
	  // parse color
	  if (typeof color === 'string') {
	    if (SVG.regex.isRgb.test(color)) {
	      // get rgb values
	      match = SVG.regex.rgb.exec(color.replace(SVG.regex.whitespace,''))
	
	      // parse numeric values
	      this.r = parseInt(match[1])
	      this.g = parseInt(match[2])
	      this.b = parseInt(match[3])
	
	    } else if (SVG.regex.isHex.test(color)) {
	      // get hex values
	      match = SVG.regex.hex.exec(fullHex(color))
	
	      // parse numeric values
	      this.r = parseInt(match[1], 16)
	      this.g = parseInt(match[2], 16)
	      this.b = parseInt(match[3], 16)
	
	    }
	
	  } else if (typeof color === 'object') {
	    this.r = color.r
	    this.g = color.g
	    this.b = color.b
	
	  }
	
	}
	
	SVG.extend(SVG.Color, {
	  // Default to hex conversion
	  toString: function() {
	    return this.toHex()
	  }
	  // Build hex value
	, toHex: function() {
	    return '#'
	      + compToHex(this.r)
	      + compToHex(this.g)
	      + compToHex(this.b)
	  }
	  // Build rgb value
	, toRgb: function() {
	    return 'rgb(' + [this.r, this.g, this.b].join() + ')'
	  }
	  // Calculate true brightness
	, brightness: function() {
	    return (this.r / 255 * 0.30)
	         + (this.g / 255 * 0.59)
	         + (this.b / 255 * 0.11)
	  }
	  // Make color morphable
	, morph: function(color) {
	    this.destination = new SVG.Color(color)
	
	    return this
	  }
	  // Get morphed color at given position
	, at: function(pos) {
	    // make sure a destination is defined
	    if (!this.destination) return this
	
	    // normalise pos
	    pos = pos < 0 ? 0 : pos > 1 ? 1 : pos
	
	    // generate morphed color
	    return new SVG.Color({
	      r: ~~(this.r + (this.destination.r - this.r) * pos)
	    , g: ~~(this.g + (this.destination.g - this.g) * pos)
	    , b: ~~(this.b + (this.destination.b - this.b) * pos)
	    })
	  }
	
	})
	
	// Testers
	
	// Test if given value is a color string
	SVG.Color.test = function(color) {
	  color += ''
	  return SVG.regex.isHex.test(color)
	      || SVG.regex.isRgb.test(color)
	}
	
	// Test if given value is a rgb object
	SVG.Color.isRgb = function(color) {
	  return color && typeof color.r == 'number'
	               && typeof color.g == 'number'
	               && typeof color.b == 'number'
	}
	
	// Test if given value is a color
	SVG.Color.isColor = function(color) {
	  return SVG.Color.isRgb(color) || SVG.Color.test(color)
	}
	// Module for array conversion
	SVG.Array = function(array, fallback) {
	  array = (array || []).valueOf()
	
	  // if array is empty and fallback is provided, use fallback
	  if (array.length == 0 && fallback)
	    array = fallback.valueOf()
	
	  // parse array
	  this.value = this.parse(array)
	}
	
	SVG.extend(SVG.Array, {
	  // Make array morphable
	  morph: function(array) {
	    this.destination = this.parse(array)
	
	    // normalize length of arrays
	    if (this.value.length != this.destination.length) {
	      var lastValue       = this.value[this.value.length - 1]
	        , lastDestination = this.destination[this.destination.length - 1]
	
	      while(this.value.length > this.destination.length)
	        this.destination.push(lastDestination)
	      while(this.value.length < this.destination.length)
	        this.value.push(lastValue)
	    }
	
	    return this
	  }
	  // Clean up any duplicate points
	, settle: function() {
	    // find all unique values
	    for (var i = 0, il = this.value.length, seen = []; i < il; i++)
	      if (seen.indexOf(this.value[i]) == -1)
	        seen.push(this.value[i])
	
	    // set new value
	    return this.value = seen
	  }
	  // Get morphed array at given position
	, at: function(pos) {
	    // make sure a destination is defined
	    if (!this.destination) return this
	
	    // generate morphed array
	    for (var i = 0, il = this.value.length, array = []; i < il; i++)
	      array.push(this.value[i] + (this.destination[i] - this.value[i]) * pos)
	
	    return new SVG.Array(array)
	  }
	  // Convert array to string
	, toString: function() {
	    return this.value.join(' ')
	  }
	  // Real value
	, valueOf: function() {
	    return this.value
	  }
	  // Parse whitespace separated string
	, parse: function(array) {
	    array = array.valueOf()
	
	    // if already is an array, no need to parse it
	    if (Array.isArray(array)) return array
	
	    return this.split(array)
	  }
	  // Strip unnecessary whitespace
	, split: function(string) {
	    return string.trim().split(SVG.regex.delimiter).map(parseFloat)
	  }
	  // Reverse array
	, reverse: function() {
	    this.value.reverse()
	
	    return this
	  }
	, clone: function() {
	    var clone = new this.constructor()
	    clone.value = array_clone(this.value)
	    return clone
	  }
	})
	// Poly points array
	SVG.PointArray = function(array, fallback) {
	  SVG.Array.call(this, array, fallback || [[0,0]])
	}
	
	// Inherit from SVG.Array
	SVG.PointArray.prototype = new SVG.Array
	SVG.PointArray.prototype.constructor = SVG.PointArray
	
	SVG.extend(SVG.PointArray, {
	  // Convert array to string
	  toString: function() {
	    // convert to a poly point string
	    for (var i = 0, il = this.value.length, array = []; i < il; i++)
	      array.push(this.value[i].join(','))
	
	    return array.join(' ')
	  }
	  // Convert array to line object
	, toLine: function() {
	    return {
	      x1: this.value[0][0]
	    , y1: this.value[0][1]
	    , x2: this.value[1][0]
	    , y2: this.value[1][1]
	    }
	  }
	  // Get morphed array at given position
	, at: function(pos) {
	    // make sure a destination is defined
	    if (!this.destination) return this
	
	    // generate morphed point string
	    for (var i = 0, il = this.value.length, array = []; i < il; i++)
	      array.push([
	        this.value[i][0] + (this.destination[i][0] - this.value[i][0]) * pos
	      , this.value[i][1] + (this.destination[i][1] - this.value[i][1]) * pos
	      ])
	
	    return new SVG.PointArray(array)
	  }
	  // Parse point string and flat array
	, parse: function(array) {
	    var points = []
	
	    array = array.valueOf()
	
	    // if it is an array
	    if (Array.isArray(array)) {
	      // and it is not flat, there is no need to parse it
	      if(Array.isArray(array[0])) {
	        return array
	      }
	    } else { // Else, it is considered as a string
	      // parse points
	      array = array.trim().split(SVG.regex.delimiter).map(parseFloat)
	    }
	
	    // validate points - https://svgwg.org/svg2-draft/shapes.html#DataTypePoints
	    // Odd number of coordinates is an error. In such cases, drop the last odd coordinate.
	    if (array.length % 2 !== 0) array.pop()
	
	    // wrap points in two-tuples and parse points as floats
	    for(var i = 0, len = array.length; i < len; i = i + 2)
	      points.push([ array[i], array[i+1] ])
	
	    return points
	  }
	  // Move point string
	, move: function(x, y) {
	    var box = this.bbox()
	
	    // get relative offset
	    x -= box.x
	    y -= box.y
	
	    // move every point
	    if (!isNaN(x) && !isNaN(y))
	      for (var i = this.value.length - 1; i >= 0; i--)
	        this.value[i] = [this.value[i][0] + x, this.value[i][1] + y]
	
	    return this
	  }
	  // Resize poly string
	, size: function(width, height) {
	    var i, box = this.bbox()
	
	    // recalculate position of all points according to new size
	    for (i = this.value.length - 1; i >= 0; i--) {
	      if(box.width) this.value[i][0] = ((this.value[i][0] - box.x) * width)  / box.width  + box.x
	      if(box.height) this.value[i][1] = ((this.value[i][1] - box.y) * height) / box.height + box.y
	    }
	
	    return this
	  }
	  // Get bounding box of points
	, bbox: function() {
	    SVG.parser.poly.setAttribute('points', this.toString())
	
	    return SVG.parser.poly.getBBox()
	  }
	})
	
	var pathHandlers = {
	  M: function(c, p, p0) {
	    p.x = p0.x = c[0]
	    p.y = p0.y = c[1]
	
	    return ['M', p.x, p.y]
	  },
	  L: function(c, p) {
	    p.x = c[0]
	    p.y = c[1]
	    return ['L', c[0], c[1]]
	  },
	  H: function(c, p) {
	    p.x = c[0]
	    return ['H', c[0]]
	  },
	  V: function(c, p) {
	    p.y = c[0]
	    return ['V', c[0]]
	  },
	  C: function(c, p) {
	    p.x = c[4]
	    p.y = c[5]
	    return ['C', c[0], c[1], c[2], c[3], c[4], c[5]]
	  },
	  S: function(c, p) {
	    p.x = c[2]
	    p.y = c[3]
	    return ['S', c[0], c[1], c[2], c[3]]
	  },
	  Q: function(c, p) {
	    p.x = c[2]
	    p.y = c[3]
	    return ['Q', c[0], c[1], c[2], c[3]]
	  },
	  T: function(c, p) {
	    p.x = c[0]
	    p.y = c[1]
	    return ['T', c[0], c[1]]
	  },
	  Z: function(c, p, p0) {
	    p.x = p0.x
	    p.y = p0.y
	    return ['Z']
	  },
	  A: function(c, p) {
	    p.x = c[5]
	    p.y = c[6]
	    return ['A', c[0], c[1], c[2], c[3], c[4], c[5], c[6]]
	  }
	}
	
	var mlhvqtcsa = 'mlhvqtcsaz'.split('')
	
	for(var i = 0, il = mlhvqtcsa.length; i < il; ++i){
	  pathHandlers[mlhvqtcsa[i]] = (function(i){
	    return function(c, p, p0) {
	      if(i == 'H') c[0] = c[0] + p.x
	      else if(i == 'V') c[0] = c[0] + p.y
	      else if(i == 'A'){
	        c[5] = c[5] + p.x,
	        c[6] = c[6] + p.y
	      }
	      else
	        for(var j = 0, jl = c.length; j < jl; ++j) {
	          c[j] = c[j] + (j%2 ? p.y : p.x)
	        }
	
	      return pathHandlers[i](c, p, p0)
	    }
	  })(mlhvqtcsa[i].toUpperCase())
	}
	
	// Path points array
	SVG.PathArray = function(array, fallback) {
	  SVG.Array.call(this, array, fallback || [['M', 0, 0]])
	}
	
	// Inherit from SVG.Array
	SVG.PathArray.prototype = new SVG.Array
	SVG.PathArray.prototype.constructor = SVG.PathArray
	
	SVG.extend(SVG.PathArray, {
	  // Convert array to string
	  toString: function() {
	    return arrayToString(this.value)
	  }
	  // Move path string
	, move: function(x, y) {
	    // get bounding box of current situation
	    var box = this.bbox()
	
	    // get relative offset
	    x -= box.x
	    y -= box.y
	
	    if (!isNaN(x) && !isNaN(y)) {
	      // move every point
	      for (var l, i = this.value.length - 1; i >= 0; i--) {
	        l = this.value[i][0]
	
	        if (l == 'M' || l == 'L' || l == 'T')  {
	          this.value[i][1] += x
	          this.value[i][2] += y
	
	        } else if (l == 'H')  {
	          this.value[i][1] += x
	
	        } else if (l == 'V')  {
	          this.value[i][1] += y
	
	        } else if (l == 'C' || l == 'S' || l == 'Q')  {
	          this.value[i][1] += x
	          this.value[i][2] += y
	          this.value[i][3] += x
	          this.value[i][4] += y
	
	          if (l == 'C')  {
	            this.value[i][5] += x
	            this.value[i][6] += y
	          }
	
	        } else if (l == 'A')  {
	          this.value[i][6] += x
	          this.value[i][7] += y
	        }
	
	      }
	    }
	
	    return this
	  }
	  // Resize path string
	, size: function(width, height) {
	    // get bounding box of current situation
	    var i, l, box = this.bbox()
	
	    // recalculate position of all points according to new size
	    for (i = this.value.length - 1; i >= 0; i--) {
	      l = this.value[i][0]
	
	      if (l == 'M' || l == 'L' || l == 'T')  {
	        this.value[i][1] = ((this.value[i][1] - box.x) * width)  / box.width  + box.x
	        this.value[i][2] = ((this.value[i][2] - box.y) * height) / box.height + box.y
	
	      } else if (l == 'H')  {
	        this.value[i][1] = ((this.value[i][1] - box.x) * width)  / box.width  + box.x
	
	      } else if (l == 'V')  {
	        this.value[i][1] = ((this.value[i][1] - box.y) * height) / box.height + box.y
	
	      } else if (l == 'C' || l == 'S' || l == 'Q')  {
	        this.value[i][1] = ((this.value[i][1] - box.x) * width)  / box.width  + box.x
	        this.value[i][2] = ((this.value[i][2] - box.y) * height) / box.height + box.y
	        this.value[i][3] = ((this.value[i][3] - box.x) * width)  / box.width  + box.x
	        this.value[i][4] = ((this.value[i][4] - box.y) * height) / box.height + box.y
	
	        if (l == 'C')  {
	          this.value[i][5] = ((this.value[i][5] - box.x) * width)  / box.width  + box.x
	          this.value[i][6] = ((this.value[i][6] - box.y) * height) / box.height + box.y
	        }
	
	      } else if (l == 'A')  {
	        // resize radii
	        this.value[i][1] = (this.value[i][1] * width)  / box.width
	        this.value[i][2] = (this.value[i][2] * height) / box.height
	
	        // move position values
	        this.value[i][6] = ((this.value[i][6] - box.x) * width)  / box.width  + box.x
	        this.value[i][7] = ((this.value[i][7] - box.y) * height) / box.height + box.y
	      }
	
	    }
	
	    return this
	  }
	  // Test if the passed path array use the same path data commands as this path array
	, equalCommands: function(pathArray) {
	    var i, il, equalCommands
	
	    pathArray = new SVG.PathArray(pathArray)
	
	    equalCommands = this.value.length === pathArray.value.length
	    for(i = 0, il = this.value.length; equalCommands && i < il; i++) {
	      equalCommands = this.value[i][0] === pathArray.value[i][0]
	    }
	
	    return equalCommands
	  }
	  // Make path array morphable
	, morph: function(pathArray) {
	    pathArray = new SVG.PathArray(pathArray)
	
	    if(this.equalCommands(pathArray)) {
	      this.destination = pathArray
	    } else {
	      this.destination = null
	    }
	
	    return this
	  }
	  // Get morphed path array at given position
	, at: function(pos) {
	    // make sure a destination is defined
	    if (!this.destination) return this
	
	    var sourceArray = this.value
	      , destinationArray = this.destination.value
	      , array = [], pathArray = new SVG.PathArray()
	      , i, il, j, jl
	
	    // Animate has specified in the SVG spec
	    // See: https://www.w3.org/TR/SVG11/paths.html#PathElement
	    for (i = 0, il = sourceArray.length; i < il; i++) {
	      array[i] = [sourceArray[i][0]]
	      for(j = 1, jl = sourceArray[i].length; j < jl; j++) {
	        array[i][j] = sourceArray[i][j] + (destinationArray[i][j] - sourceArray[i][j]) * pos
	      }
	      // For the two flags of the elliptical arc command, the SVG spec say:
	      // Flags and booleans are interpolated as fractions between zero and one, with any non-zero value considered to be a value of one/true
	      // Elliptical arc command as an array followed by corresponding indexes:
	      // ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
	      //   0    1   2        3                 4             5      6  7
	      if(array[i][0] === 'A') {
	        array[i][4] = +(array[i][4] != 0)
	        array[i][5] = +(array[i][5] != 0)
	      }
	    }
	
	    // Directly modify the value of a path array, this is done this way for performance
	    pathArray.value = array
	    return pathArray
	  }
	  // Absolutize and parse path to array
	, parse: function(array) {
	    // if it's already a patharray, no need to parse it
	    if (array instanceof SVG.PathArray) return array.valueOf()
	
	    // prepare for parsing
	    var i, x0, y0, s, seg, arr
	      , x = 0
	      , y = 0
	      , paramCnt = { 'M':2, 'L':2, 'H':1, 'V':1, 'C':6, 'S':4, 'Q':4, 'T':2, 'A':7, 'Z':0 }
	
	    if(typeof array == 'string'){
	
	      array = array
	        .replace(SVG.regex.numbersWithDots, pathRegReplace) // convert 45.123.123 to 45.123 .123
	        .replace(SVG.regex.pathLetters, ' $& ') // put some room between letters and numbers
	        .replace(SVG.regex.hyphen, '$1 -')      // add space before hyphen
	        .trim()                                 // trim
	        .split(SVG.regex.delimiter)   // split into array
	
	    }else{
	      array = array.reduce(function(prev, curr){
	        return [].concat.call(prev, curr)
	      }, [])
	    }
	
	    // array now is an array containing all parts of a path e.g. ['M', '0', '0', 'L', '30', '30' ...]
	    var arr = []
	      , p = new SVG.Point()
	      , p0 = new SVG.Point()
	      , index = 0
	      , len = array.length
	
	    do{
	      // Test if we have a path letter
	      if(SVG.regex.isPathLetter.test(array[index])){
	        s = array[index]
	        ++index
	      // If last letter was a move command and we got no new, it defaults to [L]ine
	      }else if(s == 'M'){
	        s = 'L'
	      }else if(s == 'm'){
	        s = 'l'
	      }
	
	      arr.push(pathHandlers[s].call(null,
	          array.slice(index, (index = index + paramCnt[s.toUpperCase()])).map(parseFloat),
	          p, p0
	        )
	      )
	
	    }while(len > index)
	
	    return arr
	
	  }
	  // Get bounding box of path
	, bbox: function() {
	    SVG.parser.path.setAttribute('d', this.toString())
	
	    return SVG.parser.path.getBBox()
	  }
	
	})
	
	// Module for unit convertions
	SVG.Number = SVG.invent({
	  // Initialize
	  create: function(value, unit) {
	    // initialize defaults
	    this.value = 0
	    this.unit  = unit || ''
	
	    // parse value
	    if (typeof value === 'number') {
	      // ensure a valid numeric value
	      this.value = isNaN(value) ? 0 : !isFinite(value) ? (value < 0 ? -3.4e+38 : +3.4e+38) : value
	
	    } else if (typeof value === 'string') {
	      unit = value.match(SVG.regex.numberAndUnit)
	
	      if (unit) {
	        // make value numeric
	        this.value = parseFloat(unit[1])
	
	        // normalize
	        if (unit[5] == '%')
	          this.value /= 100
	        else if (unit[5] == 's')
	          this.value *= 1000
	
	        // store unit
	        this.unit = unit[5]
	      }
	
	    } else {
	      if (value instanceof SVG.Number) {
	        this.value = value.valueOf()
	        this.unit  = value.unit
	      }
	    }
	
	  }
	  // Add methods
	, extend: {
	    // Stringalize
	    toString: function() {
	      return (
	        this.unit == '%' ?
	          ~~(this.value * 1e8) / 1e6:
	        this.unit == 's' ?
	          this.value / 1e3 :
	          this.value
	      ) + this.unit
	    }
	  , toJSON: function() {
	      return this.toString()
	    }
	  , // Convert to primitive
	    valueOf: function() {
	      return this.value
	    }
	    // Add number
	  , plus: function(number) {
	      number = new SVG.Number(number)
	      return new SVG.Number(this + number, this.unit || number.unit)
	    }
	    // Subtract number
	  , minus: function(number) {
	      number = new SVG.Number(number)
	      return new SVG.Number(this - number, this.unit || number.unit)
	    }
	    // Multiply number
	  , times: function(number) {
	      number = new SVG.Number(number)
	      return new SVG.Number(this * number, this.unit || number.unit)
	    }
	    // Divide number
	  , divide: function(number) {
	      number = new SVG.Number(number)
	      return new SVG.Number(this / number, this.unit || number.unit)
	    }
	    // Convert to different unit
	  , to: function(unit) {
	      var number = new SVG.Number(this)
	
	      if (typeof unit === 'string')
	        number.unit = unit
	
	      return number
	    }
	    // Make number morphable
	  , morph: function(number) {
	      this.destination = new SVG.Number(number)
	
	      if(number.relative) {
	        this.destination.value += this.value
	      }
	
	      return this
	    }
	    // Get morphed number at given position
	  , at: function(pos) {
	      // Make sure a destination is defined
	      if (!this.destination) return this
	
	      // Generate new morphed number
	      return new SVG.Number(this.destination)
	          .minus(this)
	          .times(pos)
	          .plus(this)
	    }
	
	  }
	})
	
	
	SVG.Element = SVG.invent({
	  // Initialize node
	  create: function(node) {
	    // make stroke value accessible dynamically
	    this._stroke = SVG.defaults.attrs.stroke
	    this._event = null
	
	    // initialize data object
	    this.dom = {}
	
	    // create circular reference
	    if (this.node = node) {
	      this.type = node.nodeName
	      this.node.instance = this
	
	      // store current attribute value
	      this._stroke = node.getAttribute('stroke') || this._stroke
	    }
	  }
	
	  // Add class methods
	, extend: {
	    // Move over x-axis
	    x: function(x) {
	      return this.attr('x', x)
	    }
	    // Move over y-axis
	  , y: function(y) {
	      return this.attr('y', y)
	    }
	    // Move by center over x-axis
	  , cx: function(x) {
	      return x == null ? this.x() + this.width() / 2 : this.x(x - this.width() / 2)
	    }
	    // Move by center over y-axis
	  , cy: function(y) {
	      return y == null ? this.y() + this.height() / 2 : this.y(y - this.height() / 2)
	    }
	    // Move element to given x and y values
	  , move: function(x, y) {
	      return this.x(x).y(y)
	    }
	    // Move element by its center
	  , center: function(x, y) {
	      return this.cx(x).cy(y)
	    }
	    // Set width of element
	  , width: function(width) {
	      return this.attr('width', width)
	    }
	    // Set height of element
	  , height: function(height) {
	      return this.attr('height', height)
	    }
	    // Set element size to given width and height
	  , size: function(width, height) {
	      var p = proportionalSize(this, width, height)
	
	      return this
	        .width(new SVG.Number(p.width))
	        .height(new SVG.Number(p.height))
	    }
	    // Clone element
	  , clone: function(parent, withData) {
	      // write dom data to the dom so the clone can pickup the data
	      this.writeDataToDom()
	
	      // clone element and assign new id
	      var clone = assignNewId(this.node.cloneNode(true))
	
	      // insert the clone in the given parent or after myself
	      if(parent) parent.add(clone)
	      else this.after(clone)
	
	      return clone
	    }
	    // Remove element
	  , remove: function() {
	      if (this.parent())
	        this.parent().removeElement(this)
	
	      return this
	    }
	    // Replace element
	  , replace: function(element) {
	      this.after(element).remove()
	
	      return element
	    }
	    // Add element to given container and return self
	  , addTo: function(parent) {
	      return parent.put(this)
	    }
	    // Add element to given container and return container
	  , putIn: function(parent) {
	      return parent.add(this)
	    }
	    // Get / set id
	  , id: function(id) {
	      return this.attr('id', id)
	    }
	    // Checks whether the given point inside the bounding box of the element
	  , inside: function(x, y) {
	      var box = this.bbox()
	
	      return x > box.x
	          && y > box.y
	          && x < box.x + box.width
	          && y < box.y + box.height
	    }
	    // Show element
	  , show: function() {
	      return this.style('display', '')
	    }
	    // Hide element
	  , hide: function() {
	      return this.style('display', 'none')
	    }
	    // Is element visible?
	  , visible: function() {
	      return this.style('display') != 'none'
	    }
	    // Return id on string conversion
	  , toString: function() {
	      return this.attr('id')
	    }
	    // Return array of classes on the node
	  , classes: function() {
	      var attr = this.attr('class')
	
	      return attr == null ? [] : attr.trim().split(SVG.regex.delimiter)
	    }
	    // Return true if class exists on the node, false otherwise
	  , hasClass: function(name) {
	      return this.classes().indexOf(name) != -1
	    }
	    // Add class to the node
	  , addClass: function(name) {
	      if (!this.hasClass(name)) {
	        var array = this.classes()
	        array.push(name)
	        this.attr('class', array.join(' '))
	      }
	
	      return this
	    }
	    // Remove class from the node
	  , removeClass: function(name) {
	      if (this.hasClass(name)) {
	        this.attr('class', this.classes().filter(function(c) {
	          return c != name
	        }).join(' '))
	      }
	
	      return this
	    }
	    // Toggle the presence of a class on the node
	  , toggleClass: function(name) {
	      return this.hasClass(name) ? this.removeClass(name) : this.addClass(name)
	    }
	    // Get referenced element form attribute value
	  , reference: function(attr) {
	      return SVG.get(this.attr(attr))
	    }
	    // Returns the parent element instance
	  , parent: function(type) {
	      var parent = this
	
	      // check for parent
	      if(!parent.node.parentNode) return null
	
	      // get parent element
	      parent = SVG.adopt(parent.node.parentNode)
	
	      if(!type) return parent
	
	      // loop trough ancestors if type is given
	      while(parent && parent.node instanceof window.SVGElement){
	        if(typeof type === 'string' ? parent.matches(type) : parent instanceof type) return parent
	        if(parent.node.parentNode.nodeName == '#document') return null // #720
	        parent = SVG.adopt(parent.node.parentNode)
	      }
	    }
	    // Get parent document
	  , doc: function() {
	      return this instanceof SVG.Doc ? this : this.parent(SVG.Doc)
	    }
	    // return array of all ancestors of given type up to the root svg
	  , parents: function(type) {
	      var parents = [], parent = this
	
	      do{
	        parent = parent.parent(type)
	        if(!parent || !parent.node) break
	
	        parents.push(parent)
	      } while(parent.parent)
	
	      return parents
	    }
	    // matches the element vs a css selector
	  , matches: function(selector){
	      return matches(this.node, selector)
	    }
	    // Returns the svg node to call native svg methods on it
	  , native: function() {
	      return this.node
	    }
	    // Import raw svg
	  , svg: function(svg) {
	      // create temporary holder
	      var well = document.createElement('svg')
	
	      // act as a setter if svg is given
	      if (svg && this instanceof SVG.Parent) {
	        // dump raw svg
	        well.innerHTML = '<svg>' + svg.replace(/\n/, '').replace(/<(\w+)([^<]+?)\/>/g, '<$1$2></$1>') + '</svg>'
	
	        // transplant nodes
	        for (var i = 0, il = well.firstChild.childNodes.length; i < il; i++)
	          this.node.appendChild(well.firstChild.firstChild)
	
	      // otherwise act as a getter
	      } else {
	        // create a wrapping svg element in case of partial content
	        well.appendChild(svg = document.createElement('svg'))
	
	        // write svgjs data to the dom
	        this.writeDataToDom()
	
	        // insert a copy of this node
	        svg.appendChild(this.node.cloneNode(true))
	
	        // return target element
	        return well.innerHTML.replace(/^<svg>/, '').replace(/<\/svg>$/, '')
	      }
	
	      return this
	    }
	  // write svgjs data to the dom
	  , writeDataToDom: function() {
	
	      // dump variables recursively
	      if(this.each || this.lines){
	        var fn = this.each ? this : this.lines();
	        fn.each(function(){
	          this.writeDataToDom()
	        })
	      }
	
	      // remove previously set data
	      this.node.removeAttribute('svgjs:data')
	
	      if(Object.keys(this.dom).length)
	        this.node.setAttribute('svgjs:data', JSON.stringify(this.dom)) // see #428
	
	      return this
	    }
	  // set given data to the elements data property
	  , setData: function(o){
	      this.dom = o
	      return this
	    }
	  , is: function(obj){
	      return is(this, obj)
	    }
	  }
	})
	
	SVG.easing = {
	  '-': function(pos){return pos}
	, '<>':function(pos){return -Math.cos(pos * Math.PI) / 2 + 0.5}
	, '>': function(pos){return  Math.sin(pos * Math.PI / 2)}
	, '<': function(pos){return -Math.cos(pos * Math.PI / 2) + 1}
	}
	
	SVG.morph = function(pos){
	  return function(from, to) {
	    return new SVG.MorphObj(from, to).at(pos)
	  }
	}
	
	SVG.Situation = SVG.invent({
	
	  create: function(o){
	    this.init = false
	    this.reversed = false
	    this.reversing = false
	
	    this.duration = new SVG.Number(o.duration).valueOf()
	    this.delay = new SVG.Number(o.delay).valueOf()
	
	    this.start = +new Date() + this.delay
	    this.finish = this.start + this.duration
	    this.ease = o.ease
	
	    // this.loop is incremented from 0 to this.loops
	    // it is also incremented when in an infinite loop (when this.loops is true)
	    this.loop = 0
	    this.loops = false
	
	    this.animations = {
	      // functionToCall: [list of morphable objects]
	      // e.g. move: [SVG.Number, SVG.Number]
	    }
	
	    this.attrs = {
	      // holds all attributes which are not represented from a function svg.js provides
	      // e.g. someAttr: SVG.Number
	    }
	
	    this.styles = {
	      // holds all styles which should be animated
	      // e.g. fill-color: SVG.Color
	    }
	
	    this.transforms = [
	      // holds all transformations as transformation objects
	      // e.g. [SVG.Rotate, SVG.Translate, SVG.Matrix]
	    ]
	
	    this.once = {
	      // functions to fire at a specific position
	      // e.g. "0.5": function foo(){}
	    }
	
	  }
	
	})
	
	
	SVG.FX = SVG.invent({
	
	  create: function(element) {
	    this._target = element
	    this.situations = []
	    this.active = false
	    this.situation = null
	    this.paused = false
	    this.lastPos = 0
	    this.pos = 0
	    // The absolute position of an animation is its position in the context of its complete duration (including delay and loops)
	    // When performing a delay, absPos is below 0 and when performing a loop, its value is above 1
	    this.absPos = 0
	    this._speed = 1
	  }
	
	, extend: {
	
	    /**
	     * sets or returns the target of this animation
	     * @param o object || number In case of Object it holds all parameters. In case of number its the duration of the animation
	     * @param ease function || string Function which should be used for easing or easing keyword
	     * @param delay Number indicating the delay before the animation starts
	     * @return target || this
	     */
	    animate: function(o, ease, delay){
	
	      if(typeof o == 'object'){
	        ease = o.ease
	        delay = o.delay
	        o = o.duration
	      }
	
	      var situation = new SVG.Situation({
	        duration: o || 1000,
	        delay: delay || 0,
	        ease: SVG.easing[ease || '-'] || ease
	      })
	
	      this.queue(situation)
	
	      return this
	    }
	
	    /**
	     * sets a delay before the next element of the queue is called
	     * @param delay Duration of delay in milliseconds
	     * @return this.target()
	     */
	  , delay: function(delay){
	      // The delay is performed by an empty situation with its duration
	      // attribute set to the duration of the delay
	      var situation = new SVG.Situation({
	        duration: delay,
	        delay: 0,
	        ease: SVG.easing['-']
	      })
	
	      return this.queue(situation)
	    }
	
	    /**
	     * sets or returns the target of this animation
	     * @param null || target SVG.Element which should be set as new target
	     * @return target || this
	     */
	  , target: function(target){
	      if(target && target instanceof SVG.Element){
	        this._target = target
	        return this
	      }
	
	      return this._target
	    }
	
	    // returns the absolute position at a given time
	  , timeToAbsPos: function(timestamp){
	      return (timestamp - this.situation.start) / (this.situation.duration/this._speed)
	    }
	
	    // returns the timestamp from a given absolute positon
	  , absPosToTime: function(absPos){
	      return this.situation.duration/this._speed * absPos + this.situation.start
	    }
	
	    // starts the animationloop
	  , startAnimFrame: function(){
	      this.stopAnimFrame()
	      this.animationFrame = window.requestAnimationFrame(function(){ this.step() }.bind(this))
	    }
	
	    // cancels the animationframe
	  , stopAnimFrame: function(){
	      window.cancelAnimationFrame(this.animationFrame)
	    }
	
	    // kicks off the animation - only does something when the queue is currently not active and at least one situation is set
	  , start: function(){
	      // dont start if already started
	      if(!this.active && this.situation){
	        this.active = true
	        this.startCurrent()
	      }
	
	      return this
	    }
	
	    // start the current situation
	  , startCurrent: function(){
	      this.situation.start = +new Date + this.situation.delay/this._speed
	      this.situation.finish = this.situation.start + this.situation.duration/this._speed
	      return this.initAnimations().step()
	    }
	
	    /**
	     * adds a function / Situation to the animation queue
	     * @param fn function / situation to add
	     * @return this
	     */
	  , queue: function(fn){
	      if(typeof fn == 'function' || fn instanceof SVG.Situation)
	        this.situations.push(fn)
	
	      if(!this.situation) this.situation = this.situations.shift()
	
	      return this
	    }
	
	    /**
	     * pulls next element from the queue and execute it
	     * @return this
	     */
	  , dequeue: function(){
	      // stop current animation
	      this.stop()
	
	      // get next animation from queue
	      this.situation = this.situations.shift()
	
	      if(this.situation){
	        if(this.situation instanceof SVG.Situation) {
	          this.start()
	        } else {
	          // If it is not a SVG.Situation, then it is a function, we execute it
	          this.situation.call(this)
	        }
	      }
	
	      return this
	    }
	
	    // updates all animations to the current state of the element
	    // this is important when one property could be changed from another property
	  , initAnimations: function() {
	      var i, j, source
	      var s = this.situation
	
	      if(s.init) return this
	
	      for(i in s.animations){
	        source = this.target()[i]()
	
	        if(!Array.isArray(source)) {
	          source = [source]
	        }
	
	        if(!Array.isArray(s.animations[i])) {
	          s.animations[i] = [s.animations[i]]
	        }
	
	        //if(s.animations[i].length > source.length) {
	        //  source.concat = source.concat(s.animations[i].slice(source.length, s.animations[i].length))
	        //}
	
	        for(j = source.length; j--;) {
	          // The condition is because some methods return a normal number instead
	          // of a SVG.Number
	          if(s.animations[i][j] instanceof SVG.Number)
	            source[j] = new SVG.Number(source[j])
	
	          s.animations[i][j] = source[j].morph(s.animations[i][j])
	        }
	      }
	
	      for(i in s.attrs){
	        s.attrs[i] = new SVG.MorphObj(this.target().attr(i), s.attrs[i])
	      }
	
	      for(i in s.styles){
	        s.styles[i] = new SVG.MorphObj(this.target().style(i), s.styles[i])
	      }
	
	      s.initialTransformation = this.target().matrixify()
	
	      s.init = true
	      return this
	    }
	  , clearQueue: function(){
	      this.situations = []
	      return this
	    }
	  , clearCurrent: function(){
	      this.situation = null
	      return this
	    }
	    /** stops the animation immediately
	     * @param jumpToEnd A Boolean indicating whether to complete the current animation immediately.
	     * @param clearQueue A Boolean indicating whether to remove queued animation as well.
	     * @return this
	     */
	  , stop: function(jumpToEnd, clearQueue){
	      var active = this.active
	      this.active = false
	
	      if(clearQueue){
	        this.clearQueue()
	      }
	
	      if(jumpToEnd && this.situation){
	        // initialize the situation if it was not
	        !active && this.startCurrent()
	        this.atEnd()
	      }
	
	      this.stopAnimFrame()
	
	      return this.clearCurrent()
	    }
	
	    /** resets the element to the state where the current element has started
	     * @return this
	     */
	  , reset: function(){
	      if(this.situation){
	        var temp = this.situation
	        this.stop()
	        this.situation = temp
	        this.atStart()
	      }
	      return this
	    }
	
	    // Stop the currently-running animation, remove all queued animations, and complete all animations for the element.
	  , finish: function(){
	
	      this.stop(true, false)
	
	      while(this.dequeue().situation && this.stop(true, false));
	
	      this.clearQueue().clearCurrent()
	
	      return this
	    }
	
	    // set the internal animation pointer at the start position, before any loops, and updates the visualisation
	  , atStart: function() {
	      return this.at(0, true)
	    }
	
	    // set the internal animation pointer at the end position, after all the loops, and updates the visualisation
	  , atEnd: function() {
	      if (this.situation.loops === true) {
	        // If in a infinite loop, we end the current iteration
	        this.situation.loops = this.situation.loop + 1
	      }
	
	      if(typeof this.situation.loops == 'number') {
	        // If performing a finite number of loops, we go after all the loops
	        return this.at(this.situation.loops, true)
	      } else {
	        // If no loops, we just go at the end
	        return this.at(1, true)
	      }
	    }
	
	    // set the internal animation pointer to the specified position and updates the visualisation
	    // if isAbsPos is true, pos is treated as an absolute position
	  , at: function(pos, isAbsPos){
	      var durDivSpd = this.situation.duration/this._speed
	
	      this.absPos = pos
	      // If pos is not an absolute position, we convert it into one
	      if (!isAbsPos) {
	        if (this.situation.reversed) this.absPos = 1 - this.absPos
	        this.absPos += this.situation.loop
	      }
	
	      this.situation.start = +new Date - this.absPos * durDivSpd
	      this.situation.finish = this.situation.start + durDivSpd
	
	      return this.step(true)
	    }
	
	    /**
	     * sets or returns the speed of the animations
	     * @param speed null || Number The new speed of the animations
	     * @return Number || this
	     */
	  , speed: function(speed){
	      if (speed === 0) return this.pause()
	
	      if (speed) {
	        this._speed = speed
	        // We use an absolute position here so that speed can affect the delay before the animation
	        return this.at(this.absPos, true)
	      } else return this._speed
	    }
	
	    // Make loopable
	  , loop: function(times, reverse) {
	      var c = this.last()
	
	      // store total loops
	      c.loops = (times != null) ? times : true
	      c.loop = 0
	
	      if(reverse) c.reversing = true
	      return this
	    }
	
	    // pauses the animation
	  , pause: function(){
	      this.paused = true
	      this.stopAnimFrame()
	
	      return this
	    }
	
	    // unpause the animation
	  , play: function(){
	      if(!this.paused) return this
	      this.paused = false
	      // We use an absolute position here so that the delay before the animation can be paused
	      return this.at(this.absPos, true)
	    }
	
	    /**
	     * toggle or set the direction of the animation
	     * true sets direction to backwards while false sets it to forwards
	     * @param reversed Boolean indicating whether to reverse the animation or not (default: toggle the reverse status)
	     * @return this
	     */
	  , reverse: function(reversed){
	      var c = this.last()
	
	      if(typeof reversed == 'undefined') c.reversed = !c.reversed
	      else c.reversed = reversed
	
	      return this
	    }
	
	
	    /**
	     * returns a float from 0-1 indicating the progress of the current animation
	     * @param eased Boolean indicating whether the returned position should be eased or not
	     * @return number
	     */
	  , progress: function(easeIt){
	      return easeIt ? this.situation.ease(this.pos) : this.pos
	    }
	
	    /**
	     * adds a callback function which is called when the current animation is finished
	     * @param fn Function which should be executed as callback
	     * @return number
	     */
	  , after: function(fn){
	      var c = this.last()
	        , wrapper = function wrapper(e){
	            if(e.detail.situation == c){
	              fn.call(this, c)
	              this.off('finished.fx', wrapper) // prevent memory leak
	            }
	          }
	
	      this.target().on('finished.fx', wrapper)
	
	      return this._callStart()
	    }
	
	    // adds a callback which is called whenever one animation step is performed
	  , during: function(fn){
	      var c = this.last()
	        , wrapper = function(e){
	            if(e.detail.situation == c){
	              fn.call(this, e.detail.pos, SVG.morph(e.detail.pos), e.detail.eased, c)
	            }
	          }
	
	      // see above
	      this.target().off('during.fx', wrapper).on('during.fx', wrapper)
	
	      this.after(function(){
	        this.off('during.fx', wrapper)
	      })
	
	      return this._callStart()
	    }
	
	    // calls after ALL animations in the queue are finished
	  , afterAll: function(fn){
	      var wrapper = function wrapper(e){
	            fn.call(this)
	            this.off('allfinished.fx', wrapper)
	          }
	
	      // see above
	      this.target().off('allfinished.fx', wrapper).on('allfinished.fx', wrapper)
	
	      return this._callStart()
	    }
	
	    // calls on every animation step for all animations
	  , duringAll: function(fn){
	      var wrapper = function(e){
	            fn.call(this, e.detail.pos, SVG.morph(e.detail.pos), e.detail.eased, e.detail.situation)
	          }
	
	      this.target().off('during.fx', wrapper).on('during.fx', wrapper)
	
	      this.afterAll(function(){
	        this.off('during.fx', wrapper)
	      })
	
	      return this._callStart()
	    }
	
	  , last: function(){
	      return this.situations.length ? this.situations[this.situations.length-1] : this.situation
	    }
	
	    // adds one property to the animations
	  , add: function(method, args, type){
	      this.last()[type || 'animations'][method] = args
	      return this._callStart()
	    }
	
	    /** perform one step of the animation
	     *  @param ignoreTime Boolean indicating whether to ignore time and use position directly or recalculate position based on time
	     *  @return this
	     */
	  , step: function(ignoreTime){
	
	      // convert current time to an absolute position
	      if(!ignoreTime) this.absPos = this.timeToAbsPos(+new Date)
	
	      // This part convert an absolute position to a position
	      if(this.situation.loops !== false) {
	        var absPos, absPosInt, lastLoop
	
	        // If the absolute position is below 0, we just treat it as if it was 0
	        absPos = Math.max(this.absPos, 0)
	        absPosInt = Math.floor(absPos)
	
	        if(this.situation.loops === true || absPosInt < this.situation.loops) {
	          this.pos = absPos - absPosInt
	          lastLoop = this.situation.loop
	          this.situation.loop = absPosInt
	        } else {
	          this.absPos = this.situation.loops
	          this.pos = 1
	          // The -1 here is because we don't want to toggle reversed when all the loops have been completed
	          lastLoop = this.situation.loop - 1
	          this.situation.loop = this.situation.loops
	        }
	
	        if(this.situation.reversing) {
	          // Toggle reversed if an odd number of loops as occured since the last call of step
	          this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - lastLoop) % 2)
	        }
	
	      } else {
	        // If there are no loop, the absolute position must not be above 1
	        this.absPos = Math.min(this.absPos, 1)
	        this.pos = this.absPos
	      }
	
	      // while the absolute position can be below 0, the position must not be below 0
	      if(this.pos < 0) this.pos = 0
	
	      if(this.situation.reversed) this.pos = 1 - this.pos
	
	
	      // apply easing
	      var eased = this.situation.ease(this.pos)
	
	      // call once-callbacks
	      for(var i in this.situation.once){
	        if(i > this.lastPos && i <= eased){
	          this.situation.once[i].call(this.target(), this.pos, eased)
	          delete this.situation.once[i]
	        }
	      }
	
	      // fire during callback with position, eased position and current situation as parameter
	      if(this.active) this.target().fire('during', {pos: this.pos, eased: eased, fx: this, situation: this.situation})
	
	      // the user may call stop or finish in the during callback
	      // so make sure that we still have a valid situation
	      if(!this.situation){
	        return this
	      }
	
	      // apply the actual animation to every property
	      this.eachAt()
	
	      // do final code when situation is finished
	      if((this.pos == 1 && !this.situation.reversed) || (this.situation.reversed && this.pos == 0)){
	
	        // stop animation callback
	        this.stopAnimFrame()
	
	        // fire finished callback with current situation as parameter
	        this.target().fire('finished', {fx:this, situation: this.situation})
	
	        if(!this.situations.length){
	          this.target().fire('allfinished')
	
	          // Recheck the length since the user may call animate in the afterAll callback
	          if(!this.situations.length){
	            this.target().off('.fx') // there shouldnt be any binding left, but to make sure...
	            this.active = false
	          }
	        }
	
	        // start next animation
	        if(this.active) this.dequeue()
	        else this.clearCurrent()
	
	      }else if(!this.paused && this.active){
	        // we continue animating when we are not at the end
	        this.startAnimFrame()
	      }
	
	      // save last eased position for once callback triggering
	      this.lastPos = eased
	      return this
	
	    }
	
	    // calculates the step for every property and calls block with it
	  , eachAt: function(){
	      var i, len, at, self = this, target = this.target(), s = this.situation
	
	      // apply animations which can be called trough a method
	      for(i in s.animations){
	
	        at = [].concat(s.animations[i]).map(function(el){
	          return typeof el !== 'string' && el.at ? el.at(s.ease(self.pos), self.pos) : el
	        })
	
	        target[i].apply(target, at)
	
	      }
	
	      // apply animation which has to be applied with attr()
	      for(i in s.attrs){
	
	        at = [i].concat(s.attrs[i]).map(function(el){
	          return typeof el !== 'string' && el.at ? el.at(s.ease(self.pos), self.pos) : el
	        })
	
	        target.attr.apply(target, at)
	
	      }
	
	      // apply animation which has to be applied with style()
	      for(i in s.styles){
	
	        at = [i].concat(s.styles[i]).map(function(el){
	          return typeof el !== 'string' && el.at ? el.at(s.ease(self.pos), self.pos) : el
	        })
	
	        target.style.apply(target, at)
	
	      }
	
	      // animate initialTransformation which has to be chained
	      if(s.transforms.length){
	
	        // get initial initialTransformation
	        at = s.initialTransformation
	        for(i = 0, len = s.transforms.length; i < len; i++){
	
	          // get next transformation in chain
	          var a = s.transforms[i]
	
	          // multiply matrix directly
	          if(a instanceof SVG.Matrix){
	
	            if(a.relative){
	              at = at.multiply(new SVG.Matrix().morph(a).at(s.ease(this.pos)))
	            }else{
	              at = at.morph(a).at(s.ease(this.pos))
	            }
	            continue
	          }
	
	          // when transformation is absolute we have to reset the needed transformation first
	          if(!a.relative)
	            a.undo(at.extract())
	
	          // and reapply it after
	          at = at.multiply(a.at(s.ease(this.pos)))
	
	        }
	
	        // set new matrix on element
	        target.matrix(at)
	      }
	
	      return this
	
	    }
	
	
	    // adds an once-callback which is called at a specific position and never again
	  , once: function(pos, fn, isEased){
	      var c = this.last()
	      if(!isEased) pos = c.ease(pos)
	
	      c.once[pos] = fn
	
	      return this
	    }
	
	  , _callStart: function() {
	      setTimeout(function(){this.start()}.bind(this), 0)
	      return this
	    }
	
	  }
	
	, parent: SVG.Element
	
	  // Add method to parent elements
	, construct: {
	    // Get fx module or create a new one, then animate with given duration and ease
	    animate: function(o, ease, delay) {
	      return (this.fx || (this.fx = new SVG.FX(this))).animate(o, ease, delay)
	    }
	  , delay: function(delay){
	      return (this.fx || (this.fx = new SVG.FX(this))).delay(delay)
	    }
	  , stop: function(jumpToEnd, clearQueue) {
	      if (this.fx)
	        this.fx.stop(jumpToEnd, clearQueue)
	
	      return this
	    }
	  , finish: function() {
	      if (this.fx)
	        this.fx.finish()
	
	      return this
	    }
	    // Pause current animation
	  , pause: function() {
	      if (this.fx)
	        this.fx.pause()
	
	      return this
	    }
	    // Play paused current animation
	  , play: function() {
	      if (this.fx)
	        this.fx.play()
	
	      return this
	    }
	    // Set/Get the speed of the animations
	  , speed: function(speed) {
	      if (this.fx)
	        if (speed == null)
	          return this.fx.speed()
	        else
	          this.fx.speed(speed)
	
	      return this
	    }
	  }
	
	})
	
	// MorphObj is used whenever no morphable object is given
	SVG.MorphObj = SVG.invent({
	
	  create: function(from, to){
	    // prepare color for morphing
	    if(SVG.Color.isColor(to)) return new SVG.Color(from).morph(to)
	    // prepare value list for morphing
	    if(SVG.regex.delimiter.test(from)) return new SVG.Array(from).morph(to)
	    // prepare number for morphing
	    if(SVG.regex.numberAndUnit.test(to)) return new SVG.Number(from).morph(to)
	
	    // prepare for plain morphing
	    this.value = from
	    this.destination = to
	  }
	
	, extend: {
	    at: function(pos, real){
	      return real < 1 ? this.value : this.destination
	    },
	
	    valueOf: function(){
	      return this.value
	    }
	  }
	
	})
	
	SVG.extend(SVG.FX, {
	  // Add animatable attributes
	  attr: function(a, v, relative) {
	    // apply attributes individually
	    if (typeof a == 'object') {
	      for (var key in a)
	        this.attr(key, a[key])
	
	    } else {
	      this.add(a, v, 'attrs')
	    }
	
	    return this
	  }
	  // Add animatable styles
	, style: function(s, v) {
	    if (typeof s == 'object')
	      for (var key in s)
	        this.style(key, s[key])
	
	    else
	      this.add(s, v, 'styles')
	
	    return this
	  }
	  // Animatable x-axis
	, x: function(x, relative) {
	    if(this.target() instanceof SVG.G){
	      this.transform({x:x}, relative)
	      return this
	    }
	
	    var num = new SVG.Number(x)
	    num.relative = relative
	    return this.add('x', num)
	  }
	  // Animatable y-axis
	, y: function(y, relative) {
	    if(this.target() instanceof SVG.G){
	      this.transform({y:y}, relative)
	      return this
	    }
	
	    var num = new SVG.Number(y)
	    num.relative = relative
	    return this.add('y', num)
	  }
	  // Animatable center x-axis
	, cx: function(x) {
	    return this.add('cx', new SVG.Number(x))
	  }
	  // Animatable center y-axis
	, cy: function(y) {
	    return this.add('cy', new SVG.Number(y))
	  }
	  // Add animatable move
	, move: function(x, y) {
	    return this.x(x).y(y)
	  }
	  // Add animatable center
	, center: function(x, y) {
	    return this.cx(x).cy(y)
	  }
	  // Add animatable size
	, size: function(width, height) {
	    if (this.target() instanceof SVG.Text) {
	      // animate font size for Text elements
	      this.attr('font-size', width)
	
	    } else {
	      // animate bbox based size for all other elements
	      var box
	
	      if(!width || !height){
	        box = this.target().bbox()
	      }
	
	      if(!width){
	        width = box.width / box.height  * height
	      }
	
	      if(!height){
	        height = box.height / box.width  * width
	      }
	
	      this.add('width' , new SVG.Number(width))
	          .add('height', new SVG.Number(height))
	
	    }
	
	    return this
	  }
	  // Add animatable width
	, width: function(width) {
	    return this.add('width', new SVG.Number(width))
	  }
	  // Add animatable height
	, height: function(height) {
	    return this.add('height', new SVG.Number(height))
	  }
	  // Add animatable plot
	, plot: function(a, b, c, d) {
	    // Lines can be plotted with 4 arguments
	    if(arguments.length == 4) {
	      return this.plot([a, b, c, d])
	    }
	
	    return this.add('plot', new (this.target().morphArray)(a))
	  }
	  // Add leading method
	, leading: function(value) {
	    return this.target().leading ?
	      this.add('leading', new SVG.Number(value)) :
	      this
	  }
	  // Add animatable viewbox
	, viewbox: function(x, y, width, height) {
	    if (this.target() instanceof SVG.Container) {
	      this.add('viewbox', new SVG.ViewBox(x, y, width, height))
	    }
	
	    return this
	  }
	, update: function(o) {
	    if (this.target() instanceof SVG.Stop) {
	      if (typeof o == 'number' || o instanceof SVG.Number) {
	        return this.update({
	          offset:  arguments[0]
	        , color:   arguments[1]
	        , opacity: arguments[2]
	        })
	      }
	
	      if (o.opacity != null) this.attr('stop-opacity', o.opacity)
	      if (o.color   != null) this.attr('stop-color', o.color)
	      if (o.offset  != null) this.attr('offset', o.offset)
	    }
	
	    return this
	  }
	})
	
	SVG.Box = SVG.invent({
	  create: function(x, y, width, height) {
	    if (typeof x == 'object' && !(x instanceof SVG.Element)) {
	      // chromes getBoundingClientRect has no x and y property
	      return SVG.Box.call(this, x.left != null ? x.left : x.x , x.top != null ? x.top : x.y, x.width, x.height)
	    } else if (arguments.length == 4) {
	      this.x = x
	      this.y = y
	      this.width = width
	      this.height = height
	    }
	
	    // add center, right, bottom...
	    fullBox(this)
	  }
	, extend: {
	    // Merge rect box with another, return a new instance
	    merge: function(box) {
	      var b = new this.constructor()
	
	      // merge boxes
	      b.x      = Math.min(this.x, box.x)
	      b.y      = Math.min(this.y, box.y)
	      b.width  = Math.max(this.x + this.width,  box.x + box.width)  - b.x
	      b.height = Math.max(this.y + this.height, box.y + box.height) - b.y
	
	      return fullBox(b)
	    }
	
	  , transform: function(m) {
	      var xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, p, bbox
	
	      var pts = [
	        new SVG.Point(this.x, this.y),
	        new SVG.Point(this.x2, this.y),
	        new SVG.Point(this.x, this.y2),
	        new SVG.Point(this.x2, this.y2)
	      ]
	
	      pts.forEach(function(p) {
	        p = p.transform(m)
	        xMin = Math.min(xMin,p.x)
	        xMax = Math.max(xMax,p.x)
	        yMin = Math.min(yMin,p.y)
	        yMax = Math.max(yMax,p.y)
	      })
	
	      bbox = new this.constructor()
	      bbox.x = xMin
	      bbox.width = xMax-xMin
	      bbox.y = yMin
	      bbox.height = yMax-yMin
	
	      fullBox(bbox)
	
	      return bbox
	    }
	  }
	})
	
	SVG.BBox = SVG.invent({
	  // Initialize
	  create: function(element) {
	    SVG.Box.apply(this, [].slice.call(arguments))
	
	    // get values if element is given
	    if (element instanceof SVG.Element) {
	      var box
	
	      // yes this is ugly, but Firefox can be a pain when it comes to elements that are not yet rendered
	      try {
	
	        if (!document.documentElement.contains){
	          // This is IE - it does not support contains() for top-level SVGs
	          var topParent = element.node
	          while (topParent.parentNode){
	            topParent = topParent.parentNode
	          }
	          if (topParent != document) throw new Exception('Element not in the dom')
	        } else {
	          // the element is NOT in the dom, throw error
	          if(!document.documentElement.contains(element.node)) throw new Exception('Element not in the dom')
	        }
	
	        // find native bbox
	        box = element.node.getBBox()
	      } catch(e) {
	        if(element instanceof SVG.Shape){
	          var clone = element.clone(SVG.parser.draw.instance).show()
	          box = clone.node.getBBox()
	          clone.remove()
	        }else{
	          box = {
	            x:      element.node.clientLeft
	          , y:      element.node.clientTop
	          , width:  element.node.clientWidth
	          , height: element.node.clientHeight
	          }
	        }
	      }
	
	      SVG.Box.call(this, box)
	    }
	
	  }
	
	  // Define ancestor
	, inherit: SVG.Box
	
	  // Define Parent
	, parent: SVG.Element
	
	  // Constructor
	, construct: {
	    // Get bounding box
	    bbox: function() {
	      return new SVG.BBox(this)
	    }
	  }
	
	})
	
	SVG.BBox.prototype.constructor = SVG.BBox
	
	
	SVG.extend(SVG.Element, {
	  tbox: function(){
	    console.warn('Use of TBox is deprecated and mapped to RBox. Use .rbox() instead.')
	    return this.rbox(this.doc())
	  }
	})
	
	SVG.RBox = SVG.invent({
	  // Initialize
	  create: function(element) {
	    SVG.Box.apply(this, [].slice.call(arguments))
	
	    if (element instanceof SVG.Element) {
	      SVG.Box.call(this, element.node.getBoundingClientRect())
	    }
	  }
	
	, inherit: SVG.Box
	
	  // define Parent
	, parent: SVG.Element
	
	, extend: {
	    addOffset: function() {
	      // offset by window scroll position, because getBoundingClientRect changes when window is scrolled
	      this.x += window.pageXOffset
	      this.y += window.pageYOffset
	      return this
	    }
	  }
	
	  // Constructor
	, construct: {
	    // Get rect box
	    rbox: function(el) {
	      if (el) return new SVG.RBox(this).transform(el.screenCTM().inverse())
	      return new SVG.RBox(this).addOffset()
	    }
	  }
	
	})
	
	SVG.RBox.prototype.constructor = SVG.RBox
	
	SVG.Matrix = SVG.invent({
	  // Initialize
	  create: function(source) {
	    var i, base = arrayToMatrix([1, 0, 0, 1, 0, 0])
	
	    // ensure source as object
	    source = source instanceof SVG.Element ?
	      source.matrixify() :
	    typeof source === 'string' ?
	      arrayToMatrix(source.split(SVG.regex.delimiter).map(parseFloat)) :
	    arguments.length == 6 ?
	      arrayToMatrix([].slice.call(arguments)) :
	    Array.isArray(source) ?
	      arrayToMatrix(source) :
	    typeof source === 'object' ?
	      source : base
	
	    // merge source
	    for (i = abcdef.length - 1; i >= 0; --i)
	      this[abcdef[i]] = source[abcdef[i]] != null ?
	        source[abcdef[i]] : base[abcdef[i]]
	  }
	
	  // Add methods
	, extend: {
	    // Extract individual transformations
	    extract: function() {
	      // find delta transform points
	      var px    = deltaTransformPoint(this, 0, 1)
	        , py    = deltaTransformPoint(this, 1, 0)
	        , skewX = 180 / Math.PI * Math.atan2(px.y, px.x) - 90
	
	      return {
	        // translation
	        x:        this.e
	      , y:        this.f
	      , transformedX:(this.e * Math.cos(skewX * Math.PI / 180) + this.f * Math.sin(skewX * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b)
	      , transformedY:(this.f * Math.cos(skewX * Math.PI / 180) + this.e * Math.sin(-skewX * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d)
	        // skew
	      , skewX:    -skewX
	      , skewY:    180 / Math.PI * Math.atan2(py.y, py.x)
	        // scale
	      , scaleX:   Math.sqrt(this.a * this.a + this.b * this.b)
	      , scaleY:   Math.sqrt(this.c * this.c + this.d * this.d)
	        // rotation
	      , rotation: skewX
	      , a: this.a
	      , b: this.b
	      , c: this.c
	      , d: this.d
	      , e: this.e
	      , f: this.f
	      , matrix: new SVG.Matrix(this)
	      }
	    }
	    // Clone matrix
	  , clone: function() {
	      return new SVG.Matrix(this)
	    }
	    // Morph one matrix into another
	  , morph: function(matrix) {
	      // store new destination
	      this.destination = new SVG.Matrix(matrix)
	
	      return this
	    }
	    // Get morphed matrix at a given position
	  , at: function(pos) {
	      // make sure a destination is defined
	      if (!this.destination) return this
	
	      // calculate morphed matrix at a given position
	      var matrix = new SVG.Matrix({
	        a: this.a + (this.destination.a - this.a) * pos
	      , b: this.b + (this.destination.b - this.b) * pos
	      , c: this.c + (this.destination.c - this.c) * pos
	      , d: this.d + (this.destination.d - this.d) * pos
	      , e: this.e + (this.destination.e - this.e) * pos
	      , f: this.f + (this.destination.f - this.f) * pos
	      })
	
	      return matrix
	    }
	    // Multiplies by given matrix
	  , multiply: function(matrix) {
	      return new SVG.Matrix(this.native().multiply(parseMatrix(matrix).native()))
	    }
	    // Inverses matrix
	  , inverse: function() {
	      return new SVG.Matrix(this.native().inverse())
	    }
	    // Translate matrix
	  , translate: function(x, y) {
	      return new SVG.Matrix(this.native().translate(x || 0, y || 0))
	    }
	    // Scale matrix
	  , scale: function(x, y, cx, cy) {
	      // support uniformal scale
	      if (arguments.length == 1) {
	        y = x
	      } else if (arguments.length == 3) {
	        cy = cx
	        cx = y
	        y = x
	      }
	
	      return this.around(cx, cy, new SVG.Matrix(x, 0, 0, y, 0, 0))
	    }
	    // Rotate matrix
	  , rotate: function(r, cx, cy) {
	      // convert degrees to radians
	      r = SVG.utils.radians(r)
	
	      return this.around(cx, cy, new SVG.Matrix(Math.cos(r), Math.sin(r), -Math.sin(r), Math.cos(r), 0, 0))
	    }
	    // Flip matrix on x or y, at a given offset
	  , flip: function(a, o) {
	      return a == 'x' ?
	          this.scale(-1, 1, o, 0) :
	        a == 'y' ?
	          this.scale(1, -1, 0, o) :
	          this.scale(-1, -1, a, o != null ? o : a)
	    }
	    // Skew
	  , skew: function(x, y, cx, cy) {
	      // support uniformal skew
	      if (arguments.length == 1) {
	        y = x
	      } else if (arguments.length == 3) {
	        cy = cx
	        cx = y
	        y = x
	      }
	
	      // convert degrees to radians
	      x = SVG.utils.radians(x)
	      y = SVG.utils.radians(y)
	
	      return this.around(cx, cy, new SVG.Matrix(1, Math.tan(y), Math.tan(x), 1, 0, 0))
	    }
	    // SkewX
	  , skewX: function(x, cx, cy) {
	      return this.skew(x, 0, cx, cy)
	    }
	    // SkewY
	  , skewY: function(y, cx, cy) {
	      return this.skew(0, y, cx, cy)
	    }
	    // Transform around a center point
	  , around: function(cx, cy, matrix) {
	      return this
	        .multiply(new SVG.Matrix(1, 0, 0, 1, cx || 0, cy || 0))
	        .multiply(matrix)
	        .multiply(new SVG.Matrix(1, 0, 0, 1, -cx || 0, -cy || 0))
	    }
	    // Convert to native SVGMatrix
	  , native: function() {
	      // create new matrix
	      var matrix = SVG.parser.native.createSVGMatrix()
	
	      // update with current values
	      for (var i = abcdef.length - 1; i >= 0; i--)
	        matrix[abcdef[i]] = this[abcdef[i]]
	
	      return matrix
	    }
	    // Convert matrix to string
	  , toString: function() {
	      return 'matrix(' + this.a + ',' + this.b + ',' + this.c + ',' + this.d + ',' + this.e + ',' + this.f + ')'
	    }
	  }
	
	  // Define parent
	, parent: SVG.Element
	
	  // Add parent method
	, construct: {
	    // Get current matrix
	    ctm: function() {
	      return new SVG.Matrix(this.node.getCTM())
	    },
	    // Get current screen matrix
	    screenCTM: function() {
	      /* https://bugzilla.mozilla.org/show_bug.cgi?id=1344537
	         This is needed because FF does not return the transformation matrix
	         for the inner coordinate system when getScreenCTM() is called on nested svgs.
	         However all other Browsers do that */
	      if(this instanceof SVG.Nested) {
	        var rect = this.rect(1,1)
	        var m = rect.node.getScreenCTM()
	        rect.remove()
	        return new SVG.Matrix(m)
	      }
	      return new SVG.Matrix(this.node.getScreenCTM())
	    }
	
	  }
	
	})
	
	SVG.Point = SVG.invent({
	  // Initialize
	  create: function(x,y) {
	    var i, source, base = {x:0, y:0}
	
	    // ensure source as object
	    source = Array.isArray(x) ?
	      {x:x[0], y:x[1]} :
	    typeof x === 'object' ?
	      {x:x.x, y:x.y} :
	    x != null ?
	      {x:x, y:(y != null ? y : x)} : base // If y has no value, then x is used has its value
	
	    // merge source
	    this.x = source.x
	    this.y = source.y
	  }
	
	  // Add methods
	, extend: {
	    // Clone point
	    clone: function() {
	      return new SVG.Point(this)
	    }
	    // Morph one point into another
	  , morph: function(x, y) {
	      // store new destination
	      this.destination = new SVG.Point(x, y)
	
	      return this
	    }
	    // Get morphed point at a given position
	  , at: function(pos) {
	      // make sure a destination is defined
	      if (!this.destination) return this
	
	      // calculate morphed matrix at a given position
	      var point = new SVG.Point({
	        x: this.x + (this.destination.x - this.x) * pos
	      , y: this.y + (this.destination.y - this.y) * pos
	      })
	
	      return point
	    }
	    // Convert to native SVGPoint
	  , native: function() {
	      // create new point
	      var point = SVG.parser.native.createSVGPoint()
	
	      // update with current values
	      point.x = this.x
	      point.y = this.y
	
	      return point
	    }
	    // transform point with matrix
	  , transform: function(matrix) {
	      return new SVG.Point(this.native().matrixTransform(matrix.native()))
	    }
	
	  }
	
	})
	
	SVG.extend(SVG.Element, {
	
	  // Get point
	  point: function(x, y) {
	    return new SVG.Point(x,y).transform(this.screenCTM().inverse());
	  }
	
	})
	
	SVG.extend(SVG.Element, {
	  // Set svg element attribute
	  attr: function(a, v, n) {
	    // act as full getter
	    if (a == null) {
	      // get an object of attributes
	      a = {}
	      v = this.node.attributes
	      for (n = v.length - 1; n >= 0; n--)
	        a[v[n].nodeName] = SVG.regex.isNumber.test(v[n].nodeValue) ? parseFloat(v[n].nodeValue) : v[n].nodeValue
	
	      return a
	
	    } else if (typeof a == 'object') {
	      // apply every attribute individually if an object is passed
	      for (v in a) this.attr(v, a[v])
	
	    } else if (v === null) {
	        // remove value
	        this.node.removeAttribute(a)
	
	    } else if (v == null) {
	      // act as a getter if the first and only argument is not an object
	      v = this.node.getAttribute(a)
	      return v == null ?
	        SVG.defaults.attrs[a] :
	      SVG.regex.isNumber.test(v) ?
	        parseFloat(v) : v
	
	    } else {
	      // BUG FIX: some browsers will render a stroke if a color is given even though stroke width is 0
	      if (a == 'stroke-width')
	        this.attr('stroke', parseFloat(v) > 0 ? this._stroke : null)
	      else if (a == 'stroke')
	        this._stroke = v
	
	      // convert image fill and stroke to patterns
	      if (a == 'fill' || a == 'stroke') {
	        if (SVG.regex.isImage.test(v))
	          v = this.doc().defs().image(v, 0, 0)
	
	        if (v instanceof SVG.Image)
	          v = this.doc().defs().pattern(0, 0, function() {
	            this.add(v)
	          })
	      }
	
	      // ensure correct numeric values (also accepts NaN and Infinity)
	      if (typeof v === 'number')
	        v = new SVG.Number(v)
	
	      // ensure full hex color
	      else if (SVG.Color.isColor(v))
	        v = new SVG.Color(v)
	
	      // parse array values
	      else if (Array.isArray(v))
	        v = new SVG.Array(v)
	
	      // if the passed attribute is leading...
	      if (a == 'leading') {
	        // ... call the leading method instead
	        if (this.leading)
	          this.leading(v)
	      } else {
	        // set given attribute on node
	        typeof n === 'string' ?
	          this.node.setAttributeNS(n, a, v.toString()) :
	          this.node.setAttribute(a, v.toString())
	      }
	
	      // rebuild if required
	      if (this.rebuild && (a == 'font-size' || a == 'x'))
	        this.rebuild(a, v)
	    }
	
	    return this
	  }
	})
	SVG.extend(SVG.Element, {
	  // Add transformations
	  transform: function(o, relative) {
	    // get target in case of the fx module, otherwise reference this
	    var target = this
	      , matrix, bbox
	
	    // act as a getter
	    if (typeof o !== 'object') {
	      // get current matrix
	      matrix = new SVG.Matrix(target).extract()
	
	      return typeof o === 'string' ? matrix[o] : matrix
	    }
	
	    // get current matrix
	    matrix = new SVG.Matrix(target)
	
	    // ensure relative flag
	    relative = !!relative || !!o.relative
	
	    // act on matrix
	    if (o.a != null) {
	      matrix = relative ?
	        // relative
	        matrix.multiply(new SVG.Matrix(o)) :
	        // absolute
	        new SVG.Matrix(o)
	
	    // act on rotation
	    } else if (o.rotation != null) {
	      // ensure centre point
	      ensureCentre(o, target)
	
	      // apply transformation
	      matrix = relative ?
	        // relative
	        matrix.rotate(o.rotation, o.cx, o.cy) :
	        // absolute
	        matrix.rotate(o.rotation - matrix.extract().rotation, o.cx, o.cy)
	
	    // act on scale
	    } else if (o.scale != null || o.scaleX != null || o.scaleY != null) {
	      // ensure centre point
	      ensureCentre(o, target)
	
	      // ensure scale values on both axes
	      o.scaleX = o.scale != null ? o.scale : o.scaleX != null ? o.scaleX : 1
	      o.scaleY = o.scale != null ? o.scale : o.scaleY != null ? o.scaleY : 1
	
	      if (!relative) {
	        // absolute; multiply inversed values
	        var e = matrix.extract()
	        o.scaleX = o.scaleX * 1 / e.scaleX
	        o.scaleY = o.scaleY * 1 / e.scaleY
	      }
	
	      matrix = matrix.scale(o.scaleX, o.scaleY, o.cx, o.cy)
	
	    // act on skew
	    } else if (o.skew != null || o.skewX != null || o.skewY != null) {
	      // ensure centre point
	      ensureCentre(o, target)
	
	      // ensure skew values on both axes
	      o.skewX = o.skew != null ? o.skew : o.skewX != null ? o.skewX : 0
	      o.skewY = o.skew != null ? o.skew : o.skewY != null ? o.skewY : 0
	
	      if (!relative) {
	        // absolute; reset skew values
	        var e = matrix.extract()
	        matrix = matrix.multiply(new SVG.Matrix().skew(e.skewX, e.skewY, o.cx, o.cy).inverse())
	      }
	
	      matrix = matrix.skew(o.skewX, o.skewY, o.cx, o.cy)
	
	    // act on flip
	    } else if (o.flip) {
	      if(o.flip == 'x' || o.flip == 'y') {
	        o.offset = o.offset == null ? target.bbox()['c' + o.flip] : o.offset
	      } else {
	        if(o.offset == null) {
	          bbox = target.bbox()
	          o.flip = bbox.cx
	          o.offset = bbox.cy
	        } else {
	          o.flip = o.offset
	        }
	      }
	
	      matrix = new SVG.Matrix().flip(o.flip, o.offset)
	
	    // act on translate
	    } else if (o.x != null || o.y != null) {
	      if (relative) {
	        // relative
	        matrix = matrix.translate(o.x, o.y)
	      } else {
	        // absolute
	        if (o.x != null) matrix.e = o.x
	        if (o.y != null) matrix.f = o.y
	      }
	    }
	
	    return this.attr('transform', matrix)
	  }
	})
	
	SVG.extend(SVG.FX, {
	  transform: function(o, relative) {
	    // get target in case of the fx module, otherwise reference this
	    var target = this.target()
	      , matrix, bbox
	
	    // act as a getter
	    if (typeof o !== 'object') {
	      // get current matrix
	      matrix = new SVG.Matrix(target).extract()
	
	      return typeof o === 'string' ? matrix[o] : matrix
	    }
	
	    // ensure relative flag
	    relative = !!relative || !!o.relative
	
	    // act on matrix
	    if (o.a != null) {
	      matrix = new SVG.Matrix(o)
	
	    // act on rotation
	    } else if (o.rotation != null) {
	      // ensure centre point
	      ensureCentre(o, target)
	
	      // apply transformation
	      matrix = new SVG.Rotate(o.rotation, o.cx, o.cy)
	
	    // act on scale
	    } else if (o.scale != null || o.scaleX != null || o.scaleY != null) {
	      // ensure centre point
	      ensureCentre(o, target)
	
	      // ensure scale values on both axes
	      o.scaleX = o.scale != null ? o.scale : o.scaleX != null ? o.scaleX : 1
	      o.scaleY = o.scale != null ? o.scale : o.scaleY != null ? o.scaleY : 1
	
	      matrix = new SVG.Scale(o.scaleX, o.scaleY, o.cx, o.cy)
	
	    // act on skew
	    } else if (o.skewX != null || o.skewY != null) {
	      // ensure centre point
	      ensureCentre(o, target)
	
	      // ensure skew values on both axes
	      o.skewX = o.skewX != null ? o.skewX : 0
	      o.skewY = o.skewY != null ? o.skewY : 0
	
	      matrix = new SVG.Skew(o.skewX, o.skewY, o.cx, o.cy)
	
	    // act on flip
	    } else if (o.flip) {
	      if(o.flip == 'x' || o.flip == 'y') {
	        o.offset = o.offset == null ? target.bbox()['c' + o.flip] : o.offset
	      } else {
	        if(o.offset == null) {
	          bbox = target.bbox()
	          o.flip = bbox.cx
	          o.offset = bbox.cy
	        } else {
	          o.flip = o.offset
	        }
	      }
	
	      matrix = new SVG.Matrix().flip(o.flip, o.offset)
	
	    // act on translate
	    } else if (o.x != null || o.y != null) {
	      matrix = new SVG.Translate(o.x, o.y)
	    }
	
	    if(!matrix) return this
	
	    matrix.relative = relative
	
	    this.last().transforms.push(matrix)
	
	    return this._callStart()
	  }
	})
	
	SVG.extend(SVG.Element, {
	  // Reset all transformations
	  untransform: function() {
	    return this.attr('transform', null)
	  },
	  // merge the whole transformation chain into one matrix and returns it
	  matrixify: function() {
	
	    var matrix = (this.attr('transform') || '')
	      // split transformations
	      .split(SVG.regex.transforms).slice(0,-1).map(function(str){
	        // generate key => value pairs
	        var kv = str.trim().split('(')
	        return [kv[0], kv[1].split(SVG.regex.delimiter).map(function(str){ return parseFloat(str) })]
	      })
	      // merge every transformation into one matrix
	      .reduce(function(matrix, transform){
	
	        if(transform[0] == 'matrix') return matrix.multiply(arrayToMatrix(transform[1]))
	        return matrix[transform[0]].apply(matrix, transform[1])
	
	      }, new SVG.Matrix())
	
	    return matrix
	  },
	  // add an element to another parent without changing the visual representation on the screen
	  toParent: function(parent) {
	    if(this == parent) return this
	    var ctm = this.screenCTM()
	    var pCtm = parent.screenCTM().inverse()
	
	    this.addTo(parent).untransform().transform(pCtm.multiply(ctm))
	
	    return this
	  },
	  // same as above with parent equals root-svg
	  toDoc: function() {
	    return this.toParent(this.doc())
	  }
	
	})
	
	SVG.Transformation = SVG.invent({
	
	  create: function(source, inversed){
	
	    if(arguments.length > 1 && typeof inversed != 'boolean'){
	      return this.constructor.call(this, [].slice.call(arguments))
	    }
	
	    if(Array.isArray(source)){
	      for(var i = 0, len = this.arguments.length; i < len; ++i){
	        this[this.arguments[i]] = source[i]
	      }
	    } else if(typeof source == 'object'){
	      for(var i = 0, len = this.arguments.length; i < len; ++i){
	        this[this.arguments[i]] = source[this.arguments[i]]
	      }
	    }
	
	    this.inversed = false
	
	    if(inversed === true){
	      this.inversed = true
	    }
	
	  }
	
	, extend: {
	
	    arguments: []
	  , method: ''
	
	  , at: function(pos){
	
	      var params = []
	
	      for(var i = 0, len = this.arguments.length; i < len; ++i){
	        params.push(this[this.arguments[i]])
	      }
	
	      var m = this._undo || new SVG.Matrix()
	
	      m = new SVG.Matrix().morph(SVG.Matrix.prototype[this.method].apply(m, params)).at(pos)
	
	      return this.inversed ? m.inverse() : m
	
	    }
	
	  , undo: function(o){
	      for(var i = 0, len = this.arguments.length; i < len; ++i){
	        o[this.arguments[i]] = typeof this[this.arguments[i]] == 'undefined' ? 0 : o[this.arguments[i]]
	      }
	
	      // The method SVG.Matrix.extract which was used before calling this
	      // method to obtain a value for the parameter o doesn't return a cx and
	      // a cy so we use the ones that were provided to this object at its creation
	      o.cx = this.cx
	      o.cy = this.cy
	
	      this._undo = new SVG[capitalize(this.method)](o, true).at(1)
	
	      return this
	    }
	
	  }
	
	})
	
	SVG.Translate = SVG.invent({
	
	  parent: SVG.Matrix
	, inherit: SVG.Transformation
	
	, create: function(source, inversed){
	    this.constructor.apply(this, [].slice.call(arguments))
	  }
	
	, extend: {
	    arguments: ['transformedX', 'transformedY']
	  , method: 'translate'
	  }
	
	})
	
	SVG.Rotate = SVG.invent({
	
	  parent: SVG.Matrix
	, inherit: SVG.Transformation
	
	, create: function(source, inversed){
	    this.constructor.apply(this, [].slice.call(arguments))
	  }
	
	, extend: {
	    arguments: ['rotation', 'cx', 'cy']
	  , method: 'rotate'
	  , at: function(pos){
	      var m = new SVG.Matrix().rotate(new SVG.Number().morph(this.rotation - (this._undo ? this._undo.rotation : 0)).at(pos), this.cx, this.cy)
	      return this.inversed ? m.inverse() : m
	    }
	  , undo: function(o){
	      this._undo = o
	      return this
	    }
	  }
	
	})
	
	SVG.Scale = SVG.invent({
	
	  parent: SVG.Matrix
	, inherit: SVG.Transformation
	
	, create: function(source, inversed){
	    this.constructor.apply(this, [].slice.call(arguments))
	  }
	
	, extend: {
	    arguments: ['scaleX', 'scaleY', 'cx', 'cy']
	  , method: 'scale'
	  }
	
	})
	
	SVG.Skew = SVG.invent({
	
	  parent: SVG.Matrix
	, inherit: SVG.Transformation
	
	, create: function(source, inversed){
	    this.constructor.apply(this, [].slice.call(arguments))
	  }
	
	, extend: {
	    arguments: ['skewX', 'skewY', 'cx', 'cy']
	  , method: 'skew'
	  }
	
	})
	
	SVG.extend(SVG.Element, {
	  // Dynamic style generator
	  style: function(s, v) {
	    if (arguments.length == 0) {
	      // get full style
	      return this.node.style.cssText || ''
	
	    } else if (arguments.length < 2) {
	      // apply every style individually if an object is passed
	      if (typeof s == 'object') {
	        for (v in s) this.style(v, s[v])
	
	      } else if (SVG.regex.isCss.test(s)) {
	        // parse css string
	        s = s.split(/\s*;\s*/)
	          // filter out suffix ; and stuff like ;;
	          .filter(function(e) { return !!e })
	          .map(function(e){ return e.split(/\s*:\s*/) })
	
	        // apply every definition individually
	        while (v = s.pop()) {
	          this.style(v[0], v[1])
	        }
	      } else {
	        // act as a getter if the first and only argument is not an object
	        return this.node.style[camelCase(s)]
	      }
	
	    } else {
	      this.node.style[camelCase(s)] = v === null || SVG.regex.isBlank.test(v) ? '' : v
	    }
	
	    return this
	  }
	})
	SVG.Parent = SVG.invent({
	  // Initialize node
	  create: function(element) {
	    this.constructor.call(this, element)
	  }
	
	  // Inherit from
	, inherit: SVG.Element
	
	  // Add class methods
	, extend: {
	    // Returns all child elements
	    children: function() {
	      return SVG.utils.map(SVG.utils.filterSVGElements(this.node.childNodes), function(node) {
	        return SVG.adopt(node)
	      })
	    }
	    // Add given element at a position
	  , add: function(element, i) {
	      if (i == null)
	        this.node.appendChild(element.node)
	      else if (element.node != this.node.childNodes[i])
	        this.node.insertBefore(element.node, this.node.childNodes[i])
	
	      return this
	    }
	    // Basically does the same as `add()` but returns the added element instead
	  , put: function(element, i) {
	      this.add(element, i)
	      return element
	    }
	    // Checks if the given element is a child
	  , has: function(element) {
	      return this.index(element) >= 0
	    }
	    // Gets index of given element
	  , index: function(element) {
	      return [].slice.call(this.node.childNodes).indexOf(element.node)
	    }
	    // Get a element at the given index
	  , get: function(i) {
	      return SVG.adopt(this.node.childNodes[i])
	    }
	    // Get first child
	  , first: function() {
	      return this.get(0)
	    }
	    // Get the last child
	  , last: function() {
	      return this.get(this.node.childNodes.length - 1)
	    }
	    // Iterates over all children and invokes a given block
	  , each: function(block, deep) {
	      var i, il
	        , children = this.children()
	
	      for (i = 0, il = children.length; i < il; i++) {
	        if (children[i] instanceof SVG.Element)
	          block.apply(children[i], [i, children])
	
	        if (deep && (children[i] instanceof SVG.Container))
	          children[i].each(block, deep)
	      }
	
	      return this
	    }
	    // Remove a given child
	  , removeElement: function(element) {
	      this.node.removeChild(element.node)
	
	      return this
	    }
	    // Remove all elements in this container
	  , clear: function() {
	      // remove children
	      while(this.node.hasChildNodes())
	        this.node.removeChild(this.node.lastChild)
	
	      // remove defs reference
	      delete this._defs
	
	      return this
	    }
	  , // Get defs
	    defs: function() {
	      return this.doc().defs()
	    }
	  }
	
	})
	
	SVG.extend(SVG.Parent, {
	
	  ungroup: function(parent, depth) {
	    if(depth === 0 || this instanceof SVG.Defs || this.node == SVG.parser.draw) return this
	
	    parent = parent || (this instanceof SVG.Doc ? this : this.parent(SVG.Parent))
	    depth = depth || Infinity
	
	    this.each(function(){
	      if(this instanceof SVG.Defs) return this
	      if(this instanceof SVG.Parent) return this.ungroup(parent, depth-1)
	      return this.toParent(parent)
	    })
	
	    this.node.firstChild || this.remove()
	
	    return this
	  },
	
	  flatten: function(parent, depth) {
	    return this.ungroup(parent, depth)
	  }
	
	})
	SVG.Container = SVG.invent({
	  // Initialize node
	  create: function(element) {
	    this.constructor.call(this, element)
	  }
	
	  // Inherit from
	, inherit: SVG.Parent
	
	})
	
	SVG.ViewBox = SVG.invent({
	
	  create: function(source) {
	    var i, base = [0, 0, 0, 0]
	
	    var x, y, width, height, box, view, we, he
	      , wm   = 1 // width multiplier
	      , hm   = 1 // height multiplier
	      , reg  = /[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?/gi
	
	    if(source instanceof SVG.Element){
	
	      we = source
	      he = source
	      view = (source.attr('viewBox') || '').match(reg)
	      box = source.bbox
	
	      // get dimensions of current node
	      width  = new SVG.Number(source.width())
	      height = new SVG.Number(source.height())
	
	      // find nearest non-percentual dimensions
	      while (width.unit == '%') {
	        wm *= width.value
	        width = new SVG.Number(we instanceof SVG.Doc ? we.parent().offsetWidth : we.parent().width())
	        we = we.parent()
	      }
	      while (height.unit == '%') {
	        hm *= height.value
	        height = new SVG.Number(he instanceof SVG.Doc ? he.parent().offsetHeight : he.parent().height())
	        he = he.parent()
	      }
	
	      // ensure defaults
	      this.x      = 0
	      this.y      = 0
	      this.width  = width  * wm
	      this.height = height * hm
	      this.zoom   = 1
	
	      if (view) {
	        // get width and height from viewbox
	        x      = parseFloat(view[0])
	        y      = parseFloat(view[1])
	        width  = parseFloat(view[2])
	        height = parseFloat(view[3])
	
	        // calculate zoom accoring to viewbox
	        this.zoom = ((this.width / this.height) > (width / height)) ?
	          this.height / height :
	          this.width  / width
	
	        // calculate real pixel dimensions on parent SVG.Doc element
	        this.x      = x
	        this.y      = y
	        this.width  = width
	        this.height = height
	
	      }
	
	    }else{
	
	      // ensure source as object
	      source = typeof source === 'string' ?
	        source.match(reg).map(function(el){ return parseFloat(el) }) :
	      Array.isArray(source) ?
	        source :
	      typeof source == 'object' ?
	        [source.x, source.y, source.width, source.height] :
	      arguments.length == 4 ?
	        [].slice.call(arguments) :
	        base
	
	      this.x = source[0]
	      this.y = source[1]
	      this.width = source[2]
	      this.height = source[3]
	    }
	
	
	  }
	
	, extend: {
	
	    toString: function() {
	      return this.x + ' ' + this.y + ' ' + this.width + ' ' + this.height
	    }
	  , morph: function(x, y, width, height){
	      this.destination = new SVG.ViewBox(x, y, width, height)
	      return this
	    }
	
	  , at: function(pos) {
	
	      if(!this.destination) return this
	
	      return new SVG.ViewBox([
	          this.x + (this.destination.x - this.x) * pos
	        , this.y + (this.destination.y - this.y) * pos
	        , this.width + (this.destination.width - this.width) * pos
	        , this.height + (this.destination.height - this.height) * pos
	      ])
	
	    }
	
	  }
	
	  // Define parent
	, parent: SVG.Container
	
	  // Add parent method
	, construct: {
	
	    // get/set viewbox
	    viewbox: function(x, y, width, height) {
	      if (arguments.length == 0)
	        // act as a getter if there are no arguments
	        return new SVG.ViewBox(this)
	
	      // otherwise act as a setter
	      return this.attr('viewBox', new SVG.ViewBox(x, y, width, height))
	    }
	
	  }
	
	})
	// Add events to elements
	;[  'click'
	  , 'dblclick'
	  , 'mousedown'
	  , 'mouseup'
	  , 'mouseover'
	  , 'mouseout'
	  , 'mousemove'
	  // , 'mouseenter' -> not supported by IE
	  // , 'mouseleave' -> not supported by IE
	  , 'touchstart'
	  , 'touchmove'
	  , 'touchleave'
	  , 'touchend'
	  , 'touchcancel' ].forEach(function(event) {
	
	  // add event to SVG.Element
	  SVG.Element.prototype[event] = function(f) {
	    // bind event to element rather than element node
	    SVG.on(this.node, event, f)
	    return this
	  }
	})
	
	// Initialize listeners stack
	SVG.listeners = []
	SVG.handlerMap = []
	SVG.listenerId = 0
	
	// Add event binder in the SVG namespace
	SVG.on = function(node, event, listener, binding, options) {
	  // create listener, get object-index
	  var l     = listener.bind(binding || node.instance || node)
	    , index = (SVG.handlerMap.indexOf(node) + 1 || SVG.handlerMap.push(node)) - 1
	    , ev    = event.split('.')[0]
	    , ns    = event.split('.')[1] || '*'
	
	
	  // ensure valid object
	  SVG.listeners[index]         = SVG.listeners[index]         || {}
	  SVG.listeners[index][ev]     = SVG.listeners[index][ev]     || {}
	  SVG.listeners[index][ev][ns] = SVG.listeners[index][ev][ns] || {}
	
	  if(!listener._svgjsListenerId)
	    listener._svgjsListenerId = ++SVG.listenerId
	
	  // reference listener
	  SVG.listeners[index][ev][ns][listener._svgjsListenerId] = l
	
	  // add listener
	  node.addEventListener(ev, l, options || false)
	}
	
	// Add event unbinder in the SVG namespace
	SVG.off = function(node, event, listener) {
	  var index = SVG.handlerMap.indexOf(node)
	    , ev    = event && event.split('.')[0]
	    , ns    = event && event.split('.')[1]
	    , namespace = ''
	
	  if(index == -1) return
	
	  if (listener) {
	    if(typeof listener == 'function') listener = listener._svgjsListenerId
	    if(!listener) return
	
	    // remove listener reference
	    if (SVG.listeners[index][ev] && SVG.listeners[index][ev][ns || '*']) {
	      // remove listener
	      node.removeEventListener(ev, SVG.listeners[index][ev][ns || '*'][listener], false)
	
	      delete SVG.listeners[index][ev][ns || '*'][listener]
	    }
	
	  } else if (ns && ev) {
	    // remove all listeners for a namespaced event
	    if (SVG.listeners[index][ev] && SVG.listeners[index][ev][ns]) {
	      for (listener in SVG.listeners[index][ev][ns])
	        SVG.off(node, [ev, ns].join('.'), listener)
	
	      delete SVG.listeners[index][ev][ns]
	    }
	
	  } else if (ns){
	    // remove all listeners for a specific namespace
	    for(event in SVG.listeners[index]){
	        for(namespace in SVG.listeners[index][event]){
	            if(ns === namespace){
	                SVG.off(node, [event, ns].join('.'))
	            }
	        }
	    }
	
	  } else if (ev) {
	    // remove all listeners for the event
	    if (SVG.listeners[index][ev]) {
	      for (namespace in SVG.listeners[index][ev])
	        SVG.off(node, [ev, namespace].join('.'))
	
	      delete SVG.listeners[index][ev]
	    }
	
	  } else {
	    // remove all listeners on a given node
	    for (event in SVG.listeners[index])
	      SVG.off(node, event)
	
	    delete SVG.listeners[index]
	    delete SVG.handlerMap[index]
	
	  }
	}
	
	//
	SVG.extend(SVG.Element, {
	  // Bind given event to listener
	  on: function(event, listener, binding, options) {
	    SVG.on(this.node, event, listener, binding, options)
	
	    return this
	  }
	  // Unbind event from listener
	, off: function(event, listener) {
	    SVG.off(this.node, event, listener)
	
	    return this
	  }
	  // Fire given event
	, fire: function(event, data) {
	
	    // Dispatch event
	    if(event instanceof window.Event){
	        this.node.dispatchEvent(event)
	    }else{
	        this.node.dispatchEvent(event = new window.CustomEvent(event, {detail:data, cancelable: true}))
	    }
	
	    this._event = event
	    return this
	  }
	, event: function() {
	    return this._event
	  }
	})
	
	
	SVG.Defs = SVG.invent({
	  // Initialize node
	  create: 'defs'
	
	  // Inherit from
	, inherit: SVG.Container
	
	})
	SVG.G = SVG.invent({
	  // Initialize node
	  create: 'g'
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Move over x-axis
	    x: function(x) {
	      return x == null ? this.transform('x') : this.transform({ x: x - this.x() }, true)
	    }
	    // Move over y-axis
	  , y: function(y) {
	      return y == null ? this.transform('y') : this.transform({ y: y - this.y() }, true)
	    }
	    // Move by center over x-axis
	  , cx: function(x) {
	      return x == null ? this.gbox().cx : this.x(x - this.gbox().width / 2)
	    }
	    // Move by center over y-axis
	  , cy: function(y) {
	      return y == null ? this.gbox().cy : this.y(y - this.gbox().height / 2)
	    }
	  , gbox: function() {
	
	      var bbox  = this.bbox()
	        , trans = this.transform()
	
	      bbox.x  += trans.x
	      bbox.x2 += trans.x
	      bbox.cx += trans.x
	
	      bbox.y  += trans.y
	      bbox.y2 += trans.y
	      bbox.cy += trans.y
	
	      return bbox
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create a group element
	    group: function() {
	      return this.put(new SVG.G)
	    }
	  }
	})
	
	// ### This module adds backward / forward functionality to elements.
	
	//
	SVG.extend(SVG.Element, {
	  // Get all siblings, including myself
	  siblings: function() {
	    return this.parent().children()
	  }
	  // Get the curent position siblings
	, position: function() {
	    return this.parent().index(this)
	  }
	  // Get the next element (will return null if there is none)
	, next: function() {
	    return this.siblings()[this.position() + 1]
	  }
	  // Get the next element (will return null if there is none)
	, previous: function() {
	    return this.siblings()[this.position() - 1]
	  }
	  // Send given element one step forward
	, forward: function() {
	    var i = this.position() + 1
	      , p = this.parent()
	
	    // move node one step forward
	    p.removeElement(this).add(this, i)
	
	    // make sure defs node is always at the top
	    if (p instanceof SVG.Doc)
	      p.node.appendChild(p.defs().node)
	
	    return this
	  }
	  // Send given element one step backward
	, backward: function() {
	    var i = this.position()
	
	    if (i > 0)
	      this.parent().removeElement(this).add(this, i - 1)
	
	    return this
	  }
	  // Send given element all the way to the front
	, front: function() {
	    var p = this.parent()
	
	    // Move node forward
	    p.node.appendChild(this.node)
	
	    // Make sure defs node is always at the top
	    if (p instanceof SVG.Doc)
	      p.node.appendChild(p.defs().node)
	
	    return this
	  }
	  // Send given element all the way to the back
	, back: function() {
	    if (this.position() > 0)
	      this.parent().removeElement(this).add(this, 0)
	
	    return this
	  }
	  // Inserts a given element before the targeted element
	, before: function(element) {
	    element.remove()
	
	    var i = this.position()
	
	    this.parent().add(element, i)
	
	    return this
	  }
	  // Insters a given element after the targeted element
	, after: function(element) {
	    element.remove()
	
	    var i = this.position()
	
	    this.parent().add(element, i + 1)
	
	    return this
	  }
	
	})
	SVG.Mask = SVG.invent({
	  // Initialize node
	  create: function() {
	    this.constructor.call(this, SVG.create('mask'))
	
	    // keep references to masked elements
	    this.targets = []
	  }
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Unmask all masked elements and remove itself
	    remove: function() {
	      // unmask all targets
	      for (var i = this.targets.length - 1; i >= 0; i--)
	        if (this.targets[i])
	          this.targets[i].unmask()
	      this.targets = []
	
	      // remove mask from parent
	      this.parent().removeElement(this)
	
	      return this
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create masking element
	    mask: function() {
	      return this.defs().put(new SVG.Mask)
	    }
	  }
	})
	
	
	SVG.extend(SVG.Element, {
	  // Distribute mask to svg element
	  maskWith: function(element) {
	    // use given mask or create a new one
	    this.masker = element instanceof SVG.Mask ? element : this.parent().mask().add(element)
	
	    // store reverence on self in mask
	    this.masker.targets.push(this)
	
	    // apply mask
	    return this.attr('mask', 'url("#' + this.masker.attr('id') + '")')
	  }
	  // Unmask element
	, unmask: function() {
	    delete this.masker
	    return this.attr('mask', null)
	  }
	
	})
	
	SVG.ClipPath = SVG.invent({
	  // Initialize node
	  create: function() {
	    this.constructor.call(this, SVG.create('clipPath'))
	
	    // keep references to clipped elements
	    this.targets = []
	  }
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Unclip all clipped elements and remove itself
	    remove: function() {
	      // unclip all targets
	      for (var i = this.targets.length - 1; i >= 0; i--)
	        if (this.targets[i])
	          this.targets[i].unclip()
	      this.targets = []
	
	      // remove clipPath from parent
	      this.parent().removeElement(this)
	
	      return this
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create clipping element
	    clip: function() {
	      return this.defs().put(new SVG.ClipPath)
	    }
	  }
	})
	
	//
	SVG.extend(SVG.Element, {
	  // Distribute clipPath to svg element
	  clipWith: function(element) {
	    // use given clip or create a new one
	    this.clipper = element instanceof SVG.ClipPath ? element : this.parent().clip().add(element)
	
	    // store reverence on self in mask
	    this.clipper.targets.push(this)
	
	    // apply mask
	    return this.attr('clip-path', 'url("#' + this.clipper.attr('id') + '")')
	  }
	  // Unclip element
	, unclip: function() {
	    delete this.clipper
	    return this.attr('clip-path', null)
	  }
	
	})
	SVG.Gradient = SVG.invent({
	  // Initialize node
	  create: function(type) {
	    this.constructor.call(this, SVG.create(type + 'Gradient'))
	
	    // store type
	    this.type = type
	  }
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Add a color stop
	    at: function(offset, color, opacity) {
	      return this.put(new SVG.Stop).update(offset, color, opacity)
	    }
	    // Update gradient
	  , update: function(block) {
	      // remove all stops
	      this.clear()
	
	      // invoke passed block
	      if (typeof block == 'function')
	        block.call(this, this)
	
	      return this
	    }
	    // Return the fill id
	  , fill: function() {
	      return 'url(#' + this.id() + ')'
	    }
	    // Alias string convertion to fill
	  , toString: function() {
	      return this.fill()
	    }
	    // custom attr to handle transform
	  , attr: function(a, b, c) {
	      if(a == 'transform') a = 'gradientTransform'
	      return SVG.Container.prototype.attr.call(this, a, b, c)
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create gradient element in defs
	    gradient: function(type, block) {
	      return this.defs().gradient(type, block)
	    }
	  }
	})
	
	// Add animatable methods to both gradient and fx module
	SVG.extend(SVG.Gradient, SVG.FX, {
	  // From position
	  from: function(x, y) {
	    return (this._target || this).type == 'radial' ?
	      this.attr({ fx: new SVG.Number(x), fy: new SVG.Number(y) }) :
	      this.attr({ x1: new SVG.Number(x), y1: new SVG.Number(y) })
	  }
	  // To position
	, to: function(x, y) {
	    return (this._target || this).type == 'radial' ?
	      this.attr({ cx: new SVG.Number(x), cy: new SVG.Number(y) }) :
	      this.attr({ x2: new SVG.Number(x), y2: new SVG.Number(y) })
	  }
	})
	
	// Base gradient generation
	SVG.extend(SVG.Defs, {
	  // define gradient
	  gradient: function(type, block) {
	    return this.put(new SVG.Gradient(type)).update(block)
	  }
	
	})
	
	SVG.Stop = SVG.invent({
	  // Initialize node
	  create: 'stop'
	
	  // Inherit from
	, inherit: SVG.Element
	
	  // Add class methods
	, extend: {
	    // add color stops
	    update: function(o) {
	      if (typeof o == 'number' || o instanceof SVG.Number) {
	        o = {
	          offset:  arguments[0]
	        , color:   arguments[1]
	        , opacity: arguments[2]
	        }
	      }
	
	      // set attributes
	      if (o.opacity != null) this.attr('stop-opacity', o.opacity)
	      if (o.color   != null) this.attr('stop-color', o.color)
	      if (o.offset  != null) this.attr('offset', new SVG.Number(o.offset))
	
	      return this
	    }
	  }
	
	})
	
	SVG.Pattern = SVG.invent({
	  // Initialize node
	  create: 'pattern'
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Return the fill id
	    fill: function() {
	      return 'url(#' + this.id() + ')'
	    }
	    // Update pattern by rebuilding
	  , update: function(block) {
	      // remove content
	      this.clear()
	
	      // invoke passed block
	      if (typeof block == 'function')
	        block.call(this, this)
	
	      return this
	    }
	    // Alias string convertion to fill
	  , toString: function() {
	      return this.fill()
	    }
	    // custom attr to handle transform
	  , attr: function(a, b, c) {
	      if(a == 'transform') a = 'patternTransform'
	      return SVG.Container.prototype.attr.call(this, a, b, c)
	    }
	
	  }
	
	  // Add parent method
	, construct: {
	    // Create pattern element in defs
	    pattern: function(width, height, block) {
	      return this.defs().pattern(width, height, block)
	    }
	  }
	})
	
	SVG.extend(SVG.Defs, {
	  // Define gradient
	  pattern: function(width, height, block) {
	    return this.put(new SVG.Pattern).update(block).attr({
	      x:            0
	    , y:            0
	    , width:        width
	    , height:       height
	    , patternUnits: 'userSpaceOnUse'
	    })
	  }
	
	})
	SVG.Doc = SVG.invent({
	  // Initialize node
	  create: function(element) {
	    if (element) {
	      // ensure the presence of a dom element
	      element = typeof element == 'string' ?
	        document.getElementById(element) :
	        element
	
	      // If the target is an svg element, use that element as the main wrapper.
	      // This allows svg.js to work with svg documents as well.
	      if (element.nodeName == 'svg') {
	        this.constructor.call(this, element)
	      } else {
	        this.constructor.call(this, SVG.create('svg'))
	        element.appendChild(this.node)
	        this.size('100%', '100%')
	      }
	
	      // set svg element attributes and ensure defs node
	      this.namespace().defs()
	    }
	  }
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Add namespaces
	    namespace: function() {
	      return this
	        .attr({ xmlns: SVG.ns, version: '1.1' })
	        .attr('xmlns:xlink', SVG.xlink, SVG.xmlns)
	        .attr('xmlns:svgjs', SVG.svgjs, SVG.xmlns)
	    }
	    // Creates and returns defs element
	  , defs: function() {
	      if (!this._defs) {
	        var defs
	
	        // Find or create a defs element in this instance
	        if (defs = this.node.getElementsByTagName('defs')[0])
	          this._defs = SVG.adopt(defs)
	        else
	          this._defs = new SVG.Defs
	
	        // Make sure the defs node is at the end of the stack
	        this.node.appendChild(this._defs.node)
	      }
	
	      return this._defs
	    }
	    // custom parent method
	  , parent: function() {
	      return this.node.parentNode.nodeName == '#document' ? null : this.node.parentNode
	    }
	    // Fix for possible sub-pixel offset. See:
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=608812
	  , spof: function() {
	      var pos = this.node.getScreenCTM()
	
	      if (pos)
	        this
	          .style('left', (-pos.e % 1) + 'px')
	          .style('top',  (-pos.f % 1) + 'px')
	
	      return this
	    }
	
	      // Removes the doc from the DOM
	  , remove: function() {
	      if(this.parent()) {
	        this.parent().removeChild(this.node)
	      }
	
	      return this
	    }
	  , clear: function() {
	      // remove children
	      while(this.node.hasChildNodes())
	        this.node.removeChild(this.node.lastChild)
	
	      // remove defs reference
	      delete this._defs
	
	      // add back parser
	      if(!SVG.parser.draw.parentNode)
	        this.node.appendChild(SVG.parser.draw)
	
	      return this
	    }
	  }
	
	})
	
	SVG.Shape = SVG.invent({
	  // Initialize node
	  create: function(element) {
	    this.constructor.call(this, element)
	  }
	
	  // Inherit from
	, inherit: SVG.Element
	
	})
	
	SVG.Bare = SVG.invent({
	  // Initialize
	  create: function(element, inherit) {
	    // construct element
	    this.constructor.call(this, SVG.create(element))
	
	    // inherit custom methods
	    if (inherit)
	      for (var method in inherit.prototype)
	        if (typeof inherit.prototype[method] === 'function')
	          this[method] = inherit.prototype[method]
	  }
	
	  // Inherit from
	, inherit: SVG.Element
	
	  // Add methods
	, extend: {
	    // Insert some plain text
	    words: function(text) {
	      // remove contents
	      while (this.node.hasChildNodes())
	        this.node.removeChild(this.node.lastChild)
	
	      // create text node
	      this.node.appendChild(document.createTextNode(text))
	
	      return this
	    }
	  }
	})
	
	
	SVG.extend(SVG.Parent, {
	  // Create an element that is not described by SVG.js
	  element: function(element, inherit) {
	    return this.put(new SVG.Bare(element, inherit))
	  }
	})
	
	SVG.Symbol = SVG.invent({
	  // Initialize node
	  create: 'symbol'
	
	  // Inherit from
	, inherit: SVG.Container
	
	, construct: {
	    // create symbol
	    symbol: function() {
	      return this.put(new SVG.Symbol)
	    }
	  }
	})
	
	SVG.Use = SVG.invent({
	  // Initialize node
	  create: 'use'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add class methods
	, extend: {
	    // Use element as a reference
	    element: function(element, file) {
	      // Set lined element
	      return this.attr('href', (file || '') + '#' + element, SVG.xlink)
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create a use element
	    use: function(element, file) {
	      return this.put(new SVG.Use).element(element, file)
	    }
	  }
	})
	SVG.Rect = SVG.invent({
	  // Initialize node
	  create: 'rect'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add parent method
	, construct: {
	    // Create a rect element
	    rect: function(width, height) {
	      return this.put(new SVG.Rect()).size(width, height)
	    }
	  }
	})
	SVG.Circle = SVG.invent({
	  // Initialize node
	  create: 'circle'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add parent method
	, construct: {
	    // Create circle element, based on ellipse
	    circle: function(size) {
	      return this.put(new SVG.Circle).rx(new SVG.Number(size).divide(2)).move(0, 0)
	    }
	  }
	})
	
	SVG.extend(SVG.Circle, SVG.FX, {
	  // Radius x value
	  rx: function(rx) {
	    return this.attr('r', rx)
	  }
	  // Alias radius x value
	, ry: function(ry) {
	    return this.rx(ry)
	  }
	})
	
	SVG.Ellipse = SVG.invent({
	  // Initialize node
	  create: 'ellipse'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add parent method
	, construct: {
	    // Create an ellipse
	    ellipse: function(width, height) {
	      return this.put(new SVG.Ellipse).size(width, height).move(0, 0)
	    }
	  }
	})
	
	SVG.extend(SVG.Ellipse, SVG.Rect, SVG.FX, {
	  // Radius x value
	  rx: function(rx) {
	    return this.attr('rx', rx)
	  }
	  // Radius y value
	, ry: function(ry) {
	    return this.attr('ry', ry)
	  }
	})
	
	// Add common method
	SVG.extend(SVG.Circle, SVG.Ellipse, {
	    // Move over x-axis
	    x: function(x) {
	      return x == null ? this.cx() - this.rx() : this.cx(x + this.rx())
	    }
	    // Move over y-axis
	  , y: function(y) {
	      return y == null ? this.cy() - this.ry() : this.cy(y + this.ry())
	    }
	    // Move by center over x-axis
	  , cx: function(x) {
	      return x == null ? this.attr('cx') : this.attr('cx', x)
	    }
	    // Move by center over y-axis
	  , cy: function(y) {
	      return y == null ? this.attr('cy') : this.attr('cy', y)
	    }
	    // Set width of element
	  , width: function(width) {
	      return width == null ? this.rx() * 2 : this.rx(new SVG.Number(width).divide(2))
	    }
	    // Set height of element
	  , height: function(height) {
	      return height == null ? this.ry() * 2 : this.ry(new SVG.Number(height).divide(2))
	    }
	    // Custom size function
	  , size: function(width, height) {
	      var p = proportionalSize(this, width, height)
	
	      return this
	        .rx(new SVG.Number(p.width).divide(2))
	        .ry(new SVG.Number(p.height).divide(2))
	    }
	})
	SVG.Line = SVG.invent({
	  // Initialize node
	  create: 'line'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add class methods
	, extend: {
	    // Get array
	    array: function() {
	      return new SVG.PointArray([
	        [ this.attr('x1'), this.attr('y1') ]
	      , [ this.attr('x2'), this.attr('y2') ]
	      ])
	    }
	    // Overwrite native plot() method
	  , plot: function(x1, y1, x2, y2) {
	      if (x1 == null)
	        return this.array()
	      else if (typeof y1 !== 'undefined')
	        x1 = { x1: x1, y1: y1, x2: x2, y2: y2 }
	      else
	        x1 = new SVG.PointArray(x1).toLine()
	
	      return this.attr(x1)
	    }
	    // Move by left top corner
	  , move: function(x, y) {
	      return this.attr(this.array().move(x, y).toLine())
	    }
	    // Set element size to given width and height
	  , size: function(width, height) {
	      var p = proportionalSize(this, width, height)
	
	      return this.attr(this.array().size(p.width, p.height).toLine())
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create a line element
	    line: function(x1, y1, x2, y2) {
	      // make sure plot is called as a setter
	      // x1 is not necessarily a number, it can also be an array, a string and a SVG.PointArray
	      return SVG.Line.prototype.plot.apply(
	        this.put(new SVG.Line)
	      , x1 != null ? [x1, y1, x2, y2] : [0, 0, 0, 0]
	      )
	    }
	  }
	})
	
	SVG.Polyline = SVG.invent({
	  // Initialize node
	  create: 'polyline'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add parent method
	, construct: {
	    // Create a wrapped polyline element
	    polyline: function(p) {
	      // make sure plot is called as a setter
	      return this.put(new SVG.Polyline).plot(p || new SVG.PointArray)
	    }
	  }
	})
	
	SVG.Polygon = SVG.invent({
	  // Initialize node
	  create: 'polygon'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add parent method
	, construct: {
	    // Create a wrapped polygon element
	    polygon: function(p) {
	      // make sure plot is called as a setter
	      return this.put(new SVG.Polygon).plot(p || new SVG.PointArray)
	    }
	  }
	})
	
	// Add polygon-specific functions
	SVG.extend(SVG.Polyline, SVG.Polygon, {
	  // Get array
	  array: function() {
	    return this._array || (this._array = new SVG.PointArray(this.attr('points')))
	  }
	  // Plot new path
	, plot: function(p) {
	    return (p == null) ?
	      this.array() :
	      this.clear().attr('points', typeof p == 'string' ? p : (this._array = new SVG.PointArray(p)))
	  }
	  // Clear array cache
	, clear: function() {
	    delete this._array
	    return this
	  }
	  // Move by left top corner
	, move: function(x, y) {
	    return this.attr('points', this.array().move(x, y))
	  }
	  // Set element size to given width and height
	, size: function(width, height) {
	    var p = proportionalSize(this, width, height)
	
	    return this.attr('points', this.array().size(p.width, p.height))
	  }
	
	})
	
	// unify all point to point elements
	SVG.extend(SVG.Line, SVG.Polyline, SVG.Polygon, {
	  // Define morphable array
	  morphArray:  SVG.PointArray
	  // Move by left top corner over x-axis
	, x: function(x) {
	    return x == null ? this.bbox().x : this.move(x, this.bbox().y)
	  }
	  // Move by left top corner over y-axis
	, y: function(y) {
	    return y == null ? this.bbox().y : this.move(this.bbox().x, y)
	  }
	  // Set width of element
	, width: function(width) {
	    var b = this.bbox()
	
	    return width == null ? b.width : this.size(width, b.height)
	  }
	  // Set height of element
	, height: function(height) {
	    var b = this.bbox()
	
	    return height == null ? b.height : this.size(b.width, height)
	  }
	})
	SVG.Path = SVG.invent({
	  // Initialize node
	  create: 'path'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add class methods
	, extend: {
	    // Define morphable array
	    morphArray:  SVG.PathArray
	    // Get array
	  , array: function() {
	      return this._array || (this._array = new SVG.PathArray(this.attr('d')))
	    }
	    // Plot new path
	  , plot: function(d) {
	      return (d == null) ?
	        this.array() :
	        this.clear().attr('d', typeof d == 'string' ? d : (this._array = new SVG.PathArray(d)))
	    }
	    // Clear array cache
	  , clear: function() {
	      delete this._array
	      return this
	    }
	    // Move by left top corner
	  , move: function(x, y) {
	      return this.attr('d', this.array().move(x, y))
	    }
	    // Move by left top corner over x-axis
	  , x: function(x) {
	      return x == null ? this.bbox().x : this.move(x, this.bbox().y)
	    }
	    // Move by left top corner over y-axis
	  , y: function(y) {
	      return y == null ? this.bbox().y : this.move(this.bbox().x, y)
	    }
	    // Set element size to given width and height
	  , size: function(width, height) {
	      var p = proportionalSize(this, width, height)
	
	      return this.attr('d', this.array().size(p.width, p.height))
	    }
	    // Set width of element
	  , width: function(width) {
	      return width == null ? this.bbox().width : this.size(width, this.bbox().height)
	    }
	    // Set height of element
	  , height: function(height) {
	      return height == null ? this.bbox().height : this.size(this.bbox().width, height)
	    }
	
	  }
	
	  // Add parent method
	, construct: {
	    // Create a wrapped path element
	    path: function(d) {
	      // make sure plot is called as a setter
	      return this.put(new SVG.Path).plot(d || new SVG.PathArray)
	    }
	  }
	})
	
	SVG.Image = SVG.invent({
	  // Initialize node
	  create: 'image'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add class methods
	, extend: {
	    // (re)load image
	    load: function(url) {
	      if (!url) return this
	
	      var self = this
	        , img  = new window.Image()
	
	      // preload image
	      SVG.on(img, 'load', function() {
	        SVG.off(img)
	
	        var p = self.parent(SVG.Pattern)
	
	        if(p === null) return
	
	        // ensure image size
	        if (self.width() == 0 && self.height() == 0)
	          self.size(img.width, img.height)
	
	        // ensure pattern size if not set
	        if (p && p.width() == 0 && p.height() == 0)
	          p.size(self.width(), self.height())
	
	        // callback
	        if (typeof self._loaded === 'function')
	          self._loaded.call(self, {
	            width:  img.width
	          , height: img.height
	          , ratio:  img.width / img.height
	          , url:    url
	          })
	      })
	
	      SVG.on(img, 'error', function(e){
	        SVG.off(img)
	
	        if (typeof self._error === 'function'){
	            self._error.call(self, e)
	        }
	      })
	
	      return this.attr('href', (img.src = this.src = url), SVG.xlink)
	    }
	    // Add loaded callback
	  , loaded: function(loaded) {
	      this._loaded = loaded
	      return this
	    }
	
	  , error: function(error) {
	      this._error = error
	      return this
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // create image element, load image and set its size
	    image: function(source, width, height) {
	      return this.put(new SVG.Image).load(source).size(width || 0, height || width || 0)
	    }
	  }
	
	})
	SVG.Text = SVG.invent({
	  // Initialize node
	  create: function() {
	    this.constructor.call(this, SVG.create('text'))
	
	    this.dom.leading = new SVG.Number(1.3)    // store leading value for rebuilding
	    this._rebuild = true                      // enable automatic updating of dy values
	    this._build   = false                     // disable build mode for adding multiple lines
	
	    // set default font
	    this.attr('font-family', SVG.defaults.attrs['font-family'])
	  }
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add class methods
	, extend: {
	    // Move over x-axis
	    x: function(x) {
	      // act as getter
	      if (x == null)
	        return this.attr('x')
	
	      return this.attr('x', x)
	    }
	    // Move over y-axis
	  , y: function(y) {
	      var oy = this.attr('y')
	        , o  = typeof oy === 'number' ? oy - this.bbox().y : 0
	
	      // act as getter
	      if (y == null)
	        return typeof oy === 'number' ? oy - o : oy
	
	      return this.attr('y', typeof y === 'number' ? y + o : y)
	    }
	    // Move center over x-axis
	  , cx: function(x) {
	      return x == null ? this.bbox().cx : this.x(x - this.bbox().width / 2)
	    }
	    // Move center over y-axis
	  , cy: function(y) {
	      return y == null ? this.bbox().cy : this.y(y - this.bbox().height / 2)
	    }
	    // Set the text content
	  , text: function(text) {
	      // act as getter
	      if (typeof text === 'undefined'){
	        var text = ''
	        var children = this.node.childNodes
	        for(var i = 0, len = children.length; i < len; ++i){
	
	          // add newline if its not the first child and newLined is set to true
	          if(i != 0 && children[i].nodeType != 3 && SVG.adopt(children[i]).dom.newLined == true){
	            text += '\n'
	          }
	
	          // add content of this node
	          text += children[i].textContent
	        }
	
	        return text
	      }
	
	      // remove existing content
	      this.clear().build(true)
	
	      if (typeof text === 'function') {
	        // call block
	        text.call(this, this)
	
	      } else {
	        // store text and make sure text is not blank
	        text = text.split('\n')
	
	        // build new lines
	        for (var i = 0, il = text.length; i < il; i++)
	          this.tspan(text[i]).newLine()
	      }
	
	      // disable build mode and rebuild lines
	      return this.build(false).rebuild()
	    }
	    // Set font size
	  , size: function(size) {
	      return this.attr('font-size', size).rebuild()
	    }
	    // Set / get leading
	  , leading: function(value) {
	      // act as getter
	      if (value == null)
	        return this.dom.leading
	
	      // act as setter
	      this.dom.leading = new SVG.Number(value)
	
	      return this.rebuild()
	    }
	    // Get all the first level lines
	  , lines: function() {
	      var node = (this.textPath && this.textPath() || this).node
	
	      // filter tspans and map them to SVG.js instances
	      var lines = SVG.utils.map(SVG.utils.filterSVGElements(node.childNodes), function(el){
	        return SVG.adopt(el)
	      })
	
	      // return an instance of SVG.set
	      return new SVG.Set(lines)
	    }
	    // Rebuild appearance type
	  , rebuild: function(rebuild) {
	      // store new rebuild flag if given
	      if (typeof rebuild == 'boolean')
	        this._rebuild = rebuild
	
	      // define position of all lines
	      if (this._rebuild) {
	        var self = this
	          , blankLineOffset = 0
	          , dy = this.dom.leading * new SVG.Number(this.attr('font-size'))
	
	        this.lines().each(function() {
	          if (this.dom.newLined) {
	            if (!self.textPath())
	              this.attr('x', self.attr('x'))
	            if(this.text() == '\n') {
	              blankLineOffset += dy
	            }else{
	              this.attr('dy', dy + blankLineOffset)
	              blankLineOffset = 0
	            }
	          }
	        })
	
	        this.fire('rebuild')
	      }
	
	      return this
	    }
	    // Enable / disable build mode
	  , build: function(build) {
	      this._build = !!build
	      return this
	    }
	    // overwrite method from parent to set data properly
	  , setData: function(o){
	      this.dom = o
	      this.dom.leading = new SVG.Number(o.leading || 1.3)
	      return this
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create text element
	    text: function(text) {
	      return this.put(new SVG.Text).text(text)
	    }
	    // Create plain text element
	  , plain: function(text) {
	      return this.put(new SVG.Text).plain(text)
	    }
	  }
	
	})
	
	SVG.Tspan = SVG.invent({
	  // Initialize node
	  create: 'tspan'
	
	  // Inherit from
	, inherit: SVG.Shape
	
	  // Add class methods
	, extend: {
	    // Set text content
	    text: function(text) {
	      if(text == null) return this.node.textContent + (this.dom.newLined ? '\n' : '')
	
	      typeof text === 'function' ? text.call(this, this) : this.plain(text)
	
	      return this
	    }
	    // Shortcut dx
	  , dx: function(dx) {
	      return this.attr('dx', dx)
	    }
	    // Shortcut dy
	  , dy: function(dy) {
	      return this.attr('dy', dy)
	    }
	    // Create new line
	  , newLine: function() {
	      // fetch text parent
	      var t = this.parent(SVG.Text)
	
	      // mark new line
	      this.dom.newLined = true
	
	      // apply new hy¡n
	      return this.dy(t.dom.leading * t.attr('font-size')).attr('x', t.x())
	    }
	  }
	
	})
	
	SVG.extend(SVG.Text, SVG.Tspan, {
	  // Create plain text node
	  plain: function(text) {
	    // clear if build mode is disabled
	    if (this._build === false)
	      this.clear()
	
	    // create text node
	    this.node.appendChild(document.createTextNode(text))
	
	    return this
	  }
	  // Create a tspan
	, tspan: function(text) {
	    var node  = (this.textPath && this.textPath() || this).node
	      , tspan = new SVG.Tspan
	
	    // clear if build mode is disabled
	    if (this._build === false)
	      this.clear()
	
	    // add new tspan
	    node.appendChild(tspan.node)
	
	    return tspan.text(text)
	  }
	  // Clear all lines
	, clear: function() {
	    var node = (this.textPath && this.textPath() || this).node
	
	    // remove existing child nodes
	    while (node.hasChildNodes())
	      node.removeChild(node.lastChild)
	
	    return this
	  }
	  // Get length of text element
	, length: function() {
	    return this.node.getComputedTextLength()
	  }
	})
	
	SVG.TextPath = SVG.invent({
	  // Initialize node
	  create: 'textPath'
	
	  // Inherit from
	, inherit: SVG.Parent
	
	  // Define parent class
	, parent: SVG.Text
	
	  // Add parent method
	, construct: {
	    morphArray: SVG.PathArray
	    // Create path for text to run on
	  , path: function(d) {
	      // create textPath element
	      var path  = new SVG.TextPath
	        , track = this.doc().defs().path(d)
	
	      // move lines to textpath
	      while (this.node.hasChildNodes())
	        path.node.appendChild(this.node.firstChild)
	
	      // add textPath element as child node
	      this.node.appendChild(path.node)
	
	      // link textPath to path and add content
	      path.attr('href', '#' + track, SVG.xlink)
	
	      return this
	    }
	    // return the array of the path track element
	  , array: function() {
	      var track = this.track()
	
	      return track ? track.array() : null
	    }
	    // Plot path if any
	  , plot: function(d) {
	      var track = this.track()
	        , pathArray = null
	
	      if (track) {
	        pathArray = track.plot(d)
	      }
	
	      return (d == null) ? pathArray : this
	    }
	    // Get the path track element
	  , track: function() {
	      var path = this.textPath()
	
	      if (path)
	        return path.reference('href')
	    }
	    // Get the textPath child
	  , textPath: function() {
	      if (this.node.firstChild && this.node.firstChild.nodeName == 'textPath')
	        return SVG.adopt(this.node.firstChild)
	    }
	  }
	})
	
	SVG.Nested = SVG.invent({
	  // Initialize node
	  create: function() {
	    this.constructor.call(this, SVG.create('svg'))
	
	    this.style('overflow', 'visible')
	  }
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add parent method
	, construct: {
	    // Create nested svg document
	    nested: function() {
	      return this.put(new SVG.Nested)
	    }
	  }
	})
	SVG.A = SVG.invent({
	  // Initialize node
	  create: 'a'
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Link url
	    to: function(url) {
	      return this.attr('href', url, SVG.xlink)
	    }
	    // Link show attribute
	  , show: function(target) {
	      return this.attr('show', target, SVG.xlink)
	    }
	    // Link target attribute
	  , target: function(target) {
	      return this.attr('target', target)
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create a hyperlink element
	    link: function(url) {
	      return this.put(new SVG.A).to(url)
	    }
	  }
	})
	
	SVG.extend(SVG.Element, {
	  // Create a hyperlink element
	  linkTo: function(url) {
	    var link = new SVG.A
	
	    if (typeof url == 'function')
	      url.call(link, link)
	    else
	      link.to(url)
	
	    return this.parent().put(link).put(this)
	  }
	
	})
	SVG.Marker = SVG.invent({
	  // Initialize node
	  create: 'marker'
	
	  // Inherit from
	, inherit: SVG.Container
	
	  // Add class methods
	, extend: {
	    // Set width of element
	    width: function(width) {
	      return this.attr('markerWidth', width)
	    }
	    // Set height of element
	  , height: function(height) {
	      return this.attr('markerHeight', height)
	    }
	    // Set marker refX and refY
	  , ref: function(x, y) {
	      return this.attr('refX', x).attr('refY', y)
	    }
	    // Update marker
	  , update: function(block) {
	      // remove all content
	      this.clear()
	
	      // invoke passed block
	      if (typeof block == 'function')
	        block.call(this, this)
	
	      return this
	    }
	    // Return the fill id
	  , toString: function() {
	      return 'url(#' + this.id() + ')'
	    }
	  }
	
	  // Add parent method
	, construct: {
	    marker: function(width, height, block) {
	      // Create marker element in defs
	      return this.defs().marker(width, height, block)
	    }
	  }
	
	})
	
	SVG.extend(SVG.Defs, {
	  // Create marker
	  marker: function(width, height, block) {
	    // Set default viewbox to match the width and height, set ref to cx and cy and set orient to auto
	    return this.put(new SVG.Marker)
	      .size(width, height)
	      .ref(width / 2, height / 2)
	      .viewbox(0, 0, width, height)
	      .attr('orient', 'auto')
	      .update(block)
	  }
	
	})
	
	SVG.extend(SVG.Line, SVG.Polyline, SVG.Polygon, SVG.Path, {
	  // Create and attach markers
	  marker: function(marker, width, height, block) {
	    var attr = ['marker']
	
	    // Build attribute name
	    if (marker != 'all') attr.push(marker)
	    attr = attr.join('-')
	
	    // Set marker attribute
	    marker = arguments[1] instanceof SVG.Marker ?
	      arguments[1] :
	      this.doc().marker(width, height, block)
	
	    return this.attr(attr, marker)
	  }
	
	})
	// Define list of available attributes for stroke and fill
	var sugar = {
	  stroke: ['color', 'width', 'opacity', 'linecap', 'linejoin', 'miterlimit', 'dasharray', 'dashoffset']
	, fill:   ['color', 'opacity', 'rule']
	, prefix: function(t, a) {
	    return a == 'color' ? t : t + '-' + a
	  }
	}
	
	// Add sugar for fill and stroke
	;['fill', 'stroke'].forEach(function(m) {
	  var i, extension = {}
	
	  extension[m] = function(o) {
	    if (typeof o == 'undefined')
	      return this
	    if (typeof o == 'string' || SVG.Color.isRgb(o) || (o && typeof o.fill === 'function'))
	      this.attr(m, o)
	
	    else
	      // set all attributes from sugar.fill and sugar.stroke list
	      for (i = sugar[m].length - 1; i >= 0; i--)
	        if (o[sugar[m][i]] != null)
	          this.attr(sugar.prefix(m, sugar[m][i]), o[sugar[m][i]])
	
	    return this
	  }
	
	  SVG.extend(SVG.Element, SVG.FX, extension)
	
	})
	
	SVG.extend(SVG.Element, SVG.FX, {
	  // Map rotation to transform
	  rotate: function(d, cx, cy) {
	    return this.transform({ rotation: d, cx: cx, cy: cy })
	  }
	  // Map skew to transform
	, skew: function(x, y, cx, cy) {
	    return arguments.length == 1  || arguments.length == 3 ?
	      this.transform({ skew: x, cx: y, cy: cx }) :
	      this.transform({ skewX: x, skewY: y, cx: cx, cy: cy })
	  }
	  // Map scale to transform
	, scale: function(x, y, cx, cy) {
	    return arguments.length == 1  || arguments.length == 3 ?
	      this.transform({ scale: x, cx: y, cy: cx }) :
	      this.transform({ scaleX: x, scaleY: y, cx: cx, cy: cy })
	  }
	  // Map translate to transform
	, translate: function(x, y) {
	    return this.transform({ x: x, y: y })
	  }
	  // Map flip to transform
	, flip: function(a, o) {
	    o = typeof a == 'number' ? a : o
	    return this.transform({ flip: a || 'both', offset: o })
	  }
	  // Map matrix to transform
	, matrix: function(m) {
	    return this.attr('transform', new SVG.Matrix(arguments.length == 6 ? [].slice.call(arguments) : m))
	  }
	  // Opacity
	, opacity: function(value) {
	    return this.attr('opacity', value)
	  }
	  // Relative move over x axis
	, dx: function(x) {
	    return this.x(new SVG.Number(x).plus(this instanceof SVG.FX ? 0 : this.x()), true)
	  }
	  // Relative move over y axis
	, dy: function(y) {
	    return this.y(new SVG.Number(y).plus(this instanceof SVG.FX ? 0 : this.y()), true)
	  }
	  // Relative move over x and y axes
	, dmove: function(x, y) {
	    return this.dx(x).dy(y)
	  }
	})
	
	SVG.extend(SVG.Rect, SVG.Ellipse, SVG.Circle, SVG.Gradient, SVG.FX, {
	  // Add x and y radius
	  radius: function(x, y) {
	    var type = (this._target || this).type;
	    return type == 'radial' || type == 'circle' ?
	      this.attr('r', new SVG.Number(x)) :
	      this.rx(x).ry(y == null ? x : y)
	  }
	})
	
	SVG.extend(SVG.Path, {
	  // Get path length
	  length: function() {
	    return this.node.getTotalLength()
	  }
	  // Get point at length
	, pointAt: function(length) {
	    return this.node.getPointAtLength(length)
	  }
	})
	
	SVG.extend(SVG.Parent, SVG.Text, SVG.Tspan, SVG.FX, {
	  // Set font
	  font: function(a, v) {
	    if (typeof a == 'object') {
	      for (v in a) this.font(v, a[v])
	    }
	
	    return a == 'leading' ?
	        this.leading(v) :
	      a == 'anchor' ?
	        this.attr('text-anchor', v) :
	      a == 'size' || a == 'family' || a == 'weight' || a == 'stretch' || a == 'variant' || a == 'style' ?
	        this.attr('font-'+ a, v) :
	        this.attr(a, v)
	  }
	})
	
	SVG.Set = SVG.invent({
	  // Initialize
	  create: function(members) {
	    // Set initial state
	    Array.isArray(members) ? this.members = members : this.clear()
	  }
	
	  // Add class methods
	, extend: {
	    // Add element to set
	    add: function() {
	      var i, il, elements = [].slice.call(arguments)
	
	      for (i = 0, il = elements.length; i < il; i++)
	        this.members.push(elements[i])
	
	      return this
	    }
	    // Remove element from set
	  , remove: function(element) {
	      var i = this.index(element)
	
	      // remove given child
	      if (i > -1)
	        this.members.splice(i, 1)
	
	      return this
	    }
	    // Iterate over all members
	  , each: function(block) {
	      for (var i = 0, il = this.members.length; i < il; i++)
	        block.apply(this.members[i], [i, this.members])
	
	      return this
	    }
	    // Restore to defaults
	  , clear: function() {
	      // initialize store
	      this.members = []
	
	      return this
	    }
	    // Get the length of a set
	  , length: function() {
	      return this.members.length
	    }
	    // Checks if a given element is present in set
	  , has: function(element) {
	      return this.index(element) >= 0
	    }
	    // retuns index of given element in set
	  , index: function(element) {
	      return this.members.indexOf(element)
	    }
	    // Get member at given index
	  , get: function(i) {
	      return this.members[i]
	    }
	    // Get first member
	  , first: function() {
	      return this.get(0)
	    }
	    // Get last member
	  , last: function() {
	      return this.get(this.members.length - 1)
	    }
	    // Default value
	  , valueOf: function() {
	      return this.members
	    }
	    // Get the bounding box of all members included or empty box if set has no items
	  , bbox: function(){
	      // return an empty box of there are no members
	      if (this.members.length == 0)
	        return new SVG.RBox()
	
	      // get the first rbox and update the target bbox
	      var rbox = this.members[0].rbox(this.members[0].doc())
	
	      this.each(function() {
	        // user rbox for correct position and visual representation
	        rbox = rbox.merge(this.rbox(this.doc()))
	      })
	
	      return rbox
	    }
	  }
	
	  // Add parent method
	, construct: {
	    // Create a new set
	    set: function(members) {
	      return new SVG.Set(members)
	    }
	  }
	})
	
	SVG.FX.Set = SVG.invent({
	  // Initialize node
	  create: function(set) {
	    // store reference to set
	    this.set = set
	  }
	
	})
	
	// Alias methods
	SVG.Set.inherit = function() {
	  var m
	    , methods = []
	
	  // gather shape methods
	  for(var m in SVG.Shape.prototype)
	    if (typeof SVG.Shape.prototype[m] == 'function' && typeof SVG.Set.prototype[m] != 'function')
	      methods.push(m)
	
	  // apply shape aliasses
	  methods.forEach(function(method) {
	    SVG.Set.prototype[method] = function() {
	      for (var i = 0, il = this.members.length; i < il; i++)
	        if (this.members[i] && typeof this.members[i][method] == 'function')
	          this.members[i][method].apply(this.members[i], arguments)
	
	      return method == 'animate' ? (this.fx || (this.fx = new SVG.FX.Set(this))) : this
	    }
	  })
	
	  // clear methods for the next round
	  methods = []
	
	  // gather fx methods
	  for(var m in SVG.FX.prototype)
	    if (typeof SVG.FX.prototype[m] == 'function' && typeof SVG.FX.Set.prototype[m] != 'function')
	      methods.push(m)
	
	  // apply fx aliasses
	  methods.forEach(function(method) {
	    SVG.FX.Set.prototype[method] = function() {
	      for (var i = 0, il = this.set.members.length; i < il; i++)
	        this.set.members[i].fx[method].apply(this.set.members[i].fx, arguments)
	
	      return this
	    }
	  })
	}
	
	
	
	
	SVG.extend(SVG.Element, {
	  // Store data values on svg nodes
	  data: function(a, v, r) {
	    if (typeof a == 'object') {
	      for (v in a)
	        this.data(v, a[v])
	
	    } else if (arguments.length < 2) {
	      try {
	        return JSON.parse(this.attr('data-' + a))
	      } catch(e) {
	        return this.attr('data-' + a)
	      }
	
	    } else {
	      this.attr(
	        'data-' + a
	      , v === null ?
	          null :
	        r === true || typeof v === 'string' || typeof v === 'number' ?
	          v :
	          JSON.stringify(v)
	      )
	    }
	
	    return this
	  }
	})
	SVG.extend(SVG.Element, {
	  // Remember arbitrary data
	  remember: function(k, v) {
	    // remember every item in an object individually
	    if (typeof arguments[0] == 'object')
	      for (var v in k)
	        this.remember(v, k[v])
	
	    // retrieve memory
	    else if (arguments.length == 1)
	      return this.memory()[k]
	
	    // store memory
	    else
	      this.memory()[k] = v
	
	    return this
	  }
	
	  // Erase a given memory
	, forget: function() {
	    if (arguments.length == 0)
	      this._memory = {}
	    else
	      for (var i = arguments.length - 1; i >= 0; i--)
	        delete this.memory()[arguments[i]]
	
	    return this
	  }
	
	  // Initialize or return local memory object
	, memory: function() {
	    return this._memory || (this._memory = {})
	  }
	
	})
	// Method for getting an element by id
	SVG.get = function(id) {
	  var node = document.getElementById(idFromReference(id) || id)
	  return SVG.adopt(node)
	}
	
	// Select elements by query string
	SVG.select = function(query, parent) {
	  return new SVG.Set(
	    SVG.utils.map((parent || document).querySelectorAll(query), function(node) {
	      return SVG.adopt(node)
	    })
	  )
	}
	
	SVG.extend(SVG.Parent, {
	  // Scoped select method
	  select: function(query) {
	    return SVG.select(query, this.node)
	  }
	
	})
	function pathRegReplace(a, b, c, d) {
	  return c + d.replace(SVG.regex.dots, ' .')
	}
	
	// creates deep clone of array
	function array_clone(arr){
	  var clone = arr.slice(0)
	  for(var i = clone.length; i--;){
	    if(Array.isArray(clone[i])){
	      clone[i] = array_clone(clone[i])
	    }
	  }
	  return clone
	}
	
	// tests if a given element is instance of an object
	function is(el, obj){
	  return el instanceof obj
	}
	
	// tests if a given selector matches an element
	function matches(el, selector) {
	  return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
	}
	
	// Convert dash-separated-string to camelCase
	function camelCase(s) {
	  return s.toLowerCase().replace(/-(.)/g, function(m, g) {
	    return g.toUpperCase()
	  })
	}
	
	// Capitalize first letter of a string
	function capitalize(s) {
	  return s.charAt(0).toUpperCase() + s.slice(1)
	}
	
	// Ensure to six-based hex
	function fullHex(hex) {
	  return hex.length == 4 ?
	    [ '#',
	      hex.substring(1, 2), hex.substring(1, 2)
	    , hex.substring(2, 3), hex.substring(2, 3)
	    , hex.substring(3, 4), hex.substring(3, 4)
	    ].join('') : hex
	}
	
	// Component to hex value
	function compToHex(comp) {
	  var hex = comp.toString(16)
	  return hex.length == 1 ? '0' + hex : hex
	}
	
	// Calculate proportional width and height values when necessary
	function proportionalSize(element, width, height) {
	  if (width == null || height == null) {
	    var box = element.bbox()
	
	    if (width == null)
	      width = box.width / box.height * height
	    else if (height == null)
	      height = box.height / box.width * width
	  }
	
	  return {
	    width:  width
	  , height: height
	  }
	}
	
	// Delta transform point
	function deltaTransformPoint(matrix, x, y) {
	  return {
	    x: x * matrix.a + y * matrix.c + 0
	  , y: x * matrix.b + y * matrix.d + 0
	  }
	}
	
	// Map matrix array to object
	function arrayToMatrix(a) {
	  return { a: a[0], b: a[1], c: a[2], d: a[3], e: a[4], f: a[5] }
	}
	
	// Parse matrix if required
	function parseMatrix(matrix) {
	  if (!(matrix instanceof SVG.Matrix))
	    matrix = new SVG.Matrix(matrix)
	
	  return matrix
	}
	
	// Add centre point to transform object
	function ensureCentre(o, target) {
	  o.cx = o.cx == null ? target.bbox().cx : o.cx
	  o.cy = o.cy == null ? target.bbox().cy : o.cy
	}
	
	// PathArray Helpers
	function arrayToString(a) {
	  for (var i = 0, il = a.length, s = ''; i < il; i++) {
	    s += a[i][0]
	
	    if (a[i][1] != null) {
	      s += a[i][1]
	
	      if (a[i][2] != null) {
	        s += ' '
	        s += a[i][2]
	
	        if (a[i][3] != null) {
	          s += ' '
	          s += a[i][3]
	          s += ' '
	          s += a[i][4]
	
	          if (a[i][5] != null) {
	            s += ' '
	            s += a[i][5]
	            s += ' '
	            s += a[i][6]
	
	            if (a[i][7] != null) {
	              s += ' '
	              s += a[i][7]
	            }
	          }
	        }
	      }
	    }
	  }
	
	  return s + ' '
	}
	
	// Deep new id assignment
	function assignNewId(node) {
	  // do the same for SVG child nodes as well
	  for (var i = node.childNodes.length - 1; i >= 0; i--)
	    if (node.childNodes[i] instanceof window.SVGElement)
	      assignNewId(node.childNodes[i])
	
	  return SVG.adopt(node).id(SVG.eid(node.nodeName))
	}
	
	// Add more bounding box properties
	function fullBox(b) {
	  if (b.x == null) {
	    b.x      = 0
	    b.y      = 0
	    b.width  = 0
	    b.height = 0
	  }
	
	  b.w  = b.width
	  b.h  = b.height
	  b.x2 = b.x + b.width
	  b.y2 = b.y + b.height
	  b.cx = b.x + b.width / 2
	  b.cy = b.y + b.height / 2
	
	  return b
	}
	
	// Get id from reference string
	function idFromReference(url) {
	  var m = url.toString().match(SVG.regex.reference)
	
	  if (m) return m[1]
	}
	
	// Create matrix array for looping
	var abcdef = 'abcdef'.split('')
	// Add CustomEvent to IE9 and IE10
	if (typeof window.CustomEvent !== 'function') {
	  // Code from: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
	  var CustomEvent = function(event, options) {
	    options = options || { bubbles: false, cancelable: false, detail: undefined }
	    var e = document.createEvent('CustomEvent')
	    e.initCustomEvent(event, options.bubbles, options.cancelable, options.detail)
	    return e
	  }
	
	  CustomEvent.prototype = window.Event.prototype
	
	  window.CustomEvent = CustomEvent
	}
	
	// requestAnimationFrame / cancelAnimationFrame Polyfill with fallback based on Paul Irish
	(function(w) {
	  var lastTime = 0
	  var vendors = ['moz', 'webkit']
	
	  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    w.requestAnimationFrame = w[vendors[x] + 'RequestAnimationFrame']
	    w.cancelAnimationFrame  = w[vendors[x] + 'CancelAnimationFrame'] ||
	                              w[vendors[x] + 'CancelRequestAnimationFrame']
	  }
	
	  w.requestAnimationFrame = w.requestAnimationFrame ||
	    function(callback) {
	      var currTime = new Date().getTime()
	      var timeToCall = Math.max(0, 16 - (currTime - lastTime))
	
	      var id = w.setTimeout(function() {
	        callback(currTime + timeToCall)
	      }, timeToCall)
	
	      lastTime = currTime + timeToCall
	      return id
	    }
	
	  w.cancelAnimationFrame = w.cancelAnimationFrame || w.clearTimeout;
	
	}(window))
	
	return SVG
	
	}));

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dentalEditorHtml = __webpack_require__(638);
	
	var _dentalEditorHtml2 = _interopRequireDefault(_dentalEditorHtml);
	
	var _svgJs = __webpack_require__(636);
	
	var _svgJs2 = _interopRequireDefault(_svgJs);
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _zubiSvgJs = __webpack_require__(616);
	
	var veze = [{ svgId: 'v_2827', id: 15, celjust: 'G' }, { svgId: 'v_2726', id: 14, celjust: 'G' }, { svgId: 'v_2625', id: 13, celjust: 'G' }, { svgId: 'v_2524', id: 12, celjust: 'G' }, { svgId: 'v_2423', id: 11, celjust: 'G' }, { svgId: 'v_2322', id: 10, celjust: 'G' }, { svgId: 'v_2221', id: 9, celjust: 'G' }, { svgId: 'v_1121', id: 8, celjust: 'G' }, { svgId: 'v_1211', id: 7, celjust: 'G' }, { svgId: 'v_1312', id: 6, celjust: 'G' }, { svgId: 'v_1413', id: 5, celjust: 'G' }, { svgId: 'v_1514', id: 4, celjust: 'G' }, { svgId: 'v_1615', id: 3, celjust: 'G' }, { svgId: 'v_1716', id: 2, celjust: 'G' }, { svgId: 'v_1817', id: 1, celjust: 'G' }, { svgId: 'v_4847', id: 1, celjust: 'D' }, { svgId: 'v_4746', id: 2, celjust: 'D' }, { svgId: 'v_4645', id: 3, celjust: 'D' }, { svgId: 'v_4544', id: 4, celjust: 'D' }, { svgId: 'v_4443', id: 5, celjust: 'D' }, { svgId: 'v_4342', id: 6, celjust: 'D' }, { svgId: 'v_4241', id: 7, celjust: 'D' }, { svgId: 'v_4131', id: 8, celjust: 'D' }, { svgId: 'v_3231', id: 9, celjust: 'D' }, { svgId: 'v_3332', id: 10, celjust: 'D' }, { svgId: 'v_3433', id: 11, celjust: 'D' }, { svgId: 'v_3534', id: 12, celjust: 'D' }, { svgId: 'v_3635', id: 13, celjust: 'D' }, { svgId: 'v_3736', id: 14, celjust: 'D' }, { svgId: 'v_3837', id: 15, celjust: 'D' }];
	
	function mapVezu(id, celjust) {
	    var index = _lodash2['default'].findIndex(veze, function (v) {
	        return v.id === id && v.celjust === celjust;
	    });
	    if (index > -1) {
	        return veze[index];
	    }
	    return null;
	}
	
	function editor($document, $timeout) {
	    return {
	        restrict: 'E',
	        scope: {
	            plan: '=',
	            onClick: '&',
	            onVeza: '&'
	        },
	        link: function link(scope, iElement, attrs) {
	            var q = _jquery2['default'];
	
	            var onClickHandler = function onClickHandler(id) {
	                $timeout(function () {
	                    scope.onClick({ id: id });
	                });
	            };
	
	            function hideVeze() {
	                veze.map(function (veza) {
	                    var element = _svgJs2['default'].get(veza.svgId);
	                    element.hide();
	                });
	            }
	
	            function setClickHandler(onClickHandler) {
	                _zubiSvgJs.zubi.map(function (zub) {
	                    var element = _svgJs2['default'].get(zub.id);
	                    element.click(function () {
	                        onClickHandler(zub.id);
	                    });
	                });
	            }
	
	            function createBoundingBoxes() {
	                _zubiSvgJs.zubi.map(function (zub) {
	                    var element = _svgJs2['default'].get(zub.id);
	                    var bbox = drawBBox(element);
	                    bbox.attr('id', 'b' + zub.id);
	                    bbox.hide();
	                });
	            }
	
	            function drawBBox(group) {
	                var b = group.bbox();
	                var bbox = group.rect(b.width, b.height).addClass('box').move(b.x, b.y).style({ fill: 'none', 'stroke-width': 10, stroke: 'black' });
	                return bbox;
	            }
	
	            function toggleSelected(zub) {
	                var element = _svgJs2['default'].get('b' + zub.id);
	                element.hide();
	                if (zub.selected === true) {
	                    element.show();
	                }
	            }
	
	            function toggleFilled(zub) {
	                var element = _svgJs2['default'].get(zub.id);
	                element.children().map(function (c) {
	                    if (c.type === 'path') {
	                        c.style({ fill: '#fafafa' });
	                        if (zub.filled === true) {
	                            c.style({ fill: '#fff539' });
	                        }
	                    }
	                });
	            }
	
	            function toggleVeze(veza) {
	                var element = _svgJs2['default'].get(veza.svgId);
	                element.hide();
	                if (veza.active === true) {
	                    element.show();
	                }
	            }
	
	            scope.$on('$destroy', function () {
	                _zubiSvgJs.zubi.map(function (zub) {
	                    var element = _svgJs2['default'].get(zub.id);
	                    element.off();
	                });
	            });
	
	            // hideVeze();
	            setClickHandler(onClickHandler);
	            createBoundingBoxes();
	
	            scope.$watch('plan', function (newVal, oldVal) {
	                if (newVal && newVal.pozicije) {
	                    newVal.pozicije.map(function (zub) {
	                        toggleSelected(zub);
	                        toggleFilled(zub);
	                    });
	                }
	
	                if (newVal && newVal.veze) {
	                    newVal.veze.map(function (v) {
	                        var veza = mapVezu(v.id, v.celjust);
	                        if (veza !== null) {
	                            veza.active = v.active;
	                            toggleVeze(veza);
	                        }
	                    });
	                }
	            });
	        },
	        templateUrl: _dentalEditorHtml2['default']
	    };
	}
	
	editor.$inject = ['$document', '$timeout'];
	
	exports.editor = editor;

/***/ },
/* 638 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/dentalEditor.html';
	var html = "<div class=\"btn-toolbar\"><div class=\"btn-group\"><a ng-click=\"onVeza()\" class=\"btn btn-default\"><i class=\"fa fa-arrows-v\"></i></a></div></div><svg id=\"svg2\" version=\"1.1\" width=\"100%\" height=\"500\" viewBox=\"0 0 3228.7856 5051.4277\"><title id=\"DentalArches\">dental arches</title><metadata id=\"metadata8\"><rdf:rdf><cc:work rdf:about><dc:format>image/svg+xml</dc:format><dc:type rdf:resource=\"http://purl.org/dc/dcmitype/StillImage\"><dc:title>dental arches</dc:title></dc:type></cc:work></rdf:rdf></metadata><defs id=\"defs6\"><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"marker6877\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6875\" d=\"M -2.5,-1.0 C -2.5,1.7600000 -4.7400000,4.0 -7.5,4.0 C -10.260000,4.0 -12.5,1.7600000 -12.5,-1.0 C -12.5,-3.7600000 -10.260000,-6.0 -7.5,-6.0 C -4.7400000,-6.0 -2.5,-3.7600000 -2.5,-1.0 z\" style=\"fill-rule:evenodd;stroke:#e7262b;stroke-width:1pt;stroke-opacity:1;fill:#e7262b;fill-opacity:1\" transform=\"scale(0.2) translate(7.4, 1)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"DotS\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6658\" d=\"M -2.5,-1.0 C -2.5,1.7600000 -4.7400000,4.0 -7.5,4.0 C -10.260000,4.0 -12.5,1.7600000 -12.5,-1.0 C -12.5,-3.7600000 -10.260000,-6.0 -7.5,-6.0 C -4.7400000,-6.0 -2.5,-3.7600000 -2.5,-1.0 z\" style=\"fill-rule:evenodd;stroke:#e7262b;stroke-width:1pt;stroke-opacity:1;fill:#e7262b;fill-opacity:1\" transform=\"scale(0.2) translate(7.4, 1)\"></path></marker><marker inkscape:stockid=\"DotM\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"marker6871\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6869\" d=\"M -2.5,-1.0 C -2.5,1.7600000 -4.7400000,4.0 -7.5,4.0 C -10.260000,4.0 -12.5,1.7600000 -12.5,-1.0 C -12.5,-3.7600000 -10.260000,-6.0 -7.5,-6.0 C -4.7400000,-6.0 -2.5,-3.7600000 -2.5,-1.0 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:1pt;stroke-opacity:1;fill:#000000;fill-opacity:1\" transform=\"scale(0.4) translate(7.4, 1)\"></path></marker><marker inkscape:stockid=\"SquareM\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"marker6867\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6865\" d=\"M -5.0,-5.0 L -5.0,5.0 L 5.0,5.0 L 5.0,-5.0 L -5.0,-5.0 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:1pt;stroke-opacity:1;fill:#000000;fill-opacity:1\" transform=\"scale(0.4)\"></path></marker><marker inkscape:stockid=\"SquareL\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"SquareL\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6661\" d=\"M -5.0,-5.0 L -5.0,5.0 L 5.0,5.0 L 5.0,-5.0 L -5.0,-5.0 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:1pt;stroke-opacity:1;fill:#000000;fill-opacity:1\" transform=\"scale(0.8)\"></path></marker><marker inkscape:stockid=\"DotL\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"marker6861\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6859\" d=\"M -2.5,-1.0 C -2.5,1.7600000 -4.7400000,4.0 -7.5,4.0 C -10.260000,4.0 -12.5,1.7600000 -12.5,-1.0 C -12.5,-3.7600000 -10.260000,-6.0 -7.5,-6.0 C -4.7400000,-6.0 -2.5,-3.7600000 -2.5,-1.0 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:1pt;stroke-opacity:1;fill:#000000;fill-opacity:1\" transform=\"scale(0.8) translate(7.4, 1)\"></path></marker><marker inkscape:stockid=\"DotM\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"DotM\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6655\" d=\"M -2.5,-1.0 C -2.5,1.7600000 -4.7400000,4.0 -7.5,4.0 C -10.260000,4.0 -12.5,1.7600000 -12.5,-1.0 C -12.5,-3.7600000 -10.260000,-6.0 -7.5,-6.0 C -4.7400000,-6.0 -2.5,-3.7600000 -2.5,-1.0 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:1pt;stroke-opacity:1;fill:#000000;fill-opacity:1\" transform=\"scale(0.4) translate(7.4, 1)\"></path></marker><marker inkscape:stockid=\"SquareM\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"SquareM\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6664\" d=\"M -5.0,-5.0 L -5.0,5.0 L 5.0,5.0 L 5.0,-5.0 L -5.0,-5.0 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:1pt;stroke-opacity:1;fill:#000000;fill-opacity:1\" transform=\"scale(0.4)\"></path></marker><marker inkscape:stockid=\"DotL\" orient=\"auto\" refY=\"0.0\" refX=\"0.0\" id=\"DotL\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path id=\"path6652\" d=\"M -2.5,-1.0 C -2.5,1.7600000 -4.7400000,4.0 -7.5,4.0 C -10.260000,4.0 -12.5,1.7600000 -12.5,-1.0 C -12.5,-3.7600000 -10.260000,-6.0 -7.5,-6.0 C -4.7400000,-6.0 -2.5,-3.7600000 -2.5,-1.0 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:1pt;stroke-opacity:1;fill:#000000;fill-opacity:1\" transform=\"scale(0.8) translate(7.4, 1)\"></path></marker><marker style=\"overflow:visible\" inkscape:stockid=\"InfiniteLineEnd\" id=\"InfiniteLineEnd\" refX=\"0\" refY=\"0\" orient=\"auto\"><g id=\"g4021\"><circle id=\"circle4023\" r=\"0.85333335\" cy=\"0\" cx=\"3.2\" style=\"stroke-width:1.06666672\"></circle><circle id=\"circle4025\" r=\"0.85333335\" cy=\"0\" cx=\"6.9333334\" style=\"stroke-width:1.06666672\"></circle><circle id=\"circle4027\" r=\"0.85333335\" cy=\"0\" cx=\"10.666667\" style=\"stroke-width:1.06666672\"></circle></g></marker><marker inkscape:stockid=\"TriangleInS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"TriangleInS\" style=\"overflow:visible\"><path id=\"path3925\" d=\"M -1.2309333,0 0.6144,-1.0666667 v 2.1333334 z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:0.21333334pt;marker-start:none\" inkscape:connector-curvature=\"0\"></path></marker><marker inkscape:stockid=\"Arrow1Sstart\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"Arrow1Sstart\" style=\"overflow:visible\"><path id=\"path3797\" d=\"M 1.28,0 2.3466667,-1.0666667 -1.3866667,0 2.3466667,1.0666667 Z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:0.21333334pt;marker-start:none\" inkscape:connector-curvature=\"0\"></path></marker><marker inkscape:stockid=\"Arrow1Lstart\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"Arrow1Lstart\" style=\"overflow:visible\"><path id=\"path3785\" d=\"M 10.666667,0 14.933333,-4.2666667 0,0 14.933333,4.2666667 Z\" style=\"fill-rule:evenodd;stroke:#000000;stroke-width:0.85333335pt;marker-start:none\" inkscape:connector-curvature=\"0\"></path></marker><filter inkscape:collect=\"always\" style=\"color-interpolation-filters:sRGB\" id=\"filter5700\" x=\"-0.082917101\" width=\"1.1658342\" y=\"-0.085111558\" height=\"1.1702231\"><fegaussianblur inkscape:collect=\"always\" stdDeviation=\"67.364997\" id=\"feGaussianBlur5702\"></fegaussianblur></filter><filter inkscape:collect=\"always\" style=\"color-interpolation-filters:sRGB\" id=\"filter5700-6\" x=\"-0.082917102\" width=\"1.1658342\" y=\"-0.085111558\" height=\"1.1702231\"><fegaussianblur inkscape:collect=\"always\" stdDeviation=\"67.364997\" id=\"feGaussianBlur5702-2\"></fegaussianblur></filter><filter inkscape:collect=\"always\" style=\"color-interpolation-filters:sRGB\" id=\"filter5242\" x=\"-1.7965439\" width=\"4.5930879\" y=\"-0.1285891\" height=\"1.2571782\"><fegaussianblur inkscape:collect=\"always\" stdDeviation=\"65.219785\" id=\"feGaussianBlur5244\"></fegaussianblur></filter><filter inkscape:collect=\"always\" style=\"color-interpolation-filters:sRGB\" id=\"filter5270\" x=\"-0.67900695\" width=\"2.3580139\" y=\"-0.056159022\" height=\"1.112318\"><fegaussianblur inkscape:collect=\"always\" stdDeviation=\"28.290032\" id=\"feGaussianBlur5272\"></fegaussianblur></filter><filter inkscape:collect=\"always\" style=\"color-interpolation-filters:sRGB\" id=\"filter5274\" x=\"-0.67900695\" width=\"2.3580139\" y=\"-0.056159019\" height=\"1.112318\"><fegaussianblur inkscape:collect=\"always\" stdDeviation=\"28.290032\" id=\"feGaussianBlur5276\"></fegaussianblur></filter><filter inkscape:collect=\"always\" style=\"color-interpolation-filters:sRGB\" id=\"filter5242-1\" x=\"-1.796544\" width=\"4.5930877\" y=\"-0.12858909\" height=\"1.2571782\"><fegaussianblur inkscape:collect=\"always\" stdDeviation=\"65.219785\" id=\"feGaussianBlur5244-2\"></fegaussianblur></filter><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-7\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-8\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-3\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-9\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-5\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-1\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-1\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-3\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-4\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-7\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-43\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-2\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-5\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-2\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-3\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-34\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-3\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-1\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-1\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-5\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-2\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-8-5\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-0-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-0\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-8-5-3\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-5\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-0-8-6\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-0-5\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-8-5-3-1\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-5-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-0-8-6-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-0-58\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-8-5-3-5\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-5-91\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-0-8-6-9\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-08\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-8-5-2\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-6\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-0-8-1\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-1\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-8-2\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-3\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-0-3\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-9-9\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-1-0\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-0-6\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-4-8\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-8-6\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-4-3\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-0-2\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-3-6\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-7-5\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-4-46\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-9-2\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-5-4\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"marker6877-8-9-2-3-7-1-8-9-8-8\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6875-6-0-0-8-3-4-0-0-8-5\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker><marker inkscape:stockid=\"DotS\" orient=\"auto\" refY=\"0\" refX=\"0\" id=\"DotS-5-4-4-4-0-3-2-4-8-4\" style=\"overflow:visible\" inkscape:isstock=\"true\"><path inkscape:connector-curvature=\"0\" id=\"path6658-2-6-4-0-2-6-6-3-8-4\" d=\"m -2.5,-1 c 0,2.76 -2.24,5 -5,5 -2.76,0 -5,-2.24 -5,-5 0,-2.76 2.24,-5 5,-5 2.76,0 5,2.24 5,5 z\" style=\"fill:#e7262b;fill-opacity:1;fill-rule:evenodd;stroke:#e7262b;stroke-width:1.00000003pt;stroke-opacity:1\" transform=\"matrix(0.2,0,0,0.2,1.48,0.2)\"></path></marker></defs><g id=\"donja_celjust_podloga\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccsccsccccccsssscccc\" inkscape:connector-curvature=\"0\" id=\"path5505-5\" d=\"m 2592.1824,2749.6056 c -59.014,-3.3903 -94.0504,-114.3914 -177.042,39.0024 -92.5285,150.3969 -321.3773,262.2008 -545.5048,329.0004 -95.4963,50.8773 -419.3933,49.4694 -548.4005,14.2059 -132.421,-22.3415 -358.19709,-109.3397 -478.45623,-270.285 -106.39977,-142.3971 -273.29881,-190.674 -380.70425,-108.1234 -2.9849,17.2373 7.46784,301.714 7.26361,325.5849 -0.20415,23.8708 115.36552,354.4311 116.39363,371.4026 1.0282,16.9716 147.85588,449.4566 147.85588,449.4566 34.95078,71.1305 22.80732,141.539 178.09201,214.5143 -28.49334,142.3321 130.37285,207.737 206.67315,320.8748 l 354.6676,93.7786 347.8451,-2.0253 195.6628,-85.8249 c 0,0 159.5427,-94.2431 197.4689,-158.9193 37.9262,-64.6764 119.4289,-261.4526 144.7334,-258.5717 25.3046,2.8809 75.043,-172.2749 86.8732,-221.771 11.8302,-49.496 44.7009,-199.9545 81.9068,-236.9058 37.2057,-36.9512 76.0977,-310.7276 76.0977,-310.7276 l -44.159,-313.3556 112.1292,-96.931 z\" style=\"fill:#e68678;fill-opacity:1;stroke:#000000;stroke-width:0.70688009px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\" transform=\"translate(54.543923,59.416001)\"></path><path sodipodi:nodetypes=\"ccccccccc\" transform=\"matrix(0.59512449,0,0,0.64302059,627.32264,2653.9532)\" inkscape:connector-curvature=\"0\" id=\"path5132-1\" d=\"m 1591.9967,1063.0677 -8.197,158.4637 -54.6151,732.0644 100.3825,326.7406 h 41.3596 l 77.6504,-335.0125 -54.856,-566.6261 -55.8821,-293.653 z\" style=\"opacity:0.28999999;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;filter:url(#filter5242-1)\"></path><path transform=\"matrix(-0.81654363,0.0450688,0.00717461,-0.7439507,1900.6478,6325.534)\" sodipodi:nodetypes=\"cccsssccscsscscccccsccccscccsscssssssscc\" inkscape:connector-curvature=\"0\" id=\"path5670-8\" d=\"m -502.38833,4392.8125 140.62254,-181.9821 c 0,0 -4.13596,-272.9732 8.27196,-330.8766 12.4078,-57.9034 78.58313,-322.6046 90.99102,-392.9159 12.4079,-70.3113 41.3596,-180.8665 62.0394,-272.9732 10.1299,-45.1182 95.127,-252.2934 103.3989,-293.653 8.2719,-41.3595 165.4383,-186.118 165.4383,-186.118 h 227.47757 c 0,0 132.3507,-45.4956 173.7102,-37.2237 41.3596,8.272 62.03936,62.0394 95.12696,78.5832 33.0877,16.5439 78.5832,41.3596 107.5349,66.1753 28.9517,24.8158 74.4472,45.4956 103.3989,111.6709 28.9517,66.1753 148.8945,140.6225 165.4383,215.0698 16.5439,74.4472 74.44728,384.644 82.71918,413.5957 8.2719,28.9517 62.0394,202.6618 66.1753,268.8371 4.136,66.1754 70.3113,413.5958 70.3113,413.5958 l 57.9034,144.7585 62.0393,45.4955 c 0,0 53.7675,-153.0304 57.9034,-173.7102 4.136,-20.6798 36.4499,-153.2689 -12.7947,-233.8008 -49.2446,-80.5319 -103.0121,-196.3387 -107.148,-233.5623 -4.136,-37.2236 -28.9517,-231.6136 -37.2236,-281.2451 -8.272,-49.6315 12.4078,-66.1753 8.2719,-136.4866 -4.136,-70.3113 -62.0394,-186.1181 -74.4473,-223.3417 -12.4078,-37.2236 -115.80678,-264.7012 -132.35058,-285.381 -16.5438,-20.6798 -219.2057,-169.5743 -219.2057,-169.5743 l -103.399,-111.6708 -244.02136,-74.4472 c 0,0 -100.5799,55.708 -161.3023,33.0876 -60.72237,-22.6203 -252.29337,28.9517 -281.24507,49.6315 -28.9517,20.6798 -136.4866,128.2147 -153.0304,144.7585 -16.5439,16.5438 -103.39899,177.8462 -111.6709,210.9338 -8.27192,33.0877 -124.07872,132.3507 -144.75851,186.1181 -20.67978,53.7675 0,190.254 -4.13595,210.9338 -4.13596,20.6798 -8.27192,144.7585 -33.08766,215.0698 -24.81574,70.3112 -111.67084,227.4776 -107.53488,252.2934 4.13595,24.8157 53.76744,227.4776 33.08765,293.6529 -20.67979,66.1753 -49.63149,153.0304 -49.63149,177.8462 v 111.6708 z\" style=\"opacity:0.45;fill:#876c51;fill-opacity:1;stroke:#000000;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;filter:url(#filter5700-6)\"></path><text transform=\"scale(0.94366402,1.0596992)\" id=\"text4924-0-9-9\" y=\"3516.8428\" x=\"1359.5511\" style=\"font-style:normal;font-weight:normal;font-size:118.41142273px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:2.96028543\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:2.96028543\" y=\"3516.8428\" x=\"1359.5511\" id=\"tspan4922-1-3-0\" sodipodi:role=\"line\">donja čeljust</tspan></text><text transform=\"scale(0.99504033,1.0049844)\" id=\"text4924-0-8-7-0\" y=\"3821.4353\" x=\"1586.1835\" style=\"font-style:normal;font-weight:normal;font-size:91.79654694px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#fefefe;fill-opacity:1;stroke:none;stroke-width:2.29491353\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#fefefe;fill-opacity:1;stroke-width:2.29491353\" y=\"3821.4353\" x=\"1586.1835\" id=\"tspan4922-1-8-0-5\" sodipodi:role=\"line\">lower jaw</tspan></text></g><g id=\"gornja_celjust_podloga\" transform=\"translate(61.329746,-199.94518)\"><g id=\"g8862\"><path style=\"fill:#e68678;fill-opacity:1;stroke:#000000;stroke-width:0.70688009px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\" d=\"m 618.74575,2522.4238 265.54048,67.804 c 203.93317,-11.5801 394.13757,-145.0994 561.87927,-252.2477 98.3813,-44.4629 265.1259,-57.1298 391.743,-13.4089 254.2032,121.2855 576.6957,417.7234 856.5653,229.9013 4.0211,-17.0055 10.7885,-301.6041 12.4355,-325.4137 1.647,-23.8097 -93.7061,-361.3483 -93.7061,-378.3538 0,-17.0056 -120.3863,-458.3316 -120.3863,-458.3316 -30.5804,-73.2985 -14.2043,-142.7634 -164.7664,-225.8576 37.0417,-140.164 -117.5524,-215.93973 -186.8599,-333.89489 L 1792.9022,715.58508 1445.6305,694.6125 1245.1702,767.33167 c 0,0 -164.9214,83.50829 -206.682,145.54811 -41.76058,62.03981 -134.99717,253.03492 -160.07694,248.48702 -25.07976,-4.5479 -85.30851,166.9696 -100.1075,215.5847 -14.799,48.615 -56.7007,196.5997 -96.06611,231.0177 -39.3654,34.4179 -94.73191,305.0757 -94.73191,305.0757 l 25.12539,315.6479 -38.1173,217.2061 z\" id=\"path5505\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccsccccccsssscccc\"></path><g id=\"g8849\"><path transform=\"matrix(0.81986743,0,0,0.85728476,306.83172,451.98766)\" sodipodi:nodetypes=\"cccsssccscsscscccccsccccscccsscssssssscc\" inkscape:connector-curvature=\"0\" id=\"path5670\" d=\"m 769.28804,2371.3275 140.62254,-181.9821 c 0,0 -4.13596,-272.9732 8.27196,-330.8766 12.4078,-57.9034 78.58313,-322.6046 90.99106,-392.9159 12.4079,-70.3113 41.3596,-180.8665 62.0394,-272.9732 10.1299,-45.1182 95.127,-252.29339 103.3989,-293.65299 8.2719,-41.35956 165.4383,-186.11806 165.4383,-186.11806 h 227.4776 c 0,0 132.3507,-45.49553 173.7102,-37.22362 41.3596,8.27192 62.0394,62.03936 95.127,78.58319 33.0877,16.54383 78.5832,41.35957 107.5349,66.17531 28.9517,24.81575 74.4472,45.49553 103.3989,111.67085 28.9517,66.17531 148.8945,140.62252 165.4383,215.06982 16.5439,74.4472 74.4473,384.644 82.7192,413.5957 8.2719,28.9517 62.0394,202.6618 66.1753,268.8371 4.136,66.1754 70.3113,413.5958 70.3113,413.5958 l 57.9034,144.7585 62.0393,45.4955 c 0,0 53.7675,-153.0304 57.9034,-173.7102 4.136,-20.6798 36.4499,-153.2689 -12.7947,-233.8008 -49.2446,-80.5319 -103.0121,-196.3387 -107.148,-233.5623 -4.136,-37.2236 -28.9517,-231.6136 -37.2236,-281.2451 -8.272,-49.6315 12.4078,-66.1753 8.2719,-136.4866 -4.136,-70.3113 -62.0394,-186.1181 -74.4473,-223.3417 C 2374.0395,1113.9965 2270.6405,886.51885 2254.0967,865.83906 2237.5529,845.15928 2034.891,696.26482 2034.891,696.26482 L 1931.492,584.59398 1687.4706,510.14674 c 0,0 -100.5799,55.708 -161.3023,33.08767 -60.7224,-22.62034 -252.2934,28.95169 -281.2451,49.63148 -28.9517,20.67979 -136.4866,128.21467 -153.0304,144.7585 -16.5439,16.54383 -103.39903,177.84616 -111.67094,210.93382 -8.27192,33.08765 -124.07872,132.35069 -144.75851,186.11809 -20.67978,53.7675 0,190.254 -4.13595,210.9338 -4.13596,20.6798 -8.27192,144.7585 -33.08766,215.0698 -24.81574,70.3112 -111.67084,227.4776 -107.53488,252.2934 4.13595,24.8157 53.76744,227.4776 33.08765,293.6529 -20.67979,66.1753 -49.63149,153.0304 -49.63149,177.8462 v 111.6708 z\" style=\"opacity:0.45;fill:#876c51;fill-opacity:1;stroke:#000000;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;filter:url(#filter5700)\"></path></g><path style=\"opacity:0.36000001;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;filter:url(#filter5242)\" d=\"m 1591.9967,1063.0677 -8.197,158.4637 -54.6151,732.0644 100.3825,326.7406 h 41.3596 l 77.6504,-335.0125 -54.856,-566.6261 -55.8821,-293.653 z\" id=\"path5132\" inkscape:connector-curvature=\"0\" transform=\"matrix(0.57081509,0,0,0.93899596,683.26097,64.851377)\" sodipodi:nodetypes=\"ccccccccc\"></path><text xml:space=\"preserve\" style=\"font-style:normal;font-weight:normal;font-size:118.41142273px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:2.96028543\" x=\"1368.5487\" y=\"1607.1218\" id=\"text4924-0-9\" transform=\"scale(0.94366402,1.0596992)\"><tspan sodipodi:role=\"line\" id=\"tspan4922-1-3\" x=\"1368.5487\" y=\"1607.1218\" style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:2.96028543\">gornja čeljust</tspan></text><text xml:space=\"preserve\" style=\"font-style:normal;font-weight:normal;font-size:91.79654694px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#fefefe;fill-opacity:1;stroke:none;stroke-width:2.29491353\" x=\"1594.7163\" y=\"1807.7426\" id=\"text4924-0-8-7\" transform=\"scale(0.99504033,1.0049844)\"><tspan sodipodi:role=\"line\" id=\"tspan4922-1-8-0\" x=\"1594.7163\" y=\"1807.7426\" style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#fefefe;fill-opacity:1;stroke-width:2.29491353\">upper jaw</tspan></text></g><path inkscape:connector-curvature=\"0\" id=\"path4873\" d=\"m 1483.8065,1050.6598 99.9932,170.8716 -66.1753,537.6744 66.1753,268.8372 -53.7674,231.6136\" style=\"fill:none;stroke:#7c5a51;stroke-width:2.70000005;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;filter:url(#filter5270)\"></path><path transform=\"matrix(-1,0,0,1,3399.7569,297.78892)\" inkscape:connector-curvature=\"0\" id=\"path4873-7\" d=\"m 1633.338,770.06335 99.9932,170.8716 -66.1753,537.67445 66.1753,268.8372 -53.7674,231.6136\" style=\"fill:none;stroke:#7c5a51;stroke-width:2.70000005;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;filter:url(#filter5274)\"></path></g><g inkscape:groupmode=\"layer\" id=\"layer1\" inkscape:label=\"svg\" transform=\"translate(54.543923,59.416001)\"><g id=\"kvadranti\" transform=\"translate(61.329746,-199.94518)\"><path inkscape:connector-curvature=\"0\" id=\"path4918\" d=\"m 1240.417,2762.089 h 818.3442\" style=\"display:inline;fill:none;stroke:#e68678;stroke-width:2.96028543px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"></path><path inkscape:connector-curvature=\"0\" id=\"path4920\" d=\"m 1660.8769,2450.962 v 614.759\" style=\"display:inline;fill:none;stroke:#e68678;stroke-width:2.96028543px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"></path></g><g id=\"kvadrant_1\" transform=\"translate(61.329746,-199.94518)\"><rect rx=\"1.5493526\" y=\"2443.2776\" x=\"1334.3092\" height=\"205.58905\" width=\"230.18442\" id=\"rect5546\" style=\"opacity:1;fill:#f0f0f0;fill-opacity:1;stroke:#e68678;stroke-width:12.67453098;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" transform=\"translate(54.543923,59.416001)\"></rect><text transform=\"scale(0.94366402,1.0596992)\" id=\"text4924-9-00\" y=\"2526.01\" x=\"1536.6976\" style=\"font-style:normal;font-weight:normal;font-size:184.51570129px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:4.61289167\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:4.61289167\" y=\"2526.01\" x=\"1536.6976\" id=\"tspan4922-2-2\" sodipodi:role=\"line\">1</tspan></text></g><g id=\"kvadrant_2\" transform=\"translate(61.329746,-199.94518)\"><rect rx=\"1.5493526\" y=\"2502.6936\" x=\"1717.3455\" height=\"205.58905\" width=\"230.18442\" id=\"rect5546-6\" style=\"opacity:1;fill:#f0f0f0;fill-opacity:1;stroke:#e68678;stroke-width:12.67453098;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></rect><text transform=\"scale(0.94366402,1.0596992)\" id=\"text4924-9-00-2\" y=\"2526.01\" x=\"1890.0137\" style=\"font-style:normal;font-weight:normal;font-size:184.51570129px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:4.61289167\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:4.61289167\" y=\"2526.01\" x=\"1890.0137\" id=\"tspan4922-2-2-1\" sodipodi:role=\"line\">2</tspan></text></g><g id=\"kvadrant_3\" transform=\"translate(61.329746,-199.94518)\"><rect rx=\"1.5493526\" y=\"2813.1799\" x=\"1719.7433\" height=\"205.58905\" width=\"230.18442\" id=\"rect5546-6-9\" style=\"opacity:1;fill:#f0f0f0;fill-opacity:1;stroke:#e68678;stroke-width:12.67453098;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></rect><text transform=\"scale(0.94366402,1.0596992)\" id=\"text4924-9-00-2-7\" y=\"2822.2407\" x=\"1896.03\" style=\"font-style:normal;font-weight:normal;font-size:184.51570129px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:4.61289167\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:4.61289167\" y=\"2822.2407\" x=\"1896.03\" id=\"tspan4922-2-2-1-3\" sodipodi:role=\"line\">3</tspan></text></g><g id=\"kvadrant_4\" transform=\"translate(61.329746,-199.94518)\"><rect rx=\"1.5493526\" y=\"2808.8286\" x=\"1383.4233\" height=\"205.58905\" width=\"230.18442\" id=\"rect5546-6-9-7\" style=\"opacity:1;fill:#f0f0f0;fill-opacity:1;stroke:#e68678;stroke-width:12.67453098;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></rect><text transform=\"scale(0.94366402,1.0596992)\" id=\"text4924-9-00-2-7-3\" y=\"2818.1348\" x=\"1534.4191\" style=\"font-style:normal;font-weight:normal;font-size:184.51570129px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:4.61289167\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:4.61289167\" y=\"2818.1348\" x=\"1534.4191\" id=\"tspan4922-2-2-1-3-7\" sodipodi:role=\"line\">4</tspan></text></g><g id=\"label_right\" transform=\"translate(61.329746,-199.94518)\"><text transform=\"scale(0.94366402,1.0596992)\" id=\"text4924-0\" y=\"2606.6133\" x=\"943.66876\" style=\"font-style:normal;font-weight:normal;font-size:118.41142273px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:2.96028543\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:2.96028543\" y=\"2606.6133\" x=\"943.66876\" id=\"tspan4922-1\" sodipodi:role=\"line\">desno</tspan></text><text transform=\"scale(0.99504034,1.0049844)\" id=\"text4924-0-8\" y=\"2830.7512\" x=\"958.14813\" style=\"font-style:normal;font-weight:normal;font-size:91.79654694px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#e68678;fill-opacity:1;stroke:none;stroke-width:2.29491353\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#e68678;fill-opacity:1;stroke-width:2.29491353\" y=\"2830.7512\" x=\"958.14813\" id=\"tspan4922-1-8\" sodipodi:role=\"line\">right</tspan></text></g><g id=\"label_left\" transform=\"translate(61.329746,-199.94518)\"><text inkscape:transform-center-y=\"49.639816\" inkscape:transform-center-x=\"-3.3909021\" transform=\"scale(0.94366402,1.0596992)\" id=\"text4924-0-6\" y=\"2610.4927\" x=\"2242.4734\" style=\"font-style:normal;font-weight:normal;font-size:118.41142273px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#000000;fill-opacity:1;stroke:none;stroke-width:2.96028543\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:2.96028543\" y=\"2610.4927\" x=\"2242.4734\" id=\"tspan4922-1-0\" sodipodi:role=\"line\">lijevo</tspan></text><text transform=\"scale(0.99504034,1.0049844)\" id=\"text4924-0-8-3\" y=\"2838.4304\" x=\"2203.9419\" style=\"font-style:normal;font-weight:normal;font-size:91.79654694px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#e68678;fill-opacity:1;stroke:none;stroke-width:2.29491353\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#e68678;fill-opacity:1;stroke-width:2.29491353\" y=\"2838.4304\" x=\"2203.9419\" id=\"tspan4922-1-8-1\" sodipodi:role=\"line\">left</tspan></text></g><g id=\"11\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccscccccc\" inkscape:connector-curvature=\"0\" id=\"path3908\" d=\"m 1319.8714,741.52191 c 0.5697,5.49329 31.249,62.05861 38.9836,87.60917 10.4584,27.5848 27.1124,52.52192 71.4565,65.62539 36.2089,-4.64928 72.9328,-5.6435 103.4124,-50.95709 l 74.934,-118.82976 13.6649,-37.8015 c 9.8669,-27.29492 -11.5014,-52.39309 -31.5058,-63.15109 l -54.2432,-15.12639 c -31.6811,-2.12262 -52.7097,-11.83216 -114.6123,7.56936 l -58.0837,13.24228 c -21.1301,9.74313 -49.3469,5.92953 -49.8956,55.04514 1.1105,18.77386 -5.9219,36.1057 5.8892,56.77449 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"731.54535\" cx=\"1456.3594\" id=\"path5780\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8\" y=\"715.59778\" x=\"1508.4896\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"715.59778\" x=\"1508.4896\" id=\"tspan4922-2-2-0\" sodipodi:role=\"line\">11</tspan></text></g><g id=\"12\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3900\" d=\"m 1092.0696,790.56187 c 116.6474,-80.06935 92.7495,-56.69826 142.6744,-74.49893 17.4022,-6.50335 31.8477,-7.47581 39.1908,4.83714 l 27.0693,28.45329 c 18.3958,24.17382 17.1716,29.30587 19.5066,37.8923 8.6657,74.74875 -1.3489,73.81052 -3.28,105.62463 -13.339,27.07874 -29.4483,51.24563 -56.7022,63.69793 -16.8193,12.40669 -40.111,11.1886 -64.8531,6.91726 l -40.6848,-10.35942 c -15.9519,2.5083 -29.6957,-8.61614 -43.6808,-18.25071 -29.5142,-21.66352 -37.1424,-52.41157 -47.2903,-82.11375 -2.0415,-19.21147 3.1859,-36.22979 15.2062,-51.19856 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"848.83014\" cx=\"1195.2916\" id=\"path5780-0\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2\" y=\"827.52869\" x=\"1225.7437\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"827.52869\" x=\"1225.7437\" id=\"tspan4922-2-2-0-5\" sodipodi:role=\"line\">12</tspan></text></g><g id=\"13\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3892\" d=\"m 945.00016,1114.9432 c -47.26415,-16.4879 -69.39763,-46.6528 -74.42081,-86.1296 -5.8394,-38.59852 0.60863,-76.24553 22.89919,-112.66568 19.49221,-56.71859 38.83454,-53.57779 58.19427,-57.38737 17.26956,2.2773 32.9654,1.24182 48.25148,-0.65623 46.20471,-2.14072 63.41631,19.76905 74.55111,34.10144 38.9888,54.59102 34.6841,86.39903 44.1662,125.46224 4.8776,43.1326 2.7261,80.0129 -18.3443,100.0653 -64.1084,50.1368 -75.0059,25.5699 -101.83548,23.3705 -49.96163,-22.003 -37.11114,-18.0479 -53.46166,-26.1606 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1000.9074\" cx=\"991.427\" id=\"path5780-0-0\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-9\" y=\"966.56213\" x=\"999.95386\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"966.56213\" x=\"999.95386\" id=\"tspan4922-2-2-0-5-6\" sodipodi:role=\"line\">13</tspan></text></g><g id=\"14\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3876\" d=\"m 816.85519,1107.4976 c -71.35628,25.9836 -76.04723,61.8349 -76.39047,98.3297 -3.62986,160.5225 126.68612,157.8052 151.92434,145.465 39.70636,5.1417 67.28304,0.3651 88.9837,-9.2161 40.51984,-3.2505 60.03704,-28.5775 66.51284,-67.6126 5.9314,-20.9536 7.9535,-43.9645 -2.0782,-73.3186 -7.3335,-16.3952 -2.3466,-32.1124 -47.36925,-50.5815 -47.4746,-5.4716 -62.50273,-18.0625 -82.09599,-31.7572 -28.18395,-31.9804 -63.24272,-25.0035 -99.48697,-11.3087 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1226.0988\" cx=\"877.36908\" id=\"path5780-0-0-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4\" y=\"1177.6793\" x=\"870.39203\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"1177.6793\" x=\"870.39203\" id=\"tspan4922-2-2-0-5-7\" sodipodi:role=\"line\">14</tspan></text></g><g id=\"15\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccccc\" inkscape:connector-curvature=\"0\" id=\"path3063\" d=\"m 747.76243,1357.3473 c -85.49152,12.7528 -126.03866,58.8638 -100.1564,154.279 27.2605,35.017 52.04406,72.6104 98.31845,87.8494 16.39629,-0.3556 30.79389,1.368 40.62746,7.8388 14.19602,4.0604 30.46068,4.0329 48.03391,1.4195 33.09453,-18.3784 77.59372,-3.0885 96.23552,-64.1337 15.38886,-48.8439 12.76204,-91.855 -24.32487,-123.7092 -73.29806,-64.0961 -113.58627,-58.7052 -158.73407,-63.5438 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1486.385\" cx=\"789.63208\" id=\"path5780-0-0-7-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3\" y=\"1412.6582\" x=\"780.73895\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"1412.6582\" x=\"780.73895\" id=\"tspan4922-2-2-0-5-7-9\" sodipodi:role=\"line\">15</tspan></text></g><g id=\"16\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccccccc\" inkscape:connector-curvature=\"0\" id=\"path5187\" d=\"m 574.64103,1628.6295 c 86.59906,-78.593 150.44312,-33.1984 214.29051,12.1781 17.24168,22.3715 34.10839,44.7421 57.72323,67.1311 72.31341,72.6679 58.71157,121.984 16.83457,163.615 -26.10053,30.2781 -51.09742,59.9828 -64.25912,83.5405 -15.08499,16.2408 -28.9539,28.6998 -40.73388,34.6629 -55.74478,26.1736 -77.02835,-10.3306 -108.32055,-28.6313 -112.42692,-61.9606 -152.68837,-148.271 -123.75894,-257.9275 3.18697,-42.2764 22.20285,-63.1571 48.22418,-74.5688 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1787.615\" cx=\"690.19696\" id=\"path5780-0-0-7-7-1\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9\" y=\"1696.6201\" x=\"672.04163\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"1696.6201\" x=\"672.04163\" id=\"tspan4922-2-2-0-5-7-9-2\" sodipodi:role=\"line\">16</tspan></text></g><g id=\"17\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccscccc\" inkscape:connector-curvature=\"0\" id=\"path5171\" d=\"m 456.30537,2156.3626 c -17.62925,-25.2605 -15.32374,-62.03 -3.43397,-104.3329 45.36996,-108.6631 126.8785,-132.0825 253.85717,-48.2469 39.82951,16.8114 71.40452,49.1378 92.17596,81.3928 20.43269,31.729 39.40323,47.0023 29.30334,103.1157 -23.31949,94.5225 -63.59923,168.6699 -177.75485,154.0667 -45.35733,-5.7693 -85.41216,6.6502 -142.77973,-40.3171 -22.20703,-38.4344 -64.99962,-35.8743 -51.36792,-145.6783 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"2161.9592\" cx=\"617.08289\" id=\"path5780-0-0-7-7-1-9\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2\" y=\"2046.0098\" x=\"594.64795\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"2046.0098\" x=\"594.64795\" id=\"tspan4922-2-2-0-5-7-9-2-6\" sodipodi:role=\"line\">17</tspan></text></g><g id=\"18\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccccccczc\" inkscape:connector-curvature=\"0\" id=\"path2994\" d=\"m 590.51328,2340.584 c 50.2712,4.8036 95.60485,17.3109 126.13697,46.0673 43.58781,23.5561 71.39704,48.2473 69.09676,75.1045 13.95173,40.9371 3.09292,70.6753 -5.07871,101.6264 l -23.22215,50.8103 c -14.68869,29.5722 -45.04378,49.257 -92.5253,58.1335 -55.89689,9.6883 -111.79863,21.3087 -167.58801,-11.943 -63.5169,-24.7746 -66.53943,-59.9217 -72.64065,-94.5408 -18.74601,-35.5125 -31.29723,-78.274 -23.86243,-144.4223 6.58749,-30.2372 14.95962,-68.677 55.95172,-86.2465 40.99209,-17.5694 77.7477,-8.4538 133.7318,5.4106 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"2498.2839\" cx=\"561.51617\" id=\"path5780-0-0-7-7-1-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8\" y=\"2357.2725\" x=\"541.27869\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"2357.2725\" x=\"541.27869\" id=\"tspan4922-2-2-0-5-7-9-2-6-2\" sodipodi:role=\"line\">18</tspan></text></g><g id=\"21\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 1940.9683,741.95351 c -0.5697,5.4933 -31.249,62.05861 -38.9837,87.6092 -10.4583,27.58478 -27.1123,52.52192 -71.4564,65.62538 -36.209,-4.64929 -72.9329,-5.64351 -103.4124,-50.9571 l -74.934,-118.82975 -13.6649,-37.80151 c -9.867,-27.29491 11.5013,-52.39309 31.5059,-63.15109 l 54.2431,-15.12639 c 31.6811,-2.1226 52.7096,-11.83217 114.6123,7.56937 l 58.0837,13.24227 c 21.1301,9.74314 49.3468,5.92953 49.8956,55.04514 -1.1105,18.77385 5.9219,36.1057 -5.8892,56.77448 z\" id=\"path4364\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccscccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"731.54535\" cx=\"1798.6064\" id=\"path5780-6\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-3\" y=\"715.59778\" x=\"1875.7483\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"715.59778\" x=\"1875.7483\" id=\"tspan4922-2-2-0-4\" sodipodi:role=\"line\">21</tspan></text></g><g id=\"22\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2168.7701,790.99347 c -116.6474,-80.06934 -92.7496,-56.69825 -142.6743,-74.49892 -17.4022,-6.50336 -31.8478,-7.4758 -39.1909,4.83715 l -27.0693,28.45327 c -18.3958,24.17384 -17.1716,29.30588 -19.5067,37.89231 -8.6656,74.74874 1.349,73.81052 3.2801,105.62463 13.339,27.07873 29.4482,51.24562 56.7023,63.69793 16.8191,12.40668 40.1108,11.1886 64.853,6.91726 l 40.6848,-10.35941 c 15.9518,2.50829 29.6957,-8.61616 43.6808,-18.25072 29.5142,-21.66352 37.1424,-52.41158 47.2903,-82.11375 2.0415,-19.21148 -3.1859,-36.2298 -15.2062,-51.19855 z\" id=\"path4356\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"848.83014\" cx=\"2053.0435\" id=\"path5780-6-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-6\" y=\"827.05994\" x=\"2149.0474\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"827.05994\" x=\"2149.0474\" id=\"tspan4922-2-2-0-5-61\" sodipodi:role=\"line\">22</tspan></text></g><g id=\"23\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2315.8395,1115.3748 c 47.2642,-16.4879 69.3977,-46.6528 74.4208,-86.1296 5.8394,-38.59851 -0.6086,-76.24552 -22.8992,-112.66568 -19.4922,-56.71858 -38.8345,-53.57779 -58.1942,-57.38736 -17.2696,2.27729 -32.9654,1.24182 -48.2515,-0.65622 -46.2047,-2.14073 -63.4163,19.76904 -74.5511,34.10143 -38.9888,54.59103 -34.6841,86.39903 -44.1661,125.46233 -4.8777,43.1325 -2.7262,80.0128 18.3442,100.0652 64.1085,50.1368 75.0059,25.57 101.8355,23.3705 49.9615,-22.003 37.1111,-18.0479 53.4616,-26.1606 z\" id=\"path4348\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1003.832\" cx=\"2260.6875\" id=\"path5780-6-7-8\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-9-3\" y=\"966.56213\" x=\"2378.9341\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"966.56213\" x=\"2378.9341\" id=\"tspan4922-2-2-0-5-6-5\" sodipodi:role=\"line\">23</tspan></text></g><g id=\"24\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2443.9845,1107.9292 c 71.3563,25.9836 76.0472,61.8349 76.3905,98.3297 3.6299,160.5225 -126.6861,157.8052 -151.9244,145.465 -39.7063,5.1417 -67.283,0.3651 -88.9837,-9.2161 -40.5198,-3.2505 -60.037,-28.5775 -66.5128,-67.6126 -5.9315,-20.9536 -7.9535,-43.9645 2.0782,-73.3186 7.3335,-16.3952 2.3466,-32.1124 47.3693,-50.5815 47.4746,-5.4716 62.5026,-18.0625 82.0959,-31.7572 28.1839,-31.9804 63.2427,-25.0035 99.487,-11.3087 z\" id=\"path4332\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1237.7971\" cx=\"2365.9719\" id=\"path5780-6-7-8-0\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-9-3-1\" y=\"1177.2106\" x=\"2493.0215\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"1177.2106\" x=\"2493.0215\" id=\"tspan4922-2-2-0-5-6-5-9\" sodipodi:role=\"line\">24</tspan></text></g><g id=\"25\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2513.0772,1357.7789 c 85.4916,12.7529 126.0387,58.8638 100.1565,154.2791 -27.2605,35.0169 -52.0442,72.6102 -98.3185,87.8493 -16.3963,-0.3555 -30.7938,1.3679 -40.6274,7.8388 -14.196,4.0603 -30.4607,4.0329 -48.034,1.4195 -33.0944,-18.3784 -77.5937,-3.0885 -96.2355,-64.1338 -15.3889,-48.8438 -12.762,-91.8549 24.3249,-123.7092 73.2981,-64.096 113.5862,-58.7051 158.734,-63.5437 z\" id=\"path4320\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1480.5359\" cx=\"2477.105\" id=\"path5780-6-7-8-0-2\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-9-3-6\" y=\"1412.1895\" x=\"2609.9434\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"1412.1895\" x=\"2609.9434\" id=\"tspan4922-2-2-0-5-6-5-0\" sodipodi:role=\"line\">25</tspan></text></g><g id=\"26\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2686.1987,1629.0612 c -86.5991,-78.5931 -150.4432,-33.1986 -214.2905,12.178 -17.2417,22.3716 -34.1085,44.7422 -57.7233,67.1312 -72.3134,72.6678 -58.7116,121.984 -16.8345,163.6149 26.1005,30.2781 51.0974,59.9829 64.2591,83.5404 15.0849,16.2409 28.9539,28.7 40.7338,34.663 55.7449,26.1737 77.0284,-10.3306 108.3207,-28.6313 112.4268,-61.9606 152.6883,-148.2711 123.7588,-257.9276 -3.1869,-42.2764 -22.2028,-63.1571 -48.2241,-74.5686 z\" id=\"path4306\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"1787.615\" cx=\"2576.5403\" id=\"path5780-6-7-8-0-2-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-9-3-8\" y=\"1696.1514\" x=\"2714.2249\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"1696.1514\" x=\"2714.2249\" id=\"tspan4922-2-2-0-5-6-5-8\" sodipodi:role=\"line\">26</tspan></text></g><g id=\"27\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2804.5343,2156.7942 c 17.6293,-25.2605 15.3237,-62.03 3.4339,-104.3329 -45.3699,-108.6631 -126.8784,-132.0824 -253.8571,-48.2468 -39.8294,16.8113 -71.4045,49.1376 -92.1759,81.3927 -20.4327,31.7291 -39.4033,47.0024 -29.3034,103.1158 23.3195,94.5224 63.5992,168.6698 177.7549,154.0666 45.3573,-5.7693 85.4122,6.6503 142.7797,-40.317 22.207,-38.4344 64.9996,-35.8745 51.3679,-145.6784 z\" id=\"path4290\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccscccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"2161.9592\" cx=\"2643.8054\" id=\"path5780-6-7-8-0-2-7-3\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-9-3-8-8\" y=\"2045.541\" x=\"2784.8843\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"2045.541\" x=\"2784.8843\" id=\"tspan4922-2-2-0-5-6-5-8-9\" sodipodi:role=\"line\">27</tspan></text></g><g id=\"28\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2670.3264,2341.0156 c -50.2712,4.8036 -95.6049,17.311 -126.137,46.0673 -43.5878,23.5561 -71.397,48.2474 -69.0968,75.1046 -13.9517,40.937 -3.0929,70.6752 5.0788,101.6263 l 23.2221,50.8102 c 14.6887,29.5723 45.0438,49.2572 92.5253,58.1335 55.8969,9.6885 111.7986,21.3088 167.5881,-11.943 63.5169,-24.7745 66.5394,-59.9215 72.6406,-94.5407 18.7459,-35.5125 31.2972,-78.2741 23.8625,-144.4224 -6.5876,-30.2371 -14.9596,-68.6769 -55.9518,-86.2463 -40.992,-17.5695 -77.7477,-8.454 -133.7318,5.4105 z\" id=\"path4278\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccccczc\"></path><ellipse inkscape:transform-center-y=\"-266.13527\" inkscape:transform-center-x=\"-193.02118\" ry=\"99.279404\" rx=\"94.94622\" cy=\"2498.2839\" cx=\"2681.8245\" id=\"path5780-6-7-8-0-2-7-3-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-9-3-8-3\" y=\"2356.8037\" x=\"2829.1248\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"2356.8037\" x=\"2829.1248\" id=\"tspan4922-2-2-0-5-6-5-8-1\" sodipodi:role=\"line\">28</tspan></text></g><g id=\"48\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3912\" d=\"m 459.16747,2966.6163 c -4.67705,-34.2396 -25.60728,-37.515 -8.76453,-112.7525 8.77403,-53.6802 33.93843,-98.0192 90.77966,-124.3046 34.40735,-5.1217 65.76726,-30.7737 105.54579,0.289 11.59407,10.5959 20.23192,16.2439 27.84292,20.5723 15.81198,17.2128 46.54633,18.2301 61.61047,83.7296 -0.0134,24.9602 -5.83461,34.622 5.05624,88.3046 3.4523,20.6863 13.49757,33.6579 2.08208,71.742 -12.30244,17.6135 -11.19101,36.266 -49.13367,51.8939 -10.41286,10.0567 -93.14933,19.5471 -119.91723,18.5912 -26.76788,-0.9559 -25.43584,8.6025 -66.26411,-31.7138 -16.19224,-21.3739 -30.89832,-30.0459 -48.83762,-66.3517 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"2892.458\" cx=\"595.57782\" id=\"path5780-0-0-7-7-1-7-5\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8\" y=\"2715.3633\" x=\"574.63\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"2715.3633\" x=\"574.63\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4\" sodipodi:role=\"line\">48</tspan></text></g><g id=\"47\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3928\" d=\"m 564.45668,3069.3849 c -28.1082,13.6617 -56.79918,22.3424 -83.05909,51.801 -21.7445,17.9057 -37.92335,50.1443 -41.75061,114.1908 -1.82534,45.0333 -12.26304,88.917 16.24036,137.9988 24.4721,21.5711 9.4804,28.913 75.97994,65.6378 34.2577,15.0067 58.84974,48.0939 111.50593,28.6844 25.47251,-7.5433 34.07544,-4.5657 77.71075,-23.4365 18.48762,-4.4041 33.80172,-15.4885 42.32095,-40.8764 9.17544,-16.4263 16.84252,-39.2324 22.04464,-72.4642 -1.78635,-28.7096 -5.92454,-40.5211 -9.66253,-55.2082 -5.97732,-38.6022 -3.73546,-54.6832 0.16579,-66.2176 0.40406,-19.4439 -3.30191,-38.8991 -14.93191,-58.3758 -6.10826,-21.0488 -10.12956,-40.9535 -45.82794,-63.9788 -32.5054,-25.5509 -53.60175,-44.767 -150.73628,-17.7553 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"3268.8301\" cx=\"607.98572\" id=\"path5780-0-0-7-7-1-7-5-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5\" y=\"3062.0623\" x=\"585.36816\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3062.0623\" x=\"585.36816\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3\" sodipodi:role=\"line\">47</tspan></text></g><g id=\"46\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccccccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3946\" d=\"m 744.40745,3463.2444 c 17.60629,-5.7245 36.95825,5.3803 56.49699,18.2858 l 26.30749,31.6044 c 18.53536,18.4447 26.30679,36.8599 24.74049,55.2495 -1.68452,32.0534 6.47579,64.1337 26.89957,96.2475 13.06488,39.4062 21.59469,77.4817 -1.02036,106.4192 -13.81095,26.2711 -30.59635,51.2887 -64.25506,69.1953 -35.19346,15.1794 -66.221,35.8329 -108.66599,41.483 -27.7435,2.2446 -50.27432,11.7963 -94.96753,-9.7196 l -60.9592,-42.7357 c -10.26329,-7.8566 -20.03933,-12.2551 -36.03515,-60.7985 -5.23331,-45.1032 -25.32324,-88.306 -1.16437,-137.1693 l 38.68172,-92.9147 c 18.28954,-23.8819 30.43067,-50.1207 69.52446,-66.0277 22.78557,-7.6879 38.08223,-19.6737 81.46051,-15.5433 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"3674.1538\" cx=\"694.84082\" id=\"path5780-0-0-7-7-1-7-5-7-8\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0\" y=\"3434.717\" x=\"683.97858\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3434.717\" x=\"683.97858\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0\" sodipodi:role=\"line\">46</tspan></text></g><g id=\"45\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3962\" d=\"m 878.33882,3869.591 c 74.0107,38.464 72.93233,59.1462 75.16879,88.4966 -5.60282,35.1525 -4.10696,48.2299 -3.93331,65.4189 1.0003,36.1358 -20.52473,45.6339 -34.08727,64.5482 -43.49264,45.5027 -66.66273,30.7968 -97.34963,38.3607 -28.21946,-4.5443 -45.41487,-9.0585 -61.78612,-13.5705 -46.01946,-11.6799 -41.99774,-29.7614 -59.44548,-45.0963 -22.36976,-31.3881 -24.3363,-71.4958 -12.52219,-117.4926 9.68836,-27.3634 29.34987,-47.8275 49.92704,-67.658 l 50.57831,-26.6642 c 38.82894,-16.7878 83.31309,6.2578 93.44986,13.6572 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"3992.6226\" cx=\"806.51166\" id=\"path5780-0-0-7-7-1-7-5-7-8-6\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0\" y=\"3729.4543\" x=\"800.172\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3729.4543\" x=\"800.172\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7\" sodipodi:role=\"line\">45</tspan></text></g><g id=\"44\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3870\" d=\"m 865.59157,4143.0998 c -29.34893,42.317 -36.39225,72.6741 -33.41627,97.6591 8.77953,43.4715 13.32284,90.1246 57.02785,107.3663 69.74763,24.2988 84.76075,4.1328 113.09855,-5.2086 32.4263,-16.4854 57.9251,-37.1351 76.2997,-62.0676 14.1307,-10.2094 13.0749,-20.4604 13.6472,-30.7068 -2.1827,-19.0359 1.734,-31.887 3.134,-47.29 2.1341,-29.8756 -10.1991,-50.7284 -17.1522,-74.9364 -20.565,-17.5094 -35.6327,-41.5532 -69.2501,-43.5468 l -58.04622,-1.7355 c -35.75587,-1.9593 -60.14586,30.474 -85.34251,60.4663 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"4220.1001\" cx=\"959.54205\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9\" y=\"3939.9807\" x=\"961.05511\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3939.9807\" x=\"961.05511\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4\" sodipodi:role=\"line\">44</tspan></text></g><g id=\"43\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"ccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3881\" d=\"m 1111.7493,4290.3995 c 50.447,-7.4122 94.6013,-7.6554 103.2032,32.6032 l 25.4351,78.9007 c 18.2859,60.137 -0.9135,47.965 -3.9373,66.9956 l -37.8113,46.4068 c -14.4497,15.295 -30.0192,29.7656 -64.1583,30.5685 -50.0538,-1.9357 -100.6992,-2.7643 -111.3816,-78.3476 l -4.3024,-88.3026 c 10.3799,-42.1935 21.7413,-83.7875 92.9526,-88.8246 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"4422.7622\" cx=\"1124.9803\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2-3\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1\" y=\"4129.8809\" x=\"1144.2832\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"4129.8809\" x=\"1144.2832\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5\" sodipodi:role=\"line\">43</tspan></text></g><g id=\"42\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3897\" d=\"m 1380.5772,4416.4768 c -14.3269,-41.8369 -49.3127,-42.3159 -73.0728,-22.2728 l -34.0381,44.8405 -40.0572,40.0941 c -5.8248,18.7663 -21.4943,17.6093 -3.2287,85.1288 10.984,36.5217 33.0755,52.8413 60.1618,60.0762 34.7374,10.4312 64.4791,3.7261 91.2553,-13.1514 18.2528,-19.6636 47.1452,-28.9425 39.3882,-73.9934 -7.7421,-20.2598 -8.1103,-24.997 -24.7186,-63.9207 -5.2303,-18.85 -10.4843,-28.1416 -15.6899,-56.8013 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"74.463661\" rx=\"78.40239\" cy=\"4530.2974\" cx=\"1315.2344\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2-3-7\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:10.53931713;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5\" y=\"4230.8901\" x=\"1349.8561\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"4230.8901\" x=\"1349.8561\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5\" sodipodi:role=\"line\">42</tspan></text></g><g id=\"41\" transform=\"translate(61.329746,-199.94518)\"><path sodipodi:nodetypes=\"cccccccccc\" inkscape:connector-curvature=\"0\" id=\"path3899\" d=\"m 1467.8716,4497.2076 c -11.3613,26.099 -19.4111,54.9827 -40.1402,73.2031 -9.3001,9.7439 -17.3061,22.2121 -6.9687,73.2938 10.7295,21.2822 29.0999,33.7338 57.9653,34.056 23.2817,-4.5762 43.3234,-11.1001 79.933,-7.6643 17.6267,-4.4535 33.6926,1.5191 55.1057,-28.2283 7.0716,-14.0488 18.0862,-22.9962 0.1737,-69.3709 l -54.8432,-76.6162 c -14.8796,-11.5876 -16.5071,-29.4301 -51.1861,-31.6725 -27.1179,0.8636 -32.203,17.944 -40.0395,32.9993 z\" style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path><ellipse ry=\"74.463661\" rx=\"78.40239\" cy=\"4588.2007\" cx=\"1517.8962\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2-3-7-3\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:10.53931713;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0\" y=\"4285.416\" x=\"1577.7739\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"4285.416\" x=\"1577.7739\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4\" sodipodi:role=\"line\">41</tspan></text></g><g id=\"31\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 1792.9681,4497.6393 c 11.3612,26.0989 19.4112,54.9826 40.1402,73.203 9.3001,9.7438 17.306,22.2122 6.9687,73.2938 -10.7296,21.2822 -29.0999,33.7337 -57.9653,34.056 -23.2817,-4.5762 -43.3234,-11.1 -79.933,-7.6642 -17.6267,-4.4535 -33.6926,1.519 -55.1057,-28.2284 -7.0717,-14.0488 -18.0863,-22.9963 -0.1737,-69.3709 l 54.8431,-76.6162 c 14.8797,-11.5876 16.5072,-29.4301 51.1862,-31.6725 27.1179,0.8635 32.203,17.9441 40.0395,32.9994 z\" id=\"path4454\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccccccc\"></path><ellipse ry=\"74.463661\" rx=\"78.40239\" cy=\"4588.2007\" cx=\"1745.3739\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2-3-7-3-4\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:10.53931713;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0\" y=\"4285.416\" x=\"1827.4771\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"4285.416\" x=\"1827.4771\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4\" sodipodi:role=\"line\">31</tspan></text></g><g id=\"32\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 1880.2624,4416.9083 c 14.327,-41.8368 49.3128,-42.3158 73.073,-22.2727 l 34.0379,44.8405 40.0573,40.0942 c 5.8247,18.7662 21.4943,17.6092 3.2287,85.1287 -10.9841,36.5217 -33.0756,52.8412 -60.1619,60.0763 -34.7373,10.4312 -64.479,3.7259 -91.2552,-13.1515 -18.2528,-19.6637 -47.1452,-28.9425 -39.3883,-73.9934 7.7422,-20.2599 8.1103,-24.9971 24.7189,-63.9208 5.2301,-18.8499 10.4841,-28.1415 15.6896,-56.8013 z\" id=\"path4452\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccccccc\"></path><ellipse ry=\"74.463661\" rx=\"78.40239\" cy=\"4530.2974\" cx=\"1935.6281\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2-3-7-3-4-3\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:10.53931713;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0-9\" y=\"4230.8901\" x=\"2031.4707\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"4230.8901\" x=\"2031.4707\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4-3\" sodipodi:role=\"line\">32</tspan></text></g><g id=\"33\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2149.0905,4290.831 c -50.4471,-7.412 -94.6014,-7.6553 -103.2032,32.6033 l -25.4353,78.9007 c -18.2858,60.137 0.9135,47.9651 3.9374,66.9956 l 37.8113,46.4068 c 14.4497,15.295 30.0192,29.7656 64.1583,30.5685 50.0537,-1.9356 100.6992,-2.7643 111.3816,-78.3477 l 4.3023,-88.3025 c -10.3798,-42.1935 -21.7413,-83.7875 -92.9524,-88.8247 z\" id=\"path4436\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"4422.7622\" cx=\"2134.1541\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2-3-6\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0-9-5\" y=\"4129.8809\" x=\"2243.3567\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"4129.8809\" x=\"2243.3567\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4-3-8\" sodipodi:role=\"line\">33</tspan></text></g><g id=\"34\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2395.2481,4143.5315 c 29.3489,42.3169 36.3923,72.674 33.4163,97.6589 -8.7796,43.4716 -13.3229,90.1247 -57.0279,107.3664 -69.7476,24.2988 -84.7607,4.1328 -113.0986,-5.2086 -32.4262,-16.4854 -57.9251,-37.1352 -76.2996,-62.0675 -14.1308,-10.2095 -13.0748,-20.4604 -13.6472,-30.7069 2.1826,-19.0358 -1.7339,-31.8869 -3.134,-47.29 -2.1342,-29.8755 10.1991,-50.7283 17.1522,-74.9365 20.565,-17.5093 35.6327,-41.5531 69.2501,-43.5466 l 58.0462,-1.7356 c 35.7559,-1.9592 60.1459,30.474 85.3425,60.4664 z\" id=\"path4426\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"4220.1001\" cx=\"2303.7283\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-2-4\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0-9-5-1\" y=\"3941.387\" x=\"2426.6392\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3941.387\" x=\"2426.6392\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4-3-8-8\" sodipodi:role=\"line\">34</tspan></text></g><g id=\"35\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2382.5009,3870.0226 c -74.0107,38.464 -72.9324,59.1463 -75.1689,88.4966 5.6028,35.1524 4.1071,48.2298 3.9334,65.4189 -1.0003,36.1358 20.5247,45.6339 34.0872,64.5482 43.4927,45.5026 66.6628,30.7969 97.3496,38.3607 28.2195,-4.5444 45.4149,-9.0585 61.7862,-13.5704 46.0195,-11.6799 41.9978,-29.7615 59.4454,-45.0964 22.3698,-31.3882 24.3364,-71.4957 12.5223,-117.4926 -9.6883,-27.3634 -29.3499,-47.8274 -49.9271,-67.6581 l -50.5783,-26.664 c -38.8289,-16.788 -83.3131,6.2577 -93.4498,13.6571 z\" id=\"path4416\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"ccccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"3992.6226\" cx=\"2436.0789\" id=\"path5780-0-0-7-7-1-7-5-7-8-6-1\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0-9-5-1-0\" y=\"3730.8606\" x=\"2572.001\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3730.8606\" x=\"2572.001\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4-3-8-8-1\" sodipodi:role=\"line\">35</tspan></text></g><g id=\"36\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2516.4322,3463.676 c -17.6063,-5.7244 -36.9582,5.3803 -56.497,18.2858 l -26.3074,31.6045 c -18.5354,18.4446 -26.3068,36.8598 -24.7405,55.2494 1.6845,32.0534 -6.4758,64.1337 -26.8995,96.2476 -13.065,39.4061 -21.5949,77.4817 1.0202,106.4191 13.811,26.2711 30.5965,51.2888 64.2551,69.1954 35.1935,15.1792 66.2211,35.8329 108.666,41.483 27.7435,2.2444 50.2743,11.7962 94.9676,-9.7197 l 60.9591,-42.7356 c 10.2633,-7.8567 20.0393,-12.2552 36.0352,-60.7986 5.2333,-45.1033 25.3232,-88.306 1.1644,-137.1692 l -38.6818,-92.9148 c -18.2895,-23.882 -30.4307,-50.1208 -69.5244,-66.0277 -22.7855,-7.6879 -38.0822,-19.6737 -81.4605,-15.5433 z\" id=\"path4400\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccccccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"3674.1538\" cx=\"2564.2935\" id=\"path5780-0-0-7-7-1-7-5-7-8-67\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0-9-5-1-0-6\" y=\"3434.717\" x=\"2711.043\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3434.717\" x=\"2711.043\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4-3-8-8-1-1\" sodipodi:role=\"line\">36</tspan></text></g><g id=\"37\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2696.383,3069.8165 c 28.1082,13.6617 56.7992,22.3424 83.0591,51.8011 21.7445,17.9057 37.9233,50.1441 41.7506,114.1907 1.8254,45.0334 12.263,88.917 -16.2404,137.9988 -24.472,21.5712 -9.4804,28.913 -75.9799,65.6378 -34.2577,15.0066 -58.8498,48.0939 -111.5059,28.6844 -25.4726,-7.5434 -34.0754,-4.5658 -77.7107,-23.4366 -18.4876,-4.404 -33.8018,-15.4884 -42.321,-40.8763 -9.1755,-16.4263 -16.8425,-39.2323 -22.0446,-72.4642 1.7863,-28.7097 5.9244,-40.5212 9.6624,-55.2082 5.9774,-38.6021 3.7355,-54.6833 -0.1657,-66.2176 -0.4042,-19.4439 3.3019,-38.899 14.9319,-58.3759 6.1082,-21.0487 10.1295,-40.9535 45.8279,-63.9786 32.5054,-25.551 53.6017,-44.7672 150.7363,-17.7554 z\" id=\"path4382\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"3268.8301\" cx=\"2647.0127\" id=\"path5780-0-0-7-7-1-7-5-7-6\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0-9-5-1-0-6-9\" y=\"3063.4685\" x=\"2798.3621\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"3063.4685\" x=\"2798.3621\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4-3-8-8-1-1-5\" sodipodi:role=\"line\">37</tspan></text></g><g id=\"38\" transform=\"translate(61.329746,-199.94518)\"><path style=\"fill:#fafafa;fill-opacity:1;stroke:#000000;stroke-width:8.94258595;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" d=\"m 2801.6722,2967.0479 c 4.6771,-34.2397 25.6073,-37.515 8.7645,-112.7525 -8.7741,-53.6803 -33.9384,-98.0192 -90.7797,-124.3045 -34.4072,-5.1218 -65.7671,-30.7738 -105.5457,0.289 -11.5941,10.5958 -20.232,16.2437 -27.843,20.5722 -15.8119,17.2128 -46.5463,18.23 -61.6104,83.7297 0.013,24.9601 5.8346,34.6219 -5.0562,88.3046 -3.4524,20.6863 -13.4976,33.6578 -2.0821,71.7419 12.3024,17.6136 11.191,36.2659 49.1336,51.894 10.4129,10.0567 93.1494,19.5471 119.9173,18.5911 26.7678,-0.9558 25.4359,8.6025 66.2641,-31.7138 16.1922,-21.374 30.8983,-30.0459 48.8376,-66.3517 z\" id=\"path4368\" inkscape:connector-curvature=\"0\" sodipodi:nodetypes=\"cccccccccccc\"></path><ellipse ry=\"99.279404\" rx=\"94.94622\" cy=\"2892.458\" cx=\"2671.8284\" id=\"path5780-0-0-7-7-1-7-5-2\" style=\"opacity:0.45;fill:#585858;fill-opacity:1;stroke:none;stroke-width:13.39195728;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></ellipse><text transform=\"scale(0.92548195,1.0805181)\" id=\"text4924-9-00-8-2-4-3-9-2-8-8-5-0-0-9-1-5-0-0-9-5-1-0-6-9-4\" y=\"2715.3633\" x=\"2820.3191\" style=\"font-style:normal;font-weight:normal;font-size:119.99372864px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;display:inline;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:2.99984264\" xml:space=\"preserve\"><tspan style=\"font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';fill:#ffffff;fill-opacity:1;stroke-width:2.99984264\" y=\"2715.3633\" x=\"2820.3191\" id=\"tspan4922-2-2-0-5-7-9-2-6-2-4-3-0-7-4-5-5-4-4-3-8-8-1-1-5-5\" sodipodi:role=\"line\">38</tspan></text></g><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877);marker-end:url(#DotS)\" d=\"m 1339.3406,570.79686 90.991,-37.22359\" id=\"v_1211\" inkscape:connector-curvature=\"0\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-9);marker-end:url(#DotS-8)\" d=\"m 1642.2642,493.32356 98.265,-2.98996\" id=\"v_1121\" inkscape:connector-curvature=\"0\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8);marker-end:url(#DotS-5)\" d=\"m 2054.1218,570.79686 -90.991,-37.22359\" id=\"v_2221\" inkscape:connector-curvature=\"0\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9);marker-end:url(#DotS-5-4)\" d=\"m 2280.9144,715.18936 -72.394,-66.5136\" id=\"v_2322\" inkscape:connector-curvature=\"0\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2);marker-end:url(#DotS-5-4-4)\" d=\"m 2454.1397,921.26876 -48.3187,-85.6169\" id=\"v_2423\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-23.150762\" inkscape:transform-center-y=\"5.4136854\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3);marker-end:url(#DotS-5-4-4-4)\" d=\"m 2571.6987,1186.641 -38.8334,-90.3157\" id=\"v_2524\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-22.434512\" inkscape:transform-center-y=\"7.8713854\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7);marker-end:url(#DotS-5-4-4-4-0)\" d=\"m 2645.1963,1444.6585 -21.6182,-95.9042\" id=\"v_2625\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-20.611312\" inkscape:transform-center-y=\"11.850735\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1);marker-end:url(#DotS-5-4-4-4-0-3)\" d=\"m 2719.4088,1802.2035 -17.9909,-96.6503\" id=\"v_2726\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-20.150362\" inkscape:transform-center-y=\"12.618585\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8);marker-end:url(#DotS-5-4-4-4-0-3-2)\" d=\"m 2769.4446,2172.6719 -10.8541,-97.7094\" id=\"v_2827\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-19.170662\" inkscape:transform-center-y=\"14.062435\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-1);marker-end:url(#DotS-5-4-3)\" d=\"m 1086.374,715.18936 72.394,-66.5136\" id=\"v_1312\" inkscape:connector-curvature=\"0\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-4);marker-end:url(#DotS-5-4-4-43)\" d=\"m 928.71494,921.26876 48.3187,-85.6169\" id=\"v_1413\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"23.150753\" inkscape:transform-center-y=\"5.4136854\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-5);marker-end:url(#DotS-5-4-4-4-2)\" d=\"m 819.19464,1186.641 38.8334,-90.3157\" id=\"v_1514\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"22.43452\" inkscape:transform-center-y=\"7.8713854\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-3);marker-end:url(#DotS-5-4-4-4-0-34)\" d=\"m 740.82754,1444.6585 21.6182,-95.9042\" id=\"v_1615\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"20.611309\" inkscape:transform-center-y=\"11.850735\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-1);marker-end:url(#DotS-5-4-4-4-0-3-5)\" d=\"m 660.73494,1802.2035 17.9909,-96.6503\" id=\"v_1716\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"20.150363\" inkscape:transform-center-y=\"12.618585\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9);marker-end:url(#DotS-5-4-4-4-0-3-2-4)\" d=\"m 597.00214,2172.6719 10.8541,-97.7094\" id=\"v_1817\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"19.170658\" inkscape:transform-center-y=\"14.062435\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8)\" d=\"m 632.27264,2916.4942 -9.9058,-97.81\" id=\"v_4847\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"15.790273\" inkscape:transform-center-y=\"17.774535\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9)\" d=\"m 685.82174,3318.5507 -22.8462,-95.6189\" id=\"v_4746\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"13.281923\" inkscape:transform-center-y=\"19.719485\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0)\" d=\"m 808.08224,3701.2816 -36.9353,-91.1082\" id=\"v_4645\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"10.172598\" inkscape:transform-center-y=\"21.489235\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0)\" d=\"m 948.36144,3975.2532 -54.0565,-82.1147\" id=\"v_4544\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"5.768918\" inkscape:transform-center-y=\"23.064885\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-2)\" d=\"m 1099.9021,4170.9714 -70.7804,-68.2281\" id=\"v_4443\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"0.559188\" inkscape:transform-center-y=\"23.768735\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:19.33082199;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7)\" d=\"m 1284.4979,4331.3989 -68.2258,-36.6435\" id=\"v_4342\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-3.0263329\" inkscape:transform-center-y=\"16.702954\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:19.33082199;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-0);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-5)\" d=\"m 1496.678,4411.5495 -75.9368,-15.2021\" id=\"v_4241\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-7.756333\" inkscape:transform-center-y=\"15.099254\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:19.33082199;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-0-5);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-5-9)\" d=\"m 1730.4674,4419.065 -77.4155,2.0836\" id=\"v_4131\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-10.922983\" inkscape:transform-center-y=\"12.993704\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:19.33082199;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-0-58);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-5-91)\" d=\"m 1899.8479,4411.5495 75.9368,-15.2021\" id=\"v_3231\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"7.7563219\" inkscape:transform-center-y=\"15.099254\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:19.33082199;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-7-08);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-7-6)\" d=\"m 2096.6861,4331.3989 68.2258,-36.6435\" id=\"v_3332\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"3.0263313\" inkscape:transform-center-y=\"16.702954\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-1-1);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-2-3)\" d=\"m 2303.3727,4170.9714 70.7804,-68.2281\" id=\"v_3433\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-0.55921956\" inkscape:transform-center-y=\"23.768735\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-9-9);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-0-6)\" d=\"m 2454.1115,3975.2532 54.0565,-82.1147\" id=\"v_3534\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-5.7689625\" inkscape:transform-center-y=\"23.064885\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-8-6);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-0-2)\" d=\"m 2599.0716,3701.2816 36.9353,-91.1082\" id=\"v_3635\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-10.172597\" inkscape:transform-center-y=\"21.489235\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-7-5);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-9-2)\" d=\"m 2691.2247,3318.5507 22.8462,-95.6189\" id=\"v_3736\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-13.281925\" inkscape:transform-center-y=\"19.719485\"></path><path style=\"fill:none;stroke:#e7262b;stroke-width:25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:95;stroke-opacity:1;marker-start:url(#marker6877-8-9-2-3-7-1-8-9-8-8);marker-end:url(#DotS-5-4-4-4-0-3-2-4-8-4)\" d=\"m 2763.9502,2916.4942 9.9058,-97.81\" id=\"v_3837\" inkscape:connector-curvature=\"0\" inkscape:transform-center-x=\"-15.790312\" inkscape:transform-center-y=\"17.774535\"></path></g></svg>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _commonCrudCrudJs = __webpack_require__(455);
	
	var _fazeForDayComponentJs = __webpack_require__(640);
	
	var fazaNaloga = _angular2['default'].module('fazaNaloga', [_commonCrudCrudJs.crud.name]);
	
	fazaNaloga.component('fazeForDay', _fazeForDayComponentJs.FazeForDayComponent);
	
	exports.fazaNaloga = fazaNaloga;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fazeForDayHtml = __webpack_require__(641);
	
	var _fazeForDayHtml2 = _interopRequireDefault(_fazeForDayHtml);
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var FazeForDayController = (function () {
	    function FazeForDayController(AppConfiguration, DS, $q) {
	        _classCallCheck(this, FazeForDayController);
	
	        this.fazeView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'DashboardView');
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	    }
	
	    _createClass(FazeForDayController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.mode = 'danas';
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            this.days = changes.days.currentValue;
	            this.getState();
	        }
	    }, {
	        key: 'onDayClicked',
	        value: function onDayClicked(day) {
	            this.onClick({ day: day });
	        }
	    }, {
	        key: 'no_reservation',
	        value: function no_reservation(header_day, item) {
	            // console.log(header_day.format('YYYY-MM-DD'), item);
	
	            // if (item && item.datum_probe === header_day.format('YYYY-MM-DD')) {
	            //     return false;
	            // }
	            return true;
	        }
	
	        // getState() {
	        //     this.items = [];
	        //     this.pivot = [];
	        //     _.forEach(this.days, day => {
	        //         let item = {};
	        //         this.getFaze(day).then(response => {
	        //             item.date = day;
	        //             item.datum = moment(day).format();
	        //             item.probe = response;
	        //             response.forEach((r, i) => {
	        //                 if (this.pivot.length <= i) {
	        //                     this.pivot.push([]);
	        //                 }
	        //                 this.pivot[i].push(r);
	        //             });
	        //         });
	
	        //         this.items.push(item);
	        //     });
	        // }
	
	    }, {
	        key: 'getItemForRow',
	        value: function getItemForRow(row, dan) {
	            var probe_za_dan = this.dani.filter(function (f) {
	                return f.datum === dan;
	            });
	            if (probe_za_dan.length === 1) {
	                var probe = probe_za_dan[0].response;
	                if (probe.length > row) {
	                    return probe[row];
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            var $q = this.$q();
	            this.items = [];
	            this.dani = [];
	            this.max_proba = 0;
	
	            $q.all(this.days.map(function (day) {
	                return _this.getFaze(day);
	            })).then(function (responses) {
	                _lodash2['default'].forEach(responses, function (response, i) {
	                    var dan = {
	                        datum: _this.days[i],
	                        broj_proba: response.length,
	                        response: response
	                    };
	                    _lodash2['default'].forEach(response, function (r) {
	                        _this.items.push(r);
	                    });
	
	                    _this.dani.push(dan);
	                });
	
	                var max_proba = _lodash2['default'].maxBy(_this.dani, 'broj_proba');
	                _this.max_proba = [].concat(_toConsumableArray(Array.from(Array(max_proba.broj_proba).keys())));
	            });
	        }
	    }, {
	        key: 'getFaze',
	        value: function getFaze(day) {
	            var DS = this.datastore();
	            return DS.findAll('FazaNaloga', { aktivne: 1, datum_probe: (0, _moment2['default'])(day).format('YYYY-MM-DD'), ordering: 'termin_probe' }, { bypassCache: true }).then(function (response) {
	                return response;
	            });
	        }
	    }]);
	
	    return FazeForDayController;
	})();
	
	FazeForDayController.$inject = ['AppConfiguration', 'DS', '$q'];
	
	var FazeForDayComponent = {
	    restrict: 'E',
	    templateUrl: _fazeForDayHtml2['default'],
	    controller: FazeForDayController,
	    controllerAs: 'vm',
	    bindings: {
	        days: '<',
	        onClick: '&'
	    }
	};
	
	exports.FazeForDayComponent = FazeForDayComponent;
	exports.FazeForDayController = FazeForDayController;

/***/ },
/* 641 */
/***/ function(module, exports) {

	var path = 'app/components/fazaNaloga/fazeForDay.html';
	var html = "<div class=\"row\"><div class=\"col-lg-12\" ng-if=\"vm.days.length === 1\"><br><div class=\"table-responsive\"><table id=\"no-more-tables\" cellpadding=\"1\" cellspacing=\"1\" class=\"table table-bordered table-striped table-hover\"><thead><tr><th>Ordinacija</th><th>Pacijent</th><th>Broj naloga</th><th>Napomena</th><th class=\"text-center\"><i class=\"fa fa-clock-o\"></i> Termin <i class=\"fa fa-sort-up\"></i></th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td data-title=\"Ordinacija\"><h5 class=\"no-margins font-extra-bold\">{{item.ordinacija_naziv}}</h5></td><td data-title=\"Pacijent\">{{item.pacijent_naziv}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item.rn\"></rn-link></td><td data-title=\"Napomena\">{{item.napomena}}&nbsp;</td><td data-title=\"Termin\" class=\"text-center\"><h5>{{item.termin_probe}}</h5></td></tr></tbody></table></div></div><table id=\"no-more-tables\" class=\"table table-striped table-bordered\" ng-if=\"vm.days.length > 1\"><thead><tr><th ng-repeat=\"dan in vm.dani\"><h5 class=\"text-primary text-center\">{{dan.datum | date:\"dd.MM.yyyy.\"}}<span class=\"label label-danger pull-right\">{{dan.broj_proba}}</span></h5></th></tr></thead><tbody><tr ng-repeat=\"row in vm.max_proba\"><td data-title=\"Datum naloga\" ng-repeat=\"day in vm.days track by $index\"><img src=\"images/slobodan_termin.png\" class=\"img-responsive center-block\" ng-if=\"!vm.getItemForRow(row, day)\"><div ng-if=\"vm.getItemForRow(row, day)\"><h5 class=\"no-margins font-extra-bold\">{{vm.getItemForRow(row, day).ordinacija_naziv}}</h5><small>{{vm.getItemForRow(row, day).pacijent_naziv}}</small><div class=\"pull-right font-bold\">{{vm.getItemForRow(row, day).termin_probe}}</div><br><rn-link rn=\"vm.getItemForRow(row, day).rn\"></rn-link></div></td></tr></tbody></table><div class=\"col-lg-2\" ng-if=\"vm.items.length > 1\" ng-repeat=\"day in vm.items\"><div class=\"list-item-container\"><div class=\"list-item text-center\"><a ng-click=\"vm.onDayClicked(day.date)\"><h5 class=\"text-success\">{{day.datum | date:\"dd.MM.yyyy\"}}<span class=\"label label-danger pull-right\">{{day.probe.length}}</span></h5></a></div><div class=\"list-item text-center\" ng-if=\"day.probe.length === 0\"><img src=\"images/slobodan_termin.png\"></div><div class=\"list-item\" ng-repeat=\"item in day.probe\"><h5 class=\"no-margins font-extra-bold text-danger\">{{item.ordinacija_naziv}}</h5><a ui-sref=\"radniNalog.details({id:item.radni_nalog})\"><small>{{item.pacijent_naziv}} (<span class=\"label label-success\">{{item.radni_nalog_sifra_naloga}}</span>)</small></a><div class=\"pull-right font-bold\">{{item.termin_probe}}</div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _jsDataAngular = __webpack_require__(643);
	
	var _jsDataAngular2 = _interopRequireDefault(_jsDataAngular);
	
	var _radniNalogJs = __webpack_require__(665);
	
	var _ordinacijaJs = __webpack_require__(666);
	
	var _tehnicarJs = __webpack_require__(667);
	
	var _valutaJs = __webpack_require__(668);
	
	var _poreznaStopaJs = __webpack_require__(669);
	
	var _protetskiRadJs = __webpack_require__(670);
	
	var _cjenikJs = __webpack_require__(671);
	
	var _stavkaCjenikaJs = __webpack_require__(672);
	
	var _bojaJs = __webpack_require__(673);
	
	var _oznakaBojeJs = __webpack_require__(674);
	
	var _fazaNalogaJs = __webpack_require__(675);
	
	var _stavkaNalogaJs = __webpack_require__(676);
	
	var _korisnikOrdinacijaJs = __webpack_require__(677);
	
	var _materijalJs = __webpack_require__(678);
	
	var _grupaRadaJs = __webpack_require__(679);
	
	var _vrstaRadaJs = __webpack_require__(680);
	
	var _dokumentNalogaJs = __webpack_require__(681);
	
	var _tokensJs = __webpack_require__(682);
	
	var _komentarJs = __webpack_require__(629);
	
	var _metaJs = __webpack_require__(470);
	
	var models = _angular2['default'].module('models', [_jsDataAngular2['default']]);
	
	Config.$inject = ['DSProvider', 'DSHttpAdapterProvider', '$httpProvider'];
	function Config(DSProvider, DSHttpAdapterProvider, $httpProvider) {
	    _angular2['default'].extend(DSProvider.defaults, {
	        bypassCache: false,
	        cacheResponse: true,
	        deserialize: function deserialize(resourceName, res) {
	            if (_angular2['default'].isDefined(res.data) && _angular2['default'].isDefined(res.data.results)) {
	                var newResponse = res.data.results;
	                newResponse.meta = {
	                    count: res.data.count,
	                    next: res.data.next,
	                    previous: res.data.previous,
	                    start: res.data.start,
	                    end: res.data.end
	                };
	                _metaJs.meta[resourceName.name] = newResponse.meta;
	                return newResponse;
	            }
	            return res.data;
	        }
	    });
	    _angular2['default'].extend(DSHttpAdapterProvider.defaults, {
	        basePath: '/api/radni_nalozi'
	    });
	
	    $httpProvider.defaults.xsrfCookieName = 'csrftoken';
	    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
	}
	
	models.run(['DS', 'RadniNalog', 'Ordinacija', 'Tehnicar', 'Valuta', 'PoreznaStopa', 'ProtetskiRad', 'Cjenik', 'StavkaCjenika', 'Boja', 'OznakaBoje', 'FazaNaloga', 'StavkaNaloga', 'KorisnikOrdinacija', 'Materijal', 'GrupaRada', 'VrstaRada', 'DokumentNaloga', 'PlanRada', 'Token', 'Komentar', 'NeprocitanKomentar', function () {
	    // require('./factory.js')(DS);
	}]);
	
	models.config(Config);
	
	models.factory('RadniNalog', _radniNalogJs.RadniNalog);
	models.factory('Ordinacija', _ordinacijaJs.Ordinacija);
	models.factory('Tehnicar', _tehnicarJs.Tehnicar);
	models.factory('Valuta', _valutaJs.Valuta);
	models.factory('PoreznaStopa', _poreznaStopaJs.PoreznaStopa);
	models.factory('ProtetskiRad', _protetskiRadJs.ProtetskiRad);
	models.factory('Cjenik', _cjenikJs.Cjenik);
	models.factory('StavkaCjenika', _stavkaCjenikaJs.StavkaCjenika);
	models.factory('Boja', _bojaJs.Boja);
	models.factory('OznakaBoje', _oznakaBojeJs.OznakaBoje);
	models.factory('FazaNaloga', _fazaNalogaJs.FazaNaloga);
	models.factory('StavkaNaloga', _stavkaNalogaJs.StavkaNaloga);
	models.factory('KorisnikOrdinacija', _korisnikOrdinacijaJs.KorisnikOrdinacija);
	models.factory('Materijal', _materijalJs.Materijal);
	models.factory('GrupaRada', _grupaRadaJs.GrupaRada);
	models.factory('VrstaRada', _vrstaRadaJs.VrstaRada);
	models.factory('DokumentNaloga', _dokumentNalogaJs.DokumentNaloga);
	models.factory('PlanRada', _radniNalogJs.PlanRada);
	models.factory('Token', _tokensJs.Token);
	models.factory('Komentar', _komentarJs.Komentar);
	models.factory('NeprocitanKomentar', _komentarJs.NeprocitanKomentar);
	
	exports.models = models;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	* js-data-angular
	* @version 3.2.1 - Homepage <https://github.com/js-data/js-data-angular>
	* @copyright (c) 2014-2016 js-data-angular project authors
	* @license MIT <https://github.com/js-data/js-data-angular/blob/master/LICENSE>
	*
	* @overview Angular wrapper for js-data.
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(644), __webpack_require__(81), (function webpackLoadOptionalExternalModule() { try { return __webpack_require__(645); } catch(e) {} }()));
		else if(typeof define === 'function' && define.amd)
			define(["js-data", "angular"], function webpackLoadOptionalExternalModuleAmd(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__) {
				return factory(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, root["axios"]);
			});
		else if(typeof exports === 'object')
			exports["jsDataAngularModuleName"] = factory(require("js-data"), require("angular"), (function webpackLoadOptionalExternalModule() { try { return require("axios"); } catch(e) {} }()));
		else
			root["jsDataAngularModuleName"] = factory(root["JSData"], root["angular"], root["axios"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		/* jshint loopfunc:true */
		var JSData = __webpack_require__(1);
		var DSHttpAdapter = __webpack_require__(2);
		var angular = __webpack_require__(4);
		
		var DSUtils = JSData.DSUtils;
		var DSErrors = JSData.DSErrors;
		var get = DSUtils.get;
		var isString = DSUtils.isString;
		var isNumber = DSUtils.isNumber;
		var isObject = DSUtils.isObject;
		var set = DSUtils.set;
		var resolveId = DSUtils.resolveId;
		
		
		var adapters = [{
		  project: 'js-data-localstorage',
		  name: 'localstorage',
		  'class': 'DSLocalStorageAdapter'
		}, {
		  project: 'js-data-localforage',
		  name: 'localforage',
		  'class': 'DSLocalForageAdapter'
		}, {
		  project: 'js-data-firebase',
		  name: 'firebase',
		  'class': 'DSFirebaseAdapter'
		}, {
		  project: 'js-data-sql',
		  name: 'sql',
		  'class': 'DSSqlAdapter'
		}];
		
		var functionsToWrap = ['compute', 'digest', 'eject', 'inject'];
		
		function registerAdapter(adapter) {
		  var Adapter = void 0;
		
		  try {
		    Adapter = __webpack_require__(5)(adapter.project);
		  } catch (e) {}
		
		  if (!Adapter) {
		    Adapter = window[adapter.class];
		  }
		
		  if (Adapter) {
		    adapter.loaded = true;
		    angular.module('js-data').provider(adapter.class, function () {
		      var _this = this;
		      _this.defaults = {};
		      _this.$get = [function () {
		        return new Adapter(_this.defaults);
		      }];
		    });
		  }
		}
		
		var DSHttpAdapterProvider = function DSHttpAdapterProvider() {
		  _classCallCheck(this, DSHttpAdapterProvider);
		
		  var defaults = {};
		  this.defaults = defaults;
		
		  this.$get = ['$http', 'DS', function ($http, DS) {
		    defaults.http = defaults.http || $http;
		    var adapter = new DSHttpAdapter(defaults);
		    DS.registerAdapter('http', adapter, { 'default': true });
		    return adapter;
		  }];
		};
		
		var DSProvider = function DSProvider() {
		  _classCallCheck(this, DSProvider);
		
		  var _this = this;
		  var deps = [];
		
		  for (var i = 0; i < adapters.length; i++) {
		    if (adapters[i].loaded) {
		      deps.push(adapters[i].class);
		    }
		  }
		
		  _this.defaults = {};
		
		  JSData.DS.prototype.bindAll = function (resourceName, params, scope, expr, cb) {
		    var _this = this;
		
		    params = params || {};
		
		    if (!_this.definitions[resourceName]) {
		      throw new DSErrors.NER(resourceName);
		    } else if (!isObject(params)) {
		      throw new DSErrors.IA('"params" must be an object!');
		    } else if (!isObject(scope)) {
		      throw new DSErrors.IA('"scope" must be an object!');
		    } else if (!isString(expr)) {
		      throw new DSErrors.IA('"expr" must be a string!');
		    }
		
		    var idAttribute = _this.definitions[resourceName].idAttribute;
		
		    try {
		      return scope.$watch(function () {
		        return _this.lastModified(resourceName);
		      }, function () {
		        var items = _this.filter(resourceName, params);
		        if (items && items.length) {
		          angular.forEach(items, function (item) {
		            _this.compute(resourceName, get(item, idAttribute));
		          });
		        }
		        set(scope, expr, items);
		        if (cb) {
		          cb(null, items);
		        }
		      });
		    } catch (err) {
		      if (cb) {
		        cb(err);
		      } else {
		        throw err;
		      }
		    }
		  };
		
		  JSData.DS.prototype.bindOne = function (resourceName, id, scope, expr, cb) {
		    var _this = this;
		
		    id = resolveId(_this.definitions[resourceName], id);
		    if (!_this.definitions[resourceName]) {
		      throw new DSErrors.NER(resourceName);
		    } else if (!isString(id) && !isNumber(id)) {
		      throw new DSErrors.IA('"id" must be a string or a number!');
		    } else if (!isObject(scope)) {
		      throw new DSErrors.IA('"scope" must be an object!');
		    } else if (!isString(expr)) {
		      throw new DSErrors.IA('"expr" must be a string!');
		    }
		
		    try {
		      return scope.$watch(function () {
		        return _this.lastModified(resourceName, id);
		      }, function () {
		        var item = _this.get(resourceName, id);
		        if (item) {
		          _this.compute(resourceName, id);
		        }
		        set(scope, expr, item);
		        if (cb) {
		          cb(null, item);
		        }
		      });
		    } catch (err) {
		      if (cb) {
		        cb(err);
		      } else {
		        throw err;
		      }
		    }
		  };
		
		  function load() {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
		
		    var $rootScope = args[args.length - 2];
		    var $q = args[args.length - 1];
		    var store = new JSData.DS(_this.defaults);
		    var originals = {};
		
		    function QPromise(executor) {
		      var deferred = $q.defer();
		
		      try {
		        executor(angular.bind(deferred, deferred.resolve), angular.bind(deferred, deferred.reject));
		      } catch (err) {
		        deferred.reject(err);
		      }
		
		      return deferred.promise;
		    }
		
		    QPromise.all = $q.all;
		    QPromise.when = $q.when;
		    QPromise.reject = $q.reject;
		
		    DSUtils.Promise = QPromise;
		
		    // Register any adapters that have been loaded
		    if (args.length) {
		      for (var i = 0; i < args.length; i++) {
		        for (var j = 0; j < adapters.length; j++) {
		          if (adapters[j].loaded && !adapters[j].registered) {
		            adapters[j].registered = true;
		            store.registerAdapter(adapters[j].name, args[i]);
		            break;
		          }
		        }
		      }
		    }
		
		    // Wrap certain sync functions with $apply
		
		    var _loop = function _loop() {
		      var name = functionsToWrap[k];
		      originals[name] = store[name];
		      store[name] = function () {
		        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		          args[_key2] = arguments[_key2];
		        }
		
		        if (!$rootScope.$$phase) {
		          return $rootScope.$apply(function () {
		            return originals[name].apply(store, args);
		          });
		        }
		        return originals[name].apply(store, args);
		      };
		    };
		
		    for (var k = 0; k < functionsToWrap.length; k++) {
		      _loop();
		    }
		
		    // Hook into the digest loop
		    if (typeof Object.observe !== 'function' || typeof Array.observe !== 'function') {
		      $rootScope.$watch(function () {
		        return store.observe.Platform.performMicrotaskCheckpoint();
		      });
		    }
		
		    return store;
		  }
		
		  deps.push('$rootScope');
		  deps.push('$q');
		  deps.push(load);
		
		  _this.$get = deps;
		};
		
		angular.module('js-data', ['ng']).value('DSUtils', DSUtils).value('DSErrors', DSErrors).value('DSVersion', JSData.version).provider('DS', DSProvider).provider('DSHttpAdapter', DSHttpAdapterProvider).run(['DS', 'DSHttpAdapter', function (DS, DSHttpAdapter) {
		  DS.registerAdapter('http', DSHttpAdapter, { 'default': true });
		}]);
		
		for (var i = 0; i < adapters.length; i++) {
		  registerAdapter(adapters[i]);
		}
		
		// return the module name
		module.exports = 'js-data';
		try {
		  module.exports.name = 'js-data';
		} catch (e) {}
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var JSData = __webpack_require__(1);
		var axios = null;
		
		try {
		  axios = __webpack_require__(3);
		} catch (e) {}
		
		var DSUtils = JSData.DSUtils;
		var deepMixIn = DSUtils.deepMixIn;
		var removeCircular = DSUtils.removeCircular;
		var copy = DSUtils.copy;
		var makePath = DSUtils.makePath;
		var isString = DSUtils.isString;
		var isNumber = DSUtils.isNumber;
		
		
		function isUndefined(value) {
		  return value === undefined;
		}
		
		var Defaults = function () {
		  function Defaults() {
		    _classCallCheck(this, Defaults);
		  }
		
		  _createClass(Defaults, [{
		    key: 'queryTransform',
		    value: function queryTransform(resourceConfig, params) {
		      return params;
		    }
		  }, {
		    key: 'deserialize',
		    value: function deserialize(resourceConfig, data) {
		      return data ? 'data' in data ? data.data : data : data;
		    }
		  }, {
		    key: 'serialize',
		    value: function serialize(resourceConfig, data) {
		      return data;
		    }
		  }, {
		    key: 'log',
		    value: function log() {}
		  }, {
		    key: 'error',
		    value: function error() {}
		  }]);
		
		  return Defaults;
		}();
		
		var defaultsPrototype = Defaults.prototype;
		
		defaultsPrototype.basePath = '';
		
		defaultsPrototype.forceTrailingSlash = '';
		
		defaultsPrototype.httpConfig = {};
		
		defaultsPrototype.verbsUseBasePath = false;
		
		var DSHttpAdapter = function () {
		  function DSHttpAdapter(options) {
		    _classCallCheck(this, DSHttpAdapter);
		
		    options || (options = {});
		    this.defaults = new Defaults();
		    if (console) {
		      this.defaults.log = function (a, b) {
		        return console[typeof console.info === 'function' ? 'info' : 'log'](a, b);
		      };
		    }
		    if (console) {
		      this.defaults.error = function (a, b) {
		        return console[typeof console.error === 'function' ? 'error' : 'log'](a, b);
		      };
		    }
		    deepMixIn(this.defaults, options);
		    this.http = options.http || axios;
		  }
		
		  _createClass(DSHttpAdapter, [{
		    key: 'getEndpoint',
		    value: function getEndpoint(resourceConfig, id, options) {
		      options || (options = {});
		      options.params = isUndefined(options.params) ? {} : options.params;
		
		      var endpoint = options.hasOwnProperty('endpoint') ? options.endpoint : resourceConfig.endpoint;
		      var parents = resourceConfig.parents || (resourceConfig.parent ? _defineProperty({}, resourceConfig.parent, {
		        key: resourceConfig.parentKey,
		        field: resourceConfig.parentField
		      }) : {});
		
		      DSUtils.forOwn(parents, function (parent, parentName) {
		        var _this2 = this;
		
		        var item = void 0;
		        var parentKey = parent.key;
		        var parentField = parent.field;
		        var parentDef = resourceConfig.getResource(parentName);
		        var parentId = options.params[parentKey];
		
		        if (parentId === false || !parentKey || !parentDef) {
		          if (parentId === false) {
		            delete options.params[parentKey];
		          }
		        } else {
		          delete options.params[parentKey];
		
		          if (DSUtils._sn(id)) {
		            item = resourceConfig.get(id);
		          } else if (DSUtils._o(id)) {
		            item = id;
		          }
		
		          if (item) {
		            parentId = parentId || item[parentKey] || (item[parentField] ? item[parentField][parentDef.idAttribute] : null);
		          }
		
		          if (parentId) {
		            (function () {
		              delete options.endpoint;
		              var _options = {};
		              DSUtils.forOwn(options, function (value, key) {
		                _options[key] = value;
		              });
		              endpoint = DSUtils.makePath(_this2.getEndpoint(parentDef, parentId, DSUtils._(parentDef, _options)), parentId, endpoint);
		            })();
		          }
		        }
		      }, this);
		
		      return endpoint;
		    }
		  }, {
		    key: 'getPath',
		    value: function getPath(method, resourceConfig, id, options) {
		      var _this = this;
		      options || (options = {});
		      if (isString(options.urlPath)) {
		        return makePath.apply(DSUtils, [options.basePath || _this.defaults.basePath || resourceConfig.basePath, options.urlPath]);
		      } else {
		        var args = [options.basePath || _this.defaults.basePath || resourceConfig.basePath, this.getEndpoint(resourceConfig, isString(id) || isNumber(id) || method === 'create' ? id : null, options)];
		        if (method === 'find' || method === 'update' || method === 'destroy') {
		          args.push(id);
		        }
		        return makePath.apply(DSUtils, args);
		      }
		    }
		  }, {
		    key: 'HTTP',
		    value: function HTTP(config) {
		      var _this = this;
		      var start = new Date();
		
		      // blacklist `data` as it can be large and will take a lot of time to copy
		      var payload = config.data;
		      var cache = config.cache;
		      var timeout = config.timeout;
		      config = copy(config, null, null, null, ['data', 'cache', 'timeout']);
		      config = deepMixIn(config, _this.defaults.httpConfig);
		      config.data = payload;
		      config.cache = cache;
		      config.timeout = timeout;
		      if (!('verbsUseBasePath' in config)) {
		        config.verbsUseBasePath = _this.defaults.verbsUseBasePath;
		      }
		      if (!config.urlOverride && config.verbsUseBasePath) {
		        config.url = makePath(config.basePath || _this.defaults.basePath, config.url);
		      }
		      if (_this.defaults.forceTrailingSlash && config.url[config.url.length - 1] !== '/' && !config.urlOverride) {
		        config.url += '/';
		      }
		      if (_typeof(config.data) === 'object') {
		        config.data = removeCircular(config.data);
		      }
		      config.method = config.method.toUpperCase();
		      var suffix = isUndefined(config.suffix) ? _this.defaults.suffix : config.suffix;
		      if (suffix && config.url.substr(config.url.length - suffix.length) !== suffix && !config.urlOverride) {
		        config.url += suffix;
		      }
		
		      // logs the HTTP response
		      function logResponse(data, isRejection) {
		        data = data || {};
		        // examine the data object
		        if (data instanceof Error) {
		          // log the Error object
		          _this.defaults.error('FAILED: ' + (data.message || 'Unknown Error'), data);
		          return DSUtils.Promise.reject(data);
		        } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
		          var str = start.toUTCString() + ' - ' + config.method + ' ' + config.url + ' - ' + data.status + ' ' + (new Date().getTime() - start.getTime()) + 'ms';
		
		          if (data.status >= 200 && data.status < 300 && !isRejection) {
		            if (_this.defaults.log) {
		              _this.defaults.log(str, data);
		            }
		            return data;
		          } else {
		            if (_this.defaults.error) {
		              _this.defaults.error('FAILED: ' + str, data);
		            }
		            return DSUtils.Promise.reject(data);
		          }
		        } else {
		          // unknown type for 'data' that is not an Object or Error
		          _this.defaults.error('FAILED', data);
		          return DSUtils.Promise.reject(data);
		        }
		      }
		
		      if (!this.http) {
		        throw new Error('You have not configured this adapter with an http library!');
		      }
		
		      return this.http(config).then(logResponse, function (data) {
		        return logResponse(data, true);
		      });
		    }
		  }, {
		    key: 'GET',
		    value: function GET(url, config) {
		      config = config || {};
		      config.method = config.method || 'get';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'POST',
		    value: function POST(url, attrs, config) {
		      config = config || {};
		      config.method = config.method || 'post';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      config.data = config.data || attrs;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'PUT',
		    value: function PUT(url, attrs, config) {
		      config = config || {};
		      config.method = config.method || 'put';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      config.data = config.data || attrs;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'DEL',
		    value: function DEL(url, config) {
		      config = config || {};
		      config.method = config.method || 'delete';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'find',
		    value: function find(resourceConfig, id, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.GET(_this.getPath('find', resourceConfig, id, options), options).then(function (data) {
		        var item = (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		        return !item ? DSUtils.Promise.reject(new Error('Not Found!')) : item;
		      });
		    }
		  }, {
		    key: 'findAll',
		    value: function findAll(resourceConfig, params, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      if (params) {
		        params = _this.defaults.queryTransform(resourceConfig, params);
		        deepMixIn(options.params, params);
		      }
		      return _this.GET(_this.getPath('findAll', resourceConfig, params, options), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'create',
		    value: function create(resourceConfig, attrs, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.POST(_this.getPath('create', resourceConfig, attrs, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'update',
		    value: function update(resourceConfig, id, attrs, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.PUT(_this.getPath('update', resourceConfig, id, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'updateAll',
		    value: function updateAll(resourceConfig, attrs, params, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      if (params) {
		        params = _this.defaults.queryTransform(resourceConfig, params);
		        deepMixIn(options.params, params);
		      }
		      return this.PUT(_this.getPath('updateAll', resourceConfig, attrs, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'destroy',
		    value: function destroy(resourceConfig, id, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.DEL(_this.getPath('destroy', resourceConfig, id, options), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'destroyAll',
		    value: function destroyAll(resourceConfig, params, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      if (params) {
		        params = _this.defaults.queryTransform(resourceConfig, params);
		        deepMixIn(options.params, params);
		      }
		      return this.DEL(_this.getPath('destroyAll', resourceConfig, params, options), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }]);
		
		  return DSHttpAdapter;
		}();
		
		DSHttpAdapter.version = {
		  full: '3.2.1',
		  major: parseInt('3', 10),
		  minor: parseInt('2', 10),
		  patch: parseInt('1', 10),
		  alpha:  true ? 'false' : false,
		  beta:  true ? 'false' : false
		};
		
		module.exports = DSHttpAdapter;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		if(typeof __WEBPACK_EXTERNAL_MODULE_3__ === 'undefined') {var e = new Error("Cannot find module \"axios\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		var map = {};
		function webpackContext(req) {
			return __webpack_require__(webpackContextResolve(req));
		};
		function webpackContextResolve(req) {
			return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
		};
		webpackContext.keys = function webpackContextKeys() {
			return Object.keys(map);
		};
		webpackContext.resolve = webpackContextResolve;
		module.exports = webpackContext;
		webpackContext.id = 5;
	
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=js-data-angular.js.map

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * js-data
	 * @version 2.9.0 - Homepage <http://www.js-data.io/>
	 * @author Jason Dobry <jason.dobry@gmail.com>
	 * @copyright (c) 2014-2016 Jason Dobry 
	 * @license MIT <https://github.com/js-data/js-data/blob/master/LICENSE>
	 * 
	 * @overview Robust framework-agnostic data store.
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["JSData"] = factory();
		else
			root["JSData"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _index = __webpack_require__(1);
		
		var _index2 = _interopRequireDefault(_index);
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/**
		 * The library export.
		 *   - window.JSData
		 *   - require('js-data')
		 *   - define(['js-data', function (JSData) { ... }]);
		 *   - import JSData from 'js-data'
		 */
		module.exports = {
		  DS: _index2.default,
		  DSUtils: _utils2.default,
		  DSErrors: _errors2.default,
		  createStore: function createStore(options) {
		    return new _index2.default(options);
		  },
		
		  version: {
		    full: '2.9.0',
		    major: parseInt('2', 10),
		    minor: parseInt('9', 10),
		    patch: parseInt('0', 10),
		    alpha:  true ? 'false' : false,
		    beta:  true ? 'false' : false
		  }
		};
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* jshint eqeqeq:false */
		
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		var _index = __webpack_require__(41);
		
		var _index2 = _interopRequireDefault(_index);
		
		var _index3 = __webpack_require__(47);
		
		var _index4 = _interopRequireDefault(_index3);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function lifecycleNoopCb(resource, attrs, cb) {
		  cb(null, attrs);
		}
		
		function lifecycleNoop(resource, attrs) {
		  return attrs;
		}
		
		function compare(orderBy, index, a, b) {
		  var def = orderBy[index];
		  var cA = _utils2.default.get(a, def[0]);
		  var cB = _utils2.default.get(b, def[0]);
		  if (_utils2.default._s(cA)) {
		    cA = _utils2.default.upperCase(cA);
		  }
		  if (_utils2.default._s(cB)) {
		    cB = _utils2.default.upperCase(cB);
		  }
		  if (def[1] === 'DESC') {
		    if (cB < cA) {
		      return -1;
		    } else if (cB > cA) {
		      return 1;
		    } else {
		      if (index < orderBy.length - 1) {
		        return compare(orderBy, index + 1, a, b);
		      } else {
		        return 0;
		      }
		    }
		  } else {
		    if (cA < cB) {
		      return -1;
		    } else if (cA > cB) {
		      return 1;
		    } else {
		      if (index < orderBy.length - 1) {
		        return compare(orderBy, index + 1, a, b);
		      } else {
		        return 0;
		      }
		    }
		  }
		}
		
		var Defaults = function () {
		  function Defaults() {
		    _classCallCheck(this, Defaults);
		  }
		
		  _createClass(Defaults, [{
		    key: 'errorFn',
		    value: function errorFn(a, b) {
		      if (this.error && typeof this.error === 'function') {
		        try {
		          if (typeof a === 'string') {
		            throw new Error(a);
		          } else {
		            throw a;
		          }
		        } catch (err) {
		          a = err;
		        }
		        this.error(this.name || null, a || null, b || null);
		      }
		    }
		  }]);
		
		  return Defaults;
		}();
		
		var defaultsPrototype = Defaults.prototype;
		
		defaultsPrototype.actions = {};
		defaultsPrototype.afterCreate = lifecycleNoopCb;
		defaultsPrototype.afterCreateCollection = lifecycleNoop;
		defaultsPrototype.afterCreateInstance = lifecycleNoop;
		defaultsPrototype.afterDestroy = lifecycleNoopCb;
		defaultsPrototype.afterEject = lifecycleNoop;
		defaultsPrototype.afterFind = lifecycleNoopCb;
		defaultsPrototype.afterFindAll = lifecycleNoopCb;
		defaultsPrototype.afterInject = lifecycleNoop;
		defaultsPrototype.afterLoadRelations = lifecycleNoopCb;
		defaultsPrototype.afterReap = lifecycleNoop;
		defaultsPrototype.afterUpdate = lifecycleNoopCb;
		defaultsPrototype.afterValidate = lifecycleNoopCb;
		defaultsPrototype.allowSimpleWhere = true;
		defaultsPrototype.basePath = '';
		defaultsPrototype.beforeCreate = lifecycleNoopCb;
		defaultsPrototype.beforeCreateCollection = lifecycleNoop;
		defaultsPrototype.beforeCreateInstance = lifecycleNoop;
		defaultsPrototype.beforeDestroy = lifecycleNoopCb;
		defaultsPrototype.beforeEject = lifecycleNoop;
		defaultsPrototype.beforeInject = lifecycleNoop;
		defaultsPrototype.beforeReap = lifecycleNoop;
		defaultsPrototype.beforeUpdate = lifecycleNoopCb;
		defaultsPrototype.beforeValidate = lifecycleNoopCb;
		defaultsPrototype.bypassCache = false;
		defaultsPrototype.cacheResponse = !!_utils2.default.w;
		defaultsPrototype.csp = false;
		defaultsPrototype.clearEmptyQueries = true;
		defaultsPrototype.computed = {};
		defaultsPrototype.defaultAdapter = 'http';
		defaultsPrototype.debug = false;
		defaultsPrototype.defaultValues = {};
		defaultsPrototype.eagerEject = false;
		// TODO: Implement eagerInject in DS#create
		defaultsPrototype.eagerInject = false;
		defaultsPrototype.endpoint = '';
		defaultsPrototype.error = console ? function (a, b, c) {
		  return console[typeof console.error === 'function' ? 'error' : 'log'](a, b, c);
		} : false;
		defaultsPrototype.errorHandler = function () {
		  return _utils2.default.Promise.reject(arguments.length <= 0 ? undefined : arguments[0]);
		};
		defaultsPrototype.fallbackAdapters = ['http'];
		defaultsPrototype.findStrictCache = false;
		defaultsPrototype.idAttribute = 'id';
		defaultsPrototype.ignoredChanges = [/\$/];
		defaultsPrototype.instanceEvents = !!_utils2.default.w;
		defaultsPrototype.keepChangeHistory = false;
		defaultsPrototype.linkRelations = !!_utils2.default.w;
		defaultsPrototype.log = console ? function (a, b, c, d, e) {
		  return console[typeof console.info === 'function' ? 'info' : 'log'](a, b, c, d, e);
		} : false;
		
		defaultsPrototype.logFn = function (a, b, c, d) {
		  var _this = this;
		  if (_this.debug && _this.log && typeof _this.log === 'function') {
		    _this.log(_this.name || null, a || null, b || null, c || null, d || null);
		  }
		};
		
		defaultsPrototype.maxAge = false;
		defaultsPrototype.methods = {};
		defaultsPrototype.notify = !!_utils2.default.w;
		defaultsPrototype.omit = [];
		defaultsPrototype.onConflict = 'merge';
		defaultsPrototype.reapAction = _utils2.default.w ? 'inject' : 'none';
		defaultsPrototype.reapInterval = _utils2.default.w ? 30000 : false;
		defaultsPrototype.relationsEnumerable = false;
		defaultsPrototype.resetHistoryOnInject = true;
		defaultsPrototype.returnMeta = false;
		defaultsPrototype.scopes = {};
		defaultsPrototype.strategy = 'single';
		defaultsPrototype.upsert = !!_utils2.default.w;
		defaultsPrototype.useClass = true;
		defaultsPrototype.useFilter = false;
		defaultsPrototype.validate = lifecycleNoopCb;
		defaultsPrototype.watchChanges = !!_utils2.default.w;
		
		var escapeRegExp = /([.*+?^=!:${}()|[\]\/\\])/g;
		var percentRegExp = /%/g;
		var underscoreRegExp = /_/g;
		
		function escape(pattern) {
		  return pattern.replace(escapeRegExp, '\\$1');
		}
		
		function like(pattern, flags) {
		  return new RegExp('^' + escape(pattern).replace(percentRegExp, '.*').replace(underscoreRegExp, '.') + '$', flags);
		}
		
		defaultsPrototype.defaultFilter = function (collection, resourceName, params, options) {
		  var definition = this.definitions[resourceName];
		  var idA = 'id';
		  var resource = undefined;
		  if (definition) {
		    idA = definition.idAttribute;
		    resource = this.store[resourceName];
		  }
		  var filtered = collection;
		  var where = null;
		  var reserved = {
		    skip: '',
		    offset: '',
		    where: '',
		    limit: '',
		    orderBy: '',
		    sort: ''
		  };
		
		  params = params || {};
		  options = options || {};
		
		  if (_utils2.default._o(params.where)) {
		    where = params.where;
		  } else {
		    where = {};
		  }
		
		  if (options.allowSimpleWhere) {
		    _utils2.default.forOwn(params, function (value, key) {
		      if (!(key in reserved) && !(key in where)) {
		        where[key] = {
		          '==': value
		        };
		      }
		    });
		  }
		
		  if (_utils2.default.isEmpty(where)) {
		    where = null;
		  }
		
		  if (where) {
		    filtered = _utils2.default.filter(filtered, function (attrs) {
		      var first = true;
		      var keep = true;
		
		      if (options.excludeTemporary && resource && resource.temporaryItems[attrs[idA]]) {
		        return false;
		      }
		
		      _utils2.default.forOwn(where, function (clause, field) {
		        if (!_utils2.default._o(clause)) {
		          clause = {
		            '==': clause
		          };
		        }
		        _utils2.default.forOwn(clause, function (term, op) {
		          var expr = undefined;
		          var isOr = op[0] === '|';
		          var val = _utils2.default.get(attrs, field);
		          op = isOr ? op.substr(1) : op;
		          if (op === '==') {
		            expr = val == term; // eslint-disable-line
		          } else if (op === '===') {
		              expr = val === term;
		            } else if (op === '!=') {
		              expr = val != term; // eslint-disable-line
		            } else if (op === '!==') {
		                expr = val !== term;
		              } else if (op === '>') {
		                expr = val > term;
		              } else if (op === '>=') {
		                expr = val >= term;
		              } else if (op === '<') {
		                expr = val < term;
		              } else if (op === '<=') {
		                expr = val <= term;
		              } else if (op === 'isectEmpty') {
		                expr = !_utils2.default.intersection(val || [], term || []).length;
		              } else if (op === 'isectNotEmpty') {
		                expr = _utils2.default.intersection(val || [], term || []).length;
		              } else if (op === 'in') {
		                if (_utils2.default._s(term)) {
		                  expr = term.indexOf(val) !== -1;
		                } else {
		                  expr = _utils2.default.contains(term, val);
		                }
		              } else if (op === 'notIn') {
		                if (_utils2.default._s(term)) {
		                  expr = term.indexOf(val) === -1;
		                } else {
		                  expr = !_utils2.default.contains(term, val);
		                }
		              } else if (op.indexOf('like') === 0) {
		                expr = like(term, op.substr(4)).exec(val) !== null;
		              } else if (op.indexOf('notLike') === 0) {
		                expr = like(term, op.substr(7)).exec(val) === null;
		              } else if (op === 'contains') {
		                if (_utils2.default._s(val)) {
		                  expr = val.indexOf(term) !== -1;
		                } else {
		                  expr = _utils2.default.contains(val, term);
		                }
		              } else if (op === 'notContains') {
		                if (_utils2.default._s(val)) {
		                  expr = val.indexOf(term) === -1;
		                } else {
		                  expr = !_utils2.default.contains(val, term);
		                }
		              }
		          if (expr !== undefined) {
		            keep = first ? expr : isOr ? keep || expr : keep && expr;
		          }
		          first = false;
		        });
		      });
		
		      return keep;
		    });
		  } else if (options.excludeTemporary && resource) {
		    filtered = _utils2.default.filter(filtered, function (attrs) {
		      return resource.temporaryItems[attrs[idA]];
		    });
		  }
		
		  var orderBy = null;
		
		  if (_utils2.default._s(params.orderBy)) {
		    orderBy = [[params.orderBy, 'ASC']];
		  } else if (_utils2.default._a(params.orderBy)) {
		    orderBy = params.orderBy;
		  }
		
		  if (!orderBy && _utils2.default._s(params.sort)) {
		    orderBy = [[params.sort, 'ASC']];
		  } else if (!orderBy && _utils2.default._a(params.sort)) {
		    orderBy = params.sort;
		  }
		
		  // Apply 'orderBy'
		  if (orderBy) {
		    (function () {
		      var index = 0;
		      _utils2.default.forEach(orderBy, function (def, i) {
		        if (_utils2.default._s(def)) {
		          orderBy[i] = [def, 'ASC'];
		        } else if (!_utils2.default._a(def)) {
		          throw new _errors2.default.IA('DS.filter("' + resourceName + '"[, params][, options]): ' + _utils2.default.toJson(def) + ': Must be a string or an array!', {
		            params: {
		              'orderBy[i]': {
		                actual: typeof def === 'undefined' ? 'undefined' : _typeof(def),
		                expected: 'string|array'
		              }
		            }
		          });
		        }
		      });
		      filtered = _utils2.default.sort(filtered, function (a, b) {
		        return compare(orderBy, index, a, b);
		      });
		    })();
		  }
		
		  var limit = _utils2.default._n(params.limit) ? params.limit : null;
		  var skip = null;
		
		  if (_utils2.default._n(params.skip)) {
		    skip = params.skip;
		  } else if (_utils2.default._n(params.offset)) {
		    skip = params.offset;
		  }
		
		  // Apply 'limit' and 'skip'
		  if (limit && skip) {
		    filtered = _utils2.default.slice(filtered, skip, Math.min(filtered.length, skip + limit));
		  } else if (_utils2.default._n(limit)) {
		    filtered = _utils2.default.slice(filtered, 0, Math.min(filtered.length, limit));
		  } else if (_utils2.default._n(skip)) {
		    if (skip < filtered.length) {
		      filtered = _utils2.default.slice(filtered, skip);
		    } else {
		      filtered = [];
		    }
		  }
		
		  return filtered === collection ? filtered.slice() : filtered;
		};
		
		var DS = function () {
		  function DS(options) {
		    _classCallCheck(this, DS);
		
		    var _this = this;
		    options = options || {};
		
		    _this.store = {};
		    _this.definitions = {};
		    _this.adapters = {};
		    _this.defaults = new Defaults();
		    _this.observe = _utils2.default.observe;
		    _utils2.default.forOwn(options, function (v, k) {
		      if (k === 'omit') {
		        _this.defaults.omit = v.concat(Defaults.prototype.omit);
		      } else {
		        _this.defaults[k] = v;
		      }
		    });
		    _this.defaults.logFn('new data store created', _this.defaults);
		
		    var P = _utils2.default.Promise;
		
		    if (P && !P.prototype.spread) {
		      P.prototype.spread = function (cb) {
		        return this.then(function (arr) {
		          return cb.apply(this, arr);
		        });
		      };
		    }
		
		    _utils2.default.Events(_this);
		  }
		
		  _createClass(DS, [{
		    key: 'getAdapterName',
		    value: function getAdapterName(options) {
		      var errorIfNotExist = false;
		      options = options || {};
		      this.defaults.logFn('getAdapterName', options);
		      if (_utils2.default._s(options)) {
		        errorIfNotExist = true;
		        options = {
		          adapter: options
		        };
		      }
		      if (this.adapters[options.adapter]) {
		        return options.adapter;
		      } else if (errorIfNotExist) {
		        throw new Error(options.adapter + ' is not a registered adapter!');
		      } else {
		        return options.defaultAdapter;
		      }
		    }
		  }, {
		    key: 'getAdapter',
		    value: function getAdapter(options) {
		      options = options || {};
		      this.defaults.logFn('getAdapter', options);
		      return this.adapters[this.getAdapterName(options)];
		    }
		  }, {
		    key: 'registerAdapter',
		    value: function registerAdapter(name, Adapter, options) {
		      var _this = this;
		      options = options || {};
		      _this.defaults.logFn('registerAdapter', name, Adapter, options);
		      if (_utils2.default.isFunction(Adapter)) {
		        _this.adapters[name] = new Adapter(options);
		      } else {
		        _this.adapters[name] = Adapter;
		      }
		      if (options.default) {
		        _this.defaults.defaultAdapter = name;
		      }
		      _this.defaults.logFn('default adapter is ' + _this.defaults.defaultAdapter);
		    }
		  }, {
		    key: 'is',
		    value: function is(resourceName, instance) {
		      var definition = this.definitions[resourceName];
		      if (!definition) {
		        throw new _errors2.default.NER(resourceName);
		      }
		      return instance instanceof definition[definition.class];
		    }
		  }, {
		    key: 'clear',
		    value: function clear() {
		      var _this2 = this;
		
		      var ejected = {};
		      _utils2.default.forOwn(this.definitions, function (definition) {
		        var name = definition.name;
		        ejected[name] = definition.ejectAll();
		        _this2.store[name].completedQueries = {};
		        _this2.store[name].queryData = {};
		      });
		      return ejected;
		    }
		  }, {
		    key: 'errorFn',
		    value: function errorFn() {
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
		
		      var options = args[args.length - 1];
		      var defaultHandler = this.defaults.errorHandler;
		      var errorHandler = options ? options.errorHandler : defaultHandler;
		      errorHandler = errorHandler || defaultHandler;
		      return function (err) {
		        return errorHandler.apply(undefined, [err].concat(args));
		      };
		    }
		  }]);
		
		  return DS;
		}();
		
		var dsPrototype = DS.prototype;
		
		dsPrototype.getAdapterName.shorthand = false;
		dsPrototype.getAdapter.shorthand = false;
		dsPrototype.registerAdapter.shorthand = false;
		dsPrototype.errors = _errors2.default;
		dsPrototype.utils = _utils2.default;
		
		function addMethods(target, obj) {
		  _utils2.default.forOwn(obj, function (v, k) {
		    target[k] = v;
		    target[k].before = function (fn) {
		      var orig = target[k];
		      target[k] = function () {
		        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		          args[_key2] = arguments[_key2];
		        }
		
		        return orig.apply(this, fn.apply(this, args) || args);
		      };
		    };
		  });
		}
		
		addMethods(dsPrototype, _index2.default);
		addMethods(dsPrototype, _index4.default);
		
		exports.default = DS;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /* jshint eqeqeq:false */
		
		/**
		 * Mix of ES6 and CommonJS module imports because the interop of Babel + Webpack + ES6 modules + CommonJS isn't very good.
		 */
		
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		var BinaryHeap = __webpack_require__(4);
		var forEach = __webpack_require__(5);
		var slice = __webpack_require__(6);
		var forOwn = __webpack_require__(7);
		var contains = __webpack_require__(10);
		var deepMixIn = __webpack_require__(12);
		var pascalCase = __webpack_require__(14);
		var remove = __webpack_require__(21);
		var pick = __webpack_require__(22);
		var _keys = __webpack_require__(23);
		var sort = __webpack_require__(24);
		var upperCase = __webpack_require__(19);
		var get = __webpack_require__(25);
		var set = __webpack_require__(27);
		var observe = __webpack_require__(29);
		var guid = __webpack_require__(30);
		var w = undefined,
		    P = undefined,
		    File = undefined;
		var objectProto = Object.prototype;
		var toString = objectProto.toString;
		
		/**
		 * Attempt to detect the global Promise constructor.
		 * JSData will still work without one, as long you do something like this:
		 *
		 * var JSData = require('js-data');
		 * JSData.DSUtils.Promise = MyPromiseLib;
		 */
		try {
		  P = Promise;
		} catch (e) {
		  console.error('js-data requires a global Promise constructor!');
		}
		
		try {
		  File = window.File;
		} catch (e) {
		  File = function File() {};
		}
		
		function _isArray(value) {
		  return toString.call(value) === '[object Array]' || false;
		}
		
		var isArray = Array.isArray || _isArray;
		
		function isRegExp(value) {
		  return toString.call(value) === '[object RegExp]' || false;
		}
		
		// adapted from lodash.isString
		function isString(value) {
		  return typeof value === 'string' || value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && toString.call(value) === '[object String]' || false;
		}
		
		function isObject(value) {
		  return toString.call(value) === '[object Object]' || false;
		}
		
		// adapted from lodash.isDate
		function isDate(value) {
		  return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && toString.call(value) === '[object Date]' || false;
		}
		
		// adapted from lodash.isNumber
		function isNumber(value) {
		  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		  return type === 'number' || value && type === 'object' && toString.call(value) === '[object Number]' || false;
		}
		
		// adapted from lodash.isFunction
		function isFunction(value) {
		  return typeof value === 'function' || value && toString.call(value) === '[object Function]' || false;
		}
		
		// shorthand argument checking functions, using these shaves 1.18 kb off of the minified build
		function isStringOrNumber(value) {
		  return isString(value) || isNumber(value);
		}
		
		function isStringOrNumberErr(field) {
		  return new _errors2.default.IA('"' + field + '" must be a string or a number!');
		}
		
		function isObjectErr(field) {
		  return new _errors2.default.IA('"' + field + '" must be an object!');
		}
		
		function isArrayErr(field) {
		  return new _errors2.default.IA('"' + field + '" must be an array!');
		}
		
		// adapted from mout.isEmpty
		function isEmpty(val) {
		  if (val == null) {
		    // jshint ignore:line
		    // typeof null == 'object' so we check it first
		    return true;
		  } else if (typeof val === 'string' || isArray(val)) {
		    return !val.length;
		  } else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
		    var result = true;
		    forOwn(val, function () {
		      result = false;
		      return false; // break loop
		    });
		    return result;
		  } else {
		    return true;
		  }
		}
		
		// Find the intersection between two arrays
		function intersection(array1, array2) {
		  if (!array1 || !array2) {
		    return [];
		  }
		  var result = [];
		  var item = undefined;
		  for (var i = 0, length = array1.length; i < length; i++) {
		    item = array1[i];
		    if (contains(result, item)) {
		      continue;
		    }
		    if (contains(array2, item)) {
		      result.push(item);
		    }
		  }
		  return result;
		}
		
		function filter(array, cb, thisObj) {
		  var results = [];
		  forEach(array, function (value, key, arr) {
		    if (cb(value, key, arr)) {
		      results.push(value);
		    }
		  }, thisObj);
		  return results;
		}
		
		/**
		 * Attempt to detect whether we are in the browser.
		 */
		try {
		  w = window;
		  w = {};
		} catch (e) {
		  w = null;
		}
		
		/**
		 * Event mixin. Usage:
		 *
		 * function handler() { ... }
		 * Events(myObject);
		 * myObject.on('foo', handler);
		 * myObject.emit('foo', 'some', 'data');
		 * myObject.off('foo', handler);
		 */
		function Events(target) {
		  var events = {};
		  target = target || this;
		  Object.defineProperties(target, {
		    on: {
		      value: function value(type, func, ctx) {
		        events[type] = events[type] || [];
		        events[type].push({
		          f: func,
		          c: ctx
		        });
		      }
		    },
		    off: {
		      value: function value(type, func) {
		        var listeners = events[type];
		        if (!listeners) {
		          events = {};
		        } else if (func) {
		          for (var i = 0; i < listeners.length; i++) {
		            if (listeners[i].f === func) {
		              listeners.splice(i, 1);
		              break;
		            }
		          }
		        } else {
		          listeners.splice(0, listeners.length);
		        }
		      }
		    },
		    emit: {
		      value: function value() {
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		          args[_key] = arguments[_key];
		        }
		
		        var listeners = events[args.shift()] || [];
		        if (listeners) {
		          for (var i = 0; i < listeners.length; i++) {
		            listeners[i].f.apply(listeners[i].c, args);
		          }
		        }
		      }
		    }
		  });
		}
		
		/**
		 * Lifecycle hooks that should support promises.
		 */
		var toPromisify = ['beforeValidate', 'validate', 'afterValidate', 'beforeCreate', 'afterCreate', 'beforeUpdate', 'afterUpdate', 'beforeDestroy', 'afterDestroy'];
		
		/**
		 * Return whether "prop" is in the blacklist.
		 */
		var isBlacklisted = observe.isBlacklisted;
		
		// adapted from angular.copy
		function copy(source, destination, stackSource, stackDest, blacklist) {
		  if (!destination) {
		    destination = source;
		    if (source) {
		      if (isArray(source)) {
		        destination = copy(source, [], stackSource, stackDest, blacklist);
		      } else if (isDate(source)) {
		        destination = new Date(source.getTime());
		      } else if (isRegExp(source)) {
		        destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
		        destination.lastIndex = source.lastIndex;
		      } else if (isObject(source)) {
		        destination = copy(source, Object.create(Object.getPrototypeOf(source)), stackSource, stackDest, blacklist);
		      }
		    }
		  } else {
		    if (source === destination) {
		      throw new Error('Cannot copy! Source and destination are identical.');
		    }
		
		    stackSource = stackSource || [];
		    stackDest = stackDest || [];
		
		    if (isObject(source)) {
		      var index = stackSource.indexOf(source);
		      if (index !== -1) {
		        return stackDest[index];
		      }
		
		      stackSource.push(source);
		      stackDest.push(destination);
		    }
		
		    var result = undefined;
		    if (isArray(source)) {
		      var i = undefined;
		      destination.length = 0;
		      for (i = 0; i < source.length; i++) {
		        result = copy(source[i], null, stackSource, stackDest, blacklist);
		        if (isObject(source[i])) {
		          stackSource.push(source[i]);
		          stackDest.push(result);
		        }
		        destination.push(result);
		      }
		    } else {
		      if (isArray(destination)) {
		        destination.length = 0;
		      } else {
		        forEach(destination, function (value, key) {
		          delete destination[key];
		        });
		      }
		      for (var key in source) {
		        if (source.hasOwnProperty(key)) {
		          if (isBlacklisted(key, blacklist)) {
		            continue;
		          }
		          result = copy(source[key], null, stackSource, stackDest, blacklist);
		          if (isObject(source[key])) {
		            stackSource.push(source[key]);
		            stackDest.push(result);
		          }
		          destination[key] = result;
		        }
		      }
		    }
		  }
		  return destination;
		}
		
		// adapted from angular.equals
		function equals(o1, o2) {
		  if (o1 === o2) {
		    return true;
		  }
		  if (o1 === null || o2 === null) {
		    return false;
		  }
		  if (o1 !== o1 && o2 !== o2) {
		    // eslint-disable-line
		    return true;
		  } // NaN === NaN
		  var t1 = typeof o1 === 'undefined' ? 'undefined' : _typeof(o1);
		  var t2 = typeof o2 === 'undefined' ? 'undefined' : _typeof(o2);
		  var length, key, keySet;
		  if (t1 == t2) {
		    // eslint-disable-line
		    if (t1 == 'object') {
		      // eslint-disable-line
		      if (isArray(o1)) {
		        if (!isArray(o2)) {
		          return false;
		        }
		        if ((length = o1.length) === o2.length) {
		          // jshint ignore:line
		          for (key = 0; key < length; key++) {
		            if (!equals(o1[key], o2[key])) {
		              return false;
		            }
		          }
		          return true;
		        }
		      } else if (isDate(o1)) {
		        if (!isDate(o2)) {
		          return false;
		        }
		        return equals(o1.getTime(), o2.getTime());
		      } else if (isRegExp(o1) && isRegExp(o2)) {
		        return o1.toString() == o2.toString(); // eslint-disable-line
		      } else {
		          if (isArray(o2)) {
		            return false;
		          }
		          keySet = {};
		          for (key in o1) {
		            if (key.charAt(0) === '$' || isFunction(o1[key])) {
		              continue;
		            }
		            if (!equals(o1[key], o2[key])) {
		              return false;
		            }
		            keySet[key] = true;
		          }
		          for (key in o2) {
		            if (!keySet.hasOwnProperty(key) && key.charAt(0) !== '$' && o2[key] !== undefined && !isFunction(o2[key])) {
		              return false;
		            }
		          }
		          return true;
		        }
		    }
		  }
		  return false;
		}
		
		/**
		 * Given either an instance or the primary key of an instance, return the primary key.
		 */
		function resolveId(definition, idOrInstance) {
		  if (isString(idOrInstance) || isNumber(idOrInstance)) {
		    return idOrInstance;
		  } else if (idOrInstance && definition) {
		    return idOrInstance[definition.idAttribute] || idOrInstance;
		  } else {
		    return idOrInstance;
		  }
		}
		
		/**
		 * Given either an instance or the primary key of an instance, return the instance.
		 */
		function resolveItem(resource, idOrInstance) {
		  if (resource && (isString(idOrInstance) || isNumber(idOrInstance))) {
		    return resource.index[idOrInstance] || idOrInstance;
		  } else {
		    return idOrInstance;
		  }
		}
		
		function isValidString(val) {
		  return val != null && val !== ''; // jshint ignore:line
		}
		
		function join(items, separator) {
		  separator = separator || '';
		  return filter(items, isValidString).join(separator);
		}
		
		function makePath() {
		  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		    args[_key2] = arguments[_key2];
		  }
		
		  var result = join(args, '/');
		  return result.replace(/([^:\/]|^)\/{2,}/g, '$1/');
		}
		
		exports.default = {
		  Promise: P,
		  /**
		   * Method to wrap an "options" object so that it will inherit from
		   * some parent object, such as a resource definition.
		   */
		  _: function _(parent, options) {
		    var _this = this;
		    parent = parent || {};
		    options = options || {};
		    if (options && options.constructor === parent.constructor) {
		      return options;
		    } else if (!isObject(options)) {
		      throw new _errors2.default.IA('"options" must be an object!');
		    }
		    forEach(toPromisify, function (name) {
		      if (typeof options[name] === 'function' && options[name].toString().indexOf('for (var _len = arg') === -1) {
		        options[name] = _this.promisify(options[name]);
		      }
		    });
		    // Dynamic constructor function
		    var O = function Options(attrs) {
		      var self = this;
		      forOwn(attrs, function (value, key) {
		        self[key] = value;
		      });
		    };
		    // Inherit from some parent object
		    O.prototype = parent;
		    // Give us a way to get the original options back.
		    O.prototype.orig = function () {
		      var orig = {};
		      forOwn(this, function (value, key) {
		        orig[key] = value;
		      });
		      return orig;
		    };
		    return new O(options);
		  },
		
		  _n: isNumber,
		  _s: isString,
		  _sn: isStringOrNumber,
		  _snErr: isStringOrNumberErr,
		  _o: isObject,
		  _oErr: isObjectErr,
		  _a: isArray,
		  _aErr: isArrayErr,
		  applyScope: function applyScope(definition, params, options) {
		    var scope = options.scope;
		    var _params = copy(params);
		    if (scope) {
		      if (isString(scope)) {
		        scope = [scope];
		      }
		    } else {
		      scope = [];
		    }
		    scope.unshift('defaultScope');
		    forEach(scope, function (_scope) {
		      var scopeDef = options.scopes[_scope];
		      if (typeof scopeDef === 'function') {
		        deepMixIn(params, scopeDef(definition));
		      } else if (scopeDef) {
		        deepMixIn(params, scopeDef);
		      }
		    });
		    deepMixIn(params, _params);
		  },
		  compute: function compute(fn, field) {
		    var _this = this;
		    var args = [];
		    if (!isObject(fn)) {
		      forEach(fn.deps, function (dep) {
		        args.push(get(_this, dep));
		      });
		      // compute property
		      set(_this, field, fn[fn.length - 1].apply(_this, args));
		    }
		  },
		
		  contains: contains,
		  copy: copy,
		  deepMixIn: deepMixIn,
		  diffObjectFromOldObject: observe.diffObjectFromOldObject,
		  BinaryHeap: BinaryHeap,
		  equals: equals,
		  Events: Events,
		  filter: filter,
		  fillIn: function fillIn(target, obj) {
		    forOwn(obj, function (v, k) {
		      if (!(k in target)) {
		        target[k] = v;
		      }
		    });
		    return target;
		  },
		
		  forEach: forEach,
		  forOwn: forOwn,
		  fromJson: function fromJson(json) {
		    return isString(json) ? JSON.parse(json) : json;
		  },
		
		  get: get,
		  guid: guid,
		  intersection: intersection,
		  isArray: isArray,
		  isBlacklisted: isBlacklisted,
		  isEmpty: isEmpty,
		  isFunction: isFunction,
		  isObject: isObject,
		  isNumber: isNumber,
		  isString: isString,
		  keys: _keys,
		  makePath: makePath,
		  observe: observe,
		  omit: function omit(obj, bl) {
		    var toRemove = [];
		    forOwn(obj, function (v, k) {
		      if (isBlacklisted(k, bl)) {
		        toRemove.push(k);
		      }
		    });
		    forEach(toRemove, function (k) {
		      delete obj[k];
		    });
		    return obj;
		  },
		
		  pascalCase: pascalCase,
		  pick: pick,
		  // Turn the given node-style callback function into one that can return a promise.
		  promisify: function promisify(fn, target) {
		    var _this = this;
		    if (!fn) {
		      return;
		    } else if (typeof fn !== 'function') {
		      throw new Error('Can only promisify functions!');
		    }
		    return function () {
		      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		        args[_key3] = arguments[_key3];
		      }
		
		      return new _this.Promise(function (resolve, reject) {
		        args.push(function (err, result) {
		          if (err) {
		            reject(err);
		          } else {
		            resolve(result);
		          }
		        });
		
		        try {
		          var promise = fn.apply(target || this, args);
		          if (promise && promise.then) {
		            promise.then(resolve, reject);
		          }
		        } catch (err) {
		          reject(err);
		        }
		      });
		    };
		  },
		
		  remove: remove,
		  set: set,
		  slice: slice,
		  sort: sort,
		  toJson: JSON.stringify,
		  updateTimestamp: function updateTimestamp(timestamp) {
		    var newTimestamp = typeof Date.now === 'function' ? Date.now() : new Date().getTime();
		    if (timestamp && newTimestamp <= timestamp) {
		      return timestamp + 1;
		    } else {
		      return newTimestamp;
		    }
		  },
		
		  upperCase: upperCase,
		  // Return a copy of "object" with cycles removed.
		  removeCircular: function removeCircular(object) {
		    return function rmCirc(value, ctx) {
		      var i = undefined;
		      var nu = undefined;
		
		      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null && !(value instanceof Boolean) && !(value instanceof Date) && !(value instanceof Number) && !(value instanceof RegExp) && !(value instanceof String) && (!File || !(value instanceof File))) {
		        // check if current object points back to itself
		        var cur = ctx.cur;
		        var parent = ctx.ctx;
		        while (parent) {
		          if (parent.cur === cur) {
		            return undefined;
		          }
		          parent = parent.ctx;
		        }
		
		        if (isArray(value)) {
		          nu = [];
		          for (i = 0; i < value.length; i += 1) {
		            nu[i] = rmCirc(value[i], { ctx: ctx, cur: value[i] });
		          }
		        } else {
		          nu = {};
		          forOwn(value, function (v, k) {
		            nu[k] = rmCirc(value[k], { ctx: ctx, cur: value[k] });
		          });
		        }
		        return nu;
		      }
		      return value;
		    }(object, { ctx: null, cur: object });
		  },
		
		  resolveItem: resolveItem,
		  resolveId: resolveId,
		  respond: function respond(response, meta, options) {
		    if (options.returnMeta === 'array') {
		      return [response, meta];
		    } else if (options.returnMeta === 'object') {
		      return { response: response, meta: meta };
		    } else {
		      return response;
		    }
		  },
		
		  w: w,
		  // This is where the magic of relations happens.
		  applyRelationGettersToTarget: function applyRelationGettersToTarget(store, definition, target) {
		    this.forEach(definition.relationList, function (def) {
		      var relationName = def.relation;
		      var localField = def.localField;
		      var localKey = def.localKey;
		      var foreignKey = def.foreignKey;
		      var localKeys = def.localKeys;
		      var foreignKeys = def.foreignKeys;
		      var enumerable = typeof def.enumerable === 'boolean' ? def.enumerable : !!definition.relationsEnumerable;
		      if (typeof def.link === 'boolean' ? def.link : !!definition.linkRelations) {
		        delete target[localField];
		        var prop = {
		          enumerable: enumerable
		        };
		        if (def.type === 'belongsTo') {
		          prop.get = function () {
		            var key = get(this, localKey);
		            var hasKey = !!(key || key === 0);
		            return hasKey ? definition.getResource(relationName).get(key) : undefined;
		          };
		          prop.set = function (parent) {
		            if (parent) {
		              set(this, localKey, get(parent, definition.getResource(relationName).idAttribute));
		            }
		            return get(this, localField);
		          };
		        } else if (def.type === 'hasMany') {
		          prop.get = function () {
		            var params = {};
		            if (foreignKey) {
		              params[foreignKey] = this[definition.idAttribute];
		              return definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params, { allowSimpleWhere: true });
		            } else if (localKeys) {
		              var keys = get(this, localKeys) || [];
		              return definition.getResource(relationName).getAll(isArray(keys) ? keys : _keys(keys));
		            } else if (foreignKeys) {
		              set(params, 'where.' + foreignKeys + '.contains', this[definition.idAttribute]);
		              return definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params);
		            }
		            return undefined;
		          };
		          prop.set = function (children) {
		            var _this2 = this;
		
		            if (children && children.length) {
		              (function () {
		                var id = get(_this2, definition.idAttribute);
		                if (foreignKey) {
		                  forEach(children, function (child) {
		                    set(child, foreignKey, id);
		                  });
		                } else if (localKeys) {
		                  (function () {
		                    var keys = [];
		                    forEach(children, function (child) {
		                      keys.push(get(child, definition.getResource(relationName).idAttribute));
		                    });
		                    set(_this2, localKeys, keys);
		                  })();
		                } else if (foreignKeys) {
		                  forEach(children, function (child) {
		                    var keys = get(child, foreignKeys);
		                    if (keys) {
		                      if (!contains(keys, id)) {
		                        keys.push(id);
		                      }
		                    } else {
		                      set(child, foreignKeys, [id]);
		                    }
		                  });
		                }
		              })();
		            }
		            return get(this, localField);
		          };
		        } else if (def.type === 'hasOne') {
		          if (localKey) {
		            prop.get = function () {
		              var key = get(this, localKey);
		              var hasKey = !!(key || key === 0);
		              return hasKey ? definition.getResource(relationName).get(key) : undefined;
		            };
		            prop.set = function (sibling) {
		              if (sibling) {
		                set(this, localKey, get(sibling, definition.getResource(relationName).idAttribute));
		              }
		              return get(this, localField);
		            };
		          } else {
		            prop.get = function () {
		              var params = {};
		              params[foreignKey] = this[definition.idAttribute];
		              var items = params[foreignKey] ? definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params, { allowSimpleWhere: true }) : [];
		              if (items.length) {
		                return items[0];
		              }
		              return undefined;
		            };
		            prop.set = function (sibling) {
		              if (sibling) {
		                set(sibling, foreignKey, get(this, definition.idAttribute));
		              }
		              return get(this, localField);
		            };
		          }
		        }
		        if (def.get) {
		          (function () {
		            var orig = prop.get;
		            prop.get = function () {
		              var _this3 = this;
		
		              return def.get(definition, def, this, function () {
		                for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		                  args[_key4] = arguments[_key4];
		                }
		
		                return orig.apply(_this3, args);
		              });
		            };
		          })();
		        }
		        Object.defineProperty(target, localField, prop);
		      }
		    });
		  }
		};
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		/**
		 * Thrown during a method call when an argument passed into the method is invalid.
		 */
		
		var IllegalArgumentError = function (_Error) {
		  _inherits(IllegalArgumentError, _Error);
		
		  function IllegalArgumentError(message) {
		    _classCallCheck(this, IllegalArgumentError);
		
		    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(IllegalArgumentError).call(this));
		
		    if (typeof Error.captureStackTrace === 'function') {
		      Error.captureStackTrace(_this, _this.constructor);
		    }
		    _this.type = _this.constructor.name;
		    _this.message = message;
		    return _this;
		  }
		
		  return IllegalArgumentError;
		}(Error);
		
		/**
		 * Thrown when an invariant is violated or unrecoverable error is encountered during execution.
		 */
		
		
		var RuntimeError = function (_Error2) {
		  _inherits(RuntimeError, _Error2);
		
		  function RuntimeError(message) {
		    _classCallCheck(this, RuntimeError);
		
		    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(RuntimeError).call(this));
		
		    if (typeof Error.captureStackTrace === 'function') {
		      Error.captureStackTrace(_this2, _this2.constructor);
		    }
		    _this2.type = _this2.constructor.name;
		    _this2.message = message;
		    return _this2;
		  }
		
		  return RuntimeError;
		}(Error);
		
		/**
		 * Thrown when attempting to access or work with a non-existent resource.
		 */
		
		
		var NonexistentResourceError = function (_Error3) {
		  _inherits(NonexistentResourceError, _Error3);
		
		  function NonexistentResourceError(resourceName) {
		    _classCallCheck(this, NonexistentResourceError);
		
		    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(NonexistentResourceError).call(this));
		
		    if (typeof Error.captureStackTrace === 'function') {
		      Error.captureStackTrace(_this3, _this3.constructor);
		    }
		    _this3.type = _this3.constructor.name;
		    _this3.message = resourceName + ' is not a registered resource!';
		    return _this3;
		  }
		
		  return NonexistentResourceError;
		}(Error);
		
		exports.default = {
		  IllegalArgumentError: IllegalArgumentError,
		  IA: IllegalArgumentError,
		  RuntimeError: RuntimeError,
		  R: RuntimeError,
		  NonexistentResourceError: NonexistentResourceError,
		  NER: NonexistentResourceError
		};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*!
		 * yabh
		 * @version 1.1.0 - Homepage <http://jmdobry.github.io/yabh/>
		 * @author Jason Dobry <jason.dobry@gmail.com>
		 * @copyright (c) 2015 Jason Dobry 
		 * @license MIT <https://github.com/jmdobry/yabh/blob/master/LICENSE>
		 * 
		 * @overview Yet another Binary Heap.
		 */
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory();
			else if(typeof define === 'function' && define.amd)
				define("yabh", factory);
			else if(typeof exports === 'object')
				exports["BinaryHeap"] = factory();
			else
				root["BinaryHeap"] = factory();
		})(this, function() {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		
		
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ function(module, exports, __webpack_require__) {
		
			/**
			 * @method bubbleUp
			 * @param {array} heap The heap.
			 * @param {function} weightFunc The weight function.
			 * @param {number} n The index of the element to bubble up.
			 */
			function bubbleUp(heap, weightFunc, n) {
			  var element = heap[n];
			  var weight = weightFunc(element);
			  // When at 0, an element can not go up any further.
			  while (n > 0) {
			    // Compute the parent element's index, and fetch it.
			    var parentN = Math.floor((n + 1) / 2) - 1;
			    var _parent = heap[parentN];
			    // If the parent has a lesser weight, things are in order and we
			    // are done.
			    if (weight >= weightFunc(_parent)) {
			      break;
			    } else {
			      heap[parentN] = element;
			      heap[n] = _parent;
			      n = parentN;
			    }
			  }
			}
		
			/**
			 * @method bubbleDown
			 * @param {array} heap The heap.
			 * @param {function} weightFunc The weight function.
			 * @param {number} n The index of the element to sink down.
			 */
			var bubbleDown = function bubbleDown(heap, weightFunc, n) {
			  var length = heap.length;
			  var node = heap[n];
			  var nodeWeight = weightFunc(node);
		
			  while (true) {
			    var child2N = (n + 1) * 2,
			        child1N = child2N - 1;
			    var swap = null;
			    if (child1N < length) {
			      var child1 = heap[child1N],
			          child1Weight = weightFunc(child1);
			      // If the score is less than our node's, we need to swap.
			      if (child1Weight < nodeWeight) {
			        swap = child1N;
			      }
			    }
			    // Do the same checks for the other child.
			    if (child2N < length) {
			      var child2 = heap[child2N],
			          child2Weight = weightFunc(child2);
			      if (child2Weight < (swap === null ? nodeWeight : weightFunc(heap[child1N]))) {
			        swap = child2N;
			      }
			    }
		
			    if (swap === null) {
			      break;
			    } else {
			      heap[n] = heap[swap];
			      heap[swap] = node;
			      n = swap;
			    }
			  }
			};
		
			function BinaryHeap(weightFunc, compareFunc) {
			  if (!weightFunc) {
			    weightFunc = function (x) {
			      return x;
			    };
			  }
			  if (!compareFunc) {
			    compareFunc = function (x, y) {
			      return x === y;
			    };
			  }
			  if (typeof weightFunc !== 'function') {
			    throw new Error('BinaryHeap([weightFunc][, compareFunc]): "weightFunc" must be a function!');
			  }
			  if (typeof compareFunc !== 'function') {
			    throw new Error('BinaryHeap([weightFunc][, compareFunc]): "compareFunc" must be a function!');
			  }
			  this.weightFunc = weightFunc;
			  this.compareFunc = compareFunc;
			  this.heap = [];
			}
		
			var BHProto = BinaryHeap.prototype;
		
			BHProto.push = function (node) {
			  this.heap.push(node);
			  bubbleUp(this.heap, this.weightFunc, this.heap.length - 1);
			};
		
			BHProto.peek = function () {
			  return this.heap[0];
			};
		
			BHProto.pop = function () {
			  var front = this.heap[0];
			  var end = this.heap.pop();
			  if (this.heap.length > 0) {
			    this.heap[0] = end;
			    bubbleDown(this.heap, this.weightFunc, 0);
			  }
			  return front;
			};
		
			BHProto.remove = function (node) {
			  var length = this.heap.length;
			  for (var i = 0; i < length; i++) {
			    if (this.compareFunc(this.heap[i], node)) {
			      var removed = this.heap[i];
			      var end = this.heap.pop();
			      if (i !== length - 1) {
			        this.heap[i] = end;
			        bubbleUp(this.heap, this.weightFunc, i);
			        bubbleDown(this.heap, this.weightFunc, i);
			      }
			      return removed;
			    }
			  }
			  return null;
			};
		
			BHProto.removeAll = function () {
			  this.heap = [];
			};
		
			BHProto.size = function () {
			  return this.heap.length;
			};
		
			module.exports = BinaryHeap;
		
		/***/ }
		/******/ ])
		});
		;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Array forEach
		     */
		    function forEach(arr, callback, thisObj) {
		        if (arr == null) {
		            return;
		        }
		        var i = -1,
		            len = arr.length;
		        while (++i < len) {
		            // we iterate over sparse items since there is no way to make it
		            // work properly on IE 7-8. see #64
		            if ( callback.call(thisObj, arr[i], i, arr) === false ) {
		                break;
		            }
		        }
		    }
		
		    module.exports = forEach;
		
		
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Create slice of source array or array-like object
		     */
		    function slice(arr, start, end){
		        var len = arr.length;
		
		        if (start == null) {
		            start = 0;
		        } else if (start < 0) {
		            start = Math.max(len + start, 0);
		        } else {
		            start = Math.min(start, len);
		        }
		
		        if (end == null) {
		            end = len;
		        } else if (end < 0) {
		            end = Math.max(len + end, 0);
		        } else {
		            end = Math.min(end, len);
		        }
		
		        var result = [];
		        while (start < end) {
		            result.push(arr[start++]);
		        }
		
		        return result;
		    }
		
		    module.exports = slice;
		
		
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		var hasOwn = __webpack_require__(8);
		var forIn = __webpack_require__(9);
		
		    /**
		     * Similar to Array/forEach but works over object properties and fixes Don't
		     * Enum bug on IE.
		     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
		     */
		    function forOwn(obj, fn, thisObj){
		        forIn(obj, function(val, key){
		            if (hasOwn(obj, key)) {
		                return fn.call(thisObj, obj[key], key, obj);
		            }
		        });
		    }
		
		    module.exports = forOwn;
		
		
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Safer Object.hasOwnProperty
		     */
		     function hasOwn(obj, prop){
		         return Object.prototype.hasOwnProperty.call(obj, prop);
		     }
		
		     module.exports = hasOwn;
		
		
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		var hasOwn = __webpack_require__(8);
		
		    var _hasDontEnumBug,
		        _dontEnums;
		
		    function checkDontEnum(){
		        _dontEnums = [
		                'toString',
		                'toLocaleString',
		                'valueOf',
		                'hasOwnProperty',
		                'isPrototypeOf',
		                'propertyIsEnumerable',
		                'constructor'
		            ];
		
		        _hasDontEnumBug = true;
		
		        for (var key in {'toString': null}) {
		            _hasDontEnumBug = false;
		        }
		    }
		
		    /**
		     * Similar to Array/forEach but works over object properties and fixes Don't
		     * Enum bug on IE.
		     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
		     */
		    function forIn(obj, fn, thisObj){
		        var key, i = 0;
		        // no need to check if argument is a real object that way we can use
		        // it for arrays, functions, date, etc.
		
		        //post-pone check till needed
		        if (_hasDontEnumBug == null) checkDontEnum();
		
		        for (key in obj) {
		            if (exec(fn, obj, key, thisObj) === false) {
		                break;
		            }
		        }
		
		
		        if (_hasDontEnumBug) {
		            var ctor = obj.constructor,
		                isProto = !!ctor && obj === ctor.prototype;
		
		            while (key = _dontEnums[i++]) {
		                // For constructor, if it is a prototype object the constructor
		                // is always non-enumerable unless defined otherwise (and
		                // enumerated above).  For non-prototype objects, it will have
		                // to be defined on this object, since it cannot be defined on
		                // any prototype objects.
		                //
		                // For other [[DontEnum]] properties, check if the value is
		                // different than Object prototype value.
		                if (
		                    (key !== 'constructor' ||
		                        (!isProto && hasOwn(obj, key))) &&
		                    obj[key] !== Object.prototype[key]
		                ) {
		                    if (exec(fn, obj, key, thisObj) === false) {
		                        break;
		                    }
		                }
		            }
		        }
		    }
		
		    function exec(fn, obj, key, thisObj){
		        return fn.call(thisObj, obj[key], key, obj);
		    }
		
		    module.exports = forIn;
		
		
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		var indexOf = __webpack_require__(11);
		
		    /**
		     * If array contains values.
		     */
		    function contains(arr, val) {
		        return indexOf(arr, val) !== -1;
		    }
		    module.exports = contains;
		
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Array.indexOf
		     */
		    function indexOf(arr, item, fromIndex) {
		        fromIndex = fromIndex || 0;
		        if (arr == null) {
		            return -1;
		        }
		
		        var len = arr.length,
		            i = fromIndex < 0 ? len + fromIndex : fromIndex;
		        while (i < len) {
		            // we iterate over sparse items since there is no way to make it
		            // work properly on IE 7-8. see #64
		            if (arr[i] === item) {
		                return i;
		            }
		
		            i++;
		        }
		
		        return -1;
		    }
		
		    module.exports = indexOf;
		
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		var forOwn = __webpack_require__(7);
		var isPlainObject = __webpack_require__(13);
		
		    /**
		     * Mixes objects into the target object, recursively mixing existing child
		     * objects.
		     */
		    function deepMixIn(target, objects) {
		        var i = 0,
		            n = arguments.length,
		            obj;
		
		        while(++i < n){
		            obj = arguments[i];
		            if (obj) {
		                forOwn(obj, copyProp, target);
		            }
		        }
		
		        return target;
		    }
		
		    function copyProp(val, key) {
		        var existing = this[key];
		        if (isPlainObject(val) && isPlainObject(existing)) {
		            deepMixIn(existing, val);
		        } else {
		            this[key] = val;
		        }
		    }
		
		    module.exports = deepMixIn;
		
		
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Checks if the value is created by the `Object` constructor.
		     */
		    function isPlainObject(value) {
		        return (!!value && typeof value === 'object' &&
		            value.constructor === Object);
		    }
		
		    module.exports = isPlainObject;
		
		
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		var camelCase = __webpack_require__(16);
		var upperCase = __webpack_require__(19);
		    /**
		     * camelCase + UPPERCASE first char
		     */
		    function pascalCase(str){
		        str = toString(str);
		        return camelCase(str).replace(/^[a-z]/, upperCase);
		    }
		
		    module.exports = pascalCase;
		
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Typecast a value to a String, using an empty string value for null or
		     * undefined.
		     */
		    function toString(val){
		        return val == null ? '' : val.toString();
		    }
		
		    module.exports = toString;
		
		
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		var replaceAccents = __webpack_require__(17);
		var removeNonWord = __webpack_require__(18);
		var upperCase = __webpack_require__(19);
		var lowerCase = __webpack_require__(20);
		    /**
		    * Convert string to camelCase text.
		    */
		    function camelCase(str){
		        str = toString(str);
		        str = replaceAccents(str);
		        str = removeNonWord(str)
		            .replace(/[\-_]/g, ' ') //convert all hyphens and underscores to spaces
		            .replace(/\s[a-z]/g, upperCase) //convert first char of each word to UPPERCASE
		            .replace(/\s+/g, '') //remove spaces
		            .replace(/^[A-Z]/g, lowerCase); //convert first char to lowercase
		        return str;
		    }
		    module.exports = camelCase;
		
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    /**
		    * Replaces all accented chars with regular ones
		    */
		    function replaceAccents(str){
		        str = toString(str);
		
		        // verifies if the String has accents and replace them
		        if (str.search(/[\xC0-\xFF]/g) > -1) {
		            str = str
		                    .replace(/[\xC0-\xC5]/g, "A")
		                    .replace(/[\xC6]/g, "AE")
		                    .replace(/[\xC7]/g, "C")
		                    .replace(/[\xC8-\xCB]/g, "E")
		                    .replace(/[\xCC-\xCF]/g, "I")
		                    .replace(/[\xD0]/g, "D")
		                    .replace(/[\xD1]/g, "N")
		                    .replace(/[\xD2-\xD6\xD8]/g, "O")
		                    .replace(/[\xD9-\xDC]/g, "U")
		                    .replace(/[\xDD]/g, "Y")
		                    .replace(/[\xDE]/g, "P")
		                    .replace(/[\xE0-\xE5]/g, "a")
		                    .replace(/[\xE6]/g, "ae")
		                    .replace(/[\xE7]/g, "c")
		                    .replace(/[\xE8-\xEB]/g, "e")
		                    .replace(/[\xEC-\xEF]/g, "i")
		                    .replace(/[\xF1]/g, "n")
		                    .replace(/[\xF2-\xF6\xF8]/g, "o")
		                    .replace(/[\xF9-\xFC]/g, "u")
		                    .replace(/[\xFE]/g, "p")
		                    .replace(/[\xFD\xFF]/g, "y");
		        }
		        return str;
		    }
		    module.exports = replaceAccents;
		
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    // This pattern is generated by the _build/pattern-removeNonWord.js script
		    var PATTERN = /[^\x20\x2D0-9A-Z\x5Fa-z\xC0-\xD6\xD8-\xF6\xF8-\xFF]/g;
		
		    /**
		     * Remove non-word chars.
		     */
		    function removeNonWord(str){
		        str = toString(str);
		        return str.replace(PATTERN, '');
		    }
		
		    module.exports = removeNonWord;
		
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    /**
		     * "Safer" String.toUpperCase()
		     */
		    function upperCase(str){
		        str = toString(str);
		        return str.toUpperCase();
		    }
		    module.exports = upperCase;
		
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    /**
		     * "Safer" String.toLowerCase()
		     */
		    function lowerCase(str){
		        str = toString(str);
		        return str.toLowerCase();
		    }
		
		    module.exports = lowerCase;
		
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		var indexOf = __webpack_require__(11);
		
		    /**
		     * Remove a single item from the array.
		     * (it won't remove duplicates, just a single item)
		     */
		    function remove(arr, item){
		        var idx = indexOf(arr, item);
		        if (idx !== -1) arr.splice(idx, 1);
		    }
		
		    module.exports = remove;
		
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		var slice = __webpack_require__(6);
		
		    /**
		     * Return a copy of the object, filtered to only have values for the whitelisted keys.
		     */
		    function pick(obj, var_keys){
		        var keys = typeof arguments[1] !== 'string'? arguments[1] : slice(arguments, 1),
		            out = {},
		            i = 0, key;
		        while (key = keys[i++]) {
		            out[key] = obj[key];
		        }
		        return out;
		    }
		
		    module.exports = pick;
		
		
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		var forOwn = __webpack_require__(7);
		
		    /**
		     * Get object keys
		     */
		     var keys = Object.keys || function (obj) {
		            var keys = [];
		            forOwn(obj, function(val, key){
		                keys.push(key);
		            });
		            return keys;
		        };
		
		    module.exports = keys;
		
		
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Merge sort (http://en.wikipedia.org/wiki/Merge_sort)
		     */
		    function mergeSort(arr, compareFn) {
		        if (arr == null) {
		            return [];
		        } else if (arr.length < 2) {
		            return arr;
		        }
		
		        if (compareFn == null) {
		            compareFn = defaultCompare;
		        }
		
		        var mid, left, right;
		
		        mid   = ~~(arr.length / 2);
		        left  = mergeSort( arr.slice(0, mid), compareFn );
		        right = mergeSort( arr.slice(mid, arr.length), compareFn );
		
		        return merge(left, right, compareFn);
		    }
		
		    function defaultCompare(a, b) {
		        return a < b ? -1 : (a > b? 1 : 0);
		    }
		
		    function merge(left, right, compareFn) {
		        var result = [];
		
		        while (left.length && right.length) {
		            if (compareFn(left[0], right[0]) <= 0) {
		                // if 0 it should preserve same order (stable)
		                result.push(left.shift());
		            } else {
		                result.push(right.shift());
		            }
		        }
		
		        if (left.length) {
		            result.push.apply(result, left);
		        }
		
		        if (right.length) {
		            result.push.apply(result, right);
		        }
		
		        return result;
		    }
		
		    module.exports = mergeSort;
		
		
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isPrimitive = __webpack_require__(26);
		
		    /**
		     * get "nested" object property
		     */
		    function get(obj, prop){
		        var parts = prop.split('.'),
		            last = parts.pop();
		
		        while (prop = parts.shift()) {
		            obj = obj[prop];
		            if (obj == null) return;
		        }
		
		        return obj[last];
		    }
		
		    module.exports = get;
		
		
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Checks if the object is a primitive
		     */
		    function isPrimitive(value) {
		        // Using switch fallthrough because it's simple to read and is
		        // generally fast: http://jsperf.com/testing-value-is-primitive/5
		        switch (typeof value) {
		            case "string":
		            case "number":
		            case "boolean":
		                return true;
		        }
		
		        return value == null;
		    }
		
		    module.exports = isPrimitive;
		
		
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		var namespace = __webpack_require__(28);
		
		    /**
		     * set "nested" object property
		     */
		    function set(obj, prop, val){
		        var parts = (/^(.+)\.(.+)$/).exec(prop);
		        if (parts){
		            namespace(obj, parts[1])[parts[2]] = val;
		        } else {
		            obj[prop] = val;
		        }
		    }
		
		    module.exports = set;
		
		
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		var forEach = __webpack_require__(5);
		
		    /**
		     * Create nested object if non-existent
		     */
		    function namespace(obj, path){
		        if (!path) return obj;
		        forEach(path.split('.'), function(key){
		            if (!obj[key]) {
		                obj[key] = {};
		            }
		            obj = obj[key];
		        });
		        return obj;
		    }
		
		    module.exports = namespace;
		
		
	
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		/*
		 * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
		 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
		 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
		 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
		 * Code distributed by Google as part of the polymer project is also
		 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
		 */
		
		// Modifications
		// Copyright 2014-2015 Jason Dobry
		//
		// Summary of modifications:
		// Fixed use of "delete" keyword for IE8 compatibility
		// Exposed diffObjectFromOldObject on the exported object
		// Added the "equals" argument to diffObjectFromOldObject to be used to check equality
		// Added a way in diffObjectFromOldObject to ignore changes to certain properties
		// Removed all code related to:
		// - ArrayObserver
		// - ArraySplice
		// - PathObserver
		// - CompoundObserver
		// - Path
		// - ObserverTransform
		
		(function(global) {
		  var testingExposeCycleCount = global.testingExposeCycleCount;
		
		  // Detect and do basic sanity checking on Object/Array.observe.
		  function detectObjectObserve() {
		    if (typeof Object.observe !== 'function' ||
		        typeof Array.observe !== 'function') {
		      return false;
		    }
		
		    var records = [];
		
		    function callback(recs) {
		      records = recs;
		    }
		
		    var test = {};
		    var arr = [];
		    Object.observe(test, callback);
		    Array.observe(arr, callback);
		    test.id = 1;
		    test.id = 2;
		    delete test.id;
		    arr.push(1, 2);
		    arr.length = 0;
		
		    Object.deliverChangeRecords(callback);
		    if (records.length !== 5)
		      return false;
		
		    if (records[0].type != 'add' ||
		        records[1].type != 'update' ||
		        records[2].type != 'delete' ||
		        records[3].type != 'splice' ||
		        records[4].type != 'splice') {
		      return false;
		    }
		
		    Object.unobserve(test, callback);
		    Array.unobserve(arr, callback);
		
		    return true;
		  }
		
		  var hasObserve = detectObjectObserve();
		
		  var createObject = ('__proto__' in {}) ?
		    function(obj) { return obj; } :
		    function(obj) {
		      var proto = obj.__proto__;
		      if (!proto)
		        return obj;
		      var newObject = Object.create(proto);
		      Object.getOwnPropertyNames(obj).forEach(function(name) {
		        Object.defineProperty(newObject, name,
		                             Object.getOwnPropertyDescriptor(obj, name));
		      });
		      return newObject;
		    };
		
		  var MAX_DIRTY_CHECK_CYCLES = 1000;
		
		  function dirtyCheck(observer) {
		    var cycles = 0;
		    while (cycles < MAX_DIRTY_CHECK_CYCLES && observer.check_()) {
		      cycles++;
		    }
		    if (testingExposeCycleCount)
		      global.dirtyCheckCycleCount = cycles;
		
		    return cycles > 0;
		  }
		
		  function objectIsEmpty(object) {
		    for (var prop in object)
		      return false;
		    return true;
		  }
		
		  function diffIsEmpty(diff) {
		    return objectIsEmpty(diff.added) &&
		           objectIsEmpty(diff.removed) &&
		           objectIsEmpty(diff.changed);
		  }
		
		  function isBlacklisted(prop, bl) {
		    if (!bl || !bl.length) {
		      return false;
		    }
		    var matches;
		    for (var i = 0; i < bl.length; i++) {
		      if ((Object.prototype.toString.call(bl[i]) === '[object RegExp]' && bl[i].test(prop)) || bl[i] === prop) {
		        return matches = prop;
		      }
		    }
		    return !!matches;
		  }
		
		  function diffObjectFromOldObject(object, oldObject, equals, bl) {
		    var added = {};
		    var removed = {};
		    var changed = {};
		
		    for (var prop in oldObject) {
		      var newValue = object[prop];
		
		      if (isBlacklisted(prop, bl))
		        continue;
		
		      if (newValue !== undefined && (equals ? equals(newValue, oldObject[prop]) : newValue === oldObject[prop]))
		        continue;
		
		      if (!(prop in object)) {
		        removed[prop] = undefined;
		        continue;
		      }
		
		      if (equals ? !equals(newValue, oldObject[prop]) : newValue !== oldObject[prop])
		        changed[prop] = newValue;
		    }
		
		    for (var prop in object) {
		      if (prop in oldObject)
		        continue;
		
		      if (isBlacklisted(prop, bl))
		        continue;
		
		      added[prop] = object[prop];
		    }
		
		    if (Array.isArray(object) && object.length !== oldObject.length)
		      changed.length = object.length;
		
		    return {
		      added: added,
		      removed: removed,
		      changed: changed
		    };
		  }
		
		  var eomTasks = [];
		  function runEOMTasks() {
		    if (!eomTasks.length)
		      return false;
		
		    for (var i = 0; i < eomTasks.length; i++) {
		      eomTasks[i]();
		    }
		    eomTasks.length = 0;
		    return true;
		  }
		
		  var runEOM = hasObserve ? (function(){
		    return function(fn) {
		      return Promise.resolve().then(fn);
		    }
		  })() :
		  (function() {
		    return function(fn) {
		      eomTasks.push(fn);
		    };
		  })();
		
		  var observedObjectCache = [];
		
		  function newObservedObject() {
		    var observer;
		    var object;
		    var discardRecords = false;
		    var first = true;
		
		    function callback(records) {
		      if (observer && observer.state_ === OPENED && !discardRecords)
		        observer.check_(records);
		    }
		
		    return {
		      open: function(obs) {
		        if (observer)
		          throw Error('ObservedObject in use');
		
		        if (!first)
		          Object.deliverChangeRecords(callback);
		
		        observer = obs;
		        first = false;
		      },
		      observe: function(obj, arrayObserve) {
		        object = obj;
		        if (arrayObserve)
		          Array.observe(object, callback);
		        else
		          Object.observe(object, callback);
		      },
		      deliver: function(discard) {
		        discardRecords = discard;
		        Object.deliverChangeRecords(callback);
		        discardRecords = false;
		      },
		      close: function() {
		        observer = undefined;
		        Object.unobserve(object, callback);
		        observedObjectCache.push(this);
		      }
		    };
		  }
		
		  function getObservedObject(observer, object, arrayObserve) {
		    var dir = observedObjectCache.pop() || newObservedObject();
		    dir.open(observer);
		    dir.observe(object, arrayObserve);
		    return dir;
		  }
		
		  var UNOPENED = 0;
		  var OPENED = 1;
		  var CLOSED = 2;
		
		  var nextObserverId = 1;
		
		  function Observer() {
		    this.state_ = UNOPENED;
		    this.callback_ = undefined;
		    this.target_ = undefined; // TODO(rafaelw): Should be WeakRef
		    this.directObserver_ = undefined;
		    this.value_ = undefined;
		    this.id_ = nextObserverId++;
		  }
		
		  Observer.prototype = {
		    open: function(callback, target) {
		      if (this.state_ != UNOPENED)
		        throw Error('Observer has already been opened.');
		
		      addToAll(this);
		      this.callback_ = callback;
		      this.target_ = target;
		      this.connect_();
		      this.state_ = OPENED;
		      return this.value_;
		    },
		
		    close: function() {
		      if (this.state_ != OPENED)
		        return;
		
		      removeFromAll(this);
		      this.disconnect_();
		      this.value_ = undefined;
		      this.callback_ = undefined;
		      this.target_ = undefined;
		      this.state_ = CLOSED;
		    },
		
		    deliver: function() {
		      if (this.state_ != OPENED)
		        return;
		
		      dirtyCheck(this);
		    },
		
		    report_: function(changes) {
		      try {
		        this.callback_.apply(this.target_, changes);
		      } catch (ex) {
		        Observer._errorThrownDuringCallback = true;
		        console.error('Exception caught during observer callback: ' +
		                       (ex.stack || ex));
		      }
		    },
		
		    discardChanges: function() {
		      this.check_(undefined, true);
		      return this.value_;
		    }
		  }
		
		  var collectObservers = !hasObserve;
		  var allObservers;
		  Observer._allObserversCount = 0;
		
		  if (collectObservers) {
		    allObservers = [];
		  }
		
		  function addToAll(observer) {
		    Observer._allObserversCount++;
		    if (!collectObservers)
		      return;
		
		    allObservers.push(observer);
		  }
		
		  function removeFromAll(observer) {
		    Observer._allObserversCount--;
		  }
		
		  var runningMicrotaskCheckpoint = false;
		
		  global.Platform = global.Platform || {};
		
		  global.Platform.performMicrotaskCheckpoint = function() {
		    if (runningMicrotaskCheckpoint)
		      return;
		
		    if (!collectObservers)
		      return;
		
		    runningMicrotaskCheckpoint = true;
		
		    var cycles = 0;
		    var anyChanged, toCheck;
		
		    do {
		      cycles++;
		      toCheck = allObservers;
		      allObservers = [];
		      anyChanged = false;
		
		      for (var i = 0; i < toCheck.length; i++) {
		        var observer = toCheck[i];
		        if (observer.state_ != OPENED)
		          continue;
		
		        if (observer.check_())
		          anyChanged = true;
		
		        allObservers.push(observer);
		      }
		      if (runEOMTasks())
		        anyChanged = true;
		    } while (cycles < MAX_DIRTY_CHECK_CYCLES && anyChanged);
		
		    if (testingExposeCycleCount)
		      global.dirtyCheckCycleCount = cycles;
		
		    runningMicrotaskCheckpoint = false;
		  };
		
		  if (collectObservers) {
		    global.Platform.clearObservers = function() {
		      allObservers = [];
		    };
		  }
		
		  function ObjectObserver(object) {
		    Observer.call(this);
		    this.value_ = object;
		    this.oldObject_ = undefined;
		  }
		
		  ObjectObserver.prototype = createObject({
		    __proto__: Observer.prototype,
		
		    arrayObserve: false,
		
		    connect_: function(callback, target) {
		      if (hasObserve) {
		        this.directObserver_ = getObservedObject(this, this.value_,
		                                                 this.arrayObserve);
		      } else {
		        this.oldObject_ = this.copyObject(this.value_);
		      }
		
		    },
		
		    copyObject: function(object) {
		      var copy = Array.isArray(object) ? [] : {};
		      for (var prop in object) {
		        copy[prop] = object[prop];
		      };
		      if (Array.isArray(object))
		        copy.length = object.length;
		      return copy;
		    },
		
		    check_: function(changeRecords, skipChanges) {
		      var diff;
		      var oldValues;
		      if (hasObserve) {
		        if (!changeRecords)
		          return false;
		
		        oldValues = {};
		        diff = diffObjectFromChangeRecords(this.value_, changeRecords,
		                                           oldValues);
		      } else {
		        oldValues = this.oldObject_;
		        diff = diffObjectFromOldObject(this.value_, this.oldObject_);
		      }
		
		      if (diffIsEmpty(diff))
		        return false;
		
		      if (!hasObserve)
		        this.oldObject_ = this.copyObject(this.value_);
		
		      this.report_([
		        diff.added || {},
		        diff.removed || {},
		        diff.changed || {},
		        function(property) {
		          return oldValues[property];
		        }
		      ]);
		
		      return true;
		    },
		
		    disconnect_: function() {
		      if (hasObserve) {
		        this.directObserver_.close();
		        this.directObserver_ = undefined;
		      } else {
		        this.oldObject_ = undefined;
		      }
		    },
		
		    deliver: function() {
		      if (this.state_ != OPENED)
		        return;
		
		      if (hasObserve)
		        this.directObserver_.deliver(false);
		      else
		        dirtyCheck(this);
		    },
		
		    discardChanges: function() {
		      if (this.directObserver_)
		        this.directObserver_.deliver(true);
		      else
		        this.oldObject_ = this.copyObject(this.value_);
		
		      return this.value_;
		    }
		  });
		
		  var observerSentinel = {};
		
		  var expectedRecordTypes = {
		    add: true,
		    update: true,
		    'delete': true
		  };
		
		  function diffObjectFromChangeRecords(object, changeRecords, oldValues) {
		    var added = {};
		    var removed = {};
		
		    for (var i = 0; i < changeRecords.length; i++) {
		      var record = changeRecords[i];
		      if (!expectedRecordTypes[record.type]) {
		        console.error('Unknown changeRecord type: ' + record.type);
		        console.error(record);
		        continue;
		      }
		
		      if (!(record.name in oldValues))
		        oldValues[record.name] = record.oldValue;
		
		      if (record.type == 'update')
		        continue;
		
		      if (record.type == 'add') {
		        if (record.name in removed)
		          delete removed[record.name];
		        else
		          added[record.name] = true;
		
		        continue;
		      }
		
		      // type = 'delete'
		      if (record.name in added) {
		        delete added[record.name];
		        delete oldValues[record.name];
		      } else {
		        removed[record.name] = true;
		      }
		    }
		
		    for (var prop in added)
		      added[prop] = object[prop];
		
		    for (var prop in removed)
		      removed[prop] = undefined;
		
		    var changed = {};
		    for (var prop in oldValues) {
		      if (prop in added || prop in removed)
		        continue;
		
		      var newValue = object[prop];
		      if (oldValues[prop] !== newValue)
		        changed[prop] = newValue;
		    }
		
		    return {
		      added: added,
		      removed: removed,
		      changed: changed
		    };
		  }
		
		  // Export the observe-js object for **Node.js**, with backwards-compatibility
		  // for the old `require()` API. Also ensure `exports` is not a DOM Element.
		  // If we're in the browser, export as a global object.
		
		  global.Observer = Observer;
		  global.isBlacklisted = isBlacklisted;
		  global.Observer.runEOM_ = runEOM;
		  global.Observer.observerSentinel_ = observerSentinel; // for testing.
		  global.Observer.hasObjectObserve = hasObserve;
		  global.diffObjectFromOldObject = diffObjectFromOldObject;
		  global.ObjectObserver = ObjectObserver;
		
		})(exports);
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		var randHex = __webpack_require__(31);
		var choice = __webpack_require__(32);
		
		  /**
		   * Returns pseudo-random guid (UUID v4)
		   * IMPORTANT: it's not totally "safe" since randHex/choice uses Math.random
		   * by default and sequences can be predicted in some cases. See the
		   * "random/random" documentation for more info about it and how to replace
		   * the default PRNG.
		   */
		  function guid() {
		    return (
		        randHex(8)+'-'+
		        randHex(4)+'-'+
		        // v4 UUID always contain "4" at this position to specify it was
		        // randomly generated
		        '4' + randHex(3) +'-'+
		        // v4 UUID always contain chars [a,b,8,9] at this position
		        choice(8, 9, 'a', 'b') + randHex(3)+'-'+
		        randHex(12)
		    );
		  }
		  module.exports = guid;
		
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		var choice = __webpack_require__(32);
		
		    var _chars = '0123456789abcdef'.split('');
		
		    /**
		     * Returns a random hexadecimal string
		     */
		    function randHex(size){
		        size = size && size > 0? size : 6;
		        var str = '';
		        while (size--) {
		            str += choice(_chars);
		        }
		        return str;
		    }
		
		    module.exports = randHex;
		
		
	
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		var randInt = __webpack_require__(33);
		var isArray = __webpack_require__(38);
		
		    /**
		     * Returns a random element from the supplied arguments
		     * or from the array (if single argument is an array).
		     */
		    function choice(items) {
		        var target = (arguments.length === 1 && isArray(items))? items : arguments;
		        return target[ randInt(0, target.length - 1) ];
		    }
		
		    module.exports = choice;
		
		
	
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		var MIN_INT = __webpack_require__(34);
		var MAX_INT = __webpack_require__(35);
		var rand = __webpack_require__(36);
		
		    /**
		     * Gets random integer inside range or snap to min/max values.
		     */
		    function randInt(min, max){
		        min = min == null? MIN_INT : ~~min;
		        max = max == null? MAX_INT : ~~max;
		        // can't be max + 0.5 otherwise it will round up if `rand`
		        // returns `max` causing it to overflow range.
		        // -0.5 and + 0.49 are required to avoid bias caused by rounding
		        return Math.round( rand(min - 0.5, max + 0.499999999999) );
		    }
		
		    module.exports = randInt;
		
	
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		/**
		 * @constant Minimum 32-bit signed integer value (-2^31).
		 */
		
		    module.exports = -2147483648;
		
	
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		/**
		 * @constant Maximum 32-bit signed integer value. (2^31 - 1)
		 */
		
		    module.exports = 2147483647;
		
	
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		var random = __webpack_require__(37);
		var MIN_INT = __webpack_require__(34);
		var MAX_INT = __webpack_require__(35);
		
		    /**
		     * Returns random number inside range
		     */
		    function rand(min, max){
		        min = min == null? MIN_INT : min;
		        max = max == null? MAX_INT : max;
		        return min + (max - min) * random();
		    }
		
		    module.exports = rand;
		
	
	
	/***/ },
	/* 37 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Just a wrapper to Math.random. No methods inside mout/random should call
		     * Math.random() directly so we can inject the pseudo-random number
		     * generator if needed (ie. in case we need a seeded random or a better
		     * algorithm than the native one)
		     */
		    function random(){
		        return random.get();
		    }
		
		    // we expose the method so it can be swapped if needed
		    random.get = Math.random;
		
		    module.exports = random;
		
		
	
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isKind = __webpack_require__(39);
		    /**
		     */
		    var isArray = Array.isArray || function (val) {
		        return isKind(val, 'Array');
		    };
		    module.exports = isArray;
		
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		var kindOf = __webpack_require__(40);
		    /**
		     * Check if value is from a specific "kind".
		     */
		    function isKind(val, kind){
		        return kindOf(val) === kind;
		    }
		    module.exports = isKind;
		
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		
		
		    var _rKind = /^\[object (.*)\]$/,
		        _toString = Object.prototype.toString,
		        UNDEF;
		
		    /**
		     * Gets the "kind" of value. (e.g. "String", "Number", etc)
		     */
		    function kindOf(val) {
		        if (val === null) {
		            return 'Null';
		        } else if (val === UNDEF) {
		            return 'Undefined';
		        } else {
		            return _rKind.exec( _toString.call(val) )[1];
		        }
		    }
		    module.exports = kindOf;
		
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		var NER = _errors2.default.NER;
		var IA = _errors2.default.IA;
		var R = _errors2.default.R;
		
		var fakeId = 'DS_' + new Date().getTime();
		
		function diffIsEmpty(diff) {
		  return !(_utils2.default.isEmpty(diff.added) && _utils2.default.isEmpty(diff.removed) && _utils2.default.isEmpty(diff.changed));
		}
		
		function check(fnName, resourceName, id, options) {
		  var _this = this;
		  var definition = _this.definitions[resourceName];
		  options = options || {};
		
		  id = _utils2.default.resolveId(definition, id);
		  if (!definition) {
		    throw new NER(resourceName);
		  } else if (!_utils2.default._sn(id)) {
		    throw _utils2.default._snErr('id');
		  }
		  id = id === fakeId ? undefined : id;
		
		  options = _utils2.default._(definition, options);
		
		  options.logFn(fnName, id, options);
		
		  return { _this: _this, definition: definition, _resourceName: resourceName, _id: id, _options: options };
		}
		
		exports.default = {
		  // Return the changes for the given item, if any.
		  //
		  // @param resourceName The name of the type of resource of the item whose changes are to be returned.
		  // @param id The primary key of the item whose changes are to be returned.
		  // @param options Optional configuration.
		  // @param options.ignoredChanges Array of strings or regular expressions of fields, the changes of which are to be ignored.
		  // @returns The changes of the given item, if any.
		
		  changes: function changes(resourceName, id, options) {
		    var _check$call = check.call(this, 'changes', resourceName, id, options);
		
		    var _this = _check$call._this;
		    var definition = _check$call.definition;
		    var _resourceName = _check$call._resourceName;
		    var _id = _check$call._id;
		    var _options = _check$call._options;
		
		
		    var item = definition.get(_id);
		    if (item) {
		      var _ret = function () {
		        var observer = _this.store[_resourceName].observers[_id];
		        if (observer && typeof observer === 'function') {
		          // force observation handler to be fired for item if there are changes and `Object.observe` is not available
		          observer.deliver();
		        }
		
		        var ignoredChanges = _options.ignoredChanges || [];
		        // add linked relations to list of ignored changes
		        _utils2.default.forEach(definition.relationFields, function (field) {
		          if (!_utils2.default.contains(ignoredChanges, field)) {
		            ignoredChanges.push(field);
		          }
		        });
		        // calculate changes
		        var diff = _utils2.default.diffObjectFromOldObject(item, _this.store[_resourceName].previousAttributes[_id], _utils2.default.equals, ignoredChanges);
		        // remove functions from diff
		        _utils2.default.forOwn(diff, function (changeset, name) {
		          var toKeep = [];
		          _utils2.default.forOwn(changeset, function (value, field) {
		            if (!_utils2.default.isFunction(value)) {
		              toKeep.push(field);
		            }
		          });
		          diff[name] = _utils2.default.pick(diff[name], toKeep);
		        });
		        // definitely ignore changes to linked relations
		        _utils2.default.forEach(definition.relationFields, function (field) {
		          delete diff.added[field];
		          delete diff.removed[field];
		          delete diff.changed[field];
		        });
		        return {
		          v: diff
		        };
		      }();
		
		      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    }
		  },
		
		
		  // Return the change history of the given item, if any.
		  //
		  // @param resourceName The name of the type of resource of the item whose change history is to be returned.
		  // @param id The primary key of the item whose change history is to be returned.
		  // @returns The change history of the given item, if any.
		  changeHistory: function changeHistory(resourceName, id) {
		    var _check$call2 = check.call(this, 'changeHistory', resourceName, id || fakeId);
		
		    var _this = _check$call2._this;
		    var definition = _check$call2.definition;
		    var _resourceName = _check$call2._resourceName;
		    var _id = _check$call2._id;
		
		    var resource = _this.store[_resourceName];
		
		    if (!definition.keepChangeHistory) {
		      definition.errorFn('changeHistory is disabled for this resource!');
		    } else {
		      if (_resourceName) {
		        var item = definition.get(_id);
		        if (item) {
		          return resource.changeHistories[_id];
		        }
		      } else {
		        return resource.changeHistory;
		      }
		    }
		  },
		  commit: function commit(resourceName, id) {
		    var _check$call3 = check.call(this, 'commit', resourceName, id);
		
		    var _this = _check$call3._this;
		    var definition = _check$call3.definition;
		    var _resourceName = _check$call3._resourceName;
		    var _id = _check$call3._id;
		
		    var resource = _this.store[_resourceName];
		    var item = _this.store[_resourceName].index[_id];
		    if (item) {
		      resource.previousAttributes[_id] = _utils2.default.copy(item, null, null, null, definition.relationFields);
		    }
		
		    if (resource.changeHistories[_id].length) {
		      _utils2.default.forEach(resource.changeHistories[_id], function (changeRecord) {
		        _utils2.default.remove(resource.changeHistory, changeRecord);
		      });
		      resource.changeHistories[_id].splice(0, resource.changeHistories[_id].length);
		    }
		    return item;
		  },
		
		
		  // Re-compute the computed properties of the given item.
		  //
		  // @param resourceName The name of the type of resource of the item whose computed properties are to be re-computed.
		  // @param instance The instance whose computed properties are to be re-computed.
		  // @returns The item whose computed properties were re-computed.
		  compute: function compute(resourceName, instance) {
		    var _this = this;
		    var definition = _this.definitions[resourceName];
		
		    instance = _utils2.default.resolveItem(_this.store[resourceName], instance);
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (!instance) {
		      throw new R('Item not in the store!');
		    } else if (!_utils2.default._o(instance) && !_utils2.default._sn(instance)) {
		      throw new IA('"instance" must be an object, string or number!');
		    }
		
		    definition.logFn('compute', instance);
		
		    // re-compute all computed properties
		    _utils2.default.forOwn(definition.computed, function (fn, field) {
		      _utils2.default.compute.call(instance, fn, field);
		    });
		    return instance;
		  },
		
		
		  // Factory function to create an instance of the specified Resource.
		  //
		  // @param resourceName The name of the type of resource of which to create an instance.
		  // @param attrs Hash of properties with which to initialize the instance.
		  // @param options Optional configuration.
		  // @param options.defaults Default values with which to initialize the instance.
		  // @returns The new instance.
		  createInstance: function createInstance(resourceName, attrs, options) {
		    var definition = this.definitions[resourceName];
		    var item = undefined;
		
		    attrs = attrs || {};
		
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (attrs && !_utils2.default.isObject(attrs)) {
		      throw new IA('"attrs" must be an object!');
		    }
		
		    options = _utils2.default._(definition, options);
		
		    var relationList = definition.relationList || [];
		    if (relationList.length) {
		      _utils2.default.forEach(relationList, function (def) {
		        var relationData = _utils2.default.get(attrs, def.localField);
		        if (relationData) {
		          if (_utils2.default.isArray(relationData)) {
		            (function () {
		              var array = [];
		              var Resource = definition.getResource(def.relation);
		              var _options = options.orig();
		              _utils2.default.forEach(relationData, function (relationDataItem) {
		                array.push(Resource.createInstance(relationDataItem, _options));
		              });
		              _utils2.default.set(attrs, def.localField, array);
		            })();
		          } else if (_utils2.default.isObject(relationData)) {
		            _utils2.default.set(attrs, def.localField, definition.getResource(def.relation).createInstance(relationData, options.orig()));
		          }
		        }
		      });
		    }
		
		    options.logFn('createInstance', attrs, options);
		
		    // lifecycle
		    options.beforeCreateInstance(options, attrs);
		
		    // grab instance constructor function from Resource definition
		    var Constructor = definition[definition.class];
		
		    // create instance
		    item = new Constructor();
		
		    if (definition.instanceEvents) {
		      _utils2.default.Events(item);
		    }
		
		    // add default values
		    if (options.defaultValues) {
		      _utils2.default.deepMixIn(item, _utils2.default.copy(options.defaultValues));
		    }
		    _utils2.default.deepMixIn(item, attrs);
		
		    // compute computed properties
		    if (definition.computed) {
		      definition.compute(item);
		    }
		    // lifecycle
		    options.afterCreateInstance(options, item);
		    return item;
		  },
		
		
		  // Create a new collection of the specified Resource.
		  //
		  // @param resourceName The name of the type of resource of which to create a collection
		  // @param arr Possibly empty array of data from which to create the collection.
		  // @param params The criteria by which to filter items. Will be passed to `DS#findAll` if `fetch` is called. See http://www.js-data.io/docs/query-syntax
		  // @param options Optional configuration.
		  // @param options.notify Whether to call the beforeCreateCollection and afterCreateCollection lifecycle hooks..
		  // @returns The new collection.
		  createCollection: function createCollection(resourceName, arr, params, options) {
		    var _this = this;
		    var definition = _this.definitions[resourceName];
		
		    arr = arr || [];
		    params = params || {};
		
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (arr && !_utils2.default.isArray(arr)) {
		      throw new IA('"arr" must be an array!');
		    }
		
		    options = _utils2.default._(definition, options);
		
		    options.logFn('createCollection', arr, options);
		
		    // lifecycle
		    options.beforeCreateCollection(options, arr);
		
		    // define the API for this collection
		    Object.defineProperties(arr, {
		      //  Call DS#findAll with the params of this collection, filling the collection with the results.
		      fetch: {
		        value: function value(params, options) {
		          var __this = this;
		          __this.params = params || __this.params;
		          return definition.findAll(__this.params, options).then(function (data) {
		            if (data === __this) {
		              return __this;
		            }
		            data.unshift(__this.length);
		            data.unshift(0);
		            __this.splice.apply(__this, data);
		            data.shift();
		            data.shift();
		            if (data.$$injected) {
		              _this.store[resourceName].queryData[_utils2.default.toJson(__this.params)] = __this;
		              __this.$$injected = true;
		            }
		            return __this;
		          });
		        }
		      },
		      // params for this collection. See http://www.js-data.io/docs/query-syntax
		      params: {
		        value: params,
		        writable: true
		      },
		      // name of the resource type of this collection
		      resourceName: {
		        value: resourceName
		      }
		    });
		
		    // lifecycle
		    options.afterCreateCollection(options, arr);
		    return arr;
		  },
		
		  defineResource: __webpack_require__(42),
		  digest: function digest() {
		    this.observe.Platform.performMicrotaskCheckpoint();
		  },
		
		  eject: __webpack_require__(43),
		  ejectAll: __webpack_require__(44),
		  filter: __webpack_require__(45),
		
		  // Return the item with the given primary key if its in the store.
		  //
		  // @param resourceName The name of the type of resource of the item to retrieve.
		  // @param id The primary key of the item to retrieve.
		  // @returns The item with the given primary key if it's in the store.
		  // /
		  get: function get(resourceName, id) {
		    var _check$call4 = check.call(this, 'get', resourceName, id);
		
		    var _this = _check$call4._this;
		    var _resourceName = _check$call4._resourceName;
		    var _id = _check$call4._id;
		
		    // return the item if it exists
		
		    return _this.store[_resourceName].index[_id];
		  },
		
		
		  // Return the items in the store that have the given primary keys.
		  //
		  // @param resourceName The name of the type of resource of the items to retrieve.
		  // @param ids The primary keys of the items to retrieve.
		  // @returns The items with the given primary keys if they're in the store.
		  getAll: function getAll(resourceName, ids) {
		    var _this = this;
		    var definition = _this.definitions[resourceName];
		    var resource = _this.store[resourceName];
		    var collection = [];
		
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (ids && !_utils2.default._a(ids)) {
		      throw _utils2.default._aErr('ids');
		    }
		
		    definition.logFn('getAll', ids);
		
		    if (_utils2.default._a(ids)) {
		      // return just the items with the given primary keys
		      var length = ids.length;
		      for (var i = 0; i < length; i++) {
		        if (resource.index[ids[i]]) {
		          collection.push(resource.index[ids[i]]);
		        }
		      }
		    } else {
		      // most efficient of retrieving ALL items from the store
		      collection = resource.collection.slice();
		    }
		
		    return collection;
		  },
		
		
		  // Return the whether the item with the given primary key has any changes.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Whether the item with the given primary key has any changes.
		  hasChanges: function hasChanges(resourceName, id) {
		    var _check$call5 = check.call(this, 'hasChanges', resourceName, id);
		
		    var definition = _check$call5.definition;
		    var _id = _check$call5._id;
		
		
		    return definition.get(_id) ? diffIsEmpty(definition.changes(_id)) : false;
		  },
		
		  inject: __webpack_require__(46),
		
		  // Return whether the item with the given primary key is a temporary item.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Whether the item with the given primary key is a temporary item.
		  isNew: function isNew(resourceName, id) {
		    var _check$call6 = check.call(this, 'isNew', resourceName, id || fakeId);
		
		    var _this = _check$call6._this;
		    var _resourceName = _check$call6._resourceName;
		    var _id = _check$call6._id;
		
		    var resource = _this.store[_resourceName];
		
		    return !!resource.temporaryItems[_id];
		  },
		
		
		  // Return the timestamp from the last time the item with the given primary key was changed.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Timestamp from the last time the item was changed.
		  lastModified: function lastModified(resourceName, id) {
		    var _check$call7 = check.call(this, 'lastModified', resourceName, id || fakeId);
		
		    var _this = _check$call7._this;
		    var _resourceName = _check$call7._resourceName;
		    var _id = _check$call7._id;
		
		    var resource = _this.store[_resourceName];
		
		    if (_id) {
		      if (!(_id in resource.modified)) {
		        resource.modified[_id] = 0;
		      }
		      return resource.modified[_id];
		    }
		    return resource.collectionModified;
		  },
		
		
		  // Return the timestamp from the last time the item with the given primary key was saved via an adapter.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Timestamp from the last time the item was saved.
		  lastSaved: function lastSaved(resourceName, id) {
		    var _check$call8 = check.call(this, 'lastSaved', resourceName, id || fakeId);
		
		    var _this = _check$call8._this;
		    var _resourceName = _check$call8._resourceName;
		    var _id = _check$call8._id;
		
		    var resource = _this.store[_resourceName];
		
		    if (!(_id in resource.saved)) {
		      resource.saved[_id] = 0;
		    }
		    return resource.saved[_id];
		  },
		
		
		  // Return the previous attributes of the item with the given primary key before it was changed.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns The previous attributes of the item
		  previous: function previous(resourceName, id) {
		    var _check$call9 = check.call(this, 'previous', resourceName, id);
		
		    var _this = _check$call9._this;
		    var _resourceName = _check$call9._resourceName;
		    var _id = _check$call9._id;
		
		    var resource = _this.store[_resourceName];
		
		    // return resource from cache
		    return resource.previousAttributes[_id] ? _utils2.default.copy(resource.previousAttributes[_id]) : undefined;
		  },
		
		
		  // Revert all attributes of the item with the given primary key to their previous values.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @param options Optional configuration.
		  // @returns The reverted item
		  revert: function revert(resourceName, id, options) {
		    var _check$call10 = check.call(this, 'revert', resourceName, id, options);
		
		    var _this = _check$call10._this;
		    var definition = _check$call10.definition;
		    var _resourceName = _check$call10._resourceName;
		    var _id = _check$call10._id;
		    var _options = _check$call10._options;
		
		
		    var preserve = _options.preserve || [];
		    var injectObj = {};
		
		    if (preserve.length === 0) {
		      injectObj = _this.previous(_resourceName, _id);
		    } else {
		      var _ret3 = function () {
		        var instance = definition.get(id);
		        var previousInstance = _this.previous(_resourceName, _id);
		
		        if (!instance) {
		          return {
		            v: undefined
		          };
		        }
		
		        _utils2.default.forOwn(instance, function (value, key) {
		          if (_utils2.default.contains(preserve, key)) {
		            injectObj[key] = instance[key];
		          } else {
		            injectObj[key] = previousInstance[key];
		          }
		        });
		      }();
		
		      if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
		    }
		
		    return definition.inject(injectObj, {
		      onConflict: 'replace'
		    });
		  }
		};
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /* jshint evil:true, loopfunc:true */
		
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/**
		 * These are DS methods that will be proxied by instances. e.g.
		 *
		 * var store = new JSData.DS()
		 * var User = store.defineResource('user')
		 * var user = User.createInstance({ id: 1 })
		 *
		 * store.update(resourceName, id, attrs[, options]) // DS method
		 * User.update(id, attrs[, options]) // DS method proxied on a Resource
		 * user.DSUpdate(attrs[, options]) // DS method proxied on an Instance
		 */
		var instanceMethods = ['compute', 'eject', 'refresh', 'save', 'update', 'destroy', 'loadRelations', 'changeHistory', 'changes', 'commit', 'hasChanges', 'isNew', 'lastModified', 'lastSaved', 'previous', 'revert'];
		
		module.exports = function defineResource(definition) {
		  var _this = this;
		  var definitions = _this.definitions;
		
		  /**
		   * This allows the name-only definition shorthand.
		   * store.defineResource('user') is the same as store.defineResource({ name: 'user'})
		   */
		  if (_utils2.default._s(definition)) {
		    definition = {
		      name: definition.replace(/\s/gi, '')
		    };
		  }
		  if (!_utils2.default._o(definition)) {
		    throw _utils2.default._oErr('definition');
		  } else if (!_utils2.default._s(definition.name)) {
		    throw new _errors2.default.IA('"name" must be a string!');
		  } else if (definitions[definition.name]) {
		    throw new _errors2.default.R(definition.name + ' is already registered!');
		  }
		
		  /**
		   * Dynamic Resource constructor function.
		   *
		   * A Resource inherits from the defaults of the data store that created it.
		   */
		  function Resource(options) {
		    this.defaultValues = {};
		    this.methods = {};
		    this.computed = {};
		    this.scopes = {};
		    this.actions = {};
		    _utils2.default.deepMixIn(this, options);
		    var parent = _this.defaults;
		    if (definition.extends && definitions[definition.extends]) {
		      parent = definitions[definition.extends];
		    }
		    _utils2.default.fillIn(this.defaultValues, parent.defaultValues);
		    _utils2.default.fillIn(this.methods, parent.methods);
		    _utils2.default.fillIn(this.computed, parent.computed);
		    _utils2.default.fillIn(this.scopes, parent.scopes);
		    _utils2.default.fillIn(this.actions, parent.actions);
		    this.endpoint = 'endpoint' in options ? options.endpoint : this.name;
		  }
		
		  try {
		    var def;
		
		    var _class;
		
		    var _ret = function () {
		      // Resources can inherit from another resource instead of inheriting directly from the data store defaults.
		      if (definition.extends && definitions[definition.extends]) {
		        // Inherit from another resource
		        Resource.prototype = definitions[definition.extends];
		      } else {
		        // Inherit from global defaults
		        Resource.prototype = _this.defaults;
		      }
		      definitions[definition.name] = new Resource(definition);
		
		      def = definitions[definition.name];
		
		
		      def.getResource = function (resourceName) {
		        return _this.definitions[resourceName];
		      };
		
		      def.logFn('Preparing resource.');
		
		      if (!_utils2.default._s(def.idAttribute)) {
		        throw new _errors2.default.IA('"idAttribute" must be a string!');
		      }
		
		      // Setup nested parent configuration
		      if (def.relations) {
		        def.relationList = [];
		        def.relationFields = [];
		        _utils2.default.forOwn(def.relations, function (relatedModels, type) {
		          _utils2.default.forOwn(relatedModels, function (defs, relationName) {
		            if (!_utils2.default._a(defs)) {
		              relatedModels[relationName] = [defs];
		            }
		            _utils2.default.forEach(relatedModels[relationName], function (d) {
		              d.type = type;
		              d.relation = relationName;
		              d.name = def.name;
		              def.relationList.push(d);
		              if (d.localField) {
		                def.relationFields.push(d.localField);
		              }
		            });
		          });
		        });
		        if (def.relations.belongsTo) {
		          def.parents = {};
		          _utils2.default.forOwn(def.relations.belongsTo, function (relatedModel, modelName) {
		            _utils2.default.forEach(relatedModel, function (relation) {
		              if (relation.parent) {
		                def.parent = modelName;
		                def.parentKey = relation.localKey;
		                def.parentField = relation.localField;
		                def.parents[modelName] = {
		                  key: def.parentKey,
		                  field: def.parentField
		                };
		              }
		            });
		          });
		        }
		        if (typeof Object.freeze === 'function') {
		          Object.freeze(def.relations);
		          Object.freeze(def.relationList);
		        }
		      }
		
		      // Create the wrapper class for the new resource
		      _class = def['class'] = _utils2.default.pascalCase(def.name);
		
		      try {
		        if (typeof def.useClass === 'function') {
		          if (def.csp) {
		            def[_class] = function () {
		              def.useClass.call(this);
		            };
		          } else {
		            def[_class] = new Function('def', 'return function ' + _class + '() { def.useClass.call(this); }')(def); // eslint-disable-line
		          }
		          def[_class].prototype = function (proto) {
		            function Ctor() {}
		
		            Ctor.prototype = proto;
		            return new Ctor();
		          }(def.useClass.prototype);
		        } else if (def.csp) {
		          def[_class] = function () {};
		        } else {
		          def[_class] = new Function('return function ' + _class + '() {}')(); // eslint-disable-line
		        }
		      } catch (e) {
		        def[_class] = function () {};
		      }
		
		      // Apply developer-defined instance methods
		      _utils2.default.forOwn(def.methods, function (fn, m) {
		        def[_class].prototype[m] = fn;
		      });
		
		      /**
		       * var user = User.createInstance({ id: 1 })
		       * user.set('foo', 'bar')
		       */
		      def[_class].prototype.set = function (key, value) {
		        var _this2 = this;
		
		        _utils2.default.set(this, key, value);
		        def.compute(this);
		        if (def.instanceEvents) {
		          setTimeout(function () {
		            _this2.emit('DS.change', def, _this2);
		          }, 0);
		        }
		        def.handleChange(this);
		        return this;
		      };
		
		      /**
		       * var user = User.createInstance({ id: 1 })
		       * user.get('id') // 1
		       */
		      def[_class].prototype.get = function (key) {
		        return _utils2.default.get(this, key);
		      };
		
		      // Setup the relation links
		      _utils2.default.applyRelationGettersToTarget(_this, def, def[_class].prototype);
		
		      var parentOmit = null;
		      if (!def.hasOwnProperty('omit')) {
		        parentOmit = def.omit;
		        def.omit = [];
		      } else {
		        parentOmit = _this.defaults.omit;
		      }
		      def.omit = def.omit.concat(parentOmit || []);
		
		      // Prepare for computed properties
		      _utils2.default.forOwn(def.computed, function (fn, field) {
		        if (_utils2.default.isFunction(fn)) {
		          def.computed[field] = [fn];
		          fn = def.computed[field];
		        }
		        if (def.methods && field in def.methods) {
		          def.errorFn('Computed property "' + field + '" conflicts with previously defined prototype method!');
		        }
		        def.omit.push(field);
		        if (_utils2.default.isArray(fn)) {
		          var deps;
		          if (fn.length === 1) {
		            var match = fn[0].toString().match(/function.*?\(([\s\S]*?)\)/);
		            deps = match[1].split(',');
		            deps = _utils2.default.filter(deps, function (x) {
		              return x;
		            });
		            def.computed[field] = deps.concat(fn);
		            fn = def.computed[field];
		            if (deps.length) {
		              def.errorFn('Use the computed property array syntax for compatibility with minified code!');
		            }
		          }
		          deps = fn.slice(0, fn.length - 1);
		          _utils2.default.forEach(deps, function (val, index) {
		            deps[index] = val.trim();
		          });
		          fn.deps = _utils2.default.filter(deps, function (dep) {
		            return !!dep;
		          });
		        } else if (_utils2.default.isObject(fn)) {
		          Object.defineProperty(def[_class].prototype, field, fn);
		        }
		      });
		
		      // add instance proxies of DS methods
		      _utils2.default.forEach(instanceMethods, function (name) {
		        def[_class].prototype['DS' + _utils2.default.pascalCase(name)] = function () {
		          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		          }
		
		          args.unshift(this[def.idAttribute] || this);
		          args.unshift(def.name);
		          return _this[name].apply(_this, args);
		        };
		      });
		
		      // manually add instance proxy for DS#create
		      def[_class].prototype.DSCreate = function () {
		        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		          args[_key2] = arguments[_key2];
		        }
		
		        args.unshift(this);
		        args.unshift(def.name);
		        return _this.create.apply(_this, args);
		      };
		
		      // Initialize store data for the new resource
		      _this.store[def.name] = {
		        collection: [],
		        expiresHeap: new _utils2.default.BinaryHeap(function (x) {
		          return x.expires;
		        }, function (x, y) {
		          return x.item === y;
		        }),
		        completedQueries: {},
		        queryData: {},
		        pendingQueries: {},
		        index: {},
		        modified: {},
		        saved: {},
		        previousAttributes: {},
		        observers: {},
		        changeHistories: {},
		        changeHistory: [],
		        collectionModified: 0,
		        temporaryItems: {}
		      };
		
		      var resource = _this.store[def.name];
		
		      // start the reaping
		      if (def.reapInterval) {
		        setInterval(function () {
		          return def.reap();
		        }, def.reapInterval);
		      }
		
		      // proxy DS methods with shorthand ones
		      var fns = ['registerAdapter', 'getAdapterName', 'getAdapter', 'is', '!clear'];
		      for (var key in _this) {
		        if (typeof _this[key] === 'function') {
		          fns.push(key);
		        }
		      }
		
		      /**
		       * Create the Resource shorthands that proxy DS methods. e.g.
		       *
		       * var store = new JSData.DS()
		       * var User = store.defineResource('user')
		       *
		       * store.update(resourceName, id, attrs[, options]) // DS method
		       * User.update(id, attrs[, options]) // DS method proxied on a Resource
		       */
		      _utils2.default.forEach(fns, function (key) {
		        var k = key;
		        if (k[0] === '!') {
		          return;
		        }
		        if (_this[k].shorthand !== false) {
		          def[k] = function () {
		            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		              args[_key3] = arguments[_key3];
		            }
		
		            args.unshift(def.name);
		            return _this[k].apply(_this, args);
		          };
		          def[k].before = function (fn) {
		            var orig = def[k];
		            def[k] = function () {
		              for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		                args[_key4] = arguments[_key4];
		              }
		
		              return orig.apply(def, fn.apply(def, args) || args);
		            };
		          };
		        } else {
		          def[k] = function () {
		            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		              args[_key5] = arguments[_key5];
		            }
		
		            return _this[k].apply(_this, args);
		          };
		        }
		      });
		
		      def.beforeValidate = _utils2.default.promisify(def.beforeValidate);
		      def.validate = _utils2.default.promisify(def.validate);
		      def.afterValidate = _utils2.default.promisify(def.afterValidate);
		      def.beforeCreate = _utils2.default.promisify(def.beforeCreate);
		      def.afterCreate = _utils2.default.promisify(def.afterCreate);
		      def.afterFind = _utils2.default.promisify(def.afterFind);
		      def.afterFindAll = _utils2.default.promisify(def.afterFindAll);
		      def.afterLoadRelations = _utils2.default.promisify(def.afterLoadRelations);
		      def.beforeUpdate = _utils2.default.promisify(def.beforeUpdate);
		      def.afterUpdate = _utils2.default.promisify(def.afterUpdate);
		      def.beforeDestroy = _utils2.default.promisify(def.beforeDestroy);
		      def.afterDestroy = _utils2.default.promisify(def.afterDestroy);
		
		      var defaultAdapter = undefined;
		      if (def.hasOwnProperty('defaultAdapter')) {
		        defaultAdapter = def.defaultAdapter;
		      }
		
		      // setup "actions"
		      _utils2.default.forOwn(def.actions, function (action, name) {
		        if (def[name] && !def.actions[name]) {
		          throw new Error('Cannot override existing method "' + name + '"!');
		        }
		        action.request = action.request || function (config) {
		          return config;
		        };
		        action.response = action.response || function (response) {
		          return response;
		        };
		        action.responseError = action.responseError || function (err) {
		          return _utils2.default.Promise.reject(err);
		        };
		        def[name] = function (id, options) {
		          if (_utils2.default._o(id)) {
		            options = id;
		          }
		          options = options || {};
		          var adapter = def.getAdapter(action.adapter || defaultAdapter || 'http');
		          var config = _utils2.default.deepMixIn({}, action);
		          if (!options.hasOwnProperty('endpoint') && config.endpoint) {
		            options.endpoint = config.endpoint;
		          }
		          if (typeof options.getEndpoint === 'function') {
		            config.url = options.getEndpoint(def, options);
		          } else {
		            var _args = [options.basePath || def.basePath || adapter.defaults.basePath, adapter.getEndpoint(def, _utils2.default._sn(id) ? id : null, options)];
		            if (_utils2.default._sn(id)) {
		              _args.push(id);
		            }
		            _args.push(action.pathname || name);
		            config.url = _utils2.default.makePath.apply(null, _args);
		          }
		          config.method = config.method || 'GET';
		          config.resourceName = def.name;
		          _utils2.default.deepMixIn(config, options);
		          return new _utils2.default.Promise(function (resolve) {
		            return resolve(config);
		          }).then(options.request || action.request).then(function (config) {
		            return adapter.HTTP(config);
		          }).then(function (data) {
		            if (data && data.config) {
		              data.config.resourceName = def.name;
		            }
		            return data;
		          }).then(options.response || action.response, options.responseError || action.responseError);
		        };
		      });
		
		      // mix in events
		      _utils2.default.Events(def);
		
		      def.handleChange = function (data) {
		        resource.collectionModified = _utils2.default.updateTimestamp(resource.collectionModified);
		        if (def.notify) {
		          setTimeout(function () {
		            def.emit('DS.change', def, data);
		          }, 0);
		        }
		      };
		
		      def.logFn('Done preparing resource.');
		
		      return {
		        v: def
		      };
		    }();
		
		    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		  } catch (err) {
		    _this.defaults.errorFn(err);
		    delete definitions[definition.name];
		    delete _this.store[definition.name];
		    throw err;
		  }
		};
	
	/***/ },
	/* 43 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/* jshint eqeqeq:false */
		/**
		 * Eject an item from the store, if it is currently in the store.
		 *
		 * @param resourceName The name of the resource type of the item eject.
		 * @param id The primary key of the item to eject.
		 * @param options Optional configuration.
		 * @param options.notify Whether to emit the "DS.beforeEject" and "DS.afterEject" events
		 * @param options.clearEmptyQueries Whether to remove cached findAll queries that become empty as a result of this method call.
		 * @returns The ejected item if one was ejected.
		 */
		module.exports = function eject(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var item = undefined;
		  var found = false;
		
		  id = DSUtils.resolveId(definition, id);
		
		  if (!definition) {
		    throw new _this.errors.NER(resourceName);
		  } else if (!DSUtils._sn(id)) {
		    throw DSUtils._snErr('id');
		  }
		
		  options = DSUtils._(definition, options);
		
		  options.logFn('eject', id, options);
		
		  // find the item to eject
		  for (var i = 0; i < resource.collection.length; i++) {
		    if (resource.collection[i][definition.idAttribute] == id) {
		      // eslint-disable-line
		      item = resource.collection[i];
		      // remove its expiration timestamp
		      resource.expiresHeap.remove(item);
		      found = true;
		      break;
		    }
		  }
		  if (found) {
		    var _ret = function () {
		      // lifecycle
		      definition.beforeEject(options, item);
		      if (options.notify) {
		        definition.emit('DS.beforeEject', definition, item);
		      }
		
		      // find the item in any ($$injected) cached queries
		      var toRemove = [];
		      DSUtils.forOwn(resource.queryData, function (items, queryHash) {
		        if (items.$$injected) {
		          DSUtils.remove(items, item);
		        }
		        // optionally remove any empty queries
		        if (!items.length && options.clearEmptyQueries) {
		          toRemove.push(queryHash);
		        }
		      });
		
		      // clean up
		      DSUtils.forEach(resource.changeHistories[id], function (changeRecord) {
		        DSUtils.remove(resource.changeHistory, changeRecord);
		      });
		      DSUtils.forEach(toRemove, function (queryHash) {
		        delete resource.completedQueries[queryHash];
		        delete resource.queryData[queryHash];
		      });
		      if (resource.observers[id] && typeof resource.observers[id].close === 'function') {
		        // stop observation
		        resource.observers[id].close();
		      }
		      delete resource.observers[id];
		      delete resource.index[id];
		      delete resource.previousAttributes[id];
		      delete resource.completedQueries[id];
		      delete resource.pendingQueries[id];
		      delete resource.changeHistories[id];
		      delete resource.modified[id];
		      delete resource.saved[id];
		      if (definition.instanceEvents && item.off) {
		        item.off();
		      }
		
		      // remove it from the store
		      resource.collection.splice(i, 1);
		      // collection has been modified
		      definition.handleChange(item);
		
		      // lifecycle
		      definition.afterEject(options, item);
		      if (options.notify) {
		        definition.emit('DS.afterEject', definition, item);
		      }
		
		      return {
		        v: item
		      };
		    }();
		
		    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		  }
		};
	
	/***/ },
	/* 44 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Eject a collection of items from the store, if any items currently in the store match the given criteria.
		 *
		 * @param resourceName The name of the resource type of the items eject.
		 * @param params The criteria by which to match items to eject. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @returns The collection of items that were ejected, if any.
		 */
		module.exports = function ejectAll(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  params = params || {};
		
		  if (!definition) {
		    throw new _this.errors.NER(resourceName);
		  } else if (!DSUtils._o(params)) {
		    throw DSUtils._oErr('params');
		  }
		
		  options = DSUtils._(definition, options);
		  definition.logFn('ejectAll', params, options);
		
		  DSUtils.applyScope(definition, params, options);
		
		  var resource = _this.store[resourceName];
		  var queryHash = DSUtils.toJson(params);
		
		  // get items that match the criteria
		  var items = definition.filter(params);
		
		  if (DSUtils.isEmpty(params)) {
		    // remove all completed queries if ejecting all items
		    resource.completedQueries = {};
		  } else {
		    // remove matching completed query, if any
		    delete resource.completedQueries[queryHash];
		  }
		  // prepare to remove matching items
		  DSUtils.forEach(items, function (item) {
		    if (item && item[definition.idAttribute]) {
		      definition.eject(item[definition.idAttribute], options);
		    }
		  });
		  // collection has been modified
		  definition.handleChange(items);
		  return items;
		};
	
	/***/ },
	/* 45 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Return the subset of items currently in the store that match the given criteria.
		 *
		 * The actual filtering is delegated to DS#defaults.defaultFilter, which can be overridden by developers.
		 *
		 * @param resourceName The name of the resource type of the items to filter.
		 * @param params The criteria by which to filter items. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @returns Matching items.
		 */
		module.exports = function filter(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		
		  if (!definition) {
		    throw new _this.errors.NER(resourceName);
		  } else if (params && !DSUtils._o(params)) {
		    throw DSUtils._oErr('params');
		  }
		
		  // Protect against null
		  params = params || {};
		  options = DSUtils._(definition, options);
		  options.logFn('filter', params, options);
		
		  DSUtils.applyScope(definition, params, options);
		
		  // delegate filtering to DS#defaults.defaultFilter, which can be overridden by developers.
		  return definition.defaultFilter.call(_this, _this.store[resourceName].collection, resourceName, params, options);
		};
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/**
		 * This is a beast of a file, but it's where a significant portion of the magic happens.
		 *
		 * DS#inject makes up the core of how data gets into the store.
		 */
		
		/**
		 * This factory function produces an observer handler function tailor-made for the current item being injected.
		 *
		 * The observer handler is what allows computed properties and change tracking to function.
		 *
		 * @param definition Resource definition produced by DS#defineResource
		 * @param resource Resource data as internally stored by the data store
		 * @returns {Function} Observer handler function
		 * @private
		 */
		function makeObserverHandler(definition, resource) {
		  var DS = this;
		
		  // using "var" avoids a JSHint error
		  var name = definition.name;
		
		  /**
		   * This will be called by observe-js when a new change record is available for the observed object
		   *
		   * @param added Change record for added properties
		   * @param removed Change record for removed properties
		   * @param changed Change record for changed properties
		   * @param oldValueFn Function that can be used to get the previous value of a changed property
		   * @param firstTime Whether this is the first time this function is being called for the given item. Will only be true once.
		   */
		  return function _react(added, removed, changed, oldValueFn, firstTime) {
		    var target = this;
		    var item = undefined;
		
		    // Get the previous primary key of the observed item, in-case some knucklehead changed it
		    var innerId = oldValueFn && oldValueFn(definition.idAttribute) ? oldValueFn(definition.idAttribute) : target[definition.idAttribute];
		
		    // Ignore changes to relation links
		    _utils2.default.forEach(definition.relationFields, function (field) {
		      delete added[field];
		      delete removed[field];
		      delete changed[field];
		    });
		
		    // Detect whether there are actually any changes
		    if (!_utils2.default.isEmpty(added) || !_utils2.default.isEmpty(removed) || !_utils2.default.isEmpty(changed) || firstTime) {
		      item = DS.get(name, innerId);
		
		      // update item and collection "modified" timestamps
		      resource.modified[innerId] = _utils2.default.updateTimestamp(resource.modified[innerId]);
		
		      if (item && definition.instanceEvents) {
		        setTimeout(function () {
		          item.emit('DS.change', definition, item);
		        }, 0);
		      }
		
		      definition.handleChange(item);
		
		      // Save a change record for the item
		      if (definition.keepChangeHistory) {
		        var changeRecord = {
		          resourceName: name,
		          target: item,
		          added: added,
		          removed: removed,
		          changed: changed,
		          timestamp: resource.modified[innerId]
		        };
		        resource.changeHistories[innerId].push(changeRecord);
		        resource.changeHistory.push(changeRecord);
		      }
		    }
		
		    // Recompute computed properties if any computed properties depend on changed properties
		    if (definition.computed) {
		      item = item || DS.get(name, innerId);
		      _utils2.default.forOwn(definition.computed, function (fn, field) {
		        if (_utils2.default._o(fn)) {
		          return;
		        }
		        var compute = false;
		        // check if required fields changed
		        _utils2.default.forEach(fn.deps, function (dep) {
		          if (dep in added || dep in removed || dep in changed || !(field in item)) {
		            compute = true;
		          }
		        });
		        compute = compute || !fn.deps.length;
		        if (compute) {
		          _utils2.default.compute.call(item, fn, field);
		        }
		      });
		    }
		
		    if (definition.idAttribute in changed) {
		      definition.errorFn('Doh! You just changed the primary key of an object! Your data for the "' + name + '" resource is now in an undefined (probably broken) state.');
		    }
		  };
		}
		
		/**
		 * A recursive function for injecting data into the store.
		 *
		 * @param definition Resource definition produced by DS#defineResource
		 * @param resource Resource data as internally stored by the data store
		 * @param attrs The data to be injected. Will be an object or an array of objects.
		 * @param options Optional configuration.
		 * @returns The injected data
		 * @private
		 */
		function _inject(definition, resource, attrs, options) {
		  var _this = this;
		  var injected = undefined;
		
		  if (_utils2.default._a(attrs)) {
		    // have an array of objects, go ahead and inject each one individually and return the resulting array
		    injected = [];
		    for (var i = 0; i < attrs.length; i++) {
		      injected.push(_inject.call(_this, definition, resource, attrs[i], options));
		    }
		  } else {
		    // check if "idAttribute" is a computed property
		    var c = definition.computed;
		    var idA = definition.idAttribute;
		    // compute the primary key if necessary
		    if (c && c[idA]) {
		      (function () {
		        var args = [];
		        _utils2.default.forEach(c[idA].deps, function (dep) {
		          args.push(attrs[dep]);
		        });
		        attrs[idA] = c[idA][c[idA].length - 1].apply(attrs, args);
		      })();
		    } else if (options.temporary) {
		      attrs[idA] = _utils2.default.guid();
		    }
		
		    if (!(idA in attrs)) {
		      var error = new _errors2.default.R(definition.name + '.inject: "attrs" must contain the property specified by "idAttribute"!');
		      options.errorFn(error);
		      throw error;
		    } else {
		      try {
		        (function () {
		          // when injecting object that contain their nested relations, this code
		          // will recursively inject them into their proper places in the data store.
		          // Magic!
		          _utils2.default.forEach(definition.relationList, function (def) {
		            var relationName = def.relation;
		            var relationDef = _this.definitions[relationName];
		            var toInject = attrs[def.localField];
		            if (typeof def.inject === 'function') {
		              def.inject(definition, def, attrs);
		            } else if (toInject && def.inject !== false) {
		              if (!relationDef) {
		                throw new _errors2.default.R(definition.name + ' relation is defined but the resource is not!');
		              }
		              // handle injecting hasMany relations
		              if (_utils2.default._a(toInject)) {
		                (function () {
		                  var items = [];
		                  _utils2.default.forEach(toInject, function (toInjectItem) {
		                    if (toInjectItem !== _this.store[relationName].index[toInjectItem[relationDef.idAttribute]]) {
		                      try {
		                        var injectedItem = relationDef.inject(toInjectItem, options.orig());
		                        if (def.foreignKey) {
		                          _utils2.default.set(injectedItem, def.foreignKey, attrs[definition.idAttribute]);
		                        }
		                        items.push(injectedItem);
		                      } catch (err) {
		                        options.errorFn(err, 'Failed to inject ' + def.type + ' relation: "' + relationName + '"!');
		                      }
		                    }
		                  });
		                })();
		              } else {
		                // handle injecting belongsTo and hasOne relations
		                if (toInject !== _this.store[relationName].index[toInject[relationDef.idAttribute]]) {
		                  try {
		                    var _injected = relationDef.inject(attrs[def.localField], options.orig());
		                    if (def.foreignKey) {
		                      _utils2.default.set(_injected, def.foreignKey, attrs[definition.idAttribute]);
		                    }
		                    if (def.localKey) {
		                      _utils2.default.set(attrs, def.localKey, _utils2.default.get(_injected, relationDef.idAttribute));
		                    }
		                  } catch (err) {
		                    options.errorFn(err, 'Failed to inject ' + def.type + ' relation: "' + relationName + '"!');
		                  }
		                }
		              }
		            }
		          });
		
		          // primary key of item being injected
		          var id = attrs[idA];
		          // item being injected
		          var item = definition.get(id);
		          // 0 if the item is new, otherwise the previous last modified timestamp of the item
		          var initialLastModified = item ? resource.modified[id] : 0;
		
		          // item is new
		          if (!item) {
		            if (attrs instanceof definition[definition['class']]) {
		              item = attrs;
		            } else {
		              item = new definition[definition['class']]();
		            }
		
		            if (definition.instanceEvents && typeof item.emit !== 'function') {
		              _utils2.default.Events(item);
		            }
		            // remove relation properties from the item, since those relations have been injected by now
		            _utils2.default.forEach(definition.relationList, function (def) {
		              if (typeof def.link === 'boolean' ? def.link : !!definition.linkRelations) {
		                delete attrs[def.localField];
		              }
		            });
		
		            // copy remaining properties to the injected item
		            _utils2.default.deepMixIn(item, attrs);
		
		            // add item to collection
		            resource.collection.push(item);
		            resource.changeHistories[id] = [];
		
		            // create the observer handler for the data to be injected
		            var _react = makeObserverHandler.call(_this, definition, resource);
		
		            // If we're in the browser, start observation
		            if (definition.watchChanges) {
		              resource.observers[id] = new _this.observe.ObjectObserver(item);
		              resource.observers[id].open(_react, item);
		            }
		
		            // index item
		            resource.index[id] = item;
		            // fire observation handler for the first time
		            _react.call(item, {}, {}, {}, null, true);
		            // save "previous" attributes of the injected item, for change diffs later
		            resource.previousAttributes[id] = _utils2.default.copy(item, null, null, null, definition.relationFields);
		            // mark item as temporary if guid has been generated
		            if (options.temporary) {
		              resource.temporaryItems[id] = true;
		            }
		          } else {
		            // item is being re-injected
		            // new properties take precedence
		            if (options.onConflict === 'merge') {
		              _utils2.default.deepMixIn(item, attrs);
		            } else if (options.onConflict === 'replace') {
		              _utils2.default.forOwn(item, function (v, k) {
		                if (k !== definition.idAttribute) {
		                  if (!attrs.hasOwnProperty(k)) {
		                    delete item[k];
		                  }
		                }
		              });
		              _utils2.default.forOwn(attrs, function (v, k) {
		                if (k !== definition.idAttribute) {
		                  item[k] = v;
		                }
		              });
		            }
		
		            if (definition.resetHistoryOnInject) {
		              // clear change history for item
		              _this.commit(definition.name, id);
		            }
		            if (resource.observers[id] && typeof resource.observers[id] === 'function') {
		              // force observation callback to be fired if there are any changes to the item and `Object.observe` is not available
		              resource.observers[id].deliver();
		            }
		          }
		          // update modified timestamp of item
		          resource.modified[id] = initialLastModified && resource.modified[id] === initialLastModified ? _utils2.default.updateTimestamp(resource.modified[id]) : resource.modified[id];
		
		          // reset expiry tracking for item
		          resource.expiresHeap.remove(item);
		          var timestamp = new Date().getTime();
		          resource.expiresHeap.push({
		            item: item,
		            timestamp: timestamp,
		            expires: definition.maxAge ? timestamp + definition.maxAge : Number.MAX_VALUE
		          });
		
		          // final injected item
		          injected = item;
		        })();
		      } catch (err) {
		        options.errorFn(err, attrs);
		      }
		    }
		  }
		  return injected;
		}
		
		/**
		 * Inject the given object or array of objects into the data store.
		 *
		 * @param resourceName The name of the type of resource of the data to be injected.
		 * @param attrs Object or array of objects. Objects must contain a primary key.
		 * @param options Optional configuration.
		 * @param options.notify Whether to emit the "DS.beforeInject" and "DS.afterInject" events.
		 * @returns The injected data.
		 */
		module.exports = function inject(resourceName, attrs, options) {
		  var _this = this;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var injected = undefined;
		
		  if (!definition) {
		    throw new _errors2.default.NER(resourceName);
		  } else if (!_utils2.default._o(attrs) && !_utils2.default._a(attrs)) {
		    throw new _errors2.default.IA(resourceName + '.inject: "attrs" must be an object or an array!');
		  }
		
		  options = _utils2.default._(definition, options);
		  options.logFn('inject', attrs, options);
		
		  // lifecycle
		  options.beforeInject(options, attrs);
		  if (options.notify) {
		    definition.emit('DS.beforeInject', definition, attrs);
		  }
		
		  // start the recursive injection of data
		  injected = _inject.call(_this, definition, resource, attrs, options);
		
		  // collection was modified
		  definition.handleChange(injected);
		
		  // lifecycle
		  options.afterInject(options, injected);
		  if (options.notify) {
		    definition.emit('DS.afterInject', definition, injected);
		  }
		
		  return injected;
		};
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  create: __webpack_require__(48),
		  destroy: __webpack_require__(49),
		  destroyAll: __webpack_require__(50),
		  find: __webpack_require__(51),
		  findAll: __webpack_require__(52),
		  loadRelations: __webpack_require__(53),
		  reap: __webpack_require__(54),
		  refresh: function refresh(resourceName, id, options) {
		    var _this = this;
		    var DSUtils = _this.utils;
		
		    return new DSUtils.Promise(function (resolve, reject) {
		      var definition = _this.definitions[resourceName];
		      id = DSUtils.resolveId(_this.definitions[resourceName], id);
		      if (!definition) {
		        reject(new _this.errors.NER(resourceName));
		      } else if (!DSUtils._sn(id)) {
		        reject(DSUtils._snErr('id'));
		      } else {
		        options = DSUtils._(definition, options);
		        options.bypassCache = true;
		        options.logFn('refresh', id, options);
		        resolve(_this.get(resourceName, id));
		      }
		    }).then(function (item) {
		      return item ? _this.find(resourceName, id, options) : item;
		    }).catch(_this.errorFn('refresh', resourceName, id, options));
		  },
		  refreshAll: function refreshAll(resourceName, params, options) {
		    var _this = this;
		    var DSUtils = _this.utils;
		    var definition = _this.definitions[resourceName];
		    params = params || {};
		
		    return new DSUtils.Promise(function (resolve, reject) {
		      if (!definition) {
		        reject(new _this.errors.NER(resourceName));
		      } else if (!DSUtils._o(params)) {
		        reject(DSUtils._oErr('params'));
		      } else {
		        options = DSUtils._(definition, options);
		        options.bypassCache = true;
		        options.logFn('refreshAll', params, options);
		        resolve(_this.filter(resourceName, params, options));
		      }
		    }).then(function (existing) {
		      options.bypassCache = true;
		      return _this.findAll(resourceName, params, options).then(function (found) {
		        DSUtils.forEach(existing, function (item) {
		          if (found.indexOf(item) === -1) {
		            definition.eject(item);
		          }
		        });
		        return found;
		      });
		    }).catch(_this.errorFn('refreshAll', resourceName, params, options));
		  },
		
		  save: __webpack_require__(55),
		  update: __webpack_require__(56),
		  updateAll: __webpack_require__(57)
		};
	
	/***/ },
	/* 48 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Using an adapter, create a new item.
		 *
		 * Generally a primary key will NOT be provided in the properties hash,
		 * because the adapter's persistence layer should be generating one.
		 *
		 * @param resourceName The name of the type of resource of the new item.
		 * @param attrs Hash of properties with which to create the new item.
		 * @param options Optional configuration.
		 * @param options.cacheResponse Whether the newly created item as returned by the adapter should be injected into the data store.
		 * @param options.upsert If the properties hash contains a primary key, attempt to call DS#update instead.
		 * @param options.notify Whether to emit the "DS.beforeCreate" and "DS.afterCreate" events.
		 * @param options.beforeValidate Lifecycle hook.
		 * @param options.validate Lifecycle hook.
		 * @param options.afterValidate Lifecycle hook.
		 * @param options.beforeCreate Lifecycle hook.
		 * @param options.afterCreate Lifecycle hook.
		 */
		module.exports = function create(resourceName, attrs, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var adapter = undefined;
		
		  options = options || {};
		  attrs = attrs || {};
		
		  var rejectionError = undefined;
		  if (!definition) {
		    rejectionError = new _this.errors.NER(resourceName);
		  } else if (!DSUtils._o(attrs)) {
		    rejectionError = DSUtils._oErr('attrs');
		  } else {
		    options = DSUtils._(definition, options);
		    if (options.upsert && DSUtils._sn(attrs[definition.idAttribute]) && !resource.temporaryItems[attrs[definition.idAttribute]]) {
		      return _this.update(resourceName, attrs[definition.idAttribute], attrs, options);
		    }
		    options.logFn('create', attrs, options);
		  }
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (rejectionError) {
		      reject(rejectionError);
		    } else {
		      resolve(attrs);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeCreate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeCreate', definition, attrs);
		    }
		    adapter = _this.getAdapterName(options);
		    return _this.adapters[adapter].create(definition, DSUtils.omit(attrs, options.omit), options);
		  }).then(function (attrs) {
		    return options.afterCreate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.afterCreate', definition, attrs);
		    }
		    if (options.cacheResponse) {
		      // injected created intem into the store
		      var created = _this.inject(definition.name, attrs, options.orig());
		      var id = created[definition.idAttribute];
		      // mark item's `find` query as completed, so a subsequent `find` call for this item will resolve immediately
		      var _resource = _this.store[resourceName];
		      _resource.completedQueries[id] = new Date().getTime();
		      _resource.saved[id] = DSUtils.updateTimestamp(_resource.saved[id]);
		      return created;
		    } else {
		      // just return an un-injected instance
		      return _this.createInstance(resourceName, attrs, options);
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  })['catch'](_this.errorFn('create', resourceName, attrs, options));
		};
	
	/***/ },
	/* 49 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Using an adapter, destroy an item.
		 *
		 * @param resourceName The name of the type of resource of the item to destroy.
		 * @param id The primary key of the item to destroy.
		 * @param options Optional configuration.
		 * @param options.eagerEject Whether to eject the item from the store before the adapter operation completes, re-injecting if the adapter operation fails.
		 * @param options.notify Whether to emit the "DS.beforeDestroy" and "DS.afterDestroy" events.
		 * @param options.beforeDestroy Lifecycle hook.
		 * @param options.afterDestroy Lifecycle hook.
		 * @returns The primary key of the destroyed item.
		 */
		module.exports = function destroy(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var item = undefined,
		      adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    id = DSUtils.resolveId(definition, id);
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else {
		      // check if the item is in the store
		      item = definition.get(id) || { id: id };
		      options = DSUtils._(definition, options);
		      options.logFn('destroy', id, options);
		      resolve(item);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeDestroy.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeDestroy', definition, attrs);
		    }
		    // don't wait for the adapter, remove the item from the store
		    if (options.eagerEject) {
		      definition.eject(id);
		    }
		    adapter = definition.getAdapter(options);
		    return adapter.destroy(definition, id, options);
		  }).then(function () {
		    return options.afterDestroy.call(item, options, item);
		  }).then(function (item) {
		    if (options.notify) {
		      definition.emit('DS.afterDestroy', definition, item);
		    }
		    // make sure the item is removed from the store
		    definition.eject(id);
		    return DSUtils.respond(id, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    // rollback by re-injecting the item into the store
		    if (options && options.eagerEject && item) {
		      definition.inject(item, { notify: false });
		    }
		    return _this.errorFn('destroy', resourceName, id, options)(err);
		  });
		};
	
	/***/ },
	/* 50 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Using an adapter, destroy an item.
		 *
		 * @param resourceName The name of the type of resource of the item to destroy.
		 * @param params The criteria by which to filter items to destroy. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @param options.eagerEject Whether to eject the items from the store before the adapter operation completes, re-injecting if the adapter operation fails.
		 * @param options.notify Whether to emit the "DS.beforeDestroy" and "DS.afterDestroy" events.
		 * @param options.beforeDestroy Lifecycle hook.
		 * @param options.afterDestroy Lifecycle hook.
		 * @returns The ejected items, if any.
		 */
		module.exports = function destroyAll(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var ejected = undefined,
		      toEject = undefined,
		      adapter = undefined;
		
		  params = params || {};
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._o(params)) {
		      reject(DSUtils._oErr('attrs'));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('destroyAll', params, options);
		      DSUtils.applyScope(definition, params, options);
		      resolve();
		    }
		  }).then(function () {
		    // find items that are to be ejected from the store
		    toEject = definition.defaultFilter.call(_this, resourceName, params);
		    return options.beforeDestroy(options, toEject);
		  }).then(function () {
		    if (options.notify) {
		      definition.emit('DS.beforeDestroy', definition, toEject);
		    }
		    // don't wait for the adapter, remove the items from the store
		    if (options.eagerEject) {
		      ejected = definition.ejectAll(params);
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].destroyAll(definition, params, options);
		  }).then(function () {
		    return options.afterDestroy(options, toEject);
		  }).then(function () {
		    if (options.notify) {
		      definition.emit('DS.afterDestroy', definition, toEject);
		    }
		    // make sure items are removed from the store
		    return ejected || definition.ejectAll(params);
		  }).then(function (items) {
		    return DSUtils.respond(items, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    // rollback by re-injecting the items into the store
		    if (options && options.eagerEject && ejected) {
		      definition.inject(ejected, { notify: false });
		    }
		    return _this.errorFn('destroyAll', resourceName, params, options)(err);
		  });
		};
	
	/***/ },
	/* 51 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/* jshint -W082 */
		
		/**
		 * Using an adapter, retrieve a single item.
		 *
		 * @param resourceName The of the type of resource of the item to retrieve.
		 * @param id The primary key of the item to retrieve.
		 * @param options Optional configuration.
		 * @param options.bypassCache Whether to ignore any cached item and force the retrieval through the adapter.
		 * @param options.cacheResponse Whether to inject the found item into the data store.
		 * @param options.strictCache Whether to only consider items to be "cached" if they were injected into the store as the result of `find` or `findAll`.
		 * @param options.strategy The retrieval strategy to use.
		 * @param options.findStrategy The retrieval strategy to use. Overrides "strategy".
		 * @param options.fallbackAdapters Array of names of adapters to use if using "fallback" strategy.
		 * @param options.findFallbackAdapters Array of names of adapters to use if using "fallback" strategy. Overrides "fallbackAdapters".
		 * @returns The item.
		 */
		module.exports = function find(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('find', id, options);
		
		      if (options.params) {
		        options.params = DSUtils.copy(options.params);
		      }
		
		      if (options.bypassCache || !options.cacheResponse) {
		        delete resource.completedQueries[id];
		      }
		
		      var expired = options.maxAge && id in resource.completedQueries && resource.completedQueries[id] + options.maxAge < new Date().getTime();
		
		      if ((!options.findStrictCache || id in resource.completedQueries) && definition.get(id) && !options.bypassCache && !expired) {
		        // resolve immediately with the cached item
		        resolve(definition.get(id));
		      } else {
		        // we're going to delegate to the adapter next
		        delete resource.completedQueries[id];
		        resolve();
		      }
		    }
		  }).then(function (item) {
		    if (!item) {
		      if (!(id in resource.pendingQueries)) {
		        var promise = undefined;
		        var strategy = options.findStrategy || options.strategy;
		
		        // try subsequent adapters if the preceeding one fails
		        if (strategy === 'fallback') {
		          var makeFallbackCall = function makeFallbackCall(index) {
		            adapter = definition.getAdapterName((options.findFallbackAdapters || options.fallbackAdapters)[index]);
		            return _this.adapters[adapter].find(definition, id, options)['catch'](function (err) {
		              index++;
		              if (index < options.fallbackAdapters.length) {
		                return makeFallbackCall(index);
		              } else {
		                return DSUtils.Promise.reject(err);
		              }
		            });
		          };
		
		          promise = makeFallbackCall(0);
		        } else {
		          adapter = definition.getAdapterName(options);
		          // just make a single attempt
		          promise = _this.adapters[adapter].find(definition, id, options);
		        }
		
		        resource.pendingQueries[id] = promise.then(function (data) {
		          return options.afterFind.call(data, options, data);
		        }).then(function (data) {
		          // Query is no longer pending
		          delete resource.pendingQueries[id];
		          if (options.cacheResponse) {
		            // inject the item into the data store
		            var injected = definition.inject(data, options.orig());
		            // mark the item as "cached"
		            resource.completedQueries[id] = new Date().getTime();
		            resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		            return injected;
		          } else {
		            // just return an un-injected instance
		            return definition.createInstance(data, options.orig());
		          }
		        });
		      }
		      return resource.pendingQueries[id];
		    } else {
		      // resolve immediately with the item
		      return item;
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    if (resource) {
		      delete resource.pendingQueries[id];
		    }
		    return _this.errorFn('find', resourceName, id, options)(err);
		  });
		};
	
	/***/ },
	/* 52 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/* jshint -W082 */
		function processResults(data, resourceName, queryHash, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var idAttribute = definition.idAttribute;
		  var date = new Date().getTime();
		
		  data = data || [];
		
		  // Query is no longer pending
		  delete resource.pendingQueries[queryHash];
		  resource.completedQueries[queryHash] = date;
		
		  // Merge the new values into the cache
		  var injected = definition.inject(data, options.orig());
		
		  // Make sure each object is added to completedQueries
		  if (DSUtils._a(injected)) {
		    DSUtils.forEach(injected, function (item) {
		      if (item) {
		        var id = item[idAttribute];
		        if (id) {
		          resource.completedQueries[id] = date;
		          resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		        }
		      }
		    });
		  } else {
		    options.errorFn('response is expected to be an array!');
		    resource.completedQueries[injected[idAttribute]] = date;
		  }
		
		  return injected;
		}
		
		/**
		 * Using an adapter, retrieve a collection of items.
		 *
		 * @param resourceName The name of the type of resource of the items to retrieve.
		 * @param params The criteria by which to filter items to retrieve. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @param options.bypassCache Whether to ignore any cached query for these items and force the retrieval through the adapter.
		 * @param options.cacheResponse Whether to inject the found items into the data store.
		 * @returns The items.
		 */
		module.exports = function findAll(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var queryHash = undefined,
		      adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    params = params || {};
		
		    if (!_this.definitions[resourceName]) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._o(params)) {
		      reject(DSUtils._oErr('params'));
		    } else {
		      options = DSUtils._(definition, options);
		      queryHash = DSUtils.toJson(params);
		      options.logFn('findAll', params, options);
		
		      if (options.params) {
		        options.params = DSUtils.copy(options.params);
		      }
		
		      DSUtils.applyScope(definition, params, options);
		
		      // force a new request
		      if (options.bypassCache || !options.cacheResponse) {
		        delete resource.completedQueries[queryHash];
		        delete resource.queryData[queryHash];
		      }
		
		      var expired = options.maxAge && queryHash in resource.completedQueries && resource.completedQueries[queryHash] + options.maxAge < new Date().getTime();
		
		      if (queryHash in resource.completedQueries && !expired) {
		        if (options.useFilter) {
		          if (options.localKeys) {
		            resolve(definition.getAll(options.localKeys, options.orig()));
		          } else {
		            // resolve immediately by filtering data from the data store
		            resolve(definition.filter(params, options.orig()));
		          }
		        } else {
		          // resolve immediately by returning the cached array from the previously made query
		          resolve(resource.queryData[queryHash]);
		        }
		      } else {
		        resolve();
		      }
		    }
		  }).then(function (items) {
		    if (!items) {
		      if (!(queryHash in resource.pendingQueries)) {
		        var promise = undefined;
		        var strategy = options.findAllStrategy || options.strategy;
		
		        // try subsequent adapters if the preceeding one fails
		        if (strategy === 'fallback') {
		          var makeFallbackCall = function makeFallbackCall(index) {
		            adapter = definition.getAdapterName((options.findAllFallbackAdapters || options.fallbackAdapters)[index]);
		            return _this.adapters[adapter].findAll(definition, params, options)['catch'](function (err) {
		              index++;
		              if (index < options.fallbackAdapters.length) {
		                return makeFallbackCall(index);
		              } else {
		                return DSUtils.Promise.reject(err);
		              }
		            });
		          };
		
		          promise = makeFallbackCall(0);
		        } else {
		          adapter = definition.getAdapterName(options);
		          // just make a single attempt
		          promise = _this.adapters[adapter].findAll(definition, params, options);
		        }
		
		        resource.pendingQueries[queryHash] = promise.then(function (data) {
		          return options.afterFindAll.call(data, options, data);
		        }).then(function (data) {
		          // Query is no longer pending
		          delete resource.pendingQueries[queryHash];
		          if (options.cacheResponse) {
		            // inject the items into the data store
		            resource.queryData[queryHash] = processResults.call(_this, data, resourceName, queryHash, options);
		            resource.queryData[queryHash].$$injected = true;
		            return resource.queryData[queryHash];
		          } else {
		            DSUtils.forEach(data, function (item, i) {
		              data[i] = definition.createInstance(item, options.orig());
		            });
		            return data;
		          }
		        });
		      }
		
		      return resource.pendingQueries[queryHash];
		    } else {
		      // resolve immediately with the items
		      return items;
		    }
		  }).then(function (items) {
		    return DSUtils.respond(items, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    if (resource) {
		      delete resource.pendingQueries[queryHash];
		    }
		    return _this.errorFn('findAll', resourceName, params, options)(err);
		  });
		};
	
	/***/ },
	/* 53 */
	/***/ function(module, exports) {
	
		'use strict';
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		/**
		 * Load the specified relations for the given instance.
		 *
		 * @param resourceName The name of the type of resource of the instance for which to load relations.
		 * @param instance The instance or the primary key of the instance.
		 * @param relations An array of the relations to load.
		 * @param options Optional configuration.
		 * @returns The instance, now with its relations loaded.
		 */
		module.exports = function loadRelations(resourceName, instance, relations, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var _options = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (DSUtils._sn(instance)) {
		      instance = definition.get(instance);
		    }
		
		    if (DSUtils._s(relations)) {
		      relations = [relations];
		    }
		
		    relations = relations || [];
		
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else if (!DSUtils._o(instance)) {
		      reject(new DSErrors.IA('"instance(id)" must be a string, number or object!'));
		    } else if (!DSUtils._a(relations)) {
		      reject(new DSErrors.IA('"relations" must be a string or an array!'));
		    } else {
		      (function () {
		        _options = DSUtils._(definition, options);
		        _options.logFn('loadRelations', instance, relations, _options);
		
		        var tasks = [];
		
		        DSUtils.forEach(definition.relationList, function (def) {
		          var relationName = def.relation;
		          var relationDef = definition.getResource(relationName);
		          var __options = DSUtils._(relationDef, options);
		
		          // relations can be loaded based on resource name or field name
		          if (!relations.length || DSUtils.contains(relations, relationName) || DSUtils.contains(relations, def.localField)) {
		            var task = undefined;
		            var params = {};
		            if (__options.allowSimpleWhere) {
		              params[def.foreignKey] = instance[definition.idAttribute];
		            } else {
		              params.where = {};
		              params.where[def.foreignKey] = {
		                '==': instance[definition.idAttribute]
		              };
		            }
		
		            var orig = __options.orig();
		            var defKey = def.localKey ? DSUtils.get(instance, def.localKey) : null;
		            var hasDefKey = !!(defKey || defKey === 0);
		
		            if (typeof def.load === 'function') {
		              task = def.load(definition, def, instance, orig);
		            } else {
		              if (def.type === 'hasMany') {
		                if (def.localKeys) {
		                  delete params[def.foreignKey];
		                  var keys = DSUtils.get(instance, def.localKeys) || [];
		                  keys = DSUtils._a(keys) ? keys : DSUtils.keys(keys);
		                  params.where = _defineProperty({}, relationDef.idAttribute, {
		                    'in': keys
		                  });
		                  orig.localKeys = keys;
		                } else if (def.foreignKeys) {
		                  delete params[def.foreignKey];
		                  params.where = _defineProperty({}, def.foreignKeys, {
		                    contains: instance[definition.idAttribute]
		                  });
		                }
		                task = relationDef.findAll(params, orig);
		              } else if (def.type === 'hasOne') {
		                if (def.localKey && hasDefKey) {
		                  task = relationDef.find(defKey, orig);
		                } else if (def.foreignKey) {
		                  task = relationDef.findAll(params, orig).then(function (hasOnes) {
		                    return hasOnes.length ? hasOnes[0] : null;
		                  });
		                }
		              } else if (hasDefKey) {
		                task = relationDef.find(defKey, orig);
		              }
		            }
		
		            if (task) {
		              if (!_options.linkRelations) {
		                task = task.then(function (data) {
		                  instance[def.localField] = data;
		                });
		              }
		              tasks.push(task);
		            }
		          }
		        });
		
		        resolve(tasks);
		      })();
		    }
		  }).then(function (tasks) {
		    return DSUtils.Promise.all(tasks);
		  }).then(function () {
		    return _options.afterLoadRelations.call(instance, _options, instance);
		  }).catch(_this.errorFn('loadRelations', resourceName, instance, relations, options));
		};
	
	/***/ },
	/* 54 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/**
		 * Find expired items of the specified resource type and perform the configured action.
		 *
		 * @param resourceName The name of the type of resource of the items to reap.
		 * @param options Optional configuration.
		 * @returns The reaped items.
		 */
		module.exports = function reap(resourceName, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else {
		      options = DSUtils._(definition, options);
		      if (!options.hasOwnProperty('notify')) {
		        options.notify = false;
		      }
		      options.logFn('reap', options);
		      var items = [];
		      var now = new Date().getTime();
		      var expiredItem = undefined;
		
		      // find the expired items
		      while ((expiredItem = resource.expiresHeap.peek()) && expiredItem.expires < now) {
		        items.push(expiredItem.item);
		        delete expiredItem.item;
		        resource.expiresHeap.pop();
		      }
		      resolve(items);
		    }
		  }).then(function (items) {
		    // only hit lifecycle if there are items
		    if (items.length) {
		      definition.beforeReap(options, items);
		      if (options.notify) {
		        definition.emit('DS.beforeReap', definition, items);
		      }
		    }
		
		    if (options.reapAction === 'inject') {
		      (function () {
		        var timestamp = new Date().getTime();
		        DSUtils.forEach(items, function (item) {
		          resource.expiresHeap.push({
		            item: item,
		            timestamp: timestamp,
		            expires: definition.maxAge ? timestamp + definition.maxAge : Number.MAX_VALUE
		          });
		        });
		      })();
		    } else if (options.reapAction === 'eject') {
		      DSUtils.forEach(items, function (item) {
		        definition.eject(item[definition.idAttribute]);
		      });
		    } else if (options.reapAction === 'refresh') {
		      var _ret2 = function () {
		        var tasks = [];
		        DSUtils.forEach(items, function (item) {
		          tasks.push(definition.refresh(item[definition.idAttribute]));
		        });
		        return {
		          v: DSUtils.Promise.all(tasks)
		        };
		      }();
		
		      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
		    }
		    return items;
		  }).then(function (items) {
		    // only hit lifecycle if there are items
		    if (items.length) {
		      definition.afterReap(options, items);
		      if (options.notify) {
		        definition.emit('DS.afterReap', definition, items);
		      }
		    }
		    return items;
		  }).catch(_this.errorFn('reap', resourceName, options));
		};
	
	/***/ },
	/* 55 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/**
		 * Save a single item in its present state.
		 *
		 * @param resourceName The name of the type of resource of the item.
		 * @param id The primary key of the item.
		 * @param options Optional congifuration.
		 * @returns The item, now saved.
		 */
		module.exports = function save(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var item = undefined,
		      noChanges = undefined,
		      adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    id = DSUtils.resolveId(definition, id);
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else if (!definition.get(id)) {
		      reject(new DSErrors.R('id "' + id + '" not found in cache!'));
		    } else {
		      item = definition.get(id);
		      options = DSUtils._(definition, options);
		      options.logFn('save', id, options);
		      resolve(item);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeUpdate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeUpdate', definition, attrs);
		    }
		    // only send changed properties to the adapter
		    if (options.changesOnly) {
		      var key;
		
		      var _ret = function () {
		        if (resource.observers[id] && typeof resource.observers[id] === 'function') {
		          resource.observers[id].deliver();
		        }
		        var toKeep = [];
		        var changes = definition.changes(id);
		
		        for (key in changes.added) {
		          toKeep.push(key);
		        }
		        for (key in changes.changed) {
		          toKeep.push(key);
		        }
		        DSUtils.forEach(options.always, function (property) {
		          toKeep.push(property);
		        });
		        changes = DSUtils.pick(attrs, toKeep);
		        // no changes? no save
		        if (DSUtils.isEmpty(changes)) {
		          // no changes, return
		          options.logFn('save - no changes', id, options);
		          noChanges = true;
		          return {
		            v: attrs
		          };
		        } else {
		          attrs = changes;
		        }
		      }();
		
		      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].update(definition, id, DSUtils.omit(attrs, options.omit), options);
		  }).then(function (data) {
		    return options.afterUpdate.call(data, options, data);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.afterUpdate', definition, attrs);
		    }
		    if (noChanges) {
		      // no changes, just return
		      return attrs;
		    } else if (options.cacheResponse) {
		      // inject the reponse into the store, updating the item
		      var injected = definition.inject(attrs, options.orig());
		      // mark the item as "saved"
		      resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		      if (!definition.resetHistoryOnInject) {
		        resource.previousAttributes[id] = DSUtils.copy(injected, null, null, null, definition.relationFields);
		      }
		      return injected;
		    } else {
		      // just return an instance
		      return definition.createInstance(attrs, options.orig());
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  }).catch(_this.errorFn('save', resourceName, id, options));
		};
	
	/***/ },
	/* 56 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Update a single item using the supplied properties hash.
		 *
		 * @param resourceName The name of the type of resource of the item to update.
		 * @param id The primary key of the item to update.
		 * @param attrs The attributes with which to update the item.
		 * @param options Optional configuration.
		 * @returns The item, now updated.
		 */
		module.exports = function update(resourceName, id, attrs, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    id = DSUtils.resolveId(definition, id);
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('update', id, attrs, options);
		      resolve(attrs);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeUpdate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeUpdate', definition, attrs);
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].update(definition, id, DSUtils.omit(attrs, options.omit), options);
		  }).then(function (data) {
		    return options.afterUpdate.call(data, options, data);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.afterUpdate', definition, attrs);
		    }
		    if (options.cacheResponse) {
		      // inject the updated item into the store
		      var injected = definition.inject(attrs, options.orig());
		      var resource = _this.store[resourceName];
		      var _id = injected[definition.idAttribute];
		      // mark the item as "saved"
		      resource.saved[_id] = DSUtils.updateTimestamp(resource.saved[_id]);
		      if (!definition.resetHistoryOnInject) {
		        resource.previousAttributes[_id] = DSUtils.copy(injected, null, null, null, definition.relationFields);
		      }
		      return injected;
		    } else {
		      // just return an instance
		      return definition.createInstance(attrs, options.orig());
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  }).catch(_this.errorFn('update', resourceName, id, attrs, options));
		};
	
	/***/ },
	/* 57 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/**
		 * Update a collection of items using the supplied properties hash.
		 *
		 * @param resourceName The name of the type of resource of the items to update.
		 * @param attrs  The attributes with which to update the item.
		 * @param params The criteria by which to select items to update. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @returns The updated items.
		 */
		module.exports = function updateAll(resourceName, attrs, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('updateAll', attrs, params, options);
		      DSUtils.applyScope(definition, params, options);
		      resolve(attrs);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeUpdate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeUpdate', definition, attrs);
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].updateAll(definition, DSUtils.omit(attrs, options.omit), params, options);
		  }).then(function (data) {
		    return options.afterUpdate.call(data, options, data);
		  }).then(function (data) {
		    if (options.notify) {
		      definition.emit('DS.afterUpdate', definition, attrs);
		    }
		    var origOptions = options.orig();
		    if (options.cacheResponse) {
		      var _ret = function () {
		        // inject the updated items into the store
		        var injected = definition.inject(data, origOptions);
		        var resource = _this.store[resourceName];
		        // mark the items as "saved"
		        DSUtils.forEach(injected, function (i) {
		          var id = i[definition.idAttribute];
		          resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		          if (!definition.resetHistoryOnInject) {
		            resource.previousAttributes[id] = DSUtils.copy(i, null, null, null, definition.relationFields);
		          }
		        });
		        return {
		          v: injected
		        };
		      }();
		
		      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    } else {
		      var _ret2 = function () {
		        // just return instances
		        var instances = [];
		        DSUtils.forEach(data, function (item) {
		          instances.push(definition.createInstance(item, origOptions));
		        });
		        return {
		          v: instances
		        };
		      }();
		
		      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
		    }
		  }).then(function (items) {
		    return DSUtils.respond(items, { adapter: adapter }, options);
		  }).catch(_this.errorFn('updateAll', resourceName, attrs, params, options));
		};
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=js-data-debug.js.map

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(646);

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(647);
	var utils = __webpack_require__(648);
	var dispatchRequest = __webpack_require__(650);
	var InterceptorManager = __webpack_require__(660);
	var isAbsoluteURL = __webpack_require__(661);
	var combineURLs = __webpack_require__(662);
	var bind = __webpack_require__(663);
	var transformData = __webpack_require__(655);
	
	function Axios(defaultConfig) {
	  this.defaults = utils.merge({}, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	var defaultInstance = new Axios(defaults);
	var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
	axios.request = bind(Axios.prototype.request, defaultInstance);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Expose properties from defaultInstance
	axios.defaults = defaultInstance.defaults;
	axios.interceptors = defaultInstance.interceptors;
	
	// Factory for creating new instances
	axios.create = function create(defaultConfig) {
	  return new Axios(defaultConfig);
	};
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(664);
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	var normalizeHeaderName = __webpack_require__(649);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	module.exports = {
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};


/***/ },
/* 648 */
/***/ function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function executor(resolve, reject) {
	    try {
	      var adapter;
	
	      if (typeof config.adapter === 'function') {
	        // For custom adapter support
	        adapter = config.adapter;
	      } else if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = __webpack_require__(652);
	      } else if (typeof process !== 'undefined') {
	        // For node use HTTP adapter
	        adapter = __webpack_require__(652);
	      }
	
	      if (typeof adapter === 'function') {
	        adapter(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(651)))

/***/ },
/* 651 */,
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	var buildURL = __webpack_require__(653);
	var parseHeaders = __webpack_require__(654);
	var transformData = __webpack_require__(655);
	var isURLSameOrigin = __webpack_require__(656);
	var btoa = (typeof window !== 'undefined' && window.btoa) || __webpack_require__(657);
	var settle = __webpack_require__(658);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  var requestData = config.data;
	  var requestHeaders = config.headers;
	
	  if (utils.isFormData(requestData)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  var request = new XMLHttpRequest();
	  var loadEvent = 'onreadystatechange';
	  var xDomain = false;
	
	  // For IE 8/9 CORS support
	  // Only supports POST and GET calls and doesn't returns the response headers.
	  // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	  if (("production") !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
	    request = new window.XDomainRequest();
	    loadEvent = 'onload';
	    xDomain = true;
	    request.onprogress = function handleProgress() {};
	    request.ontimeout = function handleTimeout() {};
	  }
	
	  // HTTP basic authentication
	  if (config.auth) {
	    var username = config.auth.username || '';
	    var password = config.auth.password || '';
	    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	  }
	
	  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request[loadEvent] = function handleLoad() {
	    if (!request || (request.readyState !== 4 && !xDomain)) {
	      return;
	    }
	
	    // The request errored out and we didn't get a response, this will be
	    // handled by onerror instead
	    if (request.status === 0) {
	      return;
	    }
	
	    // Prepare the response
	    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	    var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	    var response = {
	      data: transformData(
	        responseData,
	        responseHeaders,
	        config.transformResponse
	      ),
	      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	      status: request.status === 1223 ? 204 : request.status,
	      statusText: request.status === 1223 ? 'No Content' : request.statusText,
	      headers: responseHeaders,
	      config: config,
	      request: request
	    };
	
	    settle(resolve, reject, response);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle low level network errors
	  request.onerror = function handleError() {
	    // Real errors are hidden from us by the browser
	    // onerror should only fire if it's a network error
	    reject(new Error('Network Error'));
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle timeout
	  request.ontimeout = function handleTimeout() {
	    var err = new Error('timeout of ' + config.timeout + 'ms exceeded');
	    err.timeout = config.timeout;
	    err.code = 'ECONNABORTED';
	    reject(err);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(659);
	
	    // Add xsrf header
	    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  if ('setRequestHeader' in request) {
	    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	        // Remove Content-Type if data is undefined
	        delete requestHeaders[key];
	      } else {
	        // Otherwise add header to the request
	        request.setRequestHeader(key, val);
	      }
	    });
	  }
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  // Handle progress if needed
	  if (config.progress) {
	    if (config.method === 'post' || config.method === 'put') {
	      request.upload.addEventListener('progress', config.progress);
	    } else if (config.method === 'get') {
	      request.addEventListener('progress', config.progress);
	    }
	  }
	
	  if (requestData === undefined) {
	    requestData = null;
	  }
	
	  // Send the request
	  request.send(requestData);
	};


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 657 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 658 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(response);
	  }
	};


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(648);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 661 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 662 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 663 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 664 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 665 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var RadniNalog = function RadniNalog(DS) {
	    return DS.defineResource({
	        name: 'RadniNalog',
	        endpoint: '/radniNalozi'
	    });
	};
	
	RadniNalog.$inject = ['DS'];
	
	var PlanRada = function PlanRada(DS) {
	    return DS.defineResource({
	        name: 'PlanRada',
	        endpoint: '/planRada'
	    });
	};
	
	PlanRada.$inject = ['DS'];
	
	exports.PlanRada = PlanRada;
	exports.RadniNalog = RadniNalog;

/***/ },
/* 666 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Ordinacija = function Ordinacija(DS) {
	    return DS.defineResource({
	        name: 'Ordinacija',
	        endpoint: '/ordinacije'
	    });
	};
	
	Ordinacija.$inject = ['DS'];
	
	exports.Ordinacija = Ordinacija;

/***/ },
/* 667 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Tehnicar = function Tehnicar(DS) {
	    return DS.defineResource({
	        name: 'Tehnicar',
	        endpoint: '/tehnicari'
	    });
	};
	
	Tehnicar.$inject = ['DS'];
	
	exports.Tehnicar = Tehnicar;

/***/ },
/* 668 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Valuta = function Valuta(DS) {
	    return DS.defineResource({
	        name: 'Valuta',
	        endpoint: '/valute'
	    });
	};
	
	Valuta.$inject = ['DS'];
	
	exports.Valuta = Valuta;

/***/ },
/* 669 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var PoreznaStopa = function PoreznaStopa(DS) {
	    return DS.defineResource({
	        name: 'PoreznaStopa',
	        endpoint: '/porezneStope'
	    });
	};
	
	PoreznaStopa.$inject = ['DS'];
	
	exports.PoreznaStopa = PoreznaStopa;

/***/ },
/* 670 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var ProtetskiRad = function ProtetskiRad(DS) {
	    return DS.defineResource({
	        name: 'ProtetskiRad',
	        endpoint: '/protetskiRadovi'
	    });
	};
	
	ProtetskiRad.$inject = ['DS'];
	
	exports.ProtetskiRad = ProtetskiRad;

/***/ },
/* 671 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Cjenik = function Cjenik(DS) {
	
	    return DS.defineResource({
	        name: 'Cjenik',
	        endpoint: '/cjenici'
	    });
	};
	
	// methods: {
	//     getNazivValute: function() {
	//         let id = this.valuta;
	//         return DS.find('Valuta', id).then((item) => {
	//             return item.valuta;
	//         });
	
	//         // return DS.get('Valuta', id).valuta;
	//     }
	// },
	// relations: {
	//     belongsTo: {
	//         Valuta: {
	//             localField: 'valuta',
	//             localKey: 'valuta_id'
	//         }
	//     }
	// }
	
	Cjenik.$inject = ['DS'];
	
	exports.Cjenik = Cjenik;

/***/ },
/* 672 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var StavkaCjenika = function StavkaCjenika(DS) {
	    return DS.defineResource({
	        name: 'StavkaCjenika',
	        endpoint: '/stavkeCjenika'
	    });
	};
	
	StavkaCjenika.$inject = ['DS'];
	
	exports.StavkaCjenika = StavkaCjenika;

/***/ },
/* 673 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Boja = function Boja(DS) {
	
	    return DS.defineResource({
	        name: 'Boja',
	        endpoint: '/boje'
	    });
	};
	
	Boja.$inject = ['DS'];
	
	exports.Boja = Boja;

/***/ },
/* 674 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var OznakaBoje = function OznakaBoje(DS) {
	
	    return DS.defineResource({
	        name: 'OznakaBoje',
	        endpoint: '/oznakeBoja'
	    });
	};
	
	OznakaBoje.$inject = ['DS'];
	
	exports.OznakaBoje = OznakaBoje;

/***/ },
/* 675 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var FazaNaloga = function FazaNaloga(DS) {
	    return DS.defineResource({
	        name: 'FazaNaloga',
	        endpoint: '/fazeNaloga'
	    });
	};
	
	FazaNaloga.$inject = ['DS'];
	
	exports.FazaNaloga = FazaNaloga;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var StavkaNaloga = function StavkaNaloga(DS) {
	    return DS.defineResource({
	        name: 'StavkaNaloga',
	        endpoint: '/stavkeNaloga',
	        methods: {
	            group: function group(stavke) {
	                var groupedStavke = [];
	                stavke.map(function (stavka) {
	                    var item = _lodash2['default'].find(groupedStavke, { protetski_rad: stavka.protetski_rad, cjenik: stavka.cjenik });
	                    if (_lodash2['default'].isUndefined(item)) {
	                        item = {
	                            protetski_rad: stavka.protetski_rad,
	                            cjenik: stavka.cjenik,
	                            pozicije: [stavka.pozicija]
	                        };
	                        groupedStavke.push(item);
	                        return;
	                    }
	                    item.pozicije.push(stavka.pozicija);
	                });
	                return groupedStavke;
	            }
	        }
	    });
	};
	
	StavkaNaloga.$inject = ['DS'];
	
	exports.StavkaNaloga = StavkaNaloga;

/***/ },
/* 677 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var KorisnikOrdinacija = function KorisnikOrdinacija(DS) {
	    return DS.defineResource({
	        name: 'KorisnikOrdinacija',
	        endpoint: '/korisnikOrdinacija'
	    });
	};
	
	KorisnikOrdinacija.$inject = ['DS'];
	
	exports.KorisnikOrdinacija = KorisnikOrdinacija;

/***/ },
/* 678 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Materijal = function Materijal(DS) {
	    return DS.defineResource({
	        name: 'Materijal',
	        endpoint: '/materijali'
	    });
	};
	
	Materijal.$inject = ['DS'];
	
	exports.Materijal = Materijal;

/***/ },
/* 679 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var GrupaRada = function GrupaRada(DS) {
	    return DS.defineResource({
	        name: 'GrupaRada',
	        endpoint: '/grupeRadova'
	    });
	};
	
	GrupaRada.$inject = ['DS'];
	
	exports.GrupaRada = GrupaRada;

/***/ },
/* 680 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var VrstaRada = function VrstaRada(DS) {
	    return DS.defineResource({
	        name: 'VrstaRada',
	        endpoint: '/vrsteRadova'
	    });
	};
	
	VrstaRada.$inject = ['DS'];
	
	exports.VrstaRada = VrstaRada;

/***/ },
/* 681 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var DokumentNaloga = function DokumentNaloga(DS) {
	    return DS.defineResource({
	        name: 'DokumentNaloga',
	        endpoint: '/dokumentNaloga'
	    });
	};
	
	DokumentNaloga.$inject = ['DS'];
	
	exports.DokumentNaloga = DokumentNaloga;

/***/ },
/* 682 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Token = function Token(DS) {
	    return DS.defineResource({
	        name: 'Token',
	        endpoint: '/token'
	    });
	};
	
	Token.$inject = ['DS'];
	
	exports.Token = Token;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var config = function config($stateProvider, $urlRouterProvider, AppConfigurationProvider, datetimepickerProvider) {
	    var acp = AppConfigurationProvider;
	
	    _moment2['default'].locale('hr');
	
	    datetimepickerProvider.setOptions({ format: 'DD.MM.YYYY', locale: 'hr' });
	
	    $urlRouterProvider.otherwise('/dashboard');
	
	    var app = acp.application('DentalLab');
	
	    app.addEntity(acp.entity('dashboard'));
	    app.addEntity(acp.entity('Tehnicar').label('Tehničar'));
	    app.addEntity(acp.entity('Valuta').label('Valuta'));
	    app.addEntity(acp.entity('PoreznaStopa').label('Porezna stopa'));
	    app.addEntity(acp.entity('ProtetskiRad').label('Protetski rad'));
	    app.addEntity(acp.entity('Cjenik').label('Cjenik'));
	    app.addEntity(acp.entity('StavkaCjenika').label('Stavka cjenika'));
	    app.addEntity(acp.entity('Ordinacija').label('Ordinacija'));
	    app.addEntity(acp.entity('RadniNalog').label('Radni nalog'));
	    app.addEntity(acp.entity('StavkaNaloga').label('Stavka naloga'));
	    app.addEntity(acp.entity('Boja').label('Boja'));
	    app.addEntity(acp.entity('OznakaBoje').label('Oznaka boje'));
	    app.addEntity(acp.entity('FazaNaloga').label('Faza naloga'));
	    app.addEntity(acp.entity('KorisnikOrdinacija').label('Korisnici'));
	    app.addEntity(acp.entity('Materijal').label('Materijal'));
	    app.addEntity(acp.entity('VrstaRada').label('Vrsta rada'));
	    app.addEntity(acp.entity('GrupaRada').label('Grupa rada'));
	    app.addEntity(acp.entity('Komentar').label('Komentar'));
	
	    acp.configure(app);
	
	    __webpack_require__(684)(acp, app);
	    __webpack_require__(685)(acp, app);
	    __webpack_require__(686)(acp, app);
	    __webpack_require__(687)(acp, app);
	    __webpack_require__(688)(acp, app);
	    __webpack_require__(689)(acp, app);
	    __webpack_require__(690)(acp, app);
	    __webpack_require__(691)(acp, app);
	    __webpack_require__(692)(acp, app);
	    __webpack_require__(693)(acp, app);
	    __webpack_require__(694)(acp, app);
	    __webpack_require__(695)(acp, app);
	    __webpack_require__(696)(acp, app);
	    __webpack_require__(697)(acp, app);
	    __webpack_require__(698)(acp, app);
	    __webpack_require__(699)(acp, app);
	    __webpack_require__(700)(acp, app);
	
	    __webpack_require__(701)($stateProvider);
	    __webpack_require__(702)($stateProvider);
	    __webpack_require__(703)($stateProvider);
	    __webpack_require__(704)($stateProvider);
	    __webpack_require__(705)($stateProvider);
	    __webpack_require__(706)($stateProvider);
	};
	
	var run = function run($rootScope, $state, djangoAuth, AppConfiguration, $transitions) {
	    djangoAuth.initialize('/rest-auth', true);
	
	    var match = {
	        to: function to(state) {
	            // return state.data != null && state.data.authRequired === true;
	            return state.name !== 'login';
	        }
	    };
	
	    $transitions.onStart(match, function (trans) {
	        djangoAuth.authenticationStatus(true).then(function () {
	            return djangoAuth.profile();
	        }).then(function (response) {
	            $rootScope.user = response;
	        })['catch'](function () {
	            return $state.go('login');
	        });
	        return true;
	    });
	
	    // $rootScope.$state = $state;
	
	    var app = AppConfiguration();
	    app.menu(__webpack_require__(707)(AppConfiguration, $state));
	};
	
	run.$inject = ['$rootScope', '$state', 'djangoAuth', 'AppConfiguration', '$transitions'];
	config.$inject = ['$stateProvider', '$urlRouterProvider', 'AppConfigurationProvider', 'datetimepickerProvider'];
	
	exports.config = config;
	exports.run = run;

/***/ },
/* 684 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var dashboard = app.getEntity('dashboard');
	    dashboard.listView().fields([ac.field('sifra_naloga').label('Šifra naloga'), ac.field('pacijent'), ac.field('ordinacija', 'reference').targetEntity(app.getEntity('Ordinacija')).targetField(ac.field('naziv'))]).listActions(['edit']);
	
	    return dashboard;
	};
	
	module.exports = exports['default'];

/***/ },
/* 685 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var tehnicar = app.getEntity('Tehnicar');
	    tehnicar.listView().title('Tehničari').icon('<i class="fa fa-users fa-3x"></i>').fields([ac.field('naziv', 'template').label('Naziv').template(function (entry) {
	        return entry.prezime + ' ' + entry.ime;
	    }).cssClasses(['col-md-11'])]).listActions(['edit', 'delete']);
	
	    tehnicar.editionView().title('Tehničar').fields([{
	        key: 'prezime',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Prezime',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'ime',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Ime',
	            required: true
	        }
	    }]);
	
	    return tehnicar;
	};
	
	module.exports = exports['default'];

/***/ },
/* 686 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var valuta = app.getEntity('Valuta');
	
	    valuta.listView().title('Valute').icon('<i class="fa fa-eur fa-3x"></i>').fields([ac.field('valuta').cssClasses(['col-md-6']), ac.field('sifra').label('Šifra').cssClasses(['col-md-5'])]).listActions(['edit', 'delete']);
	
	    valuta.editionView().title('Valuta').fields([{
	        key: 'valuta',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Valuta',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'sifra',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Šifra',
	            required: true
	        }
	    }]);
	
	    return valuta;
	};
	
	module.exports = exports['default'];

/***/ },
/* 687 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var poreznaStopa = app.getEntity('PoreznaStopa');
	
	    poreznaStopa.listView().title('Porezne stope').icon('<i class="fa fa-bar-chart fa-3x"></i>').fields([ac.field('naziv').label('Naziv stope').cssClasses(['col-md-3']), ac.field('stopa').cssClasses(['col-md-2']), ac.field('vazi_od', 'date').label('Važi od').cssClasses(['col-md-3']), ac.field('vazi_do', 'date').label('Važi do').cssClasses(['col-md-3'])]).listActions(['edit', 'delete']);
	
	    poreznaStopa.editionView().title('Porezna stopa').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv stope',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'stopa',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Stopa(%)',
	            required: true
	        }
	    }, {
	        key: 'vazi_od',
	        type: 'hDatepicker',
	        templateOptions: {
	            label: 'Važi od',
	            required: true
	        }
	    }, {
	        key: 'vazi_do',
	        type: 'hDatepicker',
	        templateOptions: {
	            label: 'Važi do'
	        }
	    }]);
	
	    return poreznaStopa;
	};
	
	module.exports = exports['default'];

/***/ },
/* 688 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var protetskiRad = app.getEntity('ProtetskiRad');
	
	    protetskiRad.listView().title('Protetski radovi').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv').cssClasses(['col-md-4']),
	    // ac.field('tip')
	    //     .cssClasses(['col-md-2']),
	    ac.field('materijal', 'reference').label('Materijal').targetEntity(app.getEntity('Materijal')).targetField(ac.field('naziv')).cssClasses(['col-md-2']), ac.field('vrsta_rada', 'reference').label('Vrsta rada').targetEntity(app.getEntity('VrstaRada')).targetField(ac.field('naziv')).cssClasses(['col-md-2'])]).listActions(['edit', 'delete']);
	
	    protetskiRad.editionView().title('Protetski rad').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    },
	    // {
	    //     key: "tip",
	    //     type: "hSelect",
	    //     templateOptions: {
	    //         label: "Tip rada",
	    //         options: [
	    //             {
	    //                 name: "Fiksna",
	    //                 value: "F"
	    //             },
	    //             {
	    //                 name: "Mobilna",
	    //                 value: "M"
	    //             }
	    //         ]
	    //     }
	    // },
	
	    {
	        key: 'materijal',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Materijal',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite materijal',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Materijal').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'vrsta_rada',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Vrsta rada',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite vrstu rada',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('VrstaRada').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }]);
	
	    return protetskiRad;
	};
	
	module.exports = exports['default'];

/***/ },
/* 689 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var cjenik = app.getEntity('Cjenik');
	
	    cjenik.listView().title('Cjenici').icon('<i class="fa fa-money fa-3x"></i>');
	
	    cjenik.editionView().title('Cjenik').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv cjenika',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'valuta',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Valuta',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'valuta',
	            placeholder: 'Odaberite valutu',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            $scope.to.options = DS.getAll('Valuta');
	            DS.findAll('Valuta').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }]);
	
	    var stavkaCjenika = app.getEntity('StavkaCjenika');
	
	    stavkaCjenika.listView().title(function (entry) {
	        return 'Cjenik ' + entry.naziv;
	    }).description('Registar cjenika').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('protetski_rad', 'reference').label('Naziv protetskog rada / usluge ').targetEntity(app.getEntity('ProtetskiRad')).targetField(ac.field('naziv')), ac.field('porezna_stopa', 'reference').label('Porezna tarifa').targetEntity(app.getEntity('PoreznaStopa')).targetField(ac.field('naziv', 'template').template(function (entry) {
	        return '' + entry.naziv;
	    })), ac.field('iznos')]).listActions(['edit', 'delete']);
	
	    stavkaCjenika.creationView().title('Unos nove stavke cjenika').fields([{
	        key: 'protetski_rad',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Protetski rad',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite uslugu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('ProtetskiRad').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'porezna_stopa',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Porezna stopa',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite stopu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('PoreznaStopa').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'iznos',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Iznos'
	        }
	    }]);
	
	    return cjenik;
	};
	
	module.exports = exports['default'];

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _commonFormsLayoutJs = __webpack_require__(523);
	
	var _commonConfigurationViewListViewJs = __webpack_require__(419);
	
	var _commonConfigurationViewListViewJs2 = _interopRequireDefault(_commonConfigurationViewListViewJs);
	
	var fields = {
	    naziv: {
	        key: 'naziv',
	        type: 'input',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    },
	    oib: {
	        key: 'oib',
	        type: 'input',
	        templateOptions: {
	            label: 'OIB'
	        }
	    },
	    radno_vrijeme: {
	        key: 'radno_vrijeme',
	        type: 'input',
	        templateOptions: {
	            label: 'Radno vrijeme'
	        }
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena'
	        }
	    },
	    adresa: {
	        key: 'adresa',
	        type: 'input',
	        templateOptions: {
	            label: 'Adresa'
	        }
	    },
	    postanski_broj: {
	        key: 'postanski_broj',
	        type: 'input',
	        templateOptions: {
	            label: 'Poštanski broj'
	        }
	    },
	    mjesto: {
	        key: 'mjesto',
	        type: 'input',
	        templateOptions: {
	            label: 'Mjesto'
	        }
	    },
	    telefon: {
	        key: 'telefon',
	        type: 'input',
	        templateOptions: {
	            label: 'Telefon'
	        }
	    },
	    email: {
	        key: 'email',
	        type: 'input',
	        templateOptions: {
	            label: 'E-mail'
	        }
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var ordinacija = app.getEntity('Ordinacija');
	    var nalozi = app.getEntity('RadniNalog');
	    var view = new _commonConfigurationViewListViewJs2['default']();
	    view.setEntity(nalozi);
	    view.fields([ac.field('datum_naloga', 'date').label('Datum naloga').cssClasses(['col-lg-3']), ac.field('pacijent', 'template').cssClasses(['col-lg-4']).template(function (entry) {
	        return entry.pacijent + '<br><small><i class="fa fa-clock-o"></i> Status: <strong>' + entry.status + '</strong></small>';
	    }), ac.field('broj_naloga', 'template').label('Broj naloga').cssClasses(['col-lg-2', 'text-right']).template(function (entry) {
	        return '<a ui-sref="radniNalog.details({id: entry.id})" class="btn btn-xs btn-success " type="button"><i class="fa fa-search"></i> {{entry.sifra_naloga}}</a>';
	    })]);
	
	    nalozi.views['OrdinacijaViews'] = view;
	
	    // poreznaStopa.listView()
	    //     .title('Porezne stope')
	    //     .icon('<i class="fa fa-bar-chart fa-3x"></i>')
	    //     .fields([
	    //         ac.field('naziv')
	    //             .label('Naziv stope')
	    //             .cssClasses(['col-md-3']),
	    //         ac.field('stopa')
	    //             .cssClasses(['col-md-2']),
	    //         ac.field('vazi_od', 'date')
	    //             .label('Važi od')
	    //             .cssClasses(['col-md-3']),
	    //         ac.field('vazi_do', 'date')
	    //             .label('Važi do')
	    //             .cssClasses(['col-md-3']),
	    //     ])
	    //     .listActions([
	    //         'edit',
	    //         'delete'
	    //     ]);
	
	    ordinacija.creationView().title('Ordinacije').fields([[(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column9)([fields.naziv])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column3)([fields.oib]), (0, _commonFormsLayoutJs.Column9)([fields.radno_vrijeme])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.napomena])])], [(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column6)([fields.adresa]), (0, _commonFormsLayoutJs.Column3)([fields.postanski_broj]), (0, _commonFormsLayoutJs.Column3)([fields.mjesto])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.telefon]), (0, _commonFormsLayoutJs.Column8)([fields.email])]), { template: '<hr/>' }]]);
	
	    return ordinacija;
	};
	
	module.exports = exports['default'];

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _commonFormsLayoutJs = __webpack_require__(523);
	
	var fields = {
	    ordinacija: {
	        key: 'ordinacija',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Ordinacija',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite ordinaciju',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Ordinacija').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    datum_naloga: {
	        key: 'datum_naloga',
	        type: 'datepicker',
	        templateOptions: {
	            label: 'Datum naloga'
	        }
	    },
	    pacijent: {
	        key: 'pacijent',
	        type: 'input',
	        templateOptions: {
	            required: true,
	            label: 'Pacijent',
	            focus: true
	        }
	    },
	    spol: {
	        key: 'spol',
	        type: 'uiSelect',
	        templateOptions: {
	            required: true,
	            label: 'Spol',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite spol',
	            options: [{ id: 'M', naziv: 'M' }, { id: 'Ž', naziv: 'Ž' }]
	        }
	    },
	    godina_rodjenja: {
	        key: 'godina_rodjenja',
	        type: 'input',
	        templateOptions: {
	            label: 'Godina rođenja',
	            type: 'number'
	        }
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena',
	            rows: 4
	        }
	    },
	    boja: {
	        key: 'boja',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Boja',
	            required: true,
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'naziv',
	            labelProp: 'naziv',
	            // placeholder: 'Odaberite boju',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Boja').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    oznaka_boje: {
	        key: 'oznaka_boje',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Oznaka',
	            required: true,
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'oznaka',
	            labelProp: 'oznaka',
	            // placeholder: 'Odaberite oznaku',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('OznakaBoje').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    oblik: {
	        key: 'oblik',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Oblik',
	            required: true,
	            optionsAttr: 'bs-options',
	            valueProp: 'naziv',
	            labelProp: 'naziv',
	            // placeholder: 'Odaberite oznaku',
	            options: [{ id: '-', naziv: '-' }, { id: 'Pravokutni', naziv: 'Pravokutni' }, { id: 'Trokutasti', naziv: 'Trokutasti' }, { id: 'Ovalni', naziv: 'Ovalni' }, { id: 'Kockasti', naziv: 'Kockasti' }]
	        }
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var radniNalog = app.getEntity('RadniNalog');
	    radniNalog.listView().title('Pregled radnih naloga').description('Evidencija zaprimljenih radnih naloga').icon('<i class="fa fa-file-text-o fa-3x"></i>').fields([ac.field('sifra_naloga', 'template').label('Šifra naloga').template(function (entry) {
	        return '' + entry.sifra_naloga;
	    }), ac.field('pacijent').cssClasses(function (entry) {
	        return '';
	    }), ac.field('ordinacija', 'reference').targetEntity(app.getEntity('Ordinacija')).targetField(ac.field('naziv'))]).listActions(['edit']);
	
	    radniNalog.creationView().fields([[(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.datum_naloga])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.pacijent]), (0, _commonFormsLayoutJs.Column4)([fields.ordinacija])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.spol]), (0, _commonFormsLayoutJs.Column4)([fields.godina_rodjenja])])], [(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.boja]), (0, _commonFormsLayoutJs.Column12)([fields.oznaka_boje]), (0, _commonFormsLayoutJs.Column12)([fields.oblik])])], [(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.napomena])])]]);
	
	    radniNalog.editionView().fields([(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.datum_naloga])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.pacijent]), (0, _commonFormsLayoutJs.Column4)([fields.ordinacija])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.spol]), (0, _commonFormsLayoutJs.Column4)([fields.godina_rodjenja])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column3)([fields.boja]), (0, _commonFormsLayoutJs.Column3)([fields.oznaka_boje]), (0, _commonFormsLayoutJs.Column3)([fields.oblik])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.napomena])])]);
	
	    return radniNalog;
	};
	
	module.exports = exports['default'];

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _commonFormsLayoutJs = __webpack_require__(523);
	
	var fields = {
	    // vrsta_rada: {
	    //     key: 'vrsta_rada',
	    //     type: 'uiSelect',
	    //     templateOptions: {
	    //         label: 'Vrsta rada',
	    //         optionsAttr: 'bs-options',
	    //         ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	    //         valueProp: 'id',
	    //         labelProp: 'naziv',
	    //         placeholder: 'Odaberite vrstu rada',
	    //         options: [
	    //             {id: 'M', naziv: 'MOBILNA'},
	    //             {id: 'F', naziv: 'FIKSNA'}
	    //         ]
	    //     }
	    // },
	
	    materijal: {
	        key: 'materijal',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Materijal',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite materijal',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Materijal').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	
	    vrsta_rada: {
	        key: 'vrsta_rada',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Vrsta rada',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite vrstu rada',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('VrstaRada').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    // protetski_rad: {
	    //     key: 'protetski_rad',
	    //     type: 'huiSelect',
	    //     templateOptions: {
	    //         label: 'Protetski rad',
	    //         optionsAttr: 'bs-options',
	    //         ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	    //         valueProp: 'id',
	    //         labelProp: 'naziv',
	    //         placeholder: 'Odaberite uslugu',
	    //         options: [],
	    //         required: true
	    //     },
	    //     controller: ['$scope', 'DS', function ($scope, DS) {
	    //         $scope.$watch('model.vrsta_rada', function (newValue, oldValue) {
	    //             if(newValue !== oldValue) {
	    //                 if($scope.model[$scope.options.key] && oldValue) {
	    //                     $scope.model[$scope.options.key] = '';
	    //                 }
	    //             }
	    //             DS.findAll('ProtetskiRad').then(function (response) {
	    //                 $scope.to.options = response.filter((i) => i.tip === newValue);
	    //             });
	    //         });
	    //     }]
	    // },
	    protetski_rad: {
	        key: 'protetski_rad',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Protetski rad',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite uslugu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            // DS.findAll('ProtetskiRad').then(function (response) {
	            //     $scope.to.options = response;
	            // });
	
	            var radovi = undefined;
	
	            function setProtetskiRad() {
	                var vrsta_rada = $scope.model.vrsta_rada;
	                var materijal = $scope.model.materijal;
	                var opcije = [].concat(_toConsumableArray(radovi));
	
	                $scope.model[$scope.options.key] = null;
	
	                if (_lodash2['default'].isFinite(parseInt(vrsta_rada))) {
	                    opcije = opcije.filter(function (o) {
	                        return o.vrsta_rada === vrsta_rada;
	                    });
	                }
	
	                if (_lodash2['default'].isFinite(parseInt(materijal))) {
	                    opcije = opcije.filter(function (o) {
	                        return o.materijal === materijal;
	                    });
	                }
	
	                $scope.to.options = [].concat(_toConsumableArray(opcije));
	
	                if (opcije.length === 1) {
	                    $scope.model[$scope.options.key] = opcije[0].id;
	                }
	            }
	
	            DS.findAll('StavkaCjenika').then(function (stavke) {
	                if (stavke && stavke.length > 0) {
	                    DS.findAll('ProtetskiRad').then(function (protetskiRadovi) {
	                        $scope.to.options = protetskiRadovi.filter(function (i) {
	                            return _lodash2['default'].find(stavke, { protetski_rad: i.id });
	                        });
	                        radovi = [].concat(_toConsumableArray($scope.to.options));
	                    });
	                }
	            });
	
	            $scope.$watch('model.vrsta_rada', function (newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    $scope.model.materijal = null;
	                    setProtetskiRad();
	                }
	            });
	
	            $scope.$watch('model.materijal', function (newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    setProtetskiRad();
	                }
	            });
	        }]
	    },
	    kolicina: {
	        key: 'kolicina',
	        type: 'input',
	        templateOptions: {
	            label: 'Komada',
	            required: true
	        }
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena',
	            rows: 4
	        }
	    },
	    cjenik: {
	        key: 'cjenik',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Cjenik',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite cjenik',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	
	            var cjenici = undefined,
	                stavkeCjenika = undefined;
	
	            function setCjenik() {
	                var protetski_rad = parseInt($scope.model.protetski_rad);
	
	                $scope.model[$scope.options.key] = null;
	
	                if (_lodash2['default'].isFinite(protetski_rad)) {
	                    (function () {
	                        var stavke = stavkeCjenika.filter(function (s) {
	                            return s.protetski_rad === protetski_rad;
	                        });
	                        $scope.to.options = cjenici.filter(function (c) {
	                            return _lodash2['default'].find(stavke, { cjenik: c.id });
	                        });
	
	                        if ($scope.to.options.length === 1) {
	                            $scope.model[$scope.options.key] = $scope.to.options[0].id;
	                        }
	                    })();
	                }
	            }
	
	            DS.findAll('StavkaCjenika').then(function (stavke) {
	                stavkeCjenika = [].concat(_toConsumableArray(stavke));
	                DS.findAll('Cjenik').then(function (sviCjenici) {
	                    cjenici = sviCjenici.filter(function (c) {
	                        return _lodash2['default'].find(stavke, { cjenik: c.id });
	                    });
	                    $scope.to.options = [].concat(_toConsumableArray(cjenici));
	                });
	            });
	
	            $scope.$watch('model.protetski_rad', function (newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    setCjenik();
	                }
	            });
	        }]
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var stavkaNaloga = app.getEntity('StavkaNaloga');
	
	    stavkaNaloga.listView().fields([ac.field('protetski_rad', 'reference').targetEntity(app.getEntity('ProtetskiRad')).targetField(ac.field('naziv')).hidden(true), ac.field('pozicije', 'template').label('Protetski rad<br/><small>Pozicija</small>').template(function (entry) {
	        return '<protetski-pozicije></protetski-pozicije>';
	    }), ac.field('cjenik', 'reference').label('Tip rada').targetEntity(app.getEntity('Cjenik')).targetField(ac.field('naziv')), ac.field('kolicina', 'template').label('Količina').template(function (entry) {
	        return entry.pozicije.length;
	    })])
	    // .references(app.getEntity('ProtetskiRad'))
	    .
	    // ac.field('napomena', 'template')
	    //     .label('Napomena')
	    //     .template((entry) => {
	    //         return `<small>${entry.napomena}</small>`;
	    //     })
	    //     .cssClasses(['col-md-4']),
	    listActions(['delete']);;
	
	    // stavkaNaloga.creationView()
	    //     .title('Odaberite pozicije za rad')
	    //     .fields([
	    //         Row([Column4([fields.cjenik]), Column4([fields.vrsta_rada])]),
	    //         Row([Column8([fields.protetski_rad]), Column3([fields.kolicina])]),
	    //         Row([Column12([fields.napomena])])
	    //     ]);
	
	    stavkaNaloga.creationView().title('Odaberite pozicije za rad').fields([
	    // fields.vrsta_rada,
	    // fields.materijal,
	    fields.protetski_rad, fields.cjenik]);
	
	    return stavkaNaloga;
	};
	
	module.exports = exports['default'];

/***/ },
/* 693 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('Boja');
	
	    entity.listView().title('Boje').icon('<i class="fa fa-eur fa-3x"></i>').fields([ac.field('naziv').cssClasses(['col-md-11'])]).listActions(['edit', 'delete']);
	
	    entity.editionView().title('Boja').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 694 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('OznakaBoje');
	
	    entity.listView().title('Oznake boja').icon('<i class="fa fa-eur fa-3x"></i>').fields([ac.field('boja', 'reference').label('Boja').targetEntity(app.getEntity('Boja')).targetField(ac.field('naziv')).cssClasses(['col-md-9']), ac.field('oznaka').cssClasses(['col-md-2'])]).listActions(['edit', 'delete']);
	
	    entity.editionView().title('Boja').fields([{
	        key: 'boja',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Boja',
	            required: true,
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite boju',
	            options: [],
	            focus: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Boja').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'oznaka',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Oznaka',
	            required: true
	        }
	    }]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _commonFormsLayoutJs = __webpack_require__(523);
	
	var fields = {
	    datum_probe: {
	        key: 'datum_probe',
	        type: 'datepicker',
	        templateOptions: {
	            label: 'Datum probe',
	            required: true
	        }
	    },
	    termin_probe: {
	        key: 'termin_probe',
	        type: 'timepicker',
	        templateOptions: {
	            label: 'Termin',
	            required: true
	        }
	    },
	    tehnicar: {
	        key: 'tehnicar',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Tehničar',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite tehničara',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Tehnicar').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena',
	            rows: 4
	        }
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('FazaNaloga');
	    entity.listView().title('Faze naloga').fields([ac.field('datum_probe', 'date').label('Datum probe').cssClasses(['col-md-2']), ac.field('termin_probe').label('Termin').cssClasses(['col-md-1']), ac.field('tehnicar', 'reference').targetEntity(app.getEntity('Tehnicar')).targetField(ac.field('naziv')).label('Tehničar').cssClasses(['col-md-2']), ac.field('napomena').cssClasses(['col-md-5'])]).listActions(['delete']);
	
	    entity.dashboardView().fields([ac.field('ordinacija_naziv', 'template').label('Ordinacija').template(function (entry) {
	        return '<h4 class="font-extra-bold">' + entry.ordinacija_naziv + '</h4>';
	    }), ac.field('pacijent_naziv').label('Pacijent'), ac.field('radni_nalog_broj_naloga', 'template').label('Radni nalog').template(function (entry) {
	        return '<a ui-sref="radniNalog.details({id:' + entry.radni_nalog + '})">' + entry.radni_nalog_sifra_naloga + '</a>';
	    }), ac.field('napomena').label('Napomena'), ac.field('termin_probe', 'template').label('<i class="fa fa-clock-o"></i>Termin').template(function (entry) {
	        return '<h4>' + entry.termin_probe + '</h4>';
	    }).cssClasses(['text-center'])]);
	
	    entity.editionView().title('Izmjena faze naloga').fields([(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.datum_probe]), (0, _commonFormsLayoutJs.Column3)([fields.termin_probe])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.tehnicar]), (0, _commonFormsLayoutJs.Column8)([fields.napomena])])]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 696 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('KorisnikOrdinacija');
	
	    entity.listView().title('Korisnici').icon('<i class="fa fa-user fa-3x"></i>').fields([ac.field('first_name').label('Ime').cssClasses(['col-md-2']), ac.field('last_name').label('Prezime').cssClasses(['col-md-2']), ac.field('email'), ac.field('username')]).listActions(['delete']);
	
	    entity.creationView().title('Unos korisnika').fields([{
	        key: 'username',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Korisničko ime',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'first_name',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Ime',
	            required: true
	        }
	    }, {
	        key: 'last_name',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Prezime',
	            required: true
	        }
	    }, {
	        key: 'email',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Email'
	        }
	    }, {
	        key: 'password1',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Zaporka',
	            type: 'password',
	            required: true
	        }
	    }, {
	        key: 'password2',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Potvrdite',
	            type: 'password',
	            required: true
	        }
	    }]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 697 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var materijal = app.getEntity('Materijal');
	
	    materijal.listView().title('Materijali').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv')]).listActions(['edit', 'delete']);
	
	    materijal.editionView().title('Materijal').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }]);
	
	    return materijal;
	};
	
	module.exports = exports['default'];

/***/ },
/* 698 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var vrstaRada = app.getEntity('VrstaRada');
	
	    vrstaRada.listView().title('Vrsta rada').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv'), ac.field('grupa', 'reference').label('Grupa').targetEntity(app.getEntity('GrupaRada')).targetField(ac.field('naziv'))]).listActions(['edit', 'delete']);
	
	    vrstaRada.editionView().title('Vrsta rada').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'grupa',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Grupa',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite grupu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('GrupaRada').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'boja',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Boja'
	
	        }
	    }]);
	
	    return vrstaRada;
	};
	
	module.exports = exports['default'];

/***/ },
/* 699 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var grupaRada = app.getEntity('GrupaRada');
	
	    grupaRada.listView().title('Grupa rada').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv')]).listActions(['edit', 'delete']);
	
	    grupaRada.editionView().title('Grupa rada').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }]);
	
	    return grupaRada;
	};
	
	module.exports = exports['default'];

/***/ },
/* 700 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var komentar = app.getEntity('Komentar');
	    komentar.listView().title('Vaši komentari').icon('<i class="fa fa-comments fa-3x"></i>').fields([ac.field('sender').label('Pošiljatelj').cssClasses(['col-md-3']), ac.field('poruka').label('Poruka').cssClasses(['col-md-7']), ac.field('radni_nalog', 'template').label('Radni nalog').template(function (entry) {
	        return '<a ui-sref="radniNalog.details({id: entry.radni_nalog})" class="btn"><i class="fa fa-comments"></i> {{entry.sifra_naloga}}</a>';
	    }).cssClasses(['col-md-2'])]);
	
	    return komentar;
	};
	
	module.exports = exports['default'];

/***/ },
/* 701 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('login', {
	        url: '/login',
	        template: '<auth></auth>',
	        data: {
	            specialClass: 'blank'
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 702 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('dashboard', {
	        url: '/dashboard',
	        component: 'dashboard'
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 703 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('ordinacija', {
	        url: '/ordinacija',
	        template: '<ordinacija-list></ordinacija-list>',
	        data: {
	            pageTitle: 'Ordinacije dentalne medicine',
	            pageDesc: 'Registar ordinacija dentalne medicine',
	            icon: '<i class="fa fa-building fa-3x"></i>'
	        }
	    }).state('ordinacija.details', {
	        url: '/details/:id',
	        views: {
	            '@': {
	                // template: '<ordinacija-details></ordinacija-details>',
	                component: 'ordinacijaDetails'
	            }
	        },
	        resolve: {
	            item: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return DS.find('Ordinacija', params.id);
	            }]
	        },
	        data: {
	            pageTitle: 'Detalji ordinacije'
	        }
	    }).state('ordinacija.create', {
	        url: '/create',
	        views: {
	            '@': {
	                component: 'ordinacijaCreate'
	            }
	        },
	        resolve: {
	            item: function item() {
	                return {};
	            }
	        }
	
	    }).state('ordinacija.details.edit', {
	        url: '/edit',
	        views: {
	            '@': {
	                component: 'ordinacijaEdit'
	            }
	        },
	        resolve: {
	            item: ['DS', '$transition$', function (DS, $transition$) {
	                var params = $transition$.params();
	                return DS.find('Ordinacija', params.id);
	            }]
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 704 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('cjenik', {
	        url: '/cjenik',
	        component: 'cjenik'
	    }).state('cjenik.details', {
	        url: '/:id',
	        views: {
	            '@': {
	                component: 'stavkaCjenika'
	            }
	        },
	        resolve: {
	            cjenik: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return DS.find('Cjenik', params.id);
	            }]
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 705 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function viewProvider(viewName) {
	    return ['$transition$', 'AppConfiguration', function ($transition$, AppConfiguration) {
	        var view;
	        var params = $transition$.params();
	        try {
	            view = AppConfiguration().getViewByEntityAndType(params.entity, viewName);
	        } catch (e) {
	            var error404 = new Error('Unknown view or entity name');
	            error404.status = 404;
	            throw error404;
	        }
	        return view;
	    }];
	}
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('crud', {
	        abstract: true,
	        url: '/crud/:entity',
	        template: '<ui-view></ui-view>',
	        resolve: {
	            view: viewProvider('ListView'),
	            store: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return DS.definitions[params.entity];
	            }]
	        }
	    }).state('crud.list', {
	        url: '/list',
	        component: 'listView'
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 706 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('radniNalog', {
	        url: '/radniNalog',
	        component: 'radniNalogList',
	        data: {
	            pageTitle: 'Radni nalozi'
	        }
	    }).state('radniNalog.details', {
	        url: '/details/:id',
	        views: {
	            '@': {
	                // template: '<ordinacija-details></ordinacija-details>',
	                component: 'radniNalogDetails'
	            }
	        },
	        resolve: {
	            id: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return params.id;
	            }]
	        },
	        data: {
	            pageTitle: 'Pregled naloga'
	        }
	    }).state('radniNalog.details.edit', {
	        url: '/edit',
	        views: {
	            '@': {
	                component: 'radniNalogEdit'
	            }
	        },
	        resolve: {
	            item: ['DS', '$transition$', function (DS, $transition$) {
	                var params = $transition$.params();
	                return DS.find('RadniNalog', params.id);
	            }]
	        }
	    }).state('radniNalog.details.planRada', {
	        url: '/planRada',
	        views: {
	            '@': {
	                component: 'planRada'
	            }
	        },
	        data: {
	            pageTitle: 'Plan rada'
	        }
	    }).state('radniNalog.create', {
	        url: '/create',
	        views: {
	            '@': {
	                component: 'radniNalogCreate'
	            }
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 707 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (acp, $state) {
	    return acp.menu().addChild(acp.menu().title('Početna').icon('<i class="fa fa-home"></i>').link($state.href('dashboard'))).addChild(acp.menu().title('Šifranti').addChild(acp.menu().title('Materijali').link($state.href('crud.list', { entity: 'Materijal' }))).addChild(acp.menu().title('Grupe radova').link($state.href('crud.list', { entity: 'GrupaRada' }))).addChild(acp.menu().title('Vrste radova').link($state.href('crud.list', { entity: 'VrstaRada' }))).addChild(acp.menu().title('Protetski radovi').link($state.href('crud.list', { entity: 'ProtetskiRad' }))).addChild(acp.menu().title('Cjenici').link($state.href('cjenik'))).addChild(acp.menu().title('Firma').link($state.href('crud.list', { entity: 'Firma' }))).addChild(acp.menu().title('Ordinacije').link($state.href('ordinacija'))).addChild(acp.menu().title('Porezne stope').link($state.href('crud.list', { entity: 'PoreznaStopa' }))).addChild(acp.menu().title('Tehničari').link($state.href('crud.list', { entity: 'Tehnicar' }))).addChild(acp.menu().title('Valute').link($state.href('crud.list', { entity: 'Valuta' }))).addChild(acp.menu().title('Boje').link($state.href('crud.list', { entity: 'Boja' }))).addChild(acp.menu().title('Oznake boja').link($state.href('crud.list', { entity: 'OznakaBoje' })))).addChild(acp.menu().title('Radni nalozi').link($state.href('radniNalog'))).addChild(acp.menu().title('Upute za rad').link($state.href('upute')));
	};
	
	module.exports = exports['default'];

/***/ }
]);


// WEBPACK FOOTER //
// app.js